const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "त्सुकुयोमी बैकग्राउंड",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "अत्यधिक सीन एसेट के कारण पब्लिश करने में विफल. कृपया कुछ एसेट हटाएं और रीलोड करें.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "वर्तमान में मेंबरशिप-संबंधी फीचर्स के एक्सेस की अनुमति नहीं है",
  T_12_I_GIFT_SENDER_BELL: "घंटी",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `अब आप उसे देख रहे है और अब नहीं  
t. [FFB300] (हेल्मेट छुपाता है) [-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "ओल्ड मैन  मास्क",
  T_12_L_COS_PINKMAN: "पिंक डायनो",
  T_12_L_COS_POLAR: "पोलर बेअर",
  T_12_L_COS_RENDER: "रेनबो डायनो",
  T_12_L_COS_TIGER: "टाइगर सूट",
  T_12_L_MALE_BOTTOM_COS_ELF: "विंटर एल्क (बॉटम)",
  T_12_L_MALE_COS_SANTA: "ग्रुंपी ओल्ड मैन",
  T_12_L_MALE_HAIR_COS_ELF: "विंटर एल्क (हेड)",
  T_12_L_MALE_SHOE_COS_ELF: "विंटर एल्क (जूते)",
  T_12_L_MALE_TOP_COS_ELF: "विंटर एल्क (टॉप)",
  T_12_O_CAT_NAME: "किटी",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - विंटरलैंड्स",
  T_12_O_MACHETE_GOLD_NAME: "गोल्डन ब्लेड",
  T_12_O_PET_TITLE: "पैट",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "जंपिंग जूते़",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "आधुनिक तकनीक से बने जूते. इंसान को दुगने जंप्स परफॉर्म करने देता है.",
  T_12_Q_ITEM_FLYSHOE: "जेट पैक जूते",
  T_12_Q_ITEM_FLYSHOE_DESC: "जूते जो पहने वाले को उड़ने देता है. मध्य हवा में ईंधन ख़तम ना होने दें.",
  T_12_Q_ITEM_STOCK1: "स्टॉक Lv1",
  T_12_Q_ITEM_STOCK2: "स्टॉक Lv2",
  T_12_Q_ITEM_STOCK3: "स्टॉक Lv3",
  T_12_Q_ITEM_TREATMENTGUN: "हील पिस्टल",
  T_12_Q_ITEM_VEST4: "वेस्ट Lv4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "एंटोनियो",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "वुकॉन्ग",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "शूट डांस",
  T_12_R_EMOTE_WAVE_NAME: "आर्म वेव",
  T_12_R_SKILL_NAME_GANGLEADER: "गैंग्स्टर्स स्पिरिट",
  T_12_R_SKILL_NAME_MONKEYGOD: "कैमफ्लाश़",
  T_13_I_COLLECTION_V_AMPHIBIAN: "एमफ़िबियन कार",
  T_13_I_COLLECTION_V_JEEP: "जीप",
  T_13_I_COLLECTION_V_MONSTER: "मॉन्स्टर ट्रक",
  T_13_I_COLLECTION_V_MOTOBIKE: "मोटरबाइक",
  T_13_I_COLLECTION_V_ROADSTER: "स्पोर्ट्स कार",
  T_13_I_COLLECTION_V_SUV: "पिकअप ट्रक",
  T_13_I_COLLECTION_V_TUTU: "टू टू कार",
  T_13_L_MALE_ACCESSORY_COS_BJD: "आर्कटिक ब्लू (मास्क)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "लव इन दि एयर (बॉटम)",
  T_13_L_MALE_HAIR_COS_BJD: "आर्कटिक ब्लू (हेड)",
  T_13_L_MALE_TOP_COS_VALENTINE: "लव इन दि एयर (टॉप)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "हथियार",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "पैट स्किन: डिटेक्टिव किटी",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - क्यूपिड",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "मोको",
  T_13_R_EMOTE_BABYSHARK_NAME: "बेबी शार्क",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "पुश-अप",
  T_13_R_EMOTE_EGYPT_NAME: "ममी डांस",
  T_13_R_PVE_WEAPON_SLOT: "वेपन स्लॉट",
  T_13_R_PVE_WEAPONSKIN_RANGE: "असरदार रेंज",
  T_13_R_PVE_WEAPONSKIN_SPEED: "फायर रेट",
  T_13_R_SKILL_DESC_HACKERGIRL: "[FFB300]{0}s[-] के लिए गोली हिट हुये दुश्मनों को टैग करें. टीममेट के साथ जानकारी शेयर की जाएगी.",
  T_13_R_SKILL_NAME_HACKERGIRL: "हैकर्स आइ",
  T_13_Z_KICKOFF_BAN: "बैन",
  T_13_Z_ROOM_MORNING: "दिन",
  T_13_Z_ROOM_NIGHT: "नाइट",
  T_14_G_ITEM_KATANA: "कटाना",
  T_14_I_HEADPIC_SONGKRAN_NAME: "स्प्लेश!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "क्यूबिक बनी",
  T_14_L_COS_EASTER: "ऑब्जर्वर 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "लेडी ऑफ फ्लेम (जूते)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "बनी वॉरियर (मास्क)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - वॉटर बलून",
  T_14_O_DOG_NAME: "मैकेनिकल पप",
  T_14_O_PETSKIN_IRON_DOG_NAME: "पैट स्किन: फुल स्टील पप",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "पैट स्किन: लाइटनिंग पप",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "पैट स्किन: मेग्नेटिक पप",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "पैट स्किन: नाइट किटी",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - ब्लड मून",
  T_14_O_SCAR_SHARK_NAME: "SCAR - शार्क अटैक",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "हयातो",
  T_14_R_SKILL_DESC_SAMURAI: "प्रत्येक HP  [FFB300]{0}%[-] कम होने पर, तो आर्मर पेनेट्रेशन में [FFB300]{1}%[-] बढ़ती है.",
  T_14_R_SKILL_NAME_SAMURAI: "बुशीदो",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "हंगर स्ट्राइक (मास्क)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "वेनम टच (मास्क)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "हंगर स्ट्राइक(बॉटम)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "वेनम टच(बॉटम)",
  T_15_L_MALE_SHOE_COS_FAIM: "हंगर स्ट्राइक (जूते)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "वेनम टच (जूते)",
  T_15_L_MALE_TOP_COS_FAIM: "हंगर स्ट्राइक(टॉप)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "वेनम टच(टॉप)",
  T_15_L_TOP_COS_MOTHERSDAY: "बेस्ट मोम",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - कैटक्लिज़म",
  T_15_O_BASEBALLBAT_VIKING_NAME: "द वाइकिंग",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014- कैटक्लिज़म",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - कैटक्लिज़म",
  T_15_O_PANTHER_NAME: "नाइट पैंथर",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "पैट स्किन: कैप्टन",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "पैट स्किन: गोल्डन तेंदुआ",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "पैट स्किन: डोमिनेशन",
  T_15_O_SKS_DEATH_NAME: "SKS- स्टिलनेस विश",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP- कैटक्लिज़म",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "गैटलिंग",
  T_15_R_CHARACTER_AGENT_NAME: "लौरा",
  T_15_R_EMOTE_LETSGROOVE_NAME: "मेरे साथ नाचो.",
  T_15_R_SKILL_DESC_AGENT: "स्कोप करने पर एक्यूरेसी [FFB300]{0}%[-]  बढ़ती है.",
  T_15_R_SKILL_NAME_AGENT: "शार्प शूटर",
  T_15_W_BACKPACK_MECHGIRL_NAME: "पर्पल विंगस",
  T_16_B_ITEM_GRAPPLINGHOOK: "हुक",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "हुक गन",
  T_16_L_MALE_COS_LEGO: "मैड ब्रिकमैन",
  T_16_L_MALE_SHOE_COS_SUMMER: "समर हॉलिडे (जूते)",
  T_16_P_MANUAL_MONSTER: "मॉन्स्टर ट्रक",
  T_16_P_MANUAL_MUSHROOM1: "मशरूम Lv1",
  T_16_P_MANUAL_MUSHROOM2: "मशरूम Lv2",
  T_16_P_MANUAL_MUSHROOM3: "मशरूम Lv3",
  T_16_P_MANUAL_MUSHROOM4: "मशरूम Lv1",
  T_16_P_MANUAL_ROADSTER_DESC: "स्टाइलिश स्पोर्ट्स कार. कम HP लेकिन अद्भुत स्पीड. 2 प्लेयर सवार हो सकते हैं.",
  T_16_P_MANUAL_STROP: "ज़िप लाइन",
  T_16_P_MANUAL_SUV: "पिकअप ट्रक",
  T_16_P_MANUAL_SUV_DESC: "Free Fire विशेष गाड़ी. मीडियम आर्मर और ज़्यादा स्पीड. 2 प्लेयर सवार हो सकते हैं.",
  T_16_P_MANUAL_TUTU_DESC: "कम HP और धीमी चाल वाला एक गाड़ी. 3 प्लेयर सवार हो सकते हैं.",
  T_16_P_MANUAL_WEAPON_AR: "राइफल",
  T_16_P_MANUAL_WEAPON_BOMB: "ग्रेनेड",
  T_16_P_MANUAL_WEAPON_PISTOL: "पिस्टल",
  T_16_P_MANUAL_WEAPON_SG: "शॉटगन",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "स्नाइपर",
  T_16_Q_MINISENTRY: "मिनी टरट",
  T_16_Q_MINISENTRY_DESC: "आधुनिक तकनीक से बनाया गया ऑटो टरट. ये आसपास के दुश्मनों को खोजेगा और उन पर हमला करेगा.",
  T_16_R_EMOTE_DESERT_NAME: "गुस्सेल स्लेम",
  T_16_R_EMOTE_EPHUNTER_NAME: "युद्ध नृत्य",
  T_16_R_EMOTE_EPHUNTER2_NAME: "दे ताली!",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "मून फ्लिप",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "विगल वॉक",
  T_16_W_AK_FIRE_NAME: "AK47 - फ्लेमिंग रेड",
  T_16_W_SCAR_LLENN_NAME: "SCAR - पिंक डेविल",
  T_16_W_SCAR_WATER_NAME: "SCAR - वॉटर एलीमेंटल",
  T_16_Y_CHARACTER_HITMAN_NAME: "राफेल",
  T_16_Y_PANDA_NAME: "डिटेक्टिव पांडा",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "पैट स्किन:  वाइल्ड पांडा",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "पैट स्किन:  स्कल पांडा",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "पैट स्किन: लाइटनिंग पांडा",
  T_17_B_CS_MODE_NAME: "क्लैश स्क्वाड",
  T_17_C_SKILL_NAME_PLAYBOY: "नटी मूवमेंट",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "रॉयल जेस्टर  (मास्क)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "होलो मिस्ट्रेस (मास्क)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "होलो मिस्ट्रेस (बॉटम)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "मैजिकल फॉक्स (हेड)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "होलो मिस्ट्रेस (जूते)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "होलो मिस्ट्रेस (टॉप)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "वैम्पायर  (मास्क)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "स्ट्रीट ठग (बॉटम)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "वैम्पायर का  रिवेंज (मास्क)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "पर्पल शेड (हेड)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "द जेंटलमैन (जूते)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "वैम्पायर का  रिवेंज (टॉप )",
  T_17_L_MALE_TOP_COS_VAMPIRE: "वैम्पायर का रिवेंज (टॉप )",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "गोल्डन शेड (टॉप)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "पैट स्किन: म्याऊ प्रिंसेस",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "पैट स्किन: गोल्डन टेल",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "पैट स्किन: डीप ब्लू",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "पैट स्किन: लकी ग्रीन",
  T_17_O_SHIBA_NAME: "शिबा",
  T_17_Q_FOLDWINGS: "ग्लाइडर",
  T_17_Q_FOLDWINGS_DESC: "आपको ऊंचे इलाकों से नीचे स्लाइड करने की अनुमति देता है.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "पार्टी डांस",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS वैम्पायर",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - फैंटम असेसिन",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - ओल्ड फ़ैशनड",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "जोसफ",
  T_17_Z_CS_NAME: "नाम",
  T_17_Z_ROOM_JUMP_SWITCH: "जंप की ऊंचाई",
  T_17_Z_ROOM_SPEED_SWITCH: "चलने की स्पीड",
  T_18_B_THROWINGKNIFE_NAME: "FF चाकू",
  T_18_C_DUMMY_NAME: "डिकॉइ ग्रेनेड",
  T_18_C_SKILL_DESC_DJMALE: "[FFB300]{1}m[-] का ऐसा औरा बनता जो [FFB300]{0}s[-] के लिए स्पीड को [FFB300]{3}%[-]   तक बढ़ाता है और [FFB300]{2} HP/s[-] को रिस्टोर करता है. इसे जमा नहीं किया जा सकता. कूलडाउन: [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "ड्रॉप द बीट.",
  T_18_C_SKILL_NAME_JUNKENGINEER: "गियर रिसाईकल",
  T_18_L_COS_INDIANEWYEAR: "दिवाली डायनो",
  T_18_L_HAIR_COS_HALLOWEEN2019: "मायूस चेहरा",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "फ्लेमिंग रेड (मास्क)",
  T_18_O_FOX_NAME: "स्पिरिट फॉक्स",
  T_18_O_PETSKIN_BLACKFOX_NAME: "पैट स्किन: बैटल फॉक्स",
  T_18_O_PETSKIN_BLUEFOX_NAME: "पैट स्किन: ब्लू फॉक्स",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "पैट स्किन: लावा पंपकिन",
  T_18_O_PETSKIN_PINKFOX_NAME: "पैट स्किन: रेड फॉक्स",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "पैट स्किन: स्पिरिट",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - फ्लेमिंग स्कल",
  T_18_W_UMP_GEISHA_N: "UMP-आर्ट ऑफ वॉर",
  T_18_Y_CHARACTER_DJMALE_N: "अलोक",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "शानी",
  T_19_B_HB_NAME: "इलेक्ट्रिक सर्फबोर्ड",
  T_19_C_ICE_GUN_NAME: "आइस गन",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "विस्फोटक होने वाले वेपन का डैमेज [FFB300]{0}%[-] बढ़ जाता है, डैमेज रेंज [FFB300]{1}%[-] बढ़ जाती है",
  T_19_C_SKILL_DESC_TOMBOY: "गाड़ी चलाते समय, गाड़ी में सभी के लिए हर [FFB300]{0}s[-] में अधिकतम [FFB300]{1}[-] HP तक रेस्टोर करता है, अधिकतम [FFB300]{2}[-] HP तक.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "आर्ट ऑफ डेमॉलिशन",
  T_19_C_SKILL_NAME_TOMBOY: "रेसर की ब्लैसिंग",
  T_19_I_EVENT_INFI_ITEM: "असीमित",
  T_19_L_A_ICEFESTIVAL19_B: "लास्ट लाफ",
  T_19_L_F_S_ICEFESTIVAL: "स्‍नोई सर्विट्यूड (जूते)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "डिस्को फ़ास्को (बॉटम)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "डिस्को फ़ास्को (हेड)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "डिस्को फासको (टॉप)",
  T_19_O_PETSKIN_NAME: "पैट स्किन:डिफ़ॉल्ट",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "पैट स्किन:हिपहॉप पांडा",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "पैट स्किन:पोलर पांडा",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "पैट स्किन:  फैरो का रोबो",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "पैट स्किन: स्प्रिंग फेस्टिवल रोबो",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "पैट स्किन: स्नोवी रोबो",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "पैट स्किन:  हिपहॉप शिबा",
  T_19_O_ROBOT_NAME: "रोबो",
  T_19_O_TDM_NAME: "टीम डेथमैच",
  T_19_R_EMOTE_MIGUEL_NAME: "ब्रेक डांस",
  T_19_S_SECOND_WEAPON_TITLE: "सेकेंडरी  हथियार",
  T_19_S_VEST_TITLE: "बुलेटप्रूफ वेस्ट",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "डबल मैगज़ीन",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - टैगर्स रिवोल्ट",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - सांता की पसंद",
  T_19_W_MP40_PARK_N: "MP40 - कार्निवल कार्नेज",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - ऑरस ड्रैगन",
  T_19_X_PVE_SAMURAINAME: "गार्डियन समुराई",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "अल्वारो",
  T_19_Y_CHARACTER_TOMBOY_N: "नोटोरा",
  T_20_C_INHALER_NAME: "इन्हेलर",
  T_20_C_SKILL_DESC_PARKOURGUY: "गन का इस्तेमाल करते समय, दुश्मन को हिट करने से यूजर की कुछ HP रिकवर होती है, दुश्मन को नॉक करने से यूजर की [FFB300]{0}%[-] HP रिकवर होती है.",
  T_20_C_SKILL_NAME_GRAFFITIST: "पेंटेड रिफ्यूज",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "डेड्ली वेलोसिटी",
  T_20_C_SKILL_NAME_PARKOURGUY: "सस्टेन्ड रैड",
  T_20_L_A_APRILFOOL2020: "डोग्गो",
  T_20_L_F_A_METALHEAD_RED: "मिस्टर फाइअरी इम्प-हेड (मास्क)",
  T_20_L_F_B_THAIGIRL: "फीनिक्स एक्सेसन (बॉटम)",
  T_20_L_F_H_KILLERCUPID: "स्वीटहार्ट क्यूपिड (हेड)",
  T_20_L_F_H_THAIGIRL: "फीनिक्स एक्सेसन (हेड)",
  T_20_L_F_S_THAIGIRL: "फीनिक्स एक्सेसन (जूते)",
  T_20_L_F_T_METALHEAD_RED: "मिस फाइअरी इम्प-हेड (टॉप)",
  T_20_L_F_T_THAIGIRL: "फीनिक्स एक्सेसन (टॉप)",
  T_20_L_JEANDINO: "डेनिम डायनो",
  T_20_L_M_A_METALHEAD_RED: "मिस्टर फाइअरी इम्प-हेड (मास्क)",
  T_20_L_M_T_METALHEAD_RED: "मिस्टर फाइअरी इम्प-हेड (टॉप)",
  T_20_L_M_T_STOCKING: "जेन्टलमेन (टॉप)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "पैट स्किन: वेलेंटाइन फॉक्स",
  T_20_P_CHANNEL_G: "गिल्ड",
  T_20_P_WORLD_SSPEAKER: "लाउडस्पीकर",
  T_20_S_CSROOM_COIN: "डिफ़ॉल्ट कॉइन",
  T_20_U_SHIELD_GUN_NAME: "शील्ड गन",
  T_20_W_AN94_METALHEAD_N: "AN94 - कैरट इम्प-हेड",
  T_20_W_P90_EVILBONE_N: "P90- द पनिशर",
  T_20_Y_CHARACTER_GRAFFITIST_N: "स्टेफी",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'केली "द स्विफ्ट"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "जोटा",
  T_21_B_SMOKEGRENADE_DESC: "धुआं उत्पन्न करता है, स्क्रीनिंग और फ्लैंकिंग पैंतरेबाज़ी के लिए सही है",
  T_21_B_SMOKEGRENADE_NAME: "स्मोक ग्रेनेड",
  T_21_C_AUTOPICKUP_AVERAGE: "डिफ़ॉल्ट",
  T_21_C_SKILL_DESC_KPOPSINGER: "टीम के साथी की मदद करने पर, उस टीम के साथी को  [FFB300]{0} HP[-] शील्ड और [FFB300]{1}%[-] मूवमेंट स्पीड बूस्ट देता है. सफल हेल्प-अप के बाद बूस्ट इफ़ेक्ट [FFB300]{2}s[-] में कम कर देता है. नॉक डाउन हुए टीममेट्स की ब्लीडिंग स्पीड को [FFB300]{3}%[-] कम करता है. इफ़ेक्ट जमा नहीं होते हैं.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "हर एलिमिनेशन से अधिकतम HP में [FFB300]{0}[-] की बढ़ोतरी करता है, बूस्ट: [FFB300]{1}[-]",
  T_21_C_SKILL_NAME_KPOPSINGER: "हीलिंग सॉन्ग",
  T_21_C_SKILL_NAME_SOCCERSTAR: "हैट्रिक",
  T_21_L_ANGELICAL: "एंजेल डायनो",
  T_21_L_S_VNSLIPPER: "वियतनाम स्लिपर्स",
  T_21_O_OTTER_NAME: "ओतेरो",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "पैट स्किन: रेडियोएक्‍टिव ओटेरो",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "पैट स्‍किन: सकूरा ओतेरो",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "पैट स्कि‍न: निऑन ओतेरो",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "पैट स्किन: मास्टर ऑफ़ लाइफ",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "पैट स्किन: लाइटनिंग बोल्‍ट",
  T_21_R_EMOTE_SORROW_NAME: "क्यों? ओह क्यों?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "पंकस्टर बैकपैक",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "लास्ट स्ट्राइक",
  T_21_W_M79_RABBITKILLER_N: "M79 - हिपस्‍टर बन्‍नी",
  T_21_W_PAN_VOLCANO_N: "पैन - वाल्कैनिक फ्यूरी",
  T_21_W_XM8_RAINBOW_N: "XM8-अबिसल",
  T_21_Y_CHARACTER_KPOPSINGER_N: "कपेला",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "लूक्वेटा",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "[FFB300]{0}m[-] के अंदर दुश्मनों की जगह का पता लगाएं, जो प्रोन या स्क्वाट पोज़ीशन में नहीं हैं. [FFB300]{1}s[-] तक रहता है. दुश्मन की जगह टीममेट के साथ शेयर की जाती है.कूलडाउन: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "ट्रेसिंग स्टेप्स",
  T_22_C_SKILL_NAME_STREAMERGUY: "लाइमलाइट",
  T_22_L_F_H_COLLEGE: "ब्लिट्ज़ जूनियर (हेड)",
  T_22_L_F_S_SUMMER20: "समर डॉर्लिंग (शूज़)",
  T_22_L_M_A_GREENCOAT: "लश क्लबर (मास्क)",
  T_22_L_M_A_PINKFUR: "सकूरा क्लबर (मास्क)",
  T_22_L_M_A_PLAGUE2: "प्लेग फ़ैंटम (मास्क)",
  T_22_L_M_B_FAIM2: "फ़ैमिन फेलॉन (बॉटम)",
  T_22_L_M_B_GREENCOAT: "लश क्लबर (बॉटम)",
  T_22_L_M_B_PINKFUR: "सकूरा क्लबर (बॉटम)",
  T_22_L_M_B_PLAGUE2: "प्लेग फ़ैंटम (बॉटम)",
  T_22_L_M_B_REDPANTS: "ट्रेंडी क्लबर (बॉटम)",
  T_22_L_M_B_TIGERSTRIPE: "टाइगर क्लबर (बॉटम)",
  T_22_L_M_H_COLLEGE: "ब्लिट्ज़ सीनियर (हेड)",
  T_22_L_M_H_FAIM2: "फ़ैमिन फेलॉन (हेयर)",
  T_22_L_M_H_GREENCOAT: "लश क्लबर (हेयर)",
  T_22_L_M_H_PINKFUR: "सकूरा क्लबर (हेयर)",
  T_22_L_M_H_PLAGUE2: "प्लेग फ़ैंटम (हेयर)",
  T_22_L_M_H_REDPANTS: "ट्रेंडी क्लबर (हेयर)",
  T_22_L_M_H_TIGERSTRIPE: "टाइगर क्लबर (हेयर)",
  T_22_L_M_S_FAIM2: "फ़ैमिन फेलॉन (शूज़)",
  T_22_L_M_S_PLAGUE2: "प्लेग फ़ैंटम (शूज़)",
  T_22_L_M_T_FAIM2: "फ़ैमिन फेलॉन (टॉप)",
  T_22_L_M_T_GREENCOAT: "लश क्‍लबर (टॉप)",
  T_22_L_M_T_PINKFUR: "सकूरा क्‍लबर (टॉप)",
  T_22_L_M_T_PLAGUE2: "प्‍लेग फैंटम (टॉप)",
  T_22_L_M_T_REDPANTS: "ट्रेंडी क्‍लबर (टॉप)",
  T_22_L_M_T_TIGERSTRIPE: "टाइगर क्‍लबर (टॉप)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - रेबल अकैडमी",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "पैन - ग्रीन टाइगर",
  T_22_LC_SCAR_HERMIT_N: "SCAR - मिस्टिक सीकर",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "हील पिस्टल- लाइफबीम",
  T_22_O_HAWK_NAME: "फैल्‍को",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "पैट स्किन: अपॉकलिप्स फॉक्‍स",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "पैट स्किन: हेलफायर  फैल्‍को",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "पैट स्किन: एवरग्रीन  फैल्‍को",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "पैट स्किन: सनशाइन शिबा",
  T_22_Q_BOMB_PLIERS: "डिफ्यूज़न प्‍लायर",
  T_22_R_EMOTE_SHIMMY_NAME: "शिम्‍मी",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "आर्मर पेनेट्रेशन",
  T_22_U_WPNSKN_SPEED_RUN: "मूवमेंट स्‍पीड",
  T_22_Y_CHARACTER_DETECTIVE_N: "क्‍लू",
  T_22_Y_CHARACTER_STREAMERGUY_N: "वुल्फ्राह",
  T_23_B_CARDIAC_NAME: "होरिजलीन",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "आर्ट ऑफ़ ब्लेड्स",
  T_23_C_SKILL_NAME_SWATGUY: "रेजिंग रीलोड",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "हयातो फायरब्रांड",
  T_23_D_CHARACTER_SWATGUY_N: "जय",
  T_23_L_F_B_GANGSTERRAP_GOLD: "बिग बक्स वाइब  (बॉटम)",
  T_23_L_F_B_MIKOGIRL: "आर्कटिकफायर प्रीस्टेस (बॉटम)",
  T_23_L_F_B_NAVYGIRL: "नेवी गर्ल (बॉटम)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "बिग बक्स वाइब (हेड)",
  T_23_L_F_H_MIKOGIRL: "आर्कटिकफायर प्रीस्टेस (हेड)",
  T_23_L_F_H_NAVYGIRL: "नेवी गर्ल (हेड)",
  T_23_L_F_S_MIKOGIRL: "आर्कटिकफायर पुस्टेस (शूज)",
  T_23_L_F_S_ORDERCHALLENGER: "हाइस्ट मास्टरमाइंड (जूते)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "बिग बक्स वाइब (टॉप)",
  T_23_L_F_T_MIKOGIRL: "आर्कटिकफायर प्रीस्टेस (टॉप)",
  T_23_L_F_T_NAVYGIRL: "नेवी गर्ल (टॉप)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "बिग बक्स रैपर  (मास्क)",
  T_23_L_M_B_FOXGUY: "आर्कटिकफायर प्रीस्ट (बॉटम)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "बिग बक्स रैपर  (बॉटम)",
  T_23_L_M_H_FOXGUY: "आर्कटिकफायर प्रीस्ट (हेड)",
  T_23_LC_SKS_GEMINI_N: "SKS- हिस्टेरिया",
  T_23_O_PENGUIN_NAME: "मिस्टर वैगर",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "पैट स्किन: पार्टी वैगर",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "पैट स्किन: साइबर वैगर",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "पैट स्किन: गोल्ड वैगर",
  T_23_T_ANNI3_LOBBY_NODENAME20: "क्लैश स्क्वाड",
  T_23_T_ANNI3_LOBBY_NODENAME5: "कैरेक्टर",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "चेतावनी",
  T_24_C_FLAMETHROWER_NAME: "फ्लेमथ्रोअर",
  T_24_C_SKILL_DESC_PROFESSOR: "अधिकतम EP [FFB300]{0}[-] बढ़ती है. जिउ-जित्सु मोड:[FFB300]{2}m[-] में साथी की EP कन्वर्शन रेट [FFB300]{1}%[-]  बढ़ता है. साइकोलॉजी मोड: हर  [FFB300]{4}s[-] में  [FFB300]{5} EP[-] रिकवर करता है, [FFB300]{6} EP[-] तक. मोड स्विच कूलडाउन: [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "पार्टीइंग ऑन",
  T_24_C_SKILL_NAME_PROFESSOR: "मास्टर ऑफ़ ऑल",
  T_24_D_CHARACTER_PARTYGIRL_N: "दशा",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "मैक्स पैंट्स",
  T_24_L_H_PUMPKIN2020_A: "ट्विस्टेड पम्पकिन (हेड)",
  T_24_L_T_TSHIRT_COMEDIAN: "लास्ट शॉट हीरो",
  T_24_LC_MP5_RICHBOXER_N: "MP5- चैंपियन बॉक्स",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - पार्टी एनिमल",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- स्वोर्ड्समैन लेजेंड्स",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "कुल स्कोर",
  T_24_V_TRAINING_BOX_ATTACH: "अटैचमेंट",
  T_24_V_TRAINING_BOX_WEAPON: "वेपन",
  T_24_W_ARMORY: "वेपन",
  T_24_W_ARMOTY_MELEE: "मेले",
  T_24_W_ARMOTY_PISTOL: "पिस्टल",
  T_24_W_ARMOTY_RIFLE: "राइफल",
  T_24_W_ARMOTY_SHOTGUN: "शॉटगन",
  T_24_W_ARMOTY_SNIPER: "स्नाइपर",
  T_24_W_ARMOTY_SPECIAL: "अन्य",
  T_24_W_ARMOTY_SUBMACHINE: "सब-मशीन गन",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "पैट स्किन: Booyah पांडा",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "पैट स्किन: स्केलटन रॉकी",
  T_24_W_PETSKIN_RACCOON_MECH_N: "पैट स्किन: पार्टी रॉकी",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "पैटस्किन: अनडेड रॉकी",
  T_24_W_RACCOON_N: "रॉकी",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "टाइम टर्नर",
  T_25_D_CHARACTER_BOUNTY_N: "क्रोनो",
  T_25_E_HUD_01: "प्रीसेट 1",
  T_25_E_HUD_02: "प्रीसेट 2",
  T_25_L_F_B_DEMONKILLER: "फ्रेंज़ी जूनियर (बॉटम)",
  T_25_L_F_H_DEMONKILLER: "फ्रेंज़ी जूनियर (हेड)",
  T_25_L_F_S_DEMONKILLER: "फ्रेंज़ी जूनियर (जूते)",
  T_25_L_F_T_DEMONKILLER: "फ्रेंज़ी जूनियर (टॉप)",
  T_25_L_HA_FP_EVIL: "ईविल (फेसपेंट)",
  T_25_L_M_H_ANIMEHAIR: "ब्रीज़ी (हेयर)",
  T_25_L_S_MAXSNEAKERS: "MAX स्नीकर",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "साइबर स्विंग",
  T_25_LC_GLOO_WINTERFEST2020_N: "ग्लू वॉल - विंटरलैंड्स  2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - विंटरलैंड्स 2020",
  T_25_LC_MACHETE_BOUNTY_N: "साइबर ब्लेड",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- ट्यून ब्लास्टर ग्रीन",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- ट्यून ब्लास्टर रेड",
  T_25_LC_PAN_BOUNTY_N: "पैन - साइबर बाउंटी हंटर",
  T_25_R_LEGEND_REMIND: "रिमाइंडर",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "साइथ",
  T_25_U_VECTOR: "वेक्टर",
  T_25_W_BABOON_N: "बीस्टन",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "पैटस्किन: ग्लेशियर बीस्टन",
  T_25_W_PETSKIN_BABOON_HELL_N: "पैटस्किन: ब्लेज़िंग बीस्टन",
  T_25_W_PETSKIN_BABOON_PURE_N: "पैटस्किन: शानदार सफ़ेद बीस्टन",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "पैटस्किन: स्नो पैंथर",
  T_25_Z_R_SIMULATOR_OFF: "अनुमति न दें",
  T_26_C_SKILL_DESC_SUPERSTAR: "[FFB300]{0}m[-] में एक सोनिक वेव निकलती है. वेव विस्फोट करती है और  [FFB300]{1}m[-] रेडियस के अंदर [FFB300]{2}s[-] के लिए आसपास के ग्लू वॉल्स को समय के साथ डैमेज पहुंचाता है. कूलडाउन: [FFB300]{3}s[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "रिपटाइड रिदम",
  T_26_D_CHARACTER_DELIVERY_N: "शीरो",
  T_26_D_CHARACTER_SUPERSTAR_N: "स्काईलर",
  T_26_ET_CELLPHONE_NAME: "UAV-लाइट",
  T_26_L_A_FLAMING_PREM: "इन्फरनल सोल्जर (मास्क)",
  T_26_L_A_SANTAMODE: "स्नोमैन बॉब (मास्क)",
  T_26_L_B_SANTAMODE: "स्नोमैन बॉब (बॉटम)",
  T_26_L_F_B_WATERFEST21_A: "समर ब्रीज़ (बॉटम)",
  T_26_L_F_H_WATERFEST21_A: "समर ब्रीज़ (हेड)",
  T_26_L_F_S_WATERFEST21_A: "समर ब्रीज़ (जूते)",
  T_26_L_F_T_WATERFEST21_A: "समर ब्रीज़ (टॉप)",
  T_26_L_M_A_EGGDAY2021: "साइबर बनी (मास्क)",
  T_26_L_M_B_EGGDAY2021: "साइबर बनी (बॉटम)",
  T_26_L_M_B_PAIRING: "डायनामिक डुओ पु. (बॉटम)",
  T_26_L_M_B_WATERFEST21_A: "समर वेव (बॉटम)",
  T_26_L_M_H_EGGDAY2021: "साइबर बनी (हेड)",
  T_26_L_M_H_PAIRING: "डायनामिक डुओ पु. (हेड)",
  T_26_L_M_H_WATERFEST21_A: "समर वेव (हेड)",
  T_26_L_M_S_EGGDAY2021: "साइबर बनी (जूते)",
  T_26_L_M_S_PAIRING: "डायनामिक डुओ पु. (जूते)",
  T_26_L_M_S_WATERFEST21_A: "समर वेव (जूते)",
  T_26_L_M_T_EGGDAY2021: "साइबर बनी (टॉप)",
  T_26_L_M_T_PAIRING: "डायनामिक डुओ पु. (टॉप)",
  T_26_L_M_T_WATERFEST21_A: "समर वेव (टॉप)",
  T_26_L_S_SANTAMODE: "स्नोमैन बॉब (जूते)",
  T_26_L_T_SANTAMODE: "स्नोमैन बॉब (टॉप)",
  T_26_LC_AWM_KOICARP_N: "AWM- लकी कोई",
  T_26_LC_KATANA_VALENTINE2021_N: "कटाना - सीजन ऑफ़ पिंक",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "स्पोर्ट कार- कोबरा",
  T_26_P_SKILL_NAME_DELIVERY: "डैमेज डिलीवर्ड",
  T_26_V_TRAINING_BHH: "फैंसी हैमर",
  T_26_V_TRAINING_DICE: "जायंट डाइस",
  T_26_W_DRAGON_N: "ड्रेकी",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "पैटस्किन: स्प्लैशी ड्रेकी",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "पैटस्किन: ज़ैपिंग ड्रेकी",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "पैटस्किन: गैलेक्सी ड्रेकी",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "पैटस्किन: वैगर इन लव",
  T_26_XL_SETTING_TEAMMATE_INFO: "टीममेट इंफो",
  T_26_YP_HISTORY_WIN: "जीत",
  T_26_YP_SOCIAL_GENDER_FEMALE: "महिला",
  T_26_YP_SOCIAL_GENDER_MALE: "पुरुष",
  T_26_YP_SOCIAL_NAME: "निकनेम",
  T_27_C_SKILL_DESC__RACERGIRL: "ड्राइविंग स्पीड [FFB300]{0}%[-] बढ़ती है. गाड़ी में कैरेक्टर को हिट करना मुश्किल होगा, और मिलने वाले डैमेज में [FFB300]{1}%[-] की गिरावट होती है.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "एक अभेद्य फाॅर्स फ़ील्ड बनाता है जो दुश्मनों के [FFB300]{0} DMG[-] को ब्लॉक करता है. फाॅर्स फ़ील्ड के अंदर से बहार के दुश्मन पर हमला नहीं कर सकते. सभी इफ़ेक्ट [FFB300]{1}s[-] तक रहते हैं. कूलडाउन: [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "दूर से डैमेज में बढ़ोतरी,  [FFB300]{0}%[-] तक. मार्क किये दुश्मन के लिए [FFB300]{1}%[-] डैमेज में बढ़ोतरी",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "अवेकनिंग: प्रत्येक [FFB300]{0}%[-] HP कमी के लिए फ्रंटल डैमेज को [FFB300]{1}%[-] तक कम करता है.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "अवेकनिंग: एक्टिव करने के लिए [FFB300]{0}s[-] दौड़ें. एक्टिव होने पर, टारगेट पर पहले  [FFB300]{2}[-] शॉट पर  [FFB300]{1}%[-] ज़्यादा डैमेज. एक्टिव रहता है [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "फैल्कन फरवर",
  T_27_C_SKILL_NAME_XTREME: "एक्सट्रीम एनकाउंटर",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'एंड्रू "फिर्स"',
  T_27_D_CHARACTER_FALCONER_N: "मारॉ",
  T_27_D_CHARACTER_XTREME_N: "ज़ेयन",
  T_27_F_EAP_PKG3_D: "बैटल इन स्टाइल!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "टाइगर पेपरकट (मास्क)",
  T_27_L_B_CARDBOARD_REG: "ग्रिज़ली पेपरकट (बॉटम)",
  T_27_L_M_S_KAZAKHSTAN: "द बघाटुर (जूते)",
  T_27_L_S_CARDBOARD_REG: "ग्रिज़ली पेपरकट (जूते)",
  T_27_L_T_CARDBOARD_REG: "ग्रिज़ली पेपरकट (टॉप)",
  T_27_LC_VECTOR_FFWS2021_N: "वेक्टर- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "मॉन्स्टर ट्रक- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "मोटरबाइक - K.O. नाईट",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "स्पोर्ट कार- एमराल्ड फ़्लैश",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "पिकअप ट्रक - फ्लेम ड्रैको",
  T_27_P_SKILL_NAME_HITMAN_RE: "डेड साइलेंट",
  T_27_R_EMOTE_GREETING_NAME: "अभिवादन",
  T_27_R_VEHICLE_ACCELERATION: "तेज़ स्पीड",
  T_27_R_VEHICLE_HP: "मजबूती",
  T_27_R_VEHICLE_SPEED: "टॉप स्पीड",
  T_27_U_KORD: "कॉर्ड",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "अवेकनिंग: आर्मर डैमेज की कमी में [FFB300]{0}%[-] का इज़ाफा. [FFB300]{2}m[-] के भीतर हर टीममेट के लिए [FFB300]{1}%[-] की अतिरिक्त डैमेज में कमी.",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "वुल्फ पैक",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "मूनी",
  T_27_W_ARMOTY_DMR: "मार्क्समैन राइफल",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "पैटस्किन: क्रिस्टल मूनी",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "पैटस्किन: गेमर मूनी",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "पैटस्किन: हिप्स्टर मूनी",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "पैट स्किन: FFWS 2021 पप",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "पैट स्किन: FFWS 2021 पांडा",
  T_27_XC_REPLAY_DIE: "एलिमिनेट हुआ",
  T_27_XC_REPLAY_KILL: "एलिमिनेशन",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "रिपेयर करें",
  T_28_C_G_ICE_NAME: "फ़्लैश फ्रीज़",
  T_28_C_SKILL_DESC_STREETBEAT: "चलते हुए फायर करते समय, मूवमेन्ट स्पीड में [FFB300]{0}%[-] की बढ़ोतरी, एक्यूरेसी में [FFB300]{1}%[-] की बढ़ोतरी.",
  T_28_C_SKILL_NAME_STREETBEAT: "बुलेट बीट",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "नं.23 सॉकर जर्सी (बॉटम)",
  T_28_L_B_BRJERSEY_B: "No.10 सॉकर जर्सी (बॉटम)",
  T_28_L_B_BRJERSEY_C: "नं.24 सॉकर जर्सी (बॉटम)",
  T_28_L_B_BRJERSEY_D: "नं.30 सॉकर जर्सी (बॉटम)",
  T_28_L_B_BRJERSEY_E: "नं.1 सॉकर जर्सी (बॉटम)",
  T_28_L_B_BRJERSEY_F: "नं.20 सॉकर जर्सी (बॉटम)",
  T_28_L_F_B_FOURSYMBOLS_C: "वर्मिल्यन वर्लविंड (बॉटम)",
  T_28_L_F_H_FOURSYMBOLS_C: "वर्मिल्यन वर्लविंड (हेड)",
  T_28_L_F_HA_FOURSYMBOLS_C: "वर्मिल्यन वर्लविंड (फेसपेंट)",
  T_28_L_F_S_FOURSYMBOLS_C: "वर्मिल्यन वर्लविंड (जूते)",
  T_28_L_F_T_FOURSYMBOLS_C: "वर्मिल्यन वर्लविंड (टॉप)",
  T_28_L_HA_THUNDER: "लाइटनिंग आई (फेसपेंट)",
  T_28_L_M_A_SPORTSUIT: "बॉल्सी स्केटरबॉय (मास्क)",
  T_28_L_M_B_FOURSYMBOLS_D: "शैडो अर्थशेकर (बॉटम)",
  T_28_L_M_B_SPORTSUIT: "बॉल्सी स्केटरबॉय (बॉटम)",
  T_28_L_M_H_FOURSYMBOLS_D: "शैडो अर्थशेकर (हेड)",
  T_28_L_M_H_SPORTSUIT: "बॉल्सी स्केटरबॉय (हेड)",
  T_28_L_M_S_FOURSYMBOLS_D: "शैडो अर्थशेकर (जूते)",
  T_28_L_M_S_SPORTSUIT: "बॉल्सी स्केटरबॉय (जूते)",
  T_28_L_M_T_FALLWINTER: "सॉस स्वैगर (टॉप)",
  T_28_L_M_T_FOURSYMBOLS_D: "शैडो अर्थशेकर (टॉप)",
  T_28_L_M_T_SPORTSUIT: "बॉल्सी स्केटरबॉय (टॉप)",
  T_28_L_T_BRJERSEY_A: "नं.23 सॉकर जर्सी (टॉप)",
  T_28_L_T_BRJERSEY_B: "No.10 सॉकर जर्सी (टॉप)",
  T_28_L_T_BRJERSEY_C: "नं.24 सॉकर जर्सी (टॉप)",
  T_28_L_T_BRJERSEY_D: "नं.30 सॉकर जर्सी (टॉप)",
  T_28_L_T_BRJERSEY_E: "नं.1 सॉकर जर्सी (टॉप)",
  T_28_L_T_BRJERSEY_F: "नं.20 सॉकर जर्सी (टॉप)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - रूबी ब्राइड",
  T_28_LC_GLOO_FALLWINTER_N: "ग्लू वॉल - सॉस स्वैगर",
  T_28_LC_GLOO_FOURSYMBOLS_N: "ग्लू वॉल - स्टॉर्मब्रिंगर",
  T_28_LC_KORD_SHINOBI_N: "Kord- किलस्पार्क शिनोबी",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- मर्सिलेस नेक्रोमेंसर",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - लीथल फिन्सटूथ",
  T_28_LC_PAN_FOURSYMBOLS_N: "पैन - अर्थशेकर स्टॉम्प",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "जीप- स्टॉर्मब्रिंगर",
  T_28_T_WS_ITEM1: "स्क्वायर बॉक्स",
  T_28_T_WS_ITEM10: "हट",
  T_28_T_WS_ITEM11: "ग्रैंड टावर",
  T_28_T_WS_ITEM12: "आउटपोस्ट",
  T_28_T_WS_ITEM13: "हाउस A",
  T_28_T_WS_ITEM14: "हाउस B",
  T_28_T_WS_ITEM15: "हाउस B",
  T_28_T_WS_ITEM16: "सैंड स्ट्रक्चर",
  T_28_T_WS_ITEM17: "फाउंटेन",
  T_28_T_WS_ITEM18: "चेरी ब्लॉसम",
  T_28_T_WS_ITEM19: "बनाना ट्री",
  T_28_T_WS_ITEM2: "लॉन्ग बॉक्स",
  T_28_T_WS_ITEM20: "टॉयलेट बाउल",
  T_28_T_WS_ITEM21: "फेंस",
  T_28_T_WS_ITEM3: "झाड़ी",
  T_28_T_WS_ITEM4: "घास का ढेर",
  T_28_T_WS_ITEM5: "कार",
  T_28_T_WS_ITEM6: "बस",
  T_28_T_WS_ITEM7: "कंटेनर A",
  T_28_T_WS_ITEM8: "कंटेनर B",
  T_28_T_WS_ITEM9: "कंटेनर C",
  T_28_T_WS_TYPE1: "ऑब्जेक्ट",
  T_28_T_WS_TYPE4: "सजावट",
  T_28_W_DUCK_N: "डॉ बीनी",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "पैट स्किन: माइथोस ड्रेकी",
  T_28_W_PETSKIN_DUCK_ARMY_N: "पैटस्किन: सार्जेंट बीनी",
  T_28_W_PETSKIN_DUCK_BLACK_N: "पैट स्किन: गैंगस्टर बीनी",
  T_28_W_PETSKIN_DUCK_SHINY_N: "पैट स्किन: DJ बीनी",
  T_28_YF_AR15: "किंगफ़िशर",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "अवेकनिंग: दुश्मनों के चलने पर हिट दुश्मनों पर मार्क ज़्यादा टाइम तक रहता है, ([FFB300]{0}s[-] तक).",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "एनिग्मा की आंख",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "वाइटल वाइब्स",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "हीलिंग हार्टबीट",
  T_29_D_CHARACTER_AMOCO_N: 'मोको "एनिग्मा"',
  T_29_D_CHARACTER_MUSICBRO1_N: "दिमित्री",
  T_29_D_CHARACTER_MUSICBRO2_N: "थीवा",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "स्ट्रिप्ड सॉकर जर्सी (बॉटम)",
  T_29_L_M_A_FALCONER_C: "मूडी लैविशर (मास्क)",
  T_29_L_M_A_JUNGLE_GREEN: "कैमो वॉर-टर्टल (मास्क)",
  T_29_L_M_B_FALCONER_C: "मूडी लैविशर (बॉटम)",
  T_29_L_M_B_JUNGLE_GREEN: "कैमो वॉर-टर्टल (बॉटम)",
  T_29_L_M_H_FALCONER_C: "मूडी लैविशर (हेड)",
  T_29_L_M_H_JUNGLE_GREEN: "कैमो वॉर-टर्टल (हेड)",
  T_29_L_M_S_FALCONER_C: "मूडी लैविशर (जूते)",
  T_29_L_M_S_JUNGLE_GREEN: "कैमो वॉर-टर्टल (जूते)",
  T_29_L_M_T_FALCONER_C: "मूडी लैविशर (टॉप)",
  T_29_L_M_T_JUNGLE_GREEN: "कैमो वॉर-टर्टल (टॉप)",
  T_29_L_T_TRJERSEY: "स्ट्रिप्ड सॉकर जर्सी (टॉप)",
  T_29_M_WS_ITEM22: "रगिड कंटेनर",
  T_29_M_WS_ITEM23: "रगिड फेंस",
  T_29_M_WS_ITEM24: "स्पॉन पॉइंट A",
  T_29_M_WS_ITEM25: "स्पॉन पॉइंट B",
  T_29_M_WS_TYPE5: "इंटरैक्टिव्स",
  T_29_W_PETSKIN_BROWN_TIGER_N: "पैट स्किन: अर्थ सेंसी टिग",
  T_29_W_PETSKIN_FIRE_TIGER_N: "पैट स्किन: फायर सेंसी टिग",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "पैट स्किन: साइबर फैल्‍को",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "पैट स्किन: पार्टी पांडा",
  T_29_W_PETSKIN_WHITE_TIGER_N: "पैट स्किन: सेंसी टिग",
  T_29_W_TIGER_NINJA_N: "सेंसी टिग",
  T_29_YF_MACHETE_MUSICFEST_N: "साउंडवेव थ्रैशर",
  T_29_YF_MAGEZINE_CHAIN_N: "AR मैगज़ीन",
  T_29_YF_MUZZLE_CRASH_N: "SMG मज़ल",
  T_29_YF_MUZZLE_WIDE_N: "शॉटगन मज़ल",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- कॉस्मिक टेलीपोर्टिया",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- ऐम्बर मेगासाइफर",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "मॉन्स्टर ट्रक - नॉइंग रेजर",
  T_30_AD_RP_ROUNDEND: "राउंड ख़त्म",
  T_30_AD_TRAINING_SNOWBALL: "स्नोबॉल",
  T_30_AD_TRAINING_SNOWBALL_DES: "चलो स्नोबॉल फाइट करते हैं",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] पर हमला होने के बाद, [FFB300]{1}HP[-]/s के लिए [FFB300]{2}s[-] रिकवर करें",
  T_30_C_SKILL_NAME_BOOYAHGUY: "बज़र बीटर",
  T_30_C_SKILL_NAME_MUERTOGUY: "मेमोरी मिस्ट",
  T_30_D_CHARACTER_BOOYAHGUY_N: "लिओन",
  T_30_D_CHARACTER_MUERTOGUY_N: "ऑथो",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "जय की माइक्रोचिप",
  T_30_L_A_BRMASCOT_ADULT: "गुस्सैल चिक हेड",
  T_30_L_A_BRMASCOT_KIDS: "प्यार चिक हेड",
  T_30_L_A_SUGARSKULL21_BANDANA: "एंडिंग बाइट मास्क",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF सॉकर जर्सी - ब्लैक (बॉटम)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF सॉकर जर्सी - ग्रीन (बॉटम)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF सॉकर जर्सी - ग्रे (बॉटम)",
  T_30_L_B_BRUNIFORM: "लिटिल कैनरी (बॉटम)",
  T_30_L_F_A_SUGARSKULL21: "गोल्डरिम क्वीन (मास्क)",
  T_30_L_F_B_SUGARSKULL21: "गोल्डरिम क्वीन (बॉटम)",
  T_30_L_F_B_THASIAN: "कोरल ट्रबल (बॉटम)",
  T_30_L_F_H_CATEARS: "कवाई कान",
  T_30_L_F_H_SUGARSKULL21: "गोल्डरिम क्वीन (हेड)",
  T_30_L_F_H_THASIAN: "कोरल ट्रबल (हेड)",
  T_30_L_F_S_SUGARSKULL21: "गोल्डरिम क्वीन (जूते)",
  T_30_L_F_S_THASIAN: "कोरल ट्रबल (जूते)",
  T_30_L_F_T_SUGARSKULL21: "गोल्डरिम क्वीन (टॉप)",
  T_30_L_F_T_THASIAN: "कोरल ट्रबल (टॉप)",
  T_30_L_H_CHILDRENSDAY_BLUE: "डॉलफिन हेड",
  T_30_L_H_CHILDRENSDAY_RED: "एलीफैंट हेड",
  T_30_L_H_CLOWNHAT: "सर्कस हैट - यलो",
  T_30_L_H_ZASCARF: "बोल्ड गोल्ड स्कार्फ़",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "देसी गैंगस्टर (मास्क)",
  T_30_L_M_A_SUGARSKULL21: "गोल्डरिम किंग (मास्क)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "देसी गैंगस्टर (बॉटम)",
  T_30_L_M_B_PKCRICKET: "चैम्प इन ग्रीन (बॉटम)",
  T_30_L_M_B_SUGARSKULL21: "गोल्डरिम किंग (बॉटम)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "विंड रेसर (बॉटम)",
  T_30_L_M_B_THASIAN: "कोरल रिबेल (बॉटम)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "देसी गैंगस्टर (हेड)",
  T_30_L_M_H_SUGARSKULL21: "गोल्डरिम किंग (हेड)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "विंड रेसर (हेड)",
  T_30_L_M_H_THASIAN: "कोरल रिबेल (हेड)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "अल्फा फ्लेमबोर्न (फेसपेंट)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "देसी गैंगस्टर (जूते)",
  T_30_L_M_S_PKCRICKET: "चैम्प इन ग्रीन (जूते)",
  T_30_L_M_S_SUGARSKULL21: "गोल्डरिम किंग (जूते)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "विंड रेसर (जूते)",
  T_30_L_M_S_THASIAN: "कोरल रिबेल (जूते)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "देसी गैंगस्टर (टॉप)",
  T_30_L_M_T_PKCRICKET: "चैम्प इन ग्रीन (टॉप)",
  T_30_L_M_T_SUGARSKULL21: "गोल्डरिम किंग (टॉप)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "विंड रेसर (टॉप)",
  T_30_L_M_T_THASIAN: "कोरल रिबेल (टॉप)",
  T_30_L_S_BRUNIFORM: "लिटिल कैनरी (जूते)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF सॉकर जर्सी - ब्लैक (टॉप)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF सॉकर जर्सी - ग्रीन (टॉप)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF सॉकर जर्सी - ग्रे (टॉप)",
  T_30_L_T_BRUNIFORM: "लिटिल कैनरी (टॉप)",
  T_30_M_WS_PARTY_MODE: "प्लेग्राउंड",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "बैटल इन स्टाइल",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "चैलेंजर",
  T_30_R_EMOTE_MAX_NAME: "रैप स्वैग",
  T_30_R_LEGEND_HALO_NAME: "आग का गोला",
  T_30_T_WS_DEFAULTDESCRIPTION: "क्राफ़्टलैंड में एक मज़ेदार मैप",
  T_30_T_WS_ITEM26: "टायर",
  T_30_T_WS_ITEM27: "मेसी टायर A",
  T_30_T_WS_ITEM28: "मेसी टायर B",
  T_30_T_WS_ITEM29: "मेसी टायर C",
  T_30_T_WS_ITEM30: "बम्पर कार",
  T_30_T_WS_ITEM31: "एम्फीबियन कार",
  T_30_T_WS_ITEM32: "जीप",
  T_30_T_WS_ITEM33: "ट्रैश कैन",
  T_30_T_WS_ITEM34: "शेड",
  T_30_T_WS_ITEM35: "मेडिकल टेंट",
  T_30_T_WS_ITEM36: "गेराज",
  T_30_T_WS_ITEM37: "पेंटेड वॉल्स",
  T_30_T_WS_ITEM38: "टोरी",
  T_30_T_WS_ITEM39: "आयरन प्लेटफॉर्म",
  T_30_T_WS_ITEM40: "साइट हट",
  T_30_T_WS_ITEM41: "ट्रेलर",
  T_30_T_WS_ITEM42: "वॉल A",
  T_30_T_WS_ITEM43: "वॉल B",
  T_30_T_WS_ITEM44: "वॉल C",
  T_30_T_WS_ITEM45: "वॉल D",
  T_30_T_WS_ITEM46: "वॉल E",
  T_30_T_WS_ITEM47: "वॉल F",
  T_30_U_ATTACHMENT_1: "शील्ड बूस्टर",
  T_30_U_ATTACHMENT_4: "वेस्ट एनलार्जर",
  T_30_U_ATTACHMENT_5: "हेलमेट थिकर",
  T_30_U_ATTACHMENT_6: "वेस्ट थिकर",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "पैट स्किन: स्कल बीस्टन",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "पैट स्किन: पंक वैगर",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "पैट स्किन: बुल्सआई एजेंट हॉप",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "पैट स्किन: कार्निवल एजेंट हॉप",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "पैट स्किन: साइबर एजेंट हॉप",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "पैट स्किन: नज़र रोबो",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "पैट स्किन: ग्रीन फ्रीज रोबो",
  T_30_W_RABBIT_N: "एजेंट हॉप",
  T_30_XH_PCMAP_P17: "फ़ैक्टरी",
  T_30_YF_GLOO_BOOYAHDAY21_N: "ग्लू वॉल - BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "ग्रेनेड - BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "हील स्नाइपर",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - रॉयल वॉरिअर",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - क्रिमसन एर",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - रॉयल वॉरिअर",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- गोल्डरिम ट्रिब्यूट",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "स्पोर्ट्स कार- स्कल पंकर",
  T_31_C_SKILL_NAME_WINTERGUY: "आइस आयरन",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "बैट - विंटर बैशर",
  T_31_HQ_GLOO_EAGLE_N: "ग्लू वॉल - हेडबाउंड डेज़र्ट",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "हील स्नाइपर- आइस बोन्स",
  T_31_HQ_KATANA_WINTERFEST21_N: "कटाना - स्नो डूम",
  T_31_HQ_PAN_WINTERFEST21_N: "पैन - स्नो डूम",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "पैट स्किन: स्नो ओतेरो",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "पैट स्किन: वैगर ऑन आइस",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "पैट स्किन: ट्राइबल येती",
  T_31_HQ_PETSKIN_YETI_RED_N: "पैट स्किन: गुस्सैल येती",
  T_31_HQ_SICKLE_WINTERFEST21_N: "साइथ - स्नो",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "मोटरबाइक - आइस ब्लॉसम्स",
  T_31_HQ_YETI_N: "येती",
  T_31_KK_WINTER_BUJIX: "सप्लाई क्रेट",
  T_31_KK_WINTER_SANJITOU: "हेलमेट",
  T_31_L_A_BDCRICKET: "विक्ट्री बैटर (मास्क)",
  T_31_L_A_WINTERFEST21: "रेन्डियर कवर",
  T_31_L_B_BDCRICKET: "विक्ट्री बैटर (बॉटम)",
  T_31_L_B_MEJERSEY_10: "No.10 रूबी जर्सी (बॉटम)",
  T_31_L_B_MEJERSEY_11: "No. 11 रेड जर्सी (बॉटम)",
  T_31_L_B_MEJERSEY_13: "No. 13 वाइट जर्सी (बॉटम)",
  T_31_L_B_MEJERSEY_18G: "No. 18 ग्रीन जर्सी (बॉटम)",
  T_31_L_B_MEJERSEY_18R: "No. 18 मरून जर्सी (बॉटम)",
  T_31_L_B_MEJERSEY_7: "No. 7 बेसिल जर्सी (बॉटम)",
  T_31_L_F_B_RUMUSICIAN: "स्ट्रैप्ड ट्रांस (बॉटम)",
  T_31_L_F_B_THAGENT: "नाईट प्रोवाकटर (बॉटम)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "टाई डाई बकेट",
  T_31_L_F_H_RUMUSICIAN: "स्ट्रैप्ड ट्रांस (हेड)",
  T_31_L_F_H_THAGENT: "नाईट प्रोवाकटर (हेड)",
  T_31_L_F_HA_RUMUSICIAN: "स्ट्रैप्ड ट्रांस (फेसपेंट)",
  T_31_L_F_S_RUMUSICIAN: "स्ट्रैप्ड ट्रांस (जूते)",
  T_31_L_F_S_THAGENT: "नाईट प्रोवाकटर (जूते)",
  T_31_L_F_T_RUMUSICIAN: "स्ट्रैप्ड ट्रांस (टॉप)",
  T_31_L_F_T_THAGENT: "नाईट प्रोवाकटर (टॉप)",
  T_31_L_HA_RUMUSICIAN_MU: "स्ट्रैप ट्रैप (फेसपेंट)",
  T_31_L_HA_WINTERFEST21_BLUE: "फ्रोज़न क्लाउन फेसपेंट",
  T_31_L_HA_WINTERFEST21_PINK: "पिंक फायरस्पार्क फेसपेंट",
  T_31_L_M_A_REGGAETON_B: "नियॉन रेगेइटन (मास्क)",
  T_31_L_M_A_REGGAETON_P: "वाइब्रेंट वैनिटी (मास्क)",
  T_31_L_M_A_RUMUSICIAN: "स्ट्रैप्ड ट्रैप (मास्क)",
  T_31_L_M_A_THAGENT: "नाईट स्काउटर (मास्क)",
  T_31_L_M_B_PKCOSTUME: "स्मार्ट इन ग्रीन (बॉटम)",
  T_31_L_M_B_REGGAETON_B: "नियॉन रेगेइटन (बॉटम)",
  T_31_L_M_B_REGGAETON_P: "वाइब्रेंट वैनिटी (बॉटम)",
  T_31_L_M_B_RUMUSICIAN: "स्ट्रैप्ड ट्रैप (बॉटम)",
  T_31_L_M_B_THAGENT: "नाईट स्काउटर (बॉटम)",
  T_31_L_M_H_GREENCAP: "विनर कैप",
  T_31_L_M_H_PKCOSTUME: "स्मार्ट इन ग्रीन (हेड)",
  T_31_L_M_H_REGGAETON_B: "नियॉन रेगेइटन (हेड)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "टाई डाई हैट",
  T_31_L_M_H_REGGAETON_P: "वाइब्रेंट वैनिटी (मास्क)",
  T_31_L_M_H_RUMUSICIAN: "स्ट्रैप्ड ट्रैप (हेड)",
  T_31_L_M_H_THAGENT: "नाईट स्काउटर (हेड)",
  T_31_L_M_S_PKCOSTUME: "स्मार्ट इन ग्रीन (जूते)",
  T_31_L_M_S_REGGAETON_B: "नियॉन रेगेइटन (जूता)",
  T_31_L_M_S_REGGAETON_P: "वाइब्रेंट वैनिटी (जूते)",
  T_31_L_M_S_RUMUSICIAN: "स्ट्रैप्ड ट्रैप (जूते)",
  T_31_L_M_S_THAGENT: "नाईट स्काउटर (जूते)",
  T_31_L_M_T_PKCOSTUME: "स्मार्ट इन ग्रीन (टॉप)",
  T_31_L_M_T_REGGAETON_B: "नियॉन रेगेइटन (टॉप)",
  T_31_L_M_T_REGGAETON_P: "वाइब्रेंट वैनिटी (टॉप)",
  T_31_L_M_T_REGGAETON_TATOO: "फैमिलीया इंक",
  T_31_L_M_T_RUMUSICIAN: "स्ट्रैप्ड ट्रैप (टॉप)",
  T_31_L_M_T_THAGENT: "नाईट स्काउटर (टॉप)",
  T_31_L_S_BDCRICKET: "विक्ट्री बैटर (जूते)",
  T_31_L_T_BDCRICKET: "विक्ट्री बैटर (टॉप)",
  T_31_L_T_BRBANK: "मरून बॉम्बर",
  T_31_L_T_MEJERSEY_10: "No.10 रूबी जर्सी (टॉप)",
  T_31_L_T_MEJERSEY_11: "No. 11 रेड जर्सी (टॉप)",
  T_31_L_T_MEJERSEY_13: "No. 13 वाइट जर्सी (टॉप)",
  T_31_L_T_MEJERSEY_18G: "No. 18 ग्रीन जर्सी (टॉप)",
  T_31_L_T_MEJERSEY_18R: "No. 18 मरून जर्सी (बॉटम)",
  T_31_L_T_MEJERSEY_7: "No. 7 बेसिल जर्सी (टॉप)",
  T_31_L_T_PKMOBILE: "इंफीनिक्स टी-शर्ट",
  T_31_L_T_REGGAETON_HOOD: "गैंग स्माइल हूडी",
  T_31_MF_CHARACTER_WINTERGUY_N: "नैरी",
  T_31_R_EMOTE_FALCONER_NAME: "नंबर 1",
  T_31_RW_COMBINEMACHINE_2: "अकिम्बो एक्टिवेटर (एडवांस)",
  T_31_RW_VIBRATION_EXPLOSION: "एक्सप्लोसिव",
  T_31_RW_VIBRATION_MELEEWEAPONS: "मेले वेपन्स",
  T_31_RW_VIBRATION_OTHERWEAPONS: "दूसरी गन्स",
  T_31_T_WS_1PLAYERTEAM: "सोलो",
  T_31_T_WS_2PLAYERTEAM: "डुओ",
  T_31_T_WS_3PLAYERTEAM: "ट्रिओ",
  T_31_T_WS_4PLAYERTEAM: "स्क्वाड",
  T_31_T_WS_5PLAYERTEAM: "वर्सज़ 5",
  T_31_T_WS_6PLAYERTEAM: "वर्सज़ 6",
  T_31_T_WS_BUFFTIME_TITLE: "रिफ्रेश टाइम (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "गोली",
  T_31_T_WS_BUFFTYPE_ARMOR: "आर्मर",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "रैंडम",
  T_31_T_WS_BUFFTYPE_TITLE: "बफ टाइप",
  T_31_T_WS_DESC48: "आपको मिलीसेकंड के भीतर दूसरी जगह ले जाता है",
  T_31_T_WS_DESC49: "एक पियानो की आवाज करता है",
  T_31_T_WS_DESC51: "एक ड्रम की आवाज करता है",
  T_31_T_WS_DESC53: "एक सिन्थसाइज़र की आवाज़ करता है",
  T_31_T_WS_DESC59: "एक डिवाइस जो समय-समय पर बफ़ पैदा करता है. संबंधित एन्हांसमेंट पाने के लिए इसे उठाएं",
  T_31_T_WS_DRUMTYPE_CLAPS: "ताली",
  T_31_T_WS_DRUMTYPE_HIHATS: "हाय-हैट",
  T_31_T_WS_DRUMTYPE_KICK: "किक ड्रम",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "हाय-हैट खुल रहा",
  T_31_T_WS_DRUMTYPE_RIDES: "राइड सिम्बल",
  T_31_T_WS_DRUMTYPE_SNARES: "स्नेर ड्रम",
  T_31_T_WS_EARLYSHRINK: "तेज़ छोटा होना",
  T_31_T_WS_ITEM48: "पोर्टल",
  T_31_T_WS_ITEM49: "पिआनो की",
  T_31_T_WS_ITEM51: "ड्रम की",
  T_31_T_WS_ITEM53: "कॉम्बो की A",
  T_31_T_WS_ITEM55: "कॉम्बो की B",
  T_31_T_WS_ITEM57: "कॉम्बो की C",
  T_31_T_WS_ITEM59: "बफ जनरेटर",
  T_31_T_WS_LATESHRINK: "देर से छोटा होना",
  T_31_T_WS_ME_DAMAGE: "दिया डैमेज",
  T_31_T_WS_ME_DAMAGED: "लिया डैमेज",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "शुरुआती EP प्रोपोरशन",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "पहले सेफ ज़ोन की रेडियस",
  T_31_T_WS_ME_EPQUICKRESTORE: "तुरंत EP संरक्षित",
  T_31_T_WS_ME_FLOW: "मोड",
  T_31_T_WS_ME_GENERALSETTING: "सामन्य",
  T_31_T_WS_ME_INRANDOMSPAWN: "रैंडम स्पॉन पॉइंट",
  T_31_T_WS_ME_KILLSCORE: "एलिमिनेशन बोनस",
  T_31_T_WS_ME_MAXEP: "मैक्स EP",
  T_31_T_WS_ME_MAXHP: "मैक्स HP",
  T_31_T_WS_ME_NEARTEAM: "आस-पास टीममेट",
  T_31_T_WS_ME_REBIRTH: "रिस्पॉन वेटिंग टाइम",
  T_31_T_WS_ME_REBIRTHLOCATION: "रिस्पॉन लोकेशन",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "ज़ोन छोटा होने का समय",
  T_31_T_WS_ME_WINSCORE: "विनिंग स्कोर",
  T_31_T_WS_MINIZONE: "मिनी ज़ोन",
  T_31_T_WS_MUSICTYPE_TITLE: "म्यूजिक टाइप",
  T_31_T_WS_UNLIMITEDAMMO: "अनलिमिटेड गोली",
  T_31_WT_WS_DESC1: "एक चौकोर लकड़ी का बॉक्स जिसे जमा किया जा सकता है",
  T_31_WT_WS_DESC10: "ऊपर चढ़ने के लिए  लकड़ी की सीढ़ियों के साथ एक रन-डाउन झोपड़ी",
  T_31_WT_WS_DESC11: "शूटिंग के मक़सद के लिए कई विंडो के साथ बना",
  T_31_WT_WS_DESC12: "मेटल से बना और इसमें दरवाजे और खिड़कियां हैं",
  T_31_WT_WS_DESC13: "दरवाजे और विंडो हैं",
  T_31_WT_WS_DESC14: "छत के साथ दो मंजिला घर",
  T_31_WT_WS_DESC15: "सीलबंद छत वाला दो मंजिला घर",
  T_31_WT_WS_DESC16: "डेकॉर- एक हार्ट शेप वाला रेत का पुतला",
  T_31_WT_WS_DESC17: "डेकॉर- क्रिस्टल-क्लियर पानी का एक फाउंटेन",
  T_31_WT_WS_DESC18: "डेकॉर- गुलाब फूल वाला पेड़",
  T_31_WT_WS_DESC19: "डेकॉर- एक छोटा बिना केले वाला केले का पेड़",
  T_31_WT_WS_DESC2: "एक आयताकार लकड़ी का बक्सा जिसे जमा किया जा सकता है",
  T_31_WT_WS_DESC20: "एक सफेद बाथरूम फर्नीचर जिसे घर के अंदर रखा जा सकता है",
  T_31_WT_WS_DESC21: "एक छोटी फेंस जिसका इस्तेमाल एरिया को बांटें में के लिए किया जा सकता है",
  T_31_WT_WS_DESC22: "इस कंटेनर के किनारे के लकड़ी के बोर्ड को फाॅर्स से तोड़ा जा सकता है",
  T_31_WT_WS_DESC23: "एक छोटी सी फेंस जिसे ताकत से तोड़ा जा सकता है",
  T_31_WT_WS_DESC24: "टीम A का स्पॉन एरिया (केवल क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य)",
  T_31_WT_WS_DESC25: "टीम B का स्पॉन एरिया (केवल क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य)",
  T_31_WT_WS_DESC26: "कम दूरी के लिए जिस दिशा फेस है उस तरफ प्लेयर्स को उछाल देता है",
  T_31_WT_WS_DESC27: "कम दूरी के लिए पहले से तय दिशा में प्लेयर्स को उछाल देता है",
  T_31_WT_WS_DESC28: "मध्यम दूरी के लिए पहले से तय दिशा में प्लेयर्स को उछाल देता है",
  T_31_WT_WS_DESC29: "लंबी दूरी के लिए प्लेयर्स को पहले से तय दिशा में उछाल देता है",
  T_31_WT_WS_DESC3: "लाल और पीले रंग के फूलों से सजी जो आपके बैटलफ़ील्ड को रोशन कर सकती है",
  T_31_WT_WS_DESC30: "एक बम्पर कार जिसे चलाया जा सकता है",
  T_31_WT_WS_DESC31: "एक जमीन और पानी पर चलने वाली कार जिसे ड्राइव किया जा सकता है",
  T_31_WT_WS_DESC32: "एक जीप जिसे चलाया जा सकता है",
  T_31_WT_WS_DESC33: "कूड़े से भरा. इंसान से छोटा लेकिन थोड़ा कवर दे सकता है",
  T_31_WT_WS_DESC34: "खुली हवा में, मेटल का रेस ट्रैक शेल्टर",
  T_31_WT_WS_DESC35: "एक मीडियम साइज का टेंट जिसमें दो दरवाजे हैं लेकिन कोई खिड़कियाँ नहीं हैं",
  T_31_WT_WS_DESC36: "ईंटों से बना एक बड़ा गैरेज",
  T_31_WT_WS_DESC37: "एक बड़ी ईंट की दीवार जिसका इस्तेमाल एरिया को बांटें में किया जा सकता है",
  T_31_WT_WS_DESC38: "एक काम का लैंडमार्क",
  T_31_WT_WS_DESC39: "एक मेटैलिक प्लेटफॉर्म जिसे मुख्य फाइटिंग पिट के तौर पर इस्तेमाल किया जा सकता है",
  T_31_WT_WS_DESC4: "एक इंसानों से लंबा और इसलिए कवर के तौर पर काम  कर सकता है",
  T_31_WT_WS_DESC40: "एक रीक्रिएशनल व्हीकल की तरह दिखता है और इसमें कई दरवाजे और खिड़कियां हैं",
  T_31_WT_WS_DESC41: "एक रीक्रिएशनल व्हीकल की तरह दिखता है और इसमें कई दरवाजे और खिड़कियां हैं",
  T_31_WT_WS_DESC42: "एंट्रेंस के साथ एक तरफा दीवार",
  T_31_WT_WS_DESC43: "एक नियमित एकतरफा दीवार",
  T_31_WT_WS_DESC44: "एक दीवार का कोना",
  T_31_WT_WS_DESC45: "एक उबड़-खाबड़ दीवार का कोना",
  T_31_WT_WS_DESC46: "एक उबड़-खाबड़ दीवार का कोना",
  T_31_WT_WS_DESC47: "खिड़कियों के साथ एक दीवार का कोना",
  T_31_WT_WS_DESC5: "एक छोड़ी गई कार जो इंसान से थोड़ी छोटी है लेकिन थोड़ा कवर दे सकती है",
  T_31_WT_WS_DESC6: "एक इंसानों से लंबा और इसलिए कवर के तौर पर काम  कर सकता है",
  T_31_WT_WS_DESC7: "दोनों सिरों पर खुला और पाथ बनाने या एरिया को बांटने के लिए सेट किया जा सकता है",
  T_31_WT_WS_DESC8: "एक सिरे पर खुला और एरिया को बांटने में इस्तेमाल किया जा सकता है",
  T_31_WT_WS_DESC9: "दोनों सिरों पर सील और एरिया बांटें में इस्तेमाल किया जा सकता है",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "गाड़ी",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "[FFB300]{0}s[-] के लिए तेज़ी से आगे बढ़ता है. प्रत्येक यूज़ के बीच [FFB300]{3}s[-] के कूलडाउन के साथ, इस कौशल को  [FFB300]{2} uses[-] उसे तक जमा किया जा सकता है. डैश वापस भरने का [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "रिबेल रश",
  T_32_HQ_AUG_VNSTREET_N: "AUG- रोरिंग गनफ़ाइटर",
  T_32_HQ_BACKPACK_REDDRAGON_N: "डानलिट ड्रैगन बैकपैक",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- वैम्पायर मलेवलेंस",
  T_32_HQ_GLOO_DUNHUANG_N: "ग्लू वॉल - फ्रोज़ेन प्लैटिनम",
  T_32_HQ_GLOO_HURRICANE_2_N: "ग्लू वॉल - अरॉरा कोर",
  T_32_HQ_GRENADE_HURRICANE_N: "ग्रेनेड - ब्रासी माइक",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - फ्रोज़ेन प्लैटिनम",
  T_32_HQ_PETSKIN_DUCK_RED_N: "पैट स्किन: रेड बीनी",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "पैट स्किन: साइबर फ़्लैश",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "पैट स्किन: गेमर फ़्लैश",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "पैट स्किन: फेस्टिव फ़्लैश",
  T_32_HQ_TORTOISE_N: "फ़्लैश",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "स्पोर्ट्स कार- बेरीड पर्पलडस्ट",
  T_32_L_F_A_PHARAOH: "गोल्डकोटेड क्लेओ (मास्क)",
  T_32_L_F_B_PHARAOH: "गोल्डकोटेड क्लेओ (बॉटम)",
  T_32_L_F_H_PHARAOH: "गोल्डकोटेड क्लेओ (हेड)",
  T_32_L_F_HA_PHARAOH: "गोल्डकोटेड क्लेओ (फेसपेंट)",
  T_32_L_F_S_PHARAOH: "गोल्डकोटेड क्लेओ (जूते)",
  T_32_L_F_T_PHARAOH: "गोल्डकोटेड क्लेओ (टॉप)",
  T_32_L_M_A_JUNKFOOD: "बर्गर लैड (मास्क)",
  T_32_L_M_A_PHARAOH: "गोल्डलाइंड ममी (मास्क)",
  T_32_L_M_B_JUNKFOOD: "बर्गर लैड (बॉटम)",
  T_32_L_M_B_PHARAOH: "गोल्डलाइंड ममी (बॉटम)",
  T_32_L_M_H_JUNKFOOD: "बर्गर लैड (हेड)",
  T_32_L_M_H_PHARAOH: "गोल्डलाइंड ममी (हेड)",
  T_32_L_M_S_JUNKFOOD: "बर्गर लैड (जूते)",
  T_32_L_M_S_PHARAOH: "गोल्डलाइंड ममी (जूते)",
  T_32_L_M_T_JUNKFOOD: "बर्गर लैड (टॉप)",
  T_32_L_M_T_PHARAOH: "गोल्डलाइंड ममी (टॉप)",
  T_32_L_T_WHITESWEATER: "वाइट टर्टलनेक",
  T_32_LC_NEWVAULT_EMOTE: "इमोट",
  T_32_LO_WS_IMMORTAL: "अमर ज़ोन",
  T_32_LO_WS_ITEM60: "पाइप",
  T_32_LO_WS_ITEM60_DESC: "चलने योग्य टनल",
  T_32_LO_WS_ITEM61: "T पाइप",
  T_32_LO_WS_ITEM61_DESC: "एक चलने योग्य T टनल",
  T_32_LO_WS_ITEM62: "पाइप इंटरसेक्शन",
  T_32_LO_WS_ITEM62_DESC: "चलने योग्य इंटेरसेक्टिंग टनल",
  T_32_LO_WS_ITEM63: "पाइप कॉर्नर",
  T_32_LO_WS_ITEM63_DESC: "चलने योग्य एंगल वाली टनल",
  T_32_LO_WS_ITEM64: "फ़ूड ट्रक",
  T_32_LO_WS_ITEM64_DESC: "एक बाईट के लिए यहां रुकें",
  T_32_LO_WS_ITEM65: "मश शेड",
  T_32_LO_WS_ITEM65_DESC: "एक बड़ा मशरूम जो एक इंसान को ले जा सकता है",
  T_32_LO_WS_ITEM66: "हेंगर",
  T_32_LO_WS_ITEM66_DESC: "आमतौर पर रिहायशी इलाकों में देखा जाता है",
  T_32_LO_WS_ITEM67: "वुडेन प्लैंक",
  T_32_LO_WS_ITEM67_DESC: "एक साधारण लकड़ी का पुल बनाने के लिए इस्तेमाल करें",
  T_32_LO_WS_ITEM68: "जाली स्क्रीन",
  T_32_LO_WS_ITEM68_DESC: "एक ओरिएण्टल फील",
  T_32_LO_WS_ITEM69: "पिलर",
  T_32_LO_WS_ITEM69_DESC: "आमतौर पर निर्माण स्थलों पर देखा जाता है",
  T_32_LO_WS_ITEM70: "कैक्टस",
  T_32_LO_WS_ITEM70_DESC: "ताकतवर बड़ा लेकिन डंक नहीं मारता",
  T_32_LO_WS_ITEM71: "पत्ती रहित पेड़",
  T_32_LO_WS_ITEM71_DESC: "एक पेड़ जो सदियों से जीवित है",
  T_32_LO_WS_ITEM72: "स्टोन लैंटर्न",
  T_32_LO_WS_ITEM72_DESC: "शाही उद्यानों में दर्शनीय सजावट",
  T_32_LO_WS_ITEM73: "स्ट्रीटलैंप",
  T_32_LO_WS_ITEM73_DESC: "अक्सर सड़कों पर देखा जाता है",
  T_32_LO_WS_ITEM74: "सोलर पैनल",
  T_32_LO_WS_ITEM74_DESC: "सूर्य के प्रकाश से एनर्जी को अवशोषित करता है",
  T_32_LO_WS_ITEM75: "एयर कंडीशनर A",
  T_32_LO_WS_ITEM75_DESC: "गर्मी में मस्त रहें",
  T_32_LO_WS_ITEM76: "फैन",
  T_32_LO_WS_ITEM77: "फ्लाई पैन",
  T_32_LO_WS_ITEM78: "क्यूब",
  T_32_LO_WS_ITEM79: "रिंग",
  T_32_LO_WS_ITEM80: "हैमर",
  T_32_LO_WS_ITEM81: "बोर्ड",
  T_32_LO_WS_ITEM82: "शूटिंग टारगेट",
  T_32_LO_WS_ITEM83: "फ्लेक्स वॉल",
  T_32_LO_WS_ITEM84AMMO: "गोली लूट पॉइंट",
  T_32_LO_WS_ITEM84AMMO_DESC: "प्लेस करने पर, तो चुना हुआ गोली टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM84AR: "आर्मर लूट पॉइंट",
  T_32_LO_WS_ITEM84AR_DESC: "प्लेस करने पर, तो चुना हुआ आर्मर टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM84ARLV1: "आर्मर Lv. 1",
  T_32_LO_WS_ITEM84ARLV2: "आर्मर Lv. 2",
  T_32_LO_WS_ITEM84ARLV3: "आर्मर Lv. 3",
  T_32_LO_WS_ITEM84CO: "कन्जयूएब्ल लूट पॉइंट",
  T_32_LO_WS_ITEM84CO_DESC: "प्लेस करने पर, तो चुना हुआ कंज्यूमेब्ल टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM84JA: "थ्रोएब्ल लूट पॉइंट",
  T_32_LO_WS_ITEM84JA_DESC: "प्लेस करने पर, तो चुना हुआ थ्रोएब्ल टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM84TE: "स्कोप लूट पॉइंट",
  T_32_LO_WS_ITEM84TE_DESC: "प्लेस करने पर, तो चुना हुआ स्कोप टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM84W: "वेपन लूट पॉइंट",
  T_32_LO_WS_ITEM84W_DESC: "प्लेस करने पर, तो चुना हुआ वेपन टाइप वहां स्पॉन होगा",
  T_32_LO_WS_ITEM85: "डूम/इमोर्टल ज़ोन",
  T_32_LO_WS_ITEM85_DESC: "जब रखा जाता है, तो ट्रिगर ज़ोन में प्रवेश करने वाले प्लेयर्स इमॉर्टल या डूम के एक खास इफ़ेक्ट का अनुभव करेंगे. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_32_LO_WS_ITEM85CP: "चेकपॉइंट्स",
  T_32_LO_WS_ITEM85CP_DESC: "पार्कोर मोड में गेमप्ले बनाने के लिए इस्तेमाल किया जाने वाला आइटम. फाइनल चेकपॉइंट दिखने के लिए, प्लेयर्स को एक-एक करके हर एक चेकपॉइंट से गुजरना होगा. जब एलिमिनेट किया जाता है और फिर से स्पॉन होते हैं, तो प्लेयर अपने द्वारा पास अंतिम चेकपॉइंट पर फिर से स्पॉन होना चुन सकता है. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_32_LO_WS_ITEM85TM: "फिनिशिंग पॉइंट",
  T_32_LO_WS_ITEM85TM_DESC: "पार्कोर मोड में गेमप्ले बनाने के लिए इस्तेमाल किया जाने वाला आइटम. टारगेट पूरा करने के लिए प्लेयर्स को फिनिशिंग लाइन के अंदर पहुंचना होगा. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_32_LO_WS_ITEM86: "स्पॉन पॉइन्ट",
  T_32_LO_WS_ITEM86_DESC: "इस पॉइंट पर कोई विशिष्ट टीम नहीं असाइन की जाएगी. जब रखा जाता है, तो एक रैंडम टीम यहां दिखाई देगी. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_32_LO_WS_ITEM86L: "बड़ा स्पॉन पॉइंट",
  T_32_LO_WS_ITEM86L_DESC: "पार्कोर मोड के लिए सुझाया गया एक बड़ा स्पॉन पॉइंट, जहां सभी प्लेयर्स एक लाइन में स्पॉन करेंगे. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_32_LO_WS_ITEM87: "ब्लॉक",
  T_32_LO_WS_ITEM87_DESC: "साइज कस्टमाइज चालू करें",
  T_32_LO_WS_ITEM88: "सुबॉइड & स्लोप",
  T_32_LO_WS_ITEM88_DESC: "सुबॉइड & स्लोप जिसका आकार एडजस्ट किया जा सकता है",
  T_32_LO_WS_ITEMLINE: "शिफ्ट",
  T_32_LO_WS_ITEMMOVE: "ट्रिगर सेटिंग",
  T_32_LO_WS_ITEMROT: "ट्रांसफॉर्म करें",
  T_32_LO_WS_ITEMSCALE: "स्केल",
  T_32_LO_WS_KILLZONE: "डूम ज़ोन",
  T_32_LO_WS_LOOT_AMMOTYPE: "गोली",
  T_32_LO_WS_LOOT_ARTYPE: "आर्मर",
  T_32_LO_WS_LOOT_COTYPE: "कंज्यूएबल",
  T_32_LO_WS_LOOT_JATYPE: "फेंकने योग्य",
  T_32_LO_WS_LOOT_RANDOM: "रैंडम",
  T_32_LO_WS_LOOT_TETYPE: "स्कोप",
  T_32_LO_WS_LOOT_WEAPONTYPE: "वेपन",
  T_32_LO_WS_SCALEX: "लम्बाई",
  T_32_LO_WS_SCALEY: "ऊंचाई",
  T_32_LO_WS_SCALEZ: "चौड़ा",
  T_32_LO_WS_TRIGGERH: "छुपाएं",
  T_32_LO_WS_TRIGGERHORP: "दिखाएं/छुपाएं ट्रिगर",
  T_32_LO_WS_TRIGGERP: "दिखाएं",
  T_32_LO_WS_TRIGGERTYPE: "ट्रिगर टाइप",
  T_32_M_WS_MODE_ANNIHILATE: "वाइप आउट",
  T_32_M_WS_MODE_SCORE: "पॉइंट्स ग्रैब",
  T_32_M_WS_MODE_SPEED: "पार्कोर",
  T_32_M_WS_MULTIPLETEAMS: "मल्टी-टीम कॉम्बैट",
  T_32_M_WS_ROUNDS: "राउंड",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "स्विचिंग स्टेप्स",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "डेंजर ज़ोन",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "डैमेज",
  T_32_T_WS_ME_BLUECIRCLESETTING: "डेंजर ज़ोन",
  T_32_T_WS_ME_CUSTOM: "कस्टमाइज",
  T_32_T_WS_ME_ENDTYPE1: "वाइप आउट",
  T_32_T_WS_ME_ENDTYPE2: "हासिल पॉइंट्स",
  T_32_T_WS_ME_ENDTYPE3: "पार्कोर",
  T_32_T_WS_ME_ENDTYPEDESC1: "सर्वाइव करने वाली आख़िरी बनें",
  T_32_T_WS_ME_ENDTYPEDESC2: `एक पॉइंट-बेस्ड मोड जिसमें जो टीम पहले टारगेट स्कोर तक पहुँचती है, वही जीतती है.
आप गेमप्ले रूल्स और पैरामीटर्स को अपनी पसंद के अनुसार सेट कर सकते हैं, जैसे कि एलिमिनेशन पर मिलने वाला स्कोर.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `एक पार्कौर मोड जहाँ जिस टीम के सभी सदस्य सबसे पहले फिनिशिंग पॉइंट तक पहुँचते हैं, वही जीतती है.
आप गेमप्ले रूल्स, रास्तों में इस्तेमाल होने वाले ऑब्जेक्ट्स और फिनिशिंग लाइन को अपनी पसंद के अनुसार सेट कर सकते हैं.`,
  T_32_T_WS_ME_MATCHTIME: "मैच टाइम",
  T_32_T_WS_ME_MECHANIC: "मैकेनिज्म",
  T_32_T_WS_ME_NEARCHECKPOINT: "चेकपॉइंट के पास",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "कुल मिलाकर 12 से ज़्यादा प्लेयर्स रखने में असमर्थ",
  T_32_T_WS_ME_PREGAMETIME: "तैयारी टाइम",
  T_32_T_WS_ME_RESPAWN: "रीस्पॉन्स",
  T_32_T_WS_ME_RESPAWNSETTING: "रीस्पॉन",
  T_32_T_WS_ME_ROUNDNUM: "राउंड की संख्या",
  T_32_T_WS_ME_ROUNDOPEN: "कई राउंड चालू",
  T_32_T_WS_ME_ROUNDRESET: "राउंड रीसेट्स",
  T_32_T_WS_ME_ROUNDSETTING: "राउंड्स",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "जोन सिकुड़ने की अवधि",
  T_32_T_WS_ME_SCORESETTING: "स्कोर",
  T_32_T_WS_ME_TEAMMATENUM: "सदस्य प्रति टीम",
  T_32_T_WS_ME_TEAMNUM: "टीम की संख्या",
  T_32_T_WS_ME_TEAMSETTING: "टीम",
  T_32_U_ATTACHMENT_8: "बैग पाउच",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "अपग्रेड चिप",
  T_32_WT_WS_BARRIER: "बैरियर्स",
  T_32_WT_WS_BDS: "बिल्डिंग्स",
  T_32_WT_WS_MMINVALIDERROR: "अमान्य मैप कोड",
  T_32_WT_WS_TRGS: "ट्रिगर्स",
  T_32_YF_CHARGESHOT_N: "चार्ज बस्टर",
  T_32_YF_GOLD_GROZA_N: "Groza-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "एक्स्ट्रा डैमेज",
  T_32_YS_WEAPON_TAG_3: "रेट ऑफ़ फायर",
  T_32_YS_WEAPON_TAG_36: "आर्मर पियर्सिंग",
  T_32_YS_WEAPON_TAG_39: "अकिम्बो सपोर्ट करती",
  T_32_YS_WEAPON_TAG_42: "आइस वॉल",
  T_33_C_SKILL_DESC_GRAFFITIST: "एक ऐसा [FFB300]{0}m[-] का एरिया बनाता है जिसमें थ्रोएब्ल अमान्य हैं. एरिया में सहयोगी हर सेकंड  [FFB300]{1}%[-] आर्मर की मजबूती रीस्टोर कर सकेंगे और गोलियों से मिलने वाला डैमेज [FFB300]{2}%[-] कम हो जाएगा. इफ़ेक्ट रहता है {3}s. इफ़ेक्ट जमा नहीं होता.  कूलडाउन: [FFB300]{4}s[-] .",
  T_33_C_SKILL_DESC_HITMAN: "स्नाइपर और मार्क्समैन राइफल्स का इस्तेमाल करते समय, फायरिंग की आवाज शांत हो जाती है और सफल नॉक हुए दुश्मनों को [FFB300]{0}%[-] तेजी से खून बहता है.",
  T_33_C_SKILL_DESC_KENTA: "[FFB300]{0}m[-] चौड़ाई की एक शील्ड बनाता है जो सामने से आने वाले वेपन डैमेज को [FFB300]{1}%[-] कम करता है. फायरिंग करते समय, डैमेज में कमी [FFB300]{2}%[-] तक कम हो जाती है. [FFB300]{3}s[-] तक रहता है. कूलडाउन: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "दुश्मनों का विनाश करने  [FFB300]{0}m[-] डायामीटर की इलेक्ट्रोमैग्नेटिक वेव छोड़ती है जो दुश्मन की एक्टिव स्किल को बंद करती है , [FFB300]{3} DMG[-] देती है और उनके काउंटडाउन में बाधा डालती है.  [FFB300]{1}s[-] तक रहता है. कूलडाउन: [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "फायरआर्म एक्सपर्ट",
  T_33_C_SKILL_NAME_KENTA: "स्वॉर्ड्समैन्स रैथ",
  T_33_C_SKILL_NAME_MADEMANA: "थ्रिल ऑफ़ बैटल",
  T_33_DY_AXOLOTL_N: "ज़ैसिल",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "पैट स्किन: फ्रूटी ज़ैसिल",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "पैट स्किन: FFWS बीनी",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "पैट स्किन: ब्लूमिंग फैल्को",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "डेडली बगेट",
  T_33_HQ_EMOTE_SONGKRAN_N: "कम एंड डांस",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- हाइपरकोर ब्लू",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "ग्रेनेड - हाइपरकोर ब्लू",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - बर्निंग लिली",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG7 - शैडो रोग",
  T_33_HQ_MP40_FFWS03_N: "MP40 - हेवन वॉरियर",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - हेवन वॉरियर",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "साइथ - एमराल्ड पावर",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "डैगर - हेवन वॉरियर",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "वेक्टर- हाइपरकोर ब्लू",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "जीप- एमराल्ड शिमर",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "मॉन्स्टर ट्रक- बोनब्रूज़र स्कॉर्च",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "पिक अप ट्रक - हेवन गार्डियन",
  T_33_LO_WS_BHPARA_A: "एक्टिव",
  T_33_LO_WS_BHPARA_ATKMODE: "अटैक टाइप",
  T_33_LO_WS_BHPARA_GROUP: "टीम",
  T_33_LO_WS_BHPARA_NA: "कोई हमला नहीं",
  T_33_LO_WS_BHPARA_P: "पैसिव",
  T_33_LO_WS_DICE_DESC: "एक डाइस जो आपकी जम्प को आगे बढ़ाता है और कई गेमप्ले में इस्तेमाल किया जा सकता है",
  T_33_LO_WS_DICEVXZ: "होरिजॉन्टल स्पीड",
  T_33_LO_WS_DICEVY: "वर्टीकल स्पीड",
  T_33_LO_WS_DTOWER: "टावर",
  T_33_LO_WS_DTOWER_DESC: "अपने-आप उन दुश्मनों पर हमला करता है जो डिफेंसिव स्ट्रक्चर से एक निश्चित दूरी के भीतर हैं. बंद होता है, अगर इसका HP जीरो तक पहुंच जाती है. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_33_LO_WS_FORT: "फॉर्ट्रस",
  T_33_LO_WS_FORT_DESC: "अपने-आप उन दुश्मनों पर हमला करता है जो क्रिटिकल स्ट्रक्चर से एक निश्चित दूरी के भीतर हैं. बंद होता है, अगर इसका HP जीरो तक पहुंच जाती है. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_33_LO_WS_ITEM89: "रिफाइनरी टैंक",
  T_33_LO_WS_ITEM89_DESC: "एक वाटर-स्टोरिंग स्ट्रक्चर",
  T_33_LO_WS_ITEM90: "डॉग हाउस",
  T_33_LO_WS_ITEM90_DESC: "पप्पी का घर",
  T_33_LO_WS_ITEM91: "बस स्टॉप",
  T_33_LO_WS_ITEM91_DESC: "एक आम बस स्टॉप",
  T_33_LO_WS_ITEM92: "ग्रैफ़िटी वॉल",
  T_33_LO_WS_ITEM92_DESC: "स्प्रे पेंट से सजा एक कुआं",
  T_33_LO_WS_ITEM93: "स्टेबल",
  T_33_LO_WS_ITEM93_DESC: "घास का स्ट्रक्चर",
  T_33_LO_WS_ITEM94: "बेंच",
  T_33_LO_WS_ITEM94_DESC: "एक पार्क बेंच",
  T_33_LO_WS_ITEM95: "स्टोन ब्रिज",
  T_33_LO_WS_ITEM95_DESC: "पत्थरों से बना पुल",
  T_33_LO_WS_ITEM96: "सन शेड",
  T_33_LO_WS_ITEM96_DESC: "अम्ब्रेला के अंदर सन-बर्न से बचाता है",
  T_33_LO_WS_ITEM97: "फिनिश लाइन आर्क",
  T_33_LO_WS_ITEM97_DESC: "फिनिशिंग लाइन को इंडीकेट करें",
  T_33_LO_WS_ITEM98: "एड बोर्ड",
  T_33_LO_WS_ITEM98_DESC: "ऐड्स के लिए एक नियमित बैनर",
  T_33_LO_WS_PARA_DM: "डैमेज",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "दुश्मन स्कैन डिस्टेंस",
  T_33_LO_WS_PARA_SP: "स्पीड",
  T_33_LO_WS_ZBPARA_AMOUNT: "ज़ॉम्बी प्रति वेव",
  T_33_LO_WS_ZBPARA_INTERVAL: "वेव इंटरवल (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# लहरों का",
  T_33_LO_WS_ZBSPAWNER: "ज़ॉम्बी स्पॉन",
  T_33_LO_WS_ZBSPAWNER_DESC: "ऑटो रूप से ज़ॉम्बी पैदा करता है, जिसका व्यवहार ड्रॉप डाउन मेन्यू से कॉन्फ़िगर किया जा सकता है. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "केंटा",
  T_33_PD_ZOMBIE_LEVELUP: "लेवल अप",
  T_33_RW_SKILL_DESC_GANGGIRL: "फायरिंग रेट में [FFB300]{0}%[-] की बढ़ोतरी होती है. जब यूजर किसी दुश्मन से हिट होता है, तो अधिकतम [FFB300]{1}%[-] फायरिंग रेट, मूवमेन्ट स्पीड में बदलती है, और कॉम्बैट में जब यूजर जिन्दा रहता है तो कन्वर्शन रिसेट होता है.",
  T_33_RW_SKILL_NAME_GANGGIRL: "फाइट-या-फ्लाइट",
  T_33_WT_WS_BASICSET1: "बेसिक",
  T_33_WT_WS_QCEPRTIP: "EP को HP में तेज़ी से बदलता है",
  T_33_WT_WS_SKILLSET_TAG: "अनलिमिटेड स्किल",
  T_33_WT_WS_SKILLSET1: "स्किल सेटिंग",
  T_33_WT_WS_SKILLSET10: "टाइम टर्नर (क्रोनो)",
  T_33_WT_WS_SKILLSET11: "रिपटाइड रिदम (स्काईलर)",
  T_33_WT_WS_SKILLSET12: "एक्सट्रीम एनकाउंटर (ज़ेयन)",
  T_33_WT_WS_SKILLSET13: "हीलिंग हार्टबीट (दिमित्री)",
  T_33_WT_WS_SKILLSET2: "पैसिव स्किल्स",
  T_33_WT_WS_SKILLSET2_TIP: "पैसिव स्किल चालू/बंद करें",
  T_33_WT_WS_SKILLSET3: "एक्टिव स्किल (नीचे कोल्डाउन समय एडजस्ट करने के लिए चालू करें)",
  T_33_WT_WS_SKILLSET3_TIP: "एक्टिव स्किल चालू/बंद करें. अगर ऑन है, तो विभिन्न एक्टिव स्किल का कोल्डाउन समय नीचे कॉन्फ़िगर किया जा सकता है.",
  T_33_WT_WS_SKILLSET4: "कैमफ्लाश़",
  T_33_WT_WS_SKILLSET5: "थ्रिल ऑफ़ बैटल (A124)",
  T_33_WT_WS_SKILLSET6: "ड्रॉप द बीट (अलोक)",
  T_33_WT_WS_SKILLSET7: "पेंटेड रिफ्यूजी (स्टेफी)",
  T_33_WT_WS_SKILLSET8: "ट्रेसिंग स्टेप्स (क्लू)",
  T_33_WT_WS_SKILLSET9: "मास्टर ऑफ़ ऑल (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "से.",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "रैंडॉल (बॉटम)",
  T_33_YS_H_ONIGIRI: "ओनीगिरी हुड",
  T_33_YS_H_RAINCOAT: "रैंडॉल (हेड)",
  T_33_YS_HA_CRYINGFACE: "क्राइंग इमोट (फेसपेंट)",
  T_33_YS_M_H_FROGKING: "फ्रॉग किंग कैप",
  T_33_YS_S_RAINCOAT: "रैंडॉल (जूते)",
  T_33_YS_T_BLACKHOLE: "डॉप्लर शिफ्ट हुडी",
  T_33_YS_T_RAINCOAT: "रैंडॉल (टॉप)",
  T_33_YS_T_SOCCER_GREEN: "इलेक्ट्रिफ़ाइड किक (जर्सी)",
  T_33_YS_T_SOCCER_YELLOW: "एनर्जाइज़्ड किक (टी-शर्ट)",
  T_33_YS_T_WIFI: "नेट एन नेक्स्ट टी-शर्ट",
  T_34_C_SKILL_DESC_STREAMERGUY: "हर एलिमिनेशन या स्पेक्टेटर एक इफ़ेक्ट स्टैक देता है.  हर स्टैक से आपको मिलने वाला हेडशॉट डैमेज [FFB300]{0}%[-] तक कम हो जाता है (अधिकतम [FFB300]{1}%[-] तक), और दुश्मनों को दिया गया हेडशॉट डैमेज [FFB300]{2}%[-] तक बढ़ जाता है (अधिकतम [FFB300]{3}%[-] तक).",
  T_34_C_SKILL_DESC_TRACKER: "[FFB300]100[-]m फ्रंटल दूरी के भीतर निकटतम दुश्मन की ओर एक ड्रोन छोड़ता है, जिससे [FFB300]{5}m-डायमीटर[-] का पल्स विस्फोट होता है जो मूवमेंट स्पीड को [FFB300]{0}%[-] और फायरिंग स्पीड को [FFB300]{1}%[-] कम कर देता है. [FFB300]{3}s[-] सेकेंड तक रहता है. [FFB300]{2} DMG[-] डैमेज देता है.  कूलडाउन: {4}s.",
  T_34_C_SKILL_NAME_TRACKER: "सेंसेस शॉकवेव",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "पैट स्किन: एंग्री सर्फर फिन",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "पैट स्किन: डीप ओशन फिन",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "पैट स्किन: थंडरस्टॉर्म फिन",
  T_34_DY_PETSKIN_TIGER_BIS_N: "पैट स्किन: डिजिटल टिग",
  T_34_DY_SURFSHARK_N: "फिन",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "ग्रेट कंडक्टर",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "एनेर्जिक",
  T_34_HQ_EMOTE_RIDICULE_N: "रैडिक्यूल",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "पिकअप ट्रक - ईविल इंजीनियर",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "टुक टुक- हस्की पप",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle- हाइब्रिड एक्सप्लोशन",
  T_34_JL_G36_MADBIONIC_N: "G36- फ्लेयरिंग बायोनिका",
  T_34_JL_GRENADE_BIS_N: "ग्रेनेड - सोल्जर पिक्सल",
  T_34_JL_MACHETE_RAMPAGE4_N: "नाईट ब्लेड",
  T_34_JL_THROWINGKNIFE_BANANA_N: "बनाना डैगर",
  T_34_JL_UMP45_BIS_N: "UMP- डिजिटल डैशर",
  T_34_LY_WS_ABS_DESC: "इस संख्या की ऐब्सलूट वैल्यू हासिल करें",
  T_34_LY_WS_ADD_DESC: "लिस्ट के अंत में एक नया एलिमेंट जोड़ें",
  T_34_LY_WS_AUTO_A: "दुश्मन ऑटो स्कैन",
  T_34_LY_WS_BOT: "नियमित",
  T_34_LY_WS_BOT_PATH: "पाथ",
  T_34_LY_WS_BOT_TYPE: "टाइप",
  T_34_LY_WS_BOT4: "एक्स",
  T_34_LY_WS_BOT5: "टॉसिंग",
  T_34_LY_WS_BOT6: "सेल्फ-एक्सप्लोड",
  T_34_LY_WS_BOT8: "शील्डेड",
  T_34_LY_WS_COL_DESC: "कोई कलर चुनें",
  T_34_LY_WS_DEL_DESC: "लिस्ट में किसी नामित इंडेक्स के जुड़े एलिमेंट को डिलीट करें",
  T_34_LY_WS_DF_PER: "डिफेंस %",
  T_34_LY_WS_FORT_INTERVAL: "अटैक इंटरवल टाइम (s)",
  T_34_LY_WS_GET: "हासिल करें",
  T_34_LY_WS_GET_DESC: "लिस्ट में किसी नामित इंडेक्स के जुड़े एलिमेंट को हासिल करें",
  T_34_LY_WS_GLEN_ARR_DESC: "मौजूदा लिस्ट में एलिमेंट्स की संख्या हासिल करें",
  T_34_LY_WS_GLEN_DESC: "टेक्स्ट की इस स्ट्रिंग की लंबाई हासिल करें",
  T_34_LY_WS_GVX: "x वेक्टर कॉम्पोनेन्ट हासिल करें",
  T_34_LY_WS_GVX_DESC: "पहले वेक्टर कॉम्पोनेन्ट हासिल करें",
  T_34_LY_WS_GVY: "Y वेक्टर कॉम्पोनेन्ट पाएं",
  T_34_LY_WS_GVY_DESC: "वेक्टर का दूसरा कॉम्पोनेन्ट हासिल करें",
  T_34_LY_WS_GVZ: "z वेक्टर कॉम्पोनेन्ट हासिल करें",
  T_34_LY_WS_GVZ_DESC: "तीसरे वेक्टर कॉम्पोनेन्ट हासिल करें",
  T_34_LY_WS_INDEX: "इंडेक्स",
  T_34_LY_WS_JOIN: "कनेक्ट",
  T_34_LY_WS_NEG_DESC: "इस नंबर के लिए नेगेटिव वैल्यू इस्तेमाल करें",
  T_34_LY_WS_PATH: "पाथ सेटर",
  T_34_LY_WS_PATH_DESC: "स्पेशल लिविंग आइटम के सफर पाथ जोड़ने/हटाने के लिए इस्तेमाल करें. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_34_LY_WS_POINT: "मार्कर",
  T_34_LY_WS_POINT_DESC: "मौजूदा स्थिति की जगह को मार्क करने के लिए इस्तेमाल करें. (क्लैश स्क्वाड, टीम डेथमैच और प्लेग्राउंड मोड में मान्य नहीं)",
  T_34_LY_WS_RANGE_F: "फर",
  T_34_LY_WS_RANGE_M: "मीडियम",
  T_34_LY_WS_RANGE_N: "पास",
  T_34_LY_WS_RNDF_DESC: "एक इंटरवल से एक रैंडम डेसीमल जनरेट करें",
  T_34_LY_WS_RNDI_DESC: "एक इंटरवल से एक रैंडम इंटीजर जनरेट करें",
  T_34_LY_WS_SET: "मॉडिफाई करें",
  T_34_LY_WS_SET_DESC: "लिस्ट में किसी नामित इंडेक्स के जुड़े एलिमेंट को सेट करें",
  T_34_LY_WS_SQRT_DESC: "नंबर का स्क्वायर रूट हासिल करें",
  T_34_LY_WS_STRC_DESC: "टेक्स्ट की दो स्ट्रिंग कनेक्ट करें",
  T_34_LY_WS_SVX: "x वेक्टर कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_SVX_DESC: "वेक्टर का पहला कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_SVY: "y वेक्टर कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_SVY_DESC: "वेक्टर का दूसरा कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_SVZ: "z वेक्टर कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_SVZ_DESC: "वेक्टर का तीसरा कॉम्पोनेन्ट सेट करें",
  T_34_LY_WS_VADD: "वेक्टर जोड़",
  T_34_LY_WS_VADD_DESC: "दो वेक्टर को जोड़ें",
  T_34_LY_WS_VAL_DESC: "स्थिति के अनुसार एक इन्टिजर या दशमलव इनपुट करें",
  T_34_LY_WS_VANG_DESC: "दो वेक्टर के बीच एंगल कैलकुलेट करें",
  T_34_LY_WS_VCP: "क्रॉस प्रोडक्ट",
  T_34_LY_WS_VCP_DESC: "दो वेक्टर के क्रॉस प्रोडक्ट की गणना करें",
  T_34_LY_WS_VDIS_DESC: "दो वेक्टर के बीच की दूरी की गणना करें",
  T_34_LY_WS_VDP: "डॉट प्रोडक्ट",
  T_34_LY_WS_VDP_DESC: "दो वैक्टर के डॉट प्रोडक्ट कैलकुलेट करें",
  T_34_LY_WS_VFX1: "स्फेरिकल",
  T_34_LY_WS_VFX2: "सिलिंड्रिकल",
  T_34_LY_WS_VFX3: "रिंग",
  T_34_LY_WS_VFX4: "बूम",
  T_34_LY_WS_VFX5: "पिक्सल्स",
  T_34_LY_WS_VFX6: "स्पार्क",
  T_34_LY_WS_VMOD_DESC: "एक वेक्टर के परिमाण की गणना करें",
  T_34_LY_WS_VMUL: "वेक्टर मल्टिप्लिकेशन",
  T_34_LY_WS_VMUL_DESC: "दो वैक्टर गुणा करें",
  T_34_LY_WS_VNOR_DESC: "वेक्टर नार्मलाइज़ करें",
  T_34_LY_WS_VSUB: "वेक्टर सब्ट्रैक्शन",
  T_34_LY_WS_VSUB_DESC: "दो वैक्टर घटाएं",
  T_34_M_WS_ANGLE: "रोटेट",
  T_34_M_WS_ARRAY: "लिस्ट",
  T_34_M_WS_ATT: "प्रॉपर्टी",
  T_34_M_WS_BOOL: "बूलियन",
  T_34_M_WS_COLORARRAY: "कलर ऐरे",
  T_34_M_WS_COLOUR: "कलर",
  T_34_M_WS_CONFRONBANNER: "बैटल बैनर",
  T_34_M_WS_COORDINATE: "कोऑर्डिनेट",
  T_34_M_WS_CUSTOMINF: "कस्टम HUD",
  T_34_M_WS_CUSTOMMODEDESC: `एक खाली और पूरी तरह कस्टमाइज़ेबल मोड जिसमें कोई प्रीसेट गेमप्ले नहीं होता, जहाँ आप अपने खुद के रूल्स बना कर खेल सकते हैं.
शुरुआती मैप क्रिएटर्स के लिए थोड़ा चुनौतीपूर्ण हो सकता है.`,
  T_34_M_WS_DAMAGETYPE: "डैमेज टाइप",
  T_34_M_WS_DAMAGETYPEDESC: "मौजूदा समय में सिस्टम द्वारा निर्धारित डैमेज टाइप",
  T_34_M_WS_DESCTEXT: "डिस्क्रिप्टिव टेक्स्ट",
  T_34_M_WS_DURACTION: "अवधि",
  T_34_M_WS_ECAMODE: "कस्टमाइज मोड",
  T_34_M_WS_ENDPHASEDESC: "मौजूदा स्टेज को तुरंत समाप्त करें और अगले स्टेज के लिए आगे बढ़ें",
  T_34_M_WS_ENTITY: "एंटिटी",
  T_34_M_WS_FLOAT: "डेसीमल",
  T_34_M_WS_GAME: "गेम",
  T_34_M_WS_GAMERESULTS: "मैच रिजल्ट",
  T_34_M_WS_GETCONTROL2: "एंटिटी के प्रॉपर्टी (डिज़ाइन, रंग, कलर, आदि सहित) को एडिट करने के लिए प्लेयर इंटरफ़ेस से एक कंट्रोल एंटिटी पाएं.",
  T_34_M_WS_HEIGHT: "हाइट",
  T_34_M_WS_HUDBUTTONWIDGET: "बटन कंट्रोल",
  T_34_M_WS_HUDEMPTYWIDGET: "खाली पिवट",
  T_34_M_WS_HUDIMAGEWIDGET: "इमेज कंट्रोल",
  T_34_M_WS_HUDINPUTWIDGET: "टेक्स्ट बॉक्स कंट्रोल",
  T_34_M_WS_HUDLABELWIDGET: "टेक्स्ट कंट्रोल",
  T_34_M_WS_ICON: "आइकॉन",
  T_34_M_WS_ICON_AIM: "ऐम",
  T_34_M_WS_ICON_ARROW: "ऐरो",
  T_34_M_WS_ICON_BLAST: "ब्लास्ट",
  T_34_M_WS_ICON_CIRCULAR: "सर्किल",
  T_34_M_WS_ICON_CLOTH: "पाम",
  T_34_M_WS_ICON_COLLIMATION: "क्रॉसहेयर",
  T_34_M_WS_ICON_CORPSE: "ज़ॉम्बी",
  T_34_M_WS_ICON_CROSS: "क्रॉस",
  T_34_M_WS_ICON_DAY: "सन",
  T_34_M_WS_ICON_DEFENSE: "शील्ड",
  T_34_M_WS_ICON_DIALOGUE: "डायलाग",
  T_34_M_WS_ICON_DIAMONDS: "डायमंड",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "एक्सक्लमेशन मार्क",
  T_34_M_WS_ICON_FLAG: "फ्लैग",
  T_34_M_WS_ICON_FOLDER: "फोल्डर",
  T_34_M_WS_ICON_GLASSES: "आँख",
  T_34_M_WS_ICON_GUN: "गन",
  T_34_M_WS_ICON_HEART: "हार्ट",
  T_34_M_WS_ICON_HEXAGON: "हेक्सागॉन",
  T_34_M_WS_ICON_HOURGLASS: "ऑवरग्लास",
  T_34_M_WS_ICON_HOUSE: "हाउस",
  T_34_M_WS_ICON_KEY: "की",
  T_34_M_WS_ICON_LIGHTNING: "लाइटिंग",
  T_34_M_WS_ICON_LOCK: "लॉक",
  T_34_M_WS_ICON_LOOP: "लूप",
  T_34_M_WS_ICON_MAGNIFIER: "मैग्नीफाइंग लेंस",
  T_34_M_WS_ICON_MONEY: "मनी",
  T_34_M_WS_ICON_MONTH: "मून",
  T_34_M_WS_ICON_OPENFOLDER: "फोल्डर खोलें",
  T_34_M_WS_ICON_PLUS: "प्लस",
  T_34_M_WS_ICON_QUADRI: "चतुर्भुज",
  T_34_M_WS_ICON_QUESTIONMARK: "क्वेश्चन मार्क",
  T_34_M_WS_ICON_RECYCLING: "रीसायकल",
  T_34_M_WS_ICON_REFRESH: "रिफ्रेश",
  T_34_M_WS_ICON_REST: "रेस्ट",
  T_34_M_WS_ICON_RETURN: "वापस",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "राइट ट्रेपेज़ोइड",
  T_34_M_WS_ICON_SCISSORS: "सिज़र्ज़",
  T_34_M_WS_ICON_SETUP: "सेटिंग",
  T_34_M_WS_ICON_SIGN: "मार्क",
  T_34_M_WS_ICON_SIGNOUT: "बहार निकालें",
  T_34_M_WS_ICON_SQUARE: "स्क्वायर",
  T_34_M_WS_ICON_STAR: "स्टार",
  T_34_M_WS_ICON_STONE: "स्टोन",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "स्विम रिंग",
  T_34_M_WS_ICON_TAGGING: "पिन",
  T_34_M_WS_ICON_THESWORD: "स्वॉर्ड",
  T_34_M_WS_ICON_TRAPEZOID: "ट्रेपेज़ोइड",
  T_34_M_WS_ICON_TRASHCAN: "ट्रैश कैन",
  T_34_M_WS_ICON_TRIANGLE: "ट्रायंगल",
  T_34_M_WS_ICON_TROPHY: "ट्रॉफी",
  T_34_M_WS_ICON_UP: "थंब्स अप",
  T_34_M_WS_ICON_WRONG: "गलत",
  T_34_M_WS_ICON_YES: "राइट",
  T_34_M_WS_ICONNAME: "आइकॉन नाम",
  T_34_M_WS_INT: "इंटीजर",
  T_34_M_WS_KILLZONE: "डूम ज़ोन",
  T_34_M_WS_LEFTCOLOR: "लेफ्ट कलर",
  T_34_M_WS_LEFTTEAMINDEX: "लेफ्ट टीम इंडेक्स",
  T_34_M_WS_LEFTTEAMSCORE: "लेफ्ट टीम स्कोर",
  T_34_M_WS_LOCSWITCH: "लोकलाइजेशन स्विच",
  T_34_M_WS_MAX: "अधिकतम",
  T_34_M_WS_MIN: "मिनिमन",
  T_34_M_WS_NUMBER: "नंबर",
  T_34_M_WS_OBJECT: "एंटिटी",
  T_34_M_WS_OPEN: "ऑन",
  T_34_M_WS_OPENSATUS: "स्टेटस चालू करें",
  T_34_M_WS_PICTURE: "ग्राफ़िक्स",
  T_34_M_WS_RANKARRAY: "रैंक ऐरे",
  T_34_M_WS_RESULTS: "रिजल्ट",
  T_34_M_WS_RIGHTCOLOR: "राइट कलर",
  T_34_M_WS_RIGHTTEAMINDEX: "राइट टीम इंडेक्स",
  T_34_M_WS_RIGHTTEAMSCORE: "राइट टीम स्कोर",
  T_34_M_WS_ROUNDBANNER: "राउंड बैनर",
  T_34_M_WS_ROUNDDESC: "राउंड विवरण",
  T_34_M_WS_ROUNDHUD: "राउंड नंबर",
  T_34_M_WS_ROUNDPARAMS: "राउंड नंबर ऐरे",
  T_34_M_WS_SAME_NAME: "रिपीट हुआ नाम. कृपया एक नया आज़माएं.",
  T_34_M_WS_SCOREARRAY: "स्कोर ऐरे",
  T_34_M_WS_SCORINGTYPE: "स्कोर टाइप",
  T_34_M_WS_SCORINGTYPEDECS: "प्लेयर को किस टाइप का स्कोर मिल सकता है. स्कोर कस्टमइजेशन को सपोर्ट करता है.",
  T_34_M_WS_SCUFFLESCORING: "मल्टी-टीम स्कोर",
  T_34_M_WS_SETATTRIBUTES: "प्रॉपर्टी सेटिंग",
  T_34_M_WS_SHUT: "बंद",
  T_34_M_WS_SOUND: "साउंड इफ़ेक्ट",
  T_34_M_WS_SOUNDCLICK: "क्लिकिंग",
  T_34_M_WS_SOUNDDD: "काउंटडाउन",
  T_34_M_WS_SOUNDFEMALEA: "इंजर्ड (महिला)",
  T_34_M_WS_SOUNDM: "गनफायर",
  T_34_M_WS_SOUNDMALEA: "इंजर्ड (पुरुष)",
  T_34_M_WS_SOUNDUAV: "एक्सप्लोशन",
  T_34_M_WS_ST_ASSISTCOUNT: "असिस्ट",
  T_34_M_WS_ST_CHECKPROGRESS: "चेकपॉइंट्स प्रोग्रेस",
  T_34_M_WS_ST_DAMAGESUM: "डैमेज",
  T_34_M_WS_ST_FINISHCOUNT: "हासिल गोल की मात्रा",
  T_34_M_WS_ST_FINISHORDER: "हासिल गोल का क्रम",
  T_34_M_WS_ST_FINISHTIME: "हासिल टारगेट के समय",
  T_34_M_WS_ST_KILLCOUNT: "एलिमिनेशंस",
  T_34_M_WS_ST_MAINSCORE: "टारगेट स्कोर",
  T_34_M_WS_ST_RANKSCORE: "रैंक स्कोर",
  T_34_M_WS_ST_SURVIVALDURACTION: "सर्वाइवल टाइम",
  T_34_M_WS_ST_UNKOWN: "अननोन",
  T_34_M_WS_STARTBANNER: "स्टार्ट बैनर",
  T_34_M_WS_STARTTIME: "स्टार्ट टाइम",
  T_34_M_WS_STRING: "टेक्स्ट",
  T_34_M_WS_STUDIO: "स्टूडियो",
  T_34_M_WS_TEAMARRAY: "टीम ऐरे",
  T_34_M_WS_TEXTCONTENT: "कंटेंट",
  T_34_M_WS_THEMECOLOR: "थीम कलर",
  T_34_M_WS_TIME: "काउंटडाउन HUD",
  T_34_M_WS_TITLETEXT: "टाइटल टेक्स्ट",
  T_34_M_WS_TYPE: "टाइप",
  T_34_M_WS_UODATETYPE: "अपडेट टाइप",
  T_34_M_WS_VARNAME: "वेरिएबल का नाम",
  T_34_M_WS_VECTOR: "वेक्टर",
  T_34_M_WS_VFX: "विज़ुअल इफ़ेक्ट",
  T_34_M_WS_WIDTH: "चौड़ाई",
  T_34_MF_CHARACTER_TRACKER_N: "होमर",
  T_34_PD_FlagBattle_HYPE_1: "फायर",
  T_34_SP_WS_BLOCK1_NAME: "स्विच स्टेज",
  T_34_SP_WS_BLOCK1_NAMEDESC: "पसंद की स्टेज (या राउंड) में प्रवेश करने के लिए मैच के स्टेज पर स्विच करें. राउंड में स्टेज इंडेक्स भी होते हैं और एक स्पेशल टाइप के स्टेज होते हैं.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "टारगेट स्टेज की इंडेक्स",
  T_34_SP_WS_BLOCK10_NAME: "विज़ुअल इफ़ेक्ट बनायें",
  T_34_SP_WS_BLOCK10_NAMEDESC: "तय विज़ुअल इफ़ेक्ट का इस्तेमाल करके एक आइकन बनाएं. विज़ुअल इफ़ेक्ट एंटिटी की प्रॉपर्टी को एडजस्ट करके विज़ुअल इफ़ेक्ट की ज़्यादा क्वालिटी को कॉन्फ़िगर किया जा सकता है.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "विज़ुअल इफ़ेक्ट",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "विज़ुअल इफ़ेक्ट के टाइप जिन्हें लागू किया जा सकता है",
  T_34_SP_WS_BLOCK12_NAME: "विज़ुअल इफ़ेक्ट डिलीट करें",
  T_34_SP_WS_BLOCK12_NAMEDESC: "नामित विज़ुअल इफ़ेक्ट को डिलीट करें",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "विज़ुअल इफ़ेक्ट एंटिटी",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "डिलीट किए जाने वाली  विज़ुअल इफ़ेक्ट एंटिटी",
  T_34_SP_WS_BLOCK13_NAMEDESC: "क्लाइंट को विसुअल इफ़ेक्ट प्ले करने का ऑर्डर दें",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "प्लेयर्स लिस्ट",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "मैसेज पाने करने वाले प्लेयर्स",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "रिसोर्स पाथ",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "सिस्टम रिसोर्स पाथ :पाथ में है. कस्टम रिसोर्स पाथ:पाथ में नहीं है. डिफ़ॉल्ट रूप से खाली.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA चैनल, प्रत्येक चैनल के साथ 0 और 255 के बीच का मान int32 में सेव किया गया है. डिफ़ॉल्ट रंग सफेद है (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "ज़ूम",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "ज़ूम स्केल; डिफ़ॉल्ट रूप से 1 है",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "ग्लोबल कॉर्डिनेट में प्रदर्शित डिस्प्ले की स्थिति. वेक्टर3(0) डिफ़ॉल्ट रूप से.",
  T_34_SP_WS_BLOCK14_NAME: "साउंड इफ़ेक्ट प्ले करें",
  T_34_SP_WS_BLOCK14_NAMEDESC: "क्लाइंट को साउंड इफ़ेक्ट प्ले करने का ऑर्डर दें",
  T_34_SP_WS_BLOCK15_NAME: "आउटपुट लॉग",
  T_34_SP_WS_BLOCK15_NAMEDESC: "लॉग इंटरफ़ेस पर आउटपुट कॉन्टेंट",
  T_34_SP_WS_BLOCK2_NAMEDESC: "सेफ ज़ोन के बाहर के प्लेयर को डैमेज पहुंचाने के लिए चालू करें",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "सेफ जोन का सेंटर पॉइंट",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "रेडियस",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "सेफ ज़ोन की रेडियस",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "सेफ जोन के सिकुड़ने का काउंटडाउन",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "सेफ ज़ोन की अवधि कम होती है",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "सेफ ज़ोन से बाहर होने पर हुए डैमेज की मात्रा",
  T_34_SP_WS_BLOCK3_NAMEDESC: "जब डेंजर ज़ोन बंद हो जाता है, तो सेफ़ ज़ोन के बाहर के प्लेयर को डैमेज नहीं होगा.",
  T_34_SP_WS_BLOCK4_NAMEDESC: "बताए समय के लिए बाद की कार्रवाई में देरी करने के लिए इस्तेमाल करें",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "इंतज़ार की अवधि, मिलीसेकंड में मापी गई",
  T_34_SP_WS_BLOCK5_NAMEDESC: "अगले एक्शन को अगले फ्रेम में पोस्टपोन करने के लिए इस्तेमाल करें",
  T_34_SP_WS_BLOCK6_NAME: "कस्टम HUD बनाएं",
  T_34_SP_WS_BLOCK6_NAMEDESC: "एक नामित कस्टम HUD बनाएं",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "एक नाम जिसका इस्तेमाल HUD एंटिटी बनाने के लिए किया जाता है. यह जिस लोकल वेरिएबलसे मेल खाती है वह HUD एंटिटी है जिसे बनाया जा रहा है.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "प्लेयर",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "एक स्पेसिफिक प्लेयर की एंटिटी. सिर्फ़ उक्त प्लेयर को दिखाई देता है.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "एक HUD की यूनिक इंडेक्स",
  T_34_SP_WS_BLOCK7_NAMEDESC: "एक डिफ़ॉल्ट HUD बनाएं, जो केवल नामित प्लेयर्स के लिए विज़िबल हो",
  T_34_SP_WS_BLOCK8_NAMEDESC: "डिलीट करने पर, क्लाइंट पर डिफ़ॉल्ट HUD नहीं देखा जाएगा (या तो छिपा हुआ या ख़त्म किया हुआ )",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD एंटिटी",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "HUD एंटिटी को हटाया जाना है",
  T_34_SP_WS_BLOCK9_NAMEDESC: "डिलीट किए जाने पर, कस्टम HUD क्लाइंट पर नहीं देखा (या तो छिपा जायेगा या ख़त्म हो जायेगा)",
  T_34_T_WS_BLOCK1_NAMEDESC: "मैच शुरू होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK10_NAMEDESC: "जब प्लेयर एलिमिनेट हो जाता है तो इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "प्लेयर एलिमिनेट करें जो इंसिडेंट को ट्रिगर करेगा",
  T_34_T_WS_BLOCK13_NAMEDESC: "जब कोई प्लेयर दूसरे प्लेयर को असिस्ट करता है तो इंसिडेंट ट्रिगर हो जाता है",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "प्लेयर जो एलिमिनेट हो गया",
  T_34_T_WS_BLOCK14_NAMEDESC: "प्लेयर जब डैमेज देतें हैं तो इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "प्लेयर जिसे डैमेज मिला",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "किस तरह का डैमेज दिया गया",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "दिए डैमेज की मात्रा",
  T_34_T_WS_BLOCK15_NAMEDESC: "जब कोई प्लेयर किसी दूसरे प्लेयर को एलिमिनेट करता तब इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "प्लेयर जो एलिमिनेट हो गया",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "डैमेज का टाइप जो एलिमिनेशन का कारण बनता है",
  T_34_T_WS_BLOCK16_NAMEDESC: "जब कोई प्लेयर मैच में शामिल होता है तो इंसिडेंट ट्रिगर हो जाता है",
  T_34_T_WS_BLOCK17_NAMEDESC: "एक प्लेयर के रिवाइव होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK18_NAMEDESC: "टीम रिमूव होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK19_NAMEDESC: "जब कोई टीम जोड़ी जाती है तो इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK2_NAMEDESC: "मैच ख़त्म होने पर इंसिडेंट ट्रिगर होती है",
  T_34_T_WS_BLOCK20_NAMEDESC: "जब एक टीम का सफाया हो जाता है तो इंसिडेंट ट्रिगर हो जाता है",
  T_34_T_WS_BLOCK3_NAMEDESC: "हर राउंड शुरू होने पर इवेंट ट्रिगर हो जाता है",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "राउंड नंबर 0 से शुरू होता है.",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "राउंड इंडेक्स",
  T_34_T_WS_BLOCK4_NAMEDESC: "हर एक राउंड समाप्त होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK5_NAMEDESC: "स्टेज शुरू होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "स्टेज नंबर 0 से शुरू होती है",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "स्टेज एंटिटी",
  T_34_T_WS_BLOCK6_NAMEDESC: "स्टेज ख़त्म होने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK7_NAMEDESC: "जब कोई प्लेयर मैच से बाहर निकलता है तो इंसिडेंट ट्रिगर हो जाता है",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "प्लेयर जो इंसिडेंट ट्रिगर करेंगे",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "ट्रिगरिंग प्लेयर",
  T_34_T_WS_BLOCK8_NAMEDESC: "जब प्लेयर का स्कोर बदलता है तो इंसिडेंट ट्रिगर होता है.",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "बदले गए स्कोर का टाइप",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "चेंज के बाद स्कोर वैल्यू",
  T_34_T_WS_BLOCK9_NAMEDESC: "टीम स्कोर बदलने पर इंसिडेंट ट्रिगर होता है",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "टीम जो इंसिडेंट ट्रिगर करती है",
  T_34_WT_WS_BORNENTITY_PARAM1: "स्पॉन पॉइंट",
  T_34_WT_WS_BORNENTITY_PARAM2: "उपलब्ध कोऑर्डिनेट",
  T_34_WT_WS_BORNENTITY_PARAM3: "डिफ़ॉल्ट स्पॉन पॉइंट के रूप में सेट करें",
  T_34_WT_WS_BORNENTITY_PARAM4: "ग्लोइंग बॉउंडरी",
  T_34_WT_WS_BORNENTITY_PARAM5: "इस्तेमाल में",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "चेकपॉइंट HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "ओपन स्टेटस",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "स्टेटस ट्रिगर",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "एलिमिनेशन ट्रिगर",
  T_34_WT_WS_ENTITY_PARAM1: "गेम एंटिटी",
  T_34_WT_WS_ENTITY_PARAM10: "टीम्स का #",
  T_34_WT_WS_ENTITY_PARAM11: "टीम के सदस्यों का #",
  T_34_WT_WS_ENTITY_PARAM12: "इक्विपमेंट प्रत्येक राउंड में रीसेट होते हैं",
  T_34_WT_WS_ENTITY_PARAM13: "आउट-ऑफ-ज़ोन डैमेज चालू करें",
  T_34_WT_WS_ENTITY_PARAM14: "ज़ोन साइज",
  T_34_WT_WS_ENTITY_PARAM15: "जोन छोटा होने का टाइम",
  T_34_WT_WS_ENTITY_PARAM16: "ज़ोन सिकुड़ने की अवधि",
  T_34_WT_WS_ENTITY_PARAM17: "आउट-ऑफ़-ज़ोन डैमेज",
  T_34_WT_WS_ENTITY_PARAM18: "टारगेट स्कोर",
  T_34_WT_WS_ENTITY_PARAM19: "एलिमिनेशन स्कोर",
  T_34_WT_WS_ENTITY_PARAM2: "अमान्य स्टेटस",
  T_34_WT_WS_ENTITY_PARAM20: "रिवाइवल टाइप",
  T_34_WT_WS_ENTITY_PARAM21: "राउंड स्कोर रैंकिंग मानदंड (प्लेयर)",
  T_34_WT_WS_ENTITY_PARAM22: "मानदंड महत्व (प्लेयर)",
  T_34_WT_WS_ENTITY_PARAM23: "राउंड स्कोर रैंकिंग मानदंड (टीम)",
  T_34_WT_WS_ENTITY_PARAM24: "मानदंड महत्व (टीम)",
  T_34_WT_WS_ENTITY_PARAM25: "स्कोर रैंकिंग मानदंड (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "मानदंड महत्व (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "राउंड रैंकिंग स्कोर",
  T_34_WT_WS_ENTITY_PARAM28: "रिजल्ट पेज पर मानदंड दिखाएं",
  T_34_WT_WS_ENTITY_PARAM29: "कुल # राउंड",
  T_34_WT_WS_ENTITY_PARAM3: "दामे टाइम",
  T_34_WT_WS_ENTITY_PARAM4: "करंट राउंड इंडेक्स",
  T_34_WT_WS_ENTITY_PARAM5: "मौजूदा स्टेज इंडेक्स",
  T_34_WT_WS_ENTITY_PARAM6: "मोड टेम्पलेट ID",
  T_34_WT_WS_ENTITY_PARAM7: "प्लेयर रिवाइवल चालू करें",
  T_34_WT_WS_ENTITY_PARAM8: "बॉट रिवाइवल चालू करें",
  T_34_WT_WS_ENTITY_PARAM9: "रिवाइवल टाइम",
  T_34_WT_WS_ENTITY1_NAME: "मौजूदा एंटिटी",
  T_34_WT_WS_ENTITY1_NAMEDESC: "मौजूदा एंटिटी पर वापस",
  T_34_WT_WS_ENTITY10_NAME: "आइकॉन रिमूव करें",
  T_34_WT_WS_ENTITY10_NAMEDESC: "बताया गया आइकन रिमूव करें",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "उस आइकन चुनें जिसे आप हटाना चाहते हैं",
  T_34_WT_WS_ENTITY11_NAME: "टेक्स्ट रिमूव करें",
  T_34_WT_WS_ENTITY11_NAMEDESC: "टेक्स्ट एंटिटी रिमूव करें",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "वह टेक्स्ट चुनें जिसे आप डिलीट करना चाहते हैं",
  T_34_WT_WS_ENTITY12_NAMEDESC: "नामित प्लेयर के लिए एक आइटम जोड़ें",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "प्लेयर (प्लेयर्स) जो आइटम हासिल करेंगे",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "हासिल होने वाला स्पेसिफिक आइटम आईडी",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "दी जाने वाले आइटम की मात्रा",
  T_34_WT_WS_ENTITY12_PARAM3: "मात्रा",
  T_34_WT_WS_ENTITY13_PARAM1: "टाइप",
  T_34_WT_WS_ENTITY13_PARAM2: "लोकेशन",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "ऑब्जेक्ट के स्पॉन की जगह के कोऑर्डिनेट",
  T_34_WT_WS_ENTITY13_PARAM4: "ऑब्जेक्ट",
  T_34_WT_WS_ENTITY14_NAME: "ऑब्जेक्ट रिमूव करें",
  T_34_WT_WS_ENTITY14_NAMEDESC: "बताया गया कोई ऑब्जेक्ट रिमूव करें",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "ऑब्जेक्ट डिलीट करें",
  T_34_WT_WS_ENTITY15_NAMEDESC: "सभी प्लेयर एंटिटी एक्वायर करें",
  T_34_WT_WS_ENTITY16_NAMEDESC: "सभी टीम एंटिटी का अधिग्रहण करें",
  T_34_WT_WS_ENTITY17_NAMEDESC: "तय प्लेयर्स के लिए निर्धारित मात्रा में HP रिकवर करें. अगर रिकवरी मात्रा अधिकतम HP से ज़्यादा है, तो HP सिर्फ़ अधिकतम तक ही रिकवर होगी.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "प्लेयर (प्लेयर्स) जिनके HP उतार-चढ़ाव कॉन्फ़िगर किए जा रहे हैं",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "HP की निर्धारित मात्रा ही रिकवर की जाएगी",
  T_34_WT_WS_ENTITY18_NAME: "रैंडम स्पॉन कोऑर्डिनेट पाएं",
  T_34_WT_WS_ENTITY18_NAMEDESC: "तय प्लेयर्स के लिए जगह कॉन्फ़िगर करें जहां से स्पॉन करें और वापस जाएं",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "प्लेयर (प्लेयर्स) जो इस जगह से रैंडम रूप से स्पॉन करेंगे",
  T_34_WT_WS_ENTITY18_RETURNDESC: "उस जगह के कोऑर्डिनेट जहां प्लेयर असाइन किया जाएगा",
  T_34_WT_WS_ENTITY19_NAME: "प्लेयर स्कोर हासिल करें",
  T_34_WT_WS_ENTITY19_NAMEDESC: "नामित प्लेयर के कुछ स्कोर हासिल करें",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "इस प्लेयर (प्लेयर्स) की स्कोर एंटिटी हासिल करें",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "स्कोर के टाइप को हासिल करें",
  T_34_WT_WS_ENTITY19_RETURNDESC: "पाने वाली स्पेसिफिक स्कोर वैल्यू",
  T_34_WT_WS_ENTITY2_NAME: "प्रॉपर्टी सेट करें",
  T_34_WT_WS_ENTITY2_NAMEDESC: "किसी प्रॉपर्टी की वैल्यू को कॉन्फ़िगर करें, जहां प्रॉपर्टी टाइप पहले ही चुना जा चुका है",
  T_34_WT_WS_ENTITY2_PARAM1: "एंटिटी",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "गेम एंटिटी की प्रॉपर्टी वैल्यू",
  T_34_WT_WS_ENTITY2_PARAM3: "प्रॉपर्टी",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "इस गेम एंटिटी की एक निश्चित प्रॉपर्टी",
  T_34_WT_WS_ENTITY2_PARAM4: "वैल्यू",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "किसी प्रॉपर्टी का एक स्पेसिफिक वैल्यू. सुनिश्चित करें कि प्रॉपर्टी का टाइप चयनित के साथ मेल खाता है और संबंधित ब्लॉक में कॉन्फ़िगर किए गए टाइप से मेल खाता है.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "नामित प्लेयर्स के कुछ स्कोर कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "इस प्लेयर की स्कोर एंटिटी को कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "स्कोर के टाइप को कॉन्फिगर करें",
  T_34_WT_WS_ENTITY20_PARAM3: "स्कोर",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "स्पेसिफिक स्कोर वैल्यू सेट किया जा रहा है",
  T_34_WT_WS_ENTITY21_NAME: "टीम कुल स्कोर हासिल करें",
  T_34_WT_WS_ENTITY21_NAMEDESC: "नामित टीमों के कुछ कुल स्कोर हासिल करें",
  T_34_WT_WS_ENTITY21_PARAM1: "टीम",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "इस टीम (टीमों) की स्कोर एंटिटी पाएं",
  T_34_WT_WS_ENTITY22_NAME: "टीम का मौजूदा राउंड स्कोर सेट करें",
  T_34_WT_WS_ENTITY22_NAMEDESC: "तय टीमों के कुछ मौजूदा राउंड स्कोर कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "इस टीम (टीमों) के स्कोर को कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY23_NAME: "प्लेयर राउंड स्कोर हासिल करें",
  T_34_WT_WS_ENTITY23_NAMEDESC: "तय प्लेयर्स के लिए एक निश्चित राउंड के कुछ पॉइंट पाएं",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "इस खिलाड़ी(खिलाड़ियों) के राउंड स्कोर पाएं",
  T_34_WT_WS_ENTITY23_PARAM2: "राउंड",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "इस राउंड से स्कोर पाएं",
  T_34_WT_WS_ENTITY24_NAME: "टीम राउंड स्कोर हासिल करें",
  T_34_WT_WS_ENTITY24_NAMEDESC: "नामित टीमों के लिए एक निश्चित राउंड के कुछ स्कोर हासिल करें",
  T_34_WT_WS_ENTITY25_NAME: "टेलिपोर्ट",
  T_34_WT_WS_ENTITY25_NAMEDESC: "तय स्थान पर तय प्लेयर को टेलीपोर्ट करें",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "प्लेयर (प्लेयर्स) जिन्हें टेलीपोर्ट किया जाएगा",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "कोऑर्डिनेट जहां प्लेयर (प्लेयर्स) टेलीपोर्ट किए जाएंगे",
  T_34_WT_WS_ENTITY26_NAMEDESC: "तय प्लेयर्स को तय टारगेट को डैमेज पहुंचाने के लिए चालू करें. अगर कोई अटैकिंग प्लेयर नहीं चुना जाता है, तो तय टारगेट को सिस्टम से डैमेज होगा.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "एंटिटी जो डैमेज हासिल करेंगी",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "दिए गए डैमेज की मात्रा",
  T_34_WT_WS_ENTITY28_NAMEDESC: "नामित प्लेयर्स को रिवाइव करें",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "प्लेयर एंटिटी जो रिवाइव हो सकता है",
  T_34_WT_WS_ENTITY3_NAMEDESC: "ब्लॉक के प्रकार को कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY3_PARAM1: "के तौर पर",
  T_34_WT_WS_ENTITY4_NAME: "प्रॉपर्टी हासिल करें",
  T_34_WT_WS_ENTITY4_NAMEDESC: "एक एंटिटी की एक स्पेसिफिक प्रॉपर्टी हासिल करें",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "प्रॉपर्टी वैल्यू की स्पेसिफिक गेम एंटिटी पाएं",
  T_34_WT_WS_ENTITY4_RETURNDESC: "पाने के लिए स्पेसिफिक प्रॉपर्टी वैल्यू",
  T_34_WT_WS_ENTITY5_NAMEDESC: "सभी प्लेयर के लिए मूव करने की एबिलिटी को कॉन्फ़िगर करें",
  T_34_WT_WS_ENTITY6_NAME: "आइकॉन बनायें",
  T_34_WT_WS_ENTITY6_PARAM1: "आइकॉन",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD पर डिस्प्ले होने वाली इमेज. विभिन्न डिजाइनों में से चुनें.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "उस आइकन को चुनें जिस पर डिज़ाइन लागू किया जाना चाहिए",
  T_34_WT_WS_ENTITY7_NAMEDESC: "तय प्लेयर्स के लिए एक HUD आइकन बनाएं. अगर कोई प्लेयर  एंटिटी  नहीं चुना जाती है, तो सभी प्लेयर्स के लिए HUD बनाया जाएगा.",
  T_34_WT_WS_ENTITY7_PARAM1: "प्लेयर",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "चुनिंदा प्लेयर्स के लिए HUD आइकन बनाएं",
  T_34_WT_WS_ENTITY8_NAME: "टेक्स्ट बनाएं",
  T_34_WT_WS_ENTITY8_PARAM1: "टेक्स्ट",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "इस कमांड से बनाए जाने वाला स्पेशल टेक्स्ट कॉन्टेंट",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "टेक्स्ट एंटिटी जो वर्तमान में बनाई जा रही है",
  T_34_WT_WS_ENTITY9_NAMEDESC: "तय प्लेयर्स के लिए HUD टेक्स्ट की एक लाइन जोड़ें. अगर कोई प्लेयर एंटिटी नहीं चुना जाती है, तो सभी प्लेयर्स के HUD पर टेक्स्ट बनाया जाएगा.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "चुनिंदा प्लेयर के लिए HUG टेक्स्ट जोड़ें",
  T_34_WT_WS_ICONENTITY_PARAM1: "आइकॉन एंटिटी",
  T_34_WT_WS_ICONENTITY_PARAM2: "डिज़ाइन",
  T_34_WT_WS_ICONENTITY_PARAM3: "कलर",
  T_34_WT_WS_ICONENTITY_PARAM4: "स्केल",
  T_34_WT_WS_ICONENTITY_PARAM5: "डिस्प्ले की जगह",
  T_34_WT_WS_ICONENTITY_PARAM6: "टारगेट फॉलो करें",
  T_34_WT_WS_ICONENTITY_PARAM7: "वॉल से विज़िबल",
  T_34_WT_WS_ICONENTITY_PARAM8: "हमेशा स्क्रीन चालू",
  T_34_WT_WS_ONETEAM_TAG: "सिंगल टीम",
  T_34_WT_WS_PHASEENTITY_PARAM1: "स्टेज एंटिटी",
  T_34_WT_WS_PHASEENTITY_PARAM2: "स्टेज इंडेक्स",
  T_34_WT_WS_PHASEENTITY_PARAM3: "स्टार्ट टाइम",
  T_34_WT_WS_PHASEENTITY_PARAM4: "आखिरी टाइम",
  T_34_WT_WS_PHASEENTITY_PARAM5: "ट्रेपेज़ोइड्स",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "प्लेयर एंटिटी",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "रिवाइवल पॉइंट",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "डैमेज रेश्यो",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "कैरेक्टर 3D मॉडल",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "इन्डेन्टिटी",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "मौजूदा HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "प्लेयर स्टेट्स",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "सर्वाइवल टाइम",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "अभेद्य",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "टीम",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "टारगेट चेकपॉइंट ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "स्पॉन पॉइंट",
  T_34_WT_WS_PROCIRCLE_ICON: "आइकॉन",
  T_34_WT_WS_PVEDESC1: "अगर समय ख़त्म होने से पहले कम से कम एक प्लेयर फिनिशिंग लाइन तक पहुंचता है, तो टीम जीत जाती है. अगर सभी प्लेयर एक ही समय में एलिमिनेट हो जाते हैं, तो खेल ख़त्म हो जाता है.",
  T_34_WT_WS_PVEDESC2: "जीतने के लिए बताए समय तक सर्वाइव करें. अगर सभी प्लेयर्स एक ही समय में एलिमिनेट हो जाते हैं, तो खेल ख़त्म हो जाता है.",
  T_34_WT_WS_PVENAME1: "रश",
  T_34_WT_WS_PVENAME2: "एन्ड्यूरन्स",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "मौजूदा चेकपॉइंट ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "पार्कोर मोड चेकपॉइंट्स नंबर",
  T_34_WT_WS_SKILLSET14: "स्वॉर्ड्समैन रैथ (केंटा)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "टीम एंटिटी",
  T_34_WT_WS_TEAMENTITY_PARAM2: "ऐस",
  T_34_WT_WS_TEAMENTITY_PARAM3: "सभी मेंबर",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "रेगुलर ट्रिगर",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "उपस्थिति",
  T_34_WT_WS_TXTENTITY_PARAM1: "टेक्स्ट एंटिटी",
  T_34_WT_WS_TXTENTITY_PARAM2: "कंटेंट",
  T_34_WT_WS_VFXENTITY_PARAM1: "विसुअल एंटिटी को प्रभावित करता है",
  T_34_WZ_WS_LOGIC10_NAME: "अगले के लिए जारी रखें",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "वर्तमान लूप इटरेशन को स्किप करें और अगले को एक्सेक्यूट करें",
  T_34_WZ_WS_LOGIC11_NAME: "रिटर्न",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "मौजूदा एक्सेक्यूशन को समाप्त करता है और मुख्य प्रोग्राम में वापस आ जाता है. लौटने पर डेटा वापस भेजने की अनुमति देता है.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "रिटर्न वैल्यू",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "मुख्य प्रोग्राम में वापस भेजा जाने वाला डेटा",
  T_34_WZ_WS_LOGIC2_NAME: "कम्पेयर",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "नामित ऑपरेटर का इस्तेमाल करके 2 वैल्यू की तुलना करें",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "लेफ्ट वैल्यू",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "तुलना के लिए इस्तेमाल किया जाने वाला लेफ्ट साइड की वैल्यू",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "कम्पेयर फंक्शन",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "चुनें कि आप मान की तुलना कैसे करना चाहते हैं. समर्थित ऑपरेटर हैं: >, ≥, ==, ≠, ≤, <, AND (केवल बूलियन), OR (केवल बूलियन)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "सही वैल्यू",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "तुलना के लिए इस्तेमाल किया जाने वाला राइट साइड की वैल्यू",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "तुलना का नतीजा",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "लॉजिकल मान का उल्टा देता है",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "वह वैल्यू जिस पर आप NOT ऑपरेटर का इस्तेमाल करना चाहते हैं",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT ऑपरेशन का नतीजे",
  T_34_WZ_WS_LOGIC4_NAME: "चेक खाली",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "जांचें कि कोई एंटिटी खाली/शून्य है या नहीं",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "एंटिटी",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "एम्पटीनेस की जांच करने के लिए एंटिटी",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "एंटिटी खाली है या नहीं है",
  T_34_WZ_WS_LOGIC5_NAME: "If",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "शर्तों को पूरा किया जा रहा है या नहीं के हिसाब एक्सेक्यूट करता है. सब-प्रोसेस बाद की लॉजिक ब्रांच के समान है.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "वैल्यू",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "शर्तों की संख्या और सब-प्रोसेस (लॉजिक ब्रांच) की संख्या समान होनी चाहिए",
  T_34_WZ_WS_LOGIC6_NAME: "लूप ऑफ़  इंटीजर रेंज",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "z के एक स्टेप से x से y तक लूप करें. सब-प्रोसेस लूप ही है.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "लूप इंडेक्स का नाम जिसका इस्तेमाल स्थानीय वेरिएबल के लूप इंडेक्स का मान निकालने के लिए किया जा सकता है",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "स्टार्ट वैल्यू",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "वह वैल्यू जिस पर लूप शुरू होता है",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "एन्ड वैल्यू",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "वह वैल्यू जिस पर लूप समाप्त होता है",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "स्टेप",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "हर लूप का स्टेप. जब स्टार्ट वैल्यू, एन्ड वैल्यू से कम हो, तो स्टेप 0 से ज़्यादा होना चाहिए. जब स्टार्ट वैल्यू, एन्ड वैल्यू से अधिक हो, तो स्टेप 0 से कम होना चाहिए.",
  T_34_WZ_WS_LOGIC7_NAME: "हर एलिमेंट को लूप करें",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "डेटा कंटेनर के प्रत्येक सब-एलिमेंट को निकालने के लिए ट्रैवर्सल को चालू करता है. सब-प्रोसेस लूप ही है.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "एलिमेंट",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "इस नाम पर जाने से लोकल वेरिएबल के सब-एलिमेंट का मान निकल जाएगा",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "डाटा कंटेनर",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "ट्रैवर्स करने के लिए डेटा कंटेनर. वर्तमान में लिस्ट टाइप को सपोर्ट करता है.",
  T_34_WZ_WS_LOGIC8_NAME: "कंडीशनल लूप",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "एक सशर्त लूप तब तक दोहराया जाता है जब तक कि कोई शर्त पूरी नहीं हो जाती. शर्त गलत होने पर लूप बंद हो जाता है.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "कंडीशन",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "अगर कंडीशन सही है तो लूप को दोहराता है और कंडीशन के गलत होने पर रुकता है",
  T_34_WZ_WS_LOGIC9_NAME: "ब्रेक लूप",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "मौजूदा लूप प्रोसेस को रोकता है और लूप से बाहर निकलता है",
  T_34_Y_B_DINOSAURS: "डायनासोर इलूश़न (बॉटम)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "प्योर एंजेल (F)",
  T_34_YS_F_B_PANDACATTLE: "मू ज़ू (बॉटम)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "एक्वा रोग (बॉटम)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "एक्वा रोग (हेड)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "एक्वा रोग (फेसपेंट)",
  T_34_YS_F_S_PANDACATTLE: "मू ज़ू (जूते)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "एक्वा रोग (जूते)",
  T_34_YS_F_T_PANDACATTLE: "मू ज़ू (टॉप)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "एक्वा रोग (टॉप)",
  T_34_YS_M_B_ANGEL_BW: "प्योर एंजेल (M)",
  T_34_YS_M_B_PANDACATTLE: "पांडा पजामा (बॉटम)",
  T_34_YS_M_H_PANDACATTLE: "पांडा पजामा (हेड)",
  T_34_YS_M_S_PANDACATTLE: "पांडा पजामा (जूते)",
  T_34_YS_M_T_PANDACATTLE: "पांडा पजामा (टॉप)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "ऐ-पेट्रोअ",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "दुश्मन को नॉक डाउन करके [FFB300]{0} EP[-] पाएं.",
  T_35_DY_PET_OWL_N: "हूट",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "पैट स्किन: स्पेसशिप मूनी",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "पैट स्किन: अज़ुल्क्रेमा ट्रेस ज़ैसिल",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "पैट स्किन: अगुई ब्लू",
  T_35_DY_PETSKIN_OWL_FIRE_N: "पैट स्किन: हूट ऑन फायर",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "पैट स्किन: नॉक्टर्नल हूट",
  T_35_DY_PETSKIN_OWL_STORM_N: "पैट स्किन: फ्रॉस्टी हूट",
  T_35_JL_KNOCKEDDOWN: "नॉक डाउन हो गया",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "[FFB300]{1}s[-] के लिए, ग्लू वॉल पर सफल फायर करने के बाद, [FFB300]{3}m[-] के भीतर दुश्मनों को मार्क किया जाएगा, और उन दुश्मनों को डैमेज पहुंचाने के लिए ग्लू वॉल को पेनेट्रेट सकता है (डैमेज सामान्य से कम होगा). अधिकतम {0} ग्लू वॉल्स पर प्रभावी. कूलडाउन: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "वॉल ब्रॉल",
  T_35_KY_INFECTION_MAPNAME: "वेस्टलैंड",
  T_35_M_WS_BUTTONCLICKDESC: "इस इवेंट को ट्रिगर करता है जब संबंधित बटन टैप किया जाता है. ट्रिगर प्लेयर को मापदंडों का इस्तेमाल करके पाया जा सकता है.",
  T_35_M_WS_GETTEAMMATEPOS: "आस-पास के टीममेट की लोकेशन पाएं",
  T_35_M_WS_ROUND2: "मौजूदा वेव",
  T_35_PD_Infection_HUMANSELECT: "एक वेपन सेलेक्ट करें",
  T_35_PD_INFECTION_MODENAME: "ड्रॉइड अपॉकलिप्स",
  T_35_QX_WS_ICONTYPE_ITEM: "ऑब्जेक्ट",
  T_35_QX_WS_ICONTYPE_NATURE: "नेचर का शेप",
  T_35_QX_WS_ICONTYPE_SHAPE: "जोमेट्री",
  T_35_QX_WS_ICONTYPE_SYMBOL: "प्रतीक",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "वेपन",
  T_35_R_EMOTE_TAG_MUSIC_N: "म्यूजिक",
  T_35_RW_SKILL_DESC_Singers: "[FFB300]{0}m[-] के भीतर के स्किल यूजर और सहयोगी अपने EP का इस्तेमाल करके  [FFB300]{1}%[-] डैमेज को रोक सकते हैं. इस मामले में, सहयोगी की कम हुई EP की मात्रा को स्किल यूजर की EP में जोड़ा जाएगा.",
  T_35_RW_SKILL_NAME_Singers: "साइलेंट सेंटिनल",
  T_35_SP_WS_COMMENTKEY_01: "उपयुक्त कठिनाई",
  T_35_SP_WS_COMMENTKEY_02: "क्रिएटिव",
  T_35_SP_WS_COMMENTKEY_03: "दिलचस्प गेमप्ले",
  T_35_SP_WS_COMMENTKEY_04: "बार-बार खेला जा सकता है",
  T_35_SP_WS_COMMENTKEY_05: "दिलचस्प कहानी",
  T_35_SP_WS_COMMENTKEY_06: "अच्छे से संतुलित",
  T_35_SP_WS_COMMENTKEY_07: "सुखद अनुभव",
  T_35_SP_WS_COMMENTKEY_08: "सुविधाजनक",
  T_35_SP_WS_COMMENTKEY_09: "सुंदर रूप से सुखद",
  T_35_SP_WS_COMMENTKEY_10: "बहुत मुश्किल",
  T_35_SP_WS_COMMENTKEY_11: "बहुत आसान",
  T_35_SP_WS_COMMENTKEY_12: "बोरिंग",
  T_35_SP_WS_COMMENTKEY_13: "बहुत लंबा",
  T_35_SP_WS_COMMENTKEY_14: "ख़राब बैलेंस",
  T_35_SP_WS_COMMENTKEY_15: "बेकार अनुभव",
  T_35_SP_WS_IMAGE03: "टेक्सचर",
  T_35_SP_WS_IMAGE04: "फ्रेम",
  T_35_SY_CHARGESHOT_TEARS_N: "चार्ज बस्टर- लावा लस्टर",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "ग्रेनेड - क्रिस्टल ईरी",
  T_35_SY_GRENADE_PIRATES_N: "ग्रेनेड - राउडी सीरूलर",
  T_35_SY_GRENADE_RIDERS_N: "ग्रेनेड - ग्रिम राइडर",
  T_35_SY_M24_KUN_N: "M24 - रिवरडस्ट स्प्लैशर",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - गस्टो फ्रीरनर",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "जीप- मोनोक्रोम जिगसॉ",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "जश्न का मज़ा लें!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "मोटरबाइक - क्रिस्टल सिमिट्री",
  T_35_WT_WS_PREFAB_MENUBAR_1: "स्ट्रक्चर & डेकॉर",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "स्ट्रक्चर",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "अन्य",
  T_35_WT_WS_PREFAB_MENUBAR_2: "आर्किटेक्चर",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "बड़े घर",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "मिड-साइज बिल्डिंग",
  T_35_WT_WS_PREFAB_MENUBAR_3: "फंक्शनल ऑब्जेक्ट",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "मोड एसेंशिय;ल्स",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "म्यूजिक",
  T_35_WT_WS_PVEMODE_TAG: "सर्वाइवल मोड",
  T_35_WZY_WS_BECRE_NAMEDESC: "जब यह एंटिटी बनाई जाती है तब ट्रिगर होता है",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'ट्रिगर जब इस एंटिटी को एलिमिनेट कर दिया जाता है. हमले के सोर्स को "ट्रिगर एंटिटी" का इस्तेमाल करके पहचाना जा सकता है; और हमले के टाइप को "डैमेज टाइप" का इस्तेमाल करके पहचाना जा सकता है.',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "इवेंट को ट्रिगर करने वाली एंटिटी",
  T_35_WZY_WS_CREPROP_NAMEDESC: "किसी स्पेसिफिक जगह पर एक टाइप की आइटम या आइटम के सेट बनाएँ. एक टाइप के आइटम बनाते समय, मात्रा उस आइटम की संख्या होती है. आइटम का एक सेट बनाते समय, मात्रा वह अमाउंट लिस्ट होती है जो आइटम लिस्ट से मेल खाती है. बनाए गए आइटम मैप की यूनिट पर निर्भर होंगे.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "एक लिस्ट जिसमें वे आइटम शामिल हैं जिन्हें बनाया जाएग.। इसमें सिंगल आइटम भी शामिल हो सकता है.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "एक अमाउंट लिस्ट जो आइटम लिस्ट से मेल खाती है. इसमें केवल एक आइटम टाइप की अमाउंट हो सकती है",
  T_35_WZY_WS_DAMTYPE_CAR: "गाड़ी",
  T_35_WZY_WS_DAMTYPE_FALL: "फॉल",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "गन",
  T_35_WZY_WS_DAMTYPE_GRENADE: "ग्रेनेड",
  T_35_WZY_WS_DAMTYPE_MELEE: "मेले",
  T_35_WZY_WS_DAMTYPE_ZONE: "ज़ोन से बहार",
  T_35_WZY_WS_DELPROP_NAMEDESC: "स्पेसिफिक प्लेयर्स की बताई संख्या में आइटम हटाएं",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "ट्रिगर एरिया में जाएं",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'जब एक "ट्रिगर एंटिटी" एक ट्रिगर एरिया में प्रवेश करता है, तब ट्रिगर होता है',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "एंटिटी पाने के लिए प्लेयर. प्लेयर के साथ लिंक होने पर, एंटिटी की जानकारी केवल उक्त प्लेयर के लिए अपडेट की जाएगी. जब कोई प्लेयर लिंक नहीं होता है, तो सभी प्लेयर्स को एंटिटी की जानकारी मिलेगी.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "बैटल एंटिटी",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "एक स्पेसिफिक टाइप के सभी ऑब्जेक्ट पाएं. रिजल्ट वापस आता है एक लिस्ट.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "ऑब्जेक्ट टाइप",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI कंट्रोल",
  T_35_WZY_WS_HURT_NAMEDESC: 'जब इस एंटिटी को डैमेज होता है, तब ट्रिगर होता है. हमले के सोर्स को "ट्रिगर एंटिटी" का इस्तेमाल करके पहचाना जा सकता है.',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "आइटम का टाइप",
  T_35_WZY_WS_LEVELOBJECT_NAME: "स्टेज ऑब्जेक्ट",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'जब यह एंटिटी किसी अन्य एंटिटी को हटा देता है, तब ट्रिगर होता है. एलिमिनटेड होने वाली एंटिटी के टाइप को "एलिमिनटेड एंटिटी" का इस्तेमाल करके पहचाना जा सकता है.',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "वह एंटिटी जिसे एलिमिनेट कर दिया गया है",
  T_35_WZY_WS_ONHURT_NAMEDESC: "एंटिटी के डैमेज देने पर ट्रिगर होता है",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "वह एंटिटी जो डैमेज दे रही है",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "टारगेट एंटिटी",
  T_35_WZY_WS_PREFABID_NAME: "टेम्पलेट ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "मौजूदा EP",
  T_35_WZY_WS_PROPERTY_JUMP: "जम्प की ऊंचाई",
  T_35_WZY_WS_QUITTRIGGER_NAME: "ट्रिगर क्षेत्र से बाहर निकलें",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'जब एक "ट्रिगर एंटिटी" एक ट्रिगर एरिया से बाहर निकलता है, तब ट्रिगर होता है',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "एक ऐरे से एक स्पेसिफिक एलिमेंट निकालें. [लिस्ट] वह लिस्ट है जिसमें एलिमेंट रहते है. [एलिमेंट] हटाने वाला एलिमेंट है.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "एलिमेंट वैल्यू",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "हटाए जाने वाले एलिमेंट की वैल्यू",
  T_35_WZY_WS_ROUNDENTITY_NAME: "राउंड एंटिटी",
  T_35_WZY_WS_TOWER_PARAM1: "टावर और फोर्ट्रेस",
  T_35_WZY_WS_TOWER_PARAM2: "टीम ID",
  T_35_WZY_WS_TOWER_PARAM3: "माजूदा HP",
  T_35_WZY_WS_TOWER_PARAM4: "मैक्स. HP",
  T_35_WZY_WS_TOWER_PARAM5: "डैमेज",
  T_35_WZY_WS_TOWER_PARAM6: "अटैक इंटरवल",
  T_35_WZY_WS_TOWER_PARAM7: "अटैक की रेंज",
  T_35_WZY_WS_TOWER_PARAM8: "डिफेंस %",
  T_35_XYL_PDM_REVENGE: "एवेंज्ड",
  T_35_XYL_WS_BISPARTERRE: "ग्रैफ़िटी फ्लावरबेड",
  T_35_XYL_WS_BISPARTERRE_DESC: "एक बैटल-इन-स्टाइल-थीम वाले स्टोन फ्लावरबेड",
  T_35_XYL_WS_BISWALL: "ग्रैफ़िटी वॉल",
  T_35_XYL_WS_BISWALL_DESC: "एक बैटल-इन-स्टाइल-थीम वाली वॉल जिसे जोड़ा जा सकता है",
  T_35_XYL_WS_BOTDROP: "लूट ड्रॉप चालू/बंद करें",
  T_35_XYL_WS_CUSTOMTRIGGER: "कस्टम ट्रिगर",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "एक ऐसी वस्तु रखें जो एक प्लेयर द्वारा सक्रिय किए जाने पर एक निश्चित कस्टमाइज स्पेशल इफ़ेक्ट को ट्रिगर करें. इफ़ेक्ट स्क्रिप्ट में कॉन्फ़िगर किया जाना चाहिए. (सिर्फ़ कस्टमाइज मोड में)",
  T_35_XYL_WS_DOUBLEDOOR: "गेट",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "एक गेट जो टूट कर खुला है",
  T_35_XYL_WS_RESET: "हर राउंड को रीसेट करें",
  T_35_XYL_WS_RESETN: "नहीं",
  T_35_XYL_WS_RESETY: "हाँ",
  T_35_XYL_WS_ROADBLOCK: "रोडब्लॉक A",
  T_35_XYL_WS_ROADBLOCK_DESC: "गुजरने से रोकता है",
  T_35_XYL_WS_STAIRS: "सीढियाँ",
  T_35_XYL_WS_STAIRS_DESC: "सीढ़ियाँ जिन्हें लैंडिंग के साथ जोड़ा जा सकता है",
  T_35_XYL_WS_STAIRSL: "लैंडिंग B",
  T_35_XYL_WS_STAIRSL_DESC: "एक प्लेटफार्म जिसे सीढ़ियों से जोड़ा जा सकता है",
  T_35_XYL_WS_STAIRSZ: "लैंडिंग A",
  T_35_XYL_WS_STAIRSZ_DESC: "एक प्लेटफार्म जिसे सीढ़ियों से जोड़ा जा सकता है",
  T_35_XYL_WS_TBOOTH: "फोन बूथ",
  T_35_XYL_WS_TBOOTH_DESC: "अक्सर सड़कों पर देखा जाता है",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "अगुई",
  T_35_YS_A_CUBBY: "कब मास्क",
  T_35_YS_F_A_PANTOMIME: "टू-टोंड ग्रीफ (मास्क)",
  T_35_YS_F_A_RIDERS: "फेटल राइडर (मास्क)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "ब्यूटी रीयूनाइटर (बॉटम)",
  T_35_YS_F_B_GOLDCHAIN: "आर्मर ऑफ़ रिचिस (बॉटम)",
  T_35_YS_F_B_PANTOMIME: "टू-टोंड ग्रीफ (बॉटम)",
  T_35_YS_F_B_RIDERS: "फेटल राइडर (बॉटम)",
  T_35_YS_F_H_BEAR_HW: "कब कैप",
  T_35_YS_F_H_DIGITALUNIVERSE2: "ब्यूटी रीयूनाइटर (हेड)",
  T_35_YS_F_H_GOLDCHAIN: "आर्मर ऑफ़ रिचिस (हेड)",
  T_35_YS_F_H_PANTOMIME: "टू-टोंड ग्रीफ (हेड)",
  T_35_YS_F_H_RIDERS: "फेटल राइडर (हेड)",
  T_35_YS_F_HA_GOLDCHAIN: "आर्मर ऑफ़ रिचिस (फेसपेंट)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "ब्यूटी रीयूनाइटर (जूते)",
  T_35_YS_F_S_GOLDCHAIN: "आर्मर ऑफ़ रिचिस (जूते)",
  T_35_YS_F_S_PANTOMIME: "टू-टोंड ग्रीफ (जूते)",
  T_35_YS_F_S_RIDERS: "फेटल राइडर (जूते)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "ब्यूटी रीयूनाइटर (टॉप)",
  T_35_YS_F_T_GOLDCHAIN: "आर्मर ऑफ़ रिचिस (टॉप)",
  T_35_YS_F_T_PANTOMIME: "टू-टोंड ग्रीफ (टॉप)",
  T_35_YS_F_T_RIDERS: "फेटल राइडर (टॉप)",
  T_35_YS_ITEM_SUPERFAK: "सुपर मेड",
  T_35_YS_M_A_GOLDCHAIN: "चैंज ऑफ़ लक्स (मास्क)",
  T_35_YS_M_A_RIDERS: "ग्रिम राइडर (मास्क)",
  T_35_YS_M_B_GOLDCHAIN: "चैंज ऑफ़ लक्स (बॉटम)",
  T_35_YS_M_B_RIDERS: "ग्रिम राइडर (बॉटम)",
  T_35_YS_M_H_BEAR_HW: "कब कैप",
  T_35_YS_M_H_GOLDCHAIN: "चैंज ऑफ़ लक्स (हेड)",
  T_35_YS_M_H_RIDERS: "ग्रिम राइडर (हेड)",
  T_35_YS_M_S_GOLDCHAIN: "चैंज ऑफ़ लक्स (जूते)",
  T_35_YS_M_S_RIDERS: "ग्रिम राइडर (जूते)",
  T_35_YS_M_T_GOLDCHAIN: "चैंज ऑफ़ लक्स (टॉप)",
  T_35_YS_M_T_RIDERS: "ग्रिम राइडर (टॉप)",
  T_35_YS_T_CHAMPION: "चैंपियन टी",
  T_35_YS_T_PAINTING: "स्क्वीज़ टी",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "आईरिस",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "मैच के शुरू होने पर कॉइन पाएं",
  T_36_JH_WS_CESAYCLOSE: "मैन्युअल बंद करना रोकें या नहीं",
  T_36_JH_WS_CHOOSEEDITSHOP: "एडिट करने के लिए एक स्टोर चुनें",
  T_36_JH_WS_CHOOSESHOP: "कोई स्टोर चुनें",
  T_36_JH_WS_COINCOUNT: "करेंसी की मात्रा",
  T_36_JH_WS_COINHUD: "कॉइन मात्रा दिखाएं या नहीं",
  T_36_JH_WS_CRAFTSHOP: "एडिट स्टोर",
  T_36_JH_WS_CREATEGOLD: "कॉइन जनरेटर",
  T_36_JH_WS_CSHOPENTITY: "स्टोर एंटिटी बाइंड करें",
  T_36_JH_WS_CSHOPHUD: "स्टोर इंटरफेस",
  T_36_JH_WS_CURRENTLIMIT: "बची ख़रीद लिमिट",
  T_36_JH_WS_ECONOMIC: "इकॉनमी",
  T_36_JH_WS_INGAMEECONOMI: "गेम इकॉनमी",
  T_36_JH_WS_ITEMINDEXID: "मर्चेंडाइज नंबर",
  T_36_JH_WS_KILLMONEY: "एलिमिनेशन करके कॉइन पाएं",
  T_36_JH_WS_KILLMONEYTIP: "रश मोड और एंड्योरेंस मोड में ज़ॉम्बी को खत्म करने के लिए पाए जाने वाले कॉइन की मात्रा",
  T_36_JH_WS_LISTINDEX: "मर्चेंडाइज के टाइप की लिस्ट",
  T_36_JH_WS_NULL: "खाली",
  T_36_JH_WS_NUMBER: "मात्रा",
  T_36_JH_WS_OPTIONNAME: "ड्रॉइड अपॉकलिप्स मोड खास",
  T_36_JH_WS_REALSHOPENTITY: "स्टोर एंटिटी",
  T_36_JH_WS_SEEORHIDE: "वेंडिंग मशीन दिखाएं",
  T_36_JH_WS_SHOPFRONT: "स्टोर",
  T_36_JH_WS_SHOPITEMLIST: "मर्चेंडाइज टाइप",
  T_36_JH_WS_SHOPOPENCON: "ओपन स्टेट्स",
  T_36_JH_WS_SSHOPNAME: "स्टोर का नाम",
  T_36_JH_WS_TOTALLIMIT: "ख़रीद लिमिट",
  T_36_JH_WS_TRIGGERWIDE: "ट्रिगर रेंज",
  T_36_JH_WS_VENDMACHINE: "वेंडिंग मशीन",
  T_36_JH_WS_WINMONEY: "विक्ट्री के लिए कॉइन पाएं",
  T_36_JH_WS_WORTH: "वर्थ",
  T_36_JL_FOREGRIP_MR_N: "मार्क्समैन ग्रिप",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "शॉटगन स्टॉक",
  T_36_JL_STOCK_SR_N: "स्नाइपर स्टॉक",
  T_36_KK_WS_MONTSTERDES: "हाई ड्यूरेबिलिटी वाला 4-सीटर ट्रक और मुश्किल इलाकों में सफर कर सकता है",
  T_36_M_WS_SETTEMPVAR: "अस्थायी वेरिएबल सेट करें",
  T_36_M_WS_TEMPVAR: "टेम्पररी वेरिएबल",
  T_36_SY_AK47_MAMBAS_N: "AK47 - माम्बा नॉ",
  T_36_SY_AN94_MAMBAS_N: "AN94 - मम्बा नॉ",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - मम्बा नॉ",
  T_36_SY_AUG_MAMBAS_N: "AUG- मम्बा नॉ",
  T_36_SY_AWM_MAMBAS_N: "AWM- मम्बा नॉ",
  T_36_SY_BLT_MAMBAS_N: "M82B- मम्बा नॉ",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster - मम्बा नॉ",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle- मम्बा नॉ",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS-- मम्बा नॉ",
  T_36_SY_G18_MAMBAS_N: "G18- मम्बा नॉ",
  T_36_SY_G36_MAMBAS_N: "Groza- मम्बा नॉ",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "ग्रेनेड - नेवी फेस्टिवल",
  T_36_SY_GROZA_MAMBAS_N: "Groza- मम्बा नॉ",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon - मम्बा नॉ",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "हील स्नाइपर- मम्बा नॉ",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun - मम्बा नॉ",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - मम्बा नॉ",
  T_36_SY_KORD_MAMBAS_N: "कॉर्ड- मम्बा नॉ",
  T_36_SY_M1014_MAMBAS_N: "M1014 - मम्बा नॉ",
  T_36_SY_M14_MAMBAS_N: "M14 - मम्बा नॉ",
  T_36_SY_M1873_MAMBAS_N: "M1873- मम्बा नॉ",
  T_36_SY_M1887_MAMBAS_N: "M1887 - मम्बा नॉ",
  T_36_SY_M1917_MAMBAS_N: "M1917 - मम्बा नॉ",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker- मम्बा नॉ",
  T_36_SY_M24_MAMBAS_N: "M24 - मम्बा नॉ",
  T_36_SY_M249_MAMBAS_N: "M249 - मम्बा नॉ",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - मम्बा नॉ",
  T_36_SY_M500_MAMBAS_N: "M500- माम्बा नॉ",
  T_36_SY_M60_MAMBAS_N: "M60- माम्बा नॉ",
  T_36_SY_M79_MAMBAS_N: "M79 - मम्बा नॉ",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - माम्बा नॉ",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - माम्बा नॉ",
  T_36_SY_MINI_MAMBAS_N: "AC80 - माम्बा नॉ",
  T_36_SY_MP40_MAMBAS_N: "MP40 - माम्बा नॉ",
  T_36_SY_MP5_MAMBAS_N: "MP5- माम्बा नॉ",
  T_36_SY_P90_MAMBAS_N: "P90- माम्बा नॉ",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - माम्बा नॉ",
  T_36_SY_PP19_MAMBAS_N: "Bizon - माम्बा नॉ",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - रैथ पैट्रॉल",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - माम्बा नॉ",
  T_36_SY_SKS_MAMBAS_N: "SKS- माम्बा नॉ",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- माम्बा नॉ",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA- माम्बा नॉ",
  T_36_SY_SVD_MAMBAS_N: "SVD- माम्बा नॉ",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson- माम्बा नॉ",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "माम्बा डैगर",
  T_36_SY_THROWINGKNIFE_MENA_N: "बोहो डैगर",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "हील पिस्टल - माम्बा नॉ",
  T_36_SY_UMP45_MAMBAS_N: "UMP- माम्बा नॉ",
  T_36_SY_USP45_MAMBAS_N: "USP - माम्बा नॉ",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi- माम्बा नॉ",
  T_36_SY_VECTOR_MAMBAS_N: "Vector- माम्बा नॉ",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "मॉन्स्टर ट्रक- बाइंडिंग गोल्ड",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "मोटरबाइक - स्पेक्ट्रल राइड",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "स्पोर्ट्स कार - स्पीड एसर",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "टुक टुक - निदरवर्ल्ड राइड",
  T_36_SY_VSS_MAMBAS_N: "VSS- माम्बा नॉ",
  T_36_SY_XM8_MAMBAS_N: "XM8- माम्बा नॉ",
  T_36_WZY_AFTERACCUMULATOR: "बैक एक्युमुलेटर",
  T_36_WZY_AVAILAB: "चालू किया",
  T_36_WZY_BACKANDFORTH: "राउंड- ट्रिप",
  T_36_WZY_BASEMULTIPLIER: "बेसिक मल्टीप्लयार",
  T_36_WZY_BASIC: "बेसिक टाइप",
  T_36_WZY_BEFORACCUMULATOR: "फ्रंट एक्युमुलेटर",
  T_36_WZY_CYLIC: "सर्कल-बैक",
  T_36_WZY_GUNPRO_PARAM1: "बेसिक डैमेज",
  T_36_WZY_GUNPRO_PARAM10: "बुलेट स्प्रेड स्टार्ट",
  T_36_WZY_GUNPRO_PARAM11: "मैक्स. स्प्रेड एरिया",
  T_36_WZY_GUNPRO_PARAM12: "बर्स्ट",
  T_36_WZY_GUNPRO_PARAM2: "मैगज़ीन में बुलेट्स",
  T_36_WZY_GUNPRO_PARAM3: "शुरुआती मैगज़ीन संख्या",
  T_36_WZY_GUNPRO_PARAM4: "फायरिंग इंटरवल",
  T_36_WZY_GUNPRO_PARAM7: "मैक्स डैमेज की दूरी",
  T_36_WZY_GUNPRO_PARAM8: "न्यून. डैमेज की दूरी",
  T_36_WZY_GUNPRO_PARAM9: "न्यूनतम डैमेज",
  T_36_WZY_MULTIPLIR: "मल्टीप्लायर",
  T_36_WZY_PRICE: "प्राइस",
  T_36_WZY_SUMMULTIPLIER: "मल्टीप्लायर एक्युमुलेटर",
  T_36_WZY_WS_3DZOOM: "3D ज़ूम",
  T_36_WZY_WS_ABSRES: "अब्सोल्यूट वैल्यू रिजल्ट",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "[सोर्स लिस्ट ] से सभी एलिमेंट को [टारगेट लिस्ट ] के निचले भाग में जोड़ें",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "एलिमेंट को जोड़ने के लिए टारगेट लिस्ट",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "वह लिस्ट जिसमें जोड़े जाने वाले एलिमेंट शामिल हैं",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "बताए वॉलेट में बताई करेंसी की एक निश्चित मात्रा जोड़ें",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "वॉलेट",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "करेंसी जोड़ने के लिए वॉलेट",
  T_36_WZY_WS_ADDSUB: "मान जोड़ें या घटाएं",
  T_36_WZY_WS_AIENTITY: "AI एंटिटी",
  T_36_WZY_WS_ALLSHOP_DESC: "एक लिस्ट जिसमें स्टोर एंटिटी शामिल हैं",
  T_36_WZY_WS_ANGLE_DESC: "एंगल की माप",
  T_36_WZY_WS_ANYTYPE: "कोई भी टाइप",
  T_36_WZY_WS_ARILEFT: "ऑपरेशन में बायां मान",
  T_36_WZY_WS_ARIRES: "ऑपरेशन रिजल्ट",
  T_36_WZY_WS_ARIRIGHT: "ऑपरेशन में दायां मान",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 अरिथमेटिक ऑपरेशन",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "बेसिक पूर्णांक संचालन जोड़, घटाना, गुणा, भाग और शेष को सपोर्ट करता है. फ्लोट ऑपरेशन जोड़, घटाव, गुणा और भाग का सपोर्ट करता है.",
  T_36_WZY_WS_ARRAY_DESC: "टारगेट लिस्ट",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "जांचें कि लिस्ट में एक बताया एलिमेंट है या नहीं. वापस मिला मान बूलियन है.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "बताई लिस्ट",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "लिस्ट में देखने के लिए एलिमेंट",
  T_36_WZY_WS_ARRCONELERES: "किसी लिस्ट में एलिमेंट मौजूद है या नहीं इसका रिजल्ट. मान बूलियन है.",
  T_36_WZY_WS_ATTACK: "पैट्रॉल और अटैक",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "जब प्लेयर को नॉकडाउन किया जाता है तो ट्रिगर होता है",
  T_36_WZY_WS_BIGFLOAT: "बिग डेसीमल",
  T_36_WZY_WS_BIGTOYBALL: "डाइस",
  T_36_WZY_WS_BOOLLIST: "बूलियन लिस्ट",
  T_36_WZY_WS_CEIL_NAME_DESC: "किसी मान को अपने से बड़े सबसे छोटे इन्टिजर में राउंड करें",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "राउंड अप के लिए वैल्यू",
  T_36_WZY_WS_CEILRES: "राउंड अप का नतीजा",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "चयनित AI दूरी की परवाह किए बिना इस एंटिटी का पीछा करेग.। [चेस्ड एंटिटी ] कोई भी एंटिटी हो सकती है. जब [चेस्ड एंटिटी] के पास HP प्रॉपर्टी नहीं होगी, तो AI एंटिटी कोई डैमेज नहीं पहुंचाएगी.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "वह एंटिटी जो पीछा कर रही है",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "टारगेट जिसका पीछा किया जा रहा है. यह कोई भी एंटिटी हो सकती है.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "ऑब्जेक्ट की क्लोनिंग के लिए टेम्पले. कर्सर का इस्तेमाल करके चुनें. क्लोन की प्रॉपर्टी और स्क्रिप्ट वही होंगी जो चुनी गए ऑब्जेक्ट की है.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "क्लोन होने वाली ऑब्जेक्ट एंटिटी",
  T_36_WZY_WS_CONDITION: "कंडीशन",
  T_36_WZY_WS_CONDITIONLIST: "कंडीशन लिस्ट",
  T_36_WZY_WS_CONOFHUD: "HUD एंटिटी जो कंट्रोल में मौजूद है",
  T_36_WZY_WS_CONTROL_DESC: "कंट्रोल की एकमात्र इंडेक्स",
  T_36_WZY_WS_COS_NAMEDESC: "किसी एंगल का cosine पाएं",
  T_36_WZY_WS_COSRES: "एंगल का Cosine",
  T_36_WZY_WS_CREABLEOB: "बनाये जा सकने वाले ऑब्जेक्ट",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "एक बताए स्थान पर एक ऑब्जेक्ट एंटिटी. (टेस्ट वर्शन)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "बनाए जाने वाले ऑब्जेक्ट के कोऑर्डिनेट",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "बनाई जाने वाली ऑब्जेक्ट का टाइप",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "बनाई जाने वाले ऑब्जेक्ट की एंटिटी",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "करेंसी",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "मर्चेंडाइज एंटिटी",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "मर्चेंडाइज एंटिटी बनाएं",
  T_36_WZY_WS_CREWALL_NAMEDESC: "एक वॉलेट एंटिटी बनाएं. [बाइंड प्लेयर] वह प्लेयर है जो इस वॉलेट को देख सकता है. [मालिक] वह प्लेयर है जिसका वॉलेट है. अमान्य अगर वॉलेट पहले से मौजूद है.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "बाइंड किया प्लेयर बाइंड",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "वह प्लेयर जिसे वॉलेट दिखाई दे रहा है. अगर कोई सेटिंग कॉन्फ़िगर नहीं की गई है, तो वॉलेट सभी को दिखाई देगा.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "वॉलेट का मालिक",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "वॉलेट एंटिटी",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "वाले एंटिटी बनाई",
  T_36_WZY_WS_CURRAMT: "करेंसी मात्रा",
  T_36_WZY_WS_DATA_TYPE1: "जोड़ा पैरामीटर",
  T_36_WZY_WS_DATA_TYPE2: "बेसिक और लॉजिक कैलकुलेशन",
  T_36_WZY_WS_DATA_TYPE3: "लिस्ट में हेरफेर",
  T_36_WZY_WS_DATA_TYPE4: "वेक्टर कैलकुलेशन",
  T_36_WZY_WS_DESTITEM_NAME: "प्लेयर आइटम को नष्ट करें",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "बताए प्लेयर के लिए बताए टाइप के आइटम को नष्ट करें",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "जिन आइटम को ख़त्म  किया जा सकता है वे हैं वेपन, वेस्ट, और हेलमेट",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "चुनें आइटम के टाइप का स्लॉट इंडेक्स. वेपन इंडेक्स [1,3] है और वेस्ट और हेलमेट डिफ़ॉल्ट रूप से 1 है.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "एलिमिनेशन पर इक्विपमेंट खो देंगे",
  T_36_WZY_WS_DESTOBJ: "नष्ट होने वाले ऑब्जेक्ट",
  T_36_WZY_WS_DIRPOINT: "डायरेक्शन पॉइंट",
  T_36_WZY_WS_DIRPOINTDESC: "डायरेक्शन पॉइंट बनाया जाना है",
  T_36_WZY_WS_ELEFINDRES: "किसी एलिमेंट जो पहली पोजीशन की इंडेक्स",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'किसी लिस्ट में किसी एलिमेंट की पहली स्थिति का इंडेक्स पाएं. अगर टारगेट एलिमेंट लिस्ट  में मौजूद नहीं है, तो रिजल्ट "-1"',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "लिस्ट में देखने के लिए एलिमेंट",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'किसी लिस्ट में किसी एलिमेंट की आखिरी स्थिति का इंडेक्स पाएं. अगर टारगेट एलिमेंट लिस्ट में मौजूद नहीं है, तो रिजल्ट "-1"',
  T_36_WZY_WS_ELELINDRES: "किसी एलिमेंट की आखिरी स्थिति का इंडेक्स",
  T_36_WZY_WS_ELEMENTSNUM: "लिस्ट में # एलिमेंट",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "ट्रिगर होता है  जब [ट्रिगरिंग एंटिटी] इस ट्रिगर से टकराती है",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "वह एंटिटी जिससे यह ट्रिगर टकराता है",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "ट्रिगर होता है जब कोई [ट्रिगरिंग एंटिटी] गाड़ी चलती है",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "वह एंटिटी जो गाड़ी चला रही है",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "ट्रिगर जब प्लेयर ट्रिगर में एंटर करता है",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "एंटर करने के लिए ट्रिगर करें",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "ट्रिगर होता है जब एक [ट्रिगरिंग एंटिटी] गाडी से बाहर निकलती है",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "गाड़ी से बाहर निकलने वाली एंटिटी",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "ट्रिगर होता है जब एक [ट्रिगरिंग एंटिटी] गाड़ी में एंटर करती है",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "गाड़ी में एंटर करने वाली एंटिटी",
  T_36_WZY_WS_ENTITY_TYPE1: "आमतौर पर इस्तेमाल हुआ",
  T_36_WZY_WS_ENTITY_TYPE2: "प्रॉपर्टी",
  T_36_WZY_WS_ENTITY_TYPE3: "ऑब्जेक्ट और आइटम",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "बदलने के लिए एलिमेंट मान",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "टारगेट प्लेयर",
  T_36_WZY_WS_ENTITYLIST: "एंटिटी लिस्ट",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "ट्रिगर होता है  जब एक [ट्रिगरिंग एंटिटी] टायर से उछलती है",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "वह एंटिटी जो टायर से उछलती है",
  T_36_WZY_WS_ENTTP_NAMEDESC: "जब एक [ट्रिगरिंग एंटिटी] पोर्टल में एंटर करती है और टेलीपोर्ट की जाती है तब ट्रिगर होता है",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "एंटिटी जिसे टेलिपोर्ट कर दिया गया है",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "आर्मर, हेलमेट और बैकपैक सहित लैस आर्मर का टाइप",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "ट्रिगर होता है तब होता है जब कोई प्लेयर किसी वेपन से सफल रूप से लैस होता है. [ट्रिगर प्लेयर] वह प्लेयर है जो किसी वेपन को सफलतापूर्वक लैस करता है. [वेपन एंटिटी ] वह वेपन है जिसे प्लेयर लैस करता है.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "वेपन एंटिटी लैस  हुई",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "वेपन टाइप",
  T_36_WZY_WS_EULERANGLE: "यूलर एंगल",
  T_36_WZY_WS_FACECAMERA: "हमेशा कैमरा फेस करो",
  T_36_WZY_WS_FLOATLIST: "फ्लोट लिस्ट",
  T_36_WZY_WS_FLOOR_NAME_DESC: "किसी मान को अपने से छोटे सबसे बड़े इन्टिजर में राउंड करें",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "राउंड डाउन के लिए मान",
  T_36_WZY_WS_FLOORRES: "राउंड डाउन का रिजल्ट",
  T_36_WZY_WS_FORMUENT: "प्रॉपर्टी तैयार करने योग्य एंटिटी",
  T_36_WZY_WS_FORMUFACT: "प्रॉपर्टी फॉर्मूला फैक्टर का टाइप",
  T_36_WZY_WS_GAME_TYPE2: "गेमप्ले",
  T_36_WZY_WS_GAME_TYPE3: "स्पेशल इफ़ेक्ट",
  T_36_WZY_WS_GENENT_NAMEDESC: "ट्रिगर होता है जब एक जनरेटर एंटिटी को जन्म देता है. [यूनिट एंटिटी लिस्ट] जनरेटर द्वारा बनी यूनिट की लिस्ट है. [# की वेव] जनरेशन द्वारा बनी वेव की संख्या है.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "यूनिट एंटिटी",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "एक लिस्ट जिसमें एक जनरेटर द्वारा जेनेरेट यूनिट एंटिटी होती हैं",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "एक जनरेटर द्वारा उत्पन्न वेव की संख्या",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "मैच के सभी स्टोर पाएं. लौटाया गया मान एक लिस्ट है जिसमें स्टोर एंटिटी होते हैं.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "रंग प्राप्त करने के लिए RGB का इस्तेमाल करें",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "एक स्पेसिफिक वॉलेट में एक निश्चित करेंसी की राशि पाएं",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "वह वॉलेट जिससे करेंसी मात्रा पानी है",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "हासिल की जाने वाले करेंसी टाइप का करेंसी प्रकार",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "टारगेट एंटिटी की एंटिटी टाइप पाएं",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "वह एंटिटी जिसका टाइप पाना है",
  T_36_WZY_WS_GETENTTYPERES: "टारगेट एंटिटी का एंटिटी टाइप",
  T_36_WZY_WS_GETFOR_NAME: "डायरेक्शन कोऑर्डिनेट पाएं",
  T_36_WZY_WS_GETFOR_NAMEDESC: "बताये डायरेक्शन पॉइंट का वेक्टर हासिल करें",
  T_36_WZY_WS_GETFORRES: "डायरेक्शन पॉइंट के वेक्टर",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "वॉलेट में एक निश्चित करेंसी टाइप की करेंसी एंटिटी पाएं",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "वह वॉलेट जिसमें करेंसी एंटिटी है",
  T_36_WZY_WS_GETPOS_NAME: "कोऑर्डिनेट पाएं",
  T_36_WZY_WS_GETPOS_NAMEDESC: "बताये डायरेक्शन पॉइंट के कोऑर्डिनेट पाएं",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "एक तय डायरेक्शन पॉइंट",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "इक्विपमेंट टाइप",
  T_36_WZY_WS_GETWALLET_NAME: "वॉलेट हासिल करें",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "चुने मालिक का वॉलेट पाएं",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "बाइंड वॉलेट मौजूद है या नहीं",
  T_36_WZY_WS_GETWALLETRES: "मालिक की वॉलेट एंटिटी",
  T_36_WZY_WS_HUDCONTROL_DESC: "एक HUD मि एंटिटी को कंट्रोल करें",
  T_36_WZY_WS_HUDTYPE: "HUD टाइप",
  T_36_WZY_WS_INCIDENT_TYPE1: "ग्लोबल इंसिडेंट",
  T_36_WZY_WS_INCIDENT_TYPE2: "एंटिटी इंसिडेंट",
  T_36_WZY_WS_INDEX_DESC: "एक लिस्ट का एक इंडेक्स मान. 0 से शुरू होता है.",
  T_36_WZY_WS_INTLIST: "इन्टिजर लिस्ट",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "देखें  कि कोई एंटिटी टाइप किसी निश्चित सब-केटेगरी  से संबंधित है या नहीं. वापस मान बूलियन है.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "यह जांचने के लिए पैरेंट केटेगरी है कि एंटिटी इससे संबंधित है या नहीं",
  T_36_WZY_WS_JENTSUBCLRES: "पैरेंट केटेगरी चेक का रिजल्ट",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "जाँच करें कि कोई एंटिटी किसी निश्चित एंटिटी टाइप से संबंधित है या नहीं. मिलने वाला रिजल्ट बूलियन है.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "चेक करने के लिए एंटिटी",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "इसका मतलब है कि यह एंटिटी टाइप के समान है",
  T_36_WZY_WS_JENTTYPERES: "एंटिटी जांच का नतीजा",
  T_36_WZY_WS_JUSTPATROL: "सिर्फ़ पैट्रॉल",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "ट्रिगर होता है जब प्लेयर ट्रिगर से बाहर निकलता है",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "बाहर निकलने के लिए ट्रिगर",
  T_36_WZY_WS_LEVELOBLIST: "ऑब्जेक्ट लिस्ट",
  T_36_WZY_WS_LEVOBJSLIST: "इस मैच में सभी मैप ऑब्जेक्ट की लिस्ट",
  T_36_WZY_WS_LEVOBTYPE: "ऑब्जेक्ट टाइप",
  T_36_WZY_WS_LISTT: "कोई भी लिस्ट",
  T_36_WZY_WS_LOGCONTEXT_DESC: "प्रिंट होने वाला कॉन्टेंट",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "जोड़ा जाने वाली बांई स्ट्रिंग",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "कनेक्ट होने के लिए सही स्ट्रिंग",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "जोड़ा जाने वाला एलिमेंट मान",
  T_36_WZY_WS_LOGOPER: "लॉजिक ऑपरेशन करते समय (AND & OR: यदि AND ऑपरेशन का इस्तेमाल करें और दो बूलियन मान सही हैं, तो रिजल्ट सही होता है, और अगर OR ऑपरेशन का इस्तेमाल करें और दो बूलियन मान दोनों गलत नहीं हैं, तो परिणाम सही होता है.",
  T_36_WZY_WS_LOOTPOINT: "लूट पॉइंट",
  T_36_WZY_WS_MAINWEAP: "मौजूदा वेपन",
  T_36_WZY_WS_MAX_DESC: "जेनेरेट हुए इन्टिजर की अपर रेंज (ओपन इंटरवेल)",
  T_36_WZY_WS_MIN_DESC: "बने इन्टिजर की निचली रेंज (क्लोज इंटरवेल)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "वेपन एंटिटी",
  T_36_WZY_WS_MONENT: "करेंसी एंटिटी",
  T_36_WZY_WS_MONTYPE: "करेंसी टाइप",
  T_36_WZY_WS_MOVETO_NAMEDESC: "AI को टारगेट पॉइंट की ओर ले जाएं. AI अपनी ऑरिजिनल पोजीशन में लौटेगा या नहीं यह चुनने के लिए [वापस या नहीं] का इस्तेमाल करें. यह चुनने के लिए [अटैक करें या नहीं] का इस्तेमाल करें कि क्या AI रास्ते में दुश्मनों के लिए स्कैन करेगा.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "AI एंटिटी जो सफर करेगी",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "डेस्टिनेशन",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "यह निर्धारित करने के लिए इस्तेमाल करें कि डेस्टिनेशन पर पहुंचने के बाद AI मूल स्थान पर वापस आ जाएगा या नहीं. सही का मतलब है वापसी; गलत का मतलब है वापस न आना.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "अटैक या नहीं",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "यह निर्धारित करने के लिए इस्तेमाल करें कि क्या AI रास्ते में आस-पास के दुश्मनों पर हमला करेगा. सही का मतलब है दुश्मनों को स्कैन करना; गलत का मतलब है दुश्मनों को  स्कैन न करना.",
  T_36_WZY_WS_MULVALUE: "स्केलर",
  T_36_WZY_WS_MULVEC: "स्केलर मल्टीप्लिकेशन  वेक्टर",
  T_36_WZY_WS_NEGRES: "नेगेटिव वैल्यू रिजल्ट",
  T_36_WZY_WS_NEUTRAL: "न्यूट्रल",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "बताए जनरेटर को अगली वेव स्पॉन करने के लिए बाध्य करता है. जेनरेटर में ज़ॉम्बी स्पॉन और आइटम स्पॉन शामिल हैं.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "जनरेटर एंटिटी",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "बताये जनरेटर एंटिटी, जैसे ज़ॉम्बी स्पॉन्स और आइटम स्पॉन",
  T_36_WZY_WS_OBJENT: "ऑब्जेक्ट एंटिटी",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "कोई आइटम मिलने पर ट्रिगर करता है. [आइटम टाइप] मिले  आइटम का टाइप है.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "वेपन पाने पर ट्रिगर होता है. [वेपन एंटिटी] मिला वेपन है.",
  T_36_WZY_WS_ONEWAY: "वन-वे",
  T_36_WZY_WS_OPENSTATE: "स्टेट्स",
  T_36_WZY_WS_OPERMETHOD_NAME: "ऑपरेशन",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "बेसिक अरिथमेटिक ऑपरेशन. मौजूदा समय में, इन्टिजर ऑपरेशनमें जोड़, घटाव, गुणा, भाग और शेष शामिल हैं, और फ्लोट ऑपरेशन में जोड़, घटाव, गुणा और भाग शामिल हैं.",
  T_36_WZY_WS_OWNERENT_DESC: "वह एंटिटी जिसका वॉलेट पाना है",
  T_36_WZY_WS_PERCENTAGE: "परसेंटेज में सुधार",
  T_36_WZY_WS_PLACOLLIDE_NAME: "जब प्लेयर ट्रिगर से टकराता है",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "ट्रिगर होता है जब [ट्रिगर प्लेयर] ट्रिगर से टकराता है",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "ट्रिगर से टकराने वाला प्लेयर",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "प्लेयर जिस ऑब्जेक्ट एंटिटी से टकराता है",
  T_36_WZY_WS_PLADRIVEH_NAME: "जब प्लेयर गाड़ी ड्राइव करता है",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "ट्रिगर होता है जब [ट्रिगर प्लेयर] गाड़ी चलाता है",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "वह प्लेयर जो गाड़ी चला रहा है",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "व्हीकल एंटिटी जिसे प्लेयर चला रहा है",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "जब प्लेयर गाड़ी से बाहर निकलता है",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "ट्रिगर होता है जब [ट्रिगर प्लेयर] किसी गाड़ी से बाहर निकलता है",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "प्लेयर जो गाड़ी से बाहर निकल रहा है",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "व्हीकल एंटिटी जिससे प्लेयर बाहर निकल रहा है",
  T_36_WZY_WS_PLAGETONVEH_NAME: "जब प्लेयर एंटर करता है",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "ट्रिगर होता है जब [ट्रिगर प्लेयर] किसी गाड़ी में एंटर करता है.",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "प्लेयर जिस व्हीकल एंटिटी में प्रवेश कर रहा है",
  T_36_WZY_WS_PLAKNOFLY_NAME: "जब प्लेयर टायर से कूदता है",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "ट्रिगर होता है  जब [ट्रिगर प्लेयर] एक टायर से उछलता है",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "वह प्लेयर जो टायर से उछलता है",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "वह ऑब्जेक्ट एंटिटी  जिस पर प्लेयर उछलता है",
  T_36_WZY_WS_PLATP_NAME: "प्लेयर के टेलीपोर्ट होने के बाद",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "पोर्टल का उपयोग करने वाला प्लेयर",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "प्लेयर द्वारा इस्तेमाल किया जाने ने वाली पोर्टल एंटिटी",
  T_36_WZY_WS_PLAYERLIST_DESC: "इस मैच के सभी प्लेयर्स की लिस्ट",
  T_36_WZY_WS_POINTPICKER: "पाथ पिवोट",
  T_36_WZY_WS_PORTALENT: "पोर्टल एंटिटी",
  T_36_WZY_WS_PREFAB: "टेम्पलेट",
  T_36_WZY_WS_PRODLIST: "मर्चेंडाइज लिस्ट",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "क्रम ऑर्डर",
  T_36_WZY_WS_PROPMOD: "प्रॉपर्टी बदलाव का तरीका",
  T_36_WZY_WS_RANKABLEE: "रैंक-एब्ल एंटिटी",
  T_36_WZY_WS_REDCURR_NAMEDESC: "बताए वॉलेट में बताई करेंसी की एक निश्चित मात्रा की खपत करें",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "करेंसी खर्च करने वाला वॉलेट",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "खर्च की गई करेंसी का टाइप",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "खपत की गई करेंसी की मात्रा",
  T_36_WZY_WS_RNDFRES: "रैंडम फ्लोट जनेरेट किया",
  T_36_WZY_WS_RNDIRES: "रैंडम इन्टिजर जनरेशन का रिजल्ट",
  T_36_WZY_WS_ROUND_NAME_DESC: "किसी मान को निकटतम इन्टिजर में राउंड करें",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "राउंड करने के लिए मान",
  T_36_WZY_WS_ROUNDRES: "राउंडिंग का रिजल्ट",
  T_36_WZY_WS_RUNAI_NAMEDESC: "बिहेवियर ट्री  जिसे चयनित AI लागू करेगा",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "डिफ़ॉल्ट बिहेवियर ट्री को रोकने/चलाने वाली यूनिट एंटिटी",
  T_36_WZY_WS_SCOREABLEE: "स्कोर-एब्ल एंटिटी",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "ट्रिगर होता है, जब स्कोर बदलता है.[स्कोर टाइप] स्कोर का टाइप है जो बदल गया है. [स्कोर] नया स्कोर है.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "एक डायरेक्शन पॉइंट बनाएं",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "एक नया बना डायरेक्शन पॉइंट पाएं. पॉइंट के कोऑर्डिनेट सेट करने के लिए [जगह] का इस्तेमाल करें और डायरेक्शन के वेक्टर को सेट करने के लिए [डायरेक्शन] का इस्तेमाल करें.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "डायरेक्शन पॉइंट के कोऑर्डिनेट",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "डायरेक्शन",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "डायरेक्शन पॉइंट का वेक्टर",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI एंटिटी यहां निर्धारित ऑर्डर के अनुसार यात्रा करेंगी. उपलब्ध ट्रैवल टाइप सर्कल-बैक, वन-वे और राउंड-ट्रिप हैं. आप यह भी चुन सकते हैं कि क्या AI  रास्ते में आने वाले दुश्मनों के लिए स्कैन करेगा.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "एक लिस्ट जिसमें उन पॉइंट्स को शामिल किया गया है जहां AI को सफर करना चाहिए",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "ट्रेवल टाइप",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "ये ट्रैवल के टाइप हैं. AI के डेस्टिनेशन पर पहुंचने के बाद ट्रैवल करना बंद करने के लिए वन-वे है. सर्कल-बैक AI के लिए डेस्टिनेशन पर पहुंचने के बाद एक रास्ता खोजने के लिए है. पाथ लिस्ट के पीछे के क्रम के अनुसार AI  के लिए राउंड-ट्रिप मूल स्थान पर वापसी है.",
  T_36_WZY_WS_SHOPECON: "स्टोर और इकॉनमी",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "स्क्रीन पर फ्लोटिंग नोटिफिकेशन को दिखाने करने के लिए इस्तेमाल करें. [टेक्स्ट] का इस्तेमाल करके कॉन्टेंट को कॉन्फ़िगर करें, [कलर] का इस्तेमाल करके टेक्स्ट का रंग, और [अवधि] का इस्तेमाल करके डिस्प्ले अवधि (यूनिट मिलीसेकंड है).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "फ़्लोटिंग नोटिफिकेशन का कंटेंट",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "फ्लोटिंग नोटिफिकेशन  का कलर",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "फ़्लोटिंग नोटिफिकेशनको दिखने की अवधि, मिलीसेकंड में",
  T_36_WZY_WS_SIN_NAMEDESC: "किसी एंगल का sine पाएं",
  T_36_WZY_WS_SINRES: "एंगल का Sine",
  T_36_WZY_WS_SKIPKNODOWN: "क्या नॉकडाउन पर एलिमिनेट कर दिया गया है",
  T_36_WZY_WS_SQRTRES: "रिजल्ट का स्क्वायर रूट",
  T_36_WZY_WS_STRCONRES: "स्ट्रिंग कनेक्शन का नतीजा",
  T_36_WZY_WS_STRINGLIST: "स्ट्रिंग लिस्ट",
  T_36_WZY_WS_STRLEN: "स्ट्रिंग लम्बाई",
  T_36_WZY_WS_STRVAL: "स्ट्रिंग रिजल्ट",
  T_36_WZY_WS_TAN_NAMEDESC: "एंगल का टेंजेंट निकालें",
  T_36_WZY_WS_TANRES: "एंगल का टेंजेंट",
  T_36_WZY_WS_TEAMLIST: "टीम लिस्ट",
  T_36_WZY_WS_TEAMLIST_DESC: "इस मैच की सभी टीमों की लिस्ट",
  T_36_WZY_WS_TIMETWEENTIPS: "काउंटडाउन नोटिफिकेशनएंटिटी",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "टारगेट वैल्यू को एक स्ट्रिंग में बदलें",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "एक स्ट्रिंग में बदलने के लिए वैल्यू",
  T_36_WZY_WS_TOSTRINGRES: "स्ट्रिंग कन्वर्शन का नतीजा",
  T_36_WZY_WS_TOWERCAMP_DESC: "साइड नंबर और टीम नंबर समान हैं. न्यूट्रल टावर और किले सीमा के भीतर सभी प्लेयर्स और AIs पर हमला करते हैं.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "बताई करेंसी की एक निश्चित मात्रा को एक वॉलेट से दूसरे में ट्रांसफर करें",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "करेंसी ट्रांसफर करने वाला वॉलेट",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "ट्रांजैक्शन में करेंसी का टाइप",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "ट्रांजैक्शन  में करेंसी की मात्रा",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "करेंसी को ट्रांसफर करने के लिए वॉलेट",
  T_36_WZY_WS_TWEENTIPS: "फ़्लोटिंग नोटिफिकेशनएंटिटी",
  T_36_WZY_WS_TYPEENUM: "एनम टाइप",
  T_36_WZY_WS_USEPROP_NAMEDESC: "ट्रिगर होता है  जब कोई प्लेयर किसी आइटम का इस्तेमाल करता है. [ट्रिगरी प्लेयर] वह प्लेयर है जो किसी आइटम का इस्तेमाल करता है. [आइटम टाइप ] वह आइटम है जिसका इस्तेमाल प्लेयर करता है.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "प्लेयर द्वारा इस्तेमाल किये जाने वाले आइटम का टाइप",
  T_36_WZY_WS_VECADDLEFT: "वेक्टर जोड़ का बायां मान",
  T_36_WZY_WS_VECADDRES: "वेक्टर जोड़ रिजल्ट",
  T_36_WZY_WS_VECADDRIGHT: "वेक्टर जोड़ का दायां मान",
  T_36_WZY_WS_VECANGLEFT: "वेक्टर एंगल का बायां मान",
  T_36_WZY_WS_VECANGRES: "दो वेक्टर के बीच एंगल",
  T_36_WZY_WS_VECANGRIGHT: "वेक्टर एंगल का दायां मान",
  T_36_WZY_WS_VECCROLEFT: "क्रॉस प्रोडक्ट का बायां मान",
  T_36_WZY_WS_VECCRORES: "क्रॉस प्रोडक्ट का रिजल्ट",
  T_36_WZY_WS_VECCRORIGHT: "क्रॉस प्रोडक्ट का दायां मान",
  T_36_WZY_WS_VECDISLEFT: "वेक्टर दूरी का बायां मान",
  T_36_WZY_WS_VECDISRES: "2 वेक्टर के बीच की दूरी",
  T_36_WZY_WS_VECDISRIGHT: "वेक्टर दूरी का दायाँ मान",
  T_36_WZY_WS_VECDOCLEFT: "डॉट प्रोडक्ट का बायां मान",
  T_36_WZY_WS_VECDOCRES: "डॉट प्रोडक्ट का रिजल्ट",
  T_36_WZY_WS_VECDOCRIGHT: "डॉट प्रोडक्ट दायां  मान",
  T_36_WZY_WS_VECMULRES: "स्केलर मल्टिप्लिकेशन का रिजल्ट",
  T_36_WZY_WS_VECNORRES: "नार्मलाइज़्ड वेक्टर",
  T_36_WZY_WS_VECSIZERES: "वेक्टर का मैग्नीट्यूड",
  T_36_WZY_WS_VECSUBLEFT: "वेक्टर घटाने का बायां मान",
  T_36_WZY_WS_VECSUBRES: "वेक्टर घटाने का नतीजा",
  T_36_WZY_WS_VECSUBRIGHT: "वेक्टर घटाने का दायां मान",
  T_36_WZY_WS_VECTORLIST: "वेक्टर लिस्ट",
  T_36_WZY_WS_VECX: "x कॉम्पोनेन्ट",
  T_36_WZY_WS_VECY: "y कॉम्पोनेन्ट",
  T_36_WZY_WS_VECZ: "z कॉम्पोनेन्ट",
  T_36_WZY_WS_VEHENT: "व्हीकल एंटिटी",
  T_36_WZY_WS_WALLCONT: "वॉलेट कॉन्टेंट",
  T_36_WZY_WS_ZOMBIESPERWAVE: "निरंतर",
  T_36_XYL_WS_AIBOT: "यूनिट",
  T_36_XYL_WS_AIGENERATOR: "यूनिट जनरेटर",
  T_36_XYL_WS_AIGENERATOR_DESC: "एक जनरेटर जो लगातार बताई यूनिट बना सकता है (जैसे ज़ॉम्बी)",
  T_36_XYL_WS_AIWAVE: "पर वेव जनेरेट यूनिट का #",
  T_36_XYL_WS_ARROW: "डायरेक्शन साइन",
  T_36_XYL_WS_ARROW_DESC: "एक संकेत जो एक दिशा की ओर इशारा करता है",
  T_36_XYL_WS_BREAKBOX: "ब्रेकएब्ल बॉक्स",
  T_36_XYL_WS_BREAKBOX_DESC: "एक लकड़ी का बॉक्स जिसे हमला करने पर टुकड़ा जा सकता है",
  T_36_XYL_WS_FENCE: "आयरन फेंस",
  T_36_XYL_WS_FENCE_DESC: "एक फेंस जो गोलियों को उड़ने में सक्षम बनाती है",
  T_36_XYL_WS_STAIRI: "लैंडिंग C",
  T_36_XYL_WS_STAIRI_DESC: "एक प्लेटफॉर्म जिसे सीढ़ियों से जोड़ा जा सकता है",
  T_36_XYL_WS_ZOMBIEAI: "ज़ॉम्बी",
  T_36_XYL_WS_ZOMBIEAI_DESC: "एक ज़ॉम्बी जिसे कस्टमाइज किया जा सकता है और यूनिट जेनरेटर में पाया और सब्जेक्ट डुप्लिकेट कर सकता है",
  T_36_YF_CORRODE_GRENADE_N: "ग्लू मेल्टर",
  T_36_YF_SETTING_TYPE3: "प्रीसेट 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF ओसिन जर्सी (बॉटम)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF सनशाइन जर्सी (बॉटम)",
  T_36_YS_F_A_GHOSTHUNTER: "फ़ीनडिश फॉक्सटेल (मास्क)",
  T_36_YS_F_B_GHOSTHUNTER: "फ़ीनडिश फॉक्सटेल (बॉटम)",
  T_36_YS_F_H_GHOSTHUNTER: "फ़ीनडिश फॉक्सटेल (हेड)",
  T_36_YS_F_S_GHOSTHUNTER: "फ़ीनडिश फॉक्सटेल (जूते)",
  T_36_YS_SETTING_GRENADE: "थ्रोएब्ल",
  T_36_YS_SETTING_MOVE: "मूवमेंट",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF ओसिन जर्सी (टॉप)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF सनशाइन जर्सी (टॉप)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "लूना",
  T_36_YZY_CHARACTER_YAKUZA_N: "तात्सुया",
  T_36_YZY_PET_WOLF_N: "फेंग",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "पैट स्किन: पर्पल ज़ैसील",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "पैट स्किन: लाइटिंग फैल्को",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "पैट स्किन: लावा फेंग",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "पैट स्किन: स्पेक्ट्रल गाइड",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "पेट स्किन: आर्कटिक फेंग",
  T_37_B_WS_HIDE: "हाइड एन सीक",
  T_37_HZ_WS_CATMODEDESC1: "हाईड एन सीक",
  T_37_JH_WS_CREATEGOLD_DESC: "एक वेंडिंग मशीन जिससे खिलाड़ी सामान खरीद सकते हैं. (क्लैश स्क्वाड, टीम डेथमैच, प्लेग्राउंड और ड्रॉइड अपॉकलिप्स मोड में मान्य नहीं है)",
  T_37_JH_WS_NAME1: "FF चाकू (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME10: "M1887-X (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME11: "SPAS12 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME12: "M1014 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME13: "MP40 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME14: "MP5-III (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME15: "P90 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME16: "M60-III (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME17: "Thompson (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME18: "UMP (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME19: "SVD (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME2: "GROZA (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME20: "AWM (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME21: "M82B (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME22: "M249-X (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME23: "Kar98k - III (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME3: "AK47 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME4: "M4A1-III (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME5: "SCAR (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME6: "M14-III (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME7: "PARAFAL (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME8: "XM8 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_NAME9: "MAG-7 (ड्रॉइड अपॉकलिप्स)",
  T_37_JH_WS_VENDMACHINE_DESC: "गोल्ड जिसे मैप में कहीं से भी उठाया जा सकता है. (क्लैश स्क्वाड, टीम डेथमैच, प्लेग्राउंड और ड्रॉइड अपॉकलिप्स मोड में मान्य नहीं है)",
  T_37_JH_WS_X: "X एक्सिस",
  T_37_JH_WS_Y: "Y एक्सिस",
  T_37_JH_WS_Z: "Z एक्सिस",
  T_37_JL_FOOTBALL_TIE: "टाई",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "वैगर स्नोमैन",
  T_37_LC_BP_ENTRANCE_GIFT: "गिफ़्ट!",
  T_37_M_WS_MISSING: "मिसिंग सोर्स",
  T_37_M_WS_NAMEERROR: "संवेदनशील कैरेक्टर शामिल हैं. कृपया बदलें.",
  T_37_PD_HuntingGround_BOSSTITLE: "द बुचर",
  T_37_QL_JUMPPAD_DES: "जमीन पर जंप पैड बनाता है. इसका इस्तेमाल हवा में ऊंची छलांग लगाने और हवाई फायरिंग करने में किया जा सकता है.",
  T_37_QL_JUMPPAD_NAME: "ट्रैम्पोलिन",
  T_37_R_TAILOR_LIMIT: "लिमिटेड टाइम",
  T_37_RW_LOADOUT_BORNFIRETAG: "मैच की शुरुआत में 2 बॉनफायर जलाएं. बॉनफायर [FFBA00] एरिया के भीतर आपके और आपके साथियों के लिए 5 HP और 20 EP प्रति सेकंड[-] (10 सेकंड तक) रीजनरेट करता है. बॉनफायर के इफ़ेक्ट जमा नहीं होते हैं.",
  T_37_RW_PROPCATAPULT_DESC: "फुलाए जाने पर, लॉन्च पैड का इस्तेमाल किसी प्लेयर को हवा में प्रोजेक्ट करने के लिए किया जा सकता है. लेकिन सेफ ज़ोन में रहने का याद रखें!",
  T_37_RW_PROPCATAPULT_NAME: "लॉन्च पैड",
  T_37_SP_WS_COLOR_02: "कलर",
  T_37_SP_WS_COLOR_03: "दिखावट",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "अपनीप्रॉपर्टी पाने या सेट करते समय एंटिटी शून्य है",
  T_37_SP_WS_LOG_PHASE_END: "स्टेज {0} ख़त्म.",
  T_37_SP_WS_LOG_PHASE_START: "स्टेज {0} शुरू",
  T_37_SP_WS_LOG_ROUND_END: "राउंड {0} ख़त्म.",
  T_37_SP_WS_LOG_ROUND_START: "राउंड {0} शुरू हुआ",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "मिसमैच टाइप जब वेरिएबल को वैल्यू असाइन करते हैं. ज़रूरी टाइप: {0}. मौजूदा टाइप: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "अपरिभाषित या दायरे से बाहर का लोकल वेरिएबल {0}",
  T_37_SP_WS_MAPACCESS_08: "एडिट",
  T_37_SP_WS_RACEMODE_01: "काउंटडाउन मोड",
  T_37_SP_WS_RACEMODE_02: "काउंटडाउन टाइम",
  T_37_SP_WS_RACEMODE_04: "चालू होने पर, एक काउंटडाउन गिनती होगी जब एक पूरी टीम अंतिम बिंदु पर पहुंच जाएगी. काउंटडाउन ख़त्म होने पर गेम ख़त्म होता है.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - सॉन्ग ऑफ़ हैना",
  T_37_SY_BACKPACK_STRAW_N: "स्ट्रॉ हैट बैकपैक",
  T_37_SY_GRENADE_FFWS2022_01_N: "ग्रेनेड - नेवी स्टारसी",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "ब्लैक होल",
  T_37_SY_M1216_MAMBAS_N: "Trogon- माम्बा नॉ",
  T_37_SY_PET_FLYINGCREATURE_N: "अर्वन",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "पैट स्किन: ग्लैमस्टर बीनी",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "पैट स्किन: ऐश अर्वन",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "पैट स्किन: गैलेक्सी अर्वन",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "पैट स्किन: फायरमिथ अर्वन",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "पैट स्किन: फूटी फ़्लैश",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "पेट स्किन: विंटरलैंड्स येती",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "जीप- रॉकिन फेस्टिवल राइड",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "पिकअप ट्रक - स्टारसी बीस्ट",
  T_37_WT_WS_PVE2DESC: `एक ज़ोंबी सर्वाइवल मोड जहाँ खिलाड़ियों को तय समय सीमा में एक निश्चित संख्या में ज़ोंबीज़ को एलिमिनेट करना होता है या अंत तक सर्वाइव करना होता है.
आप गेमप्ले रूल्स और ज़ोंबीज़ की सेटिंग्स को अपनी पसंद के अनुसार एडजस्ट कर सकते हैं, जिसमें एलिमिनेट किए जाने वाले टारगेट ज़ोंबीज़ की संख्या भी शामिल है.`,
  T_37_WT_WS_RULEDESC: "जीतने के लिए टारगेट संख्या जितने ज़ॉम्बी एलिमिनेट करें.",
  T_37_WT_WS_RULETITLE: "गोल",
  T_37_WT_WS_TXT1: "ज़ॉम्बी को एलिमिनेट करें",
  T_37_WT_WS_TXT1DESC: "चालू होने पर, प्लेयर बताई संख्या में ज़ॉम्बी को एलिमिनेट जीत जाते हैं. बंद होने पर प्लेयर आखिर तक ज़िंदा रहकर जीतते हैं.",
  T_37_WT_WS_TXT2: "एलिमिनेशन की मात्रा",
  T_37_WZY_FRIDPLA: "फ्रेंडली प्लेयर",
  T_37_WZY_FRIDSIDE: "फ्रेंडली फैक्शन",
  T_37_WZY_FRIDTEAM: "फ्रेंडली टीम",
  T_37_WZY_HOSTPLA: "दुश्मन प्लेयर",
  T_37_WZY_HOSTSIDE: "दुश्मन फैक्शन",
  T_37_WZY_WS_ACCFRAMES: "जमा फ्रेम",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "किसी मर्चेंडाइज में आइटम जोड़ें. आप एक आइटम या आइटम का ग्रुप जोड़ सकते हैं. मात्रा या तो अलग-अलग इंडिविजुअल की संख्या या एक लिस्ट हो सकती है जिसमें इस मात्रा के आइटम शामिल हों.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "मर्चेंडाइज एंटिटी में आइटम जोड़ने के लिए",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "जोड़ने के लिए आइटम. आप एक आइटम या आइटम का ग्रुप जोड़ सकते हैं.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "जोड़ने के लिए अलग-अलग आइटम की मात्रा या एक लिस्ट जिसमें इस राशि के आइटम शामिल हैं.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "सेलेक्टेड के लिए एक टैग जोड़ें",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "टैग जोड़ने वाली एंटिटी",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "जोड़ने के लिए टेक्स्ट कॉन्टेंट",
  T_37_WZY_WS_AIMABLEENT: "ऐम-एब्ल एंटिटी",
  T_37_WZY_WS_AIMASSISTTYPE: "ऐम असिस्ट टाइप",
  T_37_WZY_WS_ALLOWDROP_NAME: "आइटम ड्रॉप चालू/बंद करें",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "क्या कोई प्लेयर आइटम छोड़ सकता है",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "आइटम को ड्रॉप करने के लिए कॉन्फ़िगर करने के लिए प्लेयर एंटिटी",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "क्या कोई प्लेयर आइटम ड्रॉप कर सकता है. यह बूलियन मान है.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "आइटम पिक अप चालू/बंद करें",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "क्या कोई प्लेयर आइटम उठा सकता है",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "आइटम लेने के लिए कॉन्फ़िगर करने के लिए प्लेयर एंटिटी",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "क्या कोई प्लेयर आइटम उठा सकता है. यह बूलियन मान है.",
  T_37_WZY_WS_AMBIENTCOLOR: "आस-पास रोशनी का रंग",
  T_37_WZY_WS_AMRORTOOL: "रिपेयर आर्मर",
  T_37_WZY_WS_ATTACK: "अटैक",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "प्लेयर के डिस्गाइज़ रद्द करें जिससे वे अपने नॉर्मल रूप में आ जाएंगे",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "प्लेयर एंटिटी जिसकी डिस्गाइज़ रद्द करना है",
  T_37_WZY_WS_BALLADDV_NAMEDES: "फ़ुटबॉल की स्पीड बढ़ाएं",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "स्पीड बढ़ाने के लिए फुटबॉल",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "बूस्टर का स्पीड वेक्टर",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "ट्रिगर होता है जब फुटबॉल को फुटबॉल शूटर मारता है. [प्लेयर एंटिटी] वह प्लेयर है जो फुटबॉल शूटर का मालिक है. [स्पीड बूस्ट] हिट होने के बाद फुटबॉल की अतिरिक्त स्पीड है.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "वह प्लेयर जिसके पास फुटबॉल शूटर है",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "फुटबॉल की स्पीड वेक्टर हिट होने के बाद",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "ट्रिगर तब होता है जब फ़ुटबॉल एक एंटिटी से टकराता है और गेंद की स्पीड बढ़ जाती है [टकराने वाली एंटिटी] वह एंटिटी है जो फ़ुटबॉल से टकराती है. [स्पीड बूस्ट] टक्कर के बाद फुटबॉल में जोड़ी अतिरिक्त स्पीड है.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "वह एंटिटी जो फुटबॉल से टकराती है",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "स्पीड वेक्टर जो टकराने पर फुटबॉल में जुड़ जाता है",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "ट्रिगर जब किसी प्लेयर द्वारा एंटिटी पर निशाना लगाया जा रहा हो",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "प्लेयर जो एंटिटी को एम कर रहा है",
  T_37_WZY_WS_BEHAVIORSTAT: "प्लेयर व्यवहार स्टेटस",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "वेपन एंटिटी जो इस एंटिटी को हिट करती है",
  T_37_WZY_WS_BLOODBARENT: "हेल्थ बार एंटिटी",
  T_37_WZY_WS_BOMBEND: "एक्सप्लोशन से पहले",
  T_37_WZY_WS_BOMBSTART: "बॉम्ब इंडिकेशन",
  T_37_WZY_WS_CHANENT: "चैनल एंटिटी",
  T_37_WZY_WS_CHEER: "चीयर",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "देखें कि किसी चुनी एंटिटी में बताए टैग हैं या नहीं",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "एंटिटी यह जांचने के लिए कि उसमें टैग हैं या नहीं",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "चेक करने के लिए टैग करें",
  T_37_WZY_WS_CHELABELRES: "टैग चेक का रिजल्ट. यह एक बूलियन मान है.",
  T_37_WZY_WS_CJERSEY_NAME: "जर्सी बदलें",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "वो प्लेयर जिसकी जर्सी बदलनी है",
  T_37_WZY_WS_CJERSEY_PARAM2: "जर्सी डिज़ाइन",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "बदलने के लिए चेंज करें",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "जर्सी पर पार्ट 1 का कलर",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "जर्सी पर पार्ट 3 का कलर",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "जर्सी पर पार्ट 3 का कलर",
  T_37_WZY_WS_CJERSEYTYPE1: "डिज़ाइन 1",
  T_37_WZY_WS_CJERSEYTYPE2: "डिज़ाइन 2",
  T_37_WZY_WS_CJERSEYTYPE3: "डिज़ाइन 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "लिस्ट में सभी एलिमेंट को साफ़ करें",
  T_37_WZY_WS_CREABLEOB_DESC: "ऑब्जेक्ट टाइप जिसे ब्लॉक का इस्तेमाल करके बनाया जा सकता है",
  T_37_WZY_WS_CREPROD_NAMEDESC: "एक कस्टमाइजेब्ल मर्चेंडाइज बनाएं और एक मर्चेंडाइज एंटिटी रिटर्न करें. मर्चेंडाइज कॉन्टेंट को संपत्ति सेटिंग्स से कॉन्फ़िगर किया जा सकता है.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "एक कस्टमाइज होने वाली मर्चेंडाइज लिस्ट बनाएं और एक मर्चेंडाइज लिस्ट एंटिटी पर लौटें. इस लिस्ट के कॉन्टेंट को प्रॉपर्टी सेटिंग्स से बदला जा सकता है.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "बनाई जाने वाली मर्चेंडाइज एंटिटी",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "फैक्शन एंटिटी बनाएं",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "बनाने वाली फैक्शन एंटिटी",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "एक कस्टमाइज होने वाला स्टोर बनाएं और एक स्टोर एंटिटी रिटर्न करें. स्टोर के कॉन्टेंट को प्रॉपर्टी सेटिंग्स से बदला जा सकता है.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "स्टोर एंटिटी बनाई गई",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "गेम में आकाश का वातावरण बदलें. विकल्पों में दिन, शाम और रात शामिल हैं.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "बदलने के लिए स्काई का टाइप. ऑप्शन में दिन, शाम और रात शामिल हैं.",
  T_37_WZY_WS_DARKNESS: "ओवरऑल डार्कनेस",
  T_37_WZY_WS_DELENT_NAMEDESC: "एक बताई एंटिटी डिलीट करें. वर्तमान में आइकन एंटिटी, टेक्स्ट एंटिटी, HUD एंटिटी, विसुअल इफ़ेक्ट एंटिटी, वेपन एंटिटी और दूसरे ऑब्जेक्ट एंटिटी को सपोर्ट करता है.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "डिलीट करने के लिए एंटिटी",
  T_37_WZY_WS_DROP: "गलती",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "जब प्लेयर किसी आइटम को ड्रॉप है तो ट्रिगर होता है. [आइटम टाइप] गिराए गए आइटम टाइप की आईडी है.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "ड्रॉप किए आइटम का आईडी टाइप",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "जब प्लेयर वेपन ड्रॉप करता है तो ट्रिगर करता है. [वेपन एंटिटी] ड्रॉप किया जा रहा वेपन है.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "वेपन जिसे ड्रॉप किया गया",
  T_37_WZY_WS_DUMMYLEOBJ: "रेगुलर स्टेज ऑब्जेक्ट",
  T_37_WZY_WS_DUST: "डस्क",
  T_37_WZY_WS_EMPTYCH: "डिफ़ॉल्ट खाली चैनल",
  T_37_WZY_WS_EMPTYCH1: "चैनल 1 खाली",
  T_37_WZY_WS_EMPTYCH2: "चैनल 2 खाली",
  T_37_WZY_WS_EMPTYCH3: "चैनल 3 खाली",
  T_37_WZY_WS_EMPTYCH4: "चैनल 4 खाली",
  T_37_WZY_WS_EMPTYCH5: "चैनल 5 खाली",
  T_37_WZY_WS_EMPTYCH6: "चैनल 6 खाली",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'एक लिस्ट करें जिसमें 3 शर्तों को पूरा करने वाली सभी एंटिटी शामिल हों. "सभी शामिल हैं", "शामिल नहीं", और "शामिल है"सिंगल कॉम्पोनेन्ट टाइप या कॉम्पोनेन्ट टाइप की लिस्ट है. रिटर्न रिजल्ट उन एंटिटी की लिस्ट है जो शर्तों को पूरा करती हैं.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "फ़िल्टर की गई एंटिटी में इस ऐरे के सभी घटक होने चाहिए",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "फ़िल्टर की गई एंटिटी में इस ऐरे से बताया एंटिटी नहीं होने चाहिए",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "फ़िल्टर की गई एंटिटी में इस ऐरे से कम से कम एक कॉम्पोनेन्ट होना चाहिए",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "इस एंटिटी का प्रॉपर्टी टाइप बदलने के लिए",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "प्रॉपर्टी वैल्यू को बदलने के लिए",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "प्लेयर को मौजूदा चैनल छोड़ने दें ताकि वे किसी भी चैनल में न हों",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "चैनल छोड़ने वाला प्लेयर",
  T_37_WZY_WS_FAKEENT: "डिस्गाइज़ वाली एंटिटी",
  T_37_WZY_WS_FIND_STR_DESC: "एक स्ट्रिंग के भीतर बताए टेक्स्ट की जगह खोजें",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "ढूंढने के लिए कैरेक्टर",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "शुरुआती लोकेशन से एक स्ट्रिंग खोजें, जो 0 से शुरू होती है.",
  T_37_WZY_WS_FINDSTRRES: "पहला स्थान जहां स्ट्रिंग दिखाई देती है. 0 से शुरू होता है.",
  T_37_WZY_WS_FOGCOLOR: "फॉग कलर",
  T_37_WZY_WS_FRICTIONCON: "रेगुलर फ्रिक्शन मल्टीप्लायर",
  T_37_WZY_WS_FRICTIONIMP: "कोलिशन फ्रिक्शन मल्टीप्लायर",
  T_37_WZY_WS_FROMDEATH: "रिवाइवल",
  T_37_WZY_WS_FROMKNODOWN: "हेल्प अप",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "चैनल पाएं जिसमें नामित खिलाड़ी है",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "प्लेयर एंटिटी जिसका चैनल पाना है",
  T_37_WZY_WS_GETCHANRES: "वह चैनल जिसमें प्लेयर वर्तमान में है",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "चैनल ID 1 से 8 के अनुसार, गेम की शुरुआत में डिफ़ॉल्ट रूप से बनाया गया खाली चैनल पाएं",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "डिफ़ॉल्ट खाली चैनल की ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "मिली चैनल एंटिटी",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "प्लेयर की डिस्गाइज़ एंटिटी पाएं.",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "ऑब्जेक्ट जिसकी डिस्गाइज़ एंटिटी पाना है",
  T_37_WZY_WS_GETGAMEENT_NAME: "ग्लोबल पाएं",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "इस मैच की गेम एंटिटी पाएं",
  T_37_WZY_WS_GETHOSTPLA_NAME: "अटैक करने योग्य प्लेयर पाएं",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "फैक्शन एंटिटी",
  T_37_WZY_WS_GOAL_NAMEDESC: "जब कोई फ़ुटबॉल गोल में जाती है तो ट्रिगर होता है. [टारगेट] वह गोल है जिसमें यह फ़ुटबॉल जाती है. [स्कोरर] गेंद के संपर्क में आने वाला आखिरी प्लेयर है. [असिस्ट] गेंद के संपर्क में आने वाला दूसरा प्लेयर है.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "यह फुटबॉल जिस गोल में एंटर करता है",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "बॉल के संपर्क में आने वाला आखिरी प्लेयर",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "बॉल के संपर्क में आने वाला आखिरे से पहले वाला प्लेयर",
  T_37_WZY_WS_HEARTBEAT: "हार्टबीट",
  T_37_WZY_WS_HEAVYWEAPON: "हैवी वेपन",
  T_37_WZY_WS_HIHGSHOOTANGLE: "सबसे छोटा वॉली एंगल",
  T_37_WZY_WS_HOSTPLA: "अटैक वाले प्लेयर की लिस्ट",
  T_37_WZY_WS_HOSTSIDE: "अटैक वाले फैक्शन की लिस्ट",
  T_37_WZY_WS_HOSTTEAM: "आक्रमण कर सकने वाली की लिस्ट",
  T_37_WZY_WS_ICON_CLOCK: "काउंटडाउन",
  T_37_WZY_WS_ICON_CLOTHES: "कपड़े",
  T_37_WZY_WS_ICON_QUIT: "बाहर निकालें",
  T_37_WZY_WS_INSERT_ARR_DESC: "लिस्ट में बताई लोकेशन पर एक नया एलिमेंट डालें",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "इंडेक्स लोकेशन से शुरू करके, बताई लंबाई की एक स्ट्रिंग एक्सटैक्ट. अगर एक्सटैक्ट लंबाई स्ट्रिंग की लंबाई से ज़्यादा है, तो यह स्ट्रिंग के आख़िरी तक कॉन्टेंट निकालेगा.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "एक्सट्रैक्शन की लंबाई",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "तार इसे एक्सट्रेक्ट किया गया.",
  T_37_WZY_WS_INTORINTL: "इन्टिजर या इन्टिजर लिस्ट",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "बताए फैक्शन में प्लेयर को जॉइन कराएं",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "जॉइन प्लेयर के लिए फैक्शन",
  T_37_WZY_WS_JUMP: "जम्प",
  T_37_WZY_WS_LABEL: "टैग",
  T_37_WZY_WS_LENSFLARE: "लेंस फ्लेर",
  T_37_WZY_WS_LENTH: "लम्बाई",
  T_37_WZY_WS_LIGHTATTACK: "सफल हिट",
  T_37_WZY_WS_LIGHTCOLOR: "लाइट सोर्स कलर",
  T_37_WZY_WS_LIGHTINTENSITY: "लाइट सोर्स ब्राइटनेस",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "एक नई सीनरी लोड करें",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "लोड करने के लिए सीनरी का नाम",
  T_37_WZY_WS_MOROBJECT: "ऑब्जेक्ट डिस्गाइज़ करें",
  T_37_WZY_WS_MOVEAXISX: "x एक्सिस पर चलें",
  T_37_WZY_WS_MOVEAXISY: "y एक्सिस पर चलें",
  T_37_WZY_WS_MOVEAXISZ: "z एक्सिस पर चलें",
  T_37_WZY_WS_MOVEDISTITLE: "मूवमेंट की दूरी",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "क्विक मैसेज चालू-बंद का टॉगल",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "क्विक मैसेज चालू या बंद करें. बंद होने पर, क्विक मैसेज HUD का इस्तेमाल नहीं किया जा सकता है और प्लेयर क्विक मैसेज भेज या पा नहीं सकेगा.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "क्विक मैसेज को चालू/बंद करने वाला प्लेयर",
  T_37_WZY_WS_MUTEVOICE_NAME: "वॉइस चैट चालू-बंद का टॉगल",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "वॉइस चैट चालू या बंद करें. बंद होने पर, वॉइस HUD का इस्तेमाल नहीं किया जा सकता है और प्लेयर वॉइस मैसेज भेज या पा नहीं सकेंगे.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "प्लेयर के लिए वॉइस चैट चालू/बंद करने के लिए",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "बूलियन. ट्रू का मतलब बंद है; फाल्स का मतलब  है चालू.",
  T_37_WZY_WS_NIGHTMODE: "नाईट मोड",
  T_37_WZY_WS_ONAIM_NAMEDESC: "ट्रिगर तब होता है जब प्लेयर निशाना-लगाई जाने वाली एंटिटी पर निशाना बना रहा होता है. [टारगेट एंटिटी] वह इकाई है जिसका निशाना रखा जा रहा है. जब कोई एंटिटी पर टारगेट नहीं होता है, तो रिटर्न वैल्यू जीरो होता है.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "एम्ड एंटिटी",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "वह एंटिटी जिसे वेपन ने मारा है",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "जब सीनरी सफलतापूर्वक लोड हो जाती है तो ट्रिगर हो होता है",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "लोड करने के लिए सीनरी का नाम. यह एक स्ट्रिंग है.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "जब सीनरी सफलतापूर्वक स्विच हो जाती है तो ट्रिगर हो जाता है",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "नए सीनरी का नाम. यह एक स्ट्रिंग है.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "प्लेयर के कपड़ों को उसके डिफ़ॉल्ट रूप में रिस्टोर करें",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "वह प्लेयर जिसके डिफ़ॉल्ट कपड़ों को रिस्टोर करना है",
  T_37_WZY_WS_PETSET: "पेट सेटिंग",
  T_37_WZY_WS_PETSKILL: "पैट स्किल्स",
  T_37_WZY_WS_PETSWITCH2: "क्या पैट स्किल का इस्तेमाल किया जा सकता है",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "प्लेयर मूवमेंट को बंद करना है या नहीं. यह एक बूलियन मान है.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "प्लेयर का व्यवहार टाइप",
  T_37_WZY_WS_PRESS: "जेंटल क्लिक",
  T_37_WZY_WS_PROGRESS: "मौजूदा प्रोग्रेस",
  T_37_WZY_WS_PROGRESSBAR: "प्रोग्रेस HUD एंटिटी",
  T_37_WZY_WS_RANKDOWN: "रैंक डाउन",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "चुनी एंटिटी के लिए एक टैग रिमूव करें",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "हटाने के लिए टेक्स्ट कॉन्टेंट",
  T_37_WZY_WS_REPLACE_STR_DESC: "स्ट्रिंग की कॉन्टेंट को बताये कॉन्टेंट से बदलें",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "बदला जाने वाला कैरेकटर",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "बदले जाने के लिए नया कैरेक्टर",
  T_37_WZY_WS_REVERSE_ARR_DESC: "इस सूची के सभी एलिमेंट को उलट दें",
  T_37_WZY_WS_REVIVEHERE: "वह प्लेयर जो इस रिवाइवल पॉइंट पर टीम के साथियों को रिवाइव कर रहा है",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "ट्रिगर होता है जब कोई प्लेयर इस रिवाइवल पॉइंट पर टीममेट को रिवाइव कर रहा होता है",
  T_37_WZY_WS_REVIVEWAYDESC: "वह तरीका जिसके द्वारा किसी प्लेयर्स को रिवाइव किया जाता है या एलिमिनेट होने या नॉक से बचाया जाता है",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "प्लेयर्स के लिए विभिन्न व्यवहारों की स्थिति को कॉन्फ़िगर करें. बंद होने पर, HUD पर संबंधित बटनों का इस्तेमाल नहीं किया जा सकेगा, और मैनुअल और ऑटोमैटिक मूवमेंट की अनुमति नहीं है. छुपा होने पर, संबंधित बटन HUD पर प्रदर्शित नहीं होंगे, और मैन्युअल मूवमेंट की अनुमति नहीं है जबकि ऑटोमैटिक मूवमेंट की अनुमति है. चालू होने पर, संबंधित बटन HUD पर दिखेंगे, और मैनुअल और ऑटोमैटिक मूवमेंट की अनुमति है.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "प्लेयर जिसके लिए व्यवहार स्टेटस सेट करना है",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "प्लेयर का व्यवहार, जिसमें चलना, हमला करना, कूदना और दौड़ना शामिल है",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "बंद, छिपा हुआ और चालू स्टेटस शामिल है. जब छुपाया जाता है, तो संबंधित बटन HUD पर दिखाई नहीं होंगे, और मैन्युअल मूवमेंट की अनुमति नहीं है जबकि ऑटोमैटिक मूवमेंट की अनुमति है. चालू होने पर, संबंधित बटन HUD पर दिखाई नहीं होंगे, और मैनुअल और ऑटोमैटिक मूवमेंट की अनुमति है.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "फुटबॉल के कोऑर्डिनेट",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "क्या फ़ुटबॉल को अपनी प्री-कॉन्फ़िगरेशन स्पीड बनाए रखनी चाहिए या नहीं. यह एक बूलियन मान है.",
  T_37_WZY_WS_SETPLAHOST_NAME: "प्लेयर अटैक सेटिंग",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "कॉन्फ़िगर करें कि क्या [सेटिंग प्लेयर] ,[टारगेट प्लेयर] पर हमला कर सकता है. डिफ़ॉल्ट सेटिंग इस बात पर आधारित होती है कि टारगेट प्लेयर उस टीम और फैक्शन से संबंधित है या नहीं जिस पर हमला किया जा सकता है. यह सेटिंग टीम/फैक्शन सेटिंग की तुलना में हाई प्राथमिकता वाली है.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "दुश्मनों को कॉन्फ़िगर करने के लिए प्लेयर",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "प्लेयर जो दुश्मन है",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "अटैकेब्ल",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"हां" मतलब हमला करने योग्य; "नहीं" यानी हमला करने योग्य नहीं. डिफ़ॉल्ट सेटिंग इस बात पर आधारित होती है कि टारगेट प्लेयर उस टीम और फ़ैक्शन से संबंधित है या नहीं जिस पर हमला किया जा सकता है.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"हां" मतलब अटैक किया जा सकता है; "नहीं" मतलब अटैक नहीं किया जा सकता',
  T_37_WZY_WS_SHADOWSTRENGTH: "शैडो",
  T_37_WZY_WS_SHOOTANGLE: "सबसे छोटा शूटिंग एंगल",
  T_37_WZY_WS_SKYBOX: "स्काई",
  T_37_WZY_WS_SKYBOXENT: "स्काई एंटिटी",
  T_37_WZY_WS_SKYBOXTYPE: "बेसिक स्काई टाइप",
  T_37_WZY_WS_STEPPED: "स्टेप ऑन ट्रिगर",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "प्लेयर का वॉइस चैट चैनल स्विच करें",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "चैनल स्विच करने के लिए प्लेयर",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "स्विच करने के लिए चैनल",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "बताई सीनरी पर स्विच करे",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "स्विच करने वाली सीनरी का नाम",
  T_37_WZY_WS_TARGETSTR_DESC: "टारगेट स्ट्रिंग",
  T_37_WZY_WS_TEAMASIDE: "टीम और फैक्शन",
  T_37_WZY_WS_TELEPORTN_AUTO: "ऑटोमैटिक",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "टेलिपोर्टेब्ल या नहीं",
  T_37_WZY_WS_TELEPORTN_MANUAL: "मैन्युअल",
  T_37_WZY_WS_TELEPORTN_NO: "नहीं",
  T_37_WZY_WS_TELEPORTN_TITLE: "टेलिपोर्ट मेथड",
  T_37_WZY_WS_TELEPORTN_YES: "हाँ",
  T_37_WZY_WS_TERRAINWET: "टेरन मॉइस्चर",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "[सीनरी ऑब्जेक्ट] की बनावट से [प्लेयर एंटिटी] की बनावट को सब्स्टीट्यूट करें",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "प्लेयर एंटिटी जिसका स्वरूप बदलना है",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "प्लेयर जिसकी डिस्गाइज़ एंटिटी पानी है",
  T_37_WZY_WS_TRANSP: "ट्रांसपेरेंसी",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "बताई सीनरी को अनइंस्टॉल करें",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "अनइंस्टाल के लिए सीनरी का नाम",
  T_37_WZY_WS_VFX1: "सिंबॉलिक",
  T_37_WZY_WS_VFX2: "स्मोकी",
  T_37_WZY_WS_VFX3: "कर्स एक्सप्लोसिव",
  T_37_WZY_WS_VFX5: "फ्रोज़न",
  T_37_WZY_WS_VFX6: "स्पॉटलाइट",
  T_37_WZY_WS_VFX7: "अपवर्ड टर्बुलेन्स",
  T_37_WZY_WS_VFX8: "वातावरण विस्फोट",
  T_37_WZY_WS_VISABLE: "विज़िबिलिटी",
  T_37_WZY_WS_WEAOPEN: "दिखाएं या नहीं",
  T_37_WZY_WS_WEAPONENT: "वेपन एंटिटी",
  T_37_WZY_WS_WEATARGETED: "क्या ऐम असिस्ट से टारगेट किया जा सकता है या नहीं.",
  T_37_XYL_CUSTOMJERSEY: "जर्सी मशीन",
  T_37_XYL_CUSTOMJERSEY_DESC: "अपनी आइडियल जर्सी बनाने के लिए जर्सी मशीन का इस्तेमाल करें",
  T_37_XYL_FOOTGUN: "फुटबॉल शूटर",
  T_37_XYL_SOCCER: "फुटबॉल",
  "T_37_XYL_SOCCER_ RADIUS": "रेडियस",
  T_37_XYL_SOCCER_DESC: "एक फुटबॉल जिसकी प्रॉपर्टी को कस्टमाइज किया जा सकता है",
  T_37_XYL_SOCCER_HIGHT1: "रेगुलर एंगल",
  T_37_XYL_SOCCER_HIGHT2: "वॉली एंगल",
  T_37_XYL_SOCCER_RESET: "एक गोल के बाद रिसेट टाइम (s)",
  T_37_XYL_SOCCER_RESIST1: "फ्रिक्शन (किक मोड)",
  T_37_XYL_SOCCER_RESIST2: "फ्रिक्शन (गन मोड)",
  T_37_XYL_SOCCERGOAL: "गोल",
  T_37_XYL_SOCCERGOAL_DESC: "यही गोल है. स्कोर करने के लिए फुटबॉल को गोल में शूट करें. (केवल पॉइंट ग्रैब में मान्य है.)",
  T_37_XYL_SOCCERITEM: "आइटम स्पॉन",
  T_37_XYL_SOCCERITEM_DESC: "रखने पर, यह चुने आइटम उत्पन्न करेगा",
  T_37_XYL_SPAWN_PEOPLE: "# प्लेयर्स",
  T_37_XYL_WS_AIRCONDITIONER001: "एयर कंडीशनर B",
  T_37_XYL_WS_AMMUCHEST: "वॉर चेस्ट A",
  T_37_XYL_WS_BAFFLE001: "बैरियर A",
  T_37_XYL_WS_BARREL001: "बैरल्स",
  T_37_XYL_WS_BARREL001_DES: "आमतौर पर देखे जाने वाले गोलाकार लकड़ी के बैरल",
  T_37_XYL_WS_BOARD001: "ऐड बोर्ड B",
  T_37_XYL_WS_BOOK001: "पाइल ऑफ़ बुक A",
  T_37_XYL_WS_BOOK002: "बोर्ड गेम A",
  T_37_XYL_WS_BOUGAINVILLEA: "बूगनविलिया",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "डेकोर: जगह को ब्राइट करें",
  T_37_XYL_WS_BOX001: "बॉक्स का ढेर A",
  T_37_XYL_WS_BOX002: "स्माल बॉक्स",
  T_37_XYL_WS_BUSHCOVER: "बुश",
  T_37_XYL_WS_BUSHCOVER_DES: "एक झाड़ी जिसे छिपाने के लिए इस्तेमाल किया जा सकता है",
  T_37_XYL_WS_CABINET001: "ड्रॉअर A",
  T_37_XYL_WS_CHAIR001: "चेयर A",
  T_37_XYL_WS_COCONUTTREE: "कोकोनट ट्री",
  T_37_XYL_WS_COCONUTTREE_DES: "डेकोर- बीच वाइब के लिए!",
  T_37_XYL_WS_COMPUTER001: "कंप्यूटर A",
  T_37_XYL_WS_DAMAGERATIO: "डैमेज अनुपात",
  T_37_XYL_WS_FIREEX: "फायर इक्स्टिंगग्विशर",
  T_37_XYL_WS_GUIDEPOSE: "डायरेक्शन पोस्ट",
  T_37_XYL_WS_HUGEHOUSE001: "3-स्टोरी हाउस B",
  T_37_XYL_WS_HUGEHOUSE002: "2-स्टोरी घर B",
  T_37_XYL_WS_JACKSTRAW: "स्कैरक्रो",
  T_37_XYL_WS_LADDER001: "सीढ़ी A",
  T_37_XYL_WS_OILDRUM: "जेरी कैन",
  T_37_XYL_WS_ORNAMENT001: "गुलदस्ता A",
  T_37_XYL_WS_PACKBOX: "सप्लाई कंटेनर",
  T_37_XYL_WS_PILLA001: "आपका BP EXP Lv 120 तक बढ़ सकता है.",
  T_37_XYL_WS_PRESENT: "गिफ़्ट बॉक्स",
  T_37_XYL_WS_PRESENT_DES: "हॉलिडे गिफ़्ट शामिल हैं",
  T_37_XYL_WS_PUMPKIN: "स्क्वायर जैक-ओ-लैंटर्न",
  T_37_XYL_WS_PUMPKINCUT: "जैक-ओ-लैंटर्न",
  T_37_XYL_WS_PUMPKINCUT_DES: "एक डरावने त्योहार के लिए आम सजावट",
  T_37_XYL_WS_ROADBLOCK001: "रोडब्लॉक B",
  T_37_XYL_WS_SHELF001: "बुकशेल्फ A",
  T_37_XYL_WS_SOFA001: "सोफा A",
  T_37_XYL_WS_SPAWNTEAM: "सभी टीम्स",
  T_37_XYL_WS_SUPPLYBOX: "एमो क्रेट",
  T_37_XYL_WS_TABLE001: "टेबल A",
  T_37_XYL_WS_TABLE002: "टेबल B",
  T_37_XYL_WS_TARGET001: "टारगेट",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "पॉर्टल फिनिश पॉइन्ट",
  T_37_XYL_WS_TELEPORTNEW: "पोर्टल A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "एक पोर्टल जो प्लेयर को पोर्टल के फिनिशिंग पॉइंट तक टेलीपोर्ट कर सकता है",
  T_37_XYL_WS_TIRES001: "टायर A",
  T_37_XYL_WS_TOOLRACK: "टूल शेल्फ",
  T_37_XYL_WS_WALL001: "वॉल",
  T_37_XYL_WS_WOOD001: "चॉप्ड वुड",
  T_37_XYL_WS_YELLOWDUCK001: "डकी फ्लोट",
  T_37_XYL_WS_YELLOWDUCK001_DES: "बत्तख के आकार में एक फुलाया हुआ तैरने वाला रिंग",
  T_37_YM_BOMBSQUAD_DEFUSER: "डिफ्यूज़र",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF वाइट जर्सी (बॉटम)",
  T_37_YS_F_B_VN_STREET: "क्रिमसन ऑस्पीशिऑन (बॉटम)",
  T_37_YS_F_H_VN_STREET: "क्रिमसन ऑस्पीशिऑन (हेड)",
  T_37_YS_F_S_VN_STREET: "क्रिमसन ऑस्पीशिऑन (जूते)",
  T_37_YS_F_T_VN_STREET: "क्रिमसन ऑस्पीशिऑन (टॉप)",
  T_37_YS_M_A_CRICKET_BLACK: "बम्बलबी क्रिकटर (मास्क)",
  T_37_YS_M_A_THKOL: "ब्लेज़ बैनिश बंडल (मास्क)",
  T_37_YS_M_B_CRICKET_BLACK: "बम्बलबी क्रिकटर (बॉटम)",
  T_37_YS_M_B_SILVERERA: "फियरलेस ग्रेगार्ड (बॉटम)",
  T_37_YS_M_B_THKOL: "ब्लेज़ बैनिश बंडल (बॉटम)",
  T_37_YS_M_H_SILVERERA: "फियरलेस ग्रेगार्ड (हेड)",
  T_37_YS_M_H_THKOL: "ब्लेज़ बैनिश बंडल (हेड)",
  T_37_YS_M_S_CRICKET_BLACK: "बम्बलबी क्रिकटर (जूते)",
  T_37_YS_M_S_SILVERERA: "फियरलेस ग्रेगार्ड (जूते)",
  T_37_YS_M_S_THKOL: "ब्लेज़ बैनिश बंडल (जूते)",
  T_37_YS_M_T_CRICKET_BLACK: "बम्बलबी क्रिकटर (टॉप)",
  T_37_YS_M_T_SILVERERA: "फियरलेस ग्रेगार्ड (टॉप)",
  T_37_YS_M_T_THKOL: "ब्लेज़ बैनिश बंडल (टॉप)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF व्हाइट जर्सी (टॉप)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "मिनिमन प्लेयर",
  T_38_BQ_SKILL_NAME_DUMMY1: "स्टंट डबल",
  T_38_BQ_SKILL_NAME_DUMMY2: "शेप स्प्लिटर",
  T_38_CJ_F_B_STREAMER_MUSIC: "ई-हार्टसीकर (बॉटम)",
  T_38_CJ_F_H_STREAMER_MUSIC: "ई-हार्टसीकर (हेड)",
  T_38_CJ_F_S_STREAMER_MUSIC: "ई-हार्टसीकर (जूते)",
  T_38_CJ_F_T_STREAMER_MUSIC: "ई-हार्टसीकर (टॉप)",
  T_38_JH_WS_CM1: "क्लियर नियम",
  T_38_JH_WS_CM2: "अस्पष्ट नियम",
  T_38_JH_WS_CM3: "बार-बार बाहर निकलना",
  T_38_JL_M79_AMMO_N: "M79 गोली",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs का माइक्रोचिप",
  T_38_M_WS_VECTOR2: "2D वेक्टर",
  T_38_R_TACTICS_N: "प्रीसेट",
  T_38_RW_NIW_NIWNAME: "ग्लू मेकर",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "ब्लॉक की बहुत सारी लेयर. वर्तमान: {0}. अधिकतम.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "आपके द्वारा बनाए गए आइटमों ({0}) की संख्या सीमा ({1}) से ज़्यादा हो गई है.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "एक ही फ्रेम के भीतर मिली घटनाओं की संख्या ({0}) सीमा ({1}) से अधिक हो गई है.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "प्रति-फ़्रेम डायनामिक एंटिटी क्रिएटर लिमिट तक पहुँच गया ({0}); {1} क्रिएशन प्रयास अस्वीकृत.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "प्रारंभिक सूची की लंबाई ({0}) लिमिट ({1}) पूरी हो गई है. अधिकतम क्षमता लिस्ट अपने-आप बनाता है.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "लूप की संख्या ({0}) सीमा ({1}) से अधिक हो गई है. लूप बाधित हुआ",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "कॉरूटिन स्कोप में कॉनकरंट कॉरूटिन ({0}) की संख्या सीमा ({1}) से अधिक हो गई है.",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "लिस्ट में एलिमेंट जोड़ने में विफल. सूची {0} खाली है",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "मूल अंकगणितीय ऑपरेशन करते समय मिसमैच वैल्यू टाइप. बाईं वैल्यू टाइप {0} है और बांईं वैल्यू टाइप {1} है.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "रिपीट हुए टेम्परेरी वेरिएबल परिभाषा. वेरिएबल का नाम {0}.",
  T_38_SP_WS_REVIEW_01: "टॉक्स",
  T_38_SP_WS_REVIEW_02: "असभ्य",
  T_38_SP_WS_REVIEW_03: "अपमान",
  T_38_SP_WS_REVIEW_04: "बहुत टॉक्सिक",
  T_38_SP_WS_REVIEW_05: "थ्रीटेनिंग",
  T_38_SP_WS_REVIEW_06: "डिसरेस्पेक्टलफुल",
  T_38_SP_WS_REVIEW_07: "रिव्यू में",
  T_38_SP_WS_REVIEW_08: "{0} नाम {1} नियमों को फॉलो नहीं करता है. {2}.",
  T_38_SP_WS_REVIEW_09: "स्ट्रिंग",
  T_38_SP_WS_REVIEW_10: "स्टोर",
  T_38_SP_WS_REVIEW_11: "वेरिएबल",
  T_38_SP_WS_REVIEW_12: "फंक्शन",
  T_38_SP_WS_REVIEW_13: "ऑब्जेक्ट",
  T_38_SP_WS_REVIEW_14: "परिभाषा पर जाएं",
  T_38_SP_WS_REVIEW_15: "ऑब्जेक्ट्स मैनेज करें पर जाएं.",
  T_38_SP_WS_REVIEW_16: "कोई रेडिरेक्शन नहीं",
  T_38_SP_WS_REVIEW_17: "मैप का नाम",
  T_38_SP_WS_REVIEW_18: "विवरण",
  T_38_SP_WS_REVIEW_19: "कवर इमेज",
  T_38_SP_WS_REVIEW_20: "टेक्स्ट में संवेदनशील शब्द हैं.",
  T_38_SP_WS_REVIEW_21: "सेव फेल हुआ. रिव्यू करने में असमर्थ.",
  T_38_SP_WS_REVIEW_22: "रिव्यू कूलडाउन में है",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "मेहम बैट",
  T_38_SY_CHARACTER_DESIGNER_N: "सैंटिनो",
  T_38_SY_PET_CACTUS_N: "कैक्टस",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "पैट स्किन: घोस्ट कैक्टस",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "पैट स्किन: नियॉन कैक्टस",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "पैट स्किन: पाम ड्रीम कैक्टस",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "पैट स्किन: पार्टी आर्वन",
  T_38_SY_PETSKIN_RACCOON_MO_N: "पैट स्किन: ट्रेंडी रूकी",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - नाईटफायर कामी",
  T_38_SY_SICKLE_ES_N: "साइथ - पॉप-पाउ",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "पिकअप ट्रक - मोची फ़ूड ट्रक",
  T_38_WT_WS_MUITLEVEL: "मल्टी-लेवल",
  T_38_WT_WS_SKILLSET15: "थ्रिल ऑफ़ बैटल (A124)",
  T_38_WT_WS_SKILLSET16: "सेंसेस शॉकवेव (होमर)",
  T_38_WT_WS_SKILLSET17: "वाल ब्राव्ल (आईरिस)",
  T_38_WT_WS_SKILLSET18: "रेबल रश (तात्सुया)",
  T_38_WZY_WS_ACTIVEA: "सीनरी में प्रयोग करने योग्य है या नहीं",
  T_38_WZY_WS_ACTIVEB: "लॉजिक रिफ्रेश चालू करें या नहीं",
  T_38_WZY_WS_ACTIVEVALUE: "एक्टिविटी स्टेटस",
  T_38_WZY_WS_AIR: "हवा",
  T_38_WZY_WS_ALLOWMOVE: "चल सकते हैं या नहीं",
  T_38_WZY_WS_AMMOAMOUNT: "गोली मात्रा",
  T_38_WZY_WS_AMMONAME: "गोली एंटिटी",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG कमी गुणक",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "विस्फोट DMG कमी गुणक",
  T_38_WZY_WS_ARMOR_DURABILITY: "मौजूदा ड्यूरेबिलिटी",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "मैक्स ड्यूरेबिलिटी",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "डैमेज लायक या नहीं",
  T_38_WZY_WS_ARMOR_ISDESTROY: "नष्ट लायक या नहीं",
  T_38_WZY_WS_ARMOR_LEVEL: "लेवल",
  T_38_WZY_WS_ASSCONZOM: "ज़ॉम्बी एलिमिनेशन असिस्ट",
  T_38_WZY_WS_BAGNAME: "बैकपैक एंटिटी",
  T_38_WZY_WS_BAGSPACEEX: "बैकपैक में अतिरिक्त जगह",
  T_38_WZY_WS_BRIDGING: "ब्रिज रेंडर कॉम्पोनेन्ट",
  T_38_WZY_WS_BUBBLE: "बबल",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "[प्लेयर एंटिटी के] बैकपैक में सभी आइटम क्लियर करें",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "मैप में आसपास पड़ी अनवांटेड आइटम क्लियर करें, जैसे कि लूट, फेंकने योग्य अवशेष और लूट बॉक्स",
  T_38_WZY_WS_CLEARPRO: "सिंगल प्रॉपर्टी फैक्टर क्लियर करें",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "एक [सीनरी ऑब्जेक्ट] के स्थान पर एक [प्लेयर एंटिटी] एंटिटी को क्लोन करें और [डिसगाइज़ एंटिटी] को वापस पाएं",
  T_38_WZY_WS_COMPONENT: "कॉम्पोनेन्ट",
  T_38_WZY_WS_COSTAMMO: "गोली खपत करें",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "एक कैमरा बनाएं और एक [कैमरा एंटिटी] रिटर्न करें, जिसकी प्रॉपर्टी को प्रॉपर्टी सेटिंग्स से मॉडिफाइड किया जा सकता है",
  T_38_WZY_WS_CYCLES: "बार खेला",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "जांचें कि क्या एक [एंटिटी] एक गोलाकार पोल के दायरे के अंदर है. [सेंटर] पिवोट का सेंटर है, [रेडियस] रेडियस सतह की रेडियस है, [हाइट] पोल की ऊंचाई है, [यूलर एंगल] पोल के 3D ओरिएंटेशन के एंगल हैं.",
  T_38_WZY_WS_CYLINDERJUD_RES: "सर्कुलर पोल स्कोप चेक का नतीजा. यह एक बूलियन मान है.",
  T_38_WZY_WS_DAMSUMZOM: "ज़ॉम्बी को DMG",
  T_38_WZY_WS_DARKNESS: "डार्कनेस",
  T_38_WZY_WS_DIFCOLOR: "सरफेस कलर",
  T_38_WZY_WS_DIFTEXTURE: "सरफेस टेक्सचर",
  T_38_WZY_WS_DRUMMUSIC: "कॉम्पोनेन्ट टाइप: ड्रम",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "वह खिलाड़ी जो डिस्कनेक्ट हो गया था",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "प्लेयर को रीकनेक्ट हो रहा",
  T_38_WZY_WS_EUIANCHOR: "HUD एंकर टाइप गणना",
  T_38_WZY_WS_FEATHER: "फीदर",
  T_38_WZY_WS_FLAMEAMMO: "फ्लेमथ्रोअर गोली",
  T_38_WZY_WS_FLOWER: "फ्लावर",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "[एंटिटी] को हमेशा [फॉलो की गई एंटिटी] का फॉलो करने के लिए सेट करें. [ऑफ़सेट कॉआर्डिनेट] दो एंटिटी के बीच की दूरी है.",
  T_38_WZY_WS_FOLLOWENT: "फॉलो की गई एंटिटी",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "कैमरा एंटिटी पाएं जो मौजूदा समय में एक [प्लेयर एंटिटी] द्वारा उपयोग की जा रही है",
  T_38_WZY_WS_GETCURCAMDESC: "कैमरा जो वर्तमान में प्लेयर्स द्वारा इस्तेमाल किया जा रहा है",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "[बताये आइटम टाइप] में एक [प्लेयर] के स्वामित्व वाले आइटम की मात्रा पाएं.",
  T_38_WZY_WS_GETITEMNUM_RES: "प्लेयर्स के स्वामित्व वाली बताये आइटम की मात्रा",
  T_38_WZY_WS_GETVEC_NAME: "वेक्टर हासिल करें",
  T_38_WZY_WS_GETVEC_NAMEDESC: "कोऑर्डिनेट के एक सेट के x, y, और z कॉम्पोनेन्ट का इस्तेमाल करके एक वेक्टर पाएं",
  T_38_WZY_WS_GETVECRES: "x, y और z कॉम्पोनेन्ट से मिले वेक्टर",
  T_38_WZY_WS_GHOST: "भूत",
  T_38_WZY_WS_GRENADEFROZENNAME: "फ़्लैश फ्रीज़ एंटिटी",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "फ्रीज़ ज़ोन रेडियस",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "फ्रीज़ अवधि",
  T_38_WZY_WS_GRENADENAME: "ग्रेनेड एंटिटी",
  T_38_WZY_WS_GRENADEPARAM1: "मिनी डैमेज",
  T_38_WZY_WS_GRENADEPARAM2: "मैक्स. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "विस्फोट की रेंज",
  T_38_WZY_WS_GRENADEPARAM5: "थ्रोइंग स्पीड",
  T_38_WZY_WS_GRENADEPARAM6: "एक्सप्लोसन डिले",
  T_38_WZY_WS_GRENADEPARAM7: "सेल्फ DMG गुणक",
  T_38_WZY_WS_GRENADEPARAM8: "एली DMG मल्टीप्लायर",
  T_38_WZY_WS_GRENADEPARAM9: "व्हीकल DMG  गुणक",
  T_38_WZY_WS_GUNFIRE: "गनफायर",
  T_38_WZY_WS_GUNPRO_PARAM2: "रीलोड स्पीड",
  T_38_WZY_WS_GUNPRO_PARAM3: "बॉडी शॉट DMG रेश्यो",
  T_38_WZY_WS_GUNPRO_PARAM4: "हेडशॉट DMG अनुपात",
  T_38_WZY_WS_GUNPRO_PARAM5: "लिंब शॉट्स DMG अनुपात",
  T_38_WZY_WS_GUNPRO_PARAM7: "एक्स्ट्रा DMG",
  T_38_WZY_WS_HELMET_NAME: "हेलमेट एंटिटी",
  T_38_WZY_WS_ICON1: "क्राउन",
  T_38_WZY_WS_ICON2: "डुएल",
  T_38_WZY_WS_INITPOS: "शुरुआती लोकेशन",
  T_38_WZY_WS_ISRESET: "रेसिप्रोकेटींग मोशन",
  T_38_WZY_WS_KILLCONZOM: "एलिमिनेट किये ज़ोम्बी की संख्या",
  T_38_WZY_WS_KILLENT_NAMEDESC: "चुने हुए [एंटिटी] को हटा दें, जो एक बैटल एंटिटी टाइप होना चाहिए. अभेद्य स्टेटस को इग्नोर करता है.",
  T_38_WZY_WS_LABELPARAM: "टेक्स्ट कंटेंट पैरामीटर लिस्ट",
  T_38_WZY_WS_LEADMUSICA: "कॉम्पोनेन्ट टाइप: पियानो (ट्रेबल)",
  T_38_WZY_WS_LEADMUSICB: "कॉम्पोनेन्ट टाइप: पियानो (आल्टो)",
  T_38_WZY_WS_LEADMUSICC: "कॉम्पोनेन्ट टाइप: पिआनो (बेस)",
  T_38_WZY_WS_LINE: "लाइन",
  T_38_WZY_WS_LIQUID: "लिक्विड",
  T_38_WZY_WS_LOCALKEY: "लोकलाइज की",
  T_38_WZY_WS_LOCALPOS: "रिलेटिव लोकेशन",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "एक [एंटिटी] को हमेशा [टारगेट एंटिटी] का सामना करने के लिए सेट करें. [ऑफ़सेट कोआर्डिनेट] निशाने के बिंदु और एंटिटी की स्थिति के कोआर्डिनेट में अंतर है.",
  T_38_WZY_WS_MAINWEAPONA: "मुख्य वेपन 1",
  T_38_WZY_WS_MAINWEAPONB: "मुख्य वेपन 2",
  T_38_WZY_WS_MOTIONTIME: "मूवमेंट अवधि",
  T_38_WZY_WS_MOTIONTYPE: "मूवमेंट तरीका",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "मॉडिफाइड EP",
  T_38_WZY_WS_MUSHROOMNAME: "मशरूम एंटिटी",
  T_38_WZY_WS_OBFACTION: "स्पेक्टेट फैक्सन",
  T_38_WZY_WS_OBGLOBAL: "सभी स्पेक्टेट",
  T_38_WZY_WS_OBSERVER: "स्पेक्टेटर ऑप्शन",
  T_38_WZY_WS_OBTEAM: "स्पेक्टेट टीम",
  T_38_WZY_WS_OFFSETVEC: "ऑफ़सेट कोऑर्डिनेट",
  T_38_WZY_WS_ONBUY_NAMEDESC: "ट्रिगर जब कोई खिलाड़ी इस वेंडिंग मशीन से आइटम खरीद रहा होता है. [प्लेयर एंटिटी] वह प्लेयर है जो खरीदारी करता है. [मर्चेंडाइज एंटिटी] खरीदी गई वस्तु है.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "[प्लेयर एंटिटी] द्वारा लैस होने पर ट्रिगर होता है",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "ट्रिगर होता है जब प्लेयर जंपिंग एक्शन पूरा करता है",
  T_38_WZY_WS_ONLIE_NAMEDESC: "ट्रिगर होता है जब खिलाड़ी प्रो स्थिति को पूरा करता है",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "ट्रिगर जब वेपन रीलोड होता है",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "ट्रिगर होता है जब प्लेयर्स स्प्रिंटिंग एक्शन को पूरा करता है",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "ट्रिगर होता है जब खिलाड़ी क्राउचिंग एक्शन को पूरा करता है",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "ट्रिगर जब वेपन एक यूनिट को एलिमिनेट करता है. [एलिमिनेटेड एंटिटी] वह एंटिटी है जिसे एलिमिनेट कर दिया गया था.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "ट्रिगर जब वेपन एंटिटी इकाई को नुकसान पहुंचाता है. [हिट टारगेट] वेपन एंटिटी है जिसे डैमेज पहुंचाया गया था. [डैमेज] पहुंचाया गया डैमेज है.",
  T_38_WZY_WS_OWNER: "ओनर",
  T_38_WZY_WS_PARAMLIST: "पैरामीटर लिस्ट",
  T_38_WZY_WS_PARTICALMAP: "पार्टिकल मैपिंग",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'एक [प्लेयर एंटिटी] के लिए वर्तमान इमोट को रोकें या फिर से शुरू करें. [पॉज़ या नहीं] एक बूलियन मान है. "हां" मतलब पॉज़."नहीं" मतलब रिज्यूम.',
  T_38_WZY_WS_PLAENTTRI_DESC: "ट्रिगर में एंटर करने वाले खिलाड़ी द्वारा एक्टिव किया",
  T_38_WZY_WS_PLAQUITTRI_DESC: "ट्रिगर छोड़ने वाले खिलाड़ी द्वारा एक्टिव किया",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "[प्लेयर एंटिटी] को एक बार बताये [इमोट] प्ले के लिए मजबूर करें और समाप्त होने पर मूल स्थिति पर लौटें",
  T_38_WZY_WS_PLAYSPEED: "प्लेबैक स्पीड परसेंटेज",
  T_38_WZY_WS_PREHUD_NAME: "प्रीसेट आइकॉन",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[प्लेयर एंटिटी] को मौजूदा फैक्शन छोड़ने दें",
  T_38_WZY_WS_RESETENT: "हर राउंड में कॉम्पोनेन्ट को रीसेट करें",
  T_38_WZY_WS_RESUUID: "रिसोर्स UUID",
  T_38_WZY_WS_RIMCOLOR: "बॉर्डर कलर",
  T_38_WZY_WS_RIMTEXTURE: "बॉर्डर टेक्सचर",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "जांचें कि एक [एंटिटी] कोन के अंदर है या नहीं. [सेंटर] और [रेडियस] कोन का सेंटर और रेडियस हैं. [निकाली गई रेडियस] कोन के भीतर छोटे सेक्टर की रेडियस है. ऊँचाई 3D संरचना की ऊँचाई है. [एंगल] कोन का केंद्रीय कोण है. [दिशा कोण] केंद्रीय अक्ष का दिशा वेक्टर है.",
  T_38_WZY_WS_SECTORJUD_RES: "पंखे के आकार के स्कोप चेक का रिजल्ट. यह एक बूलियन मान है.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "एक [टारगेट एंटिटी] की एक्टिविटी स्टेटस निर्धारित करें. [एक्टिविटी स्टेटस] एक बूलियन मान है और यह इकाई की उपलब्धता, विजिबिलिटी और कोलाइडेबिलिटी को प्रभावित करता है.",
  T_38_WZY_WS_SETROUNDSCORE: "प्लेयर का राउंड स्कोर सेट करें",
  T_38_WZY_WS_SHOOTANGMAX: "अधिकम शूटिंग एंगल",
  T_38_WZY_WS_SHOWMAPINFO: "एक फैक्शन के लिए मानचित्र जानकारी प्रदर्शित करें",
  T_38_WZY_WS_SHOWNAMEHUD: "एक फैक्शन के लिए HUD नाम दिखाएं",
  T_38_WZY_WS_SOUND1: "एक्सेलरेशन",
  T_38_WZY_WS_SOUND10: "स्टेज स्टार्ट",
  T_38_WZY_WS_SOUND11: "ज़ॉम्बी",
  T_38_WZY_WS_SOUND12: "हॉरर",
  T_38_WZY_WS_SOUND13: "ट्रांसफॉर्मेशन",
  T_38_WZY_WS_SOUND14: "पौंडिंग हार्ट",
  T_38_WZY_WS_SOUND15: "मीडियम हार्टबीट",
  T_38_WZY_WS_SOUND16: "स्लो हार्टबीट",
  T_38_WZY_WS_SOUND17: "रश टाइम",
  T_38_WZY_WS_SOUND18: "क्लिक",
  T_38_WZY_WS_SOUND19: "स्किल रिकवर",
  T_38_WZY_WS_SOUND2: "गायब होने की अधिसूचना",
  T_38_WZY_WS_SOUND20: "एक गेम जॉइन करें",
  T_38_WZY_WS_SOUND3: "विज़ुअल इफ़ेक्ट",
  T_38_WZY_WS_SOUND4: "नाईट चिर्प",
  T_38_WZY_WS_SOUND5: "हिट (ब्लंट)",
  T_38_WZY_WS_SOUND6: "रिएक्शन",
  T_38_WZY_WS_SOUND7: "सरप्राइज ढूंढ़ें",
  T_38_WZY_WS_SOUND8: "पिशाच",
  T_38_WZY_WS_SOUNDENT: "म्यूजिक एंटिटी",
  T_38_WZY_WS_SPAWNPOS: "पुराना स्पॉन पॉइंट",
  T_38_WZY_WS_SPHERENAME: "बेसिक स्फेयर",
  T_38_WZY_WS_SPHERERADIUS: "स्फेयर की रेडियस",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "जांचें कि क्या एक [एंटिटी] एक गोलाकार स्कोप के अंदर है. [सेंटर] और [रेडियस] गोलाकार संरचना का केंद्र और त्रिज्या है.",
  T_38_WZY_WS_SPHERICALJUD_RES: "गोलाकार स्कोप चेक का रिजल्ट. यह एक बूलियन मान है.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "जांचें कि क्या [एंटिटी] क्यूब के दायरे में है. [सेंटर] क्यूब का केंद्र है, [लंबाई], [चौड़ाई], और [ऊंचाई] क्यूब की लंबाई, चौड़ाई और ऊंचाई हैं, और [यूलर कोण] क्यूब का 3D ओरिएंटेशन के कोण है.",
  T_38_WZY_WS_SQUAREJUD_RES: "क्यूबिक स्कोप चेक का रिजल्ट. यह एक बूलियन मान है.",
  T_38_WZY_WS_STARTGENTIME: "स्पॉन स्टार्ट टाइम",
  T_38_WZY_WS_STAYTIME: "पॉज़ अवधि",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "खिलाड़ी के कैमरे को [कैमरा एंटिटी] में बदलें. [स्विच मोड] कोई एनीमेशन या प्रोग्रेसिव मूवमेंट नहीं हो सकता है. [स्विच टाइम] प्रोग्रेसिव मोड के दौरान स्विच करने का समय है.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "कैमरा मोड स्विच करें. आप नो एनिमेशन और प्रोग्रेसिव मूवमेंट के बीच चयन कर सकते हैं.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'प्रोग्रेसिव मूवमेंट मोड के दौरान स्विच समय. जब "कोई एनिमेशन नहीं" चुना जाता है, तो यह सेटिंग शून्य होती है.',
  T_38_WZY_WS_TEXTHUD: "HUD टेक्स्ट कॉम्पोनेन्ट",
  T_38_WZY_WS_TEXTTYPE: "फॉन्ट साइज",
  T_38_WZY_WS_TEXTUREID: "टेक्सचर टाइप",
  T_38_WZY_WS_TRANDIST: "मैक्स दूरी",
  T_38_WZY_WS_TWEENERENABLED: "UITweener स्क्रिप्ट चालू करें या नहीं",
  T_38_WZY_WS_TYPELIST: "टाइप लिस्ट",
  T_38_WZY_WS_TYPELISTORLIST: "टाइप या टाइप लिस्ट",
  T_38_WZY_WS_VEST_NAME: "वेस्ट एंटिटी",
  T_38_WZY_WS_VFX1: "हाइडर एलिमिनेशन",
  T_38_WZY_WS_VFX10: "साइक्लिक कम्बस्शन",
  T_38_WZY_WS_VFX11: "पॉइज़न गैस",
  T_38_WZY_WS_VFX13: "हार्ट",
  T_38_WZY_WS_VFX15: "डोर",
  T_38_WZY_WS_VFX2: "रैंपेज",
  T_38_WZY_WS_VFX3: "क्लोन एलिमिनेशन",
  T_38_WZY_WS_VFX4: "हिट फ़ीडबैक",
  T_38_WZY_WS_VFX5: "क्लोन",
  T_38_WZY_WS_VFX6: "डिस्गाइज",
  T_38_WZY_WS_VFX7: "फ़्लैशबैंग स्पार्क्स",
  T_38_WZY_WS_VFX8: "मोशन ट्रेल",
  T_38_WZY_WS_VFX9: "फायर चार्ज",
  T_38_WZY_WS_VFXENT: "VFX इंस्टैंस",
  T_38_WZY_WS_VFXTYPEA_NAME: "कस्टमाइज मैपिंग VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "नॉन-कस्टमाइज मैपिंग VFX",
  T_38_WZY_WS_VISIBILITY: "विज़िबिलिटी टाइप",
  T_38_WZY_WS_VOLUME: "वॉल्यूम",
  T_38_WZY_WS_WEAPONGEN: "वेपन जनरेटर",
  T_38_WZY_WS_WHECYCLE: "रीप्ले",
  T_38_XXJ_WS_BLOCKMODE: "ब्लॉक्ड मोड",
  T_38_XXJ_WS_CUSTOMCAMARA: "कस्टम कैमरा",
  T_38_XXJ_WS_FFCLASSIC: "क्लासिक FF (शूटिंग)",
  T_38_XXJ_WS_FOV: "फील्ड ऑफ़ व्यू",
  T_38_XXJ_WS_FOVDESC: "फील्ड ऑफ़ व्यू कैमरे से देखे जाने वाली सीमा है.",
  T_38_XXJ_WS_FPS: "फर्स्ट पर्सन (शूटिंग)",
  T_38_XXJ_WS_HORIZONTALANGLE: "होरिजॉन्टल एंगल",
  T_38_XXJ_WS_INVISICAM: "सेमी-ट्रांसपेरेंट",
  T_38_XXJ_WS_OFFSET: "ऑफ़सेट",
  T_38_XXJ_WS_ORTHOGRAPHIC: "ऑर्थोग्राफिक",
  T_38_XXJ_WS_PERSPECTIVE: "पर्सपेक्टिव",
  T_38_XXJ_WS_PROJECTIONMODE: "प्रोजेक्शन मोड",
  T_38_XXJ_WS_STABLE: "फिक्स हुआ",
  T_38_XXJ_WS_STARTCAMERA: "डिफ़ॉल्ट कैमरा",
  T_38_XXJ_WS_STARTCAMERAMODE: "डिफ़ॉल्ट कैमरा मोड",
  T_38_XXJ_WS_THIRD: "चेस कैमरा",
  T_38_XXJ_WS_TOPVIEW: "हाई एंगल",
  T_38_XXJ_WS_TPS: "थर्ड पर्सन",
  T_38_XXJ_WS_TRANSVERSE: "होरिजॉन्टल मूवमेंट",
  T_38_XXJ_WS_VERTICALANGLE: "वर्टिकल एंगल",
  T_38_XXJ_WS_ZOOM: "ज़ूम",
  T_38_XYL_WS_AISTARTTIME: "स्टार्ट टाइम (s)",
  T_38_XYL_WS_ARMORDESTROY: "आर्मर DMG गुणक",
  T_38_XYL_WS_BONFIRE: "बोनफायर",
  T_38_XYL_WS_CANDLE01: "कैंडल A",
  T_38_XYL_WS_CANNON01: "मैकेनिकल कैनन",
  T_38_XYL_WS_CLIPAMMOSIZE: "मैगज़ीन स्टोरेज",
  T_38_XYL_WS_DAMAGEDTRUCK: "डैमेज ट्रक",
  T_38_XYL_WS_DOLL01: "ईरी डॉल",
  T_38_XYL_WS_ENTERANCEHOUSE01: "ब्रिक हाउस A",
  T_38_XYL_WS_FENCE002: "आयरन फेंस B",
  T_38_XYL_WS_FIREWORK01: "फायरवर्क्स A",
  T_38_XYL_WS_GENERATOR: "जनरेटर",
  T_38_XYL_WS_GRAVITY: "ग्रेविटेशनल एक्सेलरेशन",
  T_38_XYL_WS_GRAVITYAREA: "असामान्य ग्रेव जोन",
  T_38_XYL_WS_GRAVITYAREA_DESC: "एक ज़ोन जहां प्लेयर गुरुत्वाकर्षण को बदल सकते हैं",
  T_38_XYL_WS_HOLDWEAPON: "वेपन होल्ड",
  T_38_XYL_WS_INDOORFURNITURE: "इंडोर फर्नीचर",
  T_38_XYL_WS_LIGHTTUBE001: "ट्यूब लाइट A",
  T_38_XYL_WS_LOVEBALLOON01: "वैलेंटाइन बैलून A",
  T_38_XYL_WS_LOVELAMP01: "हार्ट स्ट्रीटलाइट",
  T_38_XYL_WS_LOVESIGN01: "लव नियॉनलाइट",
  T_38_XYL_WS_OILDRUM_DAMAGE: "ऑइल बैरल डैमेज अनुपात",
  T_38_XYL_WS_OUTDOORPROPS: "आउटडोर आइटम",
  T_38_XYL_WS_PIPEANDBOX: "पाइप और कंटेनर",
  T_38_XYL_WS_PLANT: "प्लांट्स",
  T_38_XYL_WS_ROSE01: "रोज",
  T_38_XYL_WS_ROSEN: "रोज़ बुके",
  T_38_XYL_WS_SMALLBUILDING: "छोटी बिल्डिंग",
  T_38_XYL_WS_SOFA002: "सोफा B",
  T_38_XYL_WS_TOWNHOUSE01: "पुराना 2-मंजिला मकान",
  T_38_XYL_WS_TV001: "ओल्ड टीवी",
  T_38_ZP_CC_EXCHANGESTATUS: "स्टेटस",
  T_39_BQ_SKILL_NAME_VILLAIN: "क्रिमसन क्रश",
  T_39_CJ_A_BURN: "विक्ट्री ग्लिंटमार्क",
  T_39_HJ_WS_Arrow002: "एरो 2",
  T_39_HJ_WS_LIKERATE2: "{0} मि",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} मिनट",
  T_39_HJ_WS_SOUND10: "स्टेप",
  T_39_HJ_WS_SOUND11: "मिशन पूरा 1",
  T_39_HJ_WS_SOUND13: "डेंजर अलर्ट 1",
  T_39_HJ_WS_SOUND14: "डेंजर अलर्ट 2",
  T_39_HJ_WS_SOUND15: "काउंटडाउन 3",
  T_39_HJ_WS_SOUND16: "टिप साउंड",
  T_39_HJ_WS_SOUND17: "क्रो क़ॉ",
  T_39_HJ_WS_SOUND18: "गलत क्षेत्र में टेलीपोर्टिंग की आवाज",
  T_39_HJ_WS_SOUND19: "एक सही क्षेत्र में टेलीपोर्टिंग की आवाज",
  T_39_HJ_WS_SOUND2: "काउंटडाउन 1",
  T_39_HJ_WS_SOUND20: "टेलेपोर्ट",
  T_39_HJ_WS_SOUND21: "इलेक्ट्रिक शॉक",
  T_39_HJ_WS_SOUND23: "आइटम पाएं",
  T_39_HJ_WS_SOUND24: "इलेक्ट्रॉनिक & क्यूट BGM",
  T_39_HJ_WS_SOUND25: "कैज़ुअल गेम BGM",
  T_39_HJ_WS_SOUND4: "मैकेनिकल डिवाइस इको",
  T_39_HJ_WS_SOUND5: "मच्छर",
  T_39_HJ_WS_SOUND6: "डिंग डिंग डिंग 1",
  T_39_HJ_WS_SOUND7: "डिंग डिंग डिंग 2",
  T_39_HJ_WS_SOUND8: "गियर चालू किया",
  T_39_HJ_WS_SOUND9: "चार्ज 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "अनलिमिटेड ग्लू वॉल",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "अनलिमिटेड थ्रोएब्ल",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "स्पेशल फायरिंग साउंड",
  T_39_HQ_UGC_CUSTOMRES: "कस्टम रिसोर्स",
  T_39_M_ACCOUNTID: "अकाउंट",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "डबल क्लिक के बाद लागू करें",
  T_39_MF_SKILLTAG_4: "मूवमेंट",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "एक दुश्मन को नॉक डाउन करने के बाद, नॉक डाउन किए गए दुश्मन के [FFB300]{0}m[-] के भीतर दुश्मन और उनके टीममेट को मार्क करें और उनकी गति को [FFB300]{1}%[-] तक धीमा कर दें. [FFB300]{2}s[-] सेकेंड तक बना रहता है. नॉक होने पर, आस-पास के हमलावर और उसके टीममेट को मार्क करें और धीमा करें.",
  T_39_QL_SKILL_WOLFRAHH_DES: "एक दुश्मन को नॉक डाउन के बाद, हाइलाइट मोड में एंटर करें, जो फायर रेट को [FFB300]{0}%[-] और मूवमेंट स्पीड [FFB300]{1}%[-] तक बढ़ाता है लेकिन फिर जल्दी से घट जाता जाता है. [FFB300]{2}s[-] तक बना रहता है. हाइलाइट मोड के दौरान, दुश्मनों को लगातार नॉक डाउन करते हुए काउंटडाउन को रीसेट कर दिया जाएगा और फायर रेट को [FFB300]{3}%[-] और मूवमेंट स्पीड को [FFB300]{4}%[-] तक बढ़ा दिया जाएगा.",
  T_39_QL_SKILL_XAYNE_DES1: "एक्सट्रीम मोड: [FFB300]{1}s[-] के लिए [FFB300]{0} अस्थाई HP[-] पाएं. इस समय के दौरान, एचपी-हीलिंग इफ़ेक्ट [FFB300]{2}%[-] तक बढ़ जाते हैं. कूलडाउन: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "फेल हुआ",
  T_39_RW_SKILL_DESC_FORD: "डैमेज लेते समय, [FFB300]{0}s[-] के लिए [FFB300]{1} HP/s[-] पाएं. एक एक्टिव स्किल रिलीज़ करने के बाद, यह पैसिव स्किल रीसेट हो जाएगी. कूलडाउन: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "आइटम एंटिटी",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'अल्वारो "रेजब्लास्ट"',
  T_39_SY_CHARACTER_VILLAIN_N: "ऑरायन",
  T_39_SY_KATANA_FASTBREAKING23_N: "कटाना - 1001 नाईट",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "पैट स्किन: ग्रीन इम्प आर्वन",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "पैट स्किन: रॉयल टिग",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "पैट स्किन: स्कॉर्पिओ फेंग",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "मॉन्स्टर ट्रक- ग्रीन जायंट",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "टुक टुक - फ्लोरल चेरियट",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "अवेकनिंग:  [FFB300]{0}s[-] विस्फोट करने से पहले, ग्रेनेड [FFB300]{1}[-] एक्स्ट्रा ग्रेनेड में बंट जाएगा, जो इसके मूल रूप का [FFB300]{2}%[-] डैमेज देता है.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "स्प्लिट ब्लिट्ज",
  T_39_WT_WS_EMPTYMAP_TAG: "एम्प्टी स्पेस",
  T_39_WT_WS_FEMAPMODE: "मोड टाइटल",
  T_39_WT_WS_FEMAPTAG: "मैप टैग",
  T_39_WT_WS_MAPPLAYER: "प्लेयर्स की संख्या",
  T_39_WT_WS_MEDENTERNUM: "मिड-गेम जॉइन प्लेयर लिमिट",
  T_39_WT_WS_MIDENTER: "मिड-गेम जॉइनिंग",
  T_39_WT_WS_MIDENTERCOUNT: "मिड गेम जॉइन का कोटा",
  T_39_WT_WS_MIDENTERTIME1: "मिड गेम में शामिल होने की समय सीमा",
  T_39_WT_WS_MIDENTERTIME2: "मिड-गेम में शामिल होने की अवधि",
  T_39_WT_WS_MIDENTERTIMETIP: "जब मैप प्लेयर संख्या की सीमा पूरी नहीं होती है, तो मैच शुरू होने के बाद एन सेकंड के भीतर खिलाड़ियों को शामिल होने में चालू करें. N सेकंड के बाद खिलाड़ी शामिल नहीं हो सकते.",
  T_39_WT_WS_MIDENTERTIP: "चालू होने पर, प्लेयर गेम के बीच में इस मैप में शामिल हो सकते हैं",
  T_39_WT_WS_PLAYERCOUNT: "शुरुआती प्लेयर संख्या",
  T_39_WT_WS_PLAYERCOUNTTIP: "मैच शुरू होने पर खिलाड़ी संख्या. अधिक खिलाड़ी मध्य-गेम में तब तक शामिल हो सकते हैं जब तक कि यह मैप की सीमा तक नहीं पहुंच जाता.",
  T_39_WT_WS_TAG1: "फ्री फॉर ऑल",
  T_39_WT_WS_TAG10: "आसान",
  T_39_WT_WS_TAG11: "मीडियम",
  T_39_WT_WS_TAG12: "हार्ड",
  T_39_WT_WS_TAG13: "बहुत चुनौतीपूर्ण",
  T_39_WT_WS_TAG14: "एस्केप",
  T_39_WT_WS_TAG16: "वीआईपी",
  T_39_WT_WS_TAG17: "कस्टम रिसोर्स",
  T_39_WT_WS_TAG18: "पज़ल",
  T_39_WT_WS_TAG19: "रेसिंग",
  T_39_WT_WS_TAG2: "गन फाइट",
  T_39_WT_WS_TAG20: "म्यूजिक",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "एडवेंचर",
  T_39_WT_WS_TAG23: "ज़ॉम्बी हंट",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "पार्टी गेम",
  T_39_WT_WS_TAG26: "टीम डेथमैच",
  T_39_WT_WS_TAG27: "टरट डिफेंस",
  T_39_WT_WS_TAG28: "ट्रेनिंग",
  T_39_WT_WS_TAG3: "गन किंग",
  T_39_WT_WS_TAG4: "रीस्पॉन",
  T_39_WT_WS_TAG5: "स्नाइपर",
  T_39_WT_WS_TAG6: "सर्वाइवल",
  T_39_WT_WS_TAG7: "सोलो",
  T_39_WT_WS_TAG8: "हॉरर",
  T_39_WT_WS_TAG9: "कैज़ुअल",
  T_39_WT_WS_TAGMAXTIP: "{0} टैग्स तक चुनें",
  T_39_WT_WS_TAGTYPE1: "गेमप्ले टाइप",
  T_39_WT_WS_TAGTYPE2: "मैप टाइप",
  T_39_WT_WS_TAGTYPE3: "मोड टाइप",
  T_39_WT_WS_TAGTYPE4: "टीम साइज",
  T_39_WZY_WS_ACCSPEED: "एक्सेलरेशन",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "[एंटिटी] के लिए स्क्रिप्ट [स्क्रिप्ट नाम] जोड़ें",
  T_39_WZY_WS_ASC: "असेंडिंग",
  T_39_WZY_WS_ASCIGZERO: "आरोही का उपयोग करके शून्य को अनदेखा करें",
  T_39_WZY_WS_BALLISTMOVENT: "बैलिस्टिक मोशन एंटिटी",
  T_39_WZY_WS_BEUSED_NAMEDESC: "इंसिडेंट ट्रिगर होता है जब आइटम [प्लेयर एंटिटी] द्वारा इस्तेमाल किया जाता है",
  T_39_WZY_WS_BODYSCALE: "बॉडी स्केल",
  T_39_WZY_WS_BRAKETORQUE: "ब्रेक हॉर्सपावर",
  T_39_WZY_WS_CAMTRANTYPE: "कैमरा ट्रांजीशन टाइप",
  T_39_WZY_WS_CARVEHICLE: "4-व्हीलर",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "जांचें कि क्या एक बताई स्क्रिप्ट [स्क्रिप्ट नाम] [एंटिटी] में मौजूद है. (वापस मिला मान बूलियन होना चाहिए)जांचें कि क्या एक बताई स्क्रिप्ट [स्क्रिप्ट नाम] [एंटिटी] में मौजूद है. (वापस मिला मान बूलियन होना चाहिए)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "जांचें कि क्या इकाई के पास बताई स्क्रिप्ट (बूलियन) का रिजल्ट है",
  T_39_WZY_WS_COMBINEALL: "ड्यूल-वेल्डिंग (अलगअलग गन)",
  T_39_WZY_WS_COMBINESELF: "ड्यूल-वील्डिंग (सामान गन)",
  T_39_WZY_WS_CONENAME: "बेसिक कोन",
  T_39_WZY_WS_COORSYS: "कोऑर्डिनेट सिस्टम",
  T_39_WZY_WS_CRASHMAXD: "मैक्स क्रैश डैमेज",
  T_39_WZY_WS_CRASHMIND: "मिनी क्रैश डैमेज",
  T_39_WZY_WS_CRAWLSPEED: "मूवमेंट स्पीड प्रतिशत (प्रोन)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "[टारगेट एंटिटी] के लिए बैलिस्टिक मोशन बनाएं। एडिट कर सकते हैं [शुरुआती स्पीड], [एक्सेलरेशन], और [अधिकतम दूरी] टारगेट एंटिटी के लिए शुरुआती स्पीड की दिशा में जमा, और [बैलिस्टिक मोशन एंटिटी] वापस करता है.",
  T_39_WZY_WS_CRETWEEN_NAME: "इंटरपोलेशन मोशन बनाएं",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "[एंटिटी] के लिए [एट्रिब्यूट] से [टारगेट वैल्यू] तक [समय] के भीतर सुचारू रूप से चलती एंटिटी के [स्टार्ट वैल्यू] के साथ, [एंटिटी] के लिए एक इंटरपोलेशन मोशन बनाएं. [मेथड] [वन-वे], [पिंगपोंग], [साइकिल] सहित गति के तरीके को बताता है. [कर्व] गति का कर्व है. और [इंटरपोलेशन मोशन एंटिटी] गति बनाने के बाद रिटर्न कर दिया जाएगा.",
  T_39_WZY_WS_CURVE: "कर्व",
  T_39_WZY_WS_CUSTRESULT: "कस्टम मैच रिजल्ट",
  T_39_WZY_WS_CYLINDERNAME: "बेसिक सिलिंडर",
  T_39_WZY_WS_DEFAULT: "कोई एनीमेशन नहीं (डिफ़ॉल्ट)",
  T_39_WZY_WS_DESC: "डिसेंडिंग",
  T_39_WZY_WS_DIFFUSEALPHA: "सतह की पारदर्शिता",
  T_39_WZY_WS_DISCONNECT: "डिसकनेक्ट",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "प्रति से. रिकवर ऊर्जा",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "एनर्जी की खपत करें",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "मैक्स सेकंड जम्प हाइट",
  T_39_WZY_WS_ENABLEJOIN: "बीच में जॉइन करके की अनुमति",
  T_39_WZY_WS_ENDPOS: "एंड पॉइंट कोऑर्डिनेट",
  T_39_WZY_WS_ENGINETORQUE: "इंजन हॉर्सपावर",
  T_39_WZY_WS_EXPLODED: "विस्फोट डैमेज",
  T_39_WZY_WS_FEELDSPEED: "मोवेमेंट स्पीड प्रतिशत (कम की गई)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "सेंटर फ़्लैश टाइम",
  T_39_WZY_WS_FLASH_CRANGE: "सेंटर रेंज",
  T_39_WZY_WS_FLASH_EFLASHTIME: "एज फ़्लैश टाइम",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "फ़्लैशबॉम्ब हिट इफ़ेक्ट",
  T_39_WZY_WS_FLASH_RANGE: "विस्फोट रेंज",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "डेस्केन्डिंग स्पीड",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "अधिकतम ऊंचाई",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "होरिजोंटल ग्लाइड स्पीड",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "वर्टिकल ग्लाइड स्पीड",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "न्यूनतम एंड हाईट",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "मिनिमम टेक हाइट",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "सुपर हाई के बाद डिसेंट स्पीड",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "टर्निंग स्पीड",
  T_39_WZY_WS_FOLMOVENT: "पोजीशन फॉलोविंग मोशन एंटिटी",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "[Player Entity] की स्किल लिस्ट पाएं",
  T_39_WZY_WS_HB_BOOSTCD: "स्प्रिंट कूलडाउन",
  T_39_WZY_WS_HB_BOOSTDURATION: "स्प्रिंट अवधि",
  T_39_WZY_WS_HB_BOOSTINITIAL: "स्काईबोर्ड पर स्प्रिंट कूलडाउन",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "स्काईबोर्ड पर स्प्रिंट  कूलडाउन",
  T_39_WZY_WS_HB_BOOSTSPEED: "स्प्रिंट स्पीड",
  T_39_WZY_WS_HB_HOVERBCD: "स्कबोर्ड कूलडाउन",
  T_39_WZY_WS_HB_JUMPCD: "जम्प कूलडाउन",
  T_39_WZY_WS_HB_JUMPH: "स्काईबोर्ड जम्प हाइट",
  T_39_WZY_WS_HEADSCALE: "हेड स्केल",
  T_39_WZY_WS_HEADSHOTDESCALE: "हेडशॉट डैमेज कम",
  T_39_WZY_WS_INTITALSPEED: "शुरुआत स्पीड",
  T_39_WZY_WS_INVENTORYBASE: "बेसिक आइटम टाइप",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "एनर्जी कॉस्ट प्रति सेकंड",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "बेसिक होरिजॉन्टल स्पीड",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "बेसिक वर्टीकल स्पीड",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "प्रति सेकंड डैश एनर्जी कॉस्ट",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "स्प्रिंट होरिजॉन्टल स्पीड",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "स्प्रिंट दूरी",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "रश एनर्जी लागत प्रति सेकंड",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "स्प्रिंट वर्टीकल स्पीड",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "उपवर्ड एनर्जी कीमत प्रति सेकंड",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "अटैक होने लायक",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "ख़ुद से ट्रिगर होने वाला",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "साथियों द्वारा ट्रिगर किया जा सकता है या नहीं",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "ट्रिगर होने वाली गाड़ी",
  T_39_WZY_WS_LANDMINE_LIFETIME: "अवधि",
  T_39_WZY_WS_LANDMINE_STARTTIME: "एक्टिवेशन टाइम",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "ट्रिगर रेडियस",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "ट्रिगर टाइम",
  T_39_WZY_WS_LEAVE: "छोड़ें",
  T_39_WZY_WS_LIMBSCALE: "लिम्बस स्केल",
  T_39_WZY_WS_LISTLOCSTR: "लोकलाइज़ टेक्स्ट लिस्ट",
  T_39_WZY_WS_LOADRESULT_NAME: "बैटल रिजल्ट अपलोड करें",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "[प्लेयर] का बैटल रिजल्ट अपलोड करें, जिसमें [रैंक], [रिजल्ट], [स्कोर नाम], [स्कोर वैल्यू] शामिल हैं. रिजल्ट टाइप एक पूर्णांक है. 1 जीत के लिए, 2 हार के लिए, 3 बूआह के लिए, और 4 ड्रॉ के लिए.",
  T_39_WZY_WS_LOOKMOVENT: "गेज़- फॉलोइंग मोशन एंटिटी",
  T_39_WZY_WS_MAXCOUNT: "अधिकतम मात्रा",
  T_39_WZY_WS_MAXDISTANCE: "मैक्स. डिस्टेंस",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "टरट डिप्रेशन एंगल",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "टरट एंगुलर स्पीड",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "टरट एलिवेशन एंगल",
  T_39_WZY_WS_MINISENTRY_DAM: "टरट डैमेज",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "डैमेज रिडक्शन रेट",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "फायरिंग एंगल",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "टरट हिट रेट",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "टरट अटैक इंटरवल",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "मैक्स टरट नंबर",
  T_39_WZY_WS_MINISENTRY_RANGE: "टरट अटैक रेंज",
  T_39_WZY_WS_MOVEENT: "मोशन एंटिटी",
  T_39_WZY_WS_NOCOMBINE: "नॉट ड्यूल वील्डएबल",
  T_39_WZY_WS_ONCE: "एकबार",
  T_39_WZY_WS_ONDROP_NAMEDESC: "इंसिडेंट ट्रिगर होता है जब आइटम [प्लेयर एंटिटी] द्वारा ख़त्म किया जाता है",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "इंसिडेंट ट्रिगर होता है जब आइटम [प्लेयर एंटिटी] द्वारा लैस किया जाता है",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "ट्रिगर होता है जब हुक गन फायर करती है",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "लैंडमाइन एक्टिव किए जाने पर इंसिडेंट ट्रिगर होता है",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "इंसिडेंट ट्रिगर होता है जब लैंडमाइन [प्लेयर एंटिटी] द्वारा ट्रिगर की जाती है",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "एंटिटी मोशन रुकने पर ट्रिगर होता है.",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "ट्रिगर होता है जब एंटिटी रोकने के बाद फिर से शुरू होती है.",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "ट्रिगर होता है जब इकाई चलना शुरू करती है",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "इंसिडेंट ट्रिगर होता है जब आइटम [प्लेयर एंटिटी] द्वारा उठाया जाता है",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "इंसिडेंट ट्रिगर होती है जब थ्रोएबल निशाने पर आती है",
  T_39_WZY_WS_OPENATTACK: "क्या हमले को चालू करना है",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "मोशन एंटिटी या मोशन एंटिटी लिस्ट को रोकें",
  T_39_WZY_WS_PAUSESOUND_NAME: "साउंड इफ़ेक्ट रोकें",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "साउंड एंटिटी या साउंड एंटिटी लिस्ट को रोकें",
  T_39_WZY_WS_PIANOTYPE: "म्यूजिक कॉम्पोनेन्ट",
  T_39_WZY_WS_PINGPONG: "पिंगपॉन्ग",
  T_39_WZY_WS_PLAYABLELIST: "एंटिटी लिस्ट",
  T_39_WZY_WS_PLAYINGSTATUE: "स्टेटस",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "रुके हुए मोशन एंटिटी या मोशन एंटिटी लिस्ट को रीस्टोर करें. फिर से चालू करें या रीस्टार्ट करना चुन सकते हैं.",
  T_39_WZY_WS_PLAYSOUND_NAME: "साउंड इफ़ेक्ट प्ले करें",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "रुकी हुई साउंड एंटिटी यासाउंड एंटिटी लिस्ट को रिस्टोर करें. फिर से शुरू या रीस्टार्ट करना चुन सकते हैं",
  T_39_WZY_WS_PROCIRCLE_NAME: "प्रोग्रेस सर्किल",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "[शुरुआती कोऑर्डिनेट] से [डायरेक्शन] के साथ एक किरण का उत्सर्जन करता है, [दूरी] के भीतर हिट की गई पहली इकाई का पता लगाता है, और [हिट एंटिटी की लिस्ट] और [हिट कोऑर्डिनेट की सूची] लौटाता है",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "[Initial Coordinates] से [Direction] के साथ एक किरण का उत्सर्जन करता है, [Distance] के भीतर हिट की गई पहली इकाई का पता लगाता है, और [Entity Hit] और [Coordinates Hit] लौटाता है.",
  T_39_WZY_WS_REAHEALHP: "आर्मर रिकवरी वैल्यू",
  T_39_WZY_WS_REAHEALTIME: "इन-इफ़ेक्ट टाइम इंटरवेल",
  T_39_WZY_WS_RELATCOORSYS: "रिलेटिव कोऑर्डिनेट सिस्टम",
  T_39_WZY_WS_REPAIRARM: "रिपेयर किट",
  T_39_WZY_WS_REVERSE: "रिवर्स",
  T_39_WZY_WS_RIMALPHA: "किनारे की पारदर्शिता",
  T_39_WZY_WS_SCORENAME: "स्कोर नाम",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "टारगेट एंटिटी को सिग्नल भेजें, अपलोड किए गए पैरामीटर पूर्वनिर्धारित सिग्नल पैरामीटर द्वारा परिभाषित किए गए हैं. परिभाषा के समय इकाई प्रकार का चयन संबंधित संकेत स्वीकार करने वाला इवेंट जेनेरेट करेगा.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "[टारगेट एंटिटी] के लिए पोजीशन फॉलोइंग मोशन बनाएं. [टारगेट एंटिटी] [फॉलोइंग एंटिटी] का फॉलो करता है. [ऑफसेट कोऑर्डिनेट] [टारगेट एंटिटी] और [फॉलोइंग एंटिटी] के बीच कोऑर्डिनेट ऑफसेट है. [कोऑर्डिनेट सिस्टम] फॉलोइंग एंटिटी के ओरिएंटेशन के आधार पर वर्ल्ड कोऑर्डिनेट सिस्टम और रिलेटिव कोऑर्डिनेट सिस्टम का चयन कर सकते हैं. [पोजीशन फॉलोइंग मोशन एंटिटी] मोशन बनाने के बाद वापस कर दी जाएगी.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "[टारगेट एंटिटी] के लिए गेज़-फॉलोइंग मोशन बनाएँ. [टारगेट एंटिटी] [फॉलोइंग एंटिटी] का फॉलो करता है। [ऑफसेट कोऑर्डिनेट] [टारगेट एंटिटी] और [फॉलोइंग एंटिटी] के बीच कोऑर्डिनेट ऑफसेट है। [कोऑर्डिनेट सिस्टम] फॉलोइंग एंटिटी के ओरिएंटेशन के आधार पर वर्ल्ड कोऑर्डिनेट सिस्टम और रिलेटिव कोऑर्डिनेट सिस्टम का चयन कर सकते हैं. मोशन बनाने के बाद पर, [गज़-फॉलोइंग मोशन एंटिटी] पर वापस होंगे.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "गिरने से डैमेज का प्रतिशत",
  T_39_WZY_WS_SHOE_MAXENERGY: "मैक्स एनर्जी",
  T_39_WZY_WS_SKILLLIST: "स्किल लिस्ट",
  T_39_WZY_WS_SKILLTYPE: "कैरेक्टर स्किल",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "स्मोक इफ़ेक्ट अवधि",
  T_39_WZY_WS_SMOOTH: "कैमरा स्विच",
  T_39_WZY_WS_SOUNDENTL: "साउंड इफ़ेक्ट एंटिटी लिस्ट",
  T_39_WZY_WS_SOUNDENTLORSENT: "साउंड इफ़ेक्ट एंटिटी या लिस्ट",
  T_39_WZY_WS_SPRINTSPEED: "स्प्रिंट स्पीड प्रतिशत",
  T_39_WZY_WS_SQUATSPEED: "मूवमेंट स्पीड प्रति. (स्क्वाट)",
  T_39_WZY_WS_STARTCOO: "शुरुआती कोऑर्डिनेट",
  T_39_WZY_WS_STATE: "प्ले स्टेट्स",
  T_39_WZY_WS_TARGETVAL: "टारगेट वैल्यू",
  T_39_WZY_WS_THROWSPEED: "हुक फ्लाइंग स्पीड",
  T_39_WZY_WS_TOWER_PARAM10: "रोटेशन एंगल",
  T_39_WZY_WS_TOWER_PARAM11: "टरट स्टेटस",
  T_39_WZY_WS_TOWER_PARAM12: "एंटिटी ID",
  T_39_WZY_WS_TOWER_PARAM9: "अटैक टारगेट",
  T_39_WZY_WS_TOWSPEED: "प्लेयर ट्रैवेलिंग स्पीड",
  T_39_WZY_WS_TWEENCURVE_NAME: "कस्टम कर्व",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "इंटरपोलेशन मोशन के लिए कस्टम कर्व का इस्तेमाल किया जा सकता है",
  T_39_WZY_WS_TWEENENT: "इंटरपोलेशन मोशन एंटिटी",
  T_39_WZY_WS_TWEENPLAYST_NAME: "मोशन के तरीके",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "इंटरपोलेशन मोशन के तरीके",
  T_39_WZY_WS_TWEENSTYLE: "तरीका",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "[एंटिटी] के लिए स्क्रिप्ट [स्क्रिप्ट नाम] हटाएं",
  T_39_WZY_WS_UPSET_NAMEDESC: "लिस्ट एलिमेंट को रैंडम रूप दें",
  T_39_WZY_WS_VISIBLEONBACK: "पीछे दिखाई दे रहा है",
  T_39_WZY_WS_WEAPCOMBINET: "ड्यूल वेल्डिंग वेपन टाइप",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "डाउनडेड पर एक्स्ट्रा डैमेज",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "सिंगल शॉट बुलेट नंबर",
  T_39_WZY_WS_WEAREPLAY: "रीस्टार्ट मोशन?",
  T_39_WZY_WS_WORLDCOORSYS: "वर्ल्ड कोऑर्डिनेट सिस्टम",
  T_39_XXJ_WS_ADDFRIEND: "दोस्त जोड़ें",
  T_39_XXJ_WS_ALLOWZ: "प्लेयर के X- एक्सेस का मूवमेंट चालू करें",
  T_39_XXJ_WS_BLOCKMODEDESC: "कैमरे का मोशन जब कैमरे और टारगेट के बीच कोई वस्तु होती है",
  T_39_XXJ_WS_CAMERADISTANCE: "टारगेट से दूरी",
  T_39_XXJ_WS_CAMERATYPEDESC: "कई प्रकार के प्रीसेट और कस्टम कैमरा प्रदान किए जाते हैं",
  T_39_XXJ_WS_CAMERAUSER: "कैमरा यूजर",
  T_39_XXJ_WS_CURENTCAMERA: "कैमरा इस्तेमाल किया",
  T_39_XXJ_WS_DETAILS: "मैच डिटेल्स",
  T_39_XXJ_WS_FFECONOMY: "इकॉनमी",
  T_39_XXJ_WS_FOCUSTARGET: "टारगेट देखा",
  T_39_XXJ_WS_FOLLOWTARGET: "टारगेट फॉलो किया",
  T_39_XXJ_WS_GAMERESULT: "मैच रिजल्ट",
  T_39_XXJ_WS_GAMETITLE1: "मैच 1",
  T_39_XXJ_WS_GAMETITLE2: "मैच 2",
  T_39_XXJ_WS_GIFT: "गिफ़्ट",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "कैमरा का होरिजॉन्टल रोटेशन एंगल",
  T_39_XXJ_WS_INVISICAM: "पारदर्शी",
  T_39_XXJ_WS_INVISICAMDESC: "कैमरे और टारगेट के बीच की वस्तु पारदर्शी हो जाती है",
  T_39_XXJ_WS_LEFTSCORE: "लेफ्ट टीम स्कोर",
  T_39_XXJ_WS_LIKE: "लाइक",
  T_39_XXJ_WS_LOBBY: "लॉबी",
  T_39_XXJ_WS_MAINSCORENAME: "टोटल स्कोर नेम",
  T_39_XXJ_WS_MAINSCORENUM: "टोटल स्कोर नंबर",
  T_39_XXJ_WS_MAPEVALUATE: "मैप रेटिंग",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "कई टीमों का रिजल्ट",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "ऑब्जरवेशन पॉइंट ऑफसेट",
  T_39_XXJ_WS_OFFSET2DESC: "आमतौर पर प्लेयर्स की मूल स्थिति के सापेक्ष कैमरा फोकस पॉइंट की ऑफसेट को बताता है. (मतलब कैमरा प्रकार से मतलब बदलता है)",
  T_39_XXJ_WS_OFFSETDESC: "आमतौर पर खिलाड़ी की मूल स्थिति के सापेक्ष कैमरे की स्थिति के ऑफसेट को बताता है. (मतलब कैमरा प्रकार से भिन्न होता है)",
  T_39_XXJ_WS_ORTHOGONAL: "ऑर्थोगोनल",
  T_39_XXJ_WS_ORTHOGONALDESC: "कैमरा दूर और पास के टारगेट को समान साइज के रूप में चित्रित करता है",
  T_39_XXJ_WS_PERSPECTIVE: "पर्सपेक्टिव",
  T_39_XXJ_WS_PERSPECTIVEDESC: "टारगेट का निरीक्षण करने के लिए कैमरा पर्सपेक्टिव प्रोजेक्शन का उपयोग करता है",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "रेंडर करते समय कैमरा की इमेज निर्माण",
  T_39_XXJ_WS_RANK1: "टीम रैंक",
  T_39_XXJ_WS_RANK2: "प्लेयर रैंक",
  T_39_XXJ_WS_REPORT: "रिपोर्ट",
  T_39_XXJ_WS_REVIEW: "रीप्ले",
  T_39_XXJ_WS_RIGHTSCORE: "राइट टीम स्कोर",
  T_39_XXJ_WS_SCORENUM1: "स्कोर 1",
  T_39_XXJ_WS_SCORENUM2: "स्कोर 2",
  T_39_XXJ_WS_SCORENUM3: "स्कोर 3",
  T_39_XXJ_WS_SCORENUM4: "स्कोर 4",
  T_39_XXJ_WS_SCORENUM5: "स्कोर 5",
  T_39_XXJ_WS_SCORETITLELIST: "स्कोर नाम लिस्ट",
  T_39_XXJ_WS_SHARE: "शेयर करें",
  T_39_XXJ_WS_SPECTATORSWITCH: "स्पेक्टेटर",
  T_39_XXJ_WS_STABLE: "स्थिर",
  T_39_XXJ_WS_STABLEDESC: "अगर कैमरा और फॉलो की गई एंटिटी के बीच में कोई ऑब्जेक्ट है तो कैमरा स्थिर रहता है.",
  T_39_XXJ_WS_TEAMNAME1: "लेफ्ट टीम का नाम",
  T_39_XXJ_WS_TEAMNAME2: "राइट टीम का नाम",
  T_39_XXJ_WS_TEAMRANK: "टीम रैंक",
  T_39_XXJ_WS_TRANSITIONTIME: "कैमरा ट्रांजीशन टाइम",
  T_39_XXJ_WS_TRANSITIONTYPE: "कैमरा ट्रांजीशन टाइप",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "2 टीमों का रिजल्ट",
  T_39_XXJ_WS_VERTICALANGLEDESC: "कैमरा का वर्टिकल रोटेशन एंगल",
  T_39_XXJ_WS_ZOOM: "ज़ूम",
  T_39_XXJ_WS_ZOOMDESC: "अगर कैमरे और फॉलो की गई एंटिटी के बीच में कोई वस्तु है तो कैमरा ज़ूम इन करता है",
  T_39_XYL_WS_LIGHTINTENSITY: "लाइट इंटेंसिटी",
  T_39_XYL_WS_LIGHTRANGE: "लाइट रेंज",
  T_39_XYL_WS_POINTLIGHT: "पॉइंटलाइट",
  T_39_XYL_WS_WATERZONE: "कस्टम वाटर ज़ोन",
  T_40_B_DISABLE_RECONNECT: "ऑटो-रीकनेक्शन बंद करें",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "मिडनाईट जर्सी",
  T_40_CJ_T_SHUTTLECOCK_RED2: "आर्कटिक ब्लेज़ जर्सी",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "चेरी कोल जर्सी",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "सनी स्काई जर्सी",
  T_40_CJ_T_SPORTSWEAR_FIRE: "फ्लेम अप जर्सी",
  T_40_DYEING_CLEAR: "कलरिंग स्टेट्स साफ करें",
  T_40_HJ_WS_EFFECT32: "स्नीकर्स",
  T_40_HJ_WS_EFFECT33: "एक्सप्लोसन",
  T_40_HJ_WS_EFFECT34: "स्पॉनपॉइंट",
  T_40_HJ_WS_EFFECT35: "लेज़र",
  T_40_HJ_WS_EFFECT36: "गोली",
  T_40_HJ_WS_EFFECT37: "हिटइफ़ेक्ट",
  T_40_HJ_WS_EFFECT38: "फायर इफ़ेक्ट",
  T_40_HJ_WS_EFFECT43: "स्पाइडर वेब",
  T_40_HJ_WS_EFFECT44: "स्किल रिलीज करना",
  T_40_HJ_WS_SOUND69: "बॉक्स को खोलना",
  T_40_HJ_WS_SOUND70: "लेवल अप",
  T_40_HJ_WS_SOUND71: "लेवल मैक्स्ड",
  T_40_HJ_WS_SOUND72: "बटन पर टैप करना",
  T_40_HJ_WS_SOUND73: "काउंटडाउन 1",
  T_40_HJ_WS_SOUND74: "व्हिसिल",
  T_40_HJ_WS_SOUND75: "गेम ओवर",
  T_40_HJ_WS_SOUND76: "फॉरवर्ड",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "चेकपॉइंट",
  T_40_HJ_WS_SOUND79: "काउंटडाउन 2",
  T_40_HJ_WS_SOUND80: "गेम शुरू",
  T_40_HJ_WS_SOUND81: "बहुत सारे कॉइन पाये",
  T_40_HJ_WS_SOUND82: "हासिल कॉइन",
  T_40_HJ_WS_SOUND83: "कुछ कॉइन हासिल किए",
  T_40_HJ_WS_SOUND84: "गेम जॉइन किया",
  T_40_HJ_WS_SOUND85: "गिल्ड सप्लाई खोलना",
  T_40_HJ_WS_SOUND86: "हॉर्न",
  T_40_HJ_WS_SOUND87: "बॉस एलिमिनेट हुआ",
  T_40_HJ_WS_SOUND88: "वॉर चेस्ट खोलना",
  T_40_HJ_WS_SOUND89: "एक्सप्लोसिव पेंट स्किल",
  T_40_HJ_WS_SOUND90: "बुलेट हिटिंग",
  T_40_HJ_WS_SOUND91: "पेंट शील्ड स्किल",
  T_40_HJ_WS_SOUND92: "बंद बटन पर टैप करना",
  T_40_HJ_WS_SOUND93: "स्किल चार्जिंग पूरी",
  T_40_HJ_WS_SOUND95: "लेज़र स्किल",
  T_40_HJ_WS_SOUND96: "2 आइटम पाएं",
  T_40_HJ_WS_SOUND97: "गेम ओवर 2",
  T_40_HJ_WS_SOUND98: "एलिमिनेशन नोटिफिकेशन",
  T_40_HJ_WS_SOUNDTYPE_BMG: "बैकग्राउंड म्यूजिक",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "इन-मैच साउंड इफ़ेक्ट",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI विजेट साउंड इफ़ेक्ट",
  T_40_JH_WS_MAPTAG1: "कलर गेम",
  T_40_JH_WS_MAPTAG10: "कलर हाईड एन सीक",
  T_40_JH_WS_MAPTAG11: "एनिवर्सरी",
  T_40_JH_WS_MAPTAG12: "रोल प्ले",
  T_40_JH_WS_MAPTAG13: "सिमुलेशन",
  T_40_JH_WS_MAPTAG14: "ऐसमेट्रिकल",
  T_40_JH_WS_MAPTAG15: "रिसोर्स बैटल",
  T_40_JH_WS_MAPTAG16: "कार्ट एस्कॉर्ट",
  T_40_JH_WS_MAPTAG17: "ऑफिसियल मैप",
  T_40_JH_WS_MAPTAG18: "मिनी गेम",
  T_40_JH_WS_MAPTAG19: "स्पीड चैलेंज",
  T_40_JH_WS_MAPTAG2: "कलर स्प्रे",
  T_40_JH_WS_MAPTAG20: "रोगलाइक",
  T_40_JH_WS_MAPTAG3: "कलर फाइट",
  T_40_JH_WS_MAPTAG4: "कलर फाइट",
  T_40_JH_WS_MAPTAG5: "कलर प्लेग्राउंड",
  T_40_JH_WS_MAPTAG6: "प्लेग्राउंड कलर",
  T_40_JH_WS_MAPTAG7: "कलर पार्टी",
  T_40_JH_WS_MAPTAG8: "कलर पार्कोर",
  T_40_JH_WS_MAPTAG9: "स्पाइडर-वर्स पार्कोर",
  T_40_JH_WS_TAG30: "टाइकून",
  T_40_JH_WS_TAG31: "होम- रेक हैवक",
  T_40_JH_WS_TAG32: "मिस्ट्री टाउन",
  T_40_JH_WS_TAG33: "डान क्राइसिस",
  T_40_JH_WS_TAG34: "डेथ अपराइज़िंग",
  T_40_JH_WS_TAG35: "फिस्ट फ्लाइट",
  T_40_JH_WS_TAG36: "ओल्ड फैक्ट्री रूफ",
  T_40_JH_WS_UGCTOKENNAME: "क्राफ़्टलैंड टोकन",
  T_40_L_QUICKMESSAGE_MODE2: "क्लैश स्क्वाड",
  T_40_M_WS_HIS: "का",
  T_40_SP_WS_DYEING: "कलर",
  T_40_SP_WS_DYEING_AREA: "एरिया कलरिंग",
  T_40_SP_WS_DYEING_COLOR: "कलर नंबर",
  T_40_SP_WS_DYEING_COUNT: "कलरिंग काउंट",
  T_40_SP_WS_DYEING_DIR: "कलर की दिशा",
  T_40_SP_WS_DYEING_DIS: "कलरिंग दूरी",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "फिक्स्ड कलरिंग एरिया",
  T_40_SP_WS_DYEING_NORMAL: "नॉर्मल",
  T_40_SP_WS_DYEING_PLANE: "प्लेन एरिया कलरिंग",
  T_40_SP_WS_DYEING_POSITION: "कोऑर्डिनेट",
  T_40_SP_WS_DYEING_RANDOMDECAY: "रैंडम कलरिंग रेट कमी",
  T_40_SP_WS_DYEING_RANDOMRATIO: "रैंडम कलरिंग रेट",
  T_40_SP_WS_DYEING_RANGE: "कलरिंग एरिया",
  T_40_SP_WS_DYEING_STATE: "कलर स्टेट्स",
  T_40_SP_WS_FACTIONTIPS_11: "पर्पल",
  T_40_SP_WS_SHOE_CURENERGY: "मौजूदा एनर्जी",
  T_40_SW_SKILL_Name_Nanoscientist: "नैनो लाइफशील्ड",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - वैगर्स वंडर",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "अवेकन्ड अलोक",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "सोनिया",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS- वैगर्स वंडर",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - वैगर्स वंडर",
  T_40_SY_M24_PENGUIN_W_N: "M24 - वैगर्स वंडर",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - वैगर्स वंडर",
  T_40_SY_PET_PUG_N: "पग",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: '"स्पाइडर-वर्स" मूनी',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "पैट स्किन: इलेक्ट्रिक अर्वन",
  T_40_SY_PETSKIN_PUG_BLACK_N: "पैट स्किन: लेज़र आई पग",
  T_40_SY_PETSKIN_PUG_GREEN_N: "पैट स्किन: अलोहा पग",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "पैट स्किन: टाइगरस्ट्रिप पग",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - वैगर्स वंडर",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson    - वैगर्स वंडर",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP- वैगर्स वंडर",
  T_40_SY_USP45_PENGUIN_W_N: "USP - वैगर्स वंडर",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - वैगर्स वंडर",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "टेक्स्ट कंटेंट एक्टिव करें",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "प्लेसहोल्डर टेक्स्ट कंटेंट",
  T_40_W_DJMALE_AWAKENING_D: "अवेकनिंग: जबकि औरा एक्टिव है, [FFB300]{2}s[-] तक चलने वाले म्यूजिक नोट प्रत्येक [FFB300]{0}s[-] में स्किल यूजर से [FFB300]{1}m[-]पीछे छोड़ दिए जाएंगे. म्यूजिक नोट उठाने वाले टीममेट को औरा के समान इफ़ेक्ट मिलेगा.",
  T_40_W_DJMALE_AWAKENING_N: "पार्टी रीमिक्स",
  T_40_W_NURSE_D: "यूजर के सिंगल-टारगेट हीलिंग इफ़ेक्ट को (स्किल, मेड किट, हील गन, आदि) को यूजर के [FFB300]{1}m[-] के भीतर टीममेट तक  [FFB300]{0}%[-] फैलाएं.",
  T_40_WH_MP_BOXING_NAME: "बॉक्स मैच",
  T_40_WH_MP_C_PACK: "अनलॉफुल बैकपैक",
  T_40_WH_MP_EXCH_COIN: "कैश",
  T_40_WH_MP_EXCH_TEMPCOIN: "अनलॉफुलमनी",
  T_40_WH_MP_PAYCHECK: "वेज्स",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "टीममेट की मदद करने की स्पीड में [FFB300]{0}%[-] की बढ़ोतरी. कूलडाउन: [FFB300]{3}s[-]. हेल्प मिला साथी [FFB300]{1}s[-] सेकंड में [FFB300]{2} HP[-] रिकवर कर लेता है.",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "एक [FFB300]{0}m-रेडियस[-] का हीलिंग ज़ोन बनाता है. इसके अंदर, यूजर्स और साथी  [FFB300]{1} HP/s[-] रिकवर करते हैं. जरूरत पड़ने पर हेल्प अप अपने आप चालू हो जाएगा. ज़ोन [FFB300]{2}s[-] सेकेंड तक रहता है. टीममेट की मदद करने के इफ़ेक्ट को दूसरे स्किल द्वारा बढ़ाया जा सकता है. कूलडाउन: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "दिखाने का तरीका",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "कैप्सूल",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "ऊंचाई",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "रेडियस",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "स्फायर",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "हिंदी सिलीगुड़ी",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "नोटो नस्तालिक उर्दू",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF देवनागरी",
  T_40_WZY_WS_FONT_SIMPBDO: "आसान अरबी",
  T_40_WZY_WS_FONT_SUPERMARKET: "सुपरमार्केट",
  T_40_WZY_WS_ICONENTITY_COLOR: "कलर",
  T_40_WZY_WS_ICONENTITY_FILLED: "प्रोग्रेसिव",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "इमेज रिसोर्स",
  T_40_WZY_WS_ICONENTITY_NAME: "आइकॉन ऑब्जेक्ट",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "दिखाने का तरीका",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "सिंपल",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-ग्रिड",
  T_40_WZY_WS_ICONENTITY_TILED: "टाइटल",
  T_40_WZY_WS_NEWMAPTAG: "नया मैप आइकॉन",
  T_40_WZY_WS_NEWVFX1: "हालो",
  T_40_WZY_WS_NEWVFX10: "कर्स",
  T_40_WZY_WS_NEWVFX11: "फ्रीज जोन",
  T_40_WZY_WS_NEWVFX12: "कोल्ड एयर",
  T_40_WZY_WS_NEWVFX13: "स्नोफ्लैक",
  T_40_WZY_WS_NEWVFX14: "फ्लेम",
  T_40_WZY_WS_NEWVFX15: "लाइट बीम",
  T_40_WZY_WS_NEWVFX16: "जहरीली गैस का फैलाव",
  T_40_WZY_WS_NEWVFX17: "पाइजन गैस",
  T_40_WZY_WS_NEWVFX18: "एक्सप्लोसिव ब्लेज़",
  T_40_WZY_WS_NEWVFX19: "लाइट इफ़ेक्ट",
  T_40_WZY_WS_NEWVFX2: "बबल",
  T_40_WZY_WS_NEWVFX20: "स्टार",
  T_40_WZY_WS_NEWVFX3: "ऐश",
  T_40_WZY_WS_NEWVFX4: "स्टोन स्प्लैश",
  T_40_WZY_WS_NEWVFX5: "लाइन",
  T_40_WZY_WS_NEWVFX6: "फ्लिकर",
  T_40_WZY_WS_NEWVFX7: "रिंग",
  T_40_WZY_WS_NEWVFX8: "राइजिंग पार्टिकल",
  T_40_WZY_WS_NEWVFX9: "स्मोक",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "फॉन्ट साइज",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "फॉन्ट स्टाइल",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "फॉन्ट",
  T_40_WZY_WS_TEXTENTITY_NAME: "टेक्स्ट ऑब्जेक्ट",
  T_40_WZY_WS_UIFONT_LATIN: "एजेंसी FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF लैटिन",
  T_40_XXJ_WS_ACTIONHUD: "इंटरेक्शन बटन HUD कॉम्पोनेन्ट",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'क्या इसका उपयोग सीनरी में किया जा सकता है। यह केवल पढ़ने के लिए है और "पेरंट उपलब्ध है या नहीं" और "एक्टिविटी स्टेट्स".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "क्या सभी माता-पिता एक्टिव हैं. यह केवल पढ़ने के लिए है और प्लयेर्स के लिए विज़िबल नहीं है.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "पैरेंट उपलब्ध हैं या नहीं",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "दिखाएं जब ओपन स्थिति ट्रू हो, अन्यथा क्लोज हो",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'क्या यह ख़ुद पर एक्टिव हो सकता है. सीनरी में इस्तेमाल करने के लिए, आपको "सीनरी में एक्टिव या नहीं" का इस्तेमाल करना चाहिए. यह केवल पढ़ने के लिए है और API का इस्तेमाल करके कॉन्फ़िगर किया गया है.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "क्या कैमरे का कलिंग मास्क एक तय लेयर को दिखाई दे रहा है",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "एक निश्चित स्थान पर टोकन जनेरेट करें",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "प्लेयर को देने के लिए लूटने योग्य आइटम",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "खिलाड़ी का वर्तमान ओरिएंटेशन",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "दिशा",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI  एंटिटी पर हमला कर रहा है",
  T_40_XXJ_WS_AITARGET_DESCKEY: "अटैकिंग AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "संरेखित स्टाइल",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "होरिजॉन्टल अलाइन",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "वर्टिकल अलाइन करें",
  T_40_XXJ_WS_ALPHA_DESCKEY: "पारदर्शिता",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "बची गोली की संख्या",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "बची गोली",
  T_40_XXJ_WS_ANCHORMAX: "मैक्सिमम एंकर",
  T_40_XXJ_WS_ANCHORMIN: "मिनिमम एंकर",
  T_40_XXJ_WS_APOSITION_DESCKEY: "प्लेयर की मौजूदा पोजीशन",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "पोजीशन",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "आर्मर HUD स्विच",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "कॉन्फ़िगर किए एसेट ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "एसेट ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "टारगेट ऑफ़ अटैक",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "अटैक थ्रोएब्ल",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "वह एंटिटी जिस पर AI द्वारा हमला किया जा रहा है",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "टारगेट पर अटैक हुआ",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "स्पॉनपॉइंट्स के उपलब्ध कोऑर्डिनेट",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "उपलब्ध कोऑर्डिनेट",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "बॉटम इमेज",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "बैकग्राउंड",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "बैकपैक",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "बैकग्राउंड ट्रांसपेरेंसी",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "बैकग्राउंड कलर",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "बैकग्राउंड कलर",
  T_40_XXJ_WS_BGFILL_DESCKEY: "बैकग्राउंड भरना है या नहीं",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "बैकग्राउंड फिल",
  T_40_XXJ_WS_BGNAME_DESCKEY: "बैकग्राउंड का नाम",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "बैकग्राउंड नाम",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "बैकग्राउंड साइज डेल्टा",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "बैकग्राउंड साइज डेल्टा",
  T_40_XXJ_WS_BLUE: "ब्लू",
  T_40_XXJ_WS_BODY_DESCKEY: "टोरसो",
  T_40_XXJ_WS_BODY_NAMEKEY: "टोरसो",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "स्केलेटन स्केल",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "प्लेयर का स्पॉन पॉइंट",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "स्पॉन पॉइंट",
  T_40_XXJ_WS_BOTH: "दोनों में से एक",
  T_40_XXJ_WS_BUTTONNAME: "बटन कॉम्पोनेन्ट नाम",
  T_40_XXJ_WS_CAMERA_DESCKEY: "कैमरा",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "क्लाइंट कैमरे का सामना करने वाली दिशा",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "क्लाइंट कैमरे की जगह",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "क्लाइंट की कैमरा लाइन का पता लगाएं",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "कैमरा रे डिटेक्शन",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "व्यूपोर्ट के साथ मेल खाने पर ड्रैग करना बंद करें",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "फिट के बाद ड्रैग एग्जिट करें",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "गोली के आकार के अर्धवृत्तों के केंद्र के बीच की दूरी. यह गोले की त्रिज्या के दोगुने से छोटा नहीं हो सकता.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "सेल साइज",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "चाइल्ड सेल की ऊंचाई",
  T_40_XXJ_WS_CELLVALUE: "एक निश्चित सेल का कॉन्टेंट पढ़ें और एक ऑब्जेक्ट वापस पाएं",
  T_40_XXJ_WS_CENTER_DESCKEY: "वर्ल्ड कोऑर्डिनेट करता है जो मिनिमैप के सेण्टर से मेल खाता है. 0 डिफ़ॉल्ट रूप से.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "मिनीमैप सेंटर",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "बटन की पोजीशन का ऑफसेट",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "पोजीशन ऑफ़सेट",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "लोकल कोऑर्डिनेट के हिसाब से मास का सेंटर",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "मास का सेंटर",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "क्या बीच की रेखा प्रदर्शित करना है",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "मध्य रेखा दिखाएं या नहीं",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "मध्य रेखा की स्थिति [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "मिडिल लाइन पोजीशन",
  T_40_XXJ_WS_CHASERANGE: "चेज विसिनिटी",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "वह एंटिटी जिसका AI द्वारा पीछा किया जा रहा है",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "टारगेट चेज हुआ",
  T_40_XXJ_WS_CHILD_DESCKEY: "चाइल्ड एंटिटी",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "पैरेंट के चिल्ड्रन",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "वह पॉइंट जो कैमरा लाइन से टकराता है",
  T_40_XXJ_WS_CHOOSECARHUD: "HUD एंटिटी कार्ड सेलेक्ट करें",
  T_40_XXJ_WS_CLAMP_DESCKEY: "अगर पैरामीटर न्यूनतम और अधिकतम मानों के बीच संख्यात्मक सीमा के भीतर है, तो फ़ंक्शन पैरामीटर का मान लौटाएगा; यदि पैरामीटर सीमा से अधिक है, तो फ़ंक्शन अधिकतम मान लौटाएगा; यदि तर्क सीमा से कम है, तो फ़ंक्शन न्यूनतम मान लौटाएगा",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "केवल उन एंटिटी को सपोर्ट ]करता है जिनके पास ट्रांसफॉर्म कॉम्पोनेन्ट है. वर्तमान में सभी ऑब्जेक्ट के लिए कन्स्ट्रैन है.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "क्लिक एरिया का साइज",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "क्लिक साइज",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "क्लिपिंग टाइप",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "क्लिपिंग टाइप",
  T_40_XXJ_WS_CLONEENT_D: "मूल पैरेंट को रखते हुए चयनित एंटिटी और उसके प्रॉपर्टी को क्लोन करें. यदि लेवल ऑब्जेक्ट का चयन किया जाता है, तो क्रिएट लेवल ऑब्जेक्ट ब्लॉक का उपयोग किया जाएगा.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "आउटफिट की लिस्ट",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ऑउटफिट ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "आउटफिट ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "आउटफिट ID",
  T_40_XXJ_WS_COL_DESC: "पढ़ने के लिए कॉलम",
  T_40_XXJ_WS_COLNAME_DESC: "पढ़ने के लिए कॉलम का नाम.",
  T_40_XXJ_WS_COLOR_DESCKEY: "कलर",
  T_40_XXJ_WS_COLOR_NAMEKEY: "मान",
  T_40_XXJ_WS_COLOR1_DESCKEY: "RGBA कलर चैनल का उपयोग करके कलर लेयर्स जोड़ें. एक चैनल मान 0 और 255 के बीच होता है और एक Int32 में स्टोर होता है. सफेद (255, 255, 255, 255) डिफ़ॉल्ट रूप से.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "प्रोग्रेस बार का रंग",
  T_40_XXJ_WS_COLOR3_DESCKEY: "RGBA कलर चैनल का प्रकार, जो 0 से 255 तक होता है",
  T_40_XXJ_WS_COLOR4_DESCKEY: "टेक्स्ट का कलर",
  T_40_XXJ_WS_COLOR5_DESCKEY: "HUD का कलर",
  T_40_XXJ_WS_COLOR6_DESCKEY: "लाइट जा कलर",
  T_40_XXJ_WS_COLORA_DESCKEY: "A कलर वैल्यू",
  T_40_XXJ_WS_COLORB_DESCKEY: "B कलर वैल्यू",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "प्रोग्रेस बार कलर",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "कलर बैरल",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "कलर बैरल",
  T_40_XXJ_WS_COLORG_DESCKEY: "G कलर वैल्यू",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "RGBA चैनल हासिल करें",
  T_40_XXJ_WS_COLORGUN: "रेनबो स्प्रे राइफल",
  T_40_XXJ_WS_COLORGUN_01: "रेनबो स्प्रे राइफल (रेड)",
  T_40_XXJ_WS_COLORGUN_02: "रेनबो स्प्रे राइफल (येलो)",
  T_40_XXJ_WS_COLORGUN_03: "रेनबो स्प्रे राइफल (ब्लू)",
  T_40_XXJ_WS_COLORGUN_04: "रेनबो स्प्रे राइफल (ग्रीन)",
  T_40_XXJ_WS_COLORGUN_05: "रेनबो स्प्रे राइफल (पर्पल)",
  T_40_XXJ_WS_COLORR_DESCKEY: "R कलर वैल्यू",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "टेक्स्ट कलर",
  T_40_XXJ_WS_COLVALUE: "कॉलम कॉन्टेंट",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "एक सामान्य HUD स्विच की HUD एंटिटी",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "जनरल HUD स्विच की HUD एंटिटी",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "कन्सट्रैन्ट",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "कन्सट्रैन्ट",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "कन्सट्रैन्ट की संख्या",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "कन्सट्रैन्ट काउंट",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "ऑरिजिनल कॉन्टेंट",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "डिफ़ॉल्ट डायरेक्शन",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "स्क्रॉल का स्टार्टिंग पॉइंट्स. डिफ़ॉल्ट रूप से ऊपरी बाएँ कोना.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "मैप में किसी निश्चित वस्तु के लिए एक स्थिर पिक्सल जनरेट करें. पिक्सल ऑब्जेक्ट के साथ नहीं चलेगा.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "मिनिमैप आइकन बनाएं",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "टाइमस्टैम्प के लिए लोकलाइज स्ट्रिंग को परिभाषित करें",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "बताई कस्टम HUD और पैरेंट कॉम्पोनेन्ट पर एक कस्टम UI कॉम्पोनेन्ट बनाएं",
  T_40_XXJ_WS_CREEP_NAMEKEY: "क्रॉल",
  T_40_XXJ_WS_CROUCH_DESCKEY: "ट्रू होने पर दिखाएं, नहीं तो क्लोज करें",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "क्राउच",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "यह कैमरे की कलिंगमास्क रेंडर लेयर है. आप दिख रही लेयर के लेवल का इस्तेमाल करके रेंडर इकाई को फ़िल्टर कर सकते हैं.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "कलिंगमास्क",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "टॉप ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "टॉप",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "फेसपेंट ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "शू ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "जूते",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "हेड ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "हेड",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "फेसपेंट ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "मास्क",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "बॉटम ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "बॉटम",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "फेसपेंट",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "बंडल ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "वनज़ी",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "xy दिशा में ड्रैग अमाउंट",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY ड्रैग",
  T_40_XXJ_WS_DB: "टेबल वैल्यू पढ़ें",
  T_40_XXJ_WS_DB_DESC: "डेटाबेस में एक निश्चित टेबल पर एक निश्चित पहचानकर्ता के संबंधित नाम को पढ़ें.",
  T_40_XXJ_WS_DBDELETE_DESC: "डेटाबेस में एक निश्चित टेबल पर एक निश्चित पहचानकर्ता के संबंधित मान को हटाएं.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "इंडेंटिफायर",
  T_40_XXJ_WS_DBTABLENAME: "डाटाबेस टेबल नाम",
  T_40_XXJ_WS_DBTABLENAME_DESC: "डेटाबेस में टेबल का नाम.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "लिखने के लिए वैल्यू",
  T_40_XXJ_WS_DBWRITE: "टेबल वैल्यू लिखें",
  T_40_XXJ_WS_DBWRITE_DESC: "डेटाबेस में एक निश्चित टेबल पर एक निश्चित पहचानकर्ता का संगत मान लिखें.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "डिफेंस थ्रोएब्ल",
  T_40_XXJ_WS_DEFULT: "डिफॉल्ट",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "डेटाबेस में एक निश्चित लीडरबोर्ड टेबल पर एक निश्चित की (key) का संबंधित मान हटाएं.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "डेटाबेस में एक निश्चित लीडरबोर्ड टेबल पर एक निश्चित रैंक के संबंधित मान को हटाएं.",
  T_40_XXJ_WS_DEPTH: "HUD लेयर",
  T_40_XXJ_WS_DEPTH_D: "HUD की बेसिक लेयर",
  T_40_XXJ_WS_DICTANDLIST: "लिस्ट और डिक्शनरी",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "टारगेट डिक्शनरी का मान",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "सतह की पारदर्शिता",
  T_40_XXJ_WS_DIR_DESCKEY: "वेक्टर",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "एक बिंदु जो प्रदान किया जाता है और रिवाइवल पॉइंट आदि के रूप में इस्तेमाल किया जा सकता है.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "कोऑर्डिनेट",
  T_40_XXJ_WS_DISABLEALL: "सभी को चुने से हटाएं",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "कलर बंद",
  T_40_XXJ_WS_DISTANT_DESCKEY: "कैमरा लाइन का पता लगाने की दूरी",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "प्रोजेक्टिंग डिस्टेंस",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "एकाधिक ड्रैगिंग ड्रैगिंग को सपोर्ट करता है",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "ड्रैग इफ़ेक्ट",
  T_40_XXJ_WS_DRIVER_DESCKEY: "गाड़ी का ड्राइवर",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "ड्राइवर",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "मान मॉडिफाई  करें",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "डिस्प्ले स्पेशल इफ़ेक्ट",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "स्पेशल इफ़ेक्ट दिखाएं",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "इफ़ेक्ट कलर",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "स्पेशल इफ़ेक्ट एंटिटी दिखाने वाले स्पेशल इफ़ेक्टव का प्रतिनिधित्व करता है",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "स्पेशल इफ़ेक्ट ऑब्जेक्ट",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "इमोजी HUD स्विच",
  T_40_XXJ_WS_ENABLEALL: "सभी चुनें",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "लॉजिक अपडेट चालू करना है या नहीं. बंद होने पर, इस एंटिटी के ब्लॉक प्रत्येक फ़्रेम को अपडेट करना बंद कर देंगे.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "वेपन की विशेषताओं में लिखे जाने पर, वेपन के बुनियादी आँकड़े वेपन स्किन से प्रभावित होंगे",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "वेपन स्किन विशेषता लिखें",
  T_40_XXJ_WS_ENTITY_DESCKEY: "एक इकाई एक पोत है जिसमें सभी घटक होते हैं, जिन्हें एक्टिवेट होने के लिए एंटिटी में जोड़ा जाना चाहिए",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "एंटिटी टाइप",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "एक एंटिटी का मूल कॉम्पोनेन्ट. सभी कॉम्पोनेन्ट इस कॉम्पोनेन्ट को मिला देंगे.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "एंटिटी में बदलना है",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "नए जोड़े गए कस्टम UI कंट्रोल की एंटिटी का प्रतिनिधित्व करने के लिए कोड में प्रयुक्त पैरामीटर नाम. इसका सम्बंधित लोकल वेरिएबल मान नए जोड़े गए कस्टम UI कंट्रोल की एंटिटी है.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "एंटिटी वेरिएबल का नाम",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "बनाए गए आइकन की एंटिटी का प्रतिनिधित्व करने के लिए कोड में प्रयुक्त पैरामीटर नाम. इसका संबंधित लोकल वेरिएबल मान निर्मित आइकन की एंटिटी है.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP बार HUD स्विच",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "यूलर एंगल",
  T_40_XXJ_WS_FACINFECTION: "फ़ैक्शन (ड्रॉइड अपॉक्लिप्स)",
  T_40_XXJ_WS_FACINFECTION_DESC: "प्लेयर का फैक्शन. 1 = इंसान, 2 = ड्रॉयड।",
  T_40_XXJ_WS_FEMALE: "महिला",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "फइलल डायरेक्शन",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "सॉर्ट डायरेक्शन",
  T_40_XXJ_WS_FIRE_NAMEKEY: "फायर",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "फ्लोट का मान",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "फॉलो करने के लिए टारगेट एंटिटी. डिफ़ॉल्ट रूप से खाली.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "टेक्स्ट का साइज",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "फॉन्ट साइज",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "फॉन्ट स्टाइल",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "फुटबॉल ग्लू वॉल",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "फॉर्मेटिंग स्टाइल",
  T_40_XXJ_WS_FORWARD_DESCKEY: "प्लेयर की दिशा",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "टेलीपोर्ट की दिशा",
  T_40_XXJ_WS_FREE_DESCKEY: "एक कैमरा जो खिलाड़ी द्वारा कंट्रोल किया जा सकता है और स्वतंत्र रूप से चलाया जा सकता है",
  T_40_XXJ_WS_FREE_NAMEKEY: "फ्री कैमरा",
  T_40_XXJ_WS_GENDER: "जेंडर",
  T_40_XXJ_WS_GENDER_DESCKEY: "जेंडर",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "जेंडर एनम",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "कैमरे का कलिंगमास्क पाएं",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "केवल उन एंटिटी को सपोर्ट करता है जिनके पास ट्रांसफॉर्म कॉम्पोनेन्ट है. वर्तमान में सभी वस्तुओं के लिए कन्स्ट्रैंड.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "केवल उन एंटिटी को समर्थन करता है जिनके पास ट्रांसफॉर्म कॉम्पोनेन्ट है. अभी सभी वस्तुओं के लिए कन्स्ट्रैन है.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "केवल उन एंटिटी को सपोर्ट करता है जिनके पास ट्रांसफॉर्म कॉम्पोनेन्ट है. वर्तमान में सभी ऑब्जेक्ट के लिए कन्स्ट्रैनेड.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "प्लेयर की आउटफिट ID पाएं",
  T_40_XXJ_WS_GETPLAYERRANK: "प्लेयर रैंक पाएं",
  T_40_XXJ_WS_GETPLAYERRANK_D: "प्लेयर की कुल रैंक पाएं",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "प्लेयर राउंड रैंक पाएं",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "प्लेयर स्पेसिफिक राउंड रैंक पाएं",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "प्लेयर के टोकन का डाटा सर्च करें",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "प्लेयर की वेपन स्किन पाएं",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "कोऑर्डिनेट का एक सेट प्राप्त करें जो रैंडम स्पॉन पॉइंट्स द्वारा कब्जा नहीं किया गया है",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "सीनरी के लिए स्काई बॉक्स पाएं",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "एक सर्वर का रीजन पाएं",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "सर्वर का टाइमस्टैम्प पाएं",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "टीममेट के पास एक जगह पाएं, उन जगहों से बचें जहां खिलाड़ी खड़े नहीं हो सकते",
  T_40_XXJ_WS_GETTEAMRANK: "टीम रैंक पाएं",
  T_40_XXJ_WS_GETTEAMRANK_D: "टीम टोटल रैंक पाएं",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "टीम राउंड रैंक पाएं",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "टीम स्पेसिफिक राउंड रैंक पाएं",
  T_40_XXJ_WS_GREEN: "ग्रीन",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "3- डायमेंशनल शेप के आधे डायमेंशन",
  T_40_XXJ_WS_HEAD_DESCKEY: "हेड",
  T_40_XXJ_WS_HEAD_NAMEKEY: "हेड",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "हार्टबीट इफ़ेक्ट एंटिटी",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "हार्टबीट इफ़ेक्ट एंटिटी",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "द हाइट",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "हिंट बटन",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "टिप्स बटन",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "टारगेट लोकेशन  पर दिखाई होने वाली एंटिटी",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "एंटिटी टारगेट की गई",
  T_40_XXJ_WS_HITPOS_DESCKEY: "वह स्थान जो हिट हुआ",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "होरिजॉन्टल डिस्प्ले टाइप",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "होरिजॉन्टल डिस्प्ले टाइप",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "एंटिटी जो दूसरी एंटिटी को फॉलो कर रही है",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "वह एंटिटी जो दूसरी एंटिटी को देख रही है",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "हेल्थ बार HUD स्विच",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "HUD इंसर्शन एंटिटी. यह HUD है जिसे प्लेयर एडिटर से एडिट करते हैं.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "खली HUD पैनल कॉम्पोनेन्ट",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "HUD एंटिटी इससे जुड़ी है",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "HUD इंसर्शन एंटिटी. यह HUD है जिसे खिलाड़ी एडिटर का उपयोग करके एडिट करता है.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD ग्रिट कॉम्पोनेन्ट",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "HUD इंसर्शन एंटिटी. यह HUD है जिसे खिलाड़ी एडिटर का इस्तेमाल करके एडिट करता है.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD पैनल कॉम्पोनेन्ट",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "HUD इंसर्शन एंटिटी. यह HUD है जिसे प्लेयर एडिटर का उपयोग करके संपादित करता है।",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD स्क्रॉल व्यू कॉम्पोनेन्ट",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ह्यूमन मॉडल ID",
  T_40_XXJ_WS_ICON_DESCKEY: "आइकन का रिसोर्स नाम",
  T_40_XXJ_WS_ICON_NAMEKEY: "आइकॉन",
  T_40_XXJ_WS_ICON1_DESCKEY: "कोई आइकॉन चुनें",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "आइकन एंटिटी दिखाई देने वाले आइकन का प्रतिनिधित्व करती है",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "एक रिसॉर्स पाथ. बिल्ट-इन रिसोर्स इसमें है: पाथ. कस्टम रिसॉर्स बाहर है: पाथ. डिफ़ॉल्ट रूप से खाली.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "आइकॉन नाम",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "आइकॉन का नाम",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "रिसोर्स पाथ. डिफ़ॉल्ट रूप से खाली.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "क्या यह ट्रिगर्स के लिए स्कैन कर सकता है",
  T_40_XXJ_WS_INDEX_DESCKEY: "माता-पिता के अधीन बच्चे की इंडेक्स",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "शुरुआती मान [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "इन्टिजर की मान",
  T_40_XXJ_WS_IS3D: "3D साउंड इफेक्ट",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "हमेशा कैमरे के सामने",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "बोल्ड",
  T_40_XXJ_WS_ISBYORDER_D: "पता लगाएं कि खिलाड़ियों को समय के क्रम में लेवल आइटम को ट्रिगर करना चाहिए या नहीं",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "फिरएडिटर बटन है",
  T_40_XXJ_WS_ISHIT_DESCKEY: "क्या कैमरा लाइन से एंटिटी हिट होती है",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "क्या यह एक निश्चित लेयर को दिखाई देरी है",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "इटैलिक",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "चाहे स्कैन द्वारा मार्क किया गया हो",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "स्कैन किया या नहीं",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "चाहे पिन बटन द्वारा मार्क किया गया हो",
  T_40_XXJ_WS_ISTRIGGER: "ट्रिगर है",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "अंडरलाइन",
  T_40_XXJ_WS_ITEMID_DESCKEY: "सम्बंधित आइटम ID से जुड़ी एंटिटी",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "आइटम ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "आइटम ID (मौजूदा वर्शन में उपलब्ध एकमात्र वेपन ID)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "वेपन की आइटम ID",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "आइटम ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "मेट्रोपॉलीस एरिया",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "मेट्रोपॉलिस एरिया",
  T_40_XXJ_WS_JUMP_NAMEKEY: "जम्प",
  T_40_XXJ_WS_KEY_DESCKEY: "की (key) का मान",
  T_40_XXJ_WS_KEY_NAMEKEY: "की (Key)",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "पार करने के लिए की नेम. आप इसका इस्तेमाल लोकल वेरिएबल का मान पाने के लिए कर सकते हैं.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "एलिमिनेशन अकॉउंसमेंट",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "टेक्स्ट कलर",
  T_40_XXJ_WS_LANDMINEOBJ: "लैंडमाइन क्रिएशन के बाद एंटिटी",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "टकराती लेयर का मास्क. चुनी न गई लेयर स्कैन में शामिल नहीं की जाएंगी. खाली होने पर, सभी परतें स्कैन में शामिल हो जाएंगी.",
  T_40_XXJ_WS_LAYERSEDIT: "लेयर्स एडिट करें",
  T_40_XXJ_WS_LAYERSETTING: "विज़िबल लेयर सेटिंग्स",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "कैमरा लाइन डिटेक्शन की कॉलिशन लेयर",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "लेयर",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "लेआउट टाइप",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "लेआउट टाइप",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "स्कोरबोर्ड HUD कॉम्पोनेन्ट",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "स्कोरबोर्ड की HUD एंटिटी. एंटिटी की प्रॉपर्टी को मॉडिफाई करने से संबंधित UI पर दिखने वाला कॉन्टेंट प्रभावित होगा.",
  T_40_XXJ_WS_LEADERBOARDNAME: "लीडरबोर्ड नेम",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "डेटाबेस में लीडरबोर्ड टेबल का नाम.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "स्विंग करने पर एक्सेलरेशन",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "एक्सेलरेशन छोड़ दें",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "लेफ़्ट आर्म",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "लेफ्ट आर्म",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "बायां रंग",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "लेफ्ट कलर",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "क्या बाईं ओर स्पेशल इफ़ेक्ट दिखाना है",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "लेफ्ट इफ़ेक्ट दिखाएं या नहीं",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "बाया पैर",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "बाया पैर",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "लेफ्ट हैंड",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "लेफ़्ट हाथ",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "लेफ़्ट आइकॉन",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "लेफ़्ट आइकॉन",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "लेफ्ट लेग",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "बायां पैर",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "लेफ्ट स्कोर टेक्स्ट",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "लेफ़्ट स्कोर टेक्स्ट",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "लेफ्ट टेक्स्ट",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "लेफ्ट टेक्स्ट",
  T_40_XXJ_WS_LERP_DESCKEY: 't 0 और 1 के बीच में है. जब t=0, "से" रिटर्न. जब t=1, "को" रिटर्न. जब t=0.5, "से" और "को".',
  T_40_XXJ_WS_LEVELOBJECT: "स्टेज ऑब्जेक्ट",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "लाइन स्पेसिंग",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "लिस्ट में मान की तुलना करें और सबसे बड़ा रिटर्न करें",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "लिस्ट में मानों की तुलना करें और सबसे छोटा रिटर्न करें",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "लिस्ट या डिक्श",
  T_40_XXJ_WS_LOCALPOSITION: "लोकल पोजीशन",
  T_40_XXJ_WS_LOCALROTA: "लोकल इयूलर एंगल",
  T_40_XXJ_WS_LOCALROTATIONQ: "लोकल क्वाटरनियन रोटेशन",
  T_40_XXJ_WS_LOCALSACLE: "लोकल स्केल",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "लोकलाइजेशन स्विच",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "पार करने के लिए कंटेनर",
  T_40_XXJ_WS_MALE: "पुरुष",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "डिक्शनरी रिमूव करें",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "डिक्शनरी की लंबाई पता करें",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "डिक्शनरी एलिमेंट में बताई की (Key) का मान पाएं",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "डिक्शनरी में नामित की-वैल्यू पेयर को हटा दें",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "डिक्शनरी में तय की (key) का मान कॉन्फ़िगर करें",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "मिनिमैप का साइज. इसकी चौड़ाई और ऊंचाई बराबर होती है.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "मैप साइज़",
  T_40_XXJ_WS_MAPT: "डिक्श. टेम्पल",
  T_40_XXJ_WS_MAPT_D: "डिक्श. के लिए डेटा टेम्पलेट. आप कॉन्टेंट टाइप को T1 और T2 के जरिए से नामित कर सकते हैं.",
  T_40_XXJ_WS_MAPVALUE_D: "डिक्श के लिए एक डेटा कंटेनर. एलिमिनेट एक जोड़ी है जिसमें एक की (Key) और एक मान होता है.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "टारगेट डिक्शनरी",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "डिक्श",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "मास्क टाइप वह इमेज नाम है जिसका उपयोग मास्किंग करते समय किया जाता है",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "मास्क नाम",
  T_40_XXJ_WS_MASS_DESCKEY: "मास (किग्रा में)",
  T_40_XXJ_WS_MASS_NAMEKEY: "मास (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "2 मानों की तुलना करें और बड़ा मान वापस दें",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "मैक्स. लेंथ",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "अधिकतम वैल्यू",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "सबसे बड़ा कॉम्पोनेन्ट ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "मैक्स. विजेट ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "हीलिंग आइटम",
  T_40_XXJ_WS_MIN_DESCKEY: "2 मानों की तुलना करें और छोटा रिटर्न करें",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "मिनीमैप कॉम्पोनेन्ट",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "मिनी मैप पिक्सल",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "मिनीमैप आइकॉन",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "मिनीमैप",
  T_40_XXJ_WS_MINNUM_DESCKEY: "न्यूनतम मान",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "मोमेंटम का फैक्टर. मान जितना बड़ा होगा, स्क्रॉल करते समय मोमेंटम उतनी ही ज़्यादा होगी.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "मोमेंटम फैक्टर",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "मूवमेंट जॉयस्टिक",
  T_40_XXJ_WS_MRESULT_DESCKEY: "मैच रिजल्ट",
  T_40_XXJ_WS_NEWENTITY_D: "बनाने के बाद नई आइटम एंटिटी (शून्य हो सकती है)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "एक नईडिक्शनरी बनाएं",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "नई डिक्श",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "हिट का सामान्य",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD पोजीशन [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "एचयूडी की पोजीशन",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "इंडिसेस को संख्याओं में बदलने के लिए लिस्ट",
  T_40_XXJ_WS_OBJECT_DESCKEY: "वह वस्तु जिससे स्प्रे गन हिट होती है",
  T_40_XXJ_WS_OBSOLETE: "डिलीट कर दिया गया, सुरक्षा कारणों से कृपया इस ब्लॉक को बदल दें.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "डिस्प्ले की पोजीशन. जब कोई पीछा करने वाला  लक्ष्य होता है, तो यह नई स्थिति और मूल स्थिति के बीच ऑफसेट होता है. जब कोई पीछा करने वाला   लक्ष्य नहीं होता है, तो यह स्क्रीन कोऑर्डिनेट होता है (डिफ़ॉल्ट वेक्टर 3 (0) है).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "स्क्रीन के कोऑर्डिनेट (डिफ़ॉल्ट रूप से वेक्टर(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "डिस्प्ले पोजीशन. जब कोई पीछा कर रहा टारगेट होता है, तो यह नई पोजीशन और मूल पोजीशन के बीच ऑफसेट होता है. जब कोई पीछा कर रहा टारगेट नहीं होता है, तो यह स्क्रीन कोऑर्डिनेट होता है (डिफ़ॉल्ट वेक्टर 3 (0) है).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "डिस्प्ले पोजीशन (एंकर ऊपरी दाएं कोने पर है)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "होरिजॉन्टल ऑफसेट",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "होरिजॉन्टल ऑफ़सेट",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "वर्टीकल ऑफ़सेट",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "वर्टिकल ऑफ़सेट",
  T_40_XXJ_WS_OK_DESCKEY: "रूपांतरण सफल",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "इस इवेंट को ट्रिगर करें जब एंटिटी हमले के क्षेत्र में एंटर करती है",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "इस इवेंट को तब ट्रिगर करें जब एंटिटी पीछा क्षेत्र में प्रवेश करती है",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "इस इवेंट को तब ट्रिगर करें जब एंटिटी अटैक के क्षेत्र को छोड़ दे",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "इस इवेंट को ट्रिगर करें जब एंटिटी चेज विसिनिटी छोड़ देती है",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "क्लाइंट के माध्यम से कैमरा लाइन डिटेक्शन ट्रिगर करें",
  T_40_XXJ_WS_ONCOLLISION_D: "कोलाइडर कॉम्पोनेन्ट अटैच वाली एंटिटी ही इस इवेंट का समर्थन करती हैं",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "इस इवेंट को ट्रिगर करें जब स्प्रे गन एक एंटिटी को हिट करती है",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "जब फायरिंग रुकती है",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "जब कोई प्लेयर सीनरी एरिया बदलता है",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "दिखाएं जब ओपन स्टेटस ट्रू हो, अन्यथा क्लोज हो",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "ओपन स्टेट्स",
  T_40_XXJ_WS_ORANGE: "ऑरेंज",
  T_40_XXJ_WS_ORDER_DESC: "लीडरबोर्ड पर रैंक",
  T_40_XXJ_WS_ORDER1: "शुरुआती रैंक",
  T_40_XXJ_WS_ORDER2: "फिनिशिंग रैंक",
  T_40_XXJ_WS_ORIGINAL: "ओरिजिनल लॉजिक रखें",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "ओवरफ्लो तरीका",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "जब प्राथमिकता दी जाती है, तो खिलाड़ी के वेपन के गुण वेपन  के मूल गुणों को बदल देंगे",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "प्लेयर वेपन स्किन को प्राथमिकता दें",
  T_40_XXJ_WS_OWNER_DESCKEY: "वह प्लेयर जो इस एंटिटी का स्वामी है",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "यह जिस चाइल्ड सीनरी ]से संबंधित है, उसका ग्लोबल UID",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "चाइल्ड सीनरी का GUID",
  T_40_XXJ_WS_PARENT_DESCKEY: "पैरेंट एंटिटी",
  T_40_XXJ_WS_PARENT_NAMEKEY: "पैरेंट",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "पैरेंट कॉम्पोनेन्ट एंटिटी ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "मूल कॉम्पोनेन्ट की फ़ाइल ID",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "गाड़ी की सभी सवारी",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "पैसेंजर",
  T_40_XXJ_WS_PHYSICALLAYER: "फिजिकल लेयर",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "फिजिकल लेयर मैट्रिक्स",
  T_40_XXJ_WS_PHYSICALTIP1: "नाम पहले से मौजूद है",
  T_40_XXJ_WS_PHYSICALTIP2: "एक लेयर का नाम हटाएं और उसे फिजिकल लेयर मैट्रिक्स और लेयर एनम में अदृश्य बना दें, लेकिन उस लेयर के भीतर इकाई ऑब्जेक्ट प्रभावित नहीं होंगे.",
  T_40_XXJ_WS_PHYSICS: "फिजिक्स",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "लूट लिस्ट HUD स्विच",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "एक खेलने योग्य एंटिटी",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "एक एंटिटी हमेशा दूसरी एंटिटी का सामना करती है",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "एक एंटिटी दूसरी एंटिटी का फॉलो करती है",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "बुलेट ट्रेल एनीमेशन बुलेट ट्रेल का सिम्युलेटेड एनीमेशन है",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "मैसेज पाने वाला खिलाड़ी",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "प्लेयर द्वारा इस्तेमाल अवतार",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "प्लेयर द्वारा लैस आउटफिट",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "प्लेयर आउटफिट",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "प्लेयर का HUD टाइप",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "प्लेयर HUD प्रकार",
  T_40_XXJ_WS_PLAYERIDINFAC: "फैक्शन सीरियल न.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "लॉग में रिकॉर्ड करने वाला खिलाड़ी",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "कुछ निश्चित प्लेयर के टोकन खपत करें",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "प्लेयर के स्किल की लिस्ट",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "एक प्लेयर की स्थिति: जिंदा, नॉक डाउन या एलिमिनेट हुआ",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "प्लेबैक स्पीड",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "प्लेबैक स्पीड",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "उदाहरण के लिए, 1.25 का मतलब मूल स्पीड से 25% तेज़ है",
  T_40_XXJ_WS_POS_DESCKEY: "टेलीपोर्ट करने के लिए कोऑर्डिनेट",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "स्पेशल इफ़ेक्ट स्टिकर का टाइप",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "प्रेस पर कलर",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "की-वैल्यू जोड़ी पाने के लिए एक कंटेनर के ट्रैवर्सल को एक्सक्यूट करता है. एक चाइल्ड प्रोसेस शामिल है, जो लूप है.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "लूप डिक्श विजिट",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "प्रोग्रेस [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "प्रोग्रेस [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "स्किल प्रोग्रेस के लिए बटन",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "स्किल प्रोग्रेस बटन",
  T_40_XXJ_WS_QUATERNION: "क्वाटरनियन रोटेशन",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "क्विक मैसेज HUD स्विच",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "टीम लिस्ट के पास मैसेज",
  T_40_XXJ_WS_RADIUS_DESCKEY: "गोली के आकार के दो अर्धवृत्तों की त्रिज्या",
  T_40_XXJ_WS_READCELL: "A सेल पढ़ें",
  T_40_XXJ_WS_READCSV: "टेबल कंटेंट पढ़ें",
  T_40_XXJ_WS_READCSV_DESC: "पूरी टेबल के कॉन्टेंट को पढ़ें. एक द्वि-आयामी सरणी वापस मिलती है.",
  T_40_XXJ_WS_READCSVCELL: "रो # और कॉलम नाम से पढ़ें",
  T_40_XXJ_WS_READCSVCOL_DESC: "टेबल पर एक निश्चित कॉलम की कॉलम पढ़ें. एक ऐरे देता है।",
  T_40_XXJ_WS_READCSVROW_DESC: "लिस्ट पर एक निश्चित रो को कॉन्टेंट पढ़ें. एक ऐरे देता है.",
  T_40_XXJ_WS_READLEADERBOARD: "लीडरबोर्ड वैल्यू पढ़ें",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "डेटाबेस में एक लीडरबोर्ड टेबल पर एक निश्चित पहचानकर्ता के संबंधित मान को पढ़ें.",
  T_40_XXJ_WS_READLEADERBOARD2: "रैंक रेंज अनुसार पढ़ें",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "डेटाबेस में लीडरबोर्ड पर एक निश्चित रैंक से एक निश्चित रैंक के बीच के अंतर का मान पढ़ें.",
  T_40_XXJ_WS_RED: "रेड",
  T_40_XXJ_WS_RELOAD: "रीलोड",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "दिखाने का तरीका",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "प्लेयर की डिफ़ॉल्ट आउटफिट रिस्टोर करें",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "प्लेयर के डिफ़ॉल्ट वेपन स्किन को रिस्टोर करें",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "क्या ड्रैगिंग व्यूपोर्ट तक सीमित है. डिफ़ॉल्ट रूप से चयनित.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "ड्रैग को रोकें या नहीं",
  T_40_XXJ_WS_RESULT_DESCKEY: "रीड का रिजल्ट",
  T_40_XXJ_WS_RESULT_NAMEKEY: "रिजल्ट",
  T_40_XXJ_WS_RESULT1_DESCKEY: "लिस्ट में सबसे बड़ी संख्या ढूंढनी है या नहीं",
  T_40_XXJ_WS_RESULT2_DESCKEY: "क्या लिस्ट में सबसे छोटी संख्या का पता लगाना है",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "लिस्ट में सबसे छोटे नंबर को ढूंढ़ें",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "किसी लिस्ट में सबसे बड़ी संख्या ज्ञात कीजिए",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "एक प्लेयर का रिवाइवल पॉइंट. अगर कोई चेकपॉइंट नहीं हैं, तो एक स्पॉनपॉइंट का इस्तेमाल करें.नहीं तो  चेकपॉइंट का इस्तेमाल करें.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "रिवाइवल पॉइंट",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "दाहिना हाथ",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "राइट आर्म",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "राइट कलर",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "राइट कलर",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "क्या दाईं ओर स्पेशल इफ़ेक्ट दिखाना है",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "राइट इफ़ेक्ट दिखाएं करें या नहीं",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "दाहिना पैर",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "राइट फुट",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "दायां हाथ",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "दायां हाथ",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "राइट आइकॉन",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "राइट आइकॉन",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "दायां पेअर",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "दायां पैर",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "राइट स्कोर टेक्स्ट",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "राइट स्कोर टेक्स्ट",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "राइट टेक्स्ट",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "राइट टेक्स्ट",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "कठोर बॉडी प्रकार का कॉम्पोनेन्ट",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "रिजिड बॉडी कॉम्पोनेन्ट",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "कठोर बॉडी के प्रकार का एनम",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "कठोर बॉडी प्रकार एनम",
  T_40_XXJ_WS_ROW_DECS: "पढ़ने के लिए रो.",
  T_40_XXJ_WS_ROWVALUE: "रौ कंटेंट",
  T_40_XXJ_WS_SCALE_DESCKEY: "ऑब्जेक्ट के ज़ूम स्केल को कॉन्फ़िग करें",
  T_40_XXJ_WS_SCALE_NAMEKEY: "स्केल",
  T_40_XXJ_WS_SCALE0_DESCKEY: "दुनिया में कोऑर्डिनेट सीरीज का ज़ूम स्केल",
  T_40_XXJ_WS_SCALE1_DESCKEY: "जूम स्केल. 1 डिफ़ॉल्ट रूप से.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "स्केल वैल्यू",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "एरिया का नाम",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "स्कोरबार",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "स्कोर बार",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "कई स्क्रॉलिंग दिशा को सपोर्ट करता है",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "स्क्रॉल डायरेक्शन",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "स्क्रॉल का कारक. मान जितना बड़ा होगा, स्क्रॉलिंग उतनी ही तेज होगी.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "स्क्रॉल फैक्टर",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "कैमरे का कलिंग मास्क कॉन्फ़िग करें",
  T_40_XXJ_WS_SETGLOBAL: "गोबल सेट करें",
  T_40_XXJ_WS_SETPARENT_D: "केवल उन एंटिटी का समर्थन करता है जिनके पास ट्रांसफॉर्म घटक है",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "किसी प्लेयर के आउटफिट ID को कॉन्फ़िग करें",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "कई खिलाड़ी आउटफिट को मॉडिफाई करें",
  T_40_XXJ_WS_SETPLAYERFORWAR: "प्लेयर डायरेक्शन सेट करें",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "किसी प्लेयर के HUD स्विच को कॉन्फ़िग करें",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "प्लयेर की वेपन स्किन को कॉन्फ़िगर करें",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "टारगेट की जगह पर एंटिटी को दिखाना है या नहीं",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "टारगेट पर एंटिटी दिखाएं",
  T_40_XXJ_WS_SHOWPLAYER: "डिस्प्ले एंटिटी",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "सिंगल- प्लेयर मैच डिटेल्स HUD एंटिटी",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "सिंगल-प्लेयर मैचों के लिए एक HUD एंटिटी. एंटिटी की प्रॉपर्टी को मॉडिफाई करने से संबंधित UI पर दिखने वाला कॉन्टेंट प्रभावित होगा.",
  T_40_XXJ_WS_SIZEDELTA: "एंकर बॉक्स और कॉम्पोनेन्ट का साइज डेल्टा",
  T_40_XXJ_WS_SKELETON: "स्केलेटन",
  T_40_XXJ_WS_SKELETON_D: "पिवट, स्केलेटन तक पहुँचने के लिए इस्तेमाल किया जाता है",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "स्केलेटन पार्ट",
  T_40_XXJ_WS_SKILLBUTTONHUD: "स्किल बटन HUD एंटिटी",
  T_40_XXJ_WS_SLOT_DESCKEY: "वेपन का स्लॉट",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "चुने जाने पर, ड्रैग करने पर धीमी गति होगी. न चुनने पर, ड्रैगिंग माउस की गति से मेल खाती है.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "स्मूथ मोशन या नहीं",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "सॉफ्टनेस",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "सॉफ्टनेस",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "साउंड एंटिटी",
  T_40_XXJ_WS_SPACE_DESCKEY: "स्पेस",
  T_40_XXJ_WS_SPACE_NAMEKEY: "चाइल्ड सेल स्पेसिंग",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "AI के स्पॉनपॉइंट के कोऑर्डिनेट",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "स्पॉन पॉइंट कोऑर्डिनेट",
  T_40_XXJ_WS_SPEED_DESCKEY: "स्पीड",
  T_40_XXJ_WS_SPEED_NAMEKEY: "स्पीड",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "स्प्रिंट",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "वृत्त की त्रिज्या",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "स्प्रे का कलर",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "स्प्रे कलर",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "स्प्रे रिजल्ट",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "स्प्रे रिजल्ट",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "स्प्रे गन (असॉल्ट राइफल)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "स्प्रे राइफल",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "शुरुआती स्पीड",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "फ्लिप स्टीकर",
  T_40_XXJ_WS_SPRITEID: "स्प्राइट एसेट ID",
  T_40_XXJ_WS_SPRITEID_D: "स्प्राइट एसेट का वर्णन करने के लिए इस्तेमाल की जाने वाली ID",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "स्टीकर टाइप",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "टारगेट एंटिटी एक स्थिर पिक्सेल में उत्पन्न करने के लिए",
  T_40_XXJ_WS_STARTPOSITION_D: "शेप के ज्योमेट्री सेंटर के कोऑर्डिनेट",
  T_40_XXJ_WS_STAY_D: "चाइल्ड की वर्तमान विश्व स्थिति, रोटेशन और स्केलिंग को बनाए रखें? यह आम तौर पर सही पर सेट होता है, और इस विकल्प के लिए UI सेटिंग्स अप्रभावी होती हैं.",
  T_40_XXJ_WS_STRING_NAMEKEY: "स्ट्रिंग",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "किसी स्ट्रिंग को फ्लोट में बदलता है",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "एक स्ट्रिंग को पूर्णांक में बदलें",
  T_40_XXJ_WS_STYLE_DESCKEY: "इंटरपोलेशन की प्ले मेथड. विकल्पों में एक बार खेलना, लूप करना और फिर से खेलना शामिल है.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "प्लेयर का एरिया स्विच करें",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "मान स्विच करें",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "प्लेयर के स्लॉट के अनुसार वेपन बदलें",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "आइटम स्लॉट स्विच करें",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "आइटम स्विच",
  T_40_XXJ_WS_TABLENAME_DESC: "टेबल नाम के रूप में दिखाया गया लेकिन वास्तव में UID है",
  T_40_XXJ_WS_TABLEVALUE: "टेबल कॉन्टेंट",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "टैग्स की लिस्ट",
  T_40_XXJ_WS_TARGET_DESCKEY: "मैप पिक्सल जनरेट करने के लिए टारगेट एंटिटी. डिफ़ॉल्ट रूप से खाली.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "मैप पिक्सेल बनाने के लिए एंटिटी",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "अटैक टारगेट",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "टारगेट एंटिटी",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "एंटिटी",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "वह एंटिटी जहां कस्टमाइज फ़ंक्शन स्थित है",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "वह एंटिटी जिस पर AI द्वारा हमला किया जाता है",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "फॉलो करने के लिए टारगेट एंटिटी",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "आइटम एंटिटी (खाली रह सकती है)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "देखने के लिए टारगेट एंटिटी",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "एंटिटी को रोकने की साउंड",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "रोकने के बाद बजने वाली साउंड एंटिटी",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "हटाने के लिए साउंड एंटिटी",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "टीममेट की जानकारी",
  T_40_XXJ_WS_TELEPORTA_D: "प्लेयर को निर्धारित दिशा के साथ तय स्थान पर टेलीपोर्ट करें",
  T_40_XXJ_WS_TEXT_NAMEKEY: "टिप टेक्स्ट",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "नोटिफिकेशन टेक्स्ट कलर",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "टेक्स्ट एंटिटी डिस्प्ले होने वाले टेक्स्ट का रिप्रेजेंट करती है",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "दिखने  के लिए टेक्स्ट के (keys)",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "टेक्स्ट की (Key)",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "टाइमस्टाम्प",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "लोकलाइज स्ट्रिंग को दिखाने की स्टाइल",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "टाइमस्टैम्प डिस्प्ले स्टाइल",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "टाइमस्टैम्प के लिए लोकलाइज़ स्ट्रिंग",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "लोक स्ट्रिंग टाइमस्टाम्प",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "हिंट",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "टिप",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "लूटने योग्य आइटम की मात्रा",
  T_40_XXJ_WS_TOKENID_DESCKEY: "लूटे जाने योग्य आइटम की ID",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "एक प्लेयर की टो स्पीड",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "ट्रांसलेशन टाइप",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "प्रक्षेप एनीमेशन एंटिटी",
  T_40_XXJ_WS_TYPE_DESCKEY: 'इस वर्णन का प्रकार है. "टाइपऑफ़" अपना प्रकार वापस देगा.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "कठोर बॉडी का प्रकार",
  T_40_XXJ_WS_TYPE2_DESCKEY: "विभिन्न प्रकार की कठोर बॉडी के अलग-अलग काम होते हैं",
  T_40_XXJ_WS_TYPE3_DESCKEY: "मौजूदा वर्शन में सिर्फ़ मूल मुद्राएं काम करती हैं",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "मिनिमैप डेप्थ डिस्प्ले को चालू करना है या नहीं",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "गहराई मैप का इस्तेमाल करें",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "क्या यह गुरुत्वाकर्षण के नियम का पालन करता है",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "ग्रेविटेशनल या नहीं",
  T_40_XXJ_WS_UUID_DESCKEY: "एक खिलाड़ी की अद्वितीय पहचानकर्ता",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "मान",
  T_40_XXJ_WS_VALUE_NAMEKEY: "मान",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "मान [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "पहला मान",
  T_40_XXJ_WS_VALUE2_DESCKEY: "दूसरा मान",
  T_40_XXJ_WS_VALUE6_DESCKEY: "वैल्यू [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "शुरुआती मान",
  T_40_XXJ_WS_VALUEB_DESCKEY: "टारगेट वैल्यू",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "पार करने के लिए की नेम. आप इसका इस्तेमाल लोकल वेरिएबल का मान पाने के लिए कर सकते हैं.",
  T_40_XXJ_WS_VALUET_DESCKEY: "इंटरपोलेशन प्रोग्रेस. 0 और 1 के बीच में है.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "वेरिएबल टाइप",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "वर्टिकल डिस्प्ले टाइप",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "वर्टिकल डिस्प्ले टाइप",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "किसी वस्तु की विजिबिलिटी का लेवल",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "दिखाई दे रही लेयर",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "आउटफिट में बंडल, हेड, मास्क, फेसपेंट, टॉप, बॉटम और शूज शामिल हैं",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "आउटफिट टाइप",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "आउटफिट स्लॉट",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "वेपन्स",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "वेपन स्किन ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "वेपन स्किन ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "वेपनस्किन की आईडी",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "प्लेयर की वेपन स्किन",
  T_40_XXJ_WS_WIDGETTYPEENUM: "कॉम्पोनेन्ट टाइप एनम",
  T_40_XXJ_WS_WIDTH_DESCKEY: "चौड़ाई",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "वर्ड रैप",
  T_40_XXJ_WS_WRITELEADERBOARD: "लीडरबोर्ड का मान लिखें",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "डेटाबेस में एक निश्चित लीडरबोर्ड टेबल पर एक निश्चित की key) का संगत मान लिखें.",
  T_40_XYL_WS_BUMPERFACTORY: "बम्पर कार फैक्ट्री",
  T_40_XYL_WS_BURNDAMAGE: "दहन डैमेज",
  T_40_XYL_WS_BURNINTERVAL: "दहन डैमेज अंतराल (s)",
  T_40_XYL_WS_BURNTIME: "विस्फोट के बाद दहन का समय",
  T_40_XYL_WS_COLORFULSKY: "कलरफुल स्काई",
  T_40_XYL_WS_CRANEMACHINE: "क्लॉ क्रेन",
  T_40_XYL_WS_CRASHMAXDAMAGE: "अधिकतम क्रैश डैमेज",
  T_40_XYL_WS_CRASHMAXSPEED: "अधिकतम क्रैश डैमेज स्पीड लिमिट",
  T_40_XYL_WS_CRASHMESS: "क्रैश के दौरान मास पैरामीटर",
  T_40_XYL_WS_CRASHMINDAMAGE: "न्यूनतम क्रैश डैमेज",
  T_40_XYL_WS_DISPLAYBOARD: "बिलबोर्ड",
  T_40_XYL_WS_EXPLODEDAMAGE: "विस्फोट डैमेज",
  T_40_XYL_WS_EXPLODEDELAY: "विस्फोट विलंब समय",
  T_40_XYL_WS_EXPLODERANGE: "एक्सप्लोसन रेंज",
  T_40_XYL_WS_FERRISWHEEL: "फेरिस व्हील",
  T_40_XYL_WS_FOODTRUCK002: "फ़ूड ट्रक B",
  T_40_XYL_WS_GEARSHIFTDELAY: "गियर बदलने का समय (s)",
  T_40_XYL_WS_ICAROUSEL001: "मेरी-गो राउंड कॉम्पोनेन्ट A",
  T_40_XYL_WS_ICAROUSEL002: "मेरी-गो-राउंड कॉम्पोनेन्ट B",
  T_40_XYL_WS_ICAROUSEL003: "मेरी-गो-राउंड",
  T_40_XYL_WS_ICEDANCEDOOL: "ब्लू डॉल",
  T_40_XYL_WS_IDLEBRAKEINPUT: "अनकंट्रोल पार्किंग हॉर्स पावर अनुपात",
  T_40_XYL_WS_LOLLIPOP: "जाइंट लॉलीपॉप",
  T_40_XYL_WS_NEWHOOKGUN: "सुपर हुक गन",
  T_40_XYL_WS_OPENSWING: "स्विंग बटन",
  T_40_XYL_WS_OPENTRACTION: "टो बटन",
  T_40_XYL_WS_PODIUM: "पोडियम",
  T_40_XYL_WS_SKYCITY: "सिटी",
  T_40_XYL_WS_SKYSCRAPER_A001: "स्काईस्क्रैपर A कॉम्पोनेन्ट A",
  T_40_XYL_WS_SKYSCRAPER_A002: "स्काईस्क्रैपर A कॉम्पोनेन्ट B",
  T_40_XYL_WS_SKYSCRAPER_A003: "स्काईस्क्रैपर A कॉम्पोनेन्ट C",
  T_40_XYL_WS_SKYSCRAPER_B001: "स्काईस्क्रैपर B कॉम्पोनेन्ट A",
  T_40_XYL_WS_SKYSCRAPER_B002: "स्काईस्क्रैपर B कॉम्पोनेन्ट B",
  T_40_XYL_WS_SKYSCRAPER_B003: "स्काईस्क्रैपर B कॉम्पोनेन्ट C",
  T_40_XYL_WS_SKYSCRAPER_C001: "स्काईस्क्रैपर C कॉम्पोनेन्ट A",
  T_40_XYL_WS_SKYSCRAPER_C002: "स्काईस्क्रैपर C कॉम्पोनेन्ट B",
  T_40_XYL_WS_SKYSCRAPER_C003: "स्काईस्क्रैपर C कॉम्पोनेन्ट C",
  T_40_XYL_WS_SKYSCRAPER_D001: "स्काईस्क्रैपर D कॉम्पोनेन्ट A",
  T_40_XYL_WS_SKYSCRAPER_D002: "स्काईस्क्रैपर D कॉम्पोनेन्ट B",
  T_40_XYL_WS_SKYSCRAPER_D003: "स्काईस्क्रैपर D कॉम्पोनेन्ट C",
  T_40_XYL_WS_SKYSCRAPER_E001: "स्काईस्क्रैपर E कॉम्पोनेन्ट A",
  T_40_XYL_WS_SKYSCRAPER_E002: "स्काईस्क्रैपर E कॉम्पोनेन्ट B",
  T_40_XYL_WS_SKYSCRAPER_E003: "स्काईस्क्रैपर E कॉम्पोनेन्ट C",
  T_40_XYL_WS_STEERANGLE: "हाई-स्पीड टर्निंग रेडियस",
  T_40_XYL_WS_STEERSPEED: "हाई-स्पीड टर्निंग के दौरान अधिकतम गति",
  T_40_XYL_WS_SWINGSPEED: "स्विंग स्पीड",
  T_40_XYL_WS_TARGETOBJECT: "मोशन एंकर",
  T_40_XYL_WS_TRACTIONSPEED: "टो स्पीड",
  T_40_XYL_WS_TRIGGERCAPSULE: "कस्टम कैप्सूल ट्रिगर",
  T_40_XYL_WS_TRIGGERSPHERE: "कस्टम स्फीयर ट्रिगर",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "कस्टम ऑब्जेक्ट",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "एक खाली ऑब्जेक्ट कॉम्पोनेन्ट जिसका इस्तेमाल रेंडर घटक और कोलिजन कॉम्पोनेन्ट के साथ किया जा सकता है.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "कस्टम रेंडर कॉम्पोनेन्ट",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "एक कस्टम रेंडरिंग घटक, जिसका उपयोग कस्टम मॉडल रिसोर्स के साथ रेंडरिंग के लिए किया जाता है.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "आपके दुश्मन मार्किंग का भरपूर मूल्य है. सहयोगी टीम का कोई भी व्यक्ति जो मार्किंग दुश्मन को ख़त्म करता है, उसे [FFB300]{0} इन-मैच मुद्रा[-] अर्जित होगी। आप किसी दुश्मन को ख़त्म करने के लिए अतिरिक्त [FFB300]100[-] पाएं. BR मैचों में कॉइन मशीनों से अतिरिक्त [FFB300]{1} FF कॉइन[-] पाएं.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "मनी मार्क",
  T_41_CJ_A_ESPORTS_TH: "FFTC द प्रो (मास्क)",
  T_41_CJ_B_ESPORTS_TH: "FFTC द प्रो (बॉटम)",
  T_41_CJ_H_ESPORTS_TH: "FFTC द प्रो (हेड)",
  T_41_CJ_S_ESPORTS_TH: "FFTC द प्रो (जूते)",
  T_41_CJ_T_ESPORTS_TH: "FFTC द प्रो (टॉप)",
  T_41_CJ_T_FFSI: "FFSI चैंपियन जर्सी",
  T_41_CJ_T_FOOTBALL_EU01: "सनबर्स्ट जर्सी",
  T_41_CJ_T_FOOTBALL_EU02: "बोल्ड रेड जर्सी",
  T_41_CJ_T_FOOTBALL_EU03: "मैजेस्टिक क्राउन जर्सी",
  T_41_CJ_T_FOOTBALL_EU04: "रीगल टाइटन जर्सी",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "सूज़ी",
  T_41_LXW_TabName_Items: "आइटम",
  T_41_R_CD_COIL: "ज़ोन सिकुड़ना",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "इस डिवाइस को एक्टिव करना है या नहीं",
  T_41_SJ_WS_SPECIALITEM_NAME: "डिवाइस",
  T_41_SW_SKILL_DESC_DELIVERY: "जब [FFB300]{0}m[-] के भीतर से दुश्मन द्वारा हमला किया जाता है, तो उस हमलावर को [FFB300]{1}s[-] के लिए मार्क किया जाता है (इंटेल को टीममेट के साथ शेयर किया जाता है). अधिकतम. [FFB300]{2} मार्किंग[-]",
  T_41_SW_SKILL_DESC_GANGLEADER: "मैच की शुरुआत में [FFB300]{0}एक्स्ट्रा शील्ड पॉइंट्स[-] पाएं. कॉम्बैट सर्वाइव करने के बाद शील्ड पॉइंट्स रिकवर करें.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "एक्टिव स्किल का इस्तेमाल करते समय, ख़ुद और टीम के साथियों को [FFB300]{0}m[-] के भीतर [FFB300]{1} शील्ड पॉइंट[-] देती है. [FFB300]{2}s[-] के बाद शील्ड पॉइंट कम हो जाते हैं, जिसके बाद खिलाड़ी फिर से इफ़ेक्ट पा सकते हैं. कूलडाउन:  [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "लगाई ग्लू वॉल्स हिट होने पर प्रति सेकंड [FFB300]{0}[-] ड्यूरेबिलिटी को रिस्टोर करती है, जिसके दौरान [FFB300]{1}m[-] के भीतर टीम के साथी [FFB300]{2} HP/s[-] को बहाल करते हैं. अधिकतम [FFB300]{3} HP[-] प्रत्येक ग्लू वॉल से प्रति टीममेट.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "पैट स्किन: रीकलेक्टिव कैक्टस",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "पैट स्किन: इंक्ड फैल्को",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "टाइप",
  T_41_WT_SKILL_DESC_FIREBOY: "[FFB300]{0} सेकंड[-] तक रहने वाली [FFB300]{1} मीटर[-] चौड़ी आग की स्क्रीन तैनात करता है, जो [FFB300]{2} मीटर/सेकंड[-] की स्पीड से आगे बढ़ती है और अधिकतम [FFB300]{3} सेकंड[-] तक चलती है. प्रभाव के दौरान स्किल को दोबारा इस्तेमाल करके स्क्रीन को रोका जा सकता है. [FFB300]दुश्मन (या ग्लू वॉल्स)[-] जो इसके संपर्क में आते हैं, उन्हें तुरंत [FFB300]{4} (या {5}) डैमेज[-] मिलेगा, और उसके बाद उन्हें [FFB300]{6} (या {7}) डैमेज[-]/सेकंड मिलेगा। यह असर [FFB300]{8} सेकंड[-] तक चलेगा. कूलडाउन: [FFB300]{9} सेकंड[-]. अधिकतम [FFB300]{10}[-] स्किल यूज़ स्टोर किए जा सकते हैं, हर यूज़ के बीच [FFB300]{11} सेकंड[-] का कूलडाउन होगा.",
  T_41_WT_SKILL_NAME_FIREBOY: "फ्लेम मिराज",
  T_41_WZY_WS_CHARGEMAX: "अधिकतम ग्लू मेकर चार्ज",
  T_41_WZY_WS_CROSSBOWNAME: "क्रॉसबो",
  T_41_WZY_WS_DECELERATIONRATIO: "पानी में % मंदी",
  T_41_WZY_WS_DEICEWALLPARAM1: "मेल्ट एरिया की रेडियस",
  T_41_WZY_WS_DEICEWALLPARAM2: "मेल्ट होने की अवधि",
  T_41_WZY_WS_EXPPERCHIP: "ग्लू चिप से EXP",
  T_41_WZY_WS_EXPPERDAMAGE: "DMG देने से EXP",
  T_41_WZY_WS_EXPPERMOVEMILE: "हर मीटर ट्रैवेल से EXP",
  T_41_WZY_WS_EXPPERSECOND: "EXP  प्रति सेकंड",
  T_41_WZY_WS_GRENADEEXPTIME: "धमाके में देरी",
  T_41_WZY_WS_GRENADELAUNCHNAME: "एक्सप्लोसिव",
  T_41_WZY_WS_GRENADEMAX: "अधिकतम DMG",
  T_41_WZY_WS_GRENADEMIN: "न्यूनतम DMG",
  T_41_WZY_WS_GRENADERANGE: "धमाके की रेंज",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "व्हीकल पर DMG गुणांक",
  T_41_WZY_WS_GRENADERATIOSELF: "सेल्फ पर DMG गुणांक",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "टीममेट पर DMG गुणांक",
  T_41_WZY_WS_GRENADTHROWSPEED: "एक्सप्लोसिव की ट्रैवेल स्पीड",
  T_41_WZY_WS_HANDCANNONNAME: "हैंड कैनन",
  T_41_XXJ_WS_ACCELERATION: "एक्सेलरेशन",
  T_41_XXJ_WS_ACCELERATION_D: "एक तय एक्सेलरेशन इफ़ेक्ट बनाएँ",
  T_41_XXJ_WS_ACTION: "एक्शन नोड",
  T_41_XXJ_WS_ACTION_D: "एक्शन पिवट",
  T_41_XXJ_WS_ADDHP: "हीलिंग आइटम्स",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "मैक्स HP जोड़ें",
  T_41_XXJ_WS_AICASTSKILL_D: "AI स्किल रिलीज़ करता है",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "ऐम असिस्ट कंट्रोल",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "ऐम असिस्ट दूरी",
  T_41_XXJ_WS_AIMASSISTENTITY: "ऐम असिस्ट एंटिटी",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "वह एंटिटी जिसे ऐम असिस्ट किया जा सकता है",
  T_41_XXJ_WS_AISKILLTYPE: "ज़ॉम्बी स्किल टाइप",
  T_41_XXJ_WS_AISKILLTYPE_D: "ज़ॉम्बी स्किल टाइप",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "सभी आइटम",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "सभी आइटम",
  T_41_XXJ_WS_AMMOCLIPSIZE: "मॉडिफाई मैगज़ीन साइज",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "मैगज़ीन में बुलेट",
  T_41_XXJ_WS_ANCHORPOSITION_D: "एंकर पैरेंट के संबंध में कोऑर्डिनेट करता है",
  T_41_XXJ_WS_ANGLE_D: "z एक्सिस रोटेशन एंगल",
  T_41_XXJ_WS_ANGULARDRAG: "एंगुलर ड्रैग",
  T_41_XXJ_WS_ANGULARVELOCITY: "एंगुलर गति",
  T_41_XXJ_WS_ANIMATIONCLIP: "एनीमेशन स्टेट",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "एनीमेशन कंट्रोलर",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "एनीमेशन एंटिटी",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "एनीमेशन कंट्रोलर को मैनेज करने के लिए इस्तेमाल की जाने वाली फ़ाइल और रिसोर्स",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "एनीमेशन कंट्रोलर रिसोर्स UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "लूप टाइप एनम",
  T_41_XXJ_WS_ANIMATIONSTATE: "एनीमेशन स्टेट",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "ऑपरेशन, जहां सभी प्रकार के मूल्य असाइनमेंट सपोर्ट हैं, और डिजिटल प्रकार भी सेल्फ-इन्क्रीमेंट, सेल्फ-घटाना, सेल्फ-मल्टिप्लिकेशन और सेल्फ-विभाजन का समर्थन करते हैं",
  T_41_XXJ_WS_ATTACHMENT: "अटैचमेंट",
  T_41_XXJ_WS_ATTACHMENT_D: "अटैचमेंट",
  T_41_XXJ_WS_ATTACHTARGET: "लिंक हुई एंटिटी",
  T_41_XXJ_WS_BAG: "बैकपैक",
  T_41_XXJ_WS_BAG_D: "पैकपैक कॉम्पोनेन्ट",
  T_41_XXJ_WS_BANNERID: "बैनर ID",
  T_41_XXJ_WS_BANNERID_D: "बैनर ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "बिहेवियर ट्री",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "बिहेवियर ट्री",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "बिहेवियर-माउंटेबल ट्री एंटिटी",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "बिहेवियर ट्री एंटिटी जो माउंट की जा सकती है",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "बिहेवियर ट्री कस्टम नोड",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "बिहेवियर ट्री कस्टम पिवट",
  T_41_XXJ_WS_BODY: "बॉडी",
  T_41_XXJ_WS_BORDERLR: "बॉर्डर (लेफ़्ट & राइट)",
  T_41_XXJ_WS_BORDERLR_D: "लेफ्ट और राइट बॉर्डर",
  T_41_XXJ_WS_BORDERTB: "बॉर्डर (टॉप & बॉटम)",
  T_41_XXJ_WS_BORDERTB_D: "ऊपर और नीचे का बॉर्डर",
  T_41_XXJ_WS_BRPEAKRANK: "सबसे ऊंची BR रैंक",
  T_41_XXJ_WS_BRPEAKRANK_D: "सबसे ऊंची BR रैंक",
  T_41_XXJ_WS_BRRANK: "BR रैंक",
  T_41_XXJ_WS_BRRANK_D: "BR रैंक",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "बिहेवियर ट्री नोड टाइप",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "बिहेवियर ट्री पिवट टाइप",
  T_41_XXJ_WS_BTREE: "बिहेवियर ट्री",
  T_41_XXJ_WS_BTREENODESTATE: "बिहेवियर ट्री नोड स्टेट",
  T_41_XXJ_WS_BTREENODESTATE_D: "बिहेवियर ट्री पिवट ऑपरेटिंग स्टेटस",
  T_41_XXJ_WS_BUFFABLEENTITY: "बफ-चालू एंटिटी",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "बफ़्स जोड़ने, बफ़्स हटाने और बफ़ सूचियाँ जोड़ने में सक्षम बनाता है",
  T_41_XXJ_WS_BUILDINGICEWALL: "ग्लू वॉल",
  T_41_XXJ_WS_CAMOUFLAGE: "फंक्शनल आइटम्स",
  T_41_XXJ_WS_CAMOUFLAGE_D: "स्काईबोर्ड, कैमफ्लाश़...",
  T_41_XXJ_WS_CAPICITY_D: "शुरुआती कैपेसिटी",
  T_41_XXJ_WS_CENTERINVISIBLE: "सेंटर पर इनविजिबल",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "सेंटर पर दिखाई नहीं देता",
  T_41_XXJ_WS_COLOR: "कलर",
  T_41_XXJ_WS_COLOR_D: "कलर",
  T_41_XXJ_WS_CONDITION: "कंडीशन नोड",
  T_41_XXJ_WS_CONDITION_D: "कंडीशन एक विशेष बूलियन प्रकार की होती हैं",
  T_41_XXJ_WS_CONDITION1_D: "कंडीशन पिवट",
  T_41_XXJ_WS_CONSTRAIN: "कठोर बॉडी बाधा",
  T_41_XXJ_WS_CONSTRAIN_D: "कठोर बॉडी में बाधाएँ जोड़ें. यह कठोर बॉडी बाधाएँ प्रकार का संकलन है.",
  T_41_XXJ_WS_COUNT_D: "मात्रा",
  T_41_XXJ_WS_CROSSBOW_D: "क्रॉसबो",
  T_41_XXJ_WS_CSPEAKRANK: "सबसे ऊंची CS रैंक",
  T_41_XXJ_WS_CSPEAKRANK_D: "सबसे ऊंची CS रैंक",
  T_41_XXJ_WS_CSRANK: "CS रैंक",
  T_41_XXJ_WS_CSRANK_D: "CS रैंक",
  T_41_XXJ_WS_CSVNAME_D: "सीनडेटा के अंतर्गत .csv फ़ाइल जो मोड से मेल खाती है. .csv में ख़त्म होता है. हैडर छोटे अक्षरों में लिखे जाते हैं.",
  T_41_XXJ_WS_CURCAPACITY: "इस्तेमाल की गई कैपेसिटी",
  T_41_XXJ_WS_CURPROGRESS: "करंट प्रोग्रेस",
  T_41_XXJ_WS_CURRENTCLIP: "करंट क्लिप",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "मौजूदा क्लिप प्रोग्रेस",
  T_41_XXJ_WS_CURRENTSTATE: "मौजूदा स्टेट",
  T_41_XXJ_WS_CUSTOMHUDID: "कस्टम HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "कस्टम HUD कस्टम को बताने के लिए उपयोग की जाने वाली ID",
  T_41_XXJ_WS_DASHATTACK: "डैश अटैक",
  T_41_XXJ_WS_DEBUG: "डिबगिंग शुरू करें",
  T_41_XXJ_WS_DEBUG_D: "फिक्स करें",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "मंदी %: जब कोई वस्तु पानी में होती है तो मंदी (रेंज अस्थायी रूप से 0-100 के रूप में सेट की जाती है)",
  T_41_XXJ_WS_DEPTH_D: "गहराई",
  T_41_XXJ_WS_DRAG: "ड्रैग गुणांक",
  T_41_XXJ_WS_DRAG_D: "HUD टेम्प्लेट एंटिटी का यह आईडी गुणांक जितना बड़ा होगा, मूवमेंट स्पीड उतनी ही कम होगी",
  T_41_XXJ_WS_DUMMY: "डमी",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "लो-ग्राफ़िक्स मोड चालू करें",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "जब कम fps चालू होता है, तो गेम 15 fps पर चलेगा; या फिर 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "रिटर्न एंटिटी लिस्ट बनाई गई",
  T_41_XXJ_WS_ENTITYNAME: "ऑब्जेक्ट का नाम",
  T_41_XXJ_WS_ENTITYNAME_D: "प्लेयर द्वारा कस्टमाइज़ ऑब्जेक्ट नाम",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "लॉजिकल एंटिटी या प्रीफैब ID",
  T_41_XXJ_WS_EQUIPANDBAG: "आर्मर और बैकपैक",
  T_41_XXJ_WS_EQUIPMENTSLOT: "इक्विपमेंट स्लॉट एनम",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "इक्विपमेंट स्लॉट एनम",
  T_41_XXJ_WS_EXPLODE: "सेल्फ-एक्सप्लोड",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "धमाके वाले वेपन",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "ऑटो रीलोड स्पीड",
  T_41_XXJ_WS_FILEID: "इंटर्नल ID",
  T_41_XXJ_WS_FILEID_D: "प्रीफ़ैब में कंट्रोल की आंतरिक आईडी",
  T_41_XXJ_WS_FILLAMOUNT: "फिल की मात्रा",
  T_41_XXJ_WS_FILLAMOUNT_D: "फिल वैल्यू",
  T_41_XXJ_WS_FILLDIR: "फिल डायरेक्शन",
  T_41_XXJ_WS_FILLDIR_D: "भरने की दिशा",
  T_41_XXJ_WS_FILLDIR_D1: "फिल दिशा एनम",
  T_41_XXJ_WS_FILLTYPE: "फिल टाइप",
  T_41_XXJ_WS_FILLTYPE_D: "फिल टाइप",
  T_41_XXJ_WS_FILLTYPE_D1: "फिल का टाइप एनम",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "रास्ता खोजें",
  T_41_XXJ_WS_FINISH: "पूरा",
  T_41_XXJ_WS_FIREINTERVAL: "फायरिंग इंटरवल",
  T_41_XXJ_WS_FIREINTERVAL_D: "अटैक इंटरवल",
  T_41_XXJ_WS_FLIP: "फ्लिप तरीका",
  T_41_XXJ_WS_FLIP_D: "फ्लिप मेथड",
  T_41_XXJ_WS_FLYBOMBBEE: "फ्लाइंग ज़ॉम्बी",
  T_41_XXJ_WS_FORCE: "फोर्स",
  T_41_XXJ_WS_FORCE_D: "एक तय तीव्रता का बल बनाएं",
  T_41_XXJ_WS_FORCETYPE: "फोर्स टाइप",
  T_41_XXJ_WS_FORCETYPE_D: "कठोर बॉडी पर विभिन्न प्रकार के फोर्स. P.S.  सिर्फ़ गतिशील कठोर बॉडी  प्रकारों पर प्रभावी.",
  T_41_XXJ_WS_FREEZEALL: "फ्रीज़ मूवमेंट और रोटेशन",
  T_41_XXJ_WS_FREEZEPOSITION: "लीनियर मूवमेंट फ्रीज़ करें",
  T_41_XXJ_WS_FREEZEPOSITIONX: "फ्रीज़ x एक्सिस",
  T_41_XXJ_WS_FREEZEPOSITIONY: "फ्रीज़ y एक्सिस",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "फ्रीज़ z एक्सिस",
  T_41_XXJ_WS_FREEZEROTATION: "फ्रीज़ ऑल रोटेशन",
  T_41_XXJ_WS_FREEZEROTATIONX: "फ्रीज़ x रोटेशन",
  T_41_XXJ_WS_FREEZEROTATIONY: "फ्रीज y रोटेशन",
  T_41_XXJ_WS_FREEZEROTATIONZ: "फ्रीज़ z रोटेशन",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "मैक्स डैमेज के लिए दूरी",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "मैक्स डैमेज के लिए दूरी",
  T_41_XXJ_WS_GAMEID_D: "मिशन ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "कोई मेट्रोपोलिस आइटम दें",
  T_41_XXJ_WS_GRADIENT: "ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENT_D: "ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENTBOTTOM: "बॉटम पर ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "बॉटम पर ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "बॉटम पर ट्रांसपेरेंसी",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "बॉटम ट्रांसपेरेंसी",
  T_41_XXJ_WS_GRADIENTTOP: "टॉप पर ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENTTOP_D: "टॉप पर ग्रेडिएंट",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "टॉप पर ट्रांसपेरेंसी",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "टॉप ट्रांसपेरेंसी",
  T_41_XXJ_WS_GRAPHID: "स्क्रिप्ट ID",
  T_41_XXJ_WS_GRAPHID_D: "किसी स्क्रिप्ट एसेट को बताने में इस्तेमाल होने वाली ID",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "ग्लू मेल्टर कॉम्पोनेन्ट",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "धमाके में देरी",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "थ्रोएब्ल",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "मैक्स DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "मिन. डैमेज",
  T_41_XXJ_WS_GRENADERANGE_D: "धमाके की रेंज",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "सेल्फ DMG गुणक",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "सहयोगी DMG गुणक",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "व्हीकल DMG गुणांक",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "थ्रोइंग स्पीड",
  T_41_XXJ_WS_GRENADEWEAPON: "थ्रोएब्ल केटेगरी",
  T_41_XXJ_WS_GRENADEWEAPON_D: "बेसिक थ्रोएब्ल टाइप",
  T_41_XXJ_WS_HANDCANNON_D: "थ्रोएब्ल",
  T_41_XXJ_WS_HEAD: "हेड",
  T_41_XXJ_WS_HEADID: "अवतार ID",
  T_41_XXJ_WS_HEADID_D: "अवतार ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "हैवी वेपन",
  T_41_XXJ_WS_HELMET_D: "मौजूदा हेलमेट",
  T_41_XXJ_WS_HELMET1_D: "हेलमेट",
  T_41_XXJ_WS_HELMET2_D: "हेलमेट एंटिटी",
  T_41_XXJ_WS_HITBODYPART_D: "बॉडी पार्ट का वह हिस्सा जो हिट हुआ है",
  T_41_XXJ_WS_HITBPDYPART: "हिट बॉडी पार्ट",
  T_41_XXJ_WS_HITENTITY_D: "हिट एंटिटी",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "HUD एंटिटी जिसे ये जुड़ा है",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D कंटेंट कंटेनर",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "HUD 3D कंटेनर इकाई. यह HUD है जिसे प्लेयर एडिटर से मॉडिफाई करते हैं.",
  T_41_XXJ_WS_HUDGRID: "कस्टम लेआउट (पैनल) कंट्रोल",
  T_41_XXJ_WS_HUDLAYOUT: "लेआउट कंट्रोल",
  T_41_XXJ_WS_HUDLAYOUT_D: "HUD इंसर्शन एंटिटी. यह HUD है जिसे प्लेयर एडिटर से मॉडिफाई करते हैं.",
  T_41_XXJ_WS_HUDPROFILEINFO: "कस्टम अवतार कंट्रोल",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "HUD प्रोफ़ाइल इंफो एंटिटी. यह HUD है जिसे प्लेयर एडिटर से मॉडिफाई करते हैं.",
  T_41_XXJ_WS_HUDTEXTURE: "टेक्सचर कंट्रोल",
  T_41_XXJ_WS_HUDTEXTURE_D: "HUD टेक्सचर एंटिटी. यह HUD है जिसे प्लेयर एडिटर से मॉडिफाई करते हैं.",
  T_41_XXJ_WS_HUDTRANSFORM: "यूआईट्रांसफॉर्म कंट्रोल कॉम्पोनेन्ट",
  T_41_XXJ_WS_HUDTRANSFORM_D: "UITransform कंट्रोल इकाई",
  T_41_XXJ_WS_IMPULSE: "स्ट्राइक",
  T_41_XXJ_WS_IMPULSE_D: "एक तय तीव्रता का प्रहार बनाएं",
  T_41_XXJ_WS_INITIALWORLDPOS: "शुरुआती वर्ल्ड कोऑर्डिनेट",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "बफ एनम",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "BuffData.csv में आईडी कॉलम से मेल खाता है. नए मटेरियल जोड़ने से पहले, कृपया पहले GPP के साथ कपैटेबिलिटी की जांच करें.",
  T_41_XXJ_WS_INVERTFILL: "इन्वर्ट फिल",
  T_41_XXJ_WS_INVERTFILL_D: "फील इन्वर्ट करें",
  T_41_XXJ_WS_ISLOOP: "लूप है",
  T_41_XXJ_WS_ISLOOP_D: "लूप करना है या नहीं. डिफ़ॉल्ट ग़लत है.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "स्टैटिक NavMesh जनरेशन",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "केवल स्थिर लोडिंग ऑब्जेक्ट्स के दौरान स्थिर NavMesh जनरेशन की जांच करने के लिए उपयोग किया जाता है",
  T_41_XXJ_WS_ISSUCCESS_D: "नष्ट हुआ या नहीं",
  T_41_XXJ_WS_ITEMENTITY_D: "आइटम एंटिटी",
  T_41_XXJ_WS_ITEMID: "आइटम ID",
  T_41_XXJ_WS_ITEMID_D: "आइटम ID",
  T_41_XXJ_WS_ITEMID_D1: "अटैचमेंट की संबंधित आइटम आईडी",
  T_41_XXJ_WS_ITEMLIST: "आइटम लिस्ट",
  T_41_XXJ_WS_ITEMTYPE_D: "आइटम टाइप",
  T_41_XXJ_WS_JUMPATTACK: "जम्प अटैक",
  T_41_XXJ_WS_LANDMINE: "लैंडमाइन",
  T_41_XXJ_WS_LENGTH: "क्लिप की लम्बाई",
  T_41_XXJ_WS_LENGTH_D: "प्रोग्रेस बार की लंबाई. डिफ़ॉल्ट मान प्रीफ़ैब यूआई पर लंबाई है.",
  T_41_XXJ_WS_LIMB: "लिम्ब",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "लिस्ट की लंबाई क्षमता से अधिक होने के कारण एलिमेंट जोड़ने में विफल रहा",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "मुफ़्त लिस्ट",
  T_41_XXJ_WS_LOOP: "लूप",
  T_41_XXJ_WS_LOOP_D: "लूप",
  T_41_XXJ_WS_MAXCAPACITY: "कैपेसिटी",
  T_41_XXJ_WS_MAXCAPACITY_D: "बैकपैक की कैपेसिटी",
  T_41_XXJ_WS_MAXPROGRESS: "मैक्स. प्रोग्रेस",
  T_41_XXJ_WS_MELEEWEAPON_D: "मेले वेपन",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "मिन डैमेज की दूरी",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "मिन. डैमेज के लिए दूरी",
  T_41_XXJ_WS_MINISENTRY: "ऑटो टरट",
  T_41_XXJ_WS_NAME: "नाम",
  T_41_XXJ_WS_NAME_D: "स्किल बटन का नाम. ऑनक्लिक इवेंट्स के दौरान पैरामीटर भेजने के लिए इस्तेमाल किया जाता है, इसलिए विशिष्टता की गारंटी होनी चाहिए.",
  T_41_XXJ_WS_NAME1_D: "मर्चेंडाइज का नाम",
  T_41_XXJ_WS_NAME2_D: "मर्चैंडाइज़ लिस्ट का नाम",
  T_41_XXJ_WS_NAME3_D: "वेंडिंग मशीन का नाम",
  T_41_XXJ_WS_NICKNAME: "निकनेम",
  T_41_XXJ_WS_NICKNAME_D: "प्लेयर का नाम",
  T_41_XXJ_WS_NOCHANGE: "कोई बदलाव नहीं",
  T_41_XXJ_WS_NONE: "कोई बाधा नहीं",
  T_41_XXJ_WS_NONE1: "कोई नहीं",
  T_41_XXJ_WS_OFFSET: "ऑफ़सेट",
  T_41_XXJ_WS_OFFSET_D: "ऑफ़सेट",
  T_41_XXJ_WS_OFFSET1_D: "लिखित ऑफसेट वैल्यू",
  T_41_XXJ_WS_ONCE: "एकबार",
  T_41_XXJ_WS_ONCE_D: "एकबार",
  T_41_XXJ_WS_ONHIDE: "जब इंटरफ़ेस बंद हो जाता है",
  T_41_XXJ_WS_ONHIDE_D: "जब इंटरफ़ेस बंद होता है",
  T_41_XXJ_WS_ONNODEENTER_D: "जब पिवट एंटर कर रही हो",
  T_41_XXJ_WS_ONSHOW: "जब इंटरफ़ेस खुला है",
  T_41_XXJ_WS_ONSHOW_D: "जब इंटरफ़ेस खुला हो",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "टेक्स्ट बॉक्स बदल जाने पर ट्रिगर होता है",
  T_41_XXJ_WS_PERSONALUAV: "UAV-लाइट",
  T_41_XXJ_WS_PINID: "पिन ID",
  T_41_XXJ_WS_PINID_D: "पिन ID",
  T_41_XXJ_WS_PLAYERBAG: "प्लेयर बैकपैक एंटिटी",
  T_41_XXJ_WS_PLAYERBAG_D: "प्लेयर की बैकपैक एंटिटी",
  T_41_XXJ_WS_PLAYERBAGENTITY: "प्लेयर बैकपैक",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "प्लेयर का बैकपैक",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "स्कोप में रहते हुए स्पीड का मॉडिफाइड गुणांक",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "फायर के दौरान इम्पैक्ट ऑफ़ मूवमेंट स्पीड",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "फायरिंग करते समय मूवमेंट स्पीड का प्रभाव",
  T_41_XXJ_WS_PREFABID: "प्रीफैब आईडी",
  T_41_XXJ_WS_PREFABID_D: "प्रीफ़ैब एसेट को बताने के लिए उपयोग की जाने वाली ID",
  T_41_XXJ_WS_PREFABID1_D: "यह ID  जिस HUD टेम्प्लेट एंटिटी का प्रतिनिधित्व करती है",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "मुख्या वेपन 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "मुख्य वेपन 2",
  T_41_XXJ_WS_PROFILEINFO: "प्लेयर प्रोफाइल",
  T_41_XXJ_WS_PROFILEINFO_D: "प्लेयर बायो",
  T_41_XXJ_WS_PROGRESSICON_D: "प्रोग्रेस आइकॉन",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "प्रोग्रेस आइकॉन का नाम",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "मेट्रोपोलिस मिनीगेम छोड़ें",
  T_41_XXJ_WS_RANGE: "फायरिंग रेंज",
  T_41_XXJ_WS_RANGE_D: "अटैक रेंज",
  T_41_XXJ_WS_RANGE_D1: "धमाके की रेंज",
  T_41_XXJ_WS_RANGE_D2: "टरट रेंज",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "पूरी टेबल के कॉन्टेंट को पढ़ें. एक टू डायमेंशन ऐरे रिटर्न करें.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "किसी विशिष्ट सेल को कॉन्टेंट पढ़ें",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "एक निश्चित कॉलम के कॉन्टेंट को पढ़ें. एक ऐरे रिटर्न करता है.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "एक निश्चित रो के कॉन्टेंट को पढ़ें. एक ऐरे रिटर्न करता है.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "जमा डेटाबेस को पढ़ें",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "जमा डेटाबेस में किसी टेबल में किसी की से संबंधित मान पढ़ें",
  T_41_XXJ_WS_RECOVERPLAYERHP: "लगातार HP पाएं",
  T_41_XXJ_WS_RELOADSPEED: "रीलोड स्पीड",
  T_41_XXJ_WS_RELOADSPEED_D: "रीलोड स्पीड (बेसिक स्पीड x गुणांक)",
  T_41_XXJ_WS_RESOURCEID: "रिसोर्स UUID",
  T_41_XXJ_WS_RESOURCEID_D: "रिसोर्स UUID",
  T_41_XXJ_WS_RESUUID: "रिसोर्स ID",
  T_41_XXJ_WS_RESUUID_D: "रेंडर करने के लिए तय  रिसोर्स UUID",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "कठोर बॉडी बाधा प्रकार",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "प्रत्येक बाधा को बिट मार्किंग द्वारा परिभाषित किया गया है और इसे संयोजन के रूप में उपयोग किया जा सकता है",
  T_41_XXJ_WS_ROTATION: "रोटेशन",
  T_41_XXJ_WS_ROTATION_D: "वर्ल्ड कोऑर्डिनेट में रोटेशन एंगल. x, y, z क्रमशः यॉ, पिच और रोल को संदर्भित करता है.",
  T_41_XXJ_WS_ROTATION1_D: "रोटेशन",
  T_41_XXJ_WS_RUNNING: "रनिंग",
  T_41_XXJ_WS_SCALE: "स्केल",
  T_41_XXJ_WS_SCALE_D: "स्केल",
  T_41_XXJ_WS_SCALE1_D: "एक निश्चित एक्सिस के स्केल करता है. तीन अक्षों का संयोजन हो सकता है.",
  T_41_XXJ_WS_SCATTERMAX: "मैक्स. बुलेट स्कैटर",
  T_41_XXJ_WS_SCATTERMAX_D: "वह मान जिस पर गोली का स्प्रेड शुरू होता है",
  T_41_XXJ_WS_SCATTERMOVE1: "चलते समय स्प्रेड का साइज",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "स्प्रेड रिकवरी की स्पीड",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "स्पीड ऑफ़ स्प्रेड रिकवरी",
  T_41_XXJ_WS_SCATTERSPEED: "स्प्रेड की गति में वृद्धि",
  T_41_XXJ_WS_SCATTERSPEED_D: "स्प्रेड बढ़ाने की स्पीड (0.1 = हर एक विस्फोट बढ़ाने के लिए क्रॉसहेयर 10% बढ़ जाता है)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "प्रोन और क्राउच होने पर कम स्प्रेड",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "सेकेंडरी वेपन",
  T_41_XXJ_WS_SHADERNAME: "शैडर का नाम",
  T_41_XXJ_WS_SHADERNAME_D: "शैडर का नाम",
  T_41_XXJ_WS_SHIELDBROKEN: "शील्ड-शैटर अटैक",
  T_41_XXJ_WS_SHIELDUP: "शील्ड अटैक",
  T_41_XXJ_WS_SHOCKWAVE: "शॉकवेव",
  T_41_XXJ_WS_SHOWNAME: "डिस्प्ले निकनेम",
  T_41_XXJ_WS_SHOWNAME_D: "निकनेक दिखाएं",
  T_41_XXJ_WS_SHOWPIN: "डिस्प्ले पिन",
  T_41_XXJ_WS_SHOWPIN_D: "डिस्प्ले पिन",
  T_41_XXJ_WS_SHOWRANK: "डिस्प्ले रैंक",
  T_41_XXJ_WS_SHOWRANK_D: "डिस्प्ले रैंक",
  T_41_XXJ_WS_SHOWTYPE: "डिज़ाइन",
  T_41_XXJ_WS_SHOWTYPE_D: "टाइप",
  T_41_XXJ_WS_SHRINKSPEED: "सिकुड़ने की स्पीड",
  T_41_XXJ_WS_SIGHTAIMASSIST: "स्कोप पर ऐम असिस्ट ऑन करें",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "दूरी के साथ ऐम असिस्ट क्रॉसहेयर सेंसिटिविटी (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "ऐम असिस्ट के लिए दूरी को प्राथमिकता देते समय गुणांक (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "ऐम असिस्ट के लिए दूरी को प्राथमिकता देने के लिए अधिकतम दूरी",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "ऐम असिस्ट के लिए दूरी को प्राथमिकता देने के लिए न्यूनतम दूरी",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "ऐम असिस्ट के लिए दूरी को प्राथमिकता देना",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "ऐम असिस्ट क्रॉसहेयर सेंसिटिविटी",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "स्कोप ज़ूम इन फैक्टर",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV ज़ूम इन फैक्टर",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "स्कोप रोटेशन सेंसिटिविटी कोफीसिएंट",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "न्यूनतम स्कोप इन DMG का मॉडिफाइड गुणांक x",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "स्कोप इन फायरिंग UI ज़ूम इन टाइम",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "स्कोप्ड इन फायरिंग UI ज़ूम इन फैक्टर",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "स्कोप्ड इन फायरिंग UI रिज्यूम टाइम",
  T_41_XXJ_WS_SPEED: "प्लेबैक स्पीड",
  T_41_XXJ_WS_SPEEQUIP: "फंक्शनल इक्विपमेंट",
  T_41_XXJ_WS_SPEITEM: "डिवाइस",
  T_41_XXJ_WS_STATICGRAPHID: "स्टैटिक स्क्रिप्ट ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "स्टैटिक स्क्रिप्ट एसेट का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_41_XXJ_WS_STATICWAINING: "स्टैटिक कठोर बॉडी प्रकार को मॉडिफाई करने में विफल",
  T_41_XXJ_WS_TARGETTREE: "बिहेवियर ट्री एंटिटी",
  T_41_XXJ_WS_TARGETTREE_D: "बिहेवियर ट्री एंटिटी",
  T_41_XXJ_WS_TEAMINDEX: "टीम सीरियल नंबर",
  T_41_XXJ_WS_TEAMINDEX_D: "टीम इंडेक्स, जो रूम में टीम इंडेक्स से मेल खाता है",
  T_41_XXJ_WS_TEAMINDEX_D1: "टीम फ़ैशन नंबर",
  T_41_XXJ_WS_TEMPLATEPREFABID: "टेम्पलेट प्रेफैब ID",
  T_41_XXJ_WS_TEXT_D: "कॉन्टेंट",
  T_41_XXJ_WS_TEXTURENAME: "टेक्सचर का नाम",
  T_41_XXJ_WS_TEXTURENAME_D: "टेक्सचर का नाम",
  T_41_XXJ_WS_THROWATTACK: "ग्रेनेड",
  T_41_XXJ_WS_TICKINTERVAL: "रिफ्रेश इंटरवल",
  T_41_XXJ_WS_TICKINTERVAL_D: "रिफ्रेश इंटरवल. संख्या जितनी बड़ी होगी, रिफ्रेश होने में उतना ही अधिक समय लगेगा.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "प्लेयर के बैकपैक में विशेष डिवाइस चालू करें",
  T_41_XXJ_WS_UVRECTWH: "UV चौड़ाई & हाइट",
  T_41_XXJ_WS_UVRECTWH_D: "UV चौड़ाई और ऊंचाई",
  T_41_XXJ_WS_UVRECTXY: "UV ऑफसेट",
  T_41_XXJ_WS_UVRECTXY_D: "UV ऑफसेट",
  T_41_XXJ_WS_VELOCITY: "गति",
  T_41_XXJ_WS_VELOCITY_D: "कठोर बॉडी की गति को सीधे बदलने से बचें. आप संबंधित APIs का उपयोग करके इसे बदल सकते हैं.",
  T_41_XXJ_WS_VEST_D: "मौजूदा वेस्ट",
  T_41_XXJ_WS_VEST1_D: "वेस्ट",
  T_41_XXJ_WS_WIDGETID: "कंट्रोल ID",
  T_41_XXJ_WS_WIDGETID_D: "इंटरफ़ेस एसेट में कंट्रोल का वर्णन करने के लिए उपयोग की जाने वाली आईडी. यह सुनिश्चित करने के लिए कि यह एक अद्वितीय कंट्रोल ID से मेल खाता है, इसे एक कस्टम HUD आईडी के साथ जोड़ा जाना चाहिए.",
  T_41_XXJ_WS_WINDATTACK: "टोर्नेडो अटैक",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "जमा डेटाबेस ऑफ़सेट लिखें",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "जमा डेटाबेस में किसी टेबल में किसी की के अनुरूप ऑफसेट लिखें",
  T_41_XXJ_WS_ZONEDURATION_D: "फ्रीज़ अवधि",
  T_41_XXJ_WS_ZONEDURATION1_D: "ग्लू मेल्टर अवधि",
  T_41_XXJ_WS_ZONERADIUS_D: "फ़्रीज़ ज़ोन रेडियस",
  T_41_XXJ_WS_ZONERADIUS1_D: "ग्लू मेल्टर रेडियस",
  T_41_XYL_WS_BOT12: "अर्थ ड्रिलर",
  T_41_XYL_WS_BOT9: "म्यूटेड टॉसिंग ज़ॉम्बी",
  T_41_XYL_WS_ITEM262: "फ्रोज़न स्टील पैनल A",
  T_41_XYL_WS_ITEM263: "फ्रोज़न कंटेनर A",
  T_41_XYL_WS_ITEM264: "फ्रोज़न सप्लाई कंटेनर",
  T_41_XYL_WS_ITEM265: "फ्रोज़न मेटल गेट",
  T_41_XYL_WS_ITEM266: "फ्रोज़न कंटेनर B",
  T_41_XYL_WS_ITEM267: "फ्रोज़न स्टोन A",
  T_41_XYL_WS_ITEM268: "फ्रोज़न स्टोन B",
  T_41_XYL_WS_ITEM269: "फ्रोज़न स्टोन C",
  T_41_XYL_WS_ITEM270: "फ्रोज़न स्टोन D",
  T_41_XYL_WS_ITEM271: "छोड़ी हुई सबवे कार",
  T_41_XYL_WS_MODELMATCHNAME: "कॉन्टेस्ट कैनवास",
  T_41_XYL_WS_NAVMESH: "डायनामिक navmesh",
  T_41_XYL_WS_REFCUBE: "रिफ्लेक्टिव क्यूब",
  T_41_XYL_WS_SNOWSKY: "फ्रॉस्ट गैलेक्सी",
  T_41_XYL_WS_TOYCUBE: "क्यूब खेलें",
  T_42_CJ_F_B_VOCATIONAL: "गियरिंग ब्लूप्रिंट (बॉटम)",
  T_42_CJ_F_H_VOCATIONAL: "गियरिंग ब्लूप्रिंट (हेड)",
  T_42_CJ_F_S_VOCATIONAL: "गियरिंग ब्लूप्रिंट (जूते)",
  T_42_CJ_F_T_VOCATIONAL: "गियरिंग ब्लूप्रिंट (टॉप)",
  T_42_CJ_HA_THUNDER_GOLD: "लाइटनिंग फेसपेंट",
  T_42_CJ_M_B_VOCATIONAL: "मैकेनिक मास्टरप्लान (बॉटम)",
  T_42_CJ_M_H_VOCATIONAL: "मैकेनिक मास्टरप्लान (हेड)",
  T_42_CJ_M_S_VOCATIONAL: "मैकेनिक मास्टरप्लान (जूते)",
  T_42_CJ_M_T_VOCATIONAL: "मैकेनिक मास्टरप्लान (टॉप)",
  T_42_H_CHARACTER_SUPERTEEN_N: "इग्निस",
  T_42_H_GLOO_EVOTIGER_N: "ग्लू वॉल - टाइगर्स फ्यूरी",
  T_42_H_GRENADE_SMUDGE_N: "ग्रेनेड - फ़ीलाइन शैडो",
  T_42_H_M1917_EMPIRE_N: "M1917 - क्राउंड कॉन्करर",
  T_42_HJ_WS_VFX_INK: "इंक",
  T_42_JH_WS_BANMATCHMAKING: "इस मैप के लिए मैचमेकिंग की अनुमति नहीं है",
  T_42_JH_WS_BANROOMCREATE: "एक रूम बनाने में असमर्थ",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "पार्टी रीमिक्स (अलोक)",
  T_42_JH_WS_SKILLSETFIREWALL: "वॉल ऑफ़ फ्लेम (इग्निस)",
  T_42_JH_WS_SKILLSETSANTINO: "शेप स्प्लिटर (सेंटीनो)",
  T_42_JH_WS_SKILLSETSONIA: "नैनो लाइफशील्ड (सोनिया)",
  T_42_JH_WS_TAG1: "फ्रॉस्ट ब्राव्ल",
  T_42_JH_WS_TAG10: "इंफिनिटी रेसर",
  T_42_JH_WS_TAG11: "रेस रश",
  T_42_JH_WS_TAG12: "कार रेसिंग",
  T_42_JH_WS_TAG13: "लोकप्रिय को छोड़ कर",
  T_42_JH_WS_TAG14: "फ्रंटलाइन",
  T_42_JH_WS_TAG15: "ज़ॉम्बी वॉर",
  T_42_JH_WS_TAG16: "लेगसी लीजेंड",
  T_42_JH_WS_TAG2: "सोशल आइलैंड 1.0",
  T_42_JH_WS_TAG3: "सोशल आइलैंड 2.0",
  T_42_JH_WS_TAG4: "साथ खेलें",
  T_42_JH_WS_TAG5: "रूइन सर्वाइवर",
  T_42_JH_WS_TAG6: "प्रेयिंग पार्टी",
  T_42_JH_WS_TAG7: "प्रेयिंग पार्टी",
  T_42_JH_WS_TAG8: "फोर्ट फ्यूड 2.0",
  T_42_JH_WS_TAG9: "बाउंटी हंटिंग",
  T_42_RW_PORTALSFORPERSONAL_DESC: "कहीं भी एक पोर्टल रखें और दूर टेलीपोर्ट करें!",
  T_42_RW_PORTALSPERSONAL_NAME: "पोर्टल गो",
  T_42_SJ_WS_ACCESSORIESITEM: "अटैचमेंट लैस करें",
  T_42_SJ_WS_AUTOPLAY: "ऑटो प्ले",
  T_42_SJ_WS_CLIMB: "ऊपर चढ़ें",
  T_42_SJ_WS_CLOCK_EVENTS: "इवेंट कंपाइलेशन",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "काउंटडाउन या नहीं",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "लूप्स",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "इवेंट रोकें",
  T_42_SJ_WS_CLOCK_START_EVENT: "इवेंट शुरू करें",
  T_42_SJ_WS_CLOCK_START_TIME: "काउंटडाउन स्टार्ट टाइम",
  T_42_SJ_WS_CLOCK_STATE: "स्टॉपवॉच स्टेटस",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "इवेंट बंद करें",
  T_42_SJ_WS_DAMRATIOHEAD: "हेडशॉट डैमेज गुणांक बदलाव",
  T_42_SJ_WS_DAMRATIOLIMB: "लिम्ब डैमेज गुणांक बदलाव",
  T_42_SJ_WS_DAMREDUCEXPLODE: "विस्फोटक डैमेज से कटौती गुणांक",
  T_42_SJ_WS_DRIVE: "ड्राइव",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "डिस्प्ले लेयर्स",
  T_42_SJ_WS_EXTRABAGCAPACITY: "अतिरिक्त बैकपैक क्षमता",
  T_42_SJ_WS_EXTRAHPRATIO: "HP अनुपात",
  T_42_SJ_WS_GETOFF_DRIVE: "गाड़ी से निकलें",
  T_42_SJ_WS_GETON_DRIVE: "व्हीकल में एंटर करें",
  T_42_SJ_WS_KNIFEITEM: "डैगर",
  T_42_SJ_WS_KNIFEITEMPICK: "डैगर (ग्राउंड लूट)",
  T_42_SJ_WS_MARKBTNHUD: "HUD पर पिन बटन",
  T_42_SJ_WS_MARKBTNHUD_D: "आप पिन बटन को चालू या बंद कर सकते हैं",
  T_42_SJ_WS_MAXDISTANCE: "अधिकतम दूरी",
  T_42_SJ_WS_MAXDURARATIO: "अधिकतम ड्यूरेबिलिटी अनुपात",
  T_42_SJ_WS_MICBTNHUD: "HUD पर माइक स्विच",
  T_42_SJ_WS_MICBTNHUD_D: "आप माइक बटन को चालू या बंद कर सकते हैं",
  T_42_SJ_WS_MINDISTANCE: "न्यूनतम दूरी",
  T_42_SJ_WS_OPE_VEHICLE: "ऑपरेट व्हीकल",
  T_42_SJ_WS_PLANE_DESC: "एक बुनियादी जाल जिसका साइज आज़ादी रूप से एडजस्ट किया जा सकता है",
  T_42_SJ_WS_PLANENAME: "बेसिक प्लेन",
  T_42_SJ_WS_PRIORITY: "प्राथमिकता",
  T_42_SJ_WS_REPLACEPRIORITY: "प्राथमिकता बदलें",
  T_42_SJ_WS_SETBTNHUD: "HUD पर सेटिंग बटन",
  T_42_SJ_WS_SETBTNHUD_D: "आप सेटिंग बटन को चालू या बंद कर सकते हैं",
  T_42_SJ_WS_SIGNALBTNHUD: "HUD पर नेटवर्क कनेक्शन बटन",
  T_42_SJ_WS_SIGNALBTNHUD_D: "आप नेटवर्क कनेक्शन बटन को चालू या बंद कर सकते हैं",
  T_42_SJ_WS_SPEAKERBTNHUD: "HUD पर हॉर्न बटन",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "आप गाड़ी के हॉर्न बटन को चालू या बंद  कर सकते हैं",
  T_42_SJ_WS_START_TIME: "स्टार्ट टाइम (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "ग्रेनेड लॉन्चर को छोड़कर, एक्स्ट्रा [FFB300]{0}[-] गोली की बैकपैक कैपेसिटी ले जाने जा सकते हैं. ([FFB300]{1}[-] AR गोली, [FFB300]{2}[-] SMG गोली, [FFB300]{3}[-] स्नाइपर गोली, [FFB300]{4}[-] SG गोली)",
  T_42_SW_SKILL_DESC_Bodyguard: "रीलोड स्पीड [FFB300]{0}%[-] बढ़ जाती है. हर बार जब स्किल यूजर  किसी दुश्मन को हिट करता है, तो उक्त टारगेट को [FFB300]{1}%[-] हीलिंग कटौती मिलेगी जो [FFB300]{3}s[-] तक रहेगी. (अधिकतम कटौती: [FFB300]{2}% [-]).",
  T_42_SW_SKILL_DESC_Playboy: "विघटनकारी प्रभावों (जैसे स्लो डाउन, मार्किंग, स्किल-सिलेन्सिंग) से इम्यून बनें और [FFB300]{2}s[-] के लिए [FFB300]{1}%[-] मूवमेंट स्पीड को बेस्ट दें. कूलडाउन: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "किसी दुश्मन को नॉक डाउन करने या एक्टिव स्किल के बाद, गन की मैगजीन  [FFB300]{0}%[-] अपने आप से रीलोड लोड हो जाती है",
  T_42_SW_SKILL_NAME_Playboy: "सिल्वर स्पून",
  T_42_SY_BACKPACK_EMPIRE_N: "बैकपैक- क्राउंड  रोअर",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "पैट स्किन: आइसी हॉप",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "मोटरबाइक- अर्बन स्कूटर",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "एवेंटडोर अल्टीमे Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "एवेंटडोर अल्टीमे ग्रिजियो निंबस",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "वेननो नीरो नेमसिस",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "वेनीनो रोसो एफ़ेस्टो",
  T_42_TYC_CST_LOSE_MONEY_1: "एक राउंड की हार पर मिले सीएस कैश की राशि",
  T_42_TYC_CST_LOSE_MONEY_2: "दो राउंड की लगातार हार पर मिले सीएस कैश की राशि",
  T_42_TYC_CST_LOSE_MONEY_3: "तीन राउंड की लगातार हार पर मिले सीएस कैश की राशि",
  T_42_WH_ITEM_HEALUAV: "हील यूएवी-लाइट",
  T_42_WH_ITEM_HEALUAV_DESC: "एक UAV-लाइट तैनात करता है जो आगे की ओर उड़ता है और नीचे दिए गए रेंज में मौजूद टीममेट्स को लगातार हील करता है.",
  T_42_WH_ITEM_SKILLCARD: "स्किल: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `[ffba00]{0}[-]: [ffba00]{1}[-] के एक्टिव स्किल को जारी करने के लिए उपयोग करें.
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "गोली टाइप",
  T_42_XXJ_WS_AMMOTYPE_D: "गोली का प्रकार",
  T_42_XXJ_WS_ASSETCONFIGID: "स्किन ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "स्किन",
  T_42_XXJ_WS_ATTACKSTATUS: "अटैक स्टेटस",
  T_42_XXJ_WS_AUTOPLAY: "ऑटो प्ले",
  T_42_XXJ_WS_AUTOPLAY_D: "ऑटो प्ले",
  T_42_XXJ_WS_AVATARABLE: "मॉडिफिए वाले दिखावट घटक",
  T_42_XXJ_WS_AVATARABLE_D: "पार्ट्स के अनुसार स्वरूप बदलें",
  T_42_XXJ_WS_AVATARRESUUID: "दिखावट रिसोर्स UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "रोटेशन के एक्सिस-एंगल निरूपण को चतुर्भुज में परिवर्तित करें",
  T_42_XXJ_WS_B_D: "B कलर का मान",
  T_42_XXJ_WS_BASEVALUE_D: "लॉगरिथ्म का बेस",
  T_42_XXJ_WS_BEZIERCURVE: "बेज़ियर कर्व",
  T_42_XXJ_WS_BEZIERCURVE_D: "बेज़ियर कर्व",
  T_42_XXJ_WS_BOTDIFFICULTY: "बॉट की कठनाई",
  T_42_XXJ_WS_BOUNCE_COMBINE: "बाउंसीनेस का कॉम्बिनेशन मेथड",
  T_42_XXJ_WS_BOUNCINES: "बाउंसीनेस",
  T_42_XXJ_WS_BTREEID: "बेहेवियर ट्री ID",
  T_42_XXJ_WS_BTREEID_D: "व्यवहार ट्री आईडी",
  T_42_XXJ_WS_CANPURCHAS: "खरीदने योग्य या नहीं",
  T_42_XXJ_WS_CANPURCHAS_D: "खरीदने योग्य है या नहीं",
  T_42_XXJ_WS_CLIMBSTATUS: "क्लाइम्बिंग बेहेवियर",
  T_42_XXJ_WS_CLOCK: "टाइमर ऑब्जेक्ट",
  T_42_XXJ_WS_CLOCK_D: "टाइमर ऑब्जेक्ट",
  T_42_XXJ_WS_CLOCK_D1: "टाइमर",
  T_42_XXJ_WS_CONTAINER: "कंटेनर",
  T_42_XXJ_WS_CONTROLPOINTS: "कन्ट्रोल पॉइंट्स",
  T_42_XXJ_WS_CONTROLPOINTS_D: "कंट्रोल पॉइंट्स",
  T_42_XXJ_WS_COROUTINEID: "कोरॉउटिंग हैंडल",
  T_42_XXJ_WS_COROUTINEID_D: "कोरूटीन ID एक विशिष्ट कोरूटीन के हैंडल को संदर्भित करता है। यह हैंडल पर विभिन्न ऑपरेशन करने की अनुमति देता है.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "एक सेल्फ-रिलेटिव बनाएं",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "सेल्फ-रिलेटिव बनाएं",
  T_42_XXJ_WS_CREATESOUND: "साउंड इफ़ेक्ट बनाएं",
  T_42_XXJ_WS_CREATESOUND_D: "तय साउंड इफ़ेक्ट चलायें. यदि सेट करने के लिए अधिक गुण हैं, तो आप इसकी एंटिटी प्रॉपर्टी को कॉन्फ़िगर करके ऐसा कर सकते हैं.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "कस्टम मिशन पूरा करें",
  T_42_XXJ_WS_DAMAGELIST_D: "डैमेज वृद्धि लिस्ट",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "हेडशॉट डैमेज अनुपात",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "विस्फोट DMG कटौती गुणक",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "डिफ़ॉल्ट फिजिक्स मटेरियल",
  T_42_XXJ_WS_DEFAULTFIST_D: "डिफ़ॉल्ट फिस्ट",
  T_42_XXJ_WS_DELTA: "डेल्टा",
  T_42_XXJ_WS_DELTA_D: "डेल्टा",
  T_42_XXJ_WS_DELTATIME: "लॉजिक फ्रेम इंटरवल",
  T_42_XXJ_WS_DELTATIME_D: "GS के 2 लॉजिक फ्रेम अपडेट के बीच का अंतराल",
  T_42_XXJ_WS_DEPTH: "लेयर",
  T_42_XXJ_WS_DEPTH_D: "आइकन पर लेयर दिखाएं",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "बंद की गई ग्राउंड लूट की लिस्ट",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "उन आइटम की लिस्ट जो ग्राउंड लूट में नहीं हैं",
  T_42_XXJ_WS_DRIVER: "ड्राइवर की सीट",
  T_42_XXJ_WS_DRIVINGSTATUS: "ड्राइव करें",
  T_42_XXJ_WS_DURATION_D1: "काउंटडाउन अवधि सेकंड में",
  T_42_XXJ_WS_DURATION_D2: "अवधि सेकंड में",
  T_42_XXJ_WS_DURATION_D3: "अवधि",
  T_42_XXJ_WS_DURATION_D4: "अभेद्यता की अवधि सेकंड में",
  T_42_XXJ_WS_DURATIONTIMES: "टाइम अवधि",
  T_42_XXJ_WS_DURATIONTIMES_D: "अवधि सेकंड में",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "गतिक घर्षण",
  T_42_XXJ_WS_EASY: "बहुत आसान",
  T_42_XXJ_WS_ENDTIMES: "खत्म होने का टाइम",
  T_42_XXJ_WS_ENDTIMES_D: "टाइमर पर ख़त्म होने का समय सेकंड में",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "ग्लोबल एनर्जी सीमा",
  T_42_XXJ_WS_ENTITYVARNAME_D: "सेल्फ-रिलेटिव एंटिटी",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "अटैचमेंट लैस करें",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "दिए गए यूलर एंगल को चतुर्भुज में परिवर्तित करें",
  T_42_XXJ_WS_EXPONENTIATION_D: "घातांक",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "अतिरिक्त बैकपैक क्षमता",
  T_42_XXJ_WS_FIST: "फिस्ट",
  T_42_XXJ_WS_FONTTYPE: "फ़ॉन्ट एनम",
  T_42_XXJ_WS_FONTTYPE_D: "फॉन्ट एनम",
  T_42_XXJ_WS_FORCESYNCVALUE: "फोर्स सिंक GS स्टेटस",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "फोर्स सिंक वैल्यू",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "जगह की जानकारी, GS फोर्स सिंक से",
  T_42_XXJ_WS_FORCESYNCVALUE1: "फोर्स सिंक से लोकेशन",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "एक एंटिटी जो प्रॉपर्टी तैयार कर सकती है",
  T_42_XXJ_WS_FORWARD_D: "दिशा वेक्टर",
  T_42_XXJ_WS_FRICTION_COMBINE: "घर्षण संयोजन का तरीका",
  T_42_XXJ_WS_FUNCPOINT: "फ़ंक्शन पॉइंटर",
  T_42_XXJ_WS_FUNCPOINT_D: "एक सूचक जो किसी फ़ंक्शन के उदाहरण की ओर इशारा करता है। इसका उपयोग वर्चुअल फ़ंक्शंस या प्रतिनिधि तंत्र को लागू करने के लिए किया जाता है.",
  T_42_XXJ_WS_GETMAPID_D: "मैप ID पाएं",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "गाड़ी से निकालें",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "एंटर व्हीकल (ड्राइवर)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "गाड़ी में एंटर करें (यात्री)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "आज के खिलाड़ी टोकन डेटा की खोज करें",
  T_42_XXJ_WS_GRAVITY: "ग्लोबल ग्रेविटी",
  T_42_XXJ_WS_HANDHELDITEM: "मौजूदा हैंडहेल्ड",
  T_42_XXJ_WS_HANDHELDITEM_D: "मौजूदा हैंडहेल्ड",
  T_42_XXJ_WS_HARD: "हार्ड",
  T_42_XXJ_WS_HASCOMPONENT_D: "क्या कोई घटक मौजूद है",
  T_42_XXJ_WS_HEIGHTLIST_D: "हाइट इन्क्रीमेंट लिस्ट",
  T_42_XXJ_WS_INDEXLIST_D: "स्ट्रिंग की इंडेक्स सूची तक पहुंचें",
  T_42_XXJ_WS_INSCENE: "सीन में",
  T_42_XXJ_WS_INSCENE_D: "सीन में",
  T_42_XXJ_WS_IS3D_D: "चाहे वह 3D संगीत हो",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "काउंटडाउन या स्टॉपवॉच",
  T_42_XXJ_WS_ISLOOP: "लूप करें या नहीं",
  T_42_XXJ_WS_ISLOOP_D: "IsLoop कमांड",
  T_42_XXJ_WS_ISREPLAY_D: "शुरू से शुरू करना चाहिए या नहीं",
  T_42_XXJ_WS_ISSWITCH_D: "जब ट्रू पर सेट किया जाता है, तो इसे सापेक्ष गति के साथ जोड़ा जा सकता है. जब इसे फाल्स पर सेट किया जाता है, तो इसे पूर्ण गति के साथ जोड़ा जा सकता है.",
  T_42_XXJ_WS_JEEP: "जीप",
  T_42_XXJ_WS_JUMPSTATUS: "जम्प स्टेटस",
  T_42_XXJ_WS_LEFTVALUE: "लेफ़्ट वैल्यू",
  T_42_XXJ_WS_LEFTVALUE_D: "बेस",
  T_42_XXJ_WS_LOGARITHM_D: "लॉगरिथ्म",
  T_42_XXJ_WS_LOOPABLE: "लूप हो सकता",
  T_42_XXJ_WS_LOOPABLE_D: "लूप कर सकते",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "डिक्शनरी से सभी की (Key) पाएं",
  T_42_XXJ_WS_MAPVALUE_D: "टारगेट डिक्शनरी",
  T_42_XXJ_WS_MARKBTNHUD: "HUD पर पिन बटन",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "पाई",
  T_42_XXJ_WS_MAXDISTANCE_D: "अधिकतम दूरी",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "HUD पर माइक स्विच",
  T_42_XXJ_WS_MINDISTANCE_D: "न्यूनतम दूरी",
  T_42_XXJ_WS_MISSIONID_D: "मिशन ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "प्रोग्रेस (नेगेटिव संख्या नहीं हो सकती)",
  T_42_XXJ_WS_MODERATE: "मॉडरेट",
  T_42_XXJ_WS_MONSTERTRUCK: "मॉन्स्टर ट्रक",
  T_42_XXJ_WS_MOTORBIKE: "मोटो बाइक",
  T_42_XXJ_WS_MOVEMENTSTATUS: "मूवमेंट स्टेटस",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "दो चतुर्भुजों का गुणन (रोटेशन सुपरपोजिशन का प्रतिनिधित्व)",
  T_42_XXJ_WS_NORMAL: "नॉर्मल",
  T_42_XXJ_WS_OBSOLETE: "ख़त्म हुआ",
  T_42_XXJ_WS_OPENPLAYERVIEW: "खिलाड़ी का पर्सपेक्टिव चालू करें",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "खिलाड़ी पर्सपेक्टिव चालू करें",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "वेपन टाइप",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "वेपन प्रकार",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "प्लेयर कॉन्फ़िगरेशन को प्राथमिकता दें.",
  T_42_XXJ_WS_PARAMSARRAY: "पैरामीटर ऐरे",
  T_42_XXJ_WS_PARAMSARRAY_D: "पैरामीटर्स ऐरे आउटपुट में शामिल पैरामीटर्स की एक सूची है। इसे प्रारूप विवरण में %v की संख्या से मेल खाना आवश्यक है.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "कस्टम फ़ंक्शंस को पास की गई वास्तविक पैरामीटर की लिस्ट.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "पार्ट विज़िबिलिटी मास्क 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "पार्ट विज़िबिलिटी मास्क 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "पार्ट विज़िबिलिटी मास्क 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "पार्ट विज़िबिलिटी मास्क 4",
  T_42_XXJ_WS_PASSENGER1: "पैसेंजर सीट 1",
  T_42_XXJ_WS_PASSENGER2: "पैसेंजर सीट 2",
  T_42_XXJ_WS_PASSENGER3: "पैसेंजर सीट 3",
  T_42_XXJ_WS_PHYMAT: "फिजिक्स मटेरियल",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "एंटिटी",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "प्रत्येक फ्रेम में सेल्फ-रिलेटिव मोशन",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "सेल्फ-रिलेटिव मोशन प्रत्येक फ्रेम",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "सेल्फ-रिलेटिव मोशन",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "सेल्फ-रिलेटिव मोशन",
  T_42_XXJ_WS_PLAYER_D: "वह प्लेयर जिसे गाड़ी में प्रवेश करना है",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "खिलाड़ी व्यवहार प्रॉपर्टी सिंक की एंटिटी",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "प्लेयर व्यवहार प्रॉपर्टी सिंक की एंटिटी",
  T_42_XXJ_WS_PRIORITY_D: "प्राथमिकता",
  T_42_XXJ_WS_PROPID_D: "प्रॉपर्टी आईडी",
  T_42_XXJ_WS_QUATERNION: "चतुर्भुज",
  T_42_XXJ_WS_QUATERNION_D: "क्वाटरनियन एक विशेष चार-आयामी वेक्टर है जिसका उपयोग केवल रोटेशन का प्रतिनिधित्व करने के लिए किया जाता है",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "दिए गए चतुर्भुजों को अक्ष-कोण निरूपण में बदलें",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "दिए गए चतुर्भुजों को यूलर एंगल में बदलें. यदि चतुर्भुज मानक को पूरा नहीं करते हैं, तो वापस (0,0,0) पर आएं.",
  T_42_XXJ_WS_REPEATTIMES_D: "जितनी बार खेला गया. डिफ़ॉल्ट 1 है.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "रिसेट करें",
  T_42_XXJ_WS_RIGHTVALUE: "राइट वैल्यू",
  T_42_XXJ_WS_RIGHTVALUE_D: "पावर",
  T_42_XXJ_WS_SEATTYPE: "व्हीकल सीट एनम",
  T_42_XXJ_WS_SEPSTR_D: "अलगाव के लिए प्रयुक्त स्ट्रिंग",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "प्लेयर के गिरने के डैमेज को सेट करें",
  T_42_XXJ_WS_SETTINGSBTNHUD: "HUD पर सेटिंग बटन",
  T_42_XXJ_WS_SHOWPOSITION: "लोकेशन दिखाएं",
  T_42_XXJ_WS_SHOWPOSITION_D: "लोकेशन दिखाएं",
  T_42_XXJ_WS_SIGNALICOHUD: "HUD पर नेटवर्क कनेक्शन बटन",
  T_42_XXJ_WS_SIMPLE: "आसान",
  T_42_XXJ_WS_SLERPQUATERNION_D: "A से B तक गोलाकार चतुर्भुज प्रक्षेप",
  T_42_XXJ_WS_SOUNDENTITY_D: "साउंड इफ़ेक्ट एंटिटी  उस साउंड इफ़ेक्ट का प्रतिनिधित्व करती है जिसे बजाया जा रहा है",
  T_42_XXJ_WS_SPEAKERBTNHUD: "HUD पर हॉर्न बटन",
  T_42_XXJ_WS_SPLITSTRING_D: "स्ट्रिंग को एक स्लाइस में विभाजित करने के लिए डीलिमिटर के रूप में एक निश्चित स्ट्रिंग का उपयोग करें",
  T_42_XXJ_WS_SPORTSCAR: "स्पोर्ट्स कार",
  T_42_XXJ_WS_SPRINTSTATUS: "स्प्रिंट स्टेटस",
  T_42_XXJ_WS_SRCVAL_D: "स्रोत मूल्य",
  T_42_XXJ_WS_STARTTICKCOUNT: "वह पल जब जीएस टिक करना शुरू करता है",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "वह मोमेंट जब GS टिक करना शुरू करता है",
  T_42_XXJ_WS_STARTTIME_D: "स्टार्ट का टाइम",
  T_42_XXJ_WS_STARTTIME_D1: "स्टार्ट का समय",
  T_42_XXJ_WS_STATE_D: "खिलाड़ी का स्टेटस: एक्टिव, नॉक डाउन, या एलिमिनटेड",
  T_42_XXJ_WS_STATE_D1: "जांचें कि क्या यह साउंड इफ़ेक्ट चल रहा है",
  T_42_XXJ_WS_STATIC_FRICTION: "स्थैतिक घर्षण",
  T_42_XXJ_WS_STRELEMS_D: "टारगेट स्ट्रिंग सेट",
  T_42_XXJ_WS_STRINGFINDAT_D: "इंडेक्स सूची के अनुसार अंतिम कंबाइंड स्ट्रिंग पर लौटे.",
  T_42_XXJ_WS_STRINGJOIN_D: "बताये आइडेंटिफाइर का उपयोग करके स्ट्रिंग्स को जोड़ें",
  T_42_XXJ_WS_STRINGLOWER_D: "स्ट्रिंग के सभी कैरेक्टर को लोअरकेस में बदलें",
  T_42_XXJ_WS_STRINGSTRIP_D: "स्ट्रिंग के दोनों ओर से वाइटस्पेस को हटाएं",
  T_42_XXJ_WS_STRINGUPPER_D: "स्ट्रिंग के सभी कैरेक्टर को अपरकेस में बदलें",
  T_42_XXJ_WS_STYLE_D: "इसे कैसे खेलें",
  T_42_XXJ_WS_SUV: "[पिकअप ट्रक",
  T_42_XXJ_WS_SWITCH: "स्विच करें",
  T_42_XXJ_WS_SWITCH_D: "जब ट्रू पर सेट किया जाता है, तो इसे सापेक्ष गति के साथ जोड़ा जा सकता है. जब फाल्स पर सेट किया जाता है, तो इसे पूर्ण गति के साथ जोड़ा जाना चाहिए, अन्यथा गुण सही ढंग से प्रभावी नहीं होंगे.",
  T_42_XXJ_WS_TARGETENTITY_D: "टारगेट एंटिटी",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "टीम राउंड स्कोर बैनर",
  T_42_XXJ_WS_TEAMSEQ_D: "टीम क्रमांक जो टीम इकाई के क्रमांक गुण से मेल खाता है",
  T_42_XXJ_WS_TEMPORARYSHIELD: "अस्थायी शील्ड बिंदु",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "अस्थायी शील्ड पॉइंट",
  T_42_XXJ_WS_TEXT_D: "अभ्रदता फ़िल्टर करने के लिए ऑरिजिनल टेक्स्ट",
  T_42_XXJ_WS_THREESTATESWITCH: "3-स्टेट्स स्विच",
  T_42_XXJ_WS_THROWINGKNIFE_D: "डैगर (ग्राउंड लूट)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "डैगर",
  T_42_XXJ_WS_TUKTUK: "टुक-टुक",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "टीम मैच डिटेल्स",
  T_42_XXJ_WS_UNIQUEID: "यूनिक ID",
  T_42_XXJ_WS_UNIQUEID_D: "यूनिक ID",
  T_42_XXJ_WS_VALUE_D: "मान",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "यूलर कोणों के लिए दिशा वेक्टर",
  T_42_XXJ_WS_VEHICLEID: "व्हीकल ID",
  T_42_XXJ_WS_VEHICLESKINID: "व्हीकल स्किन ID",
  T_42_XXJ_WS_VERYHARD: "बहुत मुश्किल",
  T_42_XXJ_WS_VOLUME_D: "साउंड वैल्यू . डिफ़ॉल्ट 50 है.",
  T_42_XXJ_WS_WEAPONTYPE_D: "वेपन का मुख्य प्रकार",
  T_42_XXJ_WS_WORKSHOPCODE: "मैप कोड",
  T_42_XXJ_WS_WORKSHOPCODE_D: "मैप कोड जो डेटाबेस में डेटा से मेल खाता है",
  T_42_XXJ_WS_WORLDPOSITION: "वर्ल्ड कोऑर्डिनेट",
  T_42_XXJ_WS_WORLDPOSITION_D: "वर्ल्ड कोऑर्डिनेट",
  T_42_XYL_WS_ITEM275: "फ्यूल टैंक",
  T_42_XYL_WS_ITEM276: "सैंड बैग A",
  T_42_XYL_WS_ITEM277: "सैंड बैग B",
  T_42_XYL_WS_ITEM278: "सैंड बैग C",
  T_42_XYL_WS_ITEM279: "सैंड बैग",
  T_42_XYL_WS_ITEM280: "डबल डेक विला",
  T_42_XYL_WS_ITEM281: "आर्म्स फैक्ट्री",
  T_42_XYL_WS_ITEM282: "स्टोन वॉल A",
  T_42_XYL_WS_ITEM283: "स्टोन वॉल B",
  T_42_XYL_WS_ITEM284: "स्टोन वॉल C",
  T_42_XYL_WS_ITEM285: "स्टोन वॉल D",
  T_42_XYL_WS_ITEM286: "मिलिट्री सप्लाई बॉक्स A",
  T_42_XYL_WS_ITEM287: "कॉपर कॉइन",
  T_42_XYL_WS_ITEM288: "सिल्वर कॉइन",
  T_42_XYL_WS_ITEM289: "गोल्ड कॉइन",
  T_42_XYL_WS_ITEM290: "डायमंड",
  T_42_XYL_WS_ITEM291: "डायमंड शार्ड",
  T_42_XYL_WS_ITEM292: "रूबी",
  T_42_XYL_WS_ITEM293: "एमराल्ड",
  T_42_XYL_WS_ITEM294: "सफायर",
  T_42_XYL_WS_ITEM295: "वार्निंग साइन",
  T_42_XYL_WS_ITEM297: "रूइंस",
  T_42_XYL_WS_ITEM297TRUE: "कंट्रोल डिवाइस",
  T_42_XYL_WS_ITEM298: "सप्लाई कंटेनर B",
  T_42_XYL_WS_ITEM299: "स्नो पाइल",
  T_42_XYL_WS_ITEM300: "हाई-टेक वॉल A",
  T_42_XYL_WS_ITEM301: "हाई-टेक वॉल B",
  T_42_XYL_WS_ITEM302: "फ्रोज़न स्टोन F",
  T_42_XYL_WS_ITEM303: "फ्रोज़न स्टोन E",
  T_42_XYL_WS_ITEM304: "हाई-टेक प्लेटफॉर्म A",
  T_42_XYL_WS_ITEM305: "हाई-टेक स्टेयरकेस A",
  T_42_XYL_WS_ITEM306: "एक्सप्लोरेशन लैंप A",
  T_42_XYL_WS_ITEM307: "रुइन बैफल A",
  T_42_XYL_WS_ITEM308: "रुइन बैफल B",
  T_42_XYL_WS_ITEM309: "रुइन स्टील ब्रैकेट A",
  T_42_XYL_WS_ITEM310: "रुइन स्टोन A",
  T_42_XYL_WS_ITEM311: "रुइन स्टोन B",
  T_42_XYL_WS_ITEM312: "रुइन स्टोन C",
  T_42_XYL_WS_ITEM313: "फ़्लैशलाइट A",
  T_42_XYL_WS_ITEM314: "रुइन रेबर A",
  T_42_XYL_WS_LOGICALOBJECT: "लॉजिक",
  T_42_XYL_WS_THEMEHIGHTECH: "फ्यूचरिस्टिक",
  T_42_XYL_WS_THEMEICE: "आइसी",
  T_42_XYL_WS_THEMEMILITARY: "मिलिट्री",
  T_42_XYL_WS_THEMEOBJECTS: "थीम ऑब्जेक्ट",
  T_42_XYL_WS_TIMERCONTINUE: "टाइमर रिज्यूमिंग इंसीडेंट",
  T_42_XYL_WS_TIMERCYCLE: "लूप काउंट",
  T_42_XYL_WS_TIMERDOWN: "काउंटडाउन",
  T_42_XYL_WS_TIMEREND: "टाइमर एंडिंग इंसीडेंट",
  T_42_XYL_WS_TIMEREVENT: "टाइमर इंसीडेंट कस्टमाइज करें",
  T_42_XYL_WS_TIMEREVENT1: "कंट्रोल टाइमर",
  T_42_XYL_WS_TIMEREVENT2: "टाइमर इंसीडेंट सेट करें",
  T_42_XYL_WS_TIMERORDER: "समय विधि",
  T_42_XYL_WS_TIMERPAUSE: "टाइमर पॉज इंसीडेंट",
  T_42_XYL_WS_TIMERSTART1: "टाइमर स्टार्ट इंसीडेंट",
  T_42_XYL_WS_TIMERSTART2: "टाइमर स्टार्टिंग इंसीडेंट",
  T_42_XYL_WS_TIMERUP: "गिनती करो",
  T_42_XYL_WS_TRIGGERTIME_MS: "ट्रिगर समय (मिलीसेकंड में)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "एक स्काईविंग जो कई खिलाड़ियों को होल्ड कर सकता है.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "व्यक्तिगत स्कोर",
  T_42_ZZ_GUILDWAR_SCORE: "स्कोर",
  T_43_B_SKILL_DESC_MONKEYGOD: "एक झाड़ी में बदल जाता है जो [FFB300]{1}s[-] तक रहती है. कूलडाउन: [FFB300]{0}s[-]. वुकॉंग के हमला करने पर ट्रांसफॉर्मेशन बदल जाता है. जब वुकॉंग किसी दुश्मन को मार गिराता है तो CD रीसेट हो जाती है.",
  T_43_B_SKILL_DESC_Nanoscientist: "घातक डैमेज उठाने के बाद, [FFB300]{0}s[-] के लिए एक अजेय और स्थिर स्थिति में प्रवेश करें. फिर, एक [FFB300]{1} HP शील्ड[-] पाएं जो [FFB300]{2}s[-] तक चलती है. शील्ड गायब होने पर स्किल यूजर एलिमिनेट हो जाएगा. कूलडाउन: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "EP को [FFB300]{0} क्रिमसन एनर्जी[-] से रिप्लस करता है. अपनी प्रोटेक्शन को एक्टिवेट करने के लिए [FFB300]{1} क्रिमसन एनर्जी[-] का इस्तेमाल करता है, जिसके दौरान आपको डैमेज नहीं मिलेगा या दुश्मनों पर हमला नहीं कर सकते हैं और [FFB300]{4} HP[-] (दुश्मन शील्ड पॉइंट्स को नजरअंदाज करते हुए) को [FFB300]{3}m[-] के भीतर के दुश्मनों से अवशोषित कर लेंगे. [FFB300]{2}s[-] तक रहता है, जिसके दौरान आपकी मूवमेंट स्पीड [FFB300]{6}%[-] कम हो जाएगी. कूलडाउन: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "वेलोसिटी रेसर (मास्क)",
  T_43_CJ_F_B_RACER: "वेलोसिटी रेसर (बॉटम)",
  T_43_CJ_F_H_RACER: "वेलोसिटी रेसर (हेड)",
  T_43_CJ_F_HA_RACER: "वेलोसिटी रेसर (फेसपेंट)",
  T_43_CJ_F_S_RACER: "वेलोसिटी रेसर (जूते)",
  T_43_CJ_F_T_RACER: "वेलोसिटी रेसर (टॉप)",
  T_43_CJ_M_A_RACER: "टर्बो रेसर (मास्क)",
  T_43_CJ_M_B_MACHINERY: "टर्कॉइज़ टेक (बॉटम)",
  T_43_CJ_M_B_RACER: "टर्बो रेसर (बॉटम)",
  T_43_CJ_M_H_MACHINERY: "टर्कॉइज़ टेक (हेड)",
  T_43_CJ_M_H_RACER: "टर्बो रेसर (हेड)",
  T_43_CJ_M_HA_MACHINERY: "टर्कॉइज़ टेक (फेसपेंट)",
  T_43_CJ_M_S_MACHINERY: "टर्कॉइज़ टेक (जूते)",
  T_43_CJ_M_S_RACER: "टर्बो रेसर (जूते)",
  T_43_CJ_M_T_MACHINERY: "टर्कॉइज़ टेक (टॉप)",
  T_43_CJ_M_T_RACER: "टर्बो रेसर (टॉप)",
  T_43_H_CHARACTER_GEEK_N: "रायडन",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - मम्बा नॉ",
  T_43_HJ_WS_OPTION8: "अन्य",
  T_43_HJ_WS_TEXTURE_BAMBOO: "बम्बू",
  T_43_HJ_WS_TEXTURE_BEACH: "बीच",
  T_43_HJ_WS_TEXTURE_BRICK1: "ईट दिवार A",
  T_43_HJ_WS_TEXTURE_BRICK2: "ईट दिवार B",
  T_43_HJ_WS_TEXTURE_BRICK3: "ईट दिवार C",
  T_43_HJ_WS_TEXTURE_CEMENT: "कंक्रीट फ्लोर",
  T_43_HJ_WS_TEXTURE_CEMENT2: "कंक्रीट",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "क्रिस्टल",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "घास A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "घास B",
  T_43_HJ_WS_TEXTURE_ICE: "आइस ब्लॉक",
  T_43_HJ_WS_TEXTURE_IRON: "मेटल फ्लोर",
  T_43_HJ_WS_TEXTURE_IRON2: "कंटेनर",
  T_43_HJ_WS_TEXTURE_LAVA: "लावा",
  T_43_HJ_WS_TEXTURE_MARBLE: "मार्बल फ्लोर",
  T_43_HJ_WS_TEXTURE_NONE: "खाली",
  T_43_HJ_WS_TEXTURE_STONE: "पत्थर",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "टेबल कपड़ा A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "टेबल कपड़ा B",
  T_43_HJ_WS_TEXTURE_WOOD: "लकड़ी",
  T_43_HJ_WS_TEXTURE_WOODEN: "वुडेन फ्लोर A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "वुडेन फ्लोर B",
  T_43_JH_WS_MAPTAG1: "नए लोगों के लिए फ्रेंडली",
  T_43_JH_WS_MAPTAG10: "उबाऊ नया कॉन्टेंट",
  T_43_JH_WS_MAPTAG11: "इनाम की थोड़ी भावना",
  T_43_JH_WS_MAPTAG12: "इनाम असंतुलन",
  T_43_JH_WS_MAPTAG13: "प्रगति की कमजोर भावना",
  T_43_JH_WS_MAPTAG14: "नए लोगों के लिए फ्रैंडली नहीं",
  T_43_JH_WS_MAPTAG15: "भ्रमित करने वाला ट्यूटोरियल",
  T_43_JH_WS_MAPTAG16: "ट्यूटोरियल का अभाव",
  T_43_JH_WS_MAPTAG17: "काफ़ी प्लेयर गेम छोड़ देते हैं",
  T_43_JH_WS_MAPTAG18: "जटिल कंट्रोल",
  T_43_JH_WS_MAPTAG19: "अव्यवस्थित UI",
  T_43_JH_WS_MAPTAG2: "पसंदीदा न्यू कॉन्टेंट",
  T_43_JH_WS_MAPTAG20: "ख़राब मैप डिज़ाइन",
  T_43_JH_WS_MAPTAG21: "थ्रिलिंग शूटर",
  T_43_JH_WS_MAPTAG22: "फेस-पेस्ड",
  T_43_JH_WS_MAPTAG23: "ओपन वर्ल्ड",
  T_43_JH_WS_MAPTAG24: "स्टोरी-रिच",
  T_43_JH_WS_MAPTAG25: "प्रोग्रेशन",
  T_43_JH_WS_MAPTAG26: "स्पोर्ट्स सिमुलेशन",
  T_43_JH_WS_MAPTAG27: "को-ऑप मिशन",
  T_43_JH_WS_MAPTAG28: "सोशल",
  T_43_JH_WS_MAPTAG29: "विविध उदाहरण",
  T_43_JH_WS_MAPTAG3: "एक्टिव प्लेयर्स",
  T_43_JH_WS_MAPTAG30: "फ्री एक्सप्लोरेशन",
  T_43_JH_WS_MAPTAG31: "रैंकिंग चैलेंज",
  T_43_JH_WS_MAPTAG32: "अचीवमेंट",
  T_43_JH_WS_MAPTAG33: "करंसी रिडीम",
  T_43_JH_WS_MAPTAG4: "अच्छे से बना मैप",
  T_43_JH_WS_MAPTAG40: "ढेर सारे रिवॉर्ड्स",
  T_43_JH_WS_MAPTAG41: "संतोषजनक प्रगति",
  T_43_JH_WS_MAPTAG42: "पॉपुलर ट्रेनिंग ग्राउंड्स",
  T_43_JH_WS_MAPTAG43: "पॉपुलर सोलो टावर",
  T_43_JH_WS_MAPTAG44: "पॉपुलर वॉर ज़ोन",
  T_43_JH_WS_MAPTAG5: "अटकना",
  T_43_JH_WS_MAPTAG6: "हार्ड को-ऑप",
  T_43_JH_WS_MAPTAG7: "बग वाला",
  T_43_JH_WS_MAPTAG8: "कम अपडेट",
  T_43_JH_WS_MAPTAG9: "बोरिंग इन-मैच इवेंट्स",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "स्पाइडर ट्रैप (रायडन)",
  T_43_SJ_WS_AIRDROP_ITEMS: "ड्रॉप आइटम",
  T_43_SJ_WS_AIRDROP_NAME: "एयरड्रॉप",
  T_43_SJ_WS_AIRDROP_TIME: "ड्रॉप टाइम शुरू करें",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "ड्रॉप आइटम",
  T_43_SJ_WS_ANITRIGGER_AUTO: "ऑटो प्ले है",
  T_43_SJ_WS_ANITRIGGER_CENTER: "सेंटर पोजीशन है",
  T_43_SJ_WS_ANITRIGGER_CLIP: "एनीमेशन क्लिप ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "लूप है",
  T_43_SJ_WS_ANITRIGGER_NAME: "एनिमेशन ट्रिगर HUD",
  T_43_SJ_WS_RESET_ROUND: "रिसेट प्रति राउंड",
  T_43_SJ_WS_START_DROPTIME: "ड्रॉप टाइम शुरू करें (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "एनीमेशन ट्रिगर",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "पेट स्किन: म्याऊ म्याऊ जैसिल",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "मोटरबाइक - इंकार्नेशनल स्पीड",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "इसमें गोली और मेडिकल आइटम जैसी आवश्यक बैटल सप्लाई शामिल है",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "सप्लाई बॉक्स",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "एक [FFB300]{1} HP[-] पुतला तैयार करें जो आज़ादी  से [FFB300]{0}s[-] तकचलता है. जब पुतला [FFB300]{3}m[-] के भीतर हो, तो उसके साथ स्थिति बदलने के लिए फिर से स्किल का उपयोग करें. आप केवल एक बार [FFB300]{4}s[-] के भीतर, कुल मिलाकर [FFB300]{2} बार[-] तक स्विच कर सकते हैं. पुतले को नष्ट करने वाले खिलाड़ी को [FFB300]{5}s[-] के लिए मार्क किया जाएगा. कूलडाउन: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "एक्टिव स्किल",
  T_43_XXJ_WS_AIRDROP: "एयरड्रॉप और ज़ोंबी",
  T_43_XXJ_WS_ALPHA: "अल्फा",
  T_43_XXJ_WS_ALPHA_D: "HUD की सभी पारदर्शिता, 0 से 1 तक की सीमा के साथ.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "एनीमेशन कंट्रोलर ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "एनीमेशन कंट्रोलर एसेट का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_43_XXJ_WS_AUDIOID: "ऑडियो ID",
  T_43_XXJ_WS_AUDIOID_D: "किसी ऑडियो एसेट को बताने के लिए उपयोग की जाने वाली आईडी",
  T_43_XXJ_WS_BACKGRCOLOR: "बैकग्राउंड कलर",
  T_43_XXJ_WS_BACKGRCOLOR_D: "हेल्थ बार बोर्डर का रंग और धुंधला बैकग्राउंड",
  T_43_XXJ_WS_BURNING: "बर्निंग",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "कॉन्फ़िगरेशन टेबल एसेट का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_43_XXJ_WS_CURRENTHP: "मौजूदा HP",
  T_43_XXJ_WS_CURRENTHP_D: "मौजूदा HP वैल्यू",
  T_43_XXJ_WS_DAMAGEMAKER_D: "गेम एंटिटी जो डैमेज पहुंचाती है",
  T_43_XXJ_WS_DAMAGEZONE: "डैमेज जोन",
  T_43_XXJ_WS_DEFAULT: "डिफ़ॉल्ट",
  T_43_XXJ_WS_DEFAULT_D: "डिफ़ॉल्ट",
  T_43_XXJ_WS_EFFECTID: "इफ़ेक्ट ID",
  T_43_XXJ_WS_EFFECTID_D: "किसी विशेष प्रभाव वाली संपत्ति का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "एक एंटिटी जो लड़ सकती है (उदाहरण के लिए हमले शुरू कर सकती है, जिसे पर हमला किया जा सकता है, या एलिमिनेट हो सकती है)",
  T_43_XXJ_WS_FOLLOWTARGET: "टारगेट फॉलो करें",
  T_43_XXJ_WS_FOLLOWTARGET_D: "नॉकडाउन स्टेट को छोड़ें और तुरंत एलिमिनेट हो जाएं",
  T_43_XXJ_WS_GAINHPCOLOR: "HP कलर पाएं",
  T_43_XXJ_WS_GAINHPCOLOR_D: "HP का बढ़ा हुआ भाग थोड़े समय के लिए इस रंग में दिखाई देगा",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "गिरने से कोई डैमेज नहीं है",
  T_43_XXJ_WS_ISOPENTWEEN: "ओपन ट्वीन है",
  T_43_XXJ_WS_ISOPENTWEEN_D: "अलग-अलग रंगों में HP बदलाव दिखाने के लिए इसे चालू करें",
  T_43_XXJ_WS_KNOCKDOWN_D1: "प्लेयर नॉकडाउन स्थिति में है",
  T_43_XXJ_WS_KNOCKDOWN_D2: "एलिमिनेट होने पर नॉकडाउन स्थिति की प्रतिक्रिया के लिए सेटिंग्स",
  T_43_XXJ_WS_KNOCKDOWN_D3: "रिवाइवल सोर्स टाइप. किसी खिलाड़ी को गिराए जाने पर भी रिवाइव किया जा सकता है.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "नॉकडाउन स्टेट",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "नॉकडाउन स्टेट टाइप",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "नॉकडाउन स्थिति की प्रतिक्रिया: डिफ़ॉल्ट लॉजिक बनाए रखें, नॉकडाउन स्थिति को छोड़ें, या नॉकडाउन के लिए बाध्य करें.",
  T_43_XXJ_WS_LEVEL: "लेवल",
  T_43_XXJ_WS_LEVEL_D: "लेवल",
  T_43_XXJ_WS_LEVEL_D1: "मौजूदा ज़ॉम्बी लेवल",
  T_43_XXJ_WS_LINESPACING: "लाइन स्पेसिंग",
  T_43_XXJ_WS_LINESPACING_D: "दो डिवाइडरों के बीच सेगमेंट हुई एचपी ≤ 0 होने पर डिस्प्ले नहीं होता है",
  T_43_XXJ_WS_LOSEHPCOLOR: "HP रंग खोना",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "HP का घटा हुआ भाग थोड़े समय के लिए इस रंग में दिखाई देगा",
  T_43_XXJ_WS_MAINCOLOR: "मुख्य कलर",
  T_43_XXJ_WS_MAINCOLOR_D: "HP के लिए रंग, लेवल और रूपरेखा",
  T_43_XXJ_WS_MINISENTRY: "टरट",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "एनम जिस प्रकार के टारगेट पर हमला कर सकता है, उनकी सूची",
  T_43_XXJ_WS_MISSILEEXPLODE: "मिसाइल धमाका",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "नॉकडाउन करना होगा",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "फोर्स्ड नॉकडाउन",
  T_43_XXJ_WS_OFFSET: "ऑफसेट",
  T_43_XXJ_WS_OFFSET_D: "टारगेट के सापेक्ष ऑफसेट को फॉलो किया गया",
  T_43_XXJ_WS_OILDRUMEXPLODE: "ऑयल ड्रम एक्सप्लोड",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "केवल तभी ट्रिगर होता है जब कंट्रोलर मूवमेंट शुरू करता है",
  T_43_XXJ_WS_PLAYER_D: "इन-गेम प्लेयर एंटिटी. प्रत्येक प्लेयर के पास एक है.",
  T_43_XXJ_WS_PLAYERHEADHUD: "प्लेयर हेड HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "प्लेयर के हेड के ऊपर दिखाई गई जानकारी",
  T_43_XXJ_WS_PLAYERNAME: "प्लेयर नाम",
  T_43_XXJ_WS_PLAYERNAME_D: "मौजूदा हेल्थ बार मालिक का नाम दिखाता है",
  T_43_XXJ_WS_PLAYERORVEHICLE: "प्लेयर या गाड़ी",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "प्लेयर/गाड़ी एंटिटी प्रकार के लिए उपनाम",
  T_43_XXJ_WS_SCALE: "स्केल",
  T_43_XXJ_WS_SCALE_D: "मैच के लिए स्केल किए गए फ़ॉन्ट के साथ, ओवरऑल HUD स्केल साइज निर्धारित करता है।",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "डैमेज नंबर दिखाएं",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "डिफ़ॉल्ट रूप से सही. डैमेज नंबर दिखाता है.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "नॉकडाउन स्किप करें",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "नॉकडाउन स्थिति को छोड़ें और तुरंत एलिमिनेट हो जाएं",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "स्किप स्टैगर एनिमेशन है",
  T_43_XXJ_WS_TEAM_D: "(अस्वीकृत. कृपया टीम आईडी का उपयोग करें.)",
  T_43_XXJ_WS_TERRAIN: "इलाके",
  T_43_XXJ_WS_TERRAIN_D: "एक भू-भाग घटक जिसकी विशेषताओं को संशोधित नहीं किया जा सकता है. केवल फंक्शन के टेस्ट करने के लिए उपयोग किया जाता है.",
  T_43_XXJ_WS_TOTALHP: "कुल HP",
  T_43_XXJ_WS_TOTALHP_D: "कुल HP वैल्यू",
  T_43_XXJ_WS_TWEENENTITY: "ट्वीन एंटिटी",
  T_43_XXJ_WS_VEHICLEEXPLODE: "गाड़ी धमाका",
  T_43_XXJ_WS_WIDTH: "चौड़ाई",
  T_43_XXJ_WS_WIDTH_D: "दिखाई हेल्थ बार की चौड़ाई",
  T_43_XXJ_WS_ZOMBIE: "ज़ॉम्बी",
  T_43_XYL_WS_DROIDFIST: "फिस्ट (ड्रॉइड अपॉकलिप्स)",
  T_43_XYL_WS_DROIDFLAME: "फ्लैमथ्रोअर (ड्रॉइड अपॉकलिप्स)",
  T_43_XYL_WS_JAPANESE: "जापानी शैली में",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "मैच इवेंट लॉग को कस्टमाइज करें. यूजर अनुभव विश्लेषण के लिए उपयोग किया जाता है।",
  T_43_YU_WS_AIRDROPSTATE: "एयरड्रॉप स्टेट",
  T_43_YU_WS_AIRDROPSTATE_D: "एयरड्रॉप स्थिति (1: तैयार, 2: गिराना, 3: उतरा)",
  T_43_YU_WS_ANIMATIONCLIPID: "एनिमेशन क्लिप आईडी",
  T_43_YU_WS_ANIMATIONCLIPID_D: "एनीमेशन क्लिप आईडी को कस्टमाइज करें",
  T_43_YU_WS_ASKBUYTARGET: "खरीदें टारगेट पूछें",
  T_43_YU_WS_ASKBUYTARGET_D: "टारगेट बताता है और खरीद अनुरोध भेजता है",
  T_43_YU_WS_ASKEDLIST: "सूची मांगी गई",
  T_43_YU_WS_ASKEDLIST_D: "अनुरोधित आइटम की सूची",
  T_43_YU_WS_BACKGROUNDCOLOR1: "बैकग्राउंड कलर 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "बाईं ओर का रंग",
  T_43_YU_WS_BACKGROUNDCOLOR2: "बैकग्राउंड रंग 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "बॉटम बैकग्राउंड कलर",
  T_43_YU_WS_BATCHCOMBINERENDER: "बैच कंबाइन रेंडर",
  T_43_YU_WS_BINDMONEYENTITYLIST: "मोइनी एंटिटी लिस्ट बाइंड करें",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "बाउंड करेंसी एंटिटी की सूची",
  T_43_YU_WS_BINDWALLETENTITYID: "वॉलेट एंटिटी ID बाइंड करें",
  T_43_YU_WS_BINDWALLETENTITYID_D: "बाउंड वॉलेट एंटिटी की आईडी",
  T_43_YU_WS_CENTEROFFSET: "सेण्टर ओफ़्सेट",
  T_43_YU_WS_CENTEROFFSET_D: "कैप्सूल कोलाइडर के लिए ऑफसेट मान",
  T_43_YU_WS_COLLECTIONID: "कलेक्शन ID",
  T_43_YU_WS_COLLECTIONID_D: "एसेट इन्फो कलेक्शन के लिए कलेक्शन ID",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "एक एयरड्रॉप बनाएं",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "एक डैमेज संख्या बनाएँ",
  T_43_YU_WS_CROSSPLATFORM_D: "चयनित होने पर, सर्वर पर बुलाए जाने पर क्लाइंट को भेजें और ऐसे ही उल्टा होने पर.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS राउंड रिजल्ट HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "रिजल्ट प्रत्येक राउंड के आखिर में दिखते होते हैं",
  T_43_YU_WS_CURRENTEMOTECLIP: "मौजूदा इमोट क्लिप",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "वर्तमान इमोट क्लिप की आईडी",
  T_43_YU_WS_DAMAGE_D: "जोन से बाहर का डैमेज",
  T_43_YU_WS_DICTIONARY: "डिक्शनरी",
  T_43_YU_WS_DIRECTIONRULERHUD: "डिरेक्टिंग रूलर HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "टॉप पर कम्पास",
  T_43_YU_WS_DOTWEEN_D: "क्या ट्विन एनिमेशन परफॉर्म करना है",
  T_43_YU_WS_DROPITEMS_D: "एयरड्रॉप में आइटम",
  T_43_YU_WS_DURATION: "अवधि",
  T_43_YU_WS_ENERGY: "एनर्जी",
  T_43_YU_WS_ENERGY_D: "EP मॉडिकेशन वैल्यू",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "प्रोन",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "क्राउच",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "स्प्रिन्टिंग",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "स्टैंड",
  T_43_YU_WS_EVENTID: "इवेंट ID",
  T_43_YU_WS_EVENTID_D: "एक इवेंट का प्रतिनिधित्व करता है",
  T_43_YU_WS_FACTION: "फैक्शन",
  T_43_YU_WS_FACTION_D: "फैक्शन इकाई",
  T_43_YU_WS_FACTION_D1: "खरीदारी में मदद के लिए फैक्शन से पूछें",
  T_43_YU_WS_FINALRADIUS_D: "सेफ ज़ोन की फाइनल रेडियस",
  T_43_YU_WS_FIRSTAIDKIT: "मेडकिट",
  T_43_YU_WS_FIRSTAIDKIT_D: "मेड किट",
  T_43_YU_WS_FIRSTPERSONMODEL: "फर्स्ट पर्सन मॉडल",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "फर्स्ट पर्सन कैमरा",
  T_43_YU_WS_FONTCOLOR_D: "फॉन्ट कलर",
  T_43_YU_WS_FONTSIZE_D: "फॉन्ट साइज",
  T_43_YU_WS_FORBIDEN: "वर्जित",
  T_43_YU_WS_FORBIDEN_D: "खरीद अनुरोध के लिए HUD को बंद करें",
  T_43_YU_WS_FREEZINGTIME: "फ्रीजिंग टाइम",
  T_43_YU_WS_FREEZINGTIME_D: "वह अवधि जिसके लिए हिट टारगेट स्थिर रहता है",
  T_43_YU_WS_GRAVITY: "ग्रेविटी",
  T_43_YU_WS_GRAVITY_D: "गुरुत्वीय त्वरण. केवल प्लेयर नियंत्रक को प्रभावित करता है.",
  T_43_YU_WS_HANDCATAPULT: "लॉन्च पैड",
  T_43_YU_WS_HANDCATAPULT_D: "लॉन्च पैड",
  T_43_YU_WS_HEALTH: "हेल्थ",
  T_43_YU_WS_HEALTH_D: "आर्मर ड्यूबिरेलिटी का रिकवरी  वैल्यू",
  T_43_YU_WS_HEIGHT: "ऊंचाई",
  T_43_YU_WS_HELPEDPLAYER_D: "प्लेयर जिसकी हेल्प हुई",
  T_43_YU_WS_HELPPLAYER_D: "वह खिलाड़ी जो खरीदारी में सहायता करता है",
  T_43_YU_WS_HORIZONTALMAXANGLE: "क्षैतिज अधिकतम कोण",
  T_43_YU_WS_HORIZONTALMINANGLE: "क्षैतिज न्यूनतम कोण",
  T_43_YU_WS_HUDTOGGLE: "HUD टॉगल",
  T_43_YU_WS_HUDTOGGLE_D: "HudToggle एंटिटी जिसे खिलाड़ी HUD एडिटर में एडिट कर सकते हैं",
  T_43_YU_WS_INHALER: "इनहेलर",
  T_43_YU_WS_INHALER_D: "इनहेलर",
  T_43_YU_WS_INITRADIUS_D: "सेफ ज़ोन का प्रारंभिक दायरा",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "एक 64-बिट साइंड पूर्णांक",
  T_43_YU_WS_ISAPPLYSHADOW: "शैडो लागू है",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "नीचे टकरा रहा है",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "मौजूदा इमोट लूप है",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "वर्तमान इमोट एनीमेशन को लूप पर सेट करना है या नहीं",
  T_43_YU_WS_ISSIDECOLLIDING: "साइड टकरा रही",
  T_43_YU_WS_ISSLIDING: "स्लइड कर रहा है",
  T_43_YU_WS_ISTOPCOLLIDING: "टॉप टकरा रहा है",
  T_43_YU_WS_ITEM331: "फ्यूचरिस्टिक डिवाइस A",
  T_43_YU_WS_ITEM332: "ग्लोइंग रॉक A",
  T_43_YU_WS_ITEM333: "फ्यूचरिस्टिक स्क्रीन A",
  T_43_YU_WS_ITEM334: "फ्यूचरिस्टिक कंटेनर A",
  T_43_YU_WS_ITEM335: "फ्यूचरिस्टिक कंटेनर A",
  T_43_YU_WS_ITEM336: "स्टोन सोफा A",
  T_43_YU_WS_ITEM337: "फ्यूचरिस्टिक स्विच A",
  T_43_YU_WS_ITEM338: "फ्यूचरिस्टिक पाइप A",
  T_43_YU_WS_ITEM339: "मेटल प्लेटफॉर्म A",
  T_43_YU_WS_ITEM340: "फ्यूचरिस्टिक टेबल A",
  T_43_YU_WS_ITEM341: "फ्यूचरिस्टिक टेबल B",
  T_43_YU_WS_ITEM342: "फ्यूचरिस्टिक टेबल C",
  T_43_YU_WS_ITEM343: "फ्यूचरिस्टिक कंप्यूटर A",
  T_43_YU_WS_ITEM344: "स्टोन A",
  T_43_YU_WS_ITEM345: "स्टोन B",
  T_43_YU_WS_ITEM346: "स्टोन C",
  T_43_YU_WS_ITEM347: "स्टोन D",
  T_43_YU_WS_ITEM348: "स्टोन E",
  T_43_YU_WS_ITEM349: "स्टोन F",
  T_43_YU_WS_ITEM350: "स्टोन G",
  T_43_YU_WS_ITEM351: "जापानी शैली का पर्दा A",
  T_43_YU_WS_ITEM352: "जापानी शैली का परदा B",
  T_43_YU_WS_ITEM353: "जापानी शैली का पर्दा C",
  T_43_YU_WS_ITEM354: "जापानी शैली की सीढ़ियाँ A",
  T_43_YU_WS_ITEM355: "जापानी शैली की फेंस A",
  T_43_YU_WS_ITEM356: "जापानी शैली की फेंस B",
  T_43_YU_WS_ITEM357: "जापानी शैली की फेंस C",
  T_43_YU_WS_ITEM358: "जापानी शैली का प्लेटफार्म A",
  T_43_YU_WS_ITEM359: "जापानी शैली की दीवार B",
  T_43_YU_WS_ITEM360: "जापानी शैली का गेट B",
  T_43_YU_WS_ITEM361: "फ्यूचरिस्टिक वॉल D",
  T_43_YU_WS_ITEM362: "फ्यूचरिस्टिक वॉल B",
  T_43_YU_WS_ITEM363: "फ्यूचरिस्टिक एंगल बेसबोर्ड",
  T_43_YU_WS_LEFTCOLOR: "लेफ्ट कलर",
  T_43_YU_WS_LEFTCOLOR_D: "बाईं ओर का रंग",
  T_43_YU_WS_LEFTPLAYERARRAY: "लेफ्ट प्लेयर ऐरे",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "लेफ़्ट प्लेयर ऐसे",
  T_43_YU_WS_LEFTSCORE: "लेफ्ट स्कोर",
  T_43_YU_WS_LEFTSCORE_D: "बाईं ओर का स्कोर",
  T_43_YU_WS_LEFTSCOREAFTER: "बाद का लेफ्ट स्कोर",
  T_43_YU_WS_LEFTSCOREAFTER_D: "बाईं ओर का अंतिम स्कोर. स्कोर ट्रांज़िशन एनिमेशन में उपयोग किया जाता है।",
  T_43_YU_WS_LEVELOBJECTID: "लेवल ऑब्जेक्ट ID",
  T_43_YU_WS_LEVELOBJECTID_D: "वस्तु प्रकार का वर्णन करता है। लोड करने से पहले SceneEditPrefab कॉन्फ़िगरेशन टेबल के माध्यम से पार्सिंग की आवश्यकता होती है।",
  T_43_YU_WS_LOCALPOSITION_D: "लोकल कोऑर्डिनेट सिस्टम में कोऑर्डिनेट करें",
  T_43_YU_WS_LOCALPOSITION_D1: "रिलेटिव स्थिति",
  T_43_YU_WS_LOCALPOSITION_D2: "निचले दाएं एंकर के सापेक्ष स्थिति",
  T_43_YU_WS_LOCALPOSITION_D3: "एंकर के सापेक्ष स्थिति",
  T_43_YU_WS_LOCALROTATION_D: "स्थानीय कोऑर्डिनेट सिस्टम में रोटेशन एंगल (X: yaw, Y: पिच, और Z: रोल)",
  T_43_YU_WS_LOCALROTATIONQ_D: "स्थानीय कोऑर्डिनेट सिस्टम में चतुर्भुज",
  T_43_YU_WS_LOCALSCALE_D: "विश्व कोऑर्डिनेट इस्तेम में स्केल का साइज",
  T_43_YU_WS_MASS: "मास",
  T_43_YU_WS_MATERIALS: "मैटेरियल्स",
  T_43_YU_WS_MATERIALS_D: "रेंडरिंग के लिए प्रयुक्त सामग्री की सूची",
  T_43_YU_WS_MAXSPEED: "मैक्स स्पीड",
  T_43_YU_WS_MAXSPEED_D: "अधिकतम स्पीड तक पहुंचने के बाद कोई और हॉर्सपावर उत्पन्न नहीं होगी, लेकिन गाड़ी की स्पीड सीमा से अधिक हो सकती है (उदाहरण के लिए पहाड़ी से नीचे जाते समय त्वरण के माध्यम से)।",
  T_43_YU_WS_MESHID: "मैश ID",
  T_43_YU_WS_MESHID_D: "मैश टाइप का वर्णन करता है",
  T_43_YU_WS_MESHID1: "मैश ID",
  T_43_YU_WS_MESHID1_D: "रेंडरिंग के लिए उपयोग की जाने वाली जाली",
  T_43_YU_WS_MINMOVEDISTANCE: "न्यूनतम चली दूरी",
  T_43_YU_WS_MINMOVEDISTANCE_D: "इस मान से कम दूरी वाली गतिविधि एक्सेक्यूट नहीं की जाएगी. जब तक कोई विशेष आवश्यकता न हो, इसे 0 पर सेट करने का सुझाव दिया जाता है.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "एयरड्रॉप",
  T_43_YU_WS_MODULE_ANIMATION: "एनीमेशन",
  T_43_YU_WS_MODULE_AVATAR: "अवतार",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "बेस एट्रिब्यूट",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "बिहेवियर ट्री",
  T_43_YU_WS_MODULE_BUFF: "बफ",
  T_43_YU_WS_MODULE_CAMERA: "कैमरा",
  T_43_YU_WS_MODULE_CHATCHANNEL: "चैट चैनल",
  T_43_YU_WS_MODULE_CHECKPOINT: "चेकपॉइंट",
  T_43_YU_WS_MODULE_COLLECTION: "कलेक्शन",
  T_43_YU_WS_MODULE_COMBAT: "कॉम्बैट",
  T_43_YU_WS_MODULE_COMPONENT: "कॉम्पोनेन्ट",
  T_43_YU_WS_MODULE_CONVERT: "कन्वर्ट",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "रूम पैरामीटर कस्टमाइज करें",
  T_43_YU_WS_MODULE_DATABASE: "डाटा स्टोरेज",
  T_43_YU_WS_MODULE_DYEING: "डाइंग",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "डायनामिक नवमेश",
  T_43_YU_WS_MODULE_ECONOMY: "इकॉनमी",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF प्लेटफॉर्म",
  T_43_YU_WS_MODULE_FOOTBALL: "फुटबॉल",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "फ्रेम रेट मोड",
  T_43_YU_WS_MODULE_GAMERESULT: "गेम रिजल्ट",
  T_43_YU_WS_MODULE_GLOBAL: "ग्लोबल",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "ग्लोबल स्क्रिप्ट",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK और धोखाधड़ी",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "इनपुट सिस्टम",
  T_43_YU_WS_MODULE_ITEMS: "आइटम्स",
  T_43_YU_WS_MODULE_LEVELOBJECT: "लेवल ऑब्जेक्ट",
  T_43_YU_WS_MODULE_LIST: "लिस्ट",
  T_43_YU_WS_MODULE_MAP: "मैप",
  T_43_YU_WS_MODULE_MATCHING: "मैच",
  T_43_YU_WS_MODULE_MATH: "मैथ",
  T_43_YU_WS_MODULE_MECHANISM: "मैकेनिज्म पैरामीटर्स",
  T_43_YU_WS_MODULE_MINIMAP: "मिनीमैप",
  T_43_YU_WS_MODULE_MORPH: "मॉर्फ़",
  T_43_YU_WS_MODULE_OTHER: "अन्य",
  T_43_YU_WS_MODULE_PET: "पैट",
  T_43_YU_WS_MODULE_PHYSICS: "फिजिक्स",
  T_43_YU_WS_MODULE_PLAYABLE: "प्लेएब्ल",
  T_43_YU_WS_MODULE_PLAYER: "प्लेयर",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "प्लेयर स्क्रिप्ट",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "प्रीसेट कैरेक्टर",
  T_43_YU_WS_MODULE_PROFILE: "प्रोफ़ाइल",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "प्रॉपर्टी फॉर्मूला",
  T_43_YU_WS_MODULE_SAFEZONE: "सेफ ज़ोन",
  T_43_YU_WS_MODULE_SCENE: "सीन",
  T_43_YU_WS_MODULE_SKILL: "स्किल",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "स्टैटिक स्क्रिप्ट्स",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "रिपोर्ट",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD लाइब्रेरी",
  T_43_YU_WS_MODULE_STRINGS: "स्ट्रिंग्स",
  T_43_YU_WS_MODULE_TEAM: "टीम",
  T_43_YU_WS_MODULE_WORKFLOW: "वर्क फ्लो",
  T_43_YU_WS_MONEYICON: "मनी आइकॉन",
  T_43_YU_WS_MONEYICON_D: "करेंसी आइकॉन",
  T_43_YU_WS_MONEYICONCOLOR: "मनी आइकॉन कलर",
  T_43_YU_WS_MONEYICONCOLOR_D: "करेंसी आइकॉन का रंग",
  T_43_YU_WS_MOVESAFEZONE_D: "सेफ ज़ोन को उसकी प्रारंभिक स्थिति से अंतिम स्थिति तक सुचारू रूप से ले जाता है। ज़ोन के बाहर के खिलाड़ियों को एक निश्चित मात्रा में डैमेज उठाना पड़ेगा.",
  T_43_YU_WS_NEWVECTOR2: "नया वेक्टर2",
  T_43_YU_WS_NEWVECTOR2_D: "एक नया 2D वेक्टर प्राप्त होता है",
  T_43_YU_WS_OFFSET_D: "टारगेट इकाई के रिलेटिव विश्व स्थिति ऑफसेट",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "जब प्लेयर खरीद अनुरोध पूरा हो जाता है",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "जब कोई खिलाड़ी स्टोर में खरीदारी के लिए मदद का अनुरोध करता है",
  T_43_YU_WS_ONTOGGLECHANGE_D: "जब टॉगल घटक स्थिति बदलती है तो ट्रिगर होता है",
  T_43_YU_WS_OPENSTATE: "स्टेट खोलें",
  T_43_YU_WS_OPENSTATE_D: "सही पर सेट होने पर दिखता है और नहीं होने पर छिप जाता है",
  T_43_YU_WS_PACEMAKER: "होरीज़ालाइन",
  T_43_YU_WS_PACEMAKER_D: "होरीज़ालाइन",
  T_43_YU_WS_PARAMS_D: "पैरामीटर की लिस्ट",
  T_43_YU_WS_PARENT_D: "क्रमांकन के दौरान दर्ज की गई एंटिटी आईडी",
  T_43_YU_WS_PHYSICALCCT: "फिजिकल CCT",
  T_43_YU_WS_PHYSICALCCT_D: "फिजिकल इफ़ेक्ट वाला प्लेयर कंट्रोलर",
  T_43_YU_WS_PLAYER_D: "खरीदने वाला खिलाड़ी",
  T_43_YU_WS_PLAYERDATAID: "प्लेयर डेटा ID",
  T_43_YU_WS_PLAYERDATAID_D: "कैरेक्टर एसेट आईडी को कस्टमाइज करें",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "प्लेयर PhysX पोज़ प्रकार",
  T_43_YU_WS_POSITION: "पोजीशन",
  T_43_YU_WS_POSITION_D: "वर्ल्ड कोऑर्डिनेट सिस्टम कोऑर्डिनेट",
  T_43_YU_WS_POSITION_D1: "विश्व कोऑर्डिनेट सिस्टम में कोऑर्डिनेट. केवल 3D संगीत के लिए प्रभावी।",
  T_43_YU_WS_PRESSEDSPRITE: "प्रेस्ड स्प्राइट",
  T_43_YU_WS_PRESSEDSPRITE_D: "प्रेस्ड स्प्राइट",
  T_43_YU_WS_PRESSEDSPRITETYPE: "प्रेस्ड स्प्राइट टाइप",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "प्रेस्ड स्प्राइट टाइप",
  T_43_YU_WS_PRETIME: "प्रीटाइम",
  T_43_YU_WS_RADIUS: "रेडियस",
  T_43_YU_WS_RANDOMRANGE_D: "रैंडम रेंज के आधार पर निर्धारित स्थिति को ठीक करें",
  T_43_YU_WS_REQUESTPURCHASETYPE: "खरीद टाइप का अनुरोध करें",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "स्टोर में खरीदारी का अनुरोध",
  T_43_YU_WS_REQUESTTYPE: "रिक्वेस्ट टाइप",
  T_43_YU_WS_REQUESTTYPE_D: "वर्तमान HUD प्लेयर द्वारा अनुरोधित टारगेट का टाइप",
  T_43_YU_WS_RESPLAYERUUID: "प्रीसेट प्लेयर टाइप",
  T_43_YU_WS_RESPLAYERUUID_D: "प्लेयर एसेट ID",
  T_43_YU_WS_RESUUID: "एसेट UUID",
  T_43_YU_WS_RESUUID_D: "प्रस्तुत की जाने वाली बैच संपत्ति का यूयूआईडी बताता है",
  T_43_YU_WS_RIGHTCOLOR: "राइट कलर",
  T_43_YU_WS_RIGHTCOLOR_D: "दाईं ओर का रंग",
  T_43_YU_WS_RIGHTPLAYERARRAY: "राइट प्लेयर ऐरे",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "सही खिलाड़ी ऐरे",
  T_43_YU_WS_RIGHTSCORE: "राइट स्कोर",
  T_43_YU_WS_RIGHTSCORE_D: "दाहिनी ओर का स्कोर",
  T_43_YU_WS_RIGHTSCOREAFTER: "सही स्कोर के बाद",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "दाहिनी ओर का फाइनल स्कोर. स्कोर ट्रांज़िशन एनिमेशन में उपयोग किया जाता है.",
  T_43_YU_WS_ROTATIONQ_D: "विश्व समन्वय प्रणाली में चतुर्भुज",
  T_43_YU_WS_ROUNDINFOHUD: "राउंड जानकारी HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "राउंड की शुरुआत में प्रदर्शित जानकारी",
  T_43_YU_WS_SELECTEDCOLOR: "चुना कलर",
  T_43_YU_WS_SELECTEDCOLOR_D: "चुना स्प्राइट रंग",
  T_43_YU_WS_SELECTEDSPRITE: "चुनी स्प्राइट",
  T_43_YU_WS_SELECTEDSPRITE_D: "चुनी स्प्राइट",
  T_43_YU_WS_SELECTEDTYPE: "चुना टाइप",
  T_43_YU_WS_SELECTEDTYPE_D: "चुनी स्प्राइट टाइप",
  T_43_YU_WS_SHADOWCOLOR: "शैडो कलर",
  T_43_YU_WS_SHADOWOFFSET: "शैडो ऑफसेट",
  T_43_YU_WS_SHOWTAG: "टैग दिखाएँ",
  T_43_YU_WS_SHOWTAG_D: "टीम/फैक्शन मार्किंग दिखाएँ",
  T_43_YU_WS_SHRINKDURATION_D: "सेफ ज़ोन की सिकुड़न अवधि",
  T_43_YU_WS_SIMPLERENDER_D: "ब्रिजिंग रेंडरिंग कॉम्पोनेन्ट का उपयोग बिल्ड इन मॉडल के साथ रेंडरिंग के लिए किया जाता है",
  T_43_YU_WS_SKINWIDTH: "स्किन की चौड़ाई",
  T_43_YU_WS_SKINWIDTH_D: "कैरेक्टर को फंसने या घबराने से रोकने के लिए कैप्सूल में प्रवेश की गहराई",
  T_43_YU_WS_SLOPELIMIT: "स्लोप लिमिट",
  T_43_YU_WS_SLOPELIMIT_D: "इस कोण से अधिक ढलान पर रखी वस्तुएँ नीचे की ओर खिसकेंगी",
  T_43_YU_WS_SPEED: "स्पीड",
  T_43_YU_WS_STARTDROPTIME_D: "एयरड्रॉप आने का समय मिलीसेकेंड में",
  T_43_YU_WS_STARTPOS_D: "सेफ ज़ोन की शुरुआती स्थिति",
  T_43_YU_WS_STATICICONCOLORS: "स्टैटिक आइकॉन कलर",
  T_43_YU_WS_STATICICONCOLORS_D: "रूलर पर आइकन के रंग दिखाए गए हैं",
  T_43_YU_WS_STATICICONS: "स्टैटिक आइकॉन",
  T_43_YU_WS_STATICICONS_D: "रूलर पर दिखाये आइकॉन",
  T_43_YU_WS_STEPOFFSET: "स्टेप ऑफसेट",
  T_43_YU_WS_STEPOFFSET_D: "केवल इस ऊंचाई से अधिक की बाधाओं पर ही ब्लॉक इफ़ेक्ट पड़ेगा",
  T_43_YU_WS_SUBTITLE: "सबटाइटल",
  T_43_YU_WS_SUBTITLE_D: "सबटाइटल",
  T_43_YU_WS_TARGET: "टारगेट",
  T_43_YU_WS_TARGET_D: "दिखाई डैमेज संख्या के लिए टारगेट एंटिटी",
  T_43_YU_WS_TARGETICONCOLORS: "टारगेट आइकॉन कलर्स",
  T_43_YU_WS_TARGETICONCOLORS_D: "मार्क्ड टारगेट द्वारा दिखाए गए आइकन के रंग",
  T_43_YU_WS_TARGETICONS: "टारगेट रेंज",
  T_43_YU_WS_TARGETICONS_D: "मार्क किया टारगेट द्वारा दिखाए गए आइकॉन",
  T_43_YU_WS_TARGETPOS_D: "सेफ ज़ोन की टारगेट अंतिम स्थिति",
  T_43_YU_WS_TEAM: "टीम",
  T_43_YU_WS_TEAM_D: "गेम में टीम एंटिटी. प्रत्येक टीम में एक एंटिटी होती है.",
  T_43_YU_WS_TEAM_D1: "खरीदारी में सहायता के लिए टीम से पूछें",
  T_43_YU_WS_TIMEOFSTAY_D: "डिस्प्ले अवधि मिलीसेकंड में",
  T_43_YU_WS_TITLE: "टाइटल",
  T_43_YU_WS_TITLE_D: "मुख्य टाइटल",
  T_43_YU_WS_TRANSFORM_D: "रोटेशन, स्केलिंग और अभिभावक-बच्चे का रिकॉर्ड",
  T_43_YU_WS_UNSELECTEDCOLOR: "अचयनित रंग",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "अचयनित स्प्राइट रंग",
  T_43_YU_WS_UNSELECTEDSPRITE: "अचयनित स्प्राइट",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "न चुनी स्प्राइट",
  T_43_YU_WS_UNSELECTEDTYPE: "अचयनित प्रकार",
  T_43_YU_WS_UNSELECTEDTYPE_D: "अचयनित स्प्राइट टाइप",
  T_43_YU_WS_USEPHYSICALCCT: "फिजिकल सीसीटी का प्रयोग करें",
  T_43_YU_WS_VALUE_D: "दिखाया कंटेंट",
  T_43_YU_WS_VECTOR2ADD: "वेक्टर2 जोड़ें",
  T_43_YU_WS_VECTOR2GETX: "वेक्टर2 X पाएं",
  T_43_YU_WS_VECTOR2GETY: "वेक्टर2 Y पाएं",
  T_43_YU_WS_VECTOR2SCALE: "वेक्टर2 स्केल",
  T_43_YU_WS_VECTOR2SETX: "वेक्टर2 सेट X",
  T_43_YU_WS_VECTOR2SETY: "वेक्टर2 सेट Y",
  T_43_YU_WS_VECTOR2SUB: "वेक्टर2 सब",
  T_43_YU_WS_VELOCITY: "गति",
  T_43_YU_WS_VERTICALMAXANGLE: "लंबवत अधिकतम कोण",
  T_43_YU_WS_VERTICALMINANGLE: "लंबवत न्यूनतम कोण",
  T_43_YU_WS_VISIBILITY_D: "इंडीकेट करता है कि क्या विजिबिलिटी सेट की जा सकती है",
  T_43_YU_WS_VISIBLE_D: "विज़िबिलिटी सेटिंग. यदि अदृश्य पर सेट किया जाता है, तो क्लाइंट टारगेट को प्रस्तुत करना बंद कर देता है।",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "फ्यूचरिस्टिक वॉल A",
  T_43_ZY_WS_ITEM320: "फ्यूचरिस्टिक वॉल C",
  T_43_ZY_WS_ITEM321: "फ्यूचरिस्टिक विंडो",
  T_43_ZY_WS_ITEM322: "फ्यूचरिस्टिक डोर",
  T_43_ZY_WS_ITEM323: "फ्यूचरिस्टिक तिरछी छत",
  T_43_ZY_WS_ITEM324: "फ्यूचरिस्टिक गोलाकार छत",
  T_43_ZY_WS_ITEM325: "फ्यूचरिस्टिक बेसबोर्ड",
  T_43_ZY_WS_ITEM326: "फ्यूचरिस्टिक गोलाकार बेसबोर्ड",
  T_43_ZY_WS_ITEM327: "फ्यूचरिस्टिक सीढ़ी",
  T_43_ZY_WS_ITEM328: "फ्यूचरिस्टिक  डेकोरेशन A",
  T_43_ZY_WS_ITEM329: "फ्यूचरिस्टिक बिल्डिंग A",
  T_43_ZY_WS_ITEM330: "फ्यूचरिस्टिक बिल्डिंग B",
  T_44_CJ_M_B_SPORT_TH: "जिम यूनिफॉर्म (बॉटम)",
  T_44_CJ_M_H_SPORT_TH: "जिम यूनिफॉर्म (हेड)",
  T_44_CJ_M_S_SPORT_TH: "जिम यूनिफॉर्म (जूते)",
  T_44_CJ_M_T_SPORT_TH: "जिम यूनिफॉर्म (टॉप)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "काइरोस",
  T_44_H_M24_ONIMUSHA_N: "M24 - अटैक-ओ-द विस्प",
  T_44_H_USP45_CARNIVORE_N: "USP - पॉइज़न टूथ",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "मोटरबाइक - थंडरस्ट्रोक",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-II",
  T_44_JH_WS_CLHALF1: "न्यूनतम के साथ बलपूर्वक प्रारंभ करें. खिलाड़ियों",
  T_44_JH_WS_HALFWAYKEY1: "पूरी टीम के साथ शुरुआत को प्राथमिकता दें",
  T_44_PD_PVE_DRAGON_NAME: "मेकाड्रेक",
  T_44_QL_GRENADE_DRAGON: "ड्रैगन फ्रीज़",
  T_44_QL_GRENADE_DRAGON_DES: "एक अपग्रेडेड फ़्लैश फ़्रीज़ जो इफ़ेक्ट पड़ने पर लगातार तीन बार विस्फोट करेगा",
  T_44_QL_JUMPSHOESX: "ड्रैगन स्प्रिंटर्स",
  T_44_QL_JUMPSHOESX_DES: "ख़ास जंपिंग जूतों की एक जोड़ी जिससे दोहरी छलांग के दौरान हवा में तेजी से दौड़ सकते हैं.",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "सेफ ज़ोन के बंद होने का समय",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "वह समय जब सेफ ज़ोन गायब हो जाता है. यदि सेफ ज़ोन बंद होने का समय सेफ ज़ोन प्रारंभ समय से कम है, तो कोई सेफ ज़ोन उत्पन्न नहीं होगा.",
  T_44_SJ_WS_SAFEZONE_COLOR: "सेफ ज़ोन कलर",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "डैमेज अंतराल",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "डैमेज अंतराल",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "डैमेज वैल्यू",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "एक ही इवेंट में ज़ोन से बाहर के खिलाड़ी को डैमेज पहुँचाया गया",
  T_44_SJ_WS_SAFEZONE_DESC: "ज़ोन से बाहर रखने योग्य एक वस्तु",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "ज़ोन से बाहर आखिरी रेडियस",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "ज़ोन से बाहर एरिया का अंतिम रेडियस",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "सेफ ज़ोन प्लेयर लिस्ट",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "सेफ ज़ोन में प्लेयर की लिस्ट पाएं",
  T_44_SJ_WS_SAFEZONE_NAME: "ज़ोन से बाहर का एरिया",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "सिकुड़ने की अवधि (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "ज़ोन छोटा होने में लगने वाला समय",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "जोन के बहार की शुरुआती रेडियस",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "जोन के बहार की शुरुआती रेडियस",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "सिकुड़ने शुरू होना का टाइम",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "सिकुड़ना शुरू होने का टाइम",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "सेफ ज़ोन टाइम",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "वह समय जब मैच के प्रत्येक राउंड में सेफ़ जोन दिखाई देता है. डिफ़ॉल्ट 0 है.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "अल्फा एक्टिवेट",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "अल्फा एक्टिव हुआ",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "एक्टिव स्किल बटन HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "किसी एंटिटी में एक कॉम्पोनेन्ट जोड़ें. केवल कस्टम कॉम्पोनेन्ट को सपोर्ट करता है. (यदि कोई इवेंट पहले से मौजूद है तो उसे दोबारा नहीं जोड़ा जाएगा।)",
  T_44_XXJ_WS_ALLMEMBERS: "सभी मेंबर",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "बाहर दबाने की अनुमति दें",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "बताये क्षेत्र के बाहर ट्रिगर करने की अनुमति दें",
  T_44_XXJ_WS_ARROWIMAGE: "एरो इमेज",
  T_44_XXJ_WS_ARROWIMAGE_D: "तीर की इमेज",
  T_44_XXJ_WS_ARROWOFFSET: "एरो ऑफसेट",
  T_44_XXJ_WS_ARROWOFFSET_D: "एरो ऑफ़्सेट",
  T_44_XXJ_WS_ARROWSIZE: "एरो साइज",
  T_44_XXJ_WS_ARROWSIZE_D: "तीर का साइज",
  T_44_XXJ_WS_AUTOPLAY_D: "बनाने पर अपने आप चलता है",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "बैकग्राउंड इमेज",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "बेस इमेज",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "बैकग्राउंड रेडियस",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "बेस रेडियस",
  T_44_XXJ_WS_BAGSKINID: "बैकपैक स्किन ID",
  T_44_XXJ_WS_BAGSKINID_D: "बैकपैक स्किन ID",
  T_44_XXJ_WS_BONEPOSITION: "बोन पोजीशन",
  T_44_XXJ_WS_BONEPOSITION_D: "बोन नोड वर्ल्ड कोऑर्डिनेट",
  T_44_XXJ_WS_CCTMOVE: "CCT मूव करें",
  T_44_XXJ_WS_COLLIDER: "कोलाइडर",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "कॉलाइडर",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "टकराव के आकार का वर्णन करने के लिए उपयोग किया जाने वाला घटक",
  T_44_XXJ_WS_COLOR: "कलर",
  T_44_XXJ_WS_CONTENT: "कॉन्टेंट",
  T_44_XXJ_WS_CONTENT_D: "वॉलेट कॉन्टेंट करंसी का एक कलेक्शन है",
  T_44_XXJ_WS_CONTEXT_D: "प्रिंट की जाने वाला कॉन्टेंट",
  T_44_XXJ_WS_CROSSHAIRSHUD: "क्रॉसहेयर HUD",
  T_44_XXJ_WS_CURVE_D: "कर्व",
  T_44_XXJ_WS_EFFECTCOLOR_D: "सतह की बनावट का रंग",
  T_44_XXJ_WS_ENABLE: "चालू करें",
  T_44_XXJ_WS_ENTITY_D: "एंटिटी",
  T_44_XXJ_WS_GETBAGSKINID_D: "प्लेयर बैकपैक स्किन कॉन्फ़िगरेशन पाएं",
  T_44_XXJ_WS_GETFACTION_D: "फैक्शन पाएं",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "लोड किए गए सीन्स पाएं  जिन्हें अनइंस्टॉल नहीं किया गया है",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "लोकल प्लेयर पाएं",
  T_44_XXJ_WS_GROUPID: "ग्रुप ID",
  T_44_XXJ_WS_GROUPID_D: "आंतरिक लॉजिक के लिए",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD जॉयस्टिक विजेट",
  T_44_XXJ_WS_HUDJOYSTICK_D: "जॉयस्टिक एंटिटी. प्लेयर्स HUD एडिटर से HUD को एडिट कर सकते हैं।",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD टचपैड विजेट",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "HUD टचपैड विजेट जिसे खिलाड़ी HUD एडिटर में एडिट कर सकते हैं",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "कस्टम HUD या HUD विजेट",
  T_44_XXJ_WS_ICON: "आइकॉन",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "हमेशा मार्क दिखाएं",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "कंपास पर हमेशा निशान दिखाएं",
  T_44_XXJ_WS_INACTIVATEDALPHA: "निष्क्रिय अल्फा",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "निष्क्रिय अल्फ़ा",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "कॉल करते समय, वास्तविक मापदंडों की संख्या औपचारिक मापदंडों से मेल नहीं खाती है. अपेक्षित संख्या {0} है, जबकि वास्तविक संख्या {1} है.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "डायनामिक बाधा है",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "NavMesh के लिए एक डायनामिक बाधा है",
  T_44_XXJ_WS_ISEND: "ख़त्म है",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "सर्वर से चलने वाला",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "अगर गलत है, तो कस्टम ऑब्जेक्ट को APIs द्वारा नियंत्रित नहीं किया जा सकता है।",
  T_44_XXJ_WS_ISSUC_D: "रिटर्न एक्सेक्यूशन रिजल्ट",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "जॉयस्टिक ड्रैग रेडियस",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "जॉयस्टिक ड्रैग रेडियस",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "जॉयस्टिक इमेज",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "जॉयस्टिक इमेज",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "जॉयस्टिक रेडियस",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "जॉयस्टिक त्रिज्या",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "कैरेक्टर स्किल आईडी लिस्ट",
  T_44_XXJ_WS_LOOPTYPE_D: "लूप टाइप",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "बीच में ही कॉन्फ़िग से बाहर निकलें",
  T_44_XXJ_WS_MOUNTABLE: "श्रेणीबद्ध",
  T_44_XXJ_WS_MOUNTABLE_D: "चाइल्ड नोड्स माउंट करने में सक्षम एंटिटी",
  T_44_XXJ_WS_MOVEMENT: "मूवमेंट",
  T_44_XXJ_WS_NAME_D: "नाम",
  T_44_XXJ_WS_NATURALCONST: "नेचुरल कांस्टेंट",
  T_44_XXJ_WS_NATURALCONST_D: "अनावश्यक परिभाषाओं को कम करने के लिए एनम स्थिरांकों की गणना",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "प्ले आइकॉन एनिमेशन",
  T_44_XXJ_WS_OFFSET_D: "डिफ़ॉल्ट बेस ऑफसेट",
  T_44_XXJ_WS_ONFIRE_D: "हर बार जब प्लेयर गोली चलाता है, फिस्ट से हमला करता है, या मेले वेपन से हमला करता है तो इवेंट शुरू हो जाती है.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "जब खिलाड़ी प्रोन/क्राउच होता है तो इवेंट ट्रिगर होता है",
  T_44_XXJ_WS_ONSTARTFIRE_D: "जब प्लेयर्स फायर बटन पर टैप करता है तो इवेंट ट्रिगर होता है",
  T_44_XXJ_WS_OPTION: "विकल्प",
  T_44_XXJ_WS_PASSIVESKILLHUD: "पैसिव स्किल HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "फिजिकल मूवर",
  T_44_XXJ_WS_PHYSICALMOVER_D: "इस प्लेटफॉर्म पर खिलाड़ी अपने आप रूप से मूवमेंट और रोटेशन का पालन करेंगे",
  T_44_XXJ_WS_PHYSICALOBJECT: "फिजिकल ऑब्जेक्ट",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "उस पर बल लगा सकते हैं",
  T_44_XXJ_WS_PI: "पाई",
  T_44_XXJ_WS_PI_D: "गणितीय नियतांक π (पाई)",
  T_44_XXJ_WS_PLAYERS: "प्लेयर लिस्ट",
  T_44_XXJ_WS_PLAYERS_D: "प्लेयर लिस्ट",
  T_44_XXJ_WS_PLAYERSKILLID: "कैरेक्टर स्किल ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "AvatarSkill.csv में कैरेक्टर आईडी",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "प्लेयर्स के खड़े होने से पहले की पिछला पोज़",
  T_44_XXJ_WS_PRINT: "प्रिंट",
  T_44_XXJ_WS_PRINTERROR: "प्रिंट एरर",
  T_44_XXJ_WS_PRINTERROR_D: "कंसोल पर एरर के रूप में टारगेट डेटा प्रिंट करें",
  T_44_XXJ_WS_PRINTWARNING: "प्रिंट चेतवानी",
  T_44_XXJ_WS_PRINTWARNING_D: "कंसोल पर चेतावनी के रूप में टारगेट डेटा प्रिंट करें",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "प्लेयर स्किन कॉन्फ़िगरेशन को प्राथमिकता दें",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "आउट-ऑफ़-मैच खिलाड़ी स्किन कॉन्फ़िगरेशन को प्राथमिकता दें",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "किसी रो की सेल में कंटेंट को कॉलम संख्या और की से पढ़ें",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "क्लियर प्लेयर बैकपैक स्किन कॉन्फ़िगरेशन",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "किसी एंटिटी से एक घटक निकालें. केवल कस्टम घटकों का सपोर्ट करता है.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "प्लेयर बैकपैक स्किन कॉन्फ़िगरेशन को उसके आउट-ऑफ़-मैच कॉन्फ़िगरेशन पर रीसेट करें",
  T_44_XXJ_WS_SETBAGSKINID_D: "प्लेयर बैकपैक स्किन कॉन्फ़िगरेशन सेट करें",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "ट्रांसफॉर्म, स्केलेटनपार्ट, प्लेयर और माउंटपॉइंट घटकों का सपोर्ट करने वाली इकाई",
  T_44_XXJ_WS_SHOWBACKGROUND: "बैकग्राउंड दिखाएं",
  T_44_XXJ_WS_SKINID_D: "बैकपैक स्किन ID और स्किन कॉन्फ़िगरेशन",
  T_44_XXJ_WS_SPEED_D: "प्लेबैक स्पीड",
  T_44_XXJ_WS_TARGET: "टारगेट",
  T_44_XXJ_WS_TARGET_D: "टारगेट ऑब्जेक्ट",
  T_44_XXJ_WS_TITLE: "टाइटल",
  T_44_XXJ_WS_TYPEID_D: "कॉम्पोनेन्ट प्रकार आईडी. केवल कस्टम कॉम्पोनेन्ट को सपोर्ट  करता है.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "अपलोड कस्टम मैच रिजल्ट",
  T_44_XXJ_WS_WARNINGCSVTYPE: "मिसमैच टाइप. टेबल कंटेंट पढ़ने में असमर्थ.",
  T_44_XXJ_WS_X_D: "X-अक्ष कोऑर्डिनेट",
  T_44_XXJ_WS_Y_D: "Y-अक्ष कोऑर्डिनेट",
  T_44_XYL_WS_CTZSAFEZONE: "कस्टम सेफ ज़ोन",
  T_44_XYL_WS_CTZSAFEZONEDESC: "सेट पोजीशन और प्रॉपर्टी के आधार पर एक सेफ ज़ोन का आरंभ और अंत बिंदु उत्पन्न करता है",
  T_44_XYL_WS_HEMISPHERICALSHELL: "अर्धगोलाकार शैल",
  T_44_XYL_WS_QUARTERCYLINDER: "क्वार्टर सिलेंडर",
  T_44_XYL_WS_SQUAREPYRAMID: "चौकोर पिरामिड",
  T_44_XYL_WS_TORUS: "टॉरस",
  T_44_XYL_WS_TRIANGULARPYRAMID: "त्रिकोणीय पिरामिड",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "गेम इवेंट लॉग मैप जोड़ें",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "यूज़र इवेंट लॉग जोड़ें",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "UX डेटा विश्लेषण के लिए उपयोग किया जाने वाला कस्टम मैच इवेंट लॉग",
  T_44_YU_WS_ITEM366: "मिलिट्री वॉल A",
  T_44_YU_WS_ITEM367: "मिलिट्री वॉल B",
  T_44_YU_WS_ITEM368: "मिलिट्री वॉल C",
  T_44_YU_WS_ITEM369: "मिलिट्री वॉल D",
  T_44_YU_WS_ITEM370: "मिलिट्री विंडो A",
  T_44_YU_WS_ITEM371: "मिलिट्री विंडो B",
  T_44_YU_WS_ITEM372: "मिलिट्री विंडो C",
  T_44_YU_WS_ITEM373: "मिलिट्री डोर A",
  T_44_YU_WS_ITEM374: "मिलिट्री डोर C",
  T_44_YU_WS_ITEM375: "मिलिट्री एंगल रूफ A",
  T_44_YU_WS_ITEM376: "मिलिट्री एंगल रूफ B",
  T_44_YU_WS_ITEM377: "मिलिट्री सीढियाँ A",
  T_44_YU_WS_ITEM378: "मिलिट्री सीढियाँ B",
  T_44_YU_WS_ITEM379: "मिलिट्री पिलर A",
  T_44_YU_WS_ITEM380: "मिलिट्री हैंडरेल A",
  T_45_C_WEAPON_CUST_ENTRANCE: "कस्टमाइज़",
  T_45_CJ_TREATMENTGUN_Y_N: "हील पिस्टल -Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "कैसी",
  T_45_H_EMOTE_MVPDANCE_N: "चैंपियंस वॉक",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "इंस्पेक्ट",
  T_45_HL_Moderation_fail_1: "दुर्भाग्यवश, आपका सबमिट किया गया प्रोजेक्ट रिव्यू में पास नहीं हो सका.",
  T_45_HL_Moderation_fail_2: "शामिल है",
  T_45_HL_Moderation_fail_3: "वजह शामिल है:",
  T_45_HL_Moderation_fail_Location_1: "गेम कॉन्टेंट",
  T_45_HL_Moderation_fail_reason_1: "टॉक्सिक कॉन्टेंट",
  T_45_HL_Moderation_fail_reason_10: "कम्युनिटी दिशानिर्देश का उल्लंघन",
  T_45_HL_Moderation_fail_reason_11: "इन-गेम इकॉनमी और वर्चुअल प्रॉपर्टी उल्लंघन पर नकारात्मक प्रभाव",
  T_45_HL_Moderation_fail_reason_2: "अनुपयुक्त कॉन्टेंट",
  T_45_HL_Moderation_fail_reason_3: "पॉलीटिकली सेंसिटिविटी",
  T_45_HL_Moderation_fail_reason_4: "गलत जानकारी",
  T_45_HL_Moderation_fail_reason_5: "कॉपीराइट उल्लंघन",
  T_45_HL_Moderation_fail_reason_6: "गोपनीयता का उल्लंघन",
  T_45_HL_Moderation_fail_reason_7: "सिक्योरिटी समस्या",
  T_45_HL_Moderation_fail_reason_8: "हेट स्पीच",
  T_45_HL_Moderation_fail_reason_9: "स्पैम",
  T_45_HL_Moderation_fail_reason_999: "अन्य समस्या",
  T_45_JH_WS_CLEMPTYOBJECT: "ऑब्जेक्ट ग्रुप",
  T_45_JH_WS_PETSWITCH1: "मैच में पैटदिखाना है या नहीं",
  T_45_QL_CSFPP_DES: "इस स्पेशल सीएस मोड में फर्स्ट-पर्सन पर्सपेक्टिव से सभी विरोधियों को एलिमिनेट करें!",
  T_45_QL_CSFPP_NAME: "क्लैश स्क्वाड: FPP",
  T_45_QL_CSFPP_RANKNAME: "फर्स्ट-पर्सन",
  T_45_SJ_WS_REVIEW_23: "गेम कॉन्टेंट",
  T_45_SJ_WS_REVIEW_24: "{0} में {1} शामिल है",
  T_45_SJ_WS_REVIEW_25: "{0} {1} में {2} शामिल है",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]डिटेल देखने के लिए टैप करें >>[-]",
  T_45_SJ_WS_REVIEW_27: "अप्रूव नहीं हुआ",
  T_45_SJ_WS_REVIEW_28: "रिव्यू फ़ीडबैक",
  T_45_SJ_WS_REVIEW_29: "कॉन्टेंट में {0} उल्लंघन शामिल हैं",
  T_45_SJ_WS_REVIEW_31: "अप्रूव नहीं हुआ",
  T_45_SJ_WS_REVIEW_32: "सर्वर अपवादों के कारण रिव्यू विफल रहा",
  T_45_SJ_WS_REVIEW_TITLE: "उल्लंघन की डेटल",
  T_45_SJ_WS_VAULTTRIGGER_DES: "ट्रिगर वॉल्टिंग (बाधाओं पर कूदना)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "वॉल्ट दूरी",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "वॉल्टिंग की दूरी को संशोधित करता है",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "वॉल्ट हाइट",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "वॉल्टिंग करते समय ऊपर और नीचे जाने की ऊंचाई को कंट्रोल करता है",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "वॉल्ट ट्रिगर",
  T_45_TYC_CL_TEMPLATE_WS: `एक एलिमिनेशन मोड जहाँ खिलाड़ी सभी विरोधी टीमों को हटाकर इस कैओस भरी बैटल में जीत हासिल करते हैं.
आप गेमप्ले रूल्स और पैरामीटर्स को अपनी पसंद के अनुसार सेट कर सकते हैं.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "स्काईब्लास्टर",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = ऑटो अटैक, 1 = डिफेंस अटैक, 2 = अटैक न करें",
  T_45_XXJ_WS_ADDFRIEND: "दोस्त जोड़ें",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "ऑटो",
  T_45_XXJ_WS_BASEDATA: "बेस ड",
  T_45_XXJ_WS_BOTH: "दोनों",
  T_45_XXJ_WS_BYHIERARCHY: "पदानुक्रम से",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "ज़्यादा से कम के हिसाब से",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "कम से ज़्यादा के हिसाब से",
  T_45_XXJ_WS_CAMERA: "कैमरा",
  T_45_XXJ_WS_CAMERATYPE: "कैमरा टाइप",
  T_45_XXJ_WS_CENTERINVISIBLE: "सेंटर इनविजिबल",
  T_45_XXJ_WS_CLIENT: "क्लाइंट",
  T_45_XXJ_WS_COLLIDERID: "कोलाइडर ID",
  T_45_XXJ_WS_COLLIDERID_D: "कॉलाइडर ID",
  T_45_XXJ_WS_COMPONENT: "कॉम्पोनेन्ट",
  T_45_XXJ_WS_CURRENTCAMERA: "मौजूदा कैमरा",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "कस्टम पुश फाॅर्स",
  T_45_XXJ_WS_DOUBLE: "डबल",
  T_45_XXJ_WS_DUMP: "थ्रो",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "मिडएयर में मूव चालू करें",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "ग्रैविटी के साथ रोटेट को चालू करें",
  T_45_XXJ_WS_ENUM: "एनम",
  T_45_XXJ_WS_EVENT: "इवेंट",
  T_45_XXJ_WS_FILLAMOUNT: "फिल अमाउंट",
  T_45_XXJ_WS_FILLDIR: "फिल डायरेक्शन",
  T_45_XXJ_WS_FIRETYPE: "फायर टाइप",
  T_45_XXJ_WS_FIRETYPE_D: "फायरिंग टाइप",
  T_45_XXJ_WS_FIXEDDELTATIME: "फिक्स्ड डेल्टा टाइम",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "फ़्रेम अपडेट के लिए निश्चित समय अंतराल मिलीसेकंड में",
  T_45_XXJ_WS_FORWARD: "आगे",
  T_45_XXJ_WS_FORWARD_D: "लोकल कोऑर्डिनेट सिस्टम में z-अक्ष की दिशा",
  T_45_XXJ_WS_FUNCTIONTYPE: "फंक्शन टाइप",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "फंक्शन टाइप",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "स्थानीय खिलाड़ी की ऐम डायरेक्शन",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "स्थानीय टाइमस्टैम्प पाएं",
  T_45_XXJ_WS_GRADIENT: "ग्रेडिएंट",
  T_45_XXJ_WS_GRADIENTBOTTOM: "ग्रेडिएंट बॉटम",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "ग्रेडिएंट बॉटम अल्फा",
  T_45_XXJ_WS_GRADIENTTOP: "ग्रेडिएंट टॉप",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "ग्रेडिएंट टॉप अल्फा",
  T_45_XXJ_WS_HITPOSITION_D: "बुलेट्स से हिट टारगेट की विश्व स्थिति",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI सोशल बटन विजेट",
  T_45_XXJ_WS_INVERTFILL: "इन्वर्ट फिल",
  T_45_XXJ_WS_ISGROUNDED: "इस ग्राउंड किया है",
  T_45_XXJ_WS_ISSILENCE: "साइलेंस है",
  T_45_XXJ_WS_ISSILENCE_D: "साइलेंस हुआ या नहीं",
  T_45_XXJ_WS_ISSINGLESHOT: "सिंगल शॉट है",
  T_45_XXJ_WS_ISSINGLESHOT_D: "यदि यह सिंगल-शॉट है या नहीं",
  T_45_XXJ_WS_JUMPHEIGHT: "जंप की ऊंचाई",
  T_45_XXJ_WS_JUMPHEIGHT_D: "जंप हाइट",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "लेआउट सॉर्ट टाइप",
  T_45_XXJ_WS_LIGHT_D: "लाइट्स",
  T_45_XXJ_WS_LOCAL: "लोकल",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "मैक जम्प काउंट",
  T_45_XXJ_WS_MODULE: "मॉड्यूल",
  T_45_XXJ_WS_NONE: "कोई नहीं",
  T_45_XXJ_WS_ONBEFOREHURT_D: "एंटिटी को डैमेज पहुँचाने से पहले हर बार कमांड एक्सक्यूट करें",
  T_45_XXJ_WS_ONDISABLE_D: "इकाई बंद होने पर एक्ज़ेक्यूट  करें",
  T_45_XXJ_WS_ONEACHLOOP_D: "हर बार प्लेएबल लूप होने पर एक्ज़ेक्यूट करें. केवल साउंड इफ़ेक्ट  और स्पेशल इफ़ेक्ट जैसी एंटिटी के लिए ग्राहक पक्ष पर प्रभावी।",
  T_45_XXJ_WS_ONENABLE_D: "इकाई चालू होने पर एक्ज़ेक्यूट  करें",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "30 FPS की निश्चित रेट पर किसी फ्रेम में एंटर करते समय",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "जब प्लयेर किसी दोस्त को जोड़ता या हटाता है तो क्लाइंट ईवेंट ट्रिगर करें",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "बुलाये एपीआई के कारण गेम रुक जाता है तो इवेंट को ट्रिगर करें",
  T_45_XXJ_WS_ONGAMERESUME_D: "बुलाये एपीआई के कारण गेम रिज्यूम होता है तो इवेंट को ट्रिगर करें",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "जब प्लेयर दौड़ना बंद कर देता है",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "जब प्लेयर सर्फिंग बंद कर देता है",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "जब प्लेयर सर्फिंग कर रहा हो",
  T_45_XXJ_WS_PHYSICALLAYER_D: "0 से 31 की सीमा के भीतर कस्टम फिजिकल लेयर",
  T_45_XXJ_WS_PLATFORMTYPE: "प्लेटफ़ॉर्म टाइप",
  T_45_XXJ_WS_PLATFORMTYPE_D: "प्लेटफ़ॉर्म टाइप",
  T_45_XXJ_WS_PLAYER: "प्लेयर",
  T_45_XXJ_WS_PLAYERCCT: "प्लेयर CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "फिजिकल इफेक्ट्स वाला एक कैरेक्टर कंट्रोलर और केवल Free Fire कैरेक्टर के लिए उपयोग किया जाता है",
  T_45_XXJ_WS_PRIORITY: "प्रायोरिटी",
  T_45_XXJ_WS_REMAINMULTINUM: "बची जम्प संख्या",
  T_45_XXJ_WS_REPORT: "रिपोर्ट",
  T_45_XXJ_WS_RIGHT: "दाएं",
  T_45_XXJ_WS_RIGHT_D: "लोकल कोऑर्डिनेट सिस्टम में x-अक्ष की दिशा",
  T_45_XXJ_WS_SERVER: "सर्वर",
  T_45_XXJ_WS_SINGLE: "सिंगल",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "सोशल बटन स्टाइल टाइप",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "सोशल बटन स्टाइल",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "सोशल बटन टाइप",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "सोशल बटन टाइप",
  T_45_XXJ_WS_SORTTYPE_D: "क्रमबद्ध प्रकार: गैर-शून्य आरोही, अवरोही और आरोही",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "ADS के टाइम मूवस्पीड",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "लक्ष्य करते समय मूवमेंट स्पीड",
  T_45_XXJ_WS_STRINGORLOCSTRING: "स्ट्रिंग या लोकलाइज़ स्ट्रिंग",
  T_45_XXJ_WS_TRIPLE: "ट्रिपल",
  T_45_XXJ_WS_UP: "अप",
  T_45_XXJ_WS_UP_D: "लोकल कोऑर्डिनेट सिस्टम में y-अक्ष की दिशा",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "कस्टम पुश फोर्स इस्तेमाल करें",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "किसी रैंडम वाहन को बुलाने के लिए तय क्षेत्र की ओर सिग्नल फ़्लेयर फेंकें",
  T_45_ZD_VEHICLEDROP_R_NAME: "मिस्ट्री व्हीकल",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "लीला",
  T_46_HJ_SHARE_GAMEDURATION: "खेलने का समय",
  T_46_HJ_WS_SHAREBY: "{0} द्वारा",
  T_46_HJ_WS_SHAREGAMEMODE: "गेम मोड",
  T_46_HJ_WS_SHARETEAM: "टीम",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "टॉप ऑफ़ क्लास (बॉटम)",
  T_46_HX_H_SCHOOL_VN: "टॉप ऑफ़ क्लास (हेड)",
  T_46_HX_S_SCHOOL_VN: "टॉप ऑफ़ क्लास (जूते)",
  T_46_HX_T_SCHOOL_VN: "टॉप ऑफ़ क्लास (टॉप)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "टुटोरिअल",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "अन्य",
  T_46_XXJ_WS_ACTUALPOSITION: "वास्तविक स्थिति",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "दृष्टि की रेखा से परे AOI सिंक्रनाइज़ेशन के साथ मॉनिटर करने के लिए ऑब्जेक्ट जोड़ें",
  T_46_XXJ_WS_APPEARANCE: "बनावट",
  T_46_XXJ_WS_APPEARANCERES: "बनावट रिसोर्स",
  T_46_XXJ_WS_BECOME: "एक्टिवेट",
  T_46_XXJ_WS_BRAKETORQUE_D: "ब्रेक/रिवर्स का उपयोग करने पर वाहन को दी गई हॉर्सपॉवर",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "कैमरा रोटेट एंगल रेस्ट्रिक्शन टाइप",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "टारगेट की सभी निगरानी की गई वस्तुओं को क्लियर करें",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "डैमेज की गणना के लिए अधिकतम क्रैश डैमेज का उपयोग किया जाता है",
  T_46_XXJ_WS_CRASHMAXSPEED: "क्रैश मैक्स स्पीड",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "क्रैश डैमेज गणना के लिए उपयोग किया जाता है. एक बार इस गति से अधिक हो जाने पर, कोई और डैमेज नहीं होगा.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "क्रैश मास फैक्टर",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "डैमेज गणना के लिए डैमेज फॉर्मूला में उपयोग किया जाने वाला एक पैरामीटर",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "डैमेज की गणना के लिए न्यूनतम क्रैश डैमेज का उपयोग किया जाता है",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "डेटा स्टोरेज की पढ़ने और लिखने की सीमा पार हो गई है",
  T_46_XXJ_WS_DB_PARAMERROR_D: "पैरामीटर एक्सेप्शन",
  T_46_XXJ_WS_DB_TIMEOUT_D: "डेटा स्टोरेज टाइमआउट. मुख्य रूप से अभी पढ़ने और लिखने पर लागू होता है.",
  T_46_XXJ_WS_DELTA: "डेल्टा",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "बनावट एडिट करें",
  T_46_XXJ_WS_ENDVALUE_D: "गंतव्य मान",
  T_46_XXJ_WS_ENGINETORQUE_D: "गैस पेडल का उपयोग करने पर वाहन को दी जाने वाली हॉर्सपावर",
  T_46_XXJ_WS_ERRORCODE_D: "एरर कोड एनम",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "वेक्टर3 से यूलर कोण",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "यूलर एंगल को 3D वेक्टर में बदलें",
  T_46_XXJ_WS_EXPIRE: "एक्सपायर",
  T_46_XXJ_WS_FEMALEAVATAR: "फीमेल कैरेक्टर",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "प्रीमियम एक्सपायर डेट पाएं",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "ऑब्ज़र्वर किसी वस्तु की निगरानी कर रहा है या नहीं",
  T_46_XXJ_WS_HELICOPTER: "स्काईब्लास्टर",
  T_46_XXJ_WS_HELICOPTER_D: "गाड़ी का उड़ने वाली प्रकार",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "हाई-स्पीड स्टीयर प्रतिबंध",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "हाई स्पीड स्थिति में अधिकतम स्टीयरिंग एंगल",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "स्पीड पर हाई-स्पीड स्टीयर एंगल",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "अधिकतम हाई-स्पीड स्टीयरिंग कोण के लिए गति सीमा",
  T_46_XXJ_WS_IDLE: "आयडल एनीमेशन",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "आइडल ब्रेक इनपुट",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "जब गाड़ी नहीं चला रहे हों, तो उसे (आइडल ब्रेक इनपुट) x (ब्रेक टॉर्क) द्वारा धीमा कर दें।",
  T_46_XXJ_WS_INTTOFLOAT: "इंट से फ्लोट",
  T_46_XXJ_WS_INTTOFLOAT_D: "एक इन्टिजर को फ़्लोटिंग-पॉइंट संख्या में कनवर्ट करें",
  T_46_XXJ_WS_ISPREMIUM: "मेम्बरशिप है",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "डेटाबेस में लीडरबोर्ड का नाम",
  T_46_XXJ_WS_MALEAVATAR: "पुरुष कैरेक्टर",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI पेर्सोना",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "नया UMA बनावट",
  T_46_XXJ_WS_NONE_D: "कोई एरर नहीं",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "NPC ऑब्जेक्ट",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "टिप्स: ह्यूमनॉइड NPCs में आमतौर पर एक कैप्सूल के साथ टकराव मॉडल होता है जो 1.4 मीटर लंबा और 0.25 मीटर त्रिज्या होता है. पेट एनपीसी में आमतौर पर एक कैप्सूल के साथ टकराव मॉडल होता है जो 1 मीटर लंबा और 0.4 मीटर त्रिज्या का होता है।",
  T_46_XXJ_WS_OBSERVER_D: "ऑब्ज़र्वर जो वस्तुओं की निगरानी कर रहा है",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "क्राफ्टलैंड मेम्बरशिप एंटर पर",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "क्राफ्टलैंड मेंबरशिप छोड़ें पर",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "क्राफ्टलैंड मेम्बरशिप खोलें",
  T_46_XXJ_WS_PERSONA: "पर्सोना",
  T_46_XXJ_WS_PERSONACENTER: "पर्सोना सेंटर",
  T_46_XXJ_WS_PET: "पैट",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "प्लेयर या ट्रांसफॉर्म",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "प्लेयर और ट्रांसफ़ॉर्म एंटिटी के लिए एक उपनाम",
  T_46_XXJ_WS_PREMIUM: "मेंबरशिप",
  T_46_XXJ_WS_PREMIUMSTATUS: "प्रीमियम स्टेटस",
  T_46_XXJ_WS_PROXYOBSERVER: "प्रॉक्सी ऑब्ज़र्वर",
  T_46_XXJ_WS_PROXYOBSERVER_D: "प्रॉक्सी ऑब्ज़र्वर",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "मॉनिटर की गई वस्तु को हटाएं और दृष्टि रेखा से परे एओआई सिंक्रनाइज़ेशन को रद्द करें",
  T_46_XXJ_WS_RENEWAL: "रिन्यू",
  T_46_XXJ_WS_ROTATEVECTOR: "रोटेट वेक्टर",
  T_46_XXJ_WS_ROTATEVECTOR_D: "चतुर्भुज के आधार पर एक वेक्टर को घुमाएँ",
  T_46_XXJ_WS_SKIN: "गियर",
  T_46_XXJ_WS_STARTVALUE_D: "सोर्स वैल्यू",
  T_46_XXJ_WS_STATUS: "स्टेटस",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "उपयोगकर्ता के प्रॉक्सी ऑब्ज़र्वर को स्विच करें",
  T_46_XXJ_WS_TARGET_D: "जिस टारगेट पर नजर रखी जाती है",
  T_46_XXJ_WS_USER_D: "यूज़र",
  T_46_XXJ_WS_VALUE: "वैल्यू",
  T_46_XXJ_WS_VALUE_D: "वेक्टर",
  T_46_XYL_WS_CTZSAFEZONEEND: "सेफ़ ज़ोन एंड पॉइंट",
  T_46_XYL_WS_RESOURCETYPE1: "बेसिक स्ट्रुक्टर",
  T_46_XYL_WS_RESOURCETYPE1_1: "जियोमेट्रिक्स",
  T_46_XYL_WS_RESOURCETYPE1_2: "विज़ुअल & ऑडियो",
  T_46_XYL_WS_RESOURCETYPE2: "सीन आइटम",
  T_46_XYL_WS_RESOURCETYPE2_2: "बैटल सप्लाई",
  T_46_XYL_WS_RESOURCETYPE3: "नेचर",
  T_46_XYL_WS_RESOURCETYPE4: "मॉडुलर कॉम्पोनेन्ट",
  T_46_XYL_WS_TYPEOTHERPROP: "मिसलैनीअस",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "कंटेनर और बॉक्स",
  T_47_CJ_FOREGRIP_SOFT_N: "लाइट फोरग्रिप",
  T_47_CJ_MAGEZINE_FAST_N: "फ़ास्ट मैग",
  T_47_CJ_STOCK_FAST_N: "पावर स्टॉक",
  T_47_GT_WS_USERMANUAL: "यूज़र मैन्युअल",
  T_47_HJ_WS_VFX_FOG: "फॉग VFX",
  T_47_HJ_WS_VFX_LIGHTING: "लाइटिंग VFX",
  T_47_HJ_WS_VFX_TRAILING: "ट्रेलिंग VFX",
  T_47_HL_CL_CREATOR_LABEL1: "कम्युनिटी टैलेंट्स",
  T_47_HL_CL_MAP_LABEL1: "कम्युनिटी टैलेंट्स के चुने गए काम",
  T_47_JH_WS_MODERATION_REASON12: "गैंबलिंग से जुड़ा",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN कोलैबोरेशन",
  T_47_SD_RES_MATERIAL: "मटेरियल फाइल",
  T_47_SD_RES_MESH: "मैश",
  T_47_SD_WS_MAPTAG_AI: "AI मैप जनरेट",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "एक स्पेशल चाकू जो फेंके जाने के बाद इम्पैक्ट पॉइंट पर चिपक जाता है, जिससे जलने से होने वाला डैमेज से निपटने के लिए थोड़ी देर के बाद एक तेज विस्फोट हो जाता है।",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "फायरी कुनाई",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "एक स्पेशल चाकू जो फेंके जाने के बाद इम्पैक्ट पॉइंट पर चिपक जाता है, जिससे थोड़ी देर के बाद टारगेट को पैराईज़ बनाने के लिए लाइटनिंग स्ट्राइक शुरू हो जाती है.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "लाइटनिंग कुनाई",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "एक स्पेशल चाकू जो फेंके जाने के बाद इफ़ेक्ट पॉइंट पर चिपक जाता है, तथा कुछ ही देर में तूफान शुरू कर देता है, जिससे टारगेट के केंद्र की ओर बढ़ने की गति धीमी हो जाती है.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "विंड कुनाई",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "मध्यम से लंबी दूरी की लड़ाई के लिए उपयुक्त एक प्रकार का शुरिकेन. एक बार फेंकने पर एक टुकड़ा तेज़ी से निकलता है, जिससे बहुत ज़्यादा डैमेज होता है.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "हैवी शुरीकेन",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "शुरीकेनका एक प्रकार जो दो अटैक मोड के साथ निकट-से-मध्य-दूरी की लड़ाई के लिए उपयुक्त है. एक बार फेंकने पर तीन टुकड़े निकलते हैं, जो थोड़ी मात्रा में डैमेज पहुँचाते हैं.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "लाइट शुरीकेन",
  T_47_XXJ_WS_ACTION: "एक्शन",
  T_47_XXJ_WS_AOISETTING: "AOI सेटिंग",
  T_47_XXJ_WS_BAGSKINTYPE: "बैकपैक स्किन टाइप",
  T_47_XXJ_WS_CLEARMEMORY: "मेमोरी क्लियर करें",
  T_47_XXJ_WS_CLNPC: "एडवांस NPC",
  T_47_XXJ_WS_CLOTHTYPE: "आउटफिट स्किन टाइप",
  T_47_XXJ_WS_COMMON_ERROR: "कॉमन एरर",
  T_47_XXJ_WS_CONTENT: "कंटेंट",
  T_47_XXJ_WS_CREATERANDOMSEED: "रैंडम सीड बनाएं",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "इलैप्स परसेंटेज",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "फॉग फीचर चालू करें",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "लाइट रोटेशन फीचर चालू करें",
  T_47_XXJ_WS_ERRORCODE: "एरर कोड",
  T_47_XXJ_WS_EXPONENTIAL: "एक्सपोनेंशियल",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "एक्सपोनेंशिय स्क्वैर्ड",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "रूम बनाने में फेल: कोई वैध पर्सोना आईडी नहीं",
  T_47_XXJ_WS_FOG: "फॉग",
  T_47_XXJ_WS_FOGDENSITY: "फॉग डेंसिटी",
  T_47_XXJ_WS_FOGENDDISTANCE: "फॉग ख़त्म होने की दूरी",
  T_47_XXJ_WS_FOGMODE: "फॉग मोड",
  T_47_XXJ_WS_FOGMODETYPE: "फॉग मोड टाइप",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "फॉग शुरू की दूरी",
  T_47_XXJ_WS_HEIGHTSCALE: "हाइट स्केल",
  T_47_XXJ_WS_ISVISIBLE: "विज़िबल है",
  T_47_XXJ_WS_JOINNEWTEAM: "नई टीम जॉइन करें",
  T_47_XXJ_WS_JOINTEAM: "टीम जॉइन करें",
  T_47_XXJ_WS_LIGHTROTATE: "लाइट रोटेशन",
  T_47_XXJ_WS_LINEAR: "लीनियर",
  T_47_XXJ_WS_LLMCHATHUD: "UI पर्सोना चैट",
  T_47_XXJ_WS_NEWTEAM: "नई टीम",
  T_47_XXJ_WS_NEXT: "अगला",
  T_47_XXJ_WS_NPC_TIP: "आप NPC की उपस्थिति को एडिट कर सकते हैं और NPC का खेल एनीमेशन बना सकते हैं",
  T_47_XXJ_WS_OBSERVERS: "ऑब्ज़र्वर",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "प्लेयर पर UI पर्सोना चैट से मैसेज भेजने पर",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "मेंबरशिप स्टेटस बदला",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "पर्सोना से एक्शन पाएं",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "पर्सोना से कंटेंट पाएं",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "पर्सोना से फिनिश मिलने पर",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "पर्सोना से स्टेटस मिलने पर",
  T_47_XXJ_WS_PARTICLESID: "पार्टिकल ID",
  T_47_XXJ_WS_PERSONAAVATAR: "पर्सोना अवतार",
  T_47_XXJ_WS_PERSONAID: "पर्सोना ID",
  T_47_XXJ_WS_PERSONANICKNAME: "पर्सोना निकनेम",
  T_47_XXJ_WS_PLAYERORNPC: "प्लेयर या NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "मेम्बरशिप बंद हुई",
  T_47_XXJ_WS_RANDOM: "रैंडम",
  T_47_XXJ_WS_SEED: "सीड",
  T_47_XXJ_WS_SENDER: "भेजने वाला",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "पर्सोना ऑब्ज़र्वर सेट करें",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "सेट प्लेयर बीच में ही छोड़ सकता है",
  T_47_XXJ_WS_SHOULDREPLY: "रिप्लाई करना चाहिए",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "सिस्टम रिप्लाई दिखाएं",
  T_47_XXJ_WS_SPOTANGLE: "स्पॉट एंगल",
  T_47_XXJ_WS_SPOTLIGHT: "स्पॉट लाइट",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "पर्सोना को सिस्टम मैसेज भेजें",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "सिस्टम मैसेज को पर्सोना पर स्ट्रीम करें",
  T_47_XXJ_WS_TARGETTEAM: "टारगेट टीम",
  T_47_XXJ_WS_THISENTITY: "ये एंटिटी",
  T_47_XXJ_WS_USERAVATAR: "यूज़र अवतार",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "पर्सोना को यूजर मैसेज भेजें",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "यूज़र मैसेज को पर्सोना पर स्ट्रीम करें",
  T_47_XXJ_WS_USERNICKNAME: "यूजर का निकनेम",
  T_47_XXJ_WS_VEHICLESKINTYPE: "व्हीकल स्किन टाइप",
  T_47_XXJ_WS_WEAPONSKINTYPE: "वेपन स्किन टाइप",
  T_47_XYL_NB_UGC_EFFECT001: "रसेंगन रसेंगन",
  T_47_XYL_NB_UGC_EFFECT002: "चिदोरी VFX",
  T_47_XYL_NB_UGC_EFFECT003: "चेरी ब्लॉसम क्लैश VFX",
  T_47_XYL_NB_UGC_EFFECT004: "फायरबॉल जुत्सु VFX",
  T_47_XYL_NB_UGC_EFFECT005: "वाटर ड्रैगन जुत्सु",
  T_47_XYL_NB_UGC_EFFECT006: "ग्रेट ब्रीच VFX",
  T_47_XYL_NB_UGC_EFFECT007: "टेल्ड बीस्ट बॉम्ब VFX",
  T_47_XYL_NB_UGC_EFFECT008: "रीएनीमेशन कर्स मार्क VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "एसेट स्टोर",
  T_47_XYL_UGC_DONKEYCART: "डंकी कार्ट",
  T_47_XYL_UGC_SPOTLIGHT: "स्पॉर्टलाइट",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "स्पॉटलाइट एंगल",
  T_48_H_EMOTE_WATERFEST25_N: "स्विफ़्ट स्टेप्स",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "मोटरबाइक - सी फोम",
  T_48_HJ_AC_STATENOTEXIST: "एनीमेशन कंट्रोलर में स्टेट {0} मौजूद नहीं है",
  T_48_HL_CODESCRIPT: "कोड स्क्रिप्ट",
  T_48_HL_GLOBAL_VAR: "ग्लोबल वैरिएबल नीम",
  T_48_HL_GRAPH: "ब्लॉक",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "लीडरबोर्ड",
  T_48_HL_LOCAL_VAR: "लोकल वैरिएबल नेम",
  T_48_HL_LOCALIZATION: "लोकलाइजेशन नेम",
  T_48_HL_OPEN_ATTRIBUTES: "एट्रिब्यूट नाम खोलें",
  T_48_HX_A_WATERFEST25: "सी फोम (मास्क)",
  T_48_HX_B_WATERFEST25: "सी फोम (बॉटम)",
  T_48_HX_F_B_BLACKDRESS: "एंटीमैटर (बॉटम)",
  T_48_HX_F_H_BLACKDRESS: "एंटीमैटर (हेड)",
  T_48_HX_F_HA_BLACKDRESS: "एंटीमैटर (फेसपेंट)",
  T_48_HX_F_S_BLACKDRESS: "एंटीमैटर (जूते)",
  T_48_HX_F_T_BLACKDRESS: "एंटीमैटर (टॉप)",
  T_48_HX_H_WATERFEST25: "सी फोम (हेड)",
  T_48_HX_HA_WATERFEST25: "सी फोम (फेसपेंट)",
  T_48_HX_M_A_BLACKDRESS: "डार्क मैटर (मास्क)",
  T_48_HX_M_B_BLACKDRESS: "डार्क मैटर (बॉटम)",
  T_48_HX_M_H_BLACKDRESS: "डार्क मैटर (हेड)",
  T_48_HX_M_HA_BLACKDRESS: "डार्क मैटर (फेसपेंट)",
  T_48_HX_M_S_BLACKDRESS: "डार्क मैटर (जूते)",
  T_48_HX_M_T_BLACKDRESS: "डार्क मैटर (टॉप)",
  T_48_HX_S_WATERFEST25: "सी फोम (जूते)",
  T_48_HX_T_WATERFEST25: "सी फोम (टॉप)",
  T_48_JH_WS_STRINGDESC: 'टेक्स्ट या अन्य स्ट्रिंग का पैराग्राफ एंटर करें. कुछ विजेट रिच टेक्स्ट डिस्प्ले कर सकते हैं. नीचे दिए फॉर्मेट का इस्तेमाल करके रिच टेक्स्ट वाले टेक्स्ट में रंग जोड़ें: [#XXXXXX] टेक्स्ट टेक्स्ट [-]। "#XXXXXX" वह रंग है जिसे आप डिस्प्ले करना चाहते हैं. कृपया ध्यान दें कि संबंधित विजेट का टेक्स्ट रंग सफ़ेद होना चाहिए.',
  T_48_M_WS_P_ICON: "अवतार",
  T_48_META_API_10001: "ID से एंटिटी ढूंढें",
  T_48_META_API_10001_P0: "एंटिटी ID",
  T_48_META_API_1098: "बैच रीड डेटाबेस शीट वैल्यू",
  T_48_META_API_1098_D: "बैच एक तय डाटाबेस शीट से मल्टीप्ल डाटा एंट्री को पढ़ता है, जहां यूनिक प्लेयर आईडी लिस्ट की एंट्री की (लिस्ट की एंट्री के साथ एक-से-एक मेल खाती हैं",
  T_48_META_API_1098_P1: "अकाउंट IDs",
  T_48_META_API_1098_P1_D: "यूनिक प्लेयर आईडी की लिस्ट, जो की (key) लिस्ट में समान इंडेक्स पर की (key) के अनुरूप डेटा पढ़ती है.",
  T_48_META_API_1098_P2: "कीज़",
  T_48_META_API_1098_P2_D: "की (key) की सूची, जो आईडी लिस्ट में समान सूचकांक पर अद्वितीय खिलाड़ी इंडेक्स के अनुरूप डेटा को पढ़ती है.",
  T_48_META_API_1098_P5: "स्टेटस कोड",
  T_48_META_API_1098_P5_D: "स्टेटस कोड की सूची",
  T_48_META_API_1105: "नॉटिफाई स्टार्ट प्लॉट",
  T_48_META_API_1105_D: "ट्रिगरिंग प्लेयर के लिए बताये प्लॉट प्ले करना शुरू करें",
  T_48_META_API_1105_P1_D: "प्लॉट ID",
  T_48_META_API_1108: "स्थानीय भाषा पाएं",
  T_48_META_API_1500_P0: "वेक्टर",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "सेट बॉडी पार्ट वेट",
  T_48_META_API_3300_D: "अन्य लोअर-प्रायोरिटी वाले एनिमेशन के साथ ब्लेंड करते समय टारगेट शरीर के बॉडी पार्ट का वजन सेट करें",
  T_48_META_API_3300_P0_D: "वह जोड़ने योग्य एनीमेशन कंट्रोलर कॉम्पोनेन्ट जिससे बॉडी पार्ट संबंधित है",
  T_48_META_API_3300_P1: "बॉडी पार्ट नाम",
  T_48_META_API_3300_P1_D: "बॉडी पार्ट नाम",
  T_48_META_API_3300_P2: "वेट",
  T_48_META_API_3300_P2_D: "[0, 1] के वैल्यू रेंज वाला भार, जो कम-प्राथमिकता वाले एनिमेशन के साथ ब्लेंडिंग की डिग्री को दिखाता है.",
  T_48_META_API_3315: "कैरेक्टर एनीमेशन क्लिप ओवरराइड चलाएं",
  T_48_META_API_3315_D: "गेम के डिफ़ॉल्ट एनीमेशन को ओवरराइड करने के विकल्प के साथ एक करैक्टर एनीमेशन क्लिप चलाएं",
  T_48_META_API_3315_P3: "गेमप्ले कंट्रोल ओवरराइड करें",
  T_48_META_API_3315_P3_D: "गेम के डिफ़ॉल्ट एनीमेशन को ओवरराइड करना है या नहीं",
  T_48_META_API_3316: "स्टॉप एनीमेशन",
  T_48_META_API_3316_D: "तय स्टेटस में टारगेट के लिए एनीमेशन चलाना बंद करें",
  T_48_META_API_90_P1: "बीच में छोड़ सकते हैं",
  T_48_META_API_93: "पाथ मोशन के साथ बनाएं",
  T_48_META_API_93_D: "ऑब्जेक्ट को तय पाथ पर मूवमेंट करने के लिए पाथ के साथ एक इंटरपोलेटेड मूवमेंट बनाएं",
  T_48_META_API_93_P1: "पाथ",
  T_48_META_API_93_P1_D: "मोशन का पाथ",
  T_48_META_API_93_P3_D: "गति का परिमाण",
  T_48_META_API_93_P4: "टेंजेंट फेसिंग",
  T_48_META_API_93_P4_D: "क्या ऑब्जेक्ट मूवमेंट की दिशा की ओर मुख में है. यह गुण अपरिवर्तित रहता है, भले ही ऑब्जेक्ट के ओरिएंटेशन को दूसरे तरीकों से बलपूर्वक मॉडिफाइड किया गया हो.",
  T_48_META_API_96: "इंस्टेंटियेट प्रीफ़ैब",
  T_48_META_API_96_D: "एसिंक्रोनस रूप से प्रोसेस करने के विकल्प के साथ एक प्रीफ़ैब इंस्टेंस बनाएं",
  T_48_META_API_96_P2: "असिंक लोड",
  T_48_META_API_96_P2_D: "क्या लोडिंग एसिंक्रोनस है",
  T_48_META_EVT_3140: "टीम चेंज पर",
  T_48_META_EVT_3140_D: "मौजूदा इकाई की टीम बदलने पर ट्रिगर होता है",
  T_48_META_EVT_3140_P0: "फॉर्मर टीम",
  T_48_META_EVT_3140_P0_D: "बदलने से पहले आप जिस टीम से जुड़े थे",
  T_48_META_EVT_3140_P1: "मौजूदा टीम",
  T_48_META_EVT_3140_P1_D: "बदलाव के बाद टीम किससे जुड़ी है",
  T_48_META_EVT_3141: "प्लॉट स्टार्ट पर",
  T_48_META_EVT_3141_D: "जब प्लॉट चलना शुरू होता है तो ट्रिगर होता है",
  T_48_META_EVT_3141_P1: "प्लॉट ID",
  T_48_META_EVT_3141_P1_D: "प्लॉट ID",
  T_48_META_EVT_3142: "प्लॉट एन्ड पर",
  T_48_META_EVT_3142_D: "प्लॉट समाप्त होने पर ट्रिगर होता है",
  T_48_META_EVT_3142_P0_D: "ट्रिगरिंग प्लेयर्स",
  T_48_META_EVT_3142_P1_D: "प्लॉट ID",
  T_48_META_EVT_3143: "ट्रिगर प्लॉट ऑप्शन पर",
  T_48_META_EVT_3143_D: "प्लॉट में कोई विकल्प चुने जाने पर ट्रिगर होता है",
  T_48_META_EVT_3143_P1_D: "प्लॉट ID",
  T_48_META_EVT_3143_P2: "ऑप्शन ID",
  T_48_META_EVT_3143_P2_D: "ऑप्शन विकल्प की ID",
  T_48_META_TYP_409_I10: "चेंज टीम फ़ेल्ड_अमान्य टीम",
  T_48_META_TYP_409_I11: "चेंज टीम फेल्ड_एलिमिनटेड",
  T_48_META_TYP_409_I12: "चेंज टीम फ़ेल्ड_गाड़ी में",
  T_48_META_TYP_409_I7: "चेंज टीम फ़ेल्ड_समर्थित नहीं",
  T_48_META_TYP_409_I8: "टीम परिवर्तन विफल_पहले से ही टीम में हैं",
  T_48_META_TYP_409_I9: "टीम टीम फ़ेल्ड_अमान्य लक्ष्य",
  T_48_META_TYP_41_I19: "कॉलाइडर बंद करें",
  T_48_META_TYP_417: "पार्टिकल",
  T_48_META_TYP_428: "प्लेयर ट्रांसफॉर्म या NPC आउटफिट",
  T_48_META_TYP_431: "पाथ के साथ मोशन",
  T_48_META_TYP_431_I1: "पाथ",
  T_48_META_TYP_432: "कस्टम कर्व पाथ वे-पॉइंट",
  T_48_META_TYP_432_I0: "रोल",
  T_48_META_TYP_432_I1: "टेंजेंट",
  T_48_META_TYP_433: "कस्टम कर्व पाथ टाइप",
  T_48_META_TYP_433_I0: "लीनियर",
  T_48_META_TYP_433_I1: "स्मूथ",
  T_48_META_TYP_433_I2: "कस्टम",
  T_48_META_TYP_434: "कस्टम कर्व पाथ",
  T_48_META_TYP_434_I2: "क्लोज्ड लूप",
  T_48_META_TYP_434_I3: "वे-पॉइंट्स",
  T_48_META_TYP_437_I5: "स्कोर टाइप नाम",
  T_48_META_TYP_437_I6: "लेफ़्ट स्कोर कंटेंट",
  T_48_META_TYP_437_I7: "राइट स्कोर कंटेंट",
  T_48_META_TYP_438_I1: "प्लेयर्स",
  T_48_META_TYP_438_I2: "रैंक्स",
  T_48_META_TYP_438_I3: "टोटल स्कोर्स",
  T_48_META_TYP_438_I4: "स्कोर टाइप नाम",
  T_48_META_TYP_438_I5: "कलर्स",
  T_48_META_TYP_438_I6: "स्कोर्स",
  T_48_META_TYP_439: "ग्रुप",
  T_48_META_TYP_442_I1: "लेफ़्ट स्कोर",
  T_48_META_TYP_442_I10: "राइट एलिमिनटेड आइकॉन",
  T_48_META_TYP_442_I2: "राइट स्कोर",
  T_48_META_TYP_442_I3: "लेफ़्ट अलाइव नंबर",
  T_48_META_TYP_442_I4: "राइट अलाइव नंबर",
  T_48_META_TYP_442_I5: "बचे एलिमिनटेड नंबर",
  T_48_META_TYP_442_I6: "राइट एलिमिनटेड नंबर",
  T_48_META_TYP_442_I7: "लेफ़्ट अलाइव आइकॉन",
  T_48_META_TYP_442_I8: "राइट अलाइव आइकॉन",
  T_48_META_TYP_442_I9: "लेफ़्ट एलिमिनेशन आइकॉन",
  T_48_META_TYP_444: "भाषा का प्रकार",
  T_48_META_TYP_444_I0: "इंग्लिश",
  T_48_META_TYP_444_I1: "आसान चाइनीज़",
  T_48_META_TYP_444_I10: "फ्रेंच",
  T_48_META_TYP_444_I11: "जर्मन",
  T_48_META_TYP_444_I12: "टर्किश",
  T_48_META_TYP_444_I13: "हिंदी",
  T_48_META_TYP_444_I14: "जेपनीज़",
  T_48_META_TYP_444_I15: "रोमैनियन",
  T_48_META_TYP_444_I16: "अरेबिक",
  T_48_META_TYP_444_I17: "बर्मीज़",
  T_48_META_TYP_444_I18: "उर्दू",
  T_48_META_TYP_444_I19: "बंगाली",
  T_48_META_TYP_444_I2: "ट्रेडिशनल चाइनीज़",
  T_48_META_TYP_444_I3: "थाई",
  T_48_META_TYP_444_I4: "वियतनामी",
  T_48_META_TYP_444_I5: "इंडोनेशिया",
  T_48_META_TYP_444_I6: "पुर्तगाली",
  T_48_META_TYP_444_I7: "स्पेनिश",
  T_48_META_TYP_444_I8: "रसियन",
  T_48_META_TYP_444_I9: "कोरियन",
  T_48_SD_ERROR_DIVISOR: "डिवाज़र 0 नहीं",
  T_48_SD_ERROR_KEY_NOTINMAP: "स्पेसिफाइड की (Key) मैप में मौजूद नहीं है: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "लिस्ट इंडेक्स आउट ऑफ़ रेंज: {0}",
  T_48_SD_SK_WARNING: "{0} में {1} नहीं मिला",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'चूंकि क्राफ्टलैंड कैरेक्टर कंट्रोलर {0} की विशेषता "IsServerDriven" बंद है, इसलिए संबंधित सर्वर API प्रभावी नहीं होता है.',
  T_48_XXJ_WS_PARENTERROR: "पैरेंट सेट करने में फेल",
  T_48_XXJ_WS_PERFORMANCE: "परफॉरमेंस",
  T_48_XXJ_WS_TANGENT: "टेंजेंट",
  T_48_XXJ_WS_WAYPOINT: "वेपॉइंट",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "लिस्ट ऑफ़ ऑब्जेक्ट्स",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "कस्टम मिनीमैप इस्तेमाल करें",
  T_48_XYL_UGC_HIDEMINIMAP: "मिनिमैप HUD छिपाएं",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "बेसिक कस्टम सरफेस",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "सिलिंडर कटआउट",
  T_48_XYL_WS_BASICHEMISPHERE: "बेसिक हेमिस्फर",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "क्वार्टर टोरस",
  T_48_XYL_WS_BASICQUARTERTORUS: "क्वार्टर स्क्वायर टोरस",
  T_48_XYL_WS_BASICROUNDEDTORUS: "टोरस",
  T_48_XYL_WS_BASICTRIANGLE: "ट्रायंगल सरफेस",
  T_48_XYL_WS_MAPPLAYERSTIPS: "मैच प्लेयर्स = टीमों की संख्या × प्रति टीम प्लेयर्स की संख्या. जितने ज़्यादा मैच खिलाड़ी होंगे, मैचमेकिंग का समय उतना ही ज़्यादा होगा",
  T_48_XYL_WS_MAPPLAYERSWARNING: "मैच खेलने वाले प्लेयर्स की अधिक संख्या के कारण मैचमेकिंग का समय अधिक हो सकता है",
  T_49_HL_CL_CREATOR_LABEL2: "क्राफ्टलैंड कम्युनिटी टैलेंट",
  T_49_HL_CL_MAPS_LABEL2: "मैप विजेता",
  T_49_HL_CL_MAPS_LABEL3: "गेमप्ले विजेता",
  T_49_HX_T_TUNG: "टंग टंग टंग",
  T_49_HZY_CONTROLLER_TRAJECTORY: "ट्रैजेक्टरी",
  T_49_JH_WS_SKILLKASSIE: "इलेक्ट्रो थेरेपी (कैसी)",
  T_49_JH_WS_SKILLKODA: "ऑरोरा विजन (कोडा)",
  T_49_JH_WS_SKILLOSCAR: "वैलियंट डैश (ऑस्कर)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "AI से जनरेट करें",
  T_49_META_API_10065: "स्विच कस्टम कैमरा",
  T_49_META_API_10067: "गेट करंट कस्टम कैमरा",
  T_49_META_API_10069: "क्रिएट कस्टम कैमरा",
  T_49_META_API_10070: "सेट कस्टम कैमरा कूलिंग मास्क",
  T_49_META_API_10070_D: "टारगेट कैमरा के कूलिंग मास्क को सेट करें ताकि सभी लेयर्स में विजिबिलिटी कंट्रोल हो सके",
  T_49_META_API_10071: "गेट कस्टम कैमरा कूलिंग मास्क",
  T_49_META_API_10071_D: "टारगेट कैमरा का कूलिंग मास्क प्राप्त करें",
  T_49_META_API_10072: "सेट कस्टम कैमरा कूलिंग मास्क लेयर",
  T_49_META_API_10072_D: "किसी विशेष लेयर के लिए टारगेट कैमरा की विजिबिलिटी सेट करें",
  T_49_META_API_10073: "स्क्रीनशॉट कैप्चर करें",
  T_49_META_API_10073_D: "स्क्रीनशॉट कैप्चर करें (इंटरनल टेस्टिंग के लिए)",
  T_49_META_API_106: "गेट सर्वर टाइमस्टैम्प (ms)",
  T_49_META_API_106_D: "मिलीसेकंड प्रिसिशन के साथ सर्वर टाइमस्टैम्प प्राप्त करें",
  T_49_META_API_107: "लोकलाइज़्ड स्ट्रिंग के लिए टाइमस्टैम्प (ms)",
  T_49_META_API_107_D: "टाइमस्टैम्प (ms) को एक निश्चित फॉर्मेट पर आधारित स्ट्रिंग में बदलें",
  T_49_META_API_107_P0: "टाइमस्टैम्प (ms)",
  T_49_META_API_107_P0_D: "मिलीसेकंड में टाइमस्टैम्प",
  T_49_META_API_108: "लर्प वेक्टर3",
  T_49_META_API_108_D: "3D वेक्टर A से वेक्टर B तक लीनियर इंटरपोलेशन करें",
  T_49_META_API_1089_P2: "रिक्वेस्ट ID",
  T_49_META_API_109: "कंटेक्स्ट को पर्सोना में अपडेट करें",
  T_49_META_API_109_D: "करंट रूम में बताए पर्सोना के मॉडल कंटेक्स्ट को अपडेट करें और एक्सक्यूशन के बाद ओरिजिनल कंटेक्स्ट को ओवरराइट करें. यह कंटेक्स्ट पर्सोना की बैकग्राउंड, हिस्ट्री या अन्य पैरामीटर की व्याख्या को प्रभावित करेगा.",
  T_49_META_API_109_P1: "कंटेक्स्ट",
  T_49_META_API_109_P1_D: "कंटेक्स्ट का विवरण",
  T_49_META_API_110: "पर्सोना रिस्पॉन्स पर फीडबैक",
  T_49_META_API_110_D: "पर्सोना के रिस्पॉन्स कंटेंट पर फीडबैक सबमिट करें, जिसे हमारे मॉडल को बेहतर बनाने के लिए उपयोग किया जाएगा.",
  T_49_META_API_110_P1: "लाइक किया है",
  T_49_META_API_110_P1_D: "क्या रिस्पॉन्स पसंद किया गया है या नहीं. True = पसंद किया.",
  T_49_META_API_1109: "सेट लोकल प्लेयर पोजीशन",
  T_49_META_API_1109_D: "जब प्लेयर क्लासिक गेम कैरेक्टर का उपयोग कर रहा हो, तब यह API प्लेयर की पोजीशन सेट कर सकती है.",
  T_49_META_API_1109_P0_D: "टारगेट पोजीशन",
  T_49_META_API_111: "स्लर्प वेक्टर3",
  T_49_META_API_111_D: "स्मूद रोटेशन के लिए 3D वेक्टर A से वेक्टर B तक स्फेरिकल इंटरपोलेशन करें",
  T_49_META_API_1110: "सेट लोकल प्लेयर फॉरवर्ड",
  T_49_META_API_1110_D: "जब प्लेयर क्लासिक गेम कैरेक्टर का उपयोग कर रहा हो, तब यह API उस दिशा को सेट कर सकती है जिसकी ओर प्लेयर फेस कर रहा हो.",
  T_49_META_API_1110_P0_D: "फॉरवर्ड वेक्टर",
  T_49_META_API_112: "रोल बैक पर्सोना मेमोरी",
  T_49_META_API_112_D: "किसी विशेष रिस्पॉन्स ID से पहले पर्सोना की मेमोरी को रोल बैक करें. रिस्पॉन्स सहित और उसके बाद के सभी डायलॉग्स को क्लियर कर दिया जाएगा.",
  T_49_META_API_113: "वन-शॉट साउंड चलाएं",
  T_49_META_API_113_D: "एडजस्टेबल वॉल्यूम के साथ एक वन-शॉट साउंड इफ़ेक्ट चलाएं",
  T_49_META_API_113_P0_D: "चलाए जाने वाले साउंड इफ़ेक्ट का रिसोर्स ID",
  T_49_META_API_113_P1: "वॉल्यूम",
  T_49_META_API_113_P1_D: "साउंड इफ़ेक्ट के लिए प्लेबैक वॉल्यूम, जो 0 से 1 के बीच होता है.",
  T_49_META_API_97: "क्रिएट स्केलेटन पार्ट लुक-एट कंट्रोलर",
  T_49_META_API_97_D: "स्केलेटन पार्ट लुक-एट कंट्रोलर एंटिटी बनाएं, फिर इस एंटिटी का उपयोग करके निर्दिष्ट स्केलेटन पार्ट को किसी विशेष टारगेट की ओर हमेशा फेस कराएं.",
  T_49_META_API_97_P0_D: "स्केलेटन पार्ट लुक-एट कंट्रोलर एंटिटी. अगर एंटिटी डिलीट हो गई, तो लुक-एट फंक्शन बंद हो जाएगा.",
  T_49_META_API_97_P1_D: "वह स्केलेटन पार्ट जिसे कंट्रोल किया जा रहा है",
  T_49_META_API_97_P2_D: "जिस टारगेट को देखा जा रहा है",
  T_49_META_API_98: "प्रोजेक्शन",
  T_49_META_API_98_D: "वेक्टर A का वेक्टर B पर प्रोजेक्शन कैलकुलेट करें",
  T_49_META_API_99: "गेट लोकल टाइमस्टैम्प (ms)",
  T_49_META_API_99_D: "मिलीसेकंड प्रिसीजन के साथ लोकल टाइमस्टैम्प प्राप्त करें",
  T_49_META_EVT_16_P1_D: "0 से शुरू होकर, हर आउटगोइंग रिक्वेस्ट एक क्रमिक न्यूमेरिक ID उपयोग करेगा, जैसे रूम बनाते समय या मेमोरी क्लियर करते समय.",
  T_49_META_EVT_16_P2: "रिस्पॉन्स ID",
  T_49_META_EVT_16_P2_D: "हर पूरा रिस्पॉन्स एक यूनिक ID रखेगा",
  T_49_META_TYP_122_I19: "कस्टम मटेरियल",
  T_49_META_TYP_122_I19_D: "स्कायबॉक्स को कस्टम मटेरियल से बदलने की अनुमति दें",
  T_49_META_TYP_14_I78_D: "प्लेयर्स के क्लाइंट पर जो सीन अभी रेंडर कर रहा है, उस कैमरा एंटिटी को प्राप्त करें या सेट करें. नोट: कैमरा एंटिटी मूलतः क्लाइंट-साइड कैमरा को कंट्रोल करने के लिए कॉन्फ़िगरेशन डेटा को दर्शाती है.",
  T_49_META_TYP_335_I9: "बिता हुआ समय (ms)",
  T_49_META_TYP_335_I9_D: "साउंड इफ़ेक्ट का प्लेबैक ड्यूरेशन मिलीसेकंड में। यह प्रॉपर्टी केवल क्लाइंट साइड पर एक्सेस की जा सकती है।",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "परफॉर्मेंस ID",
  T_49_META_TYP_445: "प्लेएबल कंट्रोलर ID",
  T_49_META_TYP_446: "प्लेएबल कंट्रोलर अटेचेबल",
  T_49_META_TYP_446_I0: "प्लेएबल कंट्रोलर",
  T_49_META_TYP_447: "स्केलेटन पार्ट कंट्रोलर",
  T_49_META_TYP_448: "स्केलेटन पार्ट लुक-एट कंट्रोलर",
  T_49_META_TYP_448_I0: "कंट्रोल्ड टारगेट",
  T_49_META_TYP_448_I1: "लुक-एट टारगेट",
  T_49_META_TYP_449: "कस्टम कैमरा",
  T_49_META_TYP_449_I2: "ऑर्थोग्राफिक साइज",
  T_49_META_TYP_449_I2_D: "कैमरा द्वारा दिखाए जाने वाले एरिया के साइज को कंट्रोल करें",
  T_49_META_TYP_450: "टाइमस्टैम्प लोकलाइज़्ड स्ट्रिंग (ms)",
  T_49_META_TYPE_449_D: "कस्टम कैमरा पूरी तरह से डेवलपर के कंट्रोल में होता है और यह तय करता है कि गेमप्ले के दौरान प्लेयर क्या देखेगा.",
  T_49_META_TYPE_450_D: "मिलीसेकंड-स्तर के टाइमस्टैम्प को पढ़ने योग्य टेक्स्ट फॉर्मेट में कन्वर्ट करें",
  T_49_SD_SEARCH_ICONDESC: "स्मार्ट एसोसिएशन",
  T_49_SD_SEARCHKEY_ACTION: "ऐक्शन",
  T_49_SD_SEARCHKEY_ANICLIPID: "एनिमेशन क्लिप ID",
  T_49_SD_SEARCHKEY_AS: "जैसा",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "अटैचमेंट ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "साउंड इफेक्ट टाइप",
  T_49_SD_SEARCHKEY_BAGSKINID: "बैकपैक स्किन ID",
  T_49_SD_SEARCHKEY_BEZIER: "बेज़ियर कर्व",
  T_49_SD_SEARCHKEY_BOOL: "बूलियन",
  T_49_SD_SEARCHKEY_BREAK: "ब्रेक",
  T_49_SD_SEARCHKEY_BTREEID: "बिहेवियर ट्री",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "जब बटन क्लिक किया जाए",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "जब बटन डबल क्लिक किया जाए",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "जब बटन प्रेस किया जाए",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "जब बटन रिलीज किया जाए",
  T_49_SD_SEARCHKEY_CLOTHENUM: "आउटफिट टाइप",
  T_49_SD_SEARCHKEY_COLOR: "कलर",
  T_49_SD_SEARCHKEY_COMMENT: "कॉमेंट नोट",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "कंपोनेंट एनम",
  T_49_SD_SEARCHKEY_CONCANT: "कनेक्ट करें",
  T_49_SD_SEARCHKEY_CONTINUE: "जारी रखें",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "कस्टम HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "कस्टम HUD विजेट",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "डायनामिक क्रिएट लेवल ऑब्जेक्ट टाइप",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "विजुअल इफेक्ट्स टाइप",
  T_49_SD_SEARCHKEY_ENTITY: "सीन ऑब्जेक्ट सेलेक्ट करें",
  T_49_SD_SEARCHKEY_FLOAT: "फ्लोट",
  T_49_SD_SEARCHKEY_FOR: "फॉर इंडेक्स",
  T_49_SD_SEARCHKEY_FOREACH: "फॉर ईच",
  T_49_SD_SEARCHKEY_FUNCTION: "फंक्शन",
  T_49_SD_SEARCHKEY_GETCSV: "CSV प्राप्त करें",
  T_49_SD_SEARCHKEY_GETREGISTERED: "की के आधार पर रजिस्टर्ड एसेट प्राप्त करें",
  T_49_SD_SEARCHKEY_GETVALUE: "प्रॉपर्टी वैल्यू प्राप्त करें",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "ग्लोबल वेरिएबल प्राप्त करें",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "ग्लोबल वेरिएबल सेट करें",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If Else",
  T_49_SD_SEARCHKEY_IMGENUM: "इमेज टाइप",
  T_49_SD_SEARCHKEY_INT: "इंटीजर",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD टाइप",
  T_49_SD_SEARCHKEY_ITEMENUM: "आइटम टाइप",
  T_49_SD_SEARCHKEY_LISTAPPEND: "लिस्ट में ऐड करें",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "लिस्ट में रेंज ऐड करें",
  T_49_SD_SEARCHKEY_LISTCLEAR: "लिस्ट क्लियर करें",
  T_49_SD_SEARCHKEY_LISTCLONE: "लिस्ट क्लोन करें",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "लिस्ट कंटेन करें",
  T_49_SD_SEARCHKEY_LISTCREATE: "लिस्ट क्रिएट करें",
  T_49_SD_SEARCHKEY_LISTDELETE: "डिलीट लिस्ट",
  T_49_SD_SEARCHKEY_LISTGET: "लिस्ट प्राप्त करें",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "लिस्ट में इंडेक्स ऑफ देखें",
  T_49_SD_SEARCHKEY_LISTINSERT: "लिस्ट में इंसर्ट करें",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "लिस्ट में लास्ट इंडेक्स देखें",
  T_49_SD_SEARCHKEY_LISTLENGTH: "लिस्ट की लंबाई",
  T_49_SD_SEARCHKEY_LISTREVERSE: "लिस्ट रिवर्स करें",
  T_49_SD_SEARCHKEY_LISTSET: "लिस्ट सेट करें",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "लिस्ट शफल करें",
  T_49_SD_SEARCHKEY_LOCALKEY: "लोकलाइज़्ड की",
  T_49_SD_SEARCHKEY_LOCALVAR: "लोकल वेरिएबल",
  T_49_SD_SEARCHKEY_LOGICAL: "एंड और ऑर",
  T_49_SD_SEARCHKEY_LOGINFO: "लॉग इनफो प्रिंट करें",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "डिक्शनरी की सभी कीज़ पाएं, मैप की सभी कीज़ पाएं",
  T_49_SD_SEARCHKEY_MAPCLEAR: "क्लियर डिक्श क्लियर मैप",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "डिक्श में शामिल की मैप में शामिल की",
  T_49_SD_SEARCHKEY_MAPCREATE: "डिक्श बनाएं मैप बनाएं",
  T_49_SD_SEARCHKEY_MAPGET: "की से डिक्श वैल्यू से पाएं की से मैप वैल्यू से पाएं",
  T_49_SD_SEARCHKEY_MAPLENGTH: "डिक्श लम्बाई मैप लम्बाई",
  T_49_SD_SEARCHKEY_MAPREMOVE: "डिक्श हटाएं मैप हटाएं",
  T_49_SD_SEARCHKEY_MAPSET: "डिक्श वैल्यू सेट मैप वैल्यू सेट",
  T_49_SD_SEARCHKEY_MATH: "ऐड, सब्ट्रैक्ट, मल्टिप्लाई, डिवाइड",
  T_49_SD_SEARCHKEY_NEWLIST: "नई लिस्ट",
  T_49_SD_SEARCHKEY_NULL: "नल",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "नंबर को स्ट्रिंग में बदलें",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "पार्टिकल्स प्रॉपर्टीज़",
  T_49_SD_SEARCHKEY_PERSONA: "पर्सोना",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "प्लेयर डेटा ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "कैरेक्टर स्किल टाइप",
  T_49_SD_SEARCHKEY_PREEFFECT: "स्पेशल स्टीकर टाइप",
  T_49_SD_SEARCHKEY_PREFAB: "प्रीफैब",
  T_49_SD_SEARCHKEY_RAWID: "रॉ ID",
  T_49_SD_SEARCHKEY_READSTATIS: "अक्युमुलेटेड डेटा पढ़ें",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "रिसोर्स UUID",
  T_49_SD_SEARCHKEY_RETURN: "रिटर्न करें",
  T_49_SD_SEARCHKEY_SCENEENUM: "सीन फाइल",
  T_49_SD_SEARCHKEY_SCRIPTID: "स्क्रिप्ट",
  T_49_SD_SEARCHKEY_SETVALUE: "प्रॉपर्टी वैल्यू सेट करें",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "स्पेशल आइटम ID टाइप",
  T_49_SD_SEARCHKEY_TEXT: "टेक्स्ट",
  T_49_SD_SEARCHKEY_TEXTUREID: "टेक्सचर टाइप",
  T_49_SD_SEARCHKEY_THISENTITY: "यह एंटिटी",
  T_49_SD_SEARCHKEY_TIMELINE: "टाइमलाइन",
  T_49_SD_SEARCHKEY_TYPEENUM: "कोई भी टाइप",
  T_49_SD_SEARCHKEY_V2VCREATE: "Vector2 क्रिएट करें",
  T_49_SD_SEARCHKEY_V2VGET: "Vector2 कंपोनेंट्स प्राप्त करें",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 ऑपरेशन ऐड, सब्ट्रैक्ट, डॉट प्रोडक्ट, डिस्टेंस, एंगल",
  T_49_SD_SEARCHKEY_V2VSET: "Vector2 कंपोनेंट्स सेट करें",
  T_49_SD_SEARCHKEY_V3VCREATE: "Vector3 क्रिएट करें",
  T_49_SD_SEARCHKEY_V3VGET: "Vector3 कंपोनेंट्स प्राप्त करें",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 ऑपरेशन ऐड, सब्ट्रैक्ट, मल्टीप्लाय डॉट प्रोडक्ट, क्रॉस प्रोडक्ट, डिस्टेंस, एंगल",
  T_49_SD_SEARCHKEY_V3VSET: "Vector3 कंपोनेंट्स सेट करें",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "व्हीकल स्किन ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "हथियार स्किन टाइप",
  T_49_SD_SEARCHKEY_WHILE: "वाइल",
  T_49_SD_SEARCHKEY_WRITESTATIS: "अक्युमुलेटेड डेटाबेस ऑफसेट लिखें",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "मैप कोड के आधार पर अक्युमुलेटेड डेटाबेस ऑफसेट लिखें",
  T_49_XXJ_WS_DURATIONS: "ड्यूरेशन (सेकंड्स)",
  T_49_XXJ_WS_EDITPERFORMANCE: "परफॉर्मेंस एडिट करें",
  T_49_XXJ_WS_PERFORMANCE: "परफॉर्मेंस",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "परफॉर्मेंस डिलीट करें",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "डिलीटेड परफॉर्मेंस को रिकवर नहीं किया जा सकता, आगे बढ़ें?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "एडिट कर रहे हैं {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "यह नाम पहले से उपयोग में है, कृपया नाम बदलें और दोबारा प्रयास करें.",
  T_49_XXJ_WS_PERFORMANCENAME: "परफॉर्मेंस नाम",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "की फ्रेम जोड़ें",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "सब-ट्रैक जोड़ें",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "ट्रैक जोड़ें",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "ट्रैक डिलीट करें",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "एक्टर ट्रैक",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "इवेंट ट्रैक",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "की फ्रेम पहले से मौजूद है",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "संबंधित एक्टर ट्रैक पहले से मौजूद है",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "कंटेंट",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "डुप्लिकेट ट्रैक नाम पाए गए हैं. कृपया नाम बदलें और फिर प्रयास करें.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "कृपया रिकॉर्डिंग शुरू करें या पहले एक की फ्रेम चुनें.",
  T_49_XXJ_WS_TIMELINE_RECORDING: "रिकॉर्डिंग कर रहे हैं...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "की फ्रेम डिलीट करें",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "सीन व्यू",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "ट्रैक बनाने के लिए किसी ऑब्जेक्ट को सेलेक्ट करें या डायरेक्टली ऐड-ट्रैक बटन टैप करें.",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "नया ट्रैक बनाने के लिए ऐड-ट्रैक बटन टैप करें.",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "सब-ट्रैक",
  T_49_XXJ_WS_TIMELINE_TRACK: "ट्रैक",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "ट्रैक व्यू",
  T_49_XYL_WS_DAILYPROPS: "बेसिक",
  T_49_XYL_WS_STOREGAMPLAY: "गेमप्ले",
  T_49_YU_QCITEM_ALL_11: "टंग टंग टंग सहूर!",
  T_50_H_M4A1_VA_N: "M4A1 - ट्रबल एकडेमी",
  T_50_H_MACHETE_VA_N: "परांग - ट्रबल एकडेमी",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "लीडरबोर्ड फ़ील्ड्स",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "ओवरफ्लो",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "रैप अराउंड",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "फॉन्ट छोटा करें",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "ट्यूपल क्रिएट करें",
  T_50_HJ_SEARCHKEY_TUPLEGET: "ट्यूपल हासिल करें",
  T_50_HJ_SEARCHKEY_TUPLESET: "सेट ट्यूपल",
  T_50_HJ_TEXTOBGJ_H: "हाइट",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "ओवरफ्लो ऑप्शन्स",
  T_50_HJ_TEXTOBGJ_W: "चौड़ाई",
  T_50_HZY_REVIEW_TEXTOBJ: "टेक्स्ट ऑब्जेक्ट कंटेंट",
  T_50_JH_WS_HIDEMAPERROR: "कस्टम कवर इमेज के बिना मिनीमैप छिपा नहीं सकते",
  T_50_JH_WS_HIDEMAPTIP: "जब मिनीमैप छिपा होता है, तो इसे कवर इमेज के रूप में अब इस्तेमाल नहीं किया जाएगा",
  T_50_JH_WS_HIDEMINIMAP: "मिनीमैप छिपाएं",
  T_50_META_API_10073_P0: "फ़ाइल नाम",
  T_50_META_API_10073_P0_D: "फ़ाइल का नाम",
  T_50_META_API_10073_P1_D: "एक्सीक्यूशन का रिजल्ट. स्टेटस कोड एनम चेक करें.",
  T_50_META_API_1102: "डेटाबेस शीट कॉलम वैल्यू पढ़ें",
  T_50_META_API_1102_D: "एक स्टैंडर्ड डेटाबेस टेबल से किसी दिए गए की के लिए एक विशेष कॉलम का मान पढ़ें",
  T_50_META_API_1102_P3: "कॉलम इंडेक्स",
  T_50_META_API_1102_P3_D: "डेटाबेस टेबल का कॉलम इंडेक्स (0 = पहला कॉलम)",
  T_50_META_API_1106: "परफॉरमेंस क्रिएट करें",
  T_50_META_API_1106_D: "एक परफॉर्मेंस एंटिटी बनाएं",
  T_50_META_API_1106_P0_D: "परफॉर्मेंस एसेट",
  T_50_META_API_1111: "डेटाबेस लीडरबोर्ड एसोसिएशन वैल्यू पढ़ें",
  T_50_META_API_1111_D: "डेटाबेस में एक लीडरबोर्ड टेबल और उससे संबंधित टेबल से मानों का संयोजन पढ़ें",
  T_50_META_API_1111_P5: "एसोसिएशन स्टेटस कोड",
  T_50_META_API_1111_P5_D: "एसोसिएशन एरर कोड",
  T_50_META_API_1112: "रेंज के अनुसार डेटाबेस लीडरबोर्ड एसोसिएशन वैल्यू पढ़ें",
  T_50_META_API_1112_D: "लीडरबोर्ड टेबल से निर्दिष्ट रैंक रेंज के भीतर मान पढ़ें, संबंधित टेबल से प्राप्त की गई कीज़ द्वारा संबंधित मान पढ़ें, और उन्हें मिलाएं.",
  T_50_META_API_1112_P6: "एसोसिएशन स्टेटस कोड",
  T_50_META_API_1112_P6_D: "एसोसिएशन एरर कोड",
  T_50_META_API_1113: "डेटाबेस लीडरबोर्ड एसोसिएशन वैल्यू लिखें",
  T_50_META_API_1113_D: "डेटाबेस में लीडरबोर्ड टेबल और उसकी संबंधित टेबल में दिए गए key का मान लिखें",
  T_50_META_API_1113_P5: "एसोसिएशन स्टेटस कोड",
  T_50_META_API_1113_P5_D: "एसोसिएशन एरर कोड",
  T_50_META_API_114_D: "कस्टम UI बनाएं",
  T_50_META_API_114_P0_D: "कोड का उपयोग UI एंटिटी बनाने के लिए पैरामीटर नाम के रूप में किया जाता है, और इसका संबंधित लोकल वेरिएबल मान बनाई गई UI एंटिटी का प्रतिनिधित्व करता है.",
  T_50_META_API_114_P1_D: "यह प्लेयर एंटिटी जिस प्लेयर की है, वह सिर्फ़ उसी प्लेयर को दिखाई देती है.",
  T_50_META_API_114_P2: "UI एसेट ID",
  T_50_META_API_114_P2_D: "कस्टम UI एसेट ID",
  T_50_META_API_115_D: "निर्दिष्ट कस्टम UI बनाएं",
  T_50_META_API_116: "लेवल ऑब्जेक्ट हाइलाइट सेट करें",
  T_50_META_API_116_D: "ऑब्जेक्ट की हाइलाइट स्टेटस सेट करें. यह अन्य इन-गेम लॉजिक से प्रभावित हो सकता है.",
  T_50_META_API_116_P0_D: "टारगेट ऑब्जेक्ट",
  T_50_META_API_116_P1_D: "हाईलाइट स्टेटस",
  T_50_META_API_117: "बिटवाइज़ कॉमन",
  T_50_META_API_117_D: "बिटवाइज़ एंड/ऑर/एक्सओआर/लेफ़्ट शिफ्ट/राइट शिफ्ट",
  T_50_META_API_117_P0_D: "लेफ्ट वैल्यू",
  T_50_META_API_117_P1_D: "सही वैल्यू",
  T_50_META_API_117_P2_D: "ऑपरेशन टाइप",
  T_50_META_API_118: "बिटवाइज़ NOT",
  T_50_META_API_118_D: "बिटवाइज़ NOT, जिसे बिटवाइज़ कॉम्प्लीमेंट भी कहा जाता है.",
  T_50_META_API_118_P0_D: "मूल्य",
  T_50_META_API_119: "बिटवाइज़ लिस्ट से इन्टिजर",
  T_50_META_API_119_D: "सभी लिस्ट एलिमेंट्स पर बिटवाइज़ OR ऑपरेशन करें और आउटपुट को इन्टिजर वैल्यू में बदलें.",
  T_50_META_API_119_P0: "बिट ऐरे",
  T_50_META_API_119_P0_D: "बिटवाइज़ ऐरे",
  T_50_META_API_120: "बिटवाइज़ इन्ट को लिस्ट",
  T_50_META_API_120_D: "इन्टिजर के बाइनरी रूप में पोजीशन 1 पर बिट्स द्वारा दर्शाए गए दशमलव मानों को लिस्ट में बदलें",
  T_50_META_API_120_P0_D: "इंटीजर",
  T_50_META_API_121: "क्वाटरनियन एंगल",
  T_50_META_API_121_D: "दो चतुर्भुजों के बीच एंगल कैलकुलेट करें",
  T_50_META_API_121_P0_D: "क्वाटरनियन 1",
  T_50_META_API_121_P1_D: "क्वाटरनियन 2",
  T_50_META_API_122: "क्वाटरनियन डॉट",
  T_50_META_API_122_D: "दो चतुर्भुजों का डॉट प्रोडक्ट कैलकुलेट करें",
  T_50_META_API_123: "क्वाटरनियन इनवर्स",
  T_50_META_API_123_D: "क्वाटरनियन का इनवर्स निकालें",
  T_50_META_API_123_P0_D: "क्वाटर्नियन",
  T_50_META_API_124: "क्वाटरनियन फ्रॉम टू रोटेशन",
  T_50_META_API_124_D: '"from" से "to" तक रोटेशन क्वाटरनियन कैलकुलेट करें',
  T_50_META_API_124_P0_D: "शुरुआती पॉइंट",
  T_50_META_API_124_P1_D: "अंतिम पॉइंट",
  T_50_META_API_125: "क्वाटरनियन रोटेट टुवर्ड्स",
  T_50_META_API_125_D: '"from" से "to" तक रोटेशन क्वाटरनियन की गणना करें. मैक्स डिग्रीज डेल्टा अधिकतम रोटेशन एंगल है.',
  T_50_META_API_125_P0: "से",
  T_50_META_API_125_P0_D: "प्रारंभिक क्वाटरनियन",
  T_50_META_API_125_P1: "को",
  T_50_META_API_125_P1_D: "लक्ष्य क्वाटरनियन",
  T_50_META_API_125_P2: "मैक्स डिग्री डेल्टा",
  T_50_META_API_125_P2_D: "अधिकतम रोटेशन एंगल",
  T_50_META_API_126: "जाइरोस्कोप ओरिएंटेशन प्राप्त करें",
  T_50_META_API_126_D: "3D स्पेस में डिवाइस की ओरिएंटेशन, जो तीनों एक्सिस के चारों ओर रोटेशन एंगल्स को दर्शाती है.",
  T_50_META_API_127: "जाइरोस्कोप ग्रेविटी प्राप्त करें",
  T_50_META_API_127_D: "आपके डिवाइस के सेंसर द्वारा डिटेक्ट की गई ग्रेविटी कॉम्पोनेन्ट",
  T_50_META_API_128: "जाइरोस्कोप रोटेशन रेट प्राप्त करें",
  T_50_META_API_128_D: "यह डिवाइस की रोटेशन रेट को दर्शाता है. यह जाइरोस्कोप सेंसर से जुड़ा एक टर्म है, जो डिवाइस की तीन-आयामी स्पेस में रोटेशनल मूवमेंट स्पीड को बताता है.",
  T_50_META_API_129: "गेट जाइरोस्कोप रोटेशन अनबायस्ड",
  T_50_META_API_129_D: "डिवाइस की रोटेशन रेट का वर्णन करता है और डिवाइस के सेंसर्स के शोर या बायस की भरपाई करके अधिक सटीक परिणाम प्रदान करता है.",
  T_50_META_API_130: "जाइरोस्कोप यूजर एक्सेलरेशन प्राप्त करें",
  T_50_META_API_130_D: "डिवाइस के त्वरण का वह हिस्सा जिसमें गुरुत्वाकर्षण कॉम्पोनेन्ट हटा दिया गया है, यानी वह त्वरण जो यूज़र की क्रियाओं या बाहरी बलों के कारण होता है.",
  T_50_META_API_131: "टच इन्फो पाएं",
  T_50_META_API_131_D: "निर्दिष्ट इंडेक्स स्क्रीन टच जानकारी प्राप्त करें (जिसमें पोजीशन, डिस्प्लेसमेंट और बदलाव का समय शामिल है).",
  T_50_META_API_131_P0_D: "टच पॉइंट IDs को 0 से शुरू करके डिस्ट्रीब्यूट करें",
  T_50_META_API_131_P1_D: "टच पोजीशन",
  T_50_META_API_131_P2: "डेल्टा पोजीशन",
  T_50_META_API_131_P2_D: "पिछले फ्रेम की तुलना में स्थिति में बदलाव",
  T_50_META_API_131_P3: "डेल्टा टाइम",
  T_50_META_API_131_P3_D: "पिछले फ्रेम के बाद से बीता हुआ समय",
  T_50_META_API_132: "स्क्रीन टच काउंट प्राप्त करें",
  T_50_META_API_132_D: "स्क्रीन पर मौजूदा टच पॉइंट्स की संख्या पाएं",
  T_50_META_API_133: "डिवाइस वाइब्रेट करें",
  T_50_META_API_133_D: "डिवाइस को एक बार वाइब्रेट करें",
  T_50_META_API_134_D: "टार्गेट प्लेयर डिवाइस को ऑडियो प्ले करने का नोटिफाई करें",
  T_50_META_API_134_P0_D: "टारगेट प्लेयर",
  T_50_META_API_134_P1_D: "ऑडियो एसेट",
  T_50_META_API_134_P2_D: "प्लेबैक स्पीड (मान्य सीमा: 0.1~3.0; 1 = सामान्य, <1 = धीमी, >1 = तेज़)",
  T_50_META_API_135_D: "वन-टाइम ऑडियो फ़ाइल प्ले करें",
  T_50_META_API_135_P0_D: "ऑडियो रिसोर्सेस",
  T_50_META_API_135_P1_D: "प्ले स्पीड",
  T_50_META_API_136: "फॉर्मेट स्ट्रिंग",
  T_50_META_API_136_D: "स्ट्रिंग्स को फॉर्मेट करें",
  T_50_META_API_136_P0_D: "Go फॉर्मेटिंग वर्ब कंट्रोल्स का उपयोग करने वाली फॉर्मेटेड स्ट्रिंग्स",
  T_50_META_API_136_P1: "पैरामीटर ऐरे",
  T_50_META_API_136_P1_D: "पैरामीटर लिस्ट",
  T_50_META_API_137: "पेस्ट कॉम्पोनेन्ट",
  T_50_META_API_137_D: "कॉपी या कॉम्पोनेन्ट डेटा जोड़ें",
  T_50_META_API_137_P0: "सोर्स",
  T_50_META_API_137_P0_D: "सोर्स एंटिटी",
  T_50_META_API_137_P1_D: "टारगेट एंटिटी",
  T_50_META_API_137_P2: "कॉम्पोनेन्ट टाइप",
  T_50_META_API_137_P2_D: "कॉम्पोनेन्ट टाइप",
  T_50_META_API_137_P3: "सफल है",
  T_50_META_API_137_P3_D: "यह सफल है या नहीं",
  T_50_META_API_138: "अगले फ्रेम पर रिवाइव करें",
  T_50_META_API_138_D: "अगले फ्रेम पर रिवाइव करें",
  T_50_META_API_139: "अगले फ्रेम पर एलिमिनेट करें",
  T_50_META_API_139_D: "अगले फ्रेम में बैटल एंटिटी को एलिमिनेट करें",
  T_50_META_API_139_P0_D: "बैटल एंटिटी",
  T_50_META_API_140: "अगले फ्रेम पर गेम क्विट करें",
  T_50_META_API_140_D: "अगले फ्रेम पर गेम से बाहर निकलें",
  T_50_META_API_141: "माइक्रोफ़ोन वॉल्यूम प्राप्त करें",
  T_50_META_API_141_D: "माइक्रोफोन वॉल्यूम प्राप्त करें. जब प्लेयर का माइक्रोफोन बंद हो या एक्सेस न दी गई हो, तब स्टेटस लौटाएं.",
  T_50_META_API_141_P0: "वॉल्यूम",
  T_50_META_API_141_P0_D: "माइक्रोफ़ोन वॉल्यूम",
  T_50_META_API_141_P1_D: "माइक्रोफ़ोन ऑन या ऑफ है",
  T_50_META_API_142: "रेंडर क्वालिटी प्राप्त करें",
  T_50_META_API_142_D: "मौजूदा रेंडरिंग क्वालिटी प्राप्त करें (एनम: लो/मीडियम/हाई/अल्ट्रा)",
  T_50_META_API_143: "रेंडर रिज़ॉल्यूशन प्राप्त करें",
  T_50_META_API_143_D: "मौजूदा रेंडर रिज़ॉल्यूशन हासिल करें",
  T_50_META_API_144: "कस्टम प्लेयर बाइंड करें",
  T_50_META_API_144_D: "डायनामिक रूप से उस टारगेट को सेट करें जिससे यह प्लेयर बाइंड होता है, जो मौजूदा बाइंडिंग्स को ओवरराइड करेगा. फेल होने पर फॉल्स रिटर्न करता है.",
  T_50_META_API_144_P0: "कस्टम प्लेयर",
  T_50_META_API_144_P0_D: "इस कस्टम प्लेयर को प्लेयर से बाइंड करने के बाद, पोजीशन और डायरेक्शन जैसी डेटा अपने आप सिंक हो जाएगी",
  T_50_META_API_144_P1_D: "टारगेट प्लेयर",
  T_50_META_API_145: "कस्टम प्लेयर अनबाइंड",
  T_50_META_API_145_D: "बाइंडिंग रद्द करें. फेल होने पर false रिटर्न करता है.",
  T_50_META_API_145_P0: "कस्टम प्लेयर",
  T_50_META_API_145_P0_D: "इस टारगेट के लिए सभी बाइंडिंग्स क्लियर करें. अनबाइंड करने के बाद, पोजीशन और डायरेक्शन जैसी डेटा अब ऑटोमैटिकली सिंक नहीं होगी.",
  T_50_META_API_146_P0_D: "एक कस्टम प्लेयर",
  T_50_META_API_147: "कस्टम प्लेयर स्टेट सेट करें",
  T_50_META_API_147_D: "अपने आप सर्वर पर अपलोड करें और सभी क्लाइंट्स के साथ सिंक करें. फेल होने पर फॉल्स रिटर्न करता है.",
  T_50_META_API_147_P0: "कस्टम प्लेयर",
  T_50_META_API_147_P1: "स्टेट",
  T_50_META_API_147_P1_D: "आमतौर पर एनिमेशन स्टेट्स को सेव करने के लिए इस्तेमाल होता है. Get Custom Player State के साथ सिंक्ड स्टेट पाएं.",
  T_50_META_API_148: "कस्टम प्लेयर स्टेट पाएं",
  T_50_META_API_148_D: "स्टेट डेटा अपने आप सर्वर से सिंक हो जाता है. फेल होने पर false रिटर्न करता है.",
  T_50_META_API_148_P0: "कस्टम प्लेयर",
  T_50_META_API_148_P1: "स्टेट",
  T_50_META_API_148_P1_D: "सेट कस्टम प्लेयर स्टेट के साथ स्टेट सेट करें",
  T_50_META_API_149: "डिस्टेंस वॉल्यूम्स सेट करें",
  T_50_META_API_149_D: "प्लेयर्स के बीच की दूरी के अनुसार ऑडियो वॉल्यूम को डायनामिकली सेट करें.",
  T_50_META_API_149_P0: "डिस्टेंस लिस्ट",
  T_50_META_API_149_P0_D: "डिस्टेंस रेंज की एक लिस्ट, जिसमें हर रेंज वॉल्यूम लिस्ट के एक एलिमेंट से मेल खाती है.",
  T_50_META_API_149_P1: "वॉल्यूम लिस्ट",
  T_50_META_API_149_P1_D: "वॉल्यूम्स की एक लिस्ट, जिनमें से हर एक डिस्टेंस लिस्ट के एक एलिमेंट से संबंधित है.",
  T_50_META_API_150: "दोस्त पाएं",
  T_50_META_API_150_D: "प्लेयर के फ्रेंड आईडी की लिस्ट हासिल करें",
  T_50_META_API_151: "डिफ़ॉल्ट UI इंफो पाएं",
  T_50_META_API_151_D: "प्लेयर की डिफॉल्ट UI लोकेशन पाएं",
  T_50_META_API_151_P0_D: "डिफ़ॉल्ट इंटरफ़ेस",
  T_50_META_API_151_P1_D: "स्टेटस",
  T_50_META_API_151_P2_D: "UI पोजीशन",
  T_50_META_API_151_P3: "साइज",
  T_50_META_API_151_P3_D: "UI साइज",
  T_50_META_API_152: "कस्टम इवेंट ब्रॉडकास्ट करें",
  T_50_META_API_152_D: "किसी भी एंटिटी के लिए कस्टम इवेंट ब्रॉडकास्ट करें ताकि वह इस इवेंट को रिसीव (लिसन) कर सके",
  T_50_META_API_153: "एंटिटी को इवेंट डिस्पैच करें",
  T_50_META_API_153_D: "कस्टम इवेंट टारगेट एंटिटी को भेजें",
  T_50_META_EVT_17: "स्क्रीन टच शुरू होने पर",
  T_50_META_EVT_17_D: "जब स्क्रीन को टच किया जाए तो इवेंट शुरू करें",
  T_50_META_EVT_17_P0: "टच इंडेक्स",
  T_50_META_EVT_17_P0_D: "टच पॉइंट इंडेक्स",
  T_50_META_EVT_17_P1_D: "टच पोजीशन",
  T_50_META_EVT_18: "स्क्रीन टच एन्ड पर",
  T_50_META_EVT_18_D: "स्क्रीन को टच करने पर इवेंट समाप्त करें",
  T_50_META_EVT_18_P0: "टच इंडेक्स",
  T_50_META_EVT_18_P0_D: "टच पॉइंट इंडेक्स",
  T_50_META_EVT_18_P1_D: "स्क्रीन पर टच पोजीशन्स",
  T_50_META_EVT_19: "पर्सोना क्रिएट रूम रिजल्ट मिलने पर",
  T_50_META_EVT_19_D: "पर्सोना चैट रूम बनाने में फेल होने पर संबंधित परिणाम प्राप्त करें",
  T_50_META_EVT_19_P1: "रूम ID",
  T_50_META_EVT_19_P1_D: "रूम ID",
  T_50_META_EVT_20: "यूज़र के छोड़ने या यूज़र मैच खत्म होने पर",
  T_50_META_EVT_20_D: "जब यूज़र मैच छोड़ता है या जब मैच समाप्त होता है तो ट्रिगर होता है",
  T_50_META_TYP_11_I44: "दूरी वॉल्यूम्स",
  T_50_META_TYP_11_I44_D: "प्लेयर्स के बीच दूरी के आधार पर ऑडियो वॉल्यूम को डायनामिकली एडजस्ट करें",
  T_50_META_TYP_22_I9_D: "UI बनाने के लिए इस्तेमाल की जाने वाली एसेट ID",
  T_50_META_TYP_244_I12_D: "टेक्स्ट बॉक्स की चौड़ाई",
  T_50_META_TYP_244_I13_D: "टेक्स्ट बॉक्स की हाइट",
  T_50_META_TYP_244_I14_D: "ओवरफ्लो टाइप",
  T_50_META_TYP_335_I10_D: "प्लेबैक स्पीड (मान्य मान > 0, डिफ़ॉल्ट = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO ऑपरेशन फेल हो गया: फ़ाइल बनाते समय एरर आ गई.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO ऑपरेशन फेल हो गया. अमान्य फाइल नाम.",
  T_50_META_TYP_448_I0_D: "कंट्रोल्ड स्केलेटन पार्ट",
  T_50_META_TYP_448_I1_D: "वह टारगेट जिसकी ओर स्केलेटन वाला भाग देख रहा है",
  T_50_META_TYP_451: "ओवरफ्लो टाइप",
  T_50_META_TYP_451_D: "टेक्स्ट ओवरफ्लो को हैंडल करने का तरीका",
  T_50_META_TYP_452: "कस्टम UI एसेट ID",
  T_50_META_TYP_452_D: "कस्टम HUD एसेट का वर्णन करने वाली ID",
  T_50_META_TYP_453: "रेंडर क्वालिटी टाइप",
  T_50_META_TYP_453_D: "रेंडरिंग क्वालिटी एनम",
  T_50_META_TYPE_448_D: "इस एंटिटी का उपयोग टारगेट को देखने के लिए कंकाल भाग को कंट्रोल करने के लिए किया जाता है",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D ऑब्जेक्ट जनरेट मैप",
  T_50_SD_WS_MAPTAG_AIRACING: "रेसिंग AI जनरेट मैप",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "एनिमेशन स्थिति नाम enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "फुटस्टेप्स वाइब्रेशन डिसेबल करें",
  T_50_XXJ_WS_NOPERFORMANCE: "अभी तक कोई परफॉरमेंस फ़ाइल नहीं है",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "बीटा वर्शन",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "प्रिय क्रिएटर्स, परफॉर्मेंस एडिटर अभी टेस्टिंग फेज़ में है. इसमें बग्स हो सकते हैं या ज़रूरी फीचर्स की कमी हो सकती है. कृपया इसे सावधानी से इस्तेमाल करें.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "परफॉर्मेंस जोड़ें",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "की क्लिप जोड़ें",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "अलॉन्ग पाथ ट्रैक",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "एनीमेशन",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "एनीमेशन ट्रैक",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "ऑडियो ट्रैक",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "होल्ड",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "हमेशा लूप करें",
  T_50_XXJ_WS_TIMELINE_DURATION: "अवधि: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "एनीमेशन और मॉडल में मेल नहीं है",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "की क्लिप ओवरलैप",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "बाउंड एंटिटी गायब है",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "ट्रैक नाम खाली नहीं हो सकता",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC ट्रैक",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "प्रॉपर्टी ट्रैक",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "की क्लिप हटाएं",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "ट्रैक काउंट लिमिट पार हो गई",
  T_50_XYL_WS_AIGETERATESHOW: "बिल्डिंग ब्लॉक्स",
  T_50_YU_F_B_VA_WITCH: "मिस्टिक ट्रबल (बॉटम)",
  T_50_YU_F_H_VA_WITCH: "मिस्टिक ट्रबल (हेड)",
  T_50_YU_F_HA_VA_WITCH: "मिस्टिक ट्रबल (फेसपेंट)",
  T_50_YU_F_S_VA_WITCH: "मिस्टिक ट्रबल (जूते)",
  T_50_YU_F_T_VA_WITCH: "मिस्टिक ट्रबल (टॉप)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "कस्टम इवेंट",
  T_51_GT_WS_BASIC: "बेसिक",
  T_51_GT_WS_GLOBALEVENT: "ग्लोबल इवेंट",
  T_51_GT_WS_PRIVATEEVENT: "प्राइवेट इवेंट",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "गेम शुरू होने से पहले तैयारी टाइम",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "सिर्फ़ पढ़ने वाली प्रॉपर्टी",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "ब्‍लैक लेदर जैकेट (फीमेल)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "मशरूम हंटर",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "ब्‍लैक एक्टिववियर (जूते)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 हॉटपैंट्स (फीमेल)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 स्‍कर्ट (फीमेल)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "ब्‍लैक एक्टिववियर (हूड़ी)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "सॉन्‍ग्‍क्रन टॉप (काला)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "प्‍लंबर टॉप (फीमेल)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 सिंग्‍लेट (फीमेल)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "वइट प्रॉस्‍पेरिटी (बॉटम)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "काली ट्रैक्‍पैंट्स (मेल)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "पोचर",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "सर्वाइवर पैंट्स",
  TXT_AVATAR_MALE_PANTS_MARIO: "ममैमिया",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "सर्वाइवर जूते़",
  TXT_AVATAR_MALE_SHOE_RED: "रेड बूट्स (पुरुष)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "व्‍हाइट प्रॉस्‍पेरिटी (टॉप)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "ब्‍लैक बेसबाल जर्सी (पुरुष)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "रिबेल हूड़ी",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "कूल एक्टिववियर (हूड़ी)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "स्‍कुल किंग वेस्‍ट",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "सर्वाइवर शर्ट",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "प्‍लंबर टॉप (पुरुष)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "रेसर जैकेट (महिला)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "नाइट क्‍लाउन (हेड)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "रेसर जैकेट (पुरुष)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "स्‍लीवलेस जैकेट (हरी)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "मि. स्क्विडो",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "ज़ोम्‍बीफाइड समुराई (मास्‍क)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "फुल आर्म टैटू",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "एम्ब्रेश",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "विक्‍टोरिया",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "स्‍टाइलिश और रेट्रो",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "किट्सुने बॉटम",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "किट्सुने फूटवियर",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "स्‍पोर्टस जूते़ (नीले)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "डेनिम शॉर्ट्स (फीमेल)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "किट्सुने रोब",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "कॉम्‍बैट पैंट्स (मेल)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "एंजेलिक पैंट्स",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "बुशीदो बॉटम",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "ग्रे जिपर हूड़ी",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "हिप्‍स्‍टर शूज़",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "बुशीदो फूटवियर",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "एस्‍ट्रो शूज़",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "डेनिम शॉर्ट्स (मेल)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "कॉमबैट वेस्‍ट (मेल)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "हिप्‍स्‍टर टॉप",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "वे ऑफ़ द बुशीडो",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "व्‍हाइट हरीकेन",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "बेसबॉलर (टाइट्स)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "राइडर जैकेट (महिला)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "बेसबॉलर (जैकेट)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "कूल कैप्‍टेन (पैंट्स)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "दि स्‍ट्रीट्स (हेड)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "कूल कैप्‍टेन (जूते)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "ASUS जैकेट (मेल)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "कूल कैप्‍टेन (जैकेट)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "डायनो",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "सिल्‍वर बूट",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "थ्री लायन्‍स",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "टक्सेडो (मास्क)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "टक्सेडो (हेड)",
  TXT_AVATAR_PARACHUTE_8: "स्माइली",
  TXT_AVATAR_SHIRT_PLAID_2: "प्रोग्रामर्स फेवरेट (लाल)",
  TXT_AVATAR_SHOES_1: "स्नीकर्स (सफ़ेद)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "स्कूल गर्ल (नारंगी)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "स्कूल गर्ल (लाल)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "स्कूल गर्ल (पीली)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "स्कूल गर्ल (गुलाबी)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "स्कूल गर्ल (जैस्मिन)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "स्कूल गर्ल (नीली)",
  TXT_AVATAR_TSHIRT_WEEK_007: "स्टारी सनडे",
  TXT_BANNER_NAME_MISHA: "स्पीड",
  TXT_CHARACTER_ADAM_NAME: "प्रीमिस",
  TXT_CHARACTER_BODYGUARD_NAME: "निकिता",
  TXT_CHARACTER_COP_NAME: "एंड्रयू",
  TXT_CHARACTER_EVA_NAME: "नूला",
  TXT_CHARACTER_NURSE_NAME: "ओलिविया",
  TXT_CHARACTER_RACERGIRL_NAME: "मीशा",
  TXT_CHARACTER_RUNNER_NAME: "केली",
  TXT_CHARACTER_SEAMAN_NAME: "फोर्ड",
  TXT_CLAN_NAME: "नाम",
  TXT_COLLECTION_DESCRIPTION: "ब्यौरा",
  TXT_COLLECTION_HEADPORTRAIT: "अवतार",
  TXT_INVENTORY_TITLE_EQUIPMENT: "उपकरण",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR गोली",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "बैग Lv1",
  TXT_ITEM_BAG2: "बैग Lv2",
  TXT_ITEM_BAG3: "बैग Lv3",
  TXT_ITEM_BASEBALLPOLE: "बैट",
  TXT_ITEM_BOWAMMO: "क्रॉसबो बोल्ट",
  TXT_ITEM_CHANGUO: "पैन",
  TXT_ITEM_CROSSBOW: "Crossbow",
  TXT_ITEM_DESC_FLASH: "एक ऐसी विस्फोटक डिवाइस जो दुश्मन को अस्थाई रूप से भटका सकती है",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "मेड किट",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "फ़िस्ट",
  TXT_ITEM_FLASH: "फ़्लैशबैंग",
  TXT_ITEM_FOREGRIP1: "फ़ोरग्रिप Lv1",
  TXT_ITEM_FOREGRIP2: "फ़ोरग्रिप Lv2",
  TXT_ITEM_FOREGRIP3: "फ़ोरग्रिप Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "ग्रेनेड",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "हैंड कैनन",
  TXT_ITEM_HEATSIGHT: "थर्मल स्कोप",
  TXT_ITEM_HELMET1: "हेलमेट Lv1",
  TXT_ITEM_HELMET2: "हेलमेट Lv2",
  TXT_ITEM_HELMET3: "हेलमेट Lv3",
  TXT_ITEM_HGAMMO: "HG गोली",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mm SR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "छुरा",
  TXT_ITEM_MAGEZINE1: "मैगज़ीन Lv1",
  TXT_ITEM_MAGEZINE2: "मैगज़ीन Lv2",
  TXT_ITEM_MAGEZINE3: "मैगज़ीन Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "मज़ल Lv1",
  TXT_ITEM_MUZZLE2: "मज़ल Lv2",
  TXT_ITEM_MUZZLE3: "मज़ल Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "SG गोली",
  TXT_ITEM_SIGHT2: "2x स्कोप",
  TXT_ITEM_SIGHT4: "4x स्कोप",
  TXT_ITEM_SILENCER1: "साइलेंसर",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG गोली",
  TXT_ITEM_SNAMMO: "स्नाइपर गोली",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "वेस्ट Lv1",
  TXT_ITEM_VEST2: "वेस्ट Lv2",
  TXT_ITEM_VEST3: "वेस्ट Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "रिजल्ट",
  TXT_MESSAGEBOX_ERROR: "एरर",
  TXT_OB10_HQW_ITEM_BIPOD: "बायपॉड",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "ऑयल बैरल",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "मिगैल",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "क्रेज़ी स्लेयर",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "मेक्सिकन ग्रिल्ड कॉर्न",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "धमाके की सीमा",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "द एक्सक्यूशनर",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "लैंडमाइन",
  TXT_OB11_HQW_LANDMINE_DESC: "ज़मीन में माइन हो सकती है. चेतावनी! उस पर पैर न रखें.",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "कैरोलीन",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "अप्‍लॉज़",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "डैब",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "चिकन",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "हैलो!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "भड़काना",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "जब आपके हाथ में शॉटगन होती है, तो आपकी गति [FFB300]{0}%[-] तक बढ़ जाती है",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "अजिलिटी",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "चीता: पंजा",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "फ्यूचरिस्टिक",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "रिपेयर किट",
  TXT_OB5_HISTORY_HEADSHOOT: "हेडशॉट",
  TXT_OB5_HISTORY_LIVE: "सर्वाइवल",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "मैक्सिम",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "मशरूम खाने और मेड किट्स इस्तेमाल में [FFB300]{0}%[-] तेज़ी.",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "ग्लटनी",
  TXT_OB7_ZC_CLAN_NICKNAME: "निकनेम",
  TXT_OB7_ZJS_HISTORY_TIME: "समय",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "बॉनफ़ायर",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "बोल्ट",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "क्ला",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "फिस्ट से डैमेज [FFB300]{0}%[-] बढ़ा",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "मुए थाई",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "पर्पल मेडोज़",
  TXT_OB8_ZXR_G18_CAMO_NAME: "एटम स्प्लिटर",
  TXT_OB8_ZXR_M249_CAMO_NAME: "विदर्ड",
  TXT_OB8_ZXR_M79_CAMO_NAME: "स्काईस्प्लिटर",
  TXT_OB8_ZXR_USP_CAMO_NAME: "स्नो लेपर्ड",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "पालोमा",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "आर्म्स-डीलिंग",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "ग्रीन स्टार",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "ग्लू वॉल",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "डिजिटल कैमफ्लाश़",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "ब्लडी मैरी",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "डेजर्ट हंटर",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "ब्लूफ्लेम",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "पर्पल परेड",
  TXT_OB9_ZXR_M14_CAMO_NAME: "लाइफस्ट्रीम",
  TXT_OB9_ZXR_M1873_NAME: "डीप ब्लू सी",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "स्वोर्डफ़िश",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "हार्वेस्टर",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "पर्पल क्वार्ट्ज",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "स्कोर्चड अर्थ",
  TXT_OPTION_HIGH_BRIGHTNESS: "चमकीला",
  TXT_PLAYER_RANK: "रैंक",
  TXT_ROOM_LOBBY_ID: "आईडी",
  TXT_ROOM_MAP_PARADISE: "बरमूडा",
  TXT_SETTING_CHANGEWEAPON: "क्विक वेपन स्विच बटन",
  TXT_SETTING_OB4_NOTREAL: "डार्क",
  TXT_SKILL_DESC_COP: "आर्मर ड्यूरेबिलिटी की कमी में [FFB300]{0}%[-] की गिरावट.",
  TXT_SKILL_DESC_RUNNER: "स्प्रिंटिंग स्पीड [FFB300]{0}%[-] बढ़ी.",
  TXT_SKILL_NAME_COP: "आर्मर स्पेशलिस्ट",
  TXT_SKILL_NAME_NURSE: "हीलिंग टच",
  TXT_SKILL_NAME_RACERGIRL: "आफ्टर बर्नर",
  TXT_SKILL_NAME_RUNNER: "डैश",
  TXT_SKILL_NAME_SEAMAN: "आयरन विल",
  TXT_TUTORIAL_HUD: "हुड",
  TXT_TUTORIAL_HUD_LABEL10: "दौड़ें",
  TXT_TUTORIAL_PICKUP_LABEL0: "वेपन",
  T_34_M_WS_VFXTYPE: "VFX टाइप",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "हमले का लक्ष्य",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "खिलाड़ी UI प्रकार",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "मॉन्स्टर कौशल प्रकार",
  T_45_META_WS_DESCRIPTIVECOLOR: "डिस्क्रिप्टिव कलर",
  T_45_META_WS_GAMETIME: "गेम टाइम",
  T_45_META_WS_PROPERTY: "प्रॉपर्टी",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "बटन शैली प्रकार",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "बटन प्रकार",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "त्वरण",
  T_46_META_WS_A_ACCOUNTID: "खाता आईडी",
  T_46_META_WS_A_ACTIONTYPE: "कार्रवाई प्रकार",
  T_46_META_WS_A_ACTIVE: "सक्रिय",
  T_46_META_WS_A_ANGLE: "कोण",
  T_46_META_WS_A_ANY: "कोई भी",
  T_46_META_WS_A_APPEARANCEGROUP: "उपस्थिति समूह",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "दावा अभिव्यक्ति",
  T_46_META_WS_A_ATTACHMENT: "संलग्नक",
  T_46_META_WS_A_ATTACHMENTS: "संलग्नक सूची",
  T_46_META_WS_A_ATTACKABLE: "हमलावर",
  T_46_META_WS_A_ATTACKER: "हमलावर",
  T_46_META_WS_A_ATTACKTARGET: "हमला लक्ष्य",
  T_46_META_WS_A_AUTOPLAY: "स्वत: चलाएँ",
  T_46_META_WS_A_AXIS: "धुरी",
  T_46_META_WS_A_B: "बी",
  T_46_META_WS_A_BASE: "आधार",
  T_46_META_WS_A_BOUNDTARGET: "बाउंड लक्ष्य",
  T_46_META_WS_A_BTREE: "व्यवहार पेड़",
  T_46_META_WS_A_BUFF: "बफ",
  T_46_META_WS_A_CAMERA: "कैमरा",
  T_46_META_WS_A_CAPICITY: "क्षमता",
  T_46_META_WS_A_CENTER: "केंद्र",
  T_46_META_WS_A_CHANGEROTATION: "घुमाव बदलें",
  T_46_META_WS_A_CHANNEL: "चैनल",
  T_46_META_WS_A_CHASEENEMY: "दुश्मन का पीछा करें",
  T_46_META_WS_A_CHILD: "शिशु",
  T_46_META_WS_A_COLOR: "रंग",
  T_46_META_WS_A_COLUMN: "स्तंभ",
  T_46_META_WS_A_COLUMNNAME: "स्तंभ नाम",
  T_46_META_WS_A_COMEBACK: "वापस आना",
  T_46_META_WS_A_COMPONENT: "घटक",
  T_46_META_WS_A_CONTENT: "सामग्री",
  T_46_META_WS_A_COORDINATESYSTEM: "निर्देशांक प्रणाली",
  T_46_META_WS_A_COUNT: "संख्या",
  T_46_META_WS_A_COUNTS: "गिनती",
  T_46_META_WS_A_CREATEDENTITY: "निर्मित इकाई",
  T_46_META_WS_A_CROSSPLATFORM: "क्रॉस प्लेटफ़ॉर्म",
  T_46_META_WS_A_CULLINGMASK: "कलिंग मास्क",
  T_46_META_WS_A_CURVE: "वक्र",
  T_46_META_WS_A_CUSTOMTAG: "कस्टम टैग",
  T_46_META_WS_A_CUTRADIUS: "कट त्रिज्या",
  T_46_META_WS_A_DAMAGE: "नुकसान",
  T_46_META_WS_A_DAMAGESEGMENTS: "क्षति खंड",
  T_46_META_WS_A_DEGREE: "डिग्री",
  T_46_META_WS_A_DELTA: "डेल्टा",
  T_46_META_WS_A_DEPTH: "गहराई",
  T_46_META_WS_A_DESTVAL: "गंतव्य मान",
  T_46_META_WS_A_DIFFICULTY: "कठिनाई",
  T_46_META_WS_A_DIRECTION: "दिशा",
  T_46_META_WS_A_DISABLE: "अक्षम है",
  T_46_META_WS_A_DISPLACEMENT: "विस्थापन",
  T_46_META_WS_A_DISTANCE: "दूरी",
  T_46_META_WS_A_DIVINGMAXSPEED: "डाइविंग अधिकतम गति",
  T_46_META_WS_A_DOTWEEN: "ट्विन लागू करें",
  T_46_META_WS_A_DURATION: "अवधि (सेकंड)",
  T_46_META_WS_A_EMOTE: "इमोट",
  T_46_META_WS_A_ENABLE: "सक्षम करें",
  T_46_META_WS_A_ENDAREACENTER: "अंत क्षेत्र केंद्र",
  T_46_META_WS_A_ENDAREARANGE: "अंत क्षेत्र सीमा",
  T_46_META_WS_A_ENDPOSITION: "अंत स्थिति",
  T_46_META_WS_A_ENDRANK: "अंत रैंक",
  T_46_META_WS_A_EQUIPMENTS: "उपकरण",
  T_46_META_WS_A_EVENTID: "घटना आईडी",
  T_46_META_WS_A_EXPONENT: "घातांक",
  T_46_META_WS_A_FACTION: "गुट",
  T_46_META_WS_A_FACTORTYPE: "कारक प्रकार",
  T_46_META_WS_A_FILTERTYPE: "फ़िल्टर प्रकार",
  T_46_META_WS_A_FINALRADIUS: "अंतिम त्रिज्या",
  T_46_META_WS_A_FINDVALUE: "मान खोजें",
  T_46_META_WS_A_FIXEDRANGE: "स्थिर श्रेणी",
  T_46_META_WS_A_FOLLOWTARGET: "लक्ष्य का अनुसरण करें",
  T_46_META_WS_A_FONTCOLOR: "फ़ॉन्ट रंग",
  T_46_META_WS_A_FONTSIZE: "फ़ॉन्ट आकार",
  T_46_META_WS_A_FOOTBALL: "फुटबॉल",
  T_46_META_WS_A_FORCE: "बल",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "मजबूर पैराशूट ऊँचाई",
  T_46_META_WS_A_FORCEMODE: "बल मोड",
  T_46_META_WS_A_FORWARD: "दिशा",
  T_46_META_WS_A_G: "जी",
  T_46_META_WS_A_GAMEID: "खेल आईडी",
  T_46_META_WS_A_HALFEXTENTS: "आधी मात्रा",
  T_46_META_WS_A_HEIGHT: "ऊँचाई",
  T_46_META_WS_A_HEIGHTSEGMENTS: "ऊँचाई खंड",
  T_46_META_WS_A_HITDISTANCE: "हिट दूरी",
  T_46_META_WS_A_HITDISTANCES: "हिट दूरी",
  T_46_META_WS_A_HITENTITIES: "हिट इकाइयाँ",
  T_46_META_WS_A_HITENTITY: "हिट एंटिटी",
  T_46_META_WS_A_HITNORMAL: "हिट सामान्य",
  T_46_META_WS_A_HITNORMALS: "हिट सामान्य",
  T_46_META_WS_A_HITPOINTS: "हिट पॉइंट",
  T_46_META_WS_A_HITPOSITION: "हिट स्थिति",
  T_46_META_WS_A_INCLUDETRIGGER: "ट्रिगर शामिल करें",
  T_46_META_WS_A_INDEX: "सूचकांक",
  T_46_META_WS_A_INDEXS: "सूचकांक",
  T_46_META_WS_A_INITIALVELOCITY: "प्रारंभिक वेग",
  T_46_META_WS_A_INITRADIUS: "प्रारंभिक त्रिज्या",
  T_46_META_WS_A_INWALLET: "इनवॉलेट",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "क्या नीचे टकरा रहा है",
  T_46_META_WS_A_ISEXIST: "अस्तित्व",
  T_46_META_WS_A_ISLOOP: "लूप है",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "स्क्रीन पर मैप्ड है या नहीं",
  T_46_META_WS_A_ISPAUSE: "विराम",
  T_46_META_WS_A_ISSIDECOLLIDING: "क्या पक्ष पर टकरा रहा है",
  T_46_META_WS_A_ISSUCCESS: "सफल है या नहीं",
  T_46_META_WS_A_ISTOPCOLLIDING: "क्या शीर्ष पर टकरा रहा है",
  T_46_META_WS_A_ITEM: "वस्तु",
  T_46_META_WS_A_ITEMID: "वस्तु आईडी",
  T_46_META_WS_A_ITEMS: "वस्तुएँ",
  T_46_META_WS_A_ITEMTYPE: "वस्तु प्रकार",
  T_46_META_WS_A_JERSEYTYPE: "जर्सी प्रकार",
  T_46_META_WS_A_KEEPVELOCITY: "वेग बनाए रखें",
  T_46_META_WS_A_KEY: "कुंजी",
  T_46_META_WS_A_KEYCOLUMN: "कुंजी स्तंभ",
  T_46_META_WS_A_KEYS: "कुंजियाँ",
  T_46_META_WS_A_LAYER: "परत",
  T_46_META_WS_A_LAYERMASK: "लेयर मास्क",
  T_46_META_WS_A_LEFT: "बाएं",
  T_46_META_WS_A_LEFTVALUE: "बाईं ओर का मान",
  T_46_META_WS_A_LENGTH: "लंबाई",
  T_46_META_WS_A_LEVELOBJECT: "स्तर वस्तु",
  T_46_META_WS_A_LOG: "लॉग",
  T_46_META_WS_A_LOOKATTARGET: "लक्ष्य पर नजर रखें",
  T_46_META_WS_A_LOOPTYPE: "लूप प्रकार",
  T_46_META_WS_A_MAINCOLOR1: "मुख्य रंग1",
  T_46_META_WS_A_MAINCOLOR2: "मुख्य रंग2",
  T_46_META_WS_A_MAPCODE: "मानचित्र कोड",
  T_46_META_WS_A_MAPPEDPOSITION: "मैप्ड स्थिति",
  T_46_META_WS_A_MAX: "अधिकतम",
  T_46_META_WS_A_MAXDISPLACEMENT: "अधिकतम विस्थापन",
  T_46_META_WS_A_MAXDISTANCE: "अधिकतम दूरी",
  T_46_META_WS_A_MIN: "न्यूनतम",
  T_46_META_WS_A_MISSIONID: "मिशन आईडी",
  T_46_META_WS_A_MISSIONPROGRESS: "मिशन प्रगति",
  T_46_META_WS_A_MODIFYTYPE: "संशोधन प्रकार",
  T_46_META_WS_A_MONEYTYPE: "मुद्रा प्रकार",
  T_46_META_WS_A_MUST: "आवश्यक",
  T_46_META_WS_A_NAME: "नाम",
  T_46_META_WS_A_NEWVALUE: "नया मान",
  T_46_META_WS_A_NODE: "नोड",
  T_46_META_WS_A_NORMAL: "सामान्य",
  T_46_META_WS_A_NOT: "नहीं",
  T_46_META_WS_A_OBSERVER: "पर्यवेक्षक",
  T_46_META_WS_A_OFFSET: "ऑफसेट",
  T_46_META_WS_A_OLDVALUE: "पुराना मान",
  T_46_META_WS_A_OPERATIOMETHOD: "संचालन विधि",
  T_46_META_WS_A_OPTIONS: "विकल्प",
  T_46_META_WS_A_OTHERCOLOR: "अन्य रंग",
  T_46_META_WS_A_OUTFIT: "पोशाक",
  T_46_META_WS_A_OUTFITS: "पोशाक सूची",
  T_46_META_WS_A_OUTWALLET: "आउट वॉलेट",
  T_46_META_WS_A_OWNER: "मालिक",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "पैराशूटिंग अधिकतम गति",
  T_46_META_WS_A_PARAMS: "पैरामीटर",
  T_46_META_WS_A_PARENT: "जनक",
  T_46_META_WS_A_PARENTWIDGET: "जनक विजेट",
  T_46_META_WS_A_PATH: "पथ",
  T_46_META_WS_A_PATHPOINTS: "पथ बिंदु",
  T_46_META_WS_A_PHASEINDEX: "चरण सूचक",
  T_46_META_WS_A_PLATFORM: "प्लेटफ़ॉर्म",
  T_46_META_WS_A_PLAYER: "खिलाड़ी",
  T_46_META_WS_A_PLAYSPEED: "प्ले गति",
  T_46_META_WS_A_POSITION: "स्थिति",
  T_46_META_WS_A_POSITIONS: "स्थितियाँ",
  T_46_META_WS_A_POSTION: "स्थिति",
  T_46_META_WS_A_PREFAB: "प्रीफैब",
  T_46_META_WS_A_PROPERTY: "संपत्ति",
  T_46_META_WS_A_PROPERTYID: "संपत्ति आईडी",
  T_46_META_WS_A_PURSUITTARGET: "पीछा लक्ष्य",
  T_46_META_WS_A_R: "आर",
  T_46_META_WS_A_RADIUS: "त्रिज्या",
  T_46_META_WS_A_RANDOMDECAY: "यादृच्छिक क्षीणन",
  T_46_META_WS_A_RANDOMRANGE: "यादृच्छिक सीमा",
  T_46_META_WS_A_RANDOMRATIO: "यादृच्छिक अनुपात",
  T_46_META_WS_A_RANGE: "श्रेणी",
  T_46_META_WS_A_RANK: "रैंक",
  T_46_META_WS_A_REALCOIN: "वास्तविक सिक्का",
  T_46_META_WS_A_REALNUMBER: "वास्तविक संख्या",
  T_46_META_WS_A_RESET: "रीसेट करें",
  T_46_META_WS_A_RESOURCE: "संसाधन",
  T_46_META_WS_A_RESULT: "परिणाम",
  T_46_META_WS_A_RIGHT: "दाएं",
  T_46_META_WS_A_RIGHTVALUE: "दाईं ओर का मान",
  T_46_META_WS_A_ROTATION: "घुमाव",
  T_46_META_WS_A_ROW: "पंक्ति",
  T_46_META_WS_A_SAMPLEPOINT: "नमूना बिंदु",
  T_46_META_WS_A_SCALE: "पैमाना",
  T_46_META_WS_A_SCENEID: "दृश्य आईडी",
  T_46_META_WS_A_SCORE: "स्कोर",
  T_46_META_WS_A_SCORENAME: "स्कोर नाम",
  T_46_META_WS_A_SCREENPOSITION: "स्क्रीन स्थिति",
  T_46_META_WS_A_SCRIPT: "स्क्रिप्ट",
  T_46_META_WS_A_SEAT: "सीट",
  T_46_META_WS_A_SEP: "विभाजक",
  T_46_META_WS_A_SEPSTR: "विभाजक",
  T_46_META_WS_A_SHEETNAME: "शीट का नाम",
  T_46_META_WS_A_SHOPITEM: "दुकान की वस्तु",
  T_46_META_WS_A_SHOWBACKGROUND: "पृष्ठभूमि दिखाएं",
  T_46_META_WS_A_SHOWMATCHRESULT: "खेल परिणाम दिखाएँ",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "रद्द होने पर संदेश दिखाएं",
  T_46_META_WS_A_SKILL: "कौशल",
  T_46_META_WS_A_SKILLS: "कौशल",
  T_46_META_WS_A_SKILLTARGET: "कौशल लक्ष्य",
  T_46_META_WS_A_SKIN: "बैकपैक स्किन",
  T_46_META_WS_A_SLOT: "स्लॉट",
  T_46_META_WS_A_SRCVAL: "स्रोत मान",
  T_46_META_WS_A_SRCVALUE: "स्रोत मूल्य",
  T_46_META_WS_A_STARTAREACENTER: "प्रारंभ क्षेत्र केंद्र",
  T_46_META_WS_A_STARTAREARANGE: "प्रारंभ क्षेत्र सीमा",
  T_46_META_WS_A_STARTINDEX: "प्रारंभ सूचकांक",
  T_46_META_WS_A_STARTPOSITION: "प्रारंभिक स्थिति",
  T_46_META_WS_A_STARTRANK: "प्रारंभ रैंक",
  T_46_META_WS_A_STATE: "स्थिति",
  T_46_META_WS_A_STATUS: "स्थिति",
  T_46_META_WS_A_STATUSCODE: "स्थिति कोड",
  T_46_META_WS_A_STYLE: "शैली",
  T_46_META_WS_A_SURFINGMAXSPEED: "सर्फिंग अधिकतम गति",
  T_46_META_WS_A_TARGET: "लक्ष्य",
  T_46_META_WS_A_TARGETPOSITION: "लक्ष्य स्थिति",
  T_46_META_WS_A_TEAMSEQ: "टीम अनुक्रम",
  T_46_META_WS_A_THRESHOLD: "सीमा",
  T_46_META_WS_A_TIMESTAMP: "टाइमस्टैम्प",
  T_46_META_WS_A_TIPS: "सुझाव",
  T_46_META_WS_A_TITLE: "शीर्षक",
  T_46_META_WS_A_TOKENCOUNT: "टोकन की संख्या",
  T_46_META_WS_A_TOKENID: "टोकन आईडी",
  T_46_META_WS_A_TORQUE: "टॉर्क",
  T_46_META_WS_A_TOUCHPOINT: "टच प्वाइंट",
  T_46_META_WS_A_TRANSITIONTIME: "संक्रमण समय (मि.से.)",
  T_46_META_WS_A_TRANSITIONTYPE: "संक्रमण प्रकार",
  T_46_META_WS_A_TRIGGER: "ट्रिगर",
  T_46_META_WS_A_TYPE: "प्रकार",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "यूआई आईडी",
  T_46_META_WS_A_UPWARD: "ऊपर की ओर",
  T_46_META_WS_A_VALUE: "मान",
  T_46_META_WS_A_VALUEA: "मान A",
  T_46_META_WS_A_VALUEB: "मान B",
  T_46_META_WS_A_VALUES: "मान",
  T_46_META_WS_A_VALUET: "मान T",
  T_46_META_WS_A_VALUETYPE: "मूल्य प्रकार",
  T_46_META_WS_A_VEHICLE: "वाहन",
  T_46_META_WS_A_VEHICLESKIN: "वाहन स्किन",
  T_46_META_WS_A_VELOCITY: "वेग",
  T_46_META_WS_A_VELOCITYXZ: "XZ वेग",
  T_46_META_WS_A_VELOCITYY: "Y वेग",
  T_46_META_WS_A_VISIBLE: "दृश्यमान",
  T_46_META_WS_A_WAITTIME: "प्रतीक्षा समय (सेकंड)",
  T_46_META_WS_A_WALLET: "वॉलेट",
  T_46_META_WS_A_WEAPON: "हथियार",
  T_46_META_WS_A_WEAPONSKIN: "हथियार की त्वचा",
  T_46_META_WS_A_WIDGETID: "विजेट आईडी",
  T_46_META_WS_A_WIDGETTYPE: "विजेट प्रकार",
  T_46_META_WS_A_WIDTH: "चौड़ाई",
  T_46_META_WS_A_WORLDPOSITION: "विश्व स्थिति",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "विश्व स्थिति बनी रहती है",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "पूर्णांक",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI विशेष अनुसरण जोड़ें",
  T_46_META_WS_ADDATTACHMENTS: "अटैचमेंट जोड़ें",
  T_46_META_WS_ADDBUFF: "बफ जोड़ें",
  T_46_META_WS_ADDCOMPONENT: "घटक जोड़ें",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "फुटबॉल की गति जोड़ें",
  T_46_META_WS_ADDFORCE: "बल जोड़ें",
  T_46_META_WS_ADDFORCEATPOSITION: "स्थिति पर बल जोड़ें",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "फॉर्मूला प्रॉपर्टी फैक्टर जोड़ें",
  T_46_META_WS_ADDGAMEEVENTLOG: "गेम इवेंट लॉग जोड़ें",
  T_46_META_WS_ADDHP: "HP जोड़ें",
  T_46_META_WS_ADDITEM: "आइटम जोड़ें",
  T_46_META_WS_ADDITEMINSCENE: "दृश्य में आइटम बनाएं",
  T_46_META_WS_ADDITEMTOSHOPITEM: "आइटम को आइटम में जोड़ें",
  T_46_META_WS_ADDMONEY: "पैसा जोड़ें",
  T_46_META_WS_ADDSCRIPT: "स्क्रिप्ट जोड़ें",
  T_46_META_WS_ADDTAG: "टैग जोड़ें",
  T_46_META_WS_ADDTOKEN: "टोकन जोड़ें",
  T_46_META_WS_ADDTORQUE: "टॉर्क जोड़ें",
  T_46_META_WS_ADDUSEREVENTLOG: "उपयोगकर्ता इवेंट लॉग जोड़ें",
  T_46_META_WS_ANGEL: "कोण",
  T_46_META_WS_APPEND: "जोड़ें",
  T_46_META_WS_APPENDRANGE: "रेंज जोड़ें",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "बीच में छोड़ने UI कॉन्फ़िगरेशन लागू करें",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "पुष्टि करें",
  T_46_META_WS_ASSISTPLAYER: "सहायक खिलाड़ी",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "हमलावर",
  T_46_META_WS_ATTACKTARGET: "हमला लक्ष्य",
  T_46_META_WS_AXISANGLETOQUATERNION: "अक्ष कोण को क्वाटरनियन में बदलें",
  T_46_META_WS_BOXCAST: "बॉक्स कास्ट",
  T_46_META_WS_BOXOVERLAP: "बॉक्स ओवरलैप",
  T_46_META_WS_BUTTONNAME: "बटन का नाम",
  T_46_META_WS_C_ACTIONTYPE: "क्रिया प्रकार",
  T_46_META_WS_C_AIMABLE: "निशाना बनाया जा सकने वाला",
  T_46_META_WS_C_AIMASSISTABLE: "सहायता प्राप्त निशाना बनाने वाला",
  T_46_META_WS_C_AIMASSISTTYPE: "लक्ष्य सहायक प्रकार",
  T_46_META_WS_C_AIRDROP: "एयरड्रॉप",
  T_46_META_WS_C_AMMO: "गोला-बारूद",
  T_46_META_WS_C_AMMOTYPE: "गोला-बारूद प्रकार",
  T_46_META_WS_C_AMPHIBIAN: "एम्फीबियन",
  T_46_META_WS_C_ANIMATIONCLIP: "एनिमेशन क्लिप",
  T_46_META_WS_C_ANIMATIONCLIPID: "एनीमेशन क्लिप आईडी",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "एनिमेशन कंट्रोलर",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "एनीमेशन कंट्रोलर अटेचबल",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "एनीमेशन कंट्रोलर आईडी",
  T_46_META_WS_C_ANIMATIONSTATE: "एनिमेशन स्टेट",
  T_46_META_WS_C_ANIMATIONTRIGGER: "एनीमेशन ट्रिगर",
  T_46_META_WS_C_APPEARENCE: "रूप",
  T_46_META_WS_C_ASSETCONFIGID: "एसेट कॉन्फिगरेशन आईडी",
  T_46_META_WS_C_ASSETID: "संपत्ति आईडी",
  T_46_META_WS_C_ATTACHMENT: "अटैचमेंट",
  T_46_META_WS_C_ATTACKABLETYPE: "अटैक करने योग्य प्रकार",
  T_46_META_WS_C_AUDIOID: "ऑडियो आईडी",
  T_46_META_WS_C_BACKPACK: "बैग",
  T_46_META_WS_C_BACKPACKSKINID: "बैग त्वचा आईडी",
  T_46_META_WS_C_BASEDATAALIAS: "बेस डेटा उपनाम",
  T_46_META_WS_C_BASICAPPEARANCE: "मूल रूप",
  T_46_META_WS_C_BASICCYLINDER: "बुनियादी सिलेंडर या शंकु",
  T_46_META_WS_C_BASICSCALABLE: "बुनियादी स्केलेबल",
  T_46_META_WS_C_BASICSPHERE: "बुनियादी गोलाकार",
  T_46_META_WS_C_BATCHCOMBINERENDER: "बैच संयोजन रेंडर",
  T_46_META_WS_C_BEVTREE: "बिहेवियर ट्री",
  T_46_META_WS_C_BEVTREEATTACHABLE: "बिहेवियर ट्री अटैचेबल",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "बिहेवियर ट्री कस्टम नोड",
  T_46_META_WS_C_BEVTREEID: "बिहेवियर ट्री ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "बिहेवियर ट्री नोड स्थिति",
  T_46_META_WS_C_BEVTREENODETYPE: "बिहेवियर ट्री नोड प्रकार",
  T_46_META_WS_C_BEZIERCURVE: "बेज़ियर कर्व",
  T_46_META_WS_C_BOOL: "बूलियन",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "बॉट की कठिनाई प्रकार",
  T_46_META_WS_C_BOUNCINGTIRE: "उछलता हुआ टायर",
  T_46_META_WS_C_BUFFABLE: "बफ करने योग्य",
  T_46_META_WS_C_BUFFGENERATOR: "बफ जनरेटर",
  T_46_META_WS_C_BUFFTYPE: "बफ़ प्रकार",
  T_46_META_WS_C_BUILTINRENDER: "बिल्ट-इन रेंडर",
  T_46_META_WS_C_BUILTINUI: "बिल्ट-इन UI",
  T_46_META_WS_C_BUILTINUITYPE: "बिल्ट-इन UI प्रकार",
  T_46_META_WS_C_CAMERA: "कैमरा",
  T_46_META_WS_C_CAMERABLOCKMODE: "कैमरा ब्लॉक मोड",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "कैमरा प्रक्षिप्ति मोड",
  T_46_META_WS_C_CAMERARAYCASTUI: "कैमरा रे-कास्ट UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "कैमरा ट्रांजिशन प्रकार",
  T_46_META_WS_C_CAMERATYPE: "कैमरा प्रकार",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "कैमरा देखने का कोण प्रतिबंध प्रकार",
  T_46_META_WS_C_CAPSULETRIGGER: "कैप्सूल ट्रिगर",
  T_46_META_WS_C_CAR: "कार",
  T_46_META_WS_C_CHARACTERCONTROLLER: "कैरेक्टर कंट्रोलर",
  T_46_META_WS_C_CHATCHANNEL: "चैट चैनल",
  T_46_META_WS_C_CHATCHANNELTYPE: "चैट चैनल प्रकार",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "चेकपॉइंट ट्रिगर",
  T_46_META_WS_C_COINGENERATOR: "सिक्का जनरेटर",
  T_46_META_WS_C_COLLECTIONID: "संग्रह आईडी",
  T_46_META_WS_C_COLLIDER: "कोलाइडर",
  T_46_META_WS_C_COLLIDERCOLLECTION: "कोलाइडर आकार",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "कॉलाइडर संग्रह ID",
  T_46_META_WS_C_COLORDRUM: "रंगीन ड्रम",
  T_46_META_WS_C_COMBATABLE: "लड़ाई योग्य",
  T_46_META_WS_C_COMPONENT: "घटक",
  T_46_META_WS_C_CONDITION: "शर्त",
  T_46_META_WS_C_CONTAINER: "कंटेनर",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "निर्देशांक प्रणाली प्रकार",
  T_46_META_WS_C_CROSSBOW: "ग्रेनेड क्रॉसबो",
  T_46_META_WS_C_CSVID: "सीएसवी आईडी",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "कस्टम ट्रिगर",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "कस्टम ऑब्जेक्ट",
  T_46_META_WS_C_CUSTOMPATH: "कस्टम पथ",
  T_46_META_WS_C_CUSTOMUI: "कस्टम UI",
  T_46_META_WS_C_CUSTOMUIID: "कस्टम यूआई आईडी",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "कस्टम UI या विजेट",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "कस्टम UI विजेट आईडी",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "क्षतिग्रस्त शरीर के हिस्से की प्रकार",
  T_46_META_WS_C_DAMAGETYPE: "नुकसान प्रकार",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "मृत्यु या अजेयता ट्रिगर",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "नष्ट करने योग्य वस्तु",
  T_46_META_WS_C_DICE: "पासा",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "डबल जंप शूज",
  T_46_META_WS_C_DRUMMUSIC: "ड्रम संगीत",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "डुअल-व्हील्ड हथियार प्रकार",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "सामान्य स्तर वस्तु",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "डायनामिक क्रिएट लेवल ऑब्जेक्ट प्रकार",
  T_46_META_WS_C_DYNAMICFENCE: "डायनामिक फेंस",
  T_46_META_WS_C_EFFECT: "प्रभाव",
  T_46_META_WS_C_EFFECTCONTAINER: "इफेक्ट कंटेनर",
  T_46_META_WS_C_EFFECTID: "प्रभाव आईडी",
  T_46_META_WS_C_EMOTETYPE: "इमोट प्रकार",
  T_46_META_WS_C_ENDPOINTTRIGGER: "एंड पॉइंट ट्रिगर",
  T_46_META_WS_C_ENTITY: "इकाई",
  T_46_META_WS_C_ENTITYORPREFABID: "एंटिटी या प्रीफैब आईडी",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "उपकरण सहायक",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "उपकरण स्लॉट प्रकार",
  T_46_META_WS_C_EQUIPMENTTYPE: "उपकरण प्रकार",
  T_46_META_WS_C_EVENTID: "इवेंट आईडी",
  T_46_META_WS_C_FACTION: "गुट",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "भरने की दिशा का प्रकार",
  T_46_META_WS_C_FILLTYPE: "भरने का प्रकार",
  T_46_META_WS_C_FIRETYPE: "आग प्रकार",
  T_46_META_WS_C_FLOAT: "फ्लोट",
  T_46_META_WS_C_FOLDWING: "तहकिकारी पंख",
  T_46_META_WS_C_FOLLOW: "फॉलो",
  T_46_META_WS_C_FONTTYPE: "फ़ॉन्ट प्रकार",
  T_46_META_WS_C_FOOTBALL: "फुटबॉल",
  T_46_META_WS_C_FORCETYPE: "बल प्रकार",
  T_46_META_WS_C_FORMULABLE: "सूत्रीकरण योग्य",
  T_46_META_WS_C_FRAMESELFRELATIVE: "फ्रेम स्व-सापेक्ष",
  T_46_META_WS_C_GAMERESULTTYPE: "खेल परिणाम प्रकार",
  T_46_META_WS_C_GENDERTYPE: "लिंग प्रकार",
  T_46_META_WS_C_GENERALSPAWNPOINT: "सामान्य स्पॉन पॉइंट",
  T_46_META_WS_C_GRENADEDEICEWALL: "डी-आइस वॉल ग्रेनेड",
  T_46_META_WS_C_GRENADEFLASHBANG: "फ्लैशबैंग",
  T_46_META_WS_C_GRENADEFROZEN: "ठंडा ग्रेनेड",
  T_46_META_WS_C_GRENADELAUNCHER: "ग्रेनेड लॉन्चर",
  T_46_META_WS_C_GRENADESMOKE: "धुआँ ग्रेनेड",
  T_46_META_WS_C_GRENADEWEAPON: "ग्रेनेड बेस",
  T_46_META_WS_C_GRID: "ग्रिड",
  T_46_META_WS_C_HANDCANNON: "हाथ पिस्तौल ग्रेनेड",
  T_46_META_WS_C_HELMET: "हेलमेट",
  T_46_META_WS_C_HIERARCHICAL: "श्रेणीकृत",
  T_46_META_WS_C_HOOKGUN: "हुक गन",
  T_46_META_WS_C_HORIZALINE: "क्षैतिज रेखा",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI ट्रांसफार्मर",
  T_46_META_WS_C_HUMANMODELID: "मानव मॉडल आईडी",
  T_46_META_WS_C_ICEWALL: "बर्फ की दीवार",
  T_46_META_WS_C_ICEWALLCREATED: "निर्मित बर्फ की दीवार",
  T_46_META_WS_C_ICEWALLMAKER: "आइस वॉल निर्माता",
  T_46_META_WS_C_ICON: "आइकन एंटिटी",
  T_46_META_WS_C_ICONTYPE: "आइकन प्रकार",
  T_46_META_WS_C_INHALER: "इनहेलेटर",
  T_46_META_WS_C_INT: "पूर्णांक",
  T_46_META_WS_C_INT64: "64-बिट पूर्णांक",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "पूर्णांक मानक टेम्प्लेट",
  T_46_META_WS_C_INTORINTLIST: "पूर्णांक या पूर्णांकों की सूची",
  T_46_META_WS_C_INVENTORYTYPE: "इन्वेंट्री प्रकार",
  T_46_META_WS_C_ITEMBASE: "आइटम बेस",
  T_46_META_WS_C_ITEMCONTAINER: "आइटम कंटेनर",
  T_46_META_WS_C_ITEMID: "वस्तु आईडी",
  T_46_META_WS_C_ITEMIDTYPE: "आइटम आईडी प्रकार",
  "T_46_META_WS_C_JERSEY STYLE": "जर्सी शैली",
  T_46_META_WS_C_JERSEYMACHINE: "जर्सी मशीन",
  T_46_META_WS_C_JETSHOES: "जेट शूज",
  T_46_META_WS_C_KEYBOARD: "कीबोर्ड",
  T_46_META_WS_C_KNOCKDOWNTYPE: "नॉकडाउन प्रकार",
  T_46_META_WS_C_LANDMINE: "ज़मीन में खदान",
  T_46_META_WS_C_LANDMINECREATED: "निर्मित भूमि खदान",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "लॉन्च पैड स्तर वस्तु",
  T_46_META_WS_C_LAUNCHPAD: "लॉन्च पैड",
  T_46_META_WS_C_LAYOUTSORTTYPE: "लेआउट सॉर्ट प्रकार",
  T_46_META_WS_C_LEAD1MUSIC: "लीड1 संगीत",
  T_46_META_WS_C_LEAD2MUSIC: "लीड2 संगीत",
  T_46_META_WS_C_LEAD3MUSIC: "लीड3 संगीत",
  T_46_META_WS_C_LEVELOBJECTID: "स्तर वस्तु आईडी",
  T_46_META_WS_C_LEVELOBJECTTYPE: "लेवल ऑब्जेक्ट प्रकार",
  T_46_META_WS_C_LIST: "सूची",
  T_46_META_WS_C_LISTORMAP: "सूची या मानचित्र",
  T_46_META_WS_C_LISTT: "सूची टेम्पलेट",
  T_46_META_WS_C_LISTT_BOOL: "बूलियन सूची",
  T_46_META_WS_C_LISTT_CONDITION: "शर्तों की सूची",
  T_46_META_WS_C_LISTT_ENTITY: "एंटिटी सूची",
  T_46_META_WS_C_LISTT_FLOAT: "फ्लोट सूची",
  T_46_META_WS_C_LISTT_INT: "पूर्णांक सूची",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "आइटम सूची",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "स्तर वस्तु सूची",
  T_46_META_WS_C_LISTT_LOCKEY: "स्थानीयकरण कुंजी सूची",
  T_46_META_WS_C_LISTT_PLAYABLE: "प्लेएबल सूची",
  T_46_META_WS_C_LISTT_PLAYER: "खिलाड़ी सूची",
  T_46_META_WS_C_LISTT_SKILLID: "कौशल आईडी सूची",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "ध्वनि प्रभाव सूची",
  T_46_META_WS_C_LISTT_STRING: "स्ट्रिंग सूची",
  T_46_META_WS_C_LISTT_TEAM: "टीम सूची",
  T_46_META_WS_C_LISTT_TYPE: "प्रकार सूची",
  T_46_META_WS_C_LISTT_VECTOR3: "वेक्टर3 सूची",
  T_46_META_WS_C_LOCKEY: "स्थानीयकरण कुंजी",
  T_46_META_WS_C_LOOKAT: "लुकएट",
  T_46_META_WS_C_LOOPABLE: "लूप योग्य",
  T_46_META_WS_C_LOOPTYPE: "लूप टाइप",
  T_46_META_WS_C_LOOTAMMOTYPE: "लूट गोला-बारूद प्रकार",
  T_46_META_WS_C_LOOTARMOR: "लूट आर्मर",
  T_46_META_WS_C_LOOTARMORTYPE: "लूट आर्मर प्रकार",
  T_46_META_WS_C_LOOTCONSUMABLE: "लूट उपभोग्य वस्तु",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "लूट उपभोग्य वस्तु प्रकार",
  T_46_META_WS_C_LOOTIAMMO: "लूट गोला-बारूद",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "लूट फुटबॉल आइटम बॉक्स",
  T_46_META_WS_C_LOOTSCOPE: "लूट स्कोप",
  T_46_META_WS_C_LOOTSCOPETYPE: "लूट स्कोप प्रकार",
  T_46_META_WS_C_LOOTSOCCERTYPE: "लूट फुटबॉल प्रकार",
  T_46_META_WS_C_LOOTTHROWABLE: "लूट फेंकने योग्य वस्तु",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "लूट फेंकने योग्य वस्तु प्रकार",
  T_46_META_WS_C_LOOTWEAPON: "लूट हथियार",
  T_46_META_WS_C_LOOTWEAPONTYPE: "लूट हथियार प्रकार",
  T_46_META_WS_C_LOWGRAVITY: "निम्न-गुरुत्वाकर्षण क्षेत्र",
  T_46_META_WS_C_MAP: "मानचित्र",
  T_46_META_WS_C_MAPT: "मानचित्र टेम्पलेट",
  T_46_META_WS_C_MATERIALID: "सामग्री ID",
  T_46_META_WS_C_MEDKIT: "चिकित्सा किट",
  T_46_META_WS_C_MESHID: "मैश आईडी",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "मध्य-खेल निकासी कॉन्फ़िगरेशन",
  T_46_META_WS_C_MINIMAP: "मिनीमैप",
  T_46_META_WS_C_MINIMAPICON: "मिनीमैप आइकन",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "मिनीमैप पिक्सेल रेंडरर",
  T_46_META_WS_C_MINISENTRY: "मिनी सेंट्री",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "मिनी सेंट्री अटैक रेंज टाइप",
  T_46_META_WS_C_MINISENTRYCREATED: "मिनी सेंट्री क्रिएटेड",
  T_46_META_WS_C_MONEY: "पैसा",
  T_46_META_WS_C_MONEYTYPE: "पैसा प्रकार",
  T_46_META_WS_C_MONSTER: "राक्षस",
  T_46_META_WS_C_MONSTERSPAWN: "मॉन्स्टर स्पॉन",
  T_46_META_WS_C_MONSTERTYPE: "राक्षस प्रकार",
  T_46_META_WS_C_MORPHABLEOBJECT: "मोर्फेबल ऑब्जेक्ट",
  T_46_META_WS_C_MORPHOBJECT: "मोर्फ ऑब्जेक्ट",
  T_46_META_WS_C_MOTOBIKE: "मोटरसाइकिल",
  T_46_META_WS_C_MOVEPLATFORM: "मूव प्लेटफार्म",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "मूव प्लेटफार्म प्रकार",
  T_46_META_WS_C_MUSHROOM: "मशरूम",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "प्राकृतिक स्थिरांक",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "संख्या",
  T_46_META_WS_C_OBJECT: "वस्तु",
  T_46_META_WS_C_OILDRUM: "तेल ड्रम",
  T_46_META_WS_C_OUTFITID: "पोशाक आईडी",
  T_46_META_WS_C_OUTFITSLOTTYPE: "परिधान स्लॉट प्रकार",
  T_46_META_WS_C_PATHPOINT: "पथ बिंदु",
  T_46_META_WS_C_PATROLSTYLETYPE: "गश्त शैली प्रकार",
  T_46_META_WS_C_PATROLTYPE: "गश्त प्रकार",
  T_46_META_WS_C_PERSONA: "पर्सोना",
  T_46_META_WS_C_PHASE: "चरण",
  T_46_META_WS_C_PHYSICALMOVER: "भौतिक मूवर",
  T_46_META_WS_C_PHYSICALOBJECT: "भौतिक वस्तु",
  T_46_META_WS_C_PLATFORMTYPE: "प्लेटफ़ॉर्म प्रकार",
  T_46_META_WS_C_PLAYABLE: "खेल योग्य",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "प्लेएबल या प्लेएबल्स सरणी",
  T_46_META_WS_C_PLAYER: "खिलाड़ी",
  T_46_META_WS_C_PLAYERBACKPACK: "खिलाड़ी बैकपैक",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "खिलाड़ी व्यवहार स्थिति प्रकार",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "खिलाड़ी व्यवहार प्रकार",
  T_46_META_WS_C_PLAYERCCT: "FF चरित्र के लिए कैरेक्टर कंट्रोलर",
  T_46_META_WS_C_PLAYERDATAID: "प्रीसेट कैरेक्टर प्रकार",
  T_46_META_WS_C_PLAYERORTRANSFORM: "खिलाड़ी या ट्रांसफार्म",
  T_46_META_WS_C_PLAYERORVEHICLE: "खिलाड़ी या वाहन",
  T_46_META_WS_C_PLAYEROUTFIT: "खिलाड़ी आउटफिट",
  T_46_META_WS_C_PLAYERPOSETYPE: "खिलाड़ी पोज़ प्रकार",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "खिलाड़ी पुनर्जीवित स्रोत प्रकार",
  T_46_META_WS_C_PLAYERSTATETYPE: "खिलाड़ी स्थिति प्रकार",
  T_46_META_WS_C_POINTLIGHT: "पॉइंट लाइट",
  T_46_META_WS_C_PORTAL: "पोर्टल",
  T_46_META_WS_C_PREFABID: "प्रीफैब आईडी",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "प्रेजेंट इफेक्ट जनरेटर",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "प्रभाव टेक्सचर प्रकार",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "प्रोफाइल चित्र विजेट",
  T_46_META_WS_C_PROPERTY: "गुण",
  T_46_META_WS_C_PROPERTYFORMULA: "प्रॉपर्टी फॉर्मूला",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "प्रॉपर्टी फॉर्मूला फैक्टर प्रकार",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "प्रॉपर्टी मोडिफाई प्रकार",
  T_46_META_WS_C_QUATERNION: "क्वाटरनियन",
  T_46_META_WS_C_RANKABLE: "रैंक योग्य",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "रे कास्ट लेयर प्रकार",
  T_46_META_WS_C_REPAIRKIT: "मरम्मत किट",
  T_46_META_WS_C_RESETABLE: "रीसेट योग्य",
  T_46_META_WS_C_RIGIDBODY: "रिगिडबॉडी",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "रिगिडबॉडी कंस्ट्रेन प्रकार",
  T_46_META_WS_C_RIGIDBODYTYPE: "रिगिडबॉडी प्रकार",
  T_46_META_WS_C_ROUND: "राउंड",
  T_46_META_WS_C_SAFEZONE: "सुरक्षित क्षेत्र",
  T_46_META_WS_C_SCOREABLE: "स्कोर योग्य",
  T_46_META_WS_C_SCRIPTID: "स्क्रिप्ट आईडी",
  T_46_META_WS_C_SEATTYPE: "सीट प्रकार",
  T_46_META_WS_C_SELFRELATIVE: "स्व-सापेक्ष",
  T_46_META_WS_C_SHOP: "शॉप",
  T_46_META_WS_C_SHOPITEM: "शॉप आइटम",
  T_46_META_WS_C_SHOPSHELF: "शॉप शेल्फ",
  T_46_META_WS_C_SKATEBOARD: "स्केटबोर्ड",
  T_46_META_WS_C_SKELETON: "कंकाल",
  T_46_META_WS_C_SKELETONPART: "हड्डी का हिस्सा",
  T_46_META_WS_C_SKILLID: "कौशल आईडी",
  T_46_META_WS_C_SKYBLASTER: "स्काईब्लास्टर",
  T_46_META_WS_C_SKYBOX: "आकाशपटल",
  T_46_META_WS_C_SKYBOXTYPE: "स्काईबॉक्स प्रकार",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "सामाजिक द्वीप स्नोबॉल",
  T_46_META_WS_C_SORTTYPE: "क्रम प्रकार",
  T_46_META_WS_C_SOUNDDRUMTYPE: "साउंड ड्रम प्रकार",
  T_46_META_WS_C_SOUNDEFFECT: "ध्वनि प्रभाव",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "ध्वनि प्रभाव या ध्वनि प्रभाव सूची",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "ध्वनि प्रभाव प्रकार",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "साउंड लीड1 प्रकार",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "साउंड लीड2 प्रकार",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "साउंड लीड3 प्रकार",
  T_46_META_WS_C_SOUNDPIANOTYPE: "साउंड पियानो प्रकार",
  T_46_META_WS_C_SPAWN: "स्पॉन",
  T_46_META_WS_C_SPAWNABLE: "स्पॉन करने योग्य",
  T_46_META_WS_C_SPAWNBOX: "स्पॉन ज़ोन",
  T_46_META_WS_C_SPAWNPOSITION: "स्पॉन पॉइंट",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "विशेष आइटम आईडी प्रकार",
  T_46_META_WS_C_SPHERETRIGGER: "गोलाकार ट्रिगर",
  T_46_META_WS_C_SPORTSCAR: "स्पोर्ट्स कार",
  T_46_META_WS_C_SPRAYCOLOR: "स्प्रे रंग",
  T_46_META_WS_C_SPRAYGUN: "स्प्रे गन",
  T_46_META_WS_C_SPRAYRESULTUI: "स्प्रे परिणाम UI",
  T_46_META_WS_C_SPRAYRIFLE: "स्प्रे राइफल",
  T_46_META_WS_C_SPRITEID: "स्प्राइट आईडी",
  T_46_META_WS_C_STATICSCRIPTID: "स्थिर स्क्रिप्ट ID",
  T_46_META_WS_C_STRING: "स्ट्रिंग",
  T_46_META_WS_C_STRINGORLOCSTRING: "स्ट्रिंग या स्थानीयकरण स्ट्रिंग",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "आपूर्ति बॉक्स ट्रिगर",
  T_46_META_WS_C_SWINGGUN: "स्विंग गन",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "उपकरण स्लॉट बदलें",
  T_46_META_WS_C_TEAM: "टीम",
  T_46_META_WS_C_TERRAIN: "इलाका",
  T_46_META_WS_C_TEXT: "टेक्स्ट एंटिटी",
  T_46_META_WS_C_TEXTUREID: "टेक्सचर आईडी",
  T_46_META_WS_C_TEXTURETYPE: "ऑब्जेक्ट टेक्सचर",
  T_46_META_WS_C_TIMER: "टाइमर",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "टाइमस्टैम्प फॉर्मेट स्टाइल टाइप",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "टाइमस्टैम्प स्थानीयकरण स्ट्रिंग",
  T_46_META_WS_C_TRAJECTORY: "प्रक्षेपवक्र",
  T_46_META_WS_C_TRANSFORM: "रूपांतरण",
  T_46_META_WS_C_TUKTUK: "टुकटुक",
  T_46_META_WS_C_TURRET: "टॉर्रेट",
  T_46_META_WS_C_TWEEN: "ट्वीन",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "ट्वीन कर्व",
  T_46_META_WS_C_TWEENSTYLE: "ट्वीन स्टाइल प्रकार",
  T_46_META_WS_C_TYPE: "प्रकार",
  T_46_META_WS_C_TYPEENUM: "प्रकार सूची",
  T_46_META_WS_C_TYPEORTYPELIST: "प्रकार या प्रकार सूची",
  T_46_META_WS_C_UIADDSCORE: "UI स्कोर जोड़ें",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI एनिमेशन ट्रिगर HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI बिल्ट-इन स्विच",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI बिल्ट-इन UI स्विच कंट्रोलर",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI कार्ड सलेक्शन पैनल",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI चेकपॉइंट इंडिकेटर",
  T_46_META_WS_C_UICOMPASS: "UI कम्पास",
  T_46_META_WS_C_UICOUNTDOWN5: "UI 5-सेकंड काउंटडाउन",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI काउंटडाउन संकेत",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI काउंटडाउन अनुस्मारक",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "चरित्र के सिर के ऊपर स्वास्थ्य बार",
  T_46_META_WS_C_UIHEALTHBAR: "UI स्वास्थ्य पट्टी",
  T_46_META_WS_C_UIHEARTBEAT: "UI दिल की धड़कन",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI आइकन सूचना",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI पहचान सूचना",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI इंटरैक्शन बटन",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI लीडरबोर्ड बटन",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI मैच उपशीर्षक",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI मॉन्स्टर स्तर",
  T_46_META_WS_C_UIMONSTERUI: "UI मॉन्स्टर UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI मल्टी-टीम लीडरबोर्ड",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI मल्टी-टीम परिणाम पैनल",
  T_46_META_WS_C_UIOPENINGBANNER: "UI ओपनिंग बैनर",
  T_46_META_WS_C_UIPANEL: "UI पैनल",
  T_46_META_WS_C_UIPANELEMPTY: "खाली UI पैनल",
  T_46_META_WS_C_UIPHASETIMER: "प्रति मील चाल का Exp",
  T_46_META_WS_C_UIPROGRESSBAR: "UI प्रगति पट्टी",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI प्रगति चक्र",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI प्रगति कौशल बटन",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI खरीद अनुरोध प्रकार",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI राउंड जानकारी बैनर",
  T_46_META_WS_C_UIROUNDNUMBER: "UI राउंड नंबर",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI राउंड परिणाम बैनर",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI राउंड स्टार्ट बैनर",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI राउंड ट्रांज़िशन",
  T_46_META_WS_C_UISCOREBAR: "UI स्कोर बार",
  T_46_META_WS_C_UISCROLLPANEL: "UI स्क्रॉल पैनल",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI सरल राउंड स्कोर बैनर",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI सरल राउंड स्टार्ट बैनर",
  T_46_META_WS_C_UISIMPLETIP: "सरल UI टिप",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI सरल विरुद्ध बैनर",
  T_46_META_WS_C_UISKILLBUTTON: "UI कौशल बटन",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "UI सोशल बटन विजेट",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI सोलो लीडरबोर्ड",
  T_46_META_WS_C_UISTORE: "UI स्टोर UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI टीम मैच जानकारी",
  T_46_META_WS_C_UITEXTTIP: "UI टेक्स्ट टिप",
  T_46_META_WS_C_UITIMERINFO: "UI टाइमर जानकारी",
  T_46_META_WS_C_UITIPBUTTON: "UI टिप बटन",
  T_46_META_WS_C_UITITLEBANNER: "UI टाइटल बैनर",
  T_46_META_WS_C_UITWEENTIP: "UI ट्वीन टिप",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI दो टीम संक्षिप्त जानकारी",
  T_46_META_WS_C_UITWOTEAMINFO: "UI टू-टीम इंफो",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI दो-टीम लीडरबोर्ड",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI दो-टीम परिणाम पैनल",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI दो-टीम राउंड स्कोर बैनर",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI दो टीम स्कोर पैनल",
  T_46_META_WS_C_UIVERSUSBANNER: "UI विरुद्ध बैनर",
  T_46_META_WS_C_UIWIDGET: "UI विजेट",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI विजेट बटन",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI विजेट कंटेनर",
  T_46_META_WS_C_UIWIDGETEMPTY: "खाली UI विजेट",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI विजेट छवि",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI विजेट इनपुट लेबल",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI विजेट जॉयस्टिक",
  T_46_META_WS_C_UIWIDGETLABEL: "UI विजेट लेबल",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI विजेट लेआउट",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI विजेट प्रोफ़ाइल",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI विजेट टेक्सचर",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI विजेट टॉगल",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI विजेट टचपैड",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI जीत या हार बैनर",
  T_46_META_WS_C_UNITSPAWN: "यूनिट जनरेटर",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "विंडो क्लाइंबिंग लॉजिक ऑब्जेक्ट",
  T_46_META_WS_C_VECTOR2: "वेक्टर2",
  T_46_META_WS_C_VECTOR3: "वेक्टर3",
  T_46_META_WS_C_VEHICLE: "वाहन",
  T_46_META_WS_C_VEHICLEIDTYPE: "वाहन आईडी प्रकार",
  T_46_META_WS_C_VEHICLESKINID: "वाहन त्वचा आईडी",
  T_46_META_WS_C_VENDINGMACHINE: "वेंडिंग मशीन",
  T_46_META_WS_C_VEST: "वेस्ट",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "VFX बदली जाने वाली टेक्सचर एंटिटी",
  T_46_META_WS_C_VFXTEXTURE: "VFX बनावट",
  T_46_META_WS_C_VISIBILITY: "दृश्यता",
  T_46_META_WS_C_WALLET: "वॉलेट",
  T_46_META_WS_C_WALLETHUD: "वॉलेट UI",
  T_46_META_WS_C_WATERZONE: "पानी क्षेत्र",
  T_46_META_WS_C_WAVECOUNTTYPE: "लहर गिनती प्रकार",
  T_46_META_WS_C_WAVEINTERVALTYPE: "लहर अंतराल प्रकार",
  T_46_META_WS_C_WEAPON: "हथियार",
  T_46_META_WS_C_WEAPONGENERATOR: "हथियार जनरेटर",
  T_46_META_WS_C_WEAPONSKINID: "हथियार स्किन आईडी",
  T_46_META_WS_C_WEAPONTYPE: "हथियार प्रकार",
  T_46_META_WS_C_WIDGETTYPE: "विजेट प्रकार",
  T_46_META_WS_C_ZIPLINE: "ज़िपलाइन",
  T_46_META_WS_CAMERADIRECTION: "कैमरा दिशा",
  T_46_META_WS_CAMERAPOSITION: "कैमरा स्थिति",
  T_46_META_WS_CAPSULECAST: "कैप्सूल कास्ट",
  T_46_META_WS_CAPSULEOVERLAP: "कैप्सूल ओवरलैप",
  T_46_META_WS_CEIL: "ऊपर राउंड करें",
  T_46_META_WS_CHATCHANNEL: "चैट चैनल",
  T_46_META_WS_CHECKTRIGGERBYORDER: "क्रम के अनुसार ट्रिगर की जाँच करें",
  T_46_META_WS_CLAMP: "क्लैम्प",
  T_46_META_WS_CLEAR: "साफ करें",
  T_46_META_WS_CLEARALLCHILDREN: "सभी चाइल्ड हटाएं",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI विशेष अनुसरण साफ करें",
  T_46_META_WS_CLEARBACKPACK: "बैकपैक खाली करें",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "फॉर्मूला प्रॉपर्टी फैक्टर हटाएं",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "अवशिष्ट लेवल ऑब्जेक्ट्स को साफ करें",
  T_46_META_WS_CLIPNAME: "क्लिप नाम",
  T_46_META_WS_CLONE: "क्लोन",
  T_46_META_WS_COLLIDEDENTITY: "टकराई इकाई",
  T_46_META_WS_COLORGET: "रंग प्राप्त करें",
  T_46_META_WS_COMPLETECUSTOMMISSION: "कस्टम मिशन पूरा करें",
  T_46_META_WS_CONNECT: "जोड़ें",
  T_46_META_WS_CONSUMABLEID: "आइटम आईडी",
  T_46_META_WS_CONTAIN: "शामिल है",
  T_46_META_WS_CONTAINKEY: "कुंजी मौजूद है",
  T_46_META_WS_COPYTOMORPH: "रूपांतरण की प्रतिलिपि बनाएं",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "पैसा खर्च करें",
  T_46_META_WS_COSTTOKEN: "टोकन खर्च करें",
  T_46_META_WS_CREATEAIRDROP: "एयर ड्रॉप बनाएं",
  T_46_META_WS_CREATEBOT: "बॉट बनाएं",
  T_46_META_WS_CREATEBUILTINUI: "इन-बिल्ट UI बनाएं",
  T_46_META_WS_CREATEBUILTINUICLIENT: "इन-बिल्ट UI बनाएं",
  T_46_META_WS_CREATECAMERA: "कैमरा बनाएँ",
  T_46_META_WS_CREATECURVE: "कर्व बनाएं",
  T_46_META_WS_CREATECUSTOMUI: "कस्टम UI बनाएं",
  T_46_META_WS_CREATECUSTOMUICLIENT: "कस्टम UI बनाएं",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "कस्टम UI विजेट बनाएं",
  T_46_META_WS_CREATEDAMAGENUM: "डैमेज नंबर बनाएं",
  T_46_META_WS_CREATEEFFECT: "प्रभाव बनाएं",
  T_46_META_WS_CREATEEFFECTCLIENT: "प्रभाव बनाएं",
  T_46_META_WS_CREATEFACTION: "गुट बनाएँ",
  T_46_META_WS_CREATEFOLLOW: "फॉलो बनाएं",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "प्रत्येक फ्रेम पर स्वयं सापेक्ष बनाएं",
  T_46_META_WS_CREATEFROMPREFAB: "प्रीफैब से बनाएं",
  T_46_META_WS_CREATELEVELOBJECT: "लेवल ऑब्जेक्ट बनाएं",
  T_46_META_WS_CREATELOOKAT: "लुक एट बनाएं",
  T_46_META_WS_CREATEMINIMAPICON: "मिनी मैप आइकन बनाएं",
  T_46_META_WS_CREATEMINIMAPPIXEL: "मिनी मैप पिक्सेल बनाएं",
  T_46_META_WS_CREATEMONSTER: "मॉन्स्टर बनाएं",
  T_46_META_WS_CREATEMORPH: "रूपांतरण बनाएँ",
  T_46_META_WS_CREATESELFRELATIVE: "स्वयं सापेक्ष बनाएं",
  T_46_META_WS_CREATESHOP: "दुकान बनाएँ",
  T_46_META_WS_CREATESHOPITEM: "आइटम बनाएँ",
  T_46_META_WS_CREATESHOPSHELF: "दुकान की शेल्फ बनाएँ",
  T_46_META_WS_CREATESOUND: "साउंड बनाएं",
  T_46_META_WS_CREATESOUNDCLIENT: "साउंड बनाएं",
  T_46_META_WS_CREATETOKENINSCENE: "दृश्य में टोकन बनाएं",
  T_46_META_WS_CREATETRAJECTORY: "ट्रेजेक्ट्री बनाएं",
  T_46_META_WS_CREATETWEEN: "ट्वीन बनाएं",
  T_46_META_WS_CREATEWALLET: "वॉलेट बनाएं",
  T_46_META_WS_CROSS: "क्रॉस",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV कॉलम नाम को पूर्णांक में बदलें",
  T_46_META_WS_CURRENTAMMOCOUNT: "वर्तमान गोला-बारूद की गिनती",
  T_46_META_WS_DAMAGE: "क्षति",
  T_46_META_WS_DAMAGEDBODYPART: "क्षतिग्रस्त शरीर का हिस्सा",
  T_46_META_WS_DAMAGEDPLAYERS: "क्षतिग्रस्त खिलाड़ी",
  T_46_META_WS_DAMAGETYPE: "क्षति प्रकार",
  T_46_META_WS_DEALDAMAGE: "क्षति पहुंचाएं",
  T_46_META_WS_DELETE: "हटा दें",
  T_46_META_WS_DELETEAT: "हटाएं",
  T_46_META_WS_DELETECUSTOMUI: "कस्टम UI हटाएं",
  T_46_META_WS_DELETEFROMDATABASE: "डेटाबेस से हटाएं",
  T_46_META_WS_DELETEFROMDATASTORE: "डेटा स्टोर से हटाएं",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "कुंजी द्वारा लीडरबोर्ड डेटाबेस से हटाएं",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "रैंक द्वारा लीडरबोर्ड डेटाबेस से हटाएं",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "की के आधार पर लीडरबोर्ड डेटा स्टोर से हटाएं",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "रैंक के आधार पर लीडरबोर्ड डेटा स्टोर से हटाएं",
  T_46_META_WS_DELETETAG: "टैग हटाएँ",
  T_46_META_WS_DELTA: "डेल्टा",
  T_46_META_WS_DESTROY: "नष्ट करें",
  T_46_META_WS_DESTROYBOT: "बॉट को नष्ट करें",
  T_46_META_WS_DESTROYBUILTINUI: "इन-बिल्ट UI नष्ट करें",
  T_46_META_WS_DESTROYEQUIPMENT: "उपकरण नष्ट करें",
  T_46_META_WS_DESTROYITEM: "आइटम नष्ट करें",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "दिशा को ओयलर कोण में बदलें",
  T_46_META_WS_DISABLESAFEZONE: "सुरक्षित क्षेत्र को अक्षम करें",
  T_46_META_WS_DISPATCHEVENT: "इवेंट भेजें",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "प्लेटफ़ॉर्म के साथ इवेंट भेजें",
  T_46_META_WS_DISTANCE: "दूरी",
  T_46_META_WS_DOT: "बिंदु",
  T_46_META_WS_DROPITEM: "आइटम गिराएं",
  T_46_META_WS_DYEATAREA: "क्षेत्र पर रंगाई करें",
  T_46_META_WS_DYEATPLANE: "विमान पर रंगाई करें",
  T_46_META_WS_DYEATPOSITION: "स्थिति पर रंगाई करें",
  T_46_META_WS_E_ABNORMALGRAVZONE: "कम गुरुत्वाकर्षण क्षेत्र",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "त्वरण",
  T_46_META_WS_E_ACTIONNODE: "क्रिया नोड",
  T_46_META_WS_E_ACTIVE: "सक्रिय",
  T_46_META_WS_E_ACTIVESKILL: "सक्रिय कौशल",
  T_46_META_WS_E_ADBOARD: "विज्ञापन बोर्ड",
  T_46_META_WS_E_ADD: "जोड़ें",
  T_46_META_WS_E_ADDFRIEND: "मित्र जोड़ें",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "लक्ष्य",
  T_46_META_WS_E_AIR: "हवा",
  T_46_META_WS_E_AIRCONDITIONERA: "एयर कंडीशनर",
  T_46_META_WS_E_AIRDROP: "एयरड्रॉप, ज़ोंबी आत्महत्या",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "जीवित",
  T_46_META_WS_E_AMMO: "बुलेट VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "उभयचर वाहन",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "बच्चे खेल रहे हैं",
  T_46_META_WS_E_AR: "राइफल",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR गोला बारूद",
  T_46_META_WS_E_ARMAGAZINE: "एआर मैगज़ीन",
  T_46_META_WS_E_ARMOR: "कवच",
  T_46_META_WS_E_ARMORBUFF: "आर्मर बफ",
  T_46_META_WS_E_ARMORLV1: "आर्मर Lv1",
  T_46_META_WS_E_ARMORLV2: "आर्मर Lv2",
  T_46_META_WS_E_ARMORLV3: "आर्मर Lv3",
  T_46_META_WS_E_ARMORPIERCING: "आर्मर शेटर",
  T_46_META_WS_E_ARMORSPECIALIST: "कौशल 1",
  T_46_META_WS_E_ARROW: "तीर",
  T_46_META_WS_E_ASC: "आरोही क्रम",
  T_46_META_WS_E_ASCIGNOREZERO: "आरोही क्रम शून्यों को छोड़ता है",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "गैस विस्फोट",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "संगतता के लिए अटैचमेंट1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "संगतता के लिए अटैचमेंट4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "संगतता के लिए अटैचमेंट5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "संगतता के लिए अटैचमेंट6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "संगतता के लिए अटैचमेंट8",
  T_46_META_WS_E_ATTACK: "हमला",
  T_46_META_WS_E_ATTACKGRENADE: "हमला ग्रेनेड",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "स्वचालित",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "वापसी",
  T_46_META_WS_E_BACKANDFORTH: "आगे और पीछे",
  T_46_META_WS_E_BAG: "बैग",
  T_46_META_WS_E_BAG1: "बैग1",
  T_46_META_WS_E_BAG2: "बैग2",
  T_46_META_WS_E_BAG3: "बैग3",
  T_46_META_WS_E_BAMBOOA: "बांस A",
  T_46_META_WS_E_BANANATREE: "केला का पेड़",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "आधार गुणांक",
  T_46_META_WS_E_BASIC: "बुनियादी",
  T_46_META_WS_E_BASICCONE: "बेसिक शंकु",
  T_46_META_WS_E_BASICCYLINDER: "बेसिक सिलिंडर",
  T_46_META_WS_E_BASICSPHERE: "बेसिक स्फीयर",
  T_46_META_WS_E_BATTLEINSTYLE: "स्टाइल में लड़ाई",
  T_46_META_WS_E_BELL: "घंटी",
  T_46_META_WS_E_BENCH: "बेंच",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "बड़ा स्क्रीन",
  T_46_META_WS_E_BIPOD: "बाइपॉड",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS थीम दीवार",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "ब्लैकहोल विस्फोट VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "क्रिस्टल बॉल VFX",
  T_46_META_WS_E_BLAST: "विस्फोट",
  T_46_META_WS_E_BLOCK: "वर्ग",
  T_46_META_WS_E_BLOODBALL: "ब्लैकहोल VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "नीला",
  T_46_META_WS_E_BLUEDOLL: "बर्फ की गुड़िया",
  T_46_META_WS_E_BOARD: "चलने वाला प्लेटफार्म",
  T_46_META_WS_E_BODY: "शरीर",
  T_46_META_WS_E_BOMBINDICATION: "बम चेतावनी",
  T_46_META_WS_E_BOMBPLIERS: "बम प्लायर्स",
  T_46_META_WS_E_BONFIRE: "जलता हुआ अलाव",
  T_46_META_WS_E_BOOM: "बूम",
  T_46_META_WS_E_BOOYAH: "विजय",
  T_46_META_WS_E_BOTH: "दोनों",
  T_46_META_WS_E_BOUNCETIRE: "टायर",
  T_46_META_WS_E_BOWAMMO: "धनुष के गोला बारूद",
  T_46_META_WS_E_BREAKABLEBOX: "नाशक लकड़ी का बक्सा",
  T_46_META_WS_E_BREAKABLECONTAINER: "नष्ट होने वाला कंटेनर",
  T_46_META_WS_E_BREAKABLEFENCE: "नष्ट होने वाला बाड़",
  T_46_META_WS_E_BRICKA: "ईंट A",
  T_46_META_WS_E_BRICKB: "ईंट B",
  T_46_META_WS_E_BRICKC: "ईंट C",
  T_46_META_WS_E_BRICKHOUSEA: "छोटा घर A",
  T_46_META_WS_E_BRIGHT: "हल्का",
  T_46_META_WS_E_BUBBLE: "बुलबुल",
  T_46_META_WS_E_BUFFGENERATOR: "बफ जनरेटर",
  T_46_META_WS_E_BULLETBUFF: "बुलेट बफ",
  T_46_META_WS_E_BULLETHITTING: "गोली लगना",
  T_46_META_WS_E_BUMPERCAR: "बम्पर कार",
  T_46_META_WS_E_BUMPERCARFACTORY: "बम्पर कार निर्माता",
  T_46_META_WS_E_BURNING: "वाहन विस्फोट पर जलने वाला नुकसान",
  T_46_META_WS_E_BUSHES: "झाड़ियों",
  T_46_META_WS_E_BUSSTOP: "बस स्टेशन",
  T_46_META_WS_E_BUTTOM: "निचले कपड़े",
  T_46_META_WS_E_BUTTONWIDGET: "बटन विजेट",
  T_46_META_WS_E_BYHIERARCHY: "श्रेणी द्वारा",
  T_46_META_WS_E_CABINET: "कैबिनेट",
  T_46_META_WS_E_CACTUS: "कैक्टस",
  T_46_META_WS_E_CAMOUFLAGE: "कौशल 6",
  T_46_META_WS_E_CAPSULETRIGGER: "कैप्सूल ट्रिगर",
  T_46_META_WS_E_CARDIOTONIC: "कार्डियोटोनिक",
  T_46_META_WS_E_CASUALGAMEBGM: "अवकाश खेल बीजीएम",
  T_46_META_WS_E_CEMENTA: "सीमेंट A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "चैनल A",
  T_46_META_WS_E_CHANNELB: "चैनल B",
  T_46_META_WS_E_CHANNELC: "चैनल C",
  T_46_META_WS_E_CHANNELD: "चैनल D",
  T_46_META_WS_E_CHANNELE: "चैनल E",
  T_46_META_WS_E_CHANNELF: "चैनल F",
  T_46_META_WS_E_CHARACTERSKILL: "चरित्र कौशल",
  T_46_META_WS_E_CHARACTOR: "पात्र",
  T_46_META_WS_E_CHARGE: "चार्ज 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "चेकपॉइंट",
  T_46_META_WS_E_CHEER: "उत्साह",
  T_46_META_WS_E_CHERRYBLOSSOM: "चेरी ब्लॉसम ट्री",
  T_46_META_WS_E_CIRCLE: "वृत्त",
  T_46_META_WS_E_CIRCLEBACK: "लूप",
  T_46_META_WS_E_CIRCLEOFHEAT: "पैर की किरण",
  T_46_META_WS_E_CITY: "शहर",
  T_46_META_WS_E_CLAPS: "ताली",
  T_46_META_WS_E_CLEAR: "साफ",
  T_46_META_WS_E_CLIENT: "क्लाइंट",
  T_46_META_WS_E_CLONE: "रूप परिवर्तन",
  T_46_META_WS_E_CLONEKILL: "क्लोन की मौत",
  T_46_META_WS_E_CLOSE: "बंद करें",
  T_46_META_WS_E_CLOTHES: "कपड़े",
  T_46_META_WS_E_COINGENERATOR: "सोना जनरेटर",
  T_46_META_WS_E_COLDAIR: "कोहरा",
  T_46_META_WS_E_COLORBLOCK: "रंगीन ब्लॉक",
  T_46_META_WS_E_COLOROILBARREL: "रंगीन तेल ड्रम",
  T_46_META_WS_E_COMBINEALL: "सभी का संयोजन",
  T_46_META_WS_E_COMBINESELF: "खुद के साथ संयोजन",
  T_46_META_WS_E_COMBOKEYA1: "संगीत नोट्स - सिंथेसाइज़र A",
  T_46_META_WS_E_COMBOKEYA2: "संगीत नोट्स - सिंथेसाइज़र A",
  T_46_META_WS_E_COMBOKEYB1: "संगीत नोट्स - सिंथेसाइज़र B",
  T_46_META_WS_E_COMBOKEYB2: "संगीत नोट्स - सिंथेसाइज़र B",
  T_46_META_WS_E_COMBOKEYC1: "संगीत नोट्स - सिंथेसाइज़र C",
  T_46_META_WS_E_COMBOKEYC2: "संगीत नोट्स - सिंथेसाइज़र C",
  T_46_META_WS_E_CONCRETEPILLAR: "कंक्रीट का खंभा",
  T_46_META_WS_E_CONDITIONNODE: "स्थिति नोड",
  T_46_META_WS_E_CONTAINERA: "कंटेनर A",
  T_46_META_WS_E_CONTAINERB: "शिपिंग कंटेनर बी",
  T_46_META_WS_E_CONTAINERC: "शिपिंग कंटेनर सी",
  T_46_META_WS_E_CONTAINERWIDGET: "कंटेनर विजेट",
  T_46_META_WS_E_CONTINUOUS: "निरंतर",
  T_46_META_WS_E_COUNTDOWN: "काउंटडाउन",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "काउंटडाउन",
  T_46_META_WS_E_COUNTDOWNDIDI: "काउंटडाउन बीप",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "काउंटडाउन",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "काउंटडाउन 3",
  T_46_META_WS_E_CROSS: "क्रॉस",
  T_46_META_WS_E_CROSSBOW: "क्रॉसबो",
  T_46_META_WS_E_CROSSHAIR: "क्रॉसहेयर",
  T_46_META_WS_E_CROSSHAIRS: "क्रॉसहेयर",
  T_46_META_WS_E_CROUCH: "झुकना",
  T_46_META_WS_E_CROUCHING: "झुका हुआ",
  T_46_META_WS_E_CROWCAW: "कौआ की कर्कश ध्वनि",
  T_46_META_WS_E_CROWN: "मुकुट",
  T_46_META_WS_E_CUBE: "ब्लॉक मेकेनिज्म",
  T_46_META_WS_E_CURSE: "तावीज़",
  T_46_META_WS_E_CURSEEXPLOSION: "तावीज़ विस्फोट",
  T_46_META_WS_E_CUSTOM: "कस्टम कैमरा",
  T_46_META_WS_E_CUSTOMTRIGGER: "कस्टम ट्रिगर",
  T_46_META_WS_E_CUSTOMWATERZONE: "कस्टम जल शरीर",
  T_46_META_WS_E_CYCLICCOMBUSTION: "लूप में जलना",
  T_46_META_WS_E_CYLIC: "चक्रीय",
  T_46_META_WS_E_DAGGER: "थ्रोइंग नाइफ",
  T_46_META_WS_E_DAMAGEDTRUCK: "क्षतिग्रस्त ट्रक",
  T_46_META_WS_E_DAMAGEZONE: "नुकसान का क्षेत्र",
  T_46_META_WS_E_DANGERALARM: "खतरनाक संकेत 2",
  T_46_META_WS_E_DANGERVIBRATING: "खतरनाक संकेत 1",
  T_46_META_WS_E_DARK: "अंधेरा",
  T_46_META_WS_E_DARKNESS: "अंधकार",
  T_46_META_WS_E_DASHATTACK: "डैश अटैक",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "डेटा स्टोरेज सीमा पार",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "डेटा स्टोरेज पैरामीटर त्रुटि",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "डेटा स्टोरेज टाइमआउट",
  T_46_META_WS_E_DATETIME: "दिनांक और समय",
  T_46_META_WS_E_DAY: "दिन",
  T_46_META_WS_E_DEAD: "मृत",
  T_46_META_WS_E_DEATH: "मृत",
  T_46_META_WS_E_DEFAULT: "डिफ़ॉल्ट",
  T_46_META_WS_E_DEFAULTFIST: "मुट्ठी",
  T_46_META_WS_E_DEFENCEGRENADE: "रक्षा ग्रेनेड",
  T_46_META_WS_E_DESC: "अवरोही क्रम",
  T_46_META_WS_E_DIALOGUE: "संवाद",
  T_46_META_WS_E_DIAMOND: "हीरा",
  T_46_META_WS_E_DIRECTIONSIGN: "चिह्न",
  T_46_META_WS_E_DIRVEVEHICLE: "वाहन चलाएं",
  T_46_META_WS_E_DISABLE: "अक्षम करें",
  T_46_META_WS_E_DISABLED: "अक्षम",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "गायब होने की सूचना",
  T_46_META_WS_E_DISCONNECT: "डिस्कनेक्ट",
  T_46_META_WS_E_DISGUISE: "क्लोन",
  T_46_META_WS_E_DOGHOUSE: "कुत्ते का घर",
  T_46_META_WS_E_DOOR: "दरवाजा",
  T_46_META_WS_E_DOUBLE: "डबल",
  T_46_META_WS_E_DOUBLEDOOR: "डबल दरवाजा",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "डबल जम्प शू",
  T_46_META_WS_E_DOUBLEMAGEZINE: "डबल मैगज़ीन",
  T_46_META_WS_E_DRAW: "ड्रॉ",
  T_46_META_WS_E_DRILLZOMBIE: "ड्रिल ज़ॉम्बी",
  T_46_META_WS_E_DRIVE: "ड्राइव",
  T_46_META_WS_E_DRIVER: "चालक",
  T_46_META_WS_E_DROPBEAT: "कौशल 4",
  T_46_META_WS_E_DRUMKEY1: "संगीत नोट्स - ड्रम",
  T_46_META_WS_E_DRUMKEY2: "संगीत नोट्स - ड्रम",
  T_46_META_WS_E_DUEL: "लड़ाई",
  T_46_META_WS_E_DUMMY: "डमी",
  T_46_META_WS_E_DUMMYGRENADE: "नकली ग्रेनेड",
  T_46_META_WS_E_DUMP: "डंप",
  T_46_META_WS_E_DUSK: "संध्या",
  T_46_META_WS_E_DUST: "धुआं और धूल",
  T_46_META_WS_E_DYNAMIC: "गतिशील",
  T_46_META_WS_E_E: "प्राकृतिक स्थिरांक",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "आसान",
  T_46_META_WS_E_ELECTRICSHOCK: "बिजली का झटका",
  T_46_META_WS_E_ELECTRICSURFBOARD: "इलेक्ट्रिक सर्फबोर्ड",
  T_46_META_WS_E_ELECTRICZONE: "इलेक्ट्रिक जोन",
  T_46_META_WS_E_ELECTRONICBGM: "प्यारी इलेक्ट्रॉनिक फैंटेसी बीजीएम",
  T_46_META_WS_E_ELIMINATEDBOSS: "गिल्ड लीडर को महाभियोग",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "किल प्रॉम्प्ट",
  T_46_META_WS_E_EMOTE: "भाव-भंगिमा",
  T_46_META_WS_E_ENABLE: "सक्षम करें",
  T_46_META_WS_E_ENERGETIC: "ऊर्जावान",
  T_46_META_WS_E_ENTERVEHICLE: "वाहन में प्रवेश करें",
  T_46_META_WS_E_EP: "ईपी (ऊर्जा)",
  T_46_META_WS_E_EXCLAMATIONMARK: "विस्मयादिबोधक चिन्ह",
  T_46_META_WS_E_EXIT: "बाहर निकलना",
  T_46_META_WS_E_EXITVEHICLE: "वाहन से बाहर निकलें",
  T_46_META_WS_E_EXPLODE: "आत्म-स्फोट",
  T_46_META_WS_E_EXPLOSION: "विस्फोट VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "विस्फोट की आग",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "ऊर्जा बॉल कौशल",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "विस्फोटक ज़ॉम्बी",
  T_46_META_WS_E_EYE: "चश्मा",
  T_46_META_WS_E_FACEPAINT: "चेहरे की पेंटिंग",
  T_46_META_WS_E_FACTION: "गुट",
  T_46_META_WS_E_FALLING: "गिरना",
  T_46_META_WS_E_FALLINGSTAR: "उपभोग्य वस्तु प्राप्त करें",
  T_46_META_WS_E_FALSE: "नहीं",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "प्रोपेलर मेकेनिज्म",
  T_46_META_WS_E_FAR: "दूर",
  T_46_META_WS_E_FEATHER: "पंख",
  T_46_META_WS_E_FEMALE: "महिला",
  T_46_META_WS_E_FENCE: "बाड़",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "लड़ाई इकाई",
  T_46_META_WS_E_FILLED: "भरा हुआ",
  T_46_META_WS_E_FINISH: "समाप्त",
  T_46_META_WS_E_FINISHINGPOINT: "समाप्ति बिंदु",
  T_46_META_WS_E_FINISHLINEARCH: "फिनिश बैनर",
  T_46_META_WS_E_FIRE: "आग",
  T_46_META_WS_E_FIRECHARGE: "आग का गोला",
  T_46_META_WS_E_FIREWORK: "आतिशबाजी",
  T_46_META_WS_E_FIRINGEFFECT: "शूटिंग VFX",
  T_46_META_WS_E_FIRSTPERSON: "पहले व्यक्ति का कैमरा",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "पहले व्यक्ति का कैमरा (क्लासिक)",
  T_46_META_WS_E_FIST: "मुट्ठी",
  T_46_META_WS_E_FIT: "फिट",
  T_46_META_WS_E_FLAG: "झंडा",
  T_46_META_WS_E_FLAME: "आग",
  T_46_META_WS_E_FLAMEGUN: "फ्लेम गन",
  T_46_META_WS_E_FLAMETHROWER: "फ्लेमथ्रोवर",
  T_46_META_WS_E_FLASH: "फ्लैशबैंग",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "फ्लैशबैंक धुआं",
  T_46_META_WS_E_FLASHFREEZE: "फ्लैश फ्रीज",
  T_46_META_WS_E_FLEXWALL: "रिट्रैक्टेबल दीवार",
  T_46_META_WS_E_FLICKER: "झपकना",
  T_46_META_WS_E_FLOWER: "फूल",
  T_46_META_WS_E_FLYBOMBBEE: "उड़ती हुई बम मधुमक्खी",
  T_46_META_WS_E_FLYPAN: "फ्राइंग पैन मेकेनिज्म",
  T_46_META_WS_E_FLYSHOE: "फ्लाई शू",
  T_46_META_WS_E_FOLDER: "फ़ोल्डर",
  T_46_META_WS_E_FOLDWINGS: "फोल्ड विंग्स",
  T_46_META_WS_E_FOODTRUCK: "खाद्य ट्रक",
  T_46_META_WS_E_FOODTRUCKB: "खाद्य ट्रक B",
  T_46_META_WS_E_FOOTBALL: "फुटबॉल",
  T_46_META_WS_E_FOOTBALLGUN: "फुटबॉल गन",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "फुटबॉल शूटर",
  T_46_META_WS_E_FORCE: "बल",
  T_46_META_WS_E_FOREGRIP_MR: "फोरग्रिप एमआर",
  T_46_META_WS_E_FOREGRIP1: "फोरग्रिप1",
  T_46_META_WS_E_FOREGRIP2: "फोरग्रिप2",
  T_46_META_WS_E_FOREGRIP3: "फोरग्रिप3",
  T_46_META_WS_E_FORWARD: "आगे बढ़ें",
  T_46_META_WS_E_FOUNTAIN: "फव्वारा",
  T_46_META_WS_E_FREE: "फ्री कैमरा",
  T_46_META_WS_E_FREEZEALL: "सब कुछ जमा",
  T_46_META_WS_E_FREEZEPOSITION: "सभी स्थिति जमा",
  T_46_META_WS_E_FREEZEPOSITIONX: "X स्थिति जमा",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y स्थिति जमा",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z स्थिति जमा",
  T_46_META_WS_E_FREEZEROTATION: "सभी घूर्णन जमा",
  T_46_META_WS_E_FREEZEROTATIONX: "X घूर्णन जमा",
  T_46_META_WS_E_FREEZEROTATIONY: "Y घूर्णन जमा",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z घूर्णन जमा",
  T_46_META_WS_E_FREEZEZONE: "ठंढा क्षेत्र",
  "T_46_META_WS_E_FROST GALAXY": "ठंढा आकाशगंगा",
  T_46_META_WS_E_FROZEN: "ठंडक",
  T_46_META_WS_E_FROZENGRENADE: "ठंडक ग्रेनेड",
  T_46_META_WS_E_FUNCTIONALITEMS: "कार्यात्मक आइटम",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "खेल",
  T_46_META_WS_E_GAMEOVER: "खेल समाप्त 2",
  T_46_META_WS_E_GAMESTART: "खेल शुरू",
  T_46_META_WS_E_GARAGE: "गैरेज",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "यंत्र सक्रिय",
  T_46_META_WS_E_GENTLETAP: "हल्का टैप",
  T_46_META_WS_E_GETITEM: "उपभोग्य वस्तु प्राप्त करें 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "भूत",
  T_46_META_WS_E_GIANTDICE: "पासा",
  T_46_META_WS_E_GIANTLOLLIPOP: "विशाल लोलिपॉप",
  T_46_META_WS_E_GIFT: "उपहार",
  T_46_META_WS_E_GLOOWALL: "गloo दीवार",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS थीम फूलों का बिस्तर",
  T_46_META_WS_E_GRAFFITIWALL: "ग्रैफिटी दीवार",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "हुक गन",
  T_46_META_WS_E_GREATCONDUCTOR: "महान कंडक्टर",
  T_46_META_WS_E_GREEN: "हरा",
  T_46_META_WS_E_GRENADE: "ग्रेनेड",
  T_46_META_WS_E_GRID: "ग्रिड",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "निगरानी टावर",
  T_46_META_WS_E_GUILD: "गिल्ड",
  T_46_META_WS_E_GUN: "बंदूक",
  T_46_META_WS_E_GUNFIRE: "गोलियाँ",
  T_46_META_WS_E_HALO: "हैलो",
  T_46_META_WS_E_HAMMER: "विशाल हथौड़ा मकेनिज्म",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "सुखाने की रैक",
  T_46_META_WS_E_HARD: "कठिन",
  T_46_META_WS_E_HATTRICK: "कौशल 8",
  T_46_META_WS_E_HAYSTACK: "घास का ढेर",
  T_46_META_WS_E_HEAD: "हेडवियर",
  T_46_META_WS_E_HEADSHOOT: "हेडशॉट",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "हीलिंग गन",
  T_46_META_WS_E_HEART: "दिल",
  T_46_META_WS_E_HEARTBEAT: "दिल की धड़कन",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "भारी हथियार",
  T_46_META_WS_E_HELL: "बहुत कठिन",
  T_46_META_WS_E_HELMET: "हेलमेट",
  T_46_META_WS_E_HELMET1: "हेलमेट1",
  T_46_META_WS_E_HELMET2: "हेलमेट2",
  T_46_META_WS_E_HELMET3: "हेलमेट3",
  T_46_META_WS_E_HEXAGON: "षट्भुज",
  T_46_META_WS_E_HGAMMO: "HG गोला बारूद",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "छुपा-छुपाई फ्लेमथ्रोवर",
  T_46_META_WS_E_HIDERKILL: "छिपाने वाला मारा गया",
  T_46_META_WS_E_HIHATS: "हाई-हैट",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "सुस्त हिट",
  T_46_META_WS_E_HITEFFECT: "बुलेट हिट VFX",
  T_46_META_WS_E_HITFEEDBACK: "शूटिंग फीडबैक",
  T_46_META_WS_E_HOOK: "हुक",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "हुक गन गोला-बारूद",
  T_46_META_WS_E_HORIZALINE: "क्षैतिज रेखा",
  T_46_META_WS_E_HORIZONTAL: "क्षैतिज",
  T_46_META_WS_E_HORN: "स्पीकर",
  T_46_META_WS_E_HORROR: "हॉरर",
  T_46_META_WS_E_HOURGLASS: "घड़ी",
  T_46_META_WS_E_HOUSE: "घर",
  T_46_META_WS_E_HOUSEA: "एक मंजिला घर",
  T_46_META_WS_E_HOUSEB: "दो मंजिला घर",
  T_46_META_WS_E_HOUSEC: "तीन मंजिला घर",
  T_46_META_WS_E_HP: "एचपी (स्वास्थ्य)",
  T_46_META_WS_E_HPBUFF: "HP बफ",
  T_46_META_WS_E_HUT: "कक्ष",
  T_46_META_WS_E_ICEA: "बर्फ A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "आइस वॉल मेकर",
  T_46_META_WS_E_ICONOBJECT: "आइकन",
  T_46_META_WS_E_IMAGEWIDGET: "चित्र विजेट",
  T_46_META_WS_E_IMPULSE: "झटका",
  T_46_META_WS_E_INHALER: "इनहेलर",
  T_46_META_WS_E_INJUREDFEMALE: "हिट पर महिला की चीख",
  T_46_META_WS_E_INJUREDMALE: "हिट पर पुरुष की चीख",
  T_46_META_WS_E_INK: "स्याही VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "इनपुट लेबल",
  T_46_META_WS_E_INSECTCHIRPING: "कीट की चिढ़",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 सेकंड",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 सेकंड",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 सेकंड",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 सेकंड",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 सेकंड",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 सेकंड",
  T_46_META_WS_E_INVISIBLE: "अदृश्य",
  T_46_META_WS_E_IPIPE: "पाइप I",
  T_46_META_WS_E_IRONFENCE: "बाड़ा",
  T_46_META_WS_E_IRONFENCEB: "बाड़ा B",
  T_46_META_WS_E_IRONPLATFORM: "लोहे का मंच",
  T_46_META_WS_E_ITEMENTITY: "उपभोक्ता जनरेटर",
  T_46_META_WS_E_JEEP: "जीप",
  T_46_META_WS_E_JERRYCAN: "तेल ड्रम",
  T_46_META_WS_E_JERSEYMACHINE: "जर्सी मशीन",
  T_46_META_WS_E_JOINEDGAMEDULL: "झगड़े में शामिल हों",
  T_46_META_WS_E_JOINGAME: "खेल में शामिल हों",
  T_46_META_WS_E_JOYSTICKWIDGET: "जॉयस्टिक विजेट",
  T_46_META_WS_E_JUMP: "कूदना",
  T_46_META_WS_E_JUMPATTACK: "कूद हमला",
  T_46_META_WS_E_JUSTPATROL: "केवल गश्त",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "चाबी",
  T_46_META_WS_E_KICK: "बास ड्रम",
  T_46_META_WS_E_KILLINGTIPS: "हत्या के सुझाव",
  T_46_META_WS_E_KILLZONE: "मौत का क्षेत्र",
  T_46_META_WS_E_KINEMATIC: "काइनेमेटिक",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "नीचे गिरा",
  T_46_META_WS_E_KNOCKEDDOWN: "गिराया गया",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "लेबल विजेट",
  T_46_META_WS_E_LANDINGA: "सीढ़ी लैंडिंग A",
  T_46_META_WS_E_LANDINGB: "सीढ़ी लैंडिंग B",
  T_46_META_WS_E_LANDINGC: "सीढ़ी लैंडिंग C",
  T_46_META_WS_E_LANDMINE: "लैंडमाइन",
  T_46_META_WS_E_LANUNCHERAMMO: "लॉन्चर गोला-बारूद",
  T_46_META_WS_E_LASER: "लेजर VFX",
  T_46_META_WS_E_LASERSKILL: "लेजर कौशल",
  T_46_META_WS_E_LATTICESCREEN: "स्क्रीन",
  T_46_META_WS_E_LAWNA: "लॉन A",
  T_46_META_WS_E_LAWNB: "लॉन B",
  T_46_META_WS_E_LAYOUTWIDGET: "लेआउट विजेट",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "मृत लकड़ी",
  T_46_META_WS_E_LEVELMAXED: "अधिकतम स्तर",
  T_46_META_WS_E_LEVELUP: "रैंक अप",
  T_46_META_WS_E_LEVELUPDISCARDED: "रैंक अप",
  T_46_META_WS_E_LIGHTBEAM: "प्रकाश किरण",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "प्रकाश किरण",
  T_46_META_WS_E_LIGHTEFFECT: "प्रकाश प्रभाव",
  T_46_META_WS_E_LIGHTNING: "बिजली",
  T_46_META_WS_E_LIMB: "अंग",
  T_46_META_WS_E_LINE: "रेखा",
  T_46_META_WS_E_LIQUID: "तरल",
  T_46_META_WS_E_LOCAL: "स्थानीय",
  T_46_META_WS_E_LOCALPOSITION: "स्थानीय स्थिति",
  T_46_META_WS_E_LOCK: "ताला",
  T_46_META_WS_E_LONGBOX: "लंबा लकड़ी का बक्सा",
  T_46_META_WS_E_LOOP: "लूप",
  T_46_META_WS_E_LOOTITEMBOX: "लूट हथियार",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "लूट की गोलियां",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "लूट की आर्मर",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "लूट उपभोग्य सामग्री",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "लूट फेंकने योग्य वस्तु",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "लूट स्कोप",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "बर्फ ग्रेनेड",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "यादृच्छिक फ़ुटबॉल लूट",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "फ़ुटबॉल शील्ड",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "यादृच्छिक हथियार लूट",
  T_46_META_WS_E_LOSE: "हार",
  T_46_META_WS_E_LOUDSPEAKER: "स्पीकर",
  T_46_META_WS_E_LOWFALLING: "कम गिरना",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79 ग्रेनेड",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 विशेष ग्रेनेड",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "मैगज़ीन1",
  T_46_META_WS_E_MAGEZINE2: "मैगज़ीन2",
  T_46_META_WS_E_MAGEZINE3: "मैगज़ीन3",
  T_46_META_WS_E_MAGMAA: "मैग्मा A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "आवर्धक",
  T_46_META_WS_E_MALE: "पुरुष",
  T_46_META_WS_E_MARK: "चिह्न",
  T_46_META_WS_E_MARKER: "चिह्न",
  T_46_META_WS_E_MASK: "चेहरे की सजावट",
  T_46_META_WS_E_MAXVALUE: "अधिकतम मूल्य",
  T_46_META_WS_E_MECHANICAL: "त्वरित क्लिक 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "मैकेनिकल डिवाइस इको",
  T_46_META_WS_E_MEDICALPROPS: "चिकित्सा सामग्री",
  T_46_META_WS_E_MEDICALTENT: "मेडिकल टेंट",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "मध्यम दिल की धड़कन",
  T_46_META_WS_E_MEDKIT: "चिकित्सा किट",
  T_46_META_WS_E_MELEE: "नजदीकी हथियार",
  T_46_META_WS_E_MELEEWEAPONS: "नज़दीकी हथियार",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "माइक्रोफोन",
  T_46_META_WS_E_MIDDLE: "मध्य",
  T_46_META_WS_E_MINIHANDLE: "मिनी हैंडल",
  T_46_META_WS_E_MINIMAP: "मिनी मैप",
  T_46_META_WS_E_MINISENTRY: "मिनी सेंट्री",
  T_46_META_WS_E_MINVALUE: "न्यूनतम मूल्य",
  T_46_META_WS_E_MISSILEEXPLODE: "मिसाइल-प्रकार का हथियार",
  T_46_META_WS_E_MISSIONCOMPLETE: "मिशन सफलतापूर्वक 1",
  T_46_META_WS_E_MISTAKE: "गलती",
  T_46_META_WS_E_MODERATE: "मध्यम",
  T_46_META_WS_E_MONEY: "पैसा",
  T_46_META_WS_E_MONSTER: "राक्षस",
  T_46_META_WS_E_MONSTERSPAWN: "मॉन्स्टर स्पॉन पॉइंट",
  T_46_META_WS_E_MONSTERTRUCK: "मॉन्स्टर ट्रक",
  T_46_META_WS_E_MOON: "चाँद",
  T_46_META_WS_E_MOSQUITO: "मच्छर",
  T_46_META_WS_E_MOTIONTRAIL: "पीछे से टकराना",
  T_46_META_WS_E_MOTOBIKE: "मोटरसाइकिल",
  T_46_META_WS_E_MOTORBIKE: "मोटरसाइकिल",
  T_46_META_WS_E_MOVE: "ले जाओ",
  T_46_META_WS_E_MOVEMENT: "स्थानांतरित करें",
  T_46_META_WS_E_MOVINGJOYSTICK: "मूविंग जॉयस्टिक",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "मिस्टर वी",
  T_46_META_WS_E_MULTIPLIER: "गुणक",
  T_46_META_WS_E_MULTIPLY: "गुणा करें",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "गुणा और संचित",
  T_46_META_WS_E_MUSHROOM1: "मशरूम1",
  T_46_META_WS_E_MUSHROOM2: "मशरूम2",
  T_46_META_WS_E_MUSHROOM3: "मशरूम3",
  T_46_META_WS_E_MUSHROOM4: "मशरूम4",
  T_46_META_WS_E_MUSHSHADE: "विशाल मशरूम क्लस्टर",
  T_46_META_WS_E_MUSIC: "संगीत",
  T_46_META_WS_E_MUZZLE1: "मज़ल1",
  T_46_META_WS_E_MUZZLE2: "मज़ल2",
  T_46_META_WS_E_MUZZLE3: "मज़ल3",
  T_46_META_WS_E_NEAR: "निकट",
  T_46_META_WS_E_NIGHT: "रात",
  T_46_META_WS_E_NOATTACK: "कोई हमला नहीं",
  T_46_META_WS_E_NODUALWIELDING: "दोहरे हथियार नहीं",
  T_46_META_WS_E_NOERROR: "कोई त्रुटि नहीं",
  T_46_META_WS_E_NONE: "कोई नहीं",
  T_46_META_WS_E_NORMAL: "सामान्य",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "गिराने को छोड़ें नहीं",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "कौशल 7",
  T_46_META_WS_E_OBTAINEDCOINS: "मध्यम सोना प्राप्त करें",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "बड़ा सोना प्राप्त करें",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "छोटा सोना प्राप्त करें",
  T_46_META_WS_E_OILDRUMEXPLODE: "तेल ड्रम विस्फोट",
  T_46_META_WS_E_ONCE: "एक बार",
  T_46_META_WS_E_ONEWAY: "एक तरफा",
  T_46_META_WS_E_OPENFOLDER: "खुला फ़ोल्डर",
  T_46_META_WS_E_OPENHIHATS: "ओपन हाई-हैट",
  T_46_META_WS_E_OPENINGBOX: "बॉक्स खोलें",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "गिल्ड आपूर्ति",
  T_46_META_WS_E_OPENINGWARCHEST: "गोदाम सहेजें",
  T_46_META_WS_E_ORANGE: "संतरा",
  T_46_META_WS_E_ORTHOGONAL: "आर्थोगोनल",
  T_46_META_WS_E_OUTPOST: "गार्डहाउस",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "रंगीन दीवार",
  T_46_META_WS_E_PAINTSHIELDSKILL: "रक्त पूल कौशल",
  T_46_META_WS_E_PALM: "कागज",
  T_46_META_WS_E_PANEL: "पैनल",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "यात्री A",
  T_46_META_WS_E_PASSENGERB: "यात्री B",
  T_46_META_WS_E_PASSENGERC: "यात्री C",
  T_46_META_WS_E_PASSIVE: "निष्क्रिय",
  T_46_META_WS_E_PASSIVESKILL: "निष्क्रिय कौशल",
  T_46_META_WS_E_PATROLWHILEATTACK: "गश्त करते हुए हमला",
  T_46_META_WS_E_PERSONALUAV: "व्यक्तिगत UAV",
  T_46_META_WS_E_PERSPECTIVE: "परिप्रेक्ष्य",
  T_46_META_WS_E_PETTABBG: "पालतू जानवर",
  T_46_META_WS_E_PHASESTART: "चरण प्रारंभ",
  T_46_META_WS_E_PHONEBOOTH: "टेलीफोन बूथ",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "संगीत नोट्स - पियानो",
  T_46_META_WS_E_PIANOKEY2: "संगीत नोट्स - पियानो",
  T_46_META_WS_E_PICKUPS: "वस्त्र उठाना",
  T_46_META_WS_E_PICKUPTRUCK: "एसयूवी",
  T_46_META_WS_E_PILLAR: "ठोस स्तम्भ",
  T_46_META_WS_E_PIN: "कॉलआउट",
  T_46_META_WS_E_PINGPONG: "पिंग पोंग",
  T_46_META_WS_E_PIPECORNER: "एल्बो पाइप",
  T_46_META_WS_E_PIPEINTERSECTION: "क्रॉस पाइप",
  T_46_META_WS_E_PISTOL: "पिस्तौल",
  T_46_META_WS_E_PISTOLAMMO: "पिस्तौल गोला-बारूद",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "चेकर्ड एम्यूज़मेंट पार्क ब्लॉक",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "खिलाड़ी",
  T_46_META_WS_E_PLUS: "जोड़",
  T_46_META_WS_E_PODIUM: "मंच",
  T_46_META_WS_E_POISONGAS: "जहर गैस",
  T_46_META_WS_E_POISONGASPREDISCARDED: "जहर गैस",
  T_46_META_WS_E_PORTAL: "पोर्टल",
  T_46_META_WS_E_POSTACCUMULATOR: "पोस्ट संचयक",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "तेज़ दिल की धड़कन",
  T_46_META_WS_E_PREACCUMULATOR: "पूर्व संचयक",
  T_46_META_WS_E_PRIMARYWEAPONA: "प्राथमिक हथियार A",
  T_46_META_WS_E_PRIMARYWEAPONB: "प्राथमिक हथियार B",
  T_46_META_WS_E_PRIOREXPLOSION: "बम विस्फोट से पहले",
  T_46_META_WS_E_PROFILEWIDGET: "प्रोफ़ाइल विजेट",
  T_46_META_WS_E_PRONE: "लेटा हुआ",
  T_46_META_WS_E_PUMPKIN: "कद्दू",
  T_46_META_WS_E_PURPLE: "बैंगनी",
  T_46_META_WS_E_QUADRILATERAL: "चौकोर",
  T_46_META_WS_E_QUESTIONMARK: "प्रश्न चिन्ह",
  T_46_META_WS_E_QUICKCHAT: "त्वरित चैट",
  T_46_META_WS_E_QUICKCHATSHOW: "त्वरित चैट दिखाएं",
  T_46_META_WS_E_RADIAL180: "रेडियल 180°",
  T_46_META_WS_E_RADIAL360: "रेडियल 360°",
  T_46_META_WS_E_RADIAL90: "रेडियल 90°",
  T_46_META_WS_E_RAMPAGE: "बर्बरता",
  T_46_META_WS_E_RANDOM: "यादृच्छिक",
  T_46_META_WS_E_RANDOMBUFF: "रैंडम बफ",
  T_46_META_WS_E_RANKDOWN: "रैंक डाउन",
  T_46_META_WS_E_REACTION: "प्रतिक्रिया",
  T_46_META_WS_E_RECOVER: "पुनर्प्राप्त",
  T_46_META_WS_E_RECYCLE: "पुनर्नवीनीकरण",
  T_46_META_WS_E_RED: "लाल",
  T_46_META_WS_E_REFINERYTANK: "पानी का जग",
  T_46_META_WS_E_REFLECTIVECUBE: "परावर्तक ठोस रंग ब्लॉक 1",
  T_46_META_WS_E_REFRESH: "रिफ्रेश",
  T_46_META_WS_E_RELEASINGSKILL: "कौशल कैस्ट VFX",
  T_46_META_WS_E_RELOAD: "पुनः लोड करें",
  T_46_META_WS_E_REMINDER: "अनुस्मारक",
  T_46_META_WS_E_REPAIR: "मरम्मत",
  T_46_META_WS_E_REPAIREQUIP: "उपकरण मरम्मत",
  T_46_META_WS_E_REPAIRKIT: "मरम्मत किट",
  T_46_META_WS_E_REPLACER: "रिप्लेसर",
  T_46_META_WS_E_REPORT: "रिपोर्ट करें",
  T_46_META_WS_E_REST: "विश्राम",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "राइड",
  T_46_META_WS_E_RIDICULE: "उपहास",
  T_46_META_WS_E_RIDICULEFUNNY: "मजेदार उपहास",
  T_46_META_WS_E_RIFLE: "राइफल",
  T_46_META_WS_E_RIFLEAMMO: "राइफल गोला-बारूद",
  T_46_META_WS_E_RIGHT: "सही",
  T_46_META_WS_E_RIGHTTRAPEZOID: "दायां कोण वाला ट्रैपेज़ियम",
  T_46_META_WS_E_RING: "रिंग मेकेनिज्म",
  T_46_META_WS_E_RINGPREDISCARDED: "अंगूठी",
  T_46_META_WS_E_RIPTIDERHYTHM: "कौशल 9",
  T_46_META_WS_E_RISINGPARTICLE: "उठते कण",
  T_46_META_WS_E_ROADBLOCK: "बैरिकेड",
  T_46_META_WS_E_ROTATE: "घुमाव",
  T_46_META_WS_E_RUNNING: "चल रहा है",
  T_46_META_WS_E_RUSHTIME: "रैम्पेज",
  T_46_META_WS_E_SAMURAI: "समुराई",
  T_46_META_WS_E_SANDA: "बालू A",
  T_46_META_WS_E_SANDSTRUCTURE: "रेत की मूर्ति",
  T_46_META_WS_E_SCALE: "पैमाना",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "डरावनी आकृति",
  T_46_META_WS_E_SCISSORS: "कैंची",
  T_46_META_WS_E_SCOPE2X: "2x दृष्टि",
  T_46_META_WS_E_SCOPE4X: "4x दृष्टि",
  T_46_META_WS_E_SCROLLPANEL: "स्क्रॉल पैनल",
  T_46_META_WS_E_SECONDARYWEAPON: "द्वितीयक हथियार",
  T_46_META_WS_E_SENSESSHOCKWAVE: "कौशल 10",
  T_46_META_WS_E_SERVER: "सर्वर",
  T_46_META_WS_E_SET: "बॉडीसूट",
  T_46_META_WS_E_SETTING: "सेटिंग्स",
  T_46_META_WS_E_SETTINGS: "सेटिंग्स",
  T_46_META_WS_E_SG: "शॉटगन",
  T_46_META_WS_E_SGAMMO: "SN गोला बारूद",
  T_46_META_WS_E_SHARPMECHANICAL: "त्वरित क्लिक 1",
  T_46_META_WS_E_SHIELD: "रक्षा",
  T_46_META_WS_E_SHIELDBROKEN: "शील्ड टूटा",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "शील्ड अप",
  T_46_META_WS_E_SHOCKWAVE: "शॉक वेव",
  T_46_META_WS_E_SHOES: "जूते",
  T_46_META_WS_E_SHOOTINGTARGET: "चलती हुई लक्ष्य",
  T_46_META_WS_E_SHORTDATE: "छोटी तारीख",
  T_46_META_WS_E_SHORTDATETIME: "छोटा दिनांक और समय",
  T_46_META_WS_E_SHORTTIME: "छोटा समय",
  T_46_META_WS_E_SHOTGUN: "शॉटगन",
  T_46_META_WS_E_SHOTGUNAMMO: "शॉटगन की गोली",
  T_46_META_WS_E_SHOTGUNMUZZLE: "शॉटगन मज़ल",
  T_46_META_WS_E_SHOW: "दिखाएं",
  T_46_META_WS_E_SHRUB: "झाड़ी ढकी लंबी लकड़ी का बक्सा",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "साइड-स्क्रॉलिंग कैमरा",
  T_46_META_WS_E_SIGNAL: "सिग्नल",
  T_46_META_WS_E_SIGNOUT: "बाहर निकलें",
  T_46_META_WS_E_SILENCER: "साइलेंसर",
  T_46_META_WS_E_SIMPLE: "सरल",
  T_46_META_WS_E_SIMPLEWIDGET: "सरल विजेट",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "सिंगल",
  T_46_META_WS_E_SITEHUT: "कंटेनर हाउस",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "कौशल चार्ज पूरा",
  T_46_META_WS_E_SKILLRECOVER: "कौशल पुनर्प्राप्ति",
  T_46_META_WS_E_SKIPKNOCKDOWN: "गिराने को छोड़ें",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "स्लाइस",
  T_46_META_WS_E_SLOPE: "ढलान",
  T_46_META_WS_E_SLOWHEARTBEAT: "धीमी दिल की धड़कन",
  T_46_META_WS_E_SMG: "एसएमजी",
  T_46_META_WS_E_SMGAMMO: "SMG गोला बारूद",
  T_46_META_WS_E_SMGMUZZLE: "एसएमजी मज़ल",
  T_46_META_WS_E_SMILEY: "मुस्कान वाला चेहरा",
  T_46_META_WS_E_SMOKE: "धुआं",
  T_46_META_WS_E_SMOKEGRENADE: "धुआं ग्रेनेड",
  T_46_META_WS_E_SMOKEY: "धुआं",
  T_46_META_WS_E_SMOOTH: "स्मूथ",
  T_46_META_WS_E_SNAMMO: "SN गोला बारूद",
  T_46_META_WS_E_SNARES: "स्नेयर ड्रम",
  T_46_META_WS_E_SNEAKERS: "रनिंग शूज़ VFX",
  T_46_META_WS_E_SNIPER: "स्नाइपर राइफल",
  T_46_META_WS_E_SNIPERAMMO: "स्नाइपर राइफल की गोली",
  T_46_META_WS_E_SNOWA: "बर्फ A",
  T_46_META_WS_E_SNOWFLAKE: "बर्फ के टुकड़े",
  T_46_META_WS_E_SOCCER: "फुटबॉल",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "सोशल बटन",
  T_46_META_WS_E_SOLARPANEL: "सौर पैनल",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "उच्च से निम्न प्राथमिकता",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "कम से उच्च प्राथमिकता",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "स्पॉन प्वाइंट VFX",
  T_46_META_WS_E_SPEAKER: "स्पीकर",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "विशेष बंदूक की आवाज़",
  T_46_META_WS_E_SPECIALGUN: "विशेष गन",
  T_46_META_WS_E_SPHERE: "गोला",
  T_46_META_WS_E_SPHERETRIGGER: "गोलाकार टकराव ट्रिगर",
  T_46_META_WS_E_SPIDERWEB: "कौशल VFX",
  T_46_META_WS_E_SPORTSCAR: "स्पोर्ट्स कार",
  T_46_META_WS_E_SPOTLIGHT: "प्रकाश",
  T_46_META_WS_E_SPREADOFPOISONGAS: "जहर गैस का प्रसार",
  T_46_META_WS_E_SPRINT: "दौड़ना",
  T_46_META_WS_E_SQUARE: "वर्ग",
  T_46_META_WS_E_SQUAREBOX: "स्क्वायर लकड़ी का बक्सा",
  T_46_META_WS_E_SR: "स्नाइपर राइफल",
  T_46_META_WS_E_STABLE: "घास की छत की झोपड़ी",
  T_46_META_WS_E_STAIRS: "सीढ़ी",
  T_46_META_WS_E_STANDING: "खड़ा",
  T_46_META_WS_E_STAR: "तारा",
  T_46_META_WS_E_STATIC: "स्थैतिक",
  T_46_META_WS_E_STATUSTRIGGER: "मृत्यु या अमरता ट्रिगर",
  T_46_META_WS_E_STEP: "कदम की ध्वनि",
  T_46_META_WS_E_STEPTRIGGER: "मैकेनिज़म सक्रिय करें",
  T_46_META_WS_E_STOCK_S: "स्टॉक एस",
  T_46_META_WS_E_STOCK_SR: "स्टॉक एसआर",
  T_46_META_WS_E_STOCK1: "स्टॉक1",
  T_46_META_WS_E_STOCK2: "स्टॉक2",
  T_46_META_WS_E_STOCK3: "स्टॉक3",
  T_46_META_WS_E_STONE: "चट्टान",
  T_46_META_WS_E_STONEBRIDGE: "पत्थर का आर्च पुल",
  T_46_META_WS_E_STONELANTERN: "राजमहल दीपक",
  T_46_META_WS_E_STONESPLASH: "उड़ती हुई मलबा",
  T_46_META_WS_E_STORE: "स्टोर",
  T_46_META_WS_E_STREETLAMP: "सड़क लाइट",
  T_46_META_WS_E_STYLEA: "शैली A",
  T_46_META_WS_E_STYLEB: "शैली B",
  T_46_META_WS_E_STYLEC: "शैली C",
  T_46_META_WS_E_SUBMACHINEGUN: "एसएमजी",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "एसएमजी की गोली",
  T_46_META_WS_E_SUCCESSFULHIT: "हिट",
  T_46_META_WS_E_SUN: "सूरज",
  T_46_META_WS_E_SUNSHADE: "छाता के साथ आँगन सेट",
  T_46_META_WS_E_SUPERCAR: "स्पोर्ट्स कार",
  T_46_META_WS_E_SUPERMARKET: "सुपरमार्केट",
  T_46_META_WS_E_SURPRISEFIND: "आश्चर्य की खोज",
  T_46_META_WS_E_SUV: "एसयूवी",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "त्वरित हथियार स्विच करें",
  T_46_META_WS_E_SWIMRING: "तैराकी रिंग",
  T_46_META_WS_E_SWORD: "तलवार",
  T_46_META_WS_E_SYMBOLIC: "ज़मीन का मार्कर",
  T_46_META_WS_E_TANKZOMBIE: "टैंक ज़ॉम्बी",
  T_46_META_WS_E_TAP: "टैप",
  T_46_META_WS_E_TAPPINGBUTTON: "बटन टैप करें",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "टैप अक्षम बटन",
  T_46_META_WS_E_TEAM: "टीम",
  T_46_META_WS_E_TEAMMATESINFO: "टीममेट्स की जानकारी",
  T_46_META_WS_E_TELEPORT: "टेलीपोर्ट",
  T_46_META_WS_E_TELEPORTCORRECT: "सही गंतव्य की बीकनिंग",
  T_46_META_WS_E_TELEPORTWRONG: "गलत गंतव्य की बीकनिंग",
  T_46_META_WS_E_TEXT: "पाठ",
  T_46_META_WS_E_TEXTOBJECT: "पाठ",
  T_46_META_WS_E_TEXTUREWIDGET: "टेक्सचर विजेट",
  T_46_META_WS_E_THERMALSCOPE: "थर्मल स्कोप",
  T_46_META_WS_E_THIRDPERSON: "तीसरे व्यक्ति का कैमरा",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "तीसरे व्यक्ति का कैमरा (क्लासिक)",
  T_46_META_WS_E_THIRDPERSONLOCK: "तीसरे व्यक्ति का लॉक कैमरा",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "संगतता के लिए थ्रोइंग नाइफ2",
  T_46_META_WS_E_THRILLBATTLE: "कौशल 5",
  T_46_META_WS_E_THROWATTACK: "ग्रेनेड फेंको",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "लाल थ्रो ज़ॉम्बी",
  T_46_META_WS_E_THROWZOMBIE: "थ्रो ज़ॉम्बी",
  T_46_META_WS_E_THUMBSUP: "पसंद",
  T_46_META_WS_E_THUNDER: "विद्युत आघात",
  T_46_META_WS_E_TILEA: "टाइल A",
  T_46_META_WS_E_TILEB: "टाइल B",
  T_46_META_WS_E_TILEC: "टाइल C",
  T_46_META_WS_E_TILED: "टाइल्ड",
  T_46_META_WS_E_TIPSSOUND: "सुझाव दिखाएँ",
  T_46_META_WS_E_TOGGLEWIDGET: "टॉगल विजेट",
  T_46_META_WS_E_TOILETBOWL: "शौचालय",
  T_46_META_WS_E_TONEA: "पत्थर A",
  T_46_META_WS_E_TOP: "ऊपरी कपड़े",
  T_46_META_WS_E_TOPDOWN: "ऊपर से देखने वाला कैमरा",
  T_46_META_WS_E_TORII: "तोरी",
  T_46_META_WS_E_TOUCHPADWIDGET: "टचपैड विजेट",
  T_46_META_WS_E_TOWER: "किला",
  T_46_META_WS_E_TPIPE: "पाइप T",
  T_46_META_WS_E_TRACINGSTEPS: "कौशल 3",
  T_46_META_WS_E_TRAILER: "ट्रेलर",
  T_46_META_WS_E_TRANSFORMATION: "रूप बदलना",
  T_46_META_WS_E_TRANSPARENT: "पारदर्शी",
  T_46_META_WS_E_TRAPEZOID: "ट्रैपेज़ियम",
  T_46_META_WS_E_TRASHCAN: "कचरा पात्र",
  T_46_META_WS_E_TRIANGLE: "त्रिकोण",
  T_46_META_WS_E_TRIGGERS: "ट्रिगर",
  T_46_META_WS_E_TRIPLE: "ट्रिपल",
  T_46_META_WS_E_TROPHY: "ट्रॉफी",
  T_46_META_WS_E_TRUE: "हाँ",
  T_46_META_WS_E_TUKTUK: "टुकटुक",
  T_46_META_WS_E_TUTUCAR: "टुक टुक",
  T_46_META_WS_E_TYRANTZOMBIE: "अत्याचारी ज़ॉम्बी",
  T_46_META_WS_E_UAVLITE: "यूएवी लाइट",
  T_46_META_WS_E_UIFINISH: "समाप्त",
  T_46_META_WS_E_UITAP: "UI टैप",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "यूनिट जनरेटर",
  T_46_META_WS_E_UPWARDTURBULENCE: "ऊपर की ओर बहाव",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "ऊपर चढ़ना",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "वाहन",
  T_46_META_WS_E_VEHICLEEXPLODE: "वाहन विस्फोट",
  T_46_META_WS_E_VELOCITY: "गति",
  T_46_META_WS_E_VENDINGMACHINE: "वेंडिंग मशीन",
  T_46_META_WS_E_VERTICAL: "ऊर्ध्वाधर",
  T_46_META_WS_E_VEST: "वेस्ट",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "वेस्ट4",
  T_46_META_WS_E_VISUALEFFECTS: "दृश्य प्रभाव",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "दीवार A",
  T_46_META_WS_E_WALLBRAWL: "कौशल 2",
  T_46_META_WS_E_WARNING: "चेतावनी",
  T_46_META_WS_E_WATERRING: "पानी की छींटें",
  T_46_META_WS_E_WAVE1: "लहर1",
  T_46_META_WS_E_WAVE2: "लहर2",
  T_46_META_WS_E_WAVE3: "लहर3",
  T_46_META_WS_E_WEAPONGENERATOR: "हथियार",
  T_46_META_WS_E_WEAPONSLOT: "हथियार स्लॉट",
  T_46_META_WS_E_WHISTLE: "दुश्मन को हराएँ",
  T_46_META_WS_E_WIDERANGE: "विस्तृत रेंज",
  T_46_META_WS_E_WIN: "जीत",
  T_46_META_WS_E_WINDATTACK: "हवा हमला",
  T_46_META_WS_E_WOODA: "लकड़ी A",
  T_46_META_WS_E_WOODCUTZOMBIE: "लकड़ी काटने वाला ज़ॉम्बी",
  T_46_META_WS_E_WOODENPLANK: "लकड़ी का पुल",
  T_46_META_WS_E_WORLDPOSITION: "विश्व निर्देशांक",
  T_46_META_WS_E_WRECKEDBUS: "बर्बाद बस",
  T_46_META_WS_E_WRECKEDCAR: "बर्बाद गाड़ी",
  T_46_META_WS_E_WRONG: "गलत",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "ज़ोंबी",
  T_46_META_WS_E_ZOMBIES: "ज़ोंबी",
  T_46_META_WS_E_ZOOM: "ज़ूम",
  T_46_META_WS_ELIMINATE: "समाप्त करें",
  T_46_META_WS_ELIMINATEDENTITY: "समाप्त इकाई",
  T_46_META_WS_ELIMINATEDPLAYER: "खिलाड़ी समाप्त",
  T_46_META_WS_ENABLEDEFAULTBTREE: "डिफ़ॉल्ट बिहेवियर ट्री सक्षम करें",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "चलने वाले सुरक्षित क्षेत्र को सक्षम करें",
  T_46_META_WS_ENABLESAFEZONE: "सुरक्षित क्षेत्र को सक्षम करें",
  T_46_META_WS_ENDCURRENTPHASE: "वर्तमान चरण समाप्त करें",
  T_46_META_WS_ENDMORPH: "रूपांतरण समाप्त करें",
  T_46_META_WS_ENDPOSITION: "अंतिम स्थान",
  T_46_META_WS_ENTERVEHICLE: "वाहन में प्रवेश करें",
  T_46_META_WS_ENTITY: "इकाई",
  T_46_META_WS_EQUIPMENTID: "उपकरण आईडी",
  T_46_META_WS_EULERANGLETOQUATERNION: "ऑयलर कोण को क्वाटरनियन में बदलें",
  T_46_META_WS_EXITVEHICLE: "वाहन से बाहर निकलें",
  T_46_META_WS_EXPONENTIATION: "घातांक",
  T_46_META_WS_FILTERENTITY: "एंटिटी को फ़िल्टर करें",
  T_46_META_WS_FILTERLEVELOBJECTS: "लेवल ऑब्जेक्ट्स को फ़िल्टर करें",
  T_46_META_WS_FIND: "खोजें",
  T_46_META_WS_FINDAT: "खोजें स्थान",
  T_46_META_WS_FINDPATH: "मार्ग खोजें",
  T_46_META_WS_FLOOR: "नीचे राउंड करें",
  T_46_META_WS_FOOTBALLGOAL: "फुटबॉल गोल",
  T_46_META_WS_FORMAT: "स्वरूप",
  T_46_META_WS_GETALLKEYS: "सभी कुंजी प्राप्त करें",
  T_46_META_WS_GETALLPLAYERS: "सभी खिलाड़ियों को प्राप्त करें",
  T_46_META_WS_GETALLSHOPS: "सभी दुकानें प्राप्त करें",
  T_46_META_WS_GETALLTEAMS: "सभी टीमों को प्राप्त करें",
  T_46_META_WS_GETATTACKABLEENTITY: "आक्रमण योग्य एंटिटी प्राप्त करें",
  T_46_META_WS_GETATTACKABLEFACTIONS: "आक्रमण योग्य गुट प्राप्त करें",
  T_46_META_WS_GETBACKPACKSKIN: "बैकपैक की त्वचा प्राप्त करें",
  T_46_META_WS_GETBLACKBOARDVALUE: "ब्लैकबोर्ड मूल्य प्राप्त करें",
  T_46_META_WS_GETBUFFS: "बफ प्राप्त करें",
  T_46_META_WS_GETCHATCHANNEL: "चैट चैनल प्राप्त करें",
  T_46_META_WS_GETCHILDBYINDEX: "इंडेक्स द्वारा चाइल्ड प्राप्त करें",
  T_46_META_WS_GETCHILDBYNAME: "नाम द्वारा चाइल्ड प्राप्त करें",
  T_46_META_WS_GETCHILDREN: "सभी चाइल्ड प्राप्त करें",
  T_46_META_WS_GETCOLORCHANNEL: "रंग चैनल प्राप्त करें",
  T_46_META_WS_GETCONSUMABLES: "उपभोग्य वस्तुएं प्राप्त करें",
  T_46_META_WS_GETCULLINGMASK: "कूलिंग मास्क प्राप्त करें",
  T_46_META_WS_GETCURRENTCAMERA: "वर्तमान कैमरा प्राप्त करें",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "वर्तमान चैट चैनल प्राप्त करें",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "कस्टम मिशन प्रगति प्राप्त करें",
  T_46_META_WS_GETDYEDCOUNT: "रंगाई की संख्या प्राप्त करें",
  T_46_META_WS_GETDYEDSTATUS: "रंगाई स्थिति प्राप्त करें",
  T_46_META_WS_GETEQUIPMENTS: "उपकरण प्राप्त करें",
  T_46_META_WS_GETFACTION: "गुट प्राप्त करें",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "वैश्विक सोने की सीमा प्राप्त करें",
  T_46_META_WS_GETITEMCOUNT: "आइटम की संख्या प्राप्त करें",
  T_46_META_WS_GETLOADEDSCENES: "लोड की गई दृश्यों को प्राप्त करें",
  T_46_META_WS_GETLOCALAIMDIRECTION: "स्थानीय लक्ष्य दिशा प्राप्त करें",
  T_46_META_WS_GETLOCALPLAYER: "स्थानीय खिलाड़ी प्राप्त करें",
  T_46_META_WS_GETLOCALTIMESTAMP: "स्थानीय समय स्टैम्प प्राप्त करें",
  T_46_META_WS_GETMAPID: "मानचित्र ID प्राप्त करें",
  T_46_META_WS_GETMINIMAP: "मिनी मैप प्राप्त करें",
  T_46_META_WS_GETMONEY: "पैसा प्राप्त करें",
  T_46_META_WS_GETMONEYCOUNT: "पैसा की गणना प्राप्त करें",
  T_46_META_WS_GETMORPH: "रूपांतरण प्राप्त करें",
  T_46_META_WS_GETNODEVARIABLE: "नोड वेरिएबल प्राप्त करें",
  T_46_META_WS_GETOUTFIT: "परिधान प्राप्त करें",
  T_46_META_WS_GETOWNER: "मालिक प्राप्त करें",
  T_46_META_WS_GETPARENT: "पैरेंट प्राप्त करें",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "टीम के साथी के पास स्थिति प्राप्त करें",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "यादृच्छिक स्पॉन स्थिति प्राप्त करें",
  T_46_META_WS_GETRESULTFROMCURVE: "कर्व से परिणाम प्राप्त करें",
  T_46_META_WS_GETSCENESKYBOX: "सीन का स्काईबॉक्स प्राप्त करें",
  T_46_META_WS_GETSERVERREGION: "सर्वर क्षेत्र प्राप्त करें",
  T_46_META_WS_GETSERVERTIMESTAMP: "सर्वर टाइमस्टैम्प प्राप्त करें",
  T_46_META_WS_GETSKELETONPARTBYNAME: "हड्डी का भाग नाम से प्राप्त करें",
  T_46_META_WS_GETSKILLS: "कौशल प्राप्त करें",
  T_46_META_WS_GETSLEEPTHRESHOLD: "सोने की सीमा प्राप्त करें",
  T_46_META_WS_GETTOKENCOUNT: "टोकन की संख्या प्राप्त करें",
  T_46_META_WS_GETTOKENCOUNTTODAY: "आज के टोकन की संख्या प्राप्त करें",
  T_46_META_WS_GETTYPE: "प्रकार प्राप्त करें",
  T_46_META_WS_GETVEHICLESKIN: "वाहन की त्वचा प्राप्त करें",
  T_46_META_WS_GETWALLET: "वॉलेट प्राप्त करें",
  T_46_META_WS_GETWEAPONSKIN: "हथियार की त्वचा प्राप्त करें",
  T_46_META_WS_GETWIDGETBYPATH: "पथ द्वारा विजेट प्राप्त करें",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "कस्टम UI से विजेट प्राप्त करें",
  T_46_META_WS_GIVEJAILBREAKITEM: "जेलब्रेक आइटम दें",
  T_46_META_WS_GIVEJAILBREAKREWARD: "जेलब्रेक इनाम दें",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI विशेष अनुसरण है या नहीं",
  T_46_META_WS_HASCOMPONENT: "घटक मौजूद है",
  T_46_META_WS_HASSCRIPT: "स्क्रिप्ट मौजूद है या नहीं",
  T_46_META_WS_HASTAG: "टैग मौजूद है या नहीं",
  T_46_META_WS_HELPEDPLAYER: "सहायता प्राप्त खिलाड़ी",
  T_46_META_WS_HELPPLAYER: "सहायक खिलाड़ी",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "रूप बदलने वाला समूह छुपाएँ",
  T_46_META_WS_HITENTITY: "हिट इकाई",
  T_46_META_WS_HITFLY: "उड़ाएं",
  T_46_META_WS_HITNORMAL: "हिट सामान्य",
  T_46_META_WS_HITOBJECT: "हिट ऑब्जेक्ट",
  T_46_META_WS_HITPOSITION: "प्रहार स्थिति",
  T_46_META_WS_INDEXOF: "तत्व की पहली उपस्थिति प्राप्त करें",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "संक्रमण ज़ोंबी बढ़ना",
  T_46_META_WS_INSERT: "सम्मिलित करें",
  T_46_META_WS_ISATTACKABLE: "आक्रमण योग्य है या नहीं",
  T_46_META_WS_ISCHATCHANNELEMPTY: "क्या चैट चैनल खाली है",
  T_46_META_WS_ISEQUAL: "समान है",
  T_46_META_WS_ISFRIEND: "दोस्त है या नहीं",
  T_46_META_WS_ISHIT: "क्या मारा गया",
  T_46_META_WS_ISINSIDEBOX: "बॉक्स में है",
  T_46_META_WS_ISINSIDECYLINDER: "सिलेंडर में है",
  T_46_META_WS_ISINSIDESECTOR: "सेक्टर में है",
  T_46_META_WS_ISINSIDESPHERE: "गोलाकार में है",
  T_46_META_WS_ISSLEEPING: "क्या सोया हुआ है",
  T_46_META_WS_ISSUBTYPEOF: "उपप्रकार है",
  T_46_META_WS_ITEM: "इकाई",
  T_46_META_WS_ITEMID: "आइटम आईडी",
  T_46_META_WS_JOIN: "जोड़ें",
  T_46_META_WS_JOINCHATCHANNEL: "चैट चैनल में शामिल हों",
  T_46_META_WS_JOINFACTION: "गुट में शामिल हों",
  T_46_META_WS_LASTINDEXOF: "तत्व की अंतिम उपस्थिति प्राप्त करें",
  T_46_META_WS_LENGTH: "लंबाई",
  T_46_META_WS_LERP: "लerp",
  T_46_META_WS_LOADSCENE: "सीन लोड करें",
  T_46_META_WS_LOGARITHM: "लॉगरिथम",
  T_46_META_WS_LOGERROR: "त्रुटि लॉग",
  T_46_META_WS_LOGINFO: "लॉग जानकारी",
  T_46_META_WS_LOGWARNING: "चेतावनी लॉग",
  T_46_META_WS_LOOKROTATION: "लक्ष्य की दिशा में घुमाव",
  T_46_META_WS_MAGNITUDE: "परिमाण",
  T_46_META_WS_MAKER: "निर्माता",
  T_46_META_WS_MAX: "अधिकतम",
  T_46_META_WS_MECHANISM: "मैकेनिज्म",
  T_46_META_WS_MIN: "न्यूनतम",
  T_46_META_WS_MONSTERUSESKILL: "स्किल का उपयोग करें",
  T_46_META_WS_MORPHOBJECT: "रूपांतरित वस्तु",
  T_46_META_WS_MORPHTO: "रूपांतरित करें",
  T_46_META_WS_MORPHTOBYITEMID: "आइटम ID द्वारा रूपांतरण",
  T_46_META_WS_MOVECCT: "CCT को स्थानांतरित करें",
  T_46_META_WS_MOVEPOSITION: "स्थिति स्थानांतरित करें",
  T_46_META_WS_MOVEROTATION: "घूर्णन स्थानांतरित करें",
  T_46_META_WS_MULTIPLYQUATERNION: "क्वाटरनियन गुणा",
  T_46_META_WS_MULTIRAYCAST: "मल्टी-रीकास्ट",
  T_46_META_WS_NEGATE: "नकारात्मक",
  T_46_META_WS_NEW: "नया",
  T_46_META_WS_NODENAME: "नोड नाम",
  T_46_META_WS_NORMALIZE: "सामान्य बनाएं",
  T_46_META_WS_NOTIFYPLAYEFFECT: "प्रभाव चलाने की सूचना दें",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "आइकन एनिमेशन की अधिसूचना",
  T_46_META_WS_NOTIFYPLAYSOUND: "ध्वनि चलाने की सूचना दें",
  T_46_META_WS_NOTIFYSHOWTIPS: "सुझाव दिखाने की सूचना दें",
  T_46_META_WS_NUMTOSTRING: "संख्या को स्ट्रिंग में बदलें",
  T_46_META_WS_ONACCESSEQUIPMENT: "उपकरण का उपयोग करें",
  T_46_META_WS_ONACCESSITEM: "आइटम का उपयोग करें",
  T_46_META_WS_ONACCESSWEAPON: "हथियार का उपयोग करें",
  T_46_META_WS_ONACE: "ACE किया गया",
  T_46_META_WS_ONAIMED: "लक्ष्य साधा गया",
  T_46_META_WS_ONAIMING: "लक्ष्य साधा जा रहा है",
  T_46_META_WS_ONASSIST: "सहायता",
  T_46_META_WS_ONATTACK: "हमला",
  T_46_META_WS_ONATTACKSTOP: "हमला रोकें",
  T_46_META_WS_ONAWAKE: "जाग्रत",
  T_46_META_WS_ONBEKNOCKEDDOWN: "गिरा दिया गया",
  T_46_META_WS_ONBOUNCEDBYTIRE: "टायर से उछला",
  T_46_META_WS_ONBOUNCEENTITY: "इकाई उछली",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "इन-बिल्ट UI बटन दबाया गया",
  T_46_META_WS_ONBULLETHIT: "गोली मारी गई",
  T_46_META_WS_ONCAMERARAYCAST: "कैमरा रेयकास्ट",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "चरित्र नियंत्रक मारा गया",
  T_46_META_WS_ONCHASE: "पीछा",
  T_46_META_WS_ONCHASESTOP: "पीछा रोकें",
  T_46_META_WS_ONCLIPEND: "क्लिप समाप्त हुआ",
  T_46_META_WS_ONCOLLISIONENTER: "संघर्ष प्रारंभ",
  T_46_META_WS_ONCOLLISIONEXIT: "संघर्ष समाप्त",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "काउंटडाउन समाप्त हुआ",
  T_46_META_WS_ONCREEP: "रेंगना",
  T_46_META_WS_ONCROUCH: "झुकना",
  T_46_META_WS_ONDEALDAMAGE: "नुकसान देना",
  T_46_META_WS_ONDESTROY: "नष्ट करें",
  T_46_META_WS_ONDISABLE: "निष्क्रिय करें",
  T_46_META_WS_ONDISCONNECT: "डिस्कनेक्ट किया गया",
  T_46_META_WS_ONDOUBLETAPPED: "डबल टैप किया गया",
  T_46_META_WS_ONDRAG: "ड्रैग किया गया",
  T_46_META_WS_ONDRAGEND: "ड्रैग समाप्त हुआ",
  T_46_META_WS_ONDRAGSTART: "ड्रैग शुरू हुआ",
  T_46_META_WS_ONDRIVED: "चालित किया गया",
  T_46_META_WS_ONDRIVEVEHICLE: "वाहन चलाएं",
  T_46_META_WS_ONDROPCONSUMABLE: "उपभोज्य सामग्री गिराई गई",
  T_46_META_WS_ONDROPPED: "गिराया गया",
  T_46_META_WS_ONDROPWEAPON: "हथियार गिराया गया",
  T_46_META_WS_ONEACHLOOP: "प्रत्येक लूप",
  T_46_META_WS_ONELIMINATE: "समाप्त करना",
  T_46_META_WS_ONELIMINATED: "समाप्त",
  T_46_META_WS_ONENABLE: "सक्रिय करें",
  T_46_META_WS_ONEND: "समाप्त",
  T_46_META_WS_ONENTERED: "प्रवेश किया",
  T_46_META_WS_ONENTERVEHICLE: "वाहन में प्रवेश करें",
  T_46_META_WS_ONENTITYENTER: "ट्रिगर पर एंटर",
  T_46_META_WS_ONENTITYEXIT: "ट्रिगर पर छोड़ें",
  T_46_META_WS_ONEQUIPARMOR: "आर्मर पहनें",
  T_46_META_WS_ONEQUIPED: "सुसज्जित किया गया",
  T_46_META_WS_ONEQUIPWEAPON: "हथियार पहनें",
  T_46_META_WS_ONEXPLODE: "विस्फोट हुआ",
  T_46_META_WS_ONFALL: "गिरने पर",
  T_46_META_WS_ONFALLSTOP: "गिरने पर रुकें",
  T_46_META_WS_ONFIRE: "गोली चलाओ",
  T_46_META_WS_ONFIXEDUPDATE: "फिक्स्ड अपडेट",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "फुटबॉल से टक्कर हुई",
  T_46_META_WS_ONFRIENDSUPDATE: "मित्रता की स्थिति अपडेट करें ",
  T_46_META_WS_ONGAMEEND: "खेल समाप्त",
  T_46_META_WS_ONGAMEPAUSE: "खेल रोकें",
  T_46_META_WS_ONGAMERESUME: "खेल पुनः शुरू करें",
  T_46_META_WS_ONGAMESTART: "खेल शुरू",
  T_46_META_WS_ONGOAL: "गोल",
  T_46_META_WS_ONHITBYBULLET: "गोली से मारा गया",
  T_46_META_WS_ONHITFLY: "उड़ान में मारा",
  T_46_META_WS_ONHITFLYENTITY: "उड़ती इकाई को मारा",
  T_46_META_WS_ONHOOKGUNFIRE: "हुक गन फायर किया गया",
  T_46_META_WS_ONIDLE: "निष्क्रिय",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "जेल ब्रेक क्षेत्र शुरू हुआ",
  T_46_META_WS_ONJAILBREAKAREAEND: "जेल ब्रेक क्षेत्र समाप्त हुआ",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "जेल ब्रेक खिलाड़ी शामिल हुआ",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "जेल ब्रेक खिलाड़ी ने छोड़ा",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "चैट चैनल में सफलतापूर्वक शामिल हुआ",
  T_46_META_WS_ONJOYSTICKMOVE: "जॉयस्टिक हिला",
  T_46_META_WS_ONJOYSTICKPRESSED: "दबाया गया",
  T_46_META_WS_ONJOYSTICKRELEASED: "छोड़ा गया",
  T_46_META_WS_ONJUMP: "कूद",
  T_46_META_WS_ONJUMPSTOP: "कूदने पर रुकें",
  T_46_META_WS_ONLANDMINEACTIVE: "लैंडमाइन सक्रिय हुआ",
  T_46_META_WS_ONLANDMINETRIGGER: "लैंडमाइन ट्रिगर हुआ",
  T_46_META_WS_ONLEAVECHATCHANNEL: "चैट चैनल छोड़ा गया",
  T_46_META_WS_ONLEAVEVEHICLE: "वाहन से बाहर निकले",
  T_46_META_WS_ONLEFT: "छोड़ा",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "स्तर वस्तु को मोर्फ करें",
  T_46_META_WS_ONMOVE: "चला",
  T_46_META_WS_ONNODEENTER: "नोड में प्रवेश किया",
  T_46_META_WS_ONNODEEXIT: "नोड से बाहर निकला",
  T_46_META_WS_ONPAUSE: "रोकें",
  T_46_META_WS_ONPHASEEND: "चरण समाप्त",
  T_46_META_WS_ONPHASESTART: "चरण शुरू",
  T_46_META_WS_ONPICKEDUP: "उठाया गया",
  T_46_META_WS_ONPLAYERASSIST: "खिलाड़ी ने सहायता की",
  T_46_META_WS_ONPLAYERBEELIMINATED: "खिलाड़ी समाप्त किया गया",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "खिलाड़ी को गिराया गया",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "खिलाड़ी ने नुकसान पहुंचाया",
  T_46_META_WS_ONPLAYERELIMINATE: "खिलाड़ी ने समाप्त किया",
  T_46_META_WS_ONPLAYERENTER: "खिलाड़ी ने प्रवेश किया",
  T_46_META_WS_ONPLAYERJOIN: "खिलाड़ी शामिल हुआ",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "चैट चैनल में शामिल होने में विफल",
  T_46_META_WS_ONPLAYERLEAVE: "खिलाड़ी ने छोड़ा",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "खिलाड़ी ने खरीद का अनुरोध किया",
  T_46_META_WS_ONPLAYERQUIT: "खिलाड़ी के बीच में ही छोड़ने पर",
  T_46_META_WS_ONPLAYERRANKCHANGE: "खिलाड़ी की रैंक बदली",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "खिलाड़ी का अनुरोध पूरा हुआ",
  T_46_META_WS_ONPLAYERREVIVED: "खिलाड़ी पुनर्जीवित हुआ",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "खिलाड़ी को स्पॉन स्थिति में पुनर्जीवित किया गया",
  T_46_META_WS_ONPLAYERSCORECHANGE: "खिलाड़ी का स्कोर बदला",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "खिलाड़ी ने दृश्य स्विच किया",
  T_46_META_WS_ONPREDEALDAMAGE: "नुकसान देने से पहले",
  T_46_META_WS_ONPREPURCHASE: "खरीद से पहले",
  T_46_META_WS_ONPRESSED: "दबाया गया",
  T_46_META_WS_ONPRETAKEDAMAGE: "नुकसान प्राप्त करने से पहले",
  T_46_META_WS_ONPURCHASE: "खरीद",
  T_46_META_WS_ONRANKCHANGED: "इकाई की रैंक बदली",
  T_46_META_WS_ONRECONNECT: "पुनः कनेक्ट किया गया",
  T_46_META_WS_ONRELEASED: "छोड़ा गया",
  T_46_META_WS_ONRELOAD: "रीलोड करें",
  T_46_META_WS_ONRESUME: "पुनः शुरू",
  T_46_META_WS_ONREVIVED: "पुनर्जीवित किया गया",
  T_46_META_WS_ONROUNDEND: "राउंड समाप्त",
  T_46_META_WS_ONROUNDSTART: "राउंड शुरू",
  T_46_META_WS_ONSCENELOAD: "दृश्य लोड हुआ",
  T_46_META_WS_ONSCENESWITCH: "दृश्य बदला गया",
  T_46_META_WS_ONSCORECHANGE: "इकाई का स्कोर बदला",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "फुटबॉल शूटर द्वारा मारा गया",
  T_46_META_WS_ONSLEEP: "सो गया",
  T_46_META_WS_ONSPAWN: "स्पॉन हुआ",
  T_46_META_WS_ONSPRAY: "स्प्रे",
  T_46_META_WS_ONSPRAYED: "स्प्रे किया गया",
  T_46_META_WS_ONSPRINT: "दौड़",
  T_46_META_WS_ONSPRINTSTOP: "दौड़ रोकें",
  T_46_META_WS_ONSTANDUP: "उठो",
  T_46_META_WS_ONSTART: "शुरू",
  T_46_META_WS_ONSTARTFIRE: "हमला",
  T_46_META_WS_ONSTATEEND: "स्थिति समाप्त हुई",
  T_46_META_WS_ONSURFING: "सर्फिंग",
  T_46_META_WS_ONSURFINGSTOP: "सर्फिंग रोकें",
  T_46_META_WS_ONSWITCHHANDHELD: "हैंडहेल्ड स्विच करें",
  T_46_META_WS_ONTAKEDAMAGE: "नुकसान प्राप्त किया",
  T_46_META_WS_ONTAPPED: "टैप किया गया",
  T_46_META_WS_ONTEAMACE: "टीम पूरी तरह समाप्त",
  T_46_META_WS_ONTEAMADD: "टीम जोड़ी गई",
  T_46_META_WS_ONTEAMREMOVE: "टीम को हटाया गया",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "टीम की रैंक बदली",
  T_46_META_WS_ONTEAMSCORECHANGE: "टीम का स्कोर बदला",
  T_46_META_WS_ONTELEPORTENTITY: "इकाई को टेलीपोर्ट करें",
  T_46_META_WS_ONTEXTCHANGE: "पाठ बदला गया",
  T_46_META_WS_ONTHROWABLEEXPLODE: "विस्फोटक फेंका गया",
  T_46_META_WS_ONTOGGLE: "टॉगल किया गया",
  T_46_META_WS_ONTOUCHDOWN: "नीचे टच करें",
  T_46_META_WS_ONTOUCHUP: "ऊपर टच करें",
  T_46_META_WS_ONUIHIDE: "UI छुपाएँ",
  T_46_META_WS_ONUISHOW: "UI दिखाएँ",
  T_46_META_WS_ONUPDATE: "अपडेट किया गया",
  T_46_META_WS_ONUSEAVATARSKILL: "अवतार कौशल का उपयोग करें",
  T_46_META_WS_ONUSECONSUMABLE: "उपभोज्य सामग्री का उपयोग करें",
  T_46_META_WS_ONUSED: "उपयोग किया गया",
  T_46_META_WS_ONUSEPORTAL: "पोर्टल का उपयोग करें",
  T_46_META_WS_ONWAKEUP: "जाग्रत किया गया",
  T_46_META_WS_ONWEAPONBEEQUIPED: "हथियार सुसज्जित हुआ",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "हथियार ने नुकसान पहुंचाया",
  T_46_META_WS_ONWEAPONELIMINATE: "हथियार ने समाप्त किया",
  T_46_META_WS_ONWEAPONSTOPFIRING: "हथियार ने गोली चलाना बंद किया",
  T_46_META_WS_OWNER: "स्वामी",
  T_46_META_WS_P_ACCELERATE: "त्वरण",
  T_46_META_WS_P_ACCELERATION: "त्वरण",
  T_46_META_WS_P_ACCOUNTID: "अकाउंट आईडी",
  T_46_META_WS_P_ACCURACY: "सटीकता",
  T_46_META_WS_P_ACTIONTYPE: "क्रिया प्रकार",
  T_46_META_WS_P_ACTIVATEDALPHA: "सक्रिय अल्फा",
  T_46_META_WS_P_ACTIVE: "सक्रिय",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "हाइरार्की में सक्रिय",
  T_46_META_WS_P_ACTIVESELF: "सक्रिय आत्म",
  T_46_META_WS_P_ACTIVETEXT: "सक्रिय टेक्स्ट",
  T_46_META_WS_P_ACTUALPOSITION: "वास्तविक स्थिति",
  T_46_META_WS_P_AFTERACCUMULATOR: "बाद की गणना",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "लक्ष्य सहायक केंद्र परिवर्तन",
  T_46_META_WS_P_AIMASSISTDISTANCE: "लक्ष्य सहायक दूरी",
  T_46_META_WS_P_AIMASSISTTYPE: "दृष्टि सहायक",
  T_46_META_WS_P_AIRDROPSTATE: "एयर ड्रॉप स्टेट",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "क्षैतिज संरेखण",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "लंबवत संरेखण",
  T_46_META_WS_P_ALLITEMS: "सभी वस्तुएं",
  T_46_META_WS_P_ALLMEMBERS: "सभी सदस्य",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "सहायक द्वारा लॉक की अनुमति दें",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "बाहर दबाने की अनुमति",
  T_46_META_WS_P_ALLPLAYERS: "सभी खिलाड़ी",
  T_46_META_WS_P_ALLTEAMMATES: "सभी साथी",
  T_46_META_WS_P_ALPHA: "अल्फा",
  T_46_META_WS_P_ALWAYSSHOWMARK: "हमेशा मार्क दिखाएं",
  T_46_META_WS_P_AMBIENTCOLOR: "परिवेश रंग",
  T_46_META_WS_P_AMMOCLIPSIZE: "गोला-बारूद क्लिप आकार",
  T_46_META_WS_P_AMMOMAGSIZE: "गोलियों की मैग साइज",
  T_46_META_WS_P_AMMOPERSHOT: "प्रति शॉट गोला बारूद",
  T_46_META_WS_P_AMMOTYPE: "गोला बारूद प्रकार",
  T_46_META_WS_P_ANCHORMAX: "एंकर अधिकतम",
  T_46_META_WS_P_ANCHORMIN: "एंकर न्यूनतम",
  T_46_META_WS_P_ANCHOROBJECT: "एंकर वस्तु",
  T_46_META_WS_P_ANCHORPOSITION: "एंकर स्थिति",
  T_46_META_WS_P_ANCHORTYPE: "UITweener स्क्रिप्ट सक्षम",
  T_46_META_WS_P_ANGLE: "कोण",
  T_46_META_WS_P_ANGLEDOWN: "नीचे कोण",
  T_46_META_WS_P_ANGLEUP: "ऊपर कोण",
  T_46_META_WS_P_ANGULARDRAG: "कोणीय ड्रैग",
  T_46_META_WS_P_ANGULARSPEED: "कोणीय गति",
  T_46_META_WS_P_ANGULARVELOCITY: "कोणीय वेग (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "एनिमेशन नाम",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "एनीमेशन कंट्रोलर",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "एनीमेशन कंट्रोलर संसाधन आईडी",
  T_46_META_WS_P_ARMORPENETRATION: "कवच प्रवेश",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "आर्मर पेनिट्रेशन फैक्टर",
  T_46_META_WS_P_ARMORTYPE: "आर्मर प्रकार",
  T_46_META_WS_P_ARROWOFFSET: "तीर ऑफ़सेट",
  T_46_META_WS_P_ARROWSIZE: "तीर आकार",
  T_46_META_WS_P_ARROWSPRITE: "तीर स्प्राइट",
  T_46_META_WS_P_ASKBUYTARGET: "लक्ष्य खरीदने का अनुरोध",
  T_46_META_WS_P_ATTACHTARGET: "अटैच टारगेट",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "हमला करने योग्य गुट",
  T_46_META_WS_P_ATTACKDAMAGE: "आक्रमण क्षति",
  T_46_META_WS_P_ATTACKINTERVAL: "हमले का अंतराल",
  T_46_META_WS_P_ATTACKRANGE: "हमला की सीमा",
  T_46_META_WS_P_ATTACKTARGET: "आक्रमण लक्ष्य",
  T_46_META_WS_P_ATTTACKABLETARGETS: "आक्रमण के लिए लक्षित वस्तुएं",
  T_46_META_WS_P_AUTOPLAY: "स्वचालित चलाने की स्थिति",
  T_46_META_WS_P_AVAILABLEPOINT: "उपलब्ध बिंदु",
  T_46_META_WS_P_AVATAR: "अवतार",
  T_46_META_WS_P_AVATARID: "अवतार आईडी",
  T_46_META_WS_P_BACKGROUND: "बैकग्राउंड",
  T_46_META_WS_P_BACKGROUNDALPHA: "पृष्ठभूमि अल्फा",
  T_46_META_WS_P_BACKGROUNDCOLOR: "पृष्ठभूमि रंग",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "बैकग्राउंड कलर 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "बैकग्राउंड कलर 2",
  T_46_META_WS_P_BACKGROUNDFILL: "पृष्ठभूमि भरें",
  T_46_META_WS_P_BACKGROUNDICONNAME: "पृष्ठभूमि आइकॉन नाम",
  T_46_META_WS_P_BACKGROUNDNAME: "पृष्ठभूमि नाम",
  T_46_META_WS_P_BACKGROUNDOFFSET: "पृष्ठभूमि ऑफ़सेट",
  T_46_META_WS_P_BACKGROUNDRADIUS: "पृष्ठभूमि त्रिज्या",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "पृष्ठभूमि आकार डेल्टा",
  T_46_META_WS_P_BACKGROUNDSPRITE: "पृष्ठभूमि स्प्राइट",
  T_46_META_WS_P_BACKPACK: "बैकपैक",
  T_46_META_WS_P_BACKPACKSKINID: "बैग स्किन आईडी",
  T_46_META_WS_P_BACKWARDSPEED: "बैकवर्ड स्पीड",
  T_46_META_WS_P_BANNERID: "बैनर आईडी",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "आधार क्षैतिज गति",
  T_46_META_WS_P_BASEMULTIPLIER: "बेस गुणक",
  T_46_META_WS_P_BASETIME: "आधार समय",
  T_46_META_WS_P_BASEVERTICALSPEED: "आधार ऊर्ध्वाधर गति",
  T_46_META_WS_P_BEFOREACCUMULATOR: "पूर्व की गणना",
  T_46_META_WS_P_BEVTREEID: "व्यवहार वृक्ष ID",
  T_46_META_WS_P_BINDPROPERTYID: "बाइंड प्रॉपर्टी आईडी",
  T_46_META_WS_P_BODY: "धड़",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "शरीर को होने वाला नुकसान गुणांक",
  T_46_META_WS_P_BONEPOSITION: "हड्डी की स्थिति",
  T_46_META_WS_P_BONESCALE: "हड्डी का आकार",
  T_46_META_WS_P_BOOSTCD: "बूस्ट कूलडाउन",
  T_46_META_WS_P_BOOSTDURATION: "बूस्ट की अवधि",
  T_46_META_WS_P_BOOSTSPEED: "बूस्ट की गति",
  T_46_META_WS_P_BORDERLR: "बाएं और दाएं सीमा",
  T_46_META_WS_P_BORDERTB: "ऊपर और नीचे की सीमा",
  T_46_META_WS_P_BOTTOMALPHA: "नीचे का अल्फा",
  T_46_META_WS_P_BOUNDWALLET: "HUD एंकर प्रकार",
  T_46_META_WS_P_BRAKEHORSEPOWER: "ब्रेक की शक्ति",
  T_46_META_WS_P_BRAKETORQUE: "ब्रेक टॉर्क",
  T_46_META_WS_P_BRRANK: "BR रैंक",
  T_46_META_WS_P_BUFFTYPE: "बफ प्रकार",
  T_46_META_WS_P_BURNDAMAGE: "जलने की क्षति",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "जलने की क्षति अंतराल",
  T_46_META_WS_P_BURNTIME: "जलने का समय",
  T_46_META_WS_P_BUTTOM: "नीचे",
  T_46_META_WS_P_BUTTONCOLORS: "बटन रंग",
  T_46_META_WS_P_BUTTONNAMES: "बटन नाम",
  T_46_META_WS_P_BUTTONSTYLE: "बटन शैली",
  T_46_META_WS_P_CAMERABLOCKMODE: "कैमरा ब्लॉक मोड",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "कैमरा प्रक्षिप्ति मोड",
  T_46_META_WS_P_CAMERATYPE: "कैमरा",
  T_46_META_WS_P_CANCELDRAGIFFITS: "फिट करने पर खींचना रद्द करें",
  T_46_META_WS_P_CANCOSTDURABILITY: "ड्यूरेबिलिटी की लागत हो सकती है",
  T_46_META_WS_P_CANDAMAGED: "हानि हो सकती है",
  T_46_META_WS_P_CANDESTROY: "नष्ट किया जा सकता है",
  T_46_META_WS_P_CANDESTROYED: "नष्ट हो सकता है",
  T_46_META_WS_P_CANSELFTRIGGER: "स्वयं ट्रिगर कर सकता है",
  T_46_META_WS_P_CANTEAMTRIGGER: "टीम द्वारा ट्रिगर किया जा सकता है",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "ख़ुद से ट्रिगर किया जा सकता है",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "टीम द्वारा ट्रिगर किया जा सकता है",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "वाहन द्वारा ट्रिगर किया जा सकता है",
  T_46_META_WS_P_CANVEHICLETRIGGER: "वाहन द्वारा ट्रिगर किया जा सकता है",
  T_46_META_WS_P_CELLSIZE: "सेल आकार",
  T_46_META_WS_P_CELLSPACE: "सेल अंतराल",
  T_46_META_WS_P_CENTER: "सेंटर",
  T_46_META_WS_P_CENTERINVISIBLE: "केंद्र अदृश्य",
  T_46_META_WS_P_CENTEROFFSET: "केंद्र ऑफ़सेट",
  T_46_META_WS_P_CENTEROFMASS: "सेंटर ऑफ़ मास",
  T_46_META_WS_P_CENTERRANGE: "केंद्रीय दायरा",
  T_46_META_WS_P_CENTRALFLASHTIME: "किनारे की चमक का समय",
  T_46_META_WS_P_CENTRALLINEACTIVE: "केंद्रीय रेखा सक्रिय",
  T_46_META_WS_P_CENTRALLINEPOSITION: "केंद्रीय रेखा स्थिति",
  T_46_META_WS_P_CHANNELID: "चैट चैनल ID",
  T_46_META_WS_P_CHARGEMAX: "अधिकतम चार्ज",
  T_46_META_WS_P_CHASETARGET: "शिकार लक्ष्य",
  T_46_META_WS_P_CHATCHANNEL: "चैट चैनल",
  T_46_META_WS_P_CHECKPOINTID: "चेकपॉइंट आईडी",
  T_46_META_WS_P_CHILDINDEX: "बच्चे की अनुक्रमणिका",
  T_46_META_WS_P_CHIPEXP: "चिप अनुभव",
  T_46_META_WS_P_CLICKSIZE: "क्लिक आकार",
  T_46_META_WS_P_CLIPLENGTH: "क्लिप लंबाई",
  T_46_META_WS_P_CLIPPINGTYPE: "क्लिपिंग प्रकार",
  T_46_META_WS_P_COLLIDERID: "कोलाइडर ID",
  T_46_META_WS_P_CONSTRAIN: "प्रतिबंध",
  T_46_META_WS_P_CONSTRAINT: "प्रतिबंध",
  T_46_META_WS_P_CONSTRAINTCOUNT: "प्रतिबंध की संख्या",
  T_46_META_WS_P_CONSUMABLETYPE: "उपभोग्य वस्तु प्रकार",
  T_46_META_WS_P_CONTENT: "सामग्री",
  T_46_META_WS_P_CONTENTORIGIN: "सामग्री मूल",
  T_46_META_WS_P_CONTROLPOINTS: "नियंत्रण बिंदु",
  T_46_META_WS_P_COORDINATESYSTEM: "निर्देशांक प्रणाली",
  T_46_META_WS_P_COUNT: "मात्रा",
  T_46_META_WS_P_COUNTDOWNENDTIME: "काउंटडाउन एंड टाइम (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "काउंटडाउन कुंजी",
  T_46_META_WS_P_COUNTDOWNTIME: "काउंटडाउन समय",
  T_46_META_WS_P_COUNTPERWAVE: "प्रति लहर की गणना",
  T_46_META_WS_P_CRASHMAXDAMAGE: "अधिकतम क्रैश डैमेज",
  T_46_META_WS_P_CRASHMAXSPEED: "क्रैश मैक्स स्पीड",
  T_46_META_WS_P_CRASHMESSFACTOR: "क्रैश मास फैक्टर",
  T_46_META_WS_P_CRASHMINDAMAGE: "न्यूनतम क्रैश डैमेज",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "रेंगने की गति माप",
  T_46_META_WS_P_CREATEDENTITY: "बनाई गई इकाई",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "झुकने की गति माप",
  T_46_META_WS_P_CSRANK: "CS रैंक",
  "T_46_META_WS_P_CURRENT AMMO": "वर्तमान गोला-बारूद",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "वर्तमान एनिमेशन संसाधन",
  T_46_META_WS_P_CURRENTCLIP: "वर्तमान क्लिप",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "वर्तमान क्लिप प्रगति",
  T_46_META_WS_P_CURRENTDURABILITY: "वर्तमान टिकाऊपन",
  T_46_META_WS_P_CURRENTENERGY: "वर्तमान ऊर्जा",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "वर्तमान हाथ में वस्तु",
  T_46_META_WS_P_CURRENTHP: "वर्तमान HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "वर्तमान चरण सूचकांक",
  T_46_META_WS_P_CURRENTPROGRESS: "वर्तमान प्रगति",
  T_46_META_WS_P_CURRENTROUNDINDEX: "वर्तमान राउंड सूचकांक",
  T_46_META_WS_P_CURRENTSTATE: "वर्तमान स्थिति",
  T_46_META_WS_P_CURRENTVALUE: "वर्तमान मान",
  T_46_META_WS_P_CURRENTWAVE: "वर्तमान लहर",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "कस्टम पात्र संसाधन",
  T_46_META_WS_P_CUSTOMGAMERESULT: "कस्टम गेम परिणाम",
  T_46_META_WS_P_CUSTOMGRAVITY: "कस्टम गुरुत्वाकर्षण",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "कस्टम पुश फोर्स",
  T_46_META_WS_P_CUSTOMXY: "कस्टम XY",
  T_46_META_WS_P_DAMAGE: "क्षति",
  "T_46_META_WS_P_DAMAGE RANGE": "सीमा",
  T_46_META_WS_P_DAMAGEFACTOR: "क्षति गुणक",
  T_46_META_WS_P_DAMAGEINTERVAL: "डैमेज इंटरवल (s)",
  T_46_META_WS_P_DAMAGERADIUS: "क्षति त्रिज्या",
  T_46_META_WS_P_DAMAGERATIOHEAD: "सिर क्षति अनुपात",
  T_46_META_WS_P_DAMAGERATIOLIMB: "अंग क्षति अनुपात",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "क्षति में कमी कारक",
  T_46_META_WS_P_DAMAGETAKENPCT: "डैमेज लिए जाने का प्रतिशत",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "प्राप्त नुकसान प्रतिशत",
  T_46_META_WS_P_DAMAGEVALUE: "डैमेज वैल्यू",
  T_46_META_WS_P_DARKNESS: "अंधकार",
  T_46_META_WS_P_DECELERATIONPERCENT: "डिसेलरैशन प्रतिशत",
  T_46_META_WS_P_DEFAULTTEXT: "डिफ़ॉल्ट टेक्स्ट",
  T_46_META_WS_P_DEFENSE: "रक्षा दर",
  T_46_META_WS_P_DEFENSERATE: "रक्षा दर",
  T_46_META_WS_P_DELTA: "डेल्टा",
  T_46_META_WS_P_DELTATIME: "डेल्टा समय",
  T_46_META_WS_P_DELTAVALUE: "डेल्टा मान",
  T_46_META_WS_P_DEPTH: "गहराई",
  T_46_META_WS_P_DESC: "विवरण",
  T_46_META_WS_P_DESCRIPTION: "विवरण",
  T_46_META_WS_P_DESCRIPTIONKEY: "विवरण कुंजी",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "टिप्स विवरण पैरामीटर",
  T_46_META_WS_P_DESTVAL: "गंतव्य मान",
  T_46_META_WS_P_DETECTRANGE: "पता लगाने की सीमा",
  T_46_META_WS_P_DIFFUSEALPHA: "प्रसार एल्पा",
  T_46_META_WS_P_DIFFUSECOLOR: "प्रसार रंग",
  T_46_META_WS_P_DIFFUSETEXTURE: "प्रसार बनावट",
  T_46_META_WS_P_DISABLECOLOR: "अक्षम रंग",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "गिरने की क्षति बंद करें",
  T_46_META_WS_P_DISABLEITEMDROP: "आइटम छोड़ने से मना करें",
  T_46_META_WS_P_DISABLEITEMPICKUP: "आइटम उठाने से मना करें",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "मैन्युअल बंद करना अक्षम करें",
  T_46_META_WS_P_DISABLEQUICKCHAT: "त्वरित चैट बंद करें",
  T_46_META_WS_P_DISABLERECIPROCATING: "पलटा मोशन अक्षम",
  T_46_META_WS_P_DISABLEVOICECHAT: "वॉयस चैट बंद करें",
  T_46_META_WS_P_DISTANCE: "दूरी",
  T_46_META_WS_P_DOUBLEGUNTYPE: "डबल गन प्रकार",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "रेंगने की गति माप",
  T_46_META_WS_P_DOWNSPEED: "डाउन स्पीड",
  T_46_META_WS_P_DRAG: "ड्रैग",
  T_46_META_WS_P_DRIVER: "चालक",
  T_46_META_WS_P_DROPITEMS: "ड्रॉप आइटम्स",
  T_46_META_WS_P_DURABILITY: "स्थिरता",
  T_46_META_WS_P_DURABILITYRECOVERY: "स्थायीत्व रिकवरी",
  T_46_META_WS_P_DURATION: "अवधि",
  T_46_META_WS_P_EDGEFLASHTIME: "फ्लैशबैंक हिट इफेक्ट स्विच",
  T_46_META_WS_P_EFFECTACTIVE: "इफेक्ट एक्टिव",
  T_46_META_WS_P_EFFECTCOLOR: "इफेक्ट कलर",
  T_46_META_WS_P_EFFECTDURATION: "ट्रिगर समय",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "प्रभावी समय अंतराल",
  T_46_META_WS_P_EFFECTRESID: "प्रभाव संसाधन पथ",
  T_46_META_WS_P_ENABLE: "सक्षम करें",
  T_46_META_WS_P_ENABLEATTACK: "हमले को सक्षम करें",
  T_46_META_WS_P_ENABLEBOTREVIVE: "बॉट पुनर्जीवित करें",
  T_46_META_WS_P_ENABLEDEPTHMAP: "डेप्थ मैप एनेबल",
  T_46_META_WS_P_ENABLEDROPONDEATH: "मृत्यु पर गिरावट सक्षम है या नहीं",
  T_46_META_WS_P_ENABLELOCALIZATION: "स्थानीयकरण सक्षम करें",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "हवा में मूवमेंट को सक्षम करें",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "खिलाड़ी को पुनर्जीवित करने की अनुमति दें",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "प्लेयर व्यू सक्षम करें",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "गुरुत्वाकर्षण के साथ घुमाव सक्षम करें",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "स्किन विशेषताएँ सक्षम करें",
  T_46_META_WS_P_ENABLESWINGING: "झूलने को सक्षम करें",
  T_46_META_WS_P_ENABLETRACTION: "खींचने को सक्षम करें",
  T_46_META_WS_P_ENDPOSITION: "अंत स्थिति",
  T_46_META_WS_P_ENDRADIUS: "एंड रेडियस",
  T_46_META_WS_P_ENDTIME: "एंड टाइम (s)",
  T_46_META_WS_P_ENDTIMES: "समाप्ति समय",
  T_46_META_WS_P_ENDVALUE: "अंतिम मान",
  T_46_META_WS_P_ENERGY: "ऊर्जा",
  T_46_META_WS_P_ENERGYCOST: "ऊर्जा लागत",
  T_46_META_WS_P_ENERGYRECOVERY: "ऊर्जा पुनर्प्राप्ति",
  T_46_META_WS_P_ENGINEHORSEPOWER: "इंजन की शक्ति",
  T_46_META_WS_P_ENGINETORQUE: "इंजन टॉर्क",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "अधिकतम EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP पुनर्प्राप्ति मात्रा",
  T_46_META_WS_P_EVENTS: "इवेंट्स",
  T_46_META_WS_P_EXPLODEDAMAGE: "विस्फोट क्षति",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "विस्फोट क्षति कमी कारक",
  T_46_META_WS_P_EXPLODEDELAY: "विस्फोट विलंब",
  T_46_META_WS_P_EXPLODERANGE: "विस्फोट की सीमा",
  T_46_META_WS_P_EXPLOSIONDELAY: "केंद्रीय फ्लैश समय",
  T_46_META_WS_P_EXPLOSIONRANGE: "विस्फोट की सीमा",
  T_46_META_WS_P_EXPLOSIONTIME: "विस्फोट की देरी",
  T_46_META_WS_P_EXPPERDAMAGE: "प्रति नुकसान अनुभव",
  T_46_META_WS_P_EXPPERMOVEMILE: "प्रति दूरी अनुभव",
  T_46_META_WS_P_EXPPERSECOND: "प्रति सेकंड अनुभव",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "अतिरिक्त बैकपैक क्षमता",
  T_46_META_WS_P_EXTRABAGCAPACITY: "अतिरिक्त बैकपैक स्थान",
  T_46_META_WS_P_EXTRAHPRATIO: "अतिरिक्त HP अनुपात",
  T_46_META_WS_P_FACEPAINT: "मेकअप",
  T_46_META_WS_P_FACTION: "गुट",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "गिरने की क्षति अनुपात",
  T_46_META_WS_P_FALLSPEED: "गिरने की गति",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "स्वचालित पुनः लोड गति",
  T_46_META_WS_P_FILEID: "फ़ाइल आईडी",
  T_46_META_WS_P_FILL: "भरें",
  T_46_META_WS_P_FILLAMOUNT: "भरने की मात्रा",
  T_46_META_WS_P_FILLDIRECTION: "भरने की दिशा",
  T_46_META_WS_P_FILLTYPE: "भरने का प्रकार",
  T_46_META_WS_P_FIREANGLELIMIT: "आग सीमा",
  T_46_META_WS_P_FIRETYPE: "फायर प्रकार",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "पहला स्कोर पैरामीटर",
  T_46_META_WS_P_FIRSTSCORETITLE: "पहला स्कोर शीर्षक",
  T_46_META_WS_P_FIRSTSCOREVALUE: "पहला स्कोर मान",
  T_46_META_WS_P_FIXEDDELTATIME: "निश्चित डेल्टा समय",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "प्रभाव की अवधि",
  T_46_META_WS_P_FLIP: "फ्लिप",
  T_46_META_WS_P_FLIPTYPE: "फ्लिप प्रकार",
  T_46_META_WS_P_FLYMAXHEIGHT: "अधिकतम उडान ऊँचाई",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "क्षैतिज उड़ान गति",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "ऊर्ध्वाधर उड़ान गति",
  T_46_META_WS_P_FOGCOLOR: "धुंध का रंग",
  T_46_META_WS_P_FOLLOWTARGET: "लक्ष्य का पालन करें",
  T_46_META_WS_P_FONT: "फॉन्ट",
  T_46_META_WS_P_FONTSIZE: "फ़ॉन्ट आकार",
  T_46_META_WS_P_FONTSTYLE: "फ़ॉन्ट शैली",
  T_46_META_WS_P_FONTTYPE: "फ़ॉन्ट प्रकार",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "क्लाइंट को फ़ोर्स  सिंक करें",
  T_46_META_WS_P_FORWARD: "आगे",
  T_46_META_WS_P_FORWARDSPEED: "फॉरवर्ड स्पीड",
  T_46_META_WS_P_FOV: "दृष्टिकोण क्षेत्र",
  T_46_META_WS_P_FREEZEDURATION: "ठंड अवधि (सेकंड)",
  T_46_META_WS_P_FRIENDFACTIONS: "फ्रेंडली फ़ैक्शंस",
  T_46_META_WS_P_FRIENDLYPLAYERS: "दोस्त खिलाड़ी",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "पूर्ण क्षति की दूरी",
  T_46_META_WS_P_FUNCTIONTYPE: "फ़ंक्शन प्रकार",
  T_46_META_WS_P_GAINHPCOLOR: "गेन HP कलर",
  T_46_META_WS_P_GAMEFRAMECOUNT: "कुल फ्रेम की संख्या",
  T_46_META_WS_P_GAMETIMECOUNT: "खेल का समय",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "गियर शिफ्ट विलंब",
  T_46_META_WS_P_GENDER: "लिंग",
  T_46_META_WS_P_GETONBOOSTCD: "बूस्ट पर चढ़ने का कूलडाउन",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "बूस्ट पर चढ़ने का कूलडाउन स्विच",
  T_46_META_WS_P_GETONSKATEBOARDCD: "स्केटबोर्ड पर चढ़ने का कूलडाउन",
  T_46_META_WS_P_GRADIENT: "ग्रेडियंट",
  T_46_META_WS_P_GRADIENTBOTTOM: "ग्रेडियंट नीचे",
  T_46_META_WS_P_GRADIENTTOP: "ग्रेडियंट ऊपर",
  T_46_META_WS_P_GRAVITY: "गुरुत्वाकर्षण",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "ग्रेनेड मैक्स डैमेज",
  T_46_META_WS_P_GRENADEMINDAMAGE: "ग्रेनेड मिन डैमेज",
  T_46_META_WS_P_GRENADERANGE: "ग्रेनेड रेंज",
  T_46_META_WS_P_GROUPID: "समूह ID",
  T_46_META_WS_P_HEAD: "सिर",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "सिर को होने वाला नुकसान गुणांक",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "हेडशॉट डैमेज में कमी",
  T_46_META_WS_P_HEIGHT: "ऊँचाई",
  T_46_META_WS_P_HELMET: "हेलमेट",
  T_46_META_WS_P_HIGHESTBRRANK: "उच्चतम BR रैंक",
  T_46_META_WS_P_HIGHESTCSRANK: "उच्चतम CS रैंक",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "न्यूनतम उन्नयन कोण",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "उच्च गति स्टीयरिंग सीमा",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "उच्च गति स्टीयरिंग सीमा थ्रेसहोल्ड",
  T_46_META_WS_P_HITPOINTEFFECT: "हिट पॉइंट प्रभाव",
  T_46_META_WS_P_HORIZONTALBAR: "क्षैतिज बार",
  T_46_META_WS_P_HORIZONTALOFFSET: "क्षैतिज ऑफ़सेट",
  T_46_META_WS_P_HOSTILETEAMS: "शत्रु टीमें",
  T_46_META_WS_P_HOSTTEAM: "होस्ट टीम",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "अधिकतम HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP पुनर्प्राप्ति मात्रा",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP रिकवरी स्पीड (ms)",
  T_46_META_WS_P_ICON: "आइकन",
  T_46_META_WS_P_ICONCOLOR: "आइकॉन रंग",
  T_46_META_WS_P_ICONNAME: "आइकॉन नाम",
  T_46_META_WS_P_ICONRESOURCE: "आइकॉन रिसोर्स",
  T_46_META_WS_P_ID: "आईडी",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "क्षति अंतराल (सेकंड)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "आइडल ब्रेक इनपुट",
  T_46_META_WS_P_INACTIVATEDALPHA: "अक्रिय अल्फा",
  T_46_META_WS_P_INDEX: "सूचकांक",
  T_46_META_WS_P_INITIALMAGCOUNT: "प्रारंभिक मैग गिनती",
  T_46_META_WS_P_INITIALSPEED: "प्रारंभिक गति",
  T_46_META_WS_P_INITIALVALUE: "इनिशियल वैल्यू",
  T_46_META_WS_P_INITIALWORLDPOSITION: "प्रारंभिक विश्व स्थिति",
  T_46_META_WS_P_INSCENE: "दृश्य में",
  T_46_META_WS_P_INSTANCEID: "इंस्टांस आईडी",
  T_46_META_WS_P_INTENSITY: "तीव्रता",
  T_46_META_WS_P_INVERTFILL: "भरना पलटना",
  T_46_META_WS_P_INVINCIBLE: "अजेय",
  "T_46_META_WS_P_IS SHOW": "दिखा रहा है या नहीं",
  T_46_META_WS_P_IS3D: "3D है या नहीं",
  T_46_META_WS_P_ISACE: "ACE है",
  T_46_META_WS_P_ISACED: "पूरी तरह से समाप्त",
  T_46_META_WS_P_ISAI: "क्या यह AI है?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "हमेशा स्क्रीन पर",
  T_46_META_WS_P_ISAPPLYSHADOW: "शैडो लागू करें",
  T_46_META_WS_P_ISATTACKABLE: "आक्रमणशील",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "ऑटो-चेज दुश्मन है",
  T_46_META_WS_P_ISAUTOPLAY: "ऑटो प्ले",
  T_46_META_WS_P_ISAUTOTELEPORT: "ऑटो टेलीपोर्ट है या नहीं",
  T_46_META_WS_P_ISBILLBOARD: "हमेशा वीडियो में",
  T_46_META_WS_P_ISBOLD: "बोल्ड",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "नीचे टकराव",
  T_46_META_WS_P_ISCENTERPOS: "सेंटर पोजीशन है",
  T_46_META_WS_P_ISCONSUMEAMMO: "गोला-बारूद की खपत",
  T_46_META_WS_P_ISCONTINUOUS: "निरंतर है या नहीं",
  T_46_META_WS_P_ISCOUNTDOWN: "काउंटडाउन है",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "क्या वर्तमान एनिमेशन लूप है?",
  T_46_META_WS_P_ISDEADDROP: "मृत्यु समर्थन",
  T_46_META_WS_P_ISDEATHTRIGGER: "मृत्यु ट्रिगर है या नहीं",
  T_46_META_WS_P_ISDEBUG: "BTree डिबग एनेबल",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "डिफ़ॉल्ट स्पॉन बिंदु है या नहीं",
  T_46_META_WS_P_ISDROPONELIMINATED: "मृत्यु पर सभी उपकरण खो जाते हैं",
  T_46_META_WS_P_ISEND: "समाप्त",
  T_46_META_WS_P_ISFEBUTTON: "FE बटन है",
  T_46_META_WS_P_ISGREY: "ग्रे है",
  T_46_META_WS_P_ISGROUNDED: "ग्राउंडेड है",
  T_46_META_WS_P_ISIGNOREDEPTH: "गहराई को अनदेखा करें",
  T_46_META_WS_P_ISINVINCIBLE: "इन्विंसिबल है",
  T_46_META_WS_P_ISITALIC: "इटैलिक",
  T_46_META_WS_P_ISLASTROUND: "अंतिम राउंड है",
  T_46_META_WS_P_ISLOCALPOS: "लोकल कोऑर्डिनेट सिस्टम एक्टिव",
  T_46_META_WS_P_ISLOOP: "लूपिंग है",
  T_46_META_WS_P_ISMATCHPOINT: "मैच पॉइंट है",
  T_46_META_WS_P_ISMOVEABLE: "चल सकता है",
  T_46_META_WS_P_ISOCCUPIED: "कब्जा किया गया है या नहीं",
  T_46_META_WS_P_ISOPENTWEEN: "HP चेंज इफेक्ट एक्टिव",
  T_46_META_WS_P_ISPLAYING: "खेल रहा है",
  T_46_META_WS_P_ISPURCHASABLE: "स्टोर आइटम",
  T_46_META_WS_P_ISREVERSE: "उलटा",
  T_46_META_WS_P_ISSERVERDRIVEN: "सर्वर-ड्रिवन",
  T_46_META_WS_P_ISSHOW: "दिखाएँ",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD नाम दिखाएँ",
  T_46_META_WS_P_ISSHOWMAPINFO: "मानचित्र जानकारी दिखाएँ",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "त्वरित संदेश दिखाएँ",
  T_46_META_WS_P_ISSHOWSCAN: "स्कैन दिखाएँ",
  T_46_META_WS_P_ISSHOWTAG: "टैग दिखाएँ",
  T_46_META_WS_P_ISSIDECOLLIDING: "साइड टकराव",
  T_46_META_WS_P_ISSILENCE: "शस्त्र साइलेंस है",
  T_46_META_WS_P_ISSINGLESHOT: "एकल शॉट है",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "गिरने की एनीमेशन छोड़ें",
  T_46_META_WS_P_ISSLIDING: "स्लाइडिंग में है",
  T_46_META_WS_P_ISTOPCOLLIDING: "ऊपर की ओर टकराव",
  T_46_META_WS_P_ISUNDERLINE: "अंडरलाइन",
  T_46_META_WS_P_ISVISIBLE: "विज़िबल है",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "आइटम बैकग्राउंड रंग",
  T_46_META_WS_P_ITEMBACKGROUNDS: "आइटम बैकग्राउंड स्प्राइट",
  T_46_META_WS_P_ITEMCOUNTS: "खरीदने योग्य है या नहीं",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "आइटम विवरण",
  T_46_META_WS_P_ITEMICONS: "आइटम आइकॉन",
  T_46_META_WS_P_ITEMID: "आइटम आईडी",
  T_46_META_WS_P_ITEMIDS: "आइटम ID",
  T_46_META_WS_P_ITEMNAMES: "आइटम नाम",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "आइटम उठाने की रोकथाम सूची",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "जॉयस्टिक कैप ड्रैग त्रिज्या",
  T_46_META_WS_P_JOYSTICKIMAGE: "जॉयस्टिक कैप छवि",
  T_46_META_WS_P_JOYSTICKRADIUS: "जॉयस्टिक कैप त्रिज्या",
  T_46_META_WS_P_JUMPCD: "कूदने का कूलडाउन",
  T_46_META_WS_P_JUMPHEIGHT: "कूद की ऊँचाई",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "कूदने की ऊँचाई स्केल",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "नॉकडाउन डैमेज बोनस",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "नॉकडाउन स्थिति",
  T_46_META_WS_P_LABEL: "लेबल",
  T_46_META_WS_P_LABELCOLOR: "लेबल रंग",
  T_46_META_WS_P_LABELKEY: "लेबल कुंजी",
  T_46_META_WS_P_LABELPARAMS: "लेबल पैरामीटर",
  T_46_META_WS_P_LASTCHECKPOINTID: "वर्तमान चेकपॉइंट ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "अंतिम जीवित रहने का समय",
  T_46_META_WS_P_LAYERTYPE: "लेयर प्रकार",
  T_46_META_WS_P_LAYOUTTYPE: "लेआउट प्रकार",
  T_46_META_WS_P_LEFTARM: "बायां हाथ",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "बाईं पृष्ठभूमि का रंग",
  T_46_META_WS_P_LEFTCOLOR: "बाईं ओर का रंग",
  T_46_META_WS_P_LEFTDESCRIPTION: "बाईं ओर विवरण",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "बाएं प्रभाव सक्रिय",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "बाईं ओर फायरिंग आर्क कोण",
  T_46_META_WS_P_LEFTFOOT: "बायां पैर (पैर की अंगुली)",
  T_46_META_WS_P_LEFTHAND: "बायां हाथ (हथेली)",
  T_46_META_WS_P_LEFTICON: "लेफ्ट आइकॉन",
  T_46_META_WS_P_LEFTICONNAME: "बाईं आइकॉन नाम",
  T_46_META_WS_P_LEFTLEG: "बायां पैर",
  T_46_META_WS_P_LEFTPLAYERS: "बाएं खिलाड़ी",
  T_46_META_WS_P_LEFTSCORE: "लेफ्ट स्कोर",
  T_46_META_WS_P_LEFTSCOREAFTER: "लेफ्ट फाइनल स्कोर",
  T_46_META_WS_P_LEFTSCORETEXT: "लेफ्ट स्कोर",
  T_46_META_WS_P_LEFTTEAM: "दायां टीम",
  T_46_META_WS_P_LEFTTEAMINDEX: "बाईं टीम अनुक्रमणिका",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "बाईं टीम के जीवित सदस्य की संख्या",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "बाईं टीममेट झंडे की संख्या",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "बाईं टीममेट स्थिति",
  T_46_META_WS_P_LEFTTEAMNAME: "बाईं टीम का नाम",
  T_46_META_WS_P_LEFTTEAMSCORE: "बाईं टीम का स्कोर",
  T_46_META_WS_P_LEFTTEXT: "लेफ्ट टेक्स्ट",
  T_46_META_WS_P_LENGTH: "लंबाई",
  T_46_META_WS_P_LENSFLARE: "लेंस फ्लेयर",
  T_46_META_WS_P_LEVEL: "स्तर",
  T_46_META_WS_P_LIFETIME: "जीवन काल (सेकंड)",
  T_46_META_WS_P_LIGHTCOLOR: "मुख्य प्रकाश रंग",
  T_46_META_WS_P_LIGHTINTENSITY: "प्रकाश की तीव्रता",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "अंगों को होने वाला नुकसान गुणांक",
  T_46_META_WS_P_LINESPACING: "पंक्ति अंतर",
  T_46_META_WS_P_LOCALPOSITION: "स्थानीय स्थिति",
  T_46_META_WS_P_LOCALROTATION: "स्थानीय घूर्णन",
  T_46_META_WS_P_LOCALROTATIONQ: "स्थानीय घूर्णन क्वाटरनियन",
  T_46_META_WS_P_LOCALSCALE: "स्थानीय आकार",
  T_46_META_WS_P_LOCKEY: "स्थानीयकरण कुंजी",
  T_46_META_WS_P_LOOPCOUNT: "लूप काउंट",
  T_46_META_WS_P_LOOTSOCCER: "लूट सॉकर",
  T_46_META_WS_P_LOSEHPCOLOR: "लॉस HP कलर",
  T_46_META_WS_P_LOSEMVPS: "हार MVP",
  T_46_META_WS_P_LOSETEXT: "हार टेक्स्ट",
  "T_46_META_WS_P_MAIN CAMERA": "मुख्य कैमरा",
  T_46_META_WS_P_MAINCOLOR: "मेन कलर",
  T_46_META_WS_P_MAINSCORELIST: "मुख्य स्कोर",
  T_46_META_WS_P_MAINSCORETITLE: "मुख्य स्कोर शीर्षक",
  T_46_META_WS_P_MAINWEAPON: "मुख्य हथियार",
  T_46_META_WS_P_MAPSIZE: "मैप साइज",
  T_46_META_WS_P_MASK: "मास्क",
  T_46_META_WS_P_MASKNAME: "मास्क नाम",
  T_46_META_WS_P_MASS: "मास (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "मैच शीर्षक बायां",
  T_46_META_WS_P_MATCHTITLERIGHT: "मैच शीर्षक दायाँ",
  T_46_META_WS_P_MAXCAPACITY: "अधिकतम क्षमता",
  T_46_META_WS_P_MAXCOUNT: "अधिकतम संख्या",
  T_46_META_WS_P_MAXDAMAGE: "अधिकतम नुकसान",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "अधिकतम अवनति कोण",
  T_46_META_WS_P_MAXDISPLACEMENT: "अधिकतम विस्थापन",
  T_46_META_WS_P_MAXDISTANCE: "अधिकतम दूरी",
  T_46_META_WS_P_MAXDURABILITY: "अधिकतम टिकाऊपन",
  T_46_META_WS_P_MAXDURABILITYRATIO: "अधिकतम स्थायित्व अनुपात",
  T_46_META_WS_P_MAXENERGY: "अधिकतम ऊर्जा",
  T_46_META_WS_P_MAXEP: "अधिकतम ऊर्जा",
  T_46_META_WS_P_MAXHP: "अधिकतम HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "अधिकतम कूद की संख्या",
  T_46_META_WS_P_MAXJUMPHEIGHT: "अधिकतम कूद की ऊँचाई",
  T_46_META_WS_P_MAXLENGTH: "अधिकतम लंबाई",
  T_46_META_WS_P_MAXPROGRESS: "अधिकतम प्रगति",
  T_46_META_WS_P_MAXSCATTERRATIO: "अधिकतम स्कैटर अनुपात",
  T_46_META_WS_P_MAXSPEED: "अधिकतम गति",
  T_46_META_WS_P_MAXTURRETCOUNT: "अधिकतम टॉरट संख्या",
  T_46_META_WS_P_MAXVALUE: "अधिकतम मान",
  T_46_META_WS_P_MAXWIDGETID: "मैक्सWidgetID",
  T_46_META_WS_P_MINDAMAGE: "न्यूनतम नुकसान",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "न्यूनतम नुकसान की दूरी",
  T_46_META_WS_P_MINDISTANCE: "न्यूनतम दूरी",
  T_46_META_WS_P_MINELEVATIONANGLE: "न्यूनतम ऊँचाई कोण",
  T_46_META_WS_P_MINENDHEIGHT: "न्यूनतम समाप्ति ऊँचाई",
  T_46_META_WS_P_MINFLYHEIGHT: "न्यूनतम उड़ान ऊँचाई",
  T_46_META_WS_P_MINMOVEDISTANCE: "न्यूनतम चाल दूरी",
  T_46_META_WS_P_MINVALUE: "न्यूनतम मान",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "मिसाइल अधिकतम क्षति",
  T_46_META_WS_P_MISSILEMINDAMAGE: "मिसाइल न्यूनतम क्षति",
  T_46_META_WS_P_MISSILERANGE: "मिसाइल रेंज",
  T_46_META_WS_P_MODEL: "मॉडल",
  T_46_META_WS_P_MODELVISIBILITY: "मॉडल दृश्यता",
  T_46_META_WS_P_MODELVISIBLE: "मॉडल दृश्यता",
  T_46_META_WS_P_MONEY: "पैसा",
  T_46_META_WS_P_MONEYLIST: "पैसे की सूची",
  T_46_META_WS_P_MONEYS: "बाउंड वॉलेट",
  T_46_META_WS_P_MONEYTYPE: "मुद्रा प्रकार",
  T_46_META_WS_P_MONSTERTYPE: "मॉन्स्टर टाइप",
  T_46_META_WS_P_MOTIONTYPE: "मोशन प्रकार",
  T_46_META_WS_P_MOTIONVALUEX: "X दिशा में मोशन मान",
  T_46_META_WS_P_MOTIONVALUEY: "Y दिशा में मोशन मान",
  T_46_META_WS_P_MOTIONVALUEZ: "Z दिशा में मोशन मान",
  T_46_META_WS_P_MOVEMENTDURATION: "आंदोलन की अवधि",
  T_46_META_WS_P_MULTIPLIER: "गुणक",
  T_46_META_WS_P_MUSICELEMENTTYPE: "संगीत तत्व प्रकार",
  T_46_META_WS_P_MUZZLEVELOCITY: "नाल वेग",
  T_46_META_WS_P_MVP: "एमवीपी",
  T_46_META_WS_P_NAME: "नाम",
  T_46_META_WS_P_NEXTROUNDINDEX: "अगला राउंड अनुक्रमणिका",
  T_46_META_WS_P_NICKNAME: "उपनाम",
  T_46_META_WS_P_NORMALCOLOR: "सामान्य रंग",
  T_46_META_WS_P_NORMALIZEDPOSITION: "सामान्य स्थिति",
  T_46_META_WS_P_NUMBERINFACTION: "फрак्शन में संख्या",
  T_46_META_WS_P_OBJECTID: "ऑब्जेक्ट आईडी",
  T_46_META_WS_P_OFFSET: "ऑफ़सेट",
  T_46_META_WS_P_OPTIONS: "विकल्प",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "अन्य डैमेज फैक्टर",
  T_46_META_WS_P_OUTFIT: "खिलाड़ी का परिधान",
  T_46_META_WS_P_OVERFLOW: "ओवरफ्लो",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "ऊंचाई को पार करने के बाद गिरने की गति",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "खिलाड़ी कॉन्फ़िगरेशन प्राथमिकता",
  T_46_META_WS_P_OWNER: "मालिक",
  T_46_META_WS_P_PARAMS: "पैरामीटर",
  T_46_META_WS_P_PARENT: "माता-पिता",
  T_46_META_WS_P_PARENTID: "पेरेंट आईडी",
  T_46_META_WS_P_PARENTUI: "पेरेंट यूआई",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "पैरेंट विजेट एंटिटी ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "पैरेंट विजेट फ़ाइल आईडी",
  T_46_META_WS_P_PARTMASKA: "पार्ट मास्क 1",
  T_46_META_WS_P_PASSENGERS: "यात्री",
  T_46_META_WS_P_PATHID: "पथ आईडी",
  T_46_META_WS_P_PAUSEEVENT: "पॉज़ इवेंट",
  T_46_META_WS_P_PERSONAID: "पर्सोना ID",
  T_46_META_WS_P_PHASEDURATION: "अवधि (ms)",
  T_46_META_WS_P_PHASEENDTIME: "समाप्ति समय (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "भौतिक परत",
  T_46_META_WS_P_PINID: "पिन आईडी",
  T_46_META_WS_P_PITCH: "पिच",
  T_46_META_WS_P_PIVOT: "पिवट",
  T_46_META_WS_P_PLAYER: "खिलाड़ी",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "खिलाड़ी लक्ष्य गति गुणांक",
  T_46_META_WS_P_PLAYERLIST: "खिलाड़ी सूची",
  T_46_META_WS_P_PLAYERNAME: "प्लेयर नाम",
  T_46_META_WS_P_PLAYERRANK: "खिलाड़ी रैंक",
  T_46_META_WS_P_PLAYERRANKS: "खिलाड़ी रैंक",
  T_46_META_WS_P_PLAYERS: "खिलाड़ी",
  T_46_META_WS_P_PLAYERSCORETYPES: "खिलाड़ी स्कोर प्रकार",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "खिलाड़ी गति कारक",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "फायरिंग के दौरान खिलाड़ी गति कारक",
  T_46_META_WS_P_PLAYERSTATUS: "खिलाड़ी की स्थिति",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "खिलाड़ी खींचने की गति",
  T_46_META_WS_P_PLAYINGSTATUS: "चलाने की स्थिति",
  T_46_META_WS_P_PLAYSPEED: "प्ले गति",
  T_46_META_WS_P_POINTPOSITION: "बिंदु स्थिति",
  T_46_META_WS_P_POINTS: "अंक",
  T_46_META_WS_P_POSITION: "स्थिति",
  T_46_META_WS_P_PREFABID: "प्रीफ़ेब आईडी",
  T_46_META_WS_P_PRESSEDCOLOR: "दबाया गया रंग",
  T_46_META_WS_P_PRESSEDSPRITE: "दबाया गया स्प्राइट",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "दबाया गया स्प्राइट प्रकार",
  T_46_META_WS_P_PRICE: "मूल्य",
  T_46_META_WS_P_PRIORITY: "प्राथमिकता",
  T_46_META_WS_P_PROFILEINFO: "प्रोफ़ाइल जानकारी",
  T_46_META_WS_P_PROGRESS: "प्रोग्रेस [0,1]",
  T_46_META_WS_P_PROGRESSICON: "प्रगति आइकन",
  T_46_META_WS_P_PROGRESSICONNAME: "प्रगति आइकन नाम",
  T_46_META_WS_P_PROPID: "गुण ID",
  T_46_META_WS_P_PURCHASELIMIT: "खरीद सीमा",
  T_46_META_WS_P_RADIUS: "त्रिज्या",
  T_46_META_WS_P_RANGE: "सीमा",
  T_46_META_WS_P_RANK: "रैंक",
  T_46_META_WS_P_RATIOSELFFACTOR: "स्वयं नुकसान अनुपात",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "टीम के साथी नुकसान अनुपात",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "वाहन नुकसान अनुपात",
  T_46_META_WS_P_REFRESHTIME: "बफ ताजगी समय (सेकंड में)",
  T_46_META_WS_P_RELOADSPEED: "पुनः लोड गति",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "रीलोड स्पीड फैक्टर",
  T_46_META_WS_P_REMAINJUMPCOUNT: "शेष कूद की संख्या",
  T_46_META_WS_P_REMAINQUANTITY: "शेष मात्रा",
  T_46_META_WS_P_RENDERTYPE: "रेंडर प्रकार",
  T_46_META_WS_P_REPEATTIMES: "पुनरावृत्ति समय",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "प्रतिस्थापन प्राथमिकता",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ट्रिगर खिलाड़ी आईडी",
  T_46_META_WS_P_REQUESTTYPE: "अनुरोधित वस्तुओं की सूची",
  T_46_META_WS_P_RESETPERROUND: "राउंड के अनुसार रीसेट",
  T_46_META_WS_P_RESETPOSITION: "रिसेट स्थिति",
  T_46_META_WS_P_RESETTIME: "रिसेट समय",
  T_46_META_WS_P_RESOURCE: "संसाधन",
  T_46_META_WS_P_RESOURCEID: "संसाधन आईडी",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "पैनल के भीतर प्रतिबंधित",
  T_46_META_WS_P_RESULT: "परिणाम",
  T_46_META_WS_P_RESULTTYPE: "परिणाम प्रकार",
  T_46_META_WS_P_REVIVALPOINT: "पुनरुत्थान बिंदु",
  T_46_META_WS_P_REVIVECD: "पुनर्जीवित होने का समय",
  T_46_META_WS_P_RIGHT: "दायां",
  T_46_META_WS_P_RIGHTARM: "दायां हाथ",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "दाईं पृष्ठभूमि का रंग",
  T_46_META_WS_P_RIGHTCOLOR: "दाईं ओर का रंग",
  T_46_META_WS_P_RIGHTDESCRIPTION: "दाईं ओर विवरण",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "दाएं प्रभाव सक्रिय",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "दाईं ओर फायरिंग आर्क कोण",
  T_46_META_WS_P_RIGHTFOOT: "दायां पैर (पैर की अंगुली)",
  T_46_META_WS_P_RIGHTHAND: "दायां हाथ (हथेली)",
  T_46_META_WS_P_RIGHTICON: "राइट आइकॉन",
  T_46_META_WS_P_RIGHTICONNAME: "दाईं आइकॉन नाम",
  T_46_META_WS_P_RIGHTLEG: "दायां पैर",
  T_46_META_WS_P_RIGHTPLAYERS: "दाएं खिलाड़ी",
  T_46_META_WS_P_RIGHTSCORE: "राइट स्कोर",
  T_46_META_WS_P_RIGHTSCOREAFTER: "राइट फाइनल स्कोर",
  T_46_META_WS_P_RIGHTSCORETEXT: "राइट स्कोर",
  T_46_META_WS_P_RIGHTTEAM: "शीर्षक",
  T_46_META_WS_P_RIGHTTEAMINDEX: "दाईं टीम अनुक्रमणिका",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "दाईं टीम के जीवित सदस्य की संख्या",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "दाएं साथी का झंडा संख्या",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "दाईं टीममेट स्थिति",
  T_46_META_WS_P_RIGHTTEAMNAME: "दाईं टीम का नाम",
  T_46_META_WS_P_RIGHTTEAMSCORE: "दाईं टीम का स्कोर",
  T_46_META_WS_P_RIGHTTEXT: "राइट टेक्स्ट",
  T_46_META_WS_P_RIMALPHA: "किनारा अल्फा",
  T_46_META_WS_P_RIMCOLOR: "किनारा रंग",
  T_46_META_WS_P_RIMTEXTURE: "किनारा बनावट",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "रोलिंग घर्षण गुणांक",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "त्वरित घर्षण गुणांक",
  T_46_META_WS_P_ROTATION: "घुमाव",
  T_46_META_WS_P_ROTATIONANGLE: "घूर्णन कोण",
  T_46_META_WS_P_ROTATIONQ: "घूर्णन क्वाटरनियन",
  T_46_META_WS_P_ROUNDINCOME: "राउंड आय",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "राउंड आय विवरण संख्या",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "राउंड आय विवरण शीर्षक",
  T_46_META_WS_P_ROUNDINCOMETITLE: "राउंड आय शीर्षक",
  T_46_META_WS_P_ROUNDNUM: "राउंड संख्या",
  T_46_META_WS_P_ROUNDNUMKEY: "राउंड संख्या की कुंजी",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "राउंड संख्या लोकलाइज़ेशन कुंजी पैरामीटर",
  T_46_META_WS_P_RUNSPEED: "दौड़ने की गति",
  T_46_META_WS_P_RUNSPEEDSCALE: "दौड़ने की गति स्केल",
  T_46_META_WS_P_RUSHDISTANCE: "रश की दूरी",
  T_46_META_WS_P_RUSHENERGYCOST: "रश ऊर्जा लागत",
  T_46_META_WS_P_RUSHVERTICALSPEED: "रश ऊर्ध्वाधर गति",
  T_46_META_WS_P_SCALE: "स्केल",
  T_46_META_WS_P_SCATTERINCREASESPEED: "स्कैटर बढ़ने की स्पीड",
  T_46_META_WS_P_SCATTERMAX: "अधिकतम फैलाव",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "चलते समय स्कैटर मल्टीप्लायर",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "स्कैटर रिकवर स्पीड",
  T_46_META_WS_P_SCATTERSPEED: "स्कैटर स्पीड",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "झुकते या लेटते समय फैलाव की गति",
  T_46_META_WS_P_SCATTERTHRESHOLD: "फैलाव सीमा",
  T_46_META_WS_P_SCOPETYPE: "स्कोप प्रकार",
  T_46_META_WS_P_SCORE: "स्कोर",
  T_46_META_WS_P_SCORES1: "स्कोर 1",
  T_46_META_WS_P_SCORES2: "स्कोर 2",
  T_46_META_WS_P_SCORES3: "स्कोर 3",
  T_46_META_WS_P_SCORES4: "स्कोर 4",
  T_46_META_WS_P_SCORES5: "स्कोर 5",
  T_46_META_WS_P_SCORETEXTKEY: "स्कोर टेक्स्ट कुंजी",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "स्कोर टेक्स्ट कुंजी पैरामीटर",
  T_46_META_WS_P_SCROLLCONTINUITY: "स्क्रॉल निरंतरता",
  T_46_META_WS_P_SCROLLDIRECTION: "स्क्रॉल दिशा",
  T_46_META_WS_P_SCROLLEFFECT: "स्क्रॉल प्रभाव",
  T_46_META_WS_P_SCROLLWHEELSPEED: "स्क्रॉल व्हील गति",
  T_46_META_WS_P_SECONDSCORETITLE: "दूसरा स्कोर शीर्षक",
  T_46_META_WS_P_SECONDSCOREVALUE: "दूसरा स्कोर मान",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "दूसरा स्कोर पैरामीटर",
  T_46_META_WS_P_SELECTEDCOLOR: "चयनित रंग",
  T_46_META_WS_P_SELECTEDINDEX: "चयनित अनुक्रमणिका",
  T_46_META_WS_P_SELECTEDSPRITE: "चयनित स्प्राइट",
  T_46_META_WS_P_SELECTEDTYPE: "चयनित प्रकार",
  T_46_META_WS_P_SELF: "स्वयं",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "स्व-नुकसान गुणक",
  T_46_META_WS_P_SET: "सेट",
  T_46_META_WS_P_SHADERNAME: "शेडर नाम",
  T_46_META_WS_P_SHADOWCOLOR: "शैडो रंग",
  T_46_META_WS_P_SHADOWOFFSET: "शैडो ऑफ़सेट",
  T_46_META_WS_P_SHADOWSTRENGTH: "छाया की ताकत",
  T_46_META_WS_P_SHELFS: "मैनुअल बंद करना अक्षम है या नहीं",
  T_46_META_WS_P_SHOES: "जूते",
  T_46_META_WS_P_SHOOTANGLEMAX: "अधिकतम शूटिंग कोण",
  T_46_META_WS_P_SHOOTANGLEMIN: "न्यूनतम शूटिंग कोण",
  T_46_META_WS_P_SHOP: "शॉप",
  T_46_META_WS_P_SHOPITEMS: "शेल्व्स",
  T_46_META_WS_P_SHOWADDFRIEND: "दोस्त जोड़ें दिखाएँ",
  T_46_META_WS_P_SHOWATTACKGRENADE: "हमले की ग्रेनेड दिखाएँ",
  T_46_META_WS_P_SHOWBACKGROUND: "पृष्ठभूमि दिखाएं",
  T_46_META_WS_P_SHOWCROUCH: "झुकने दिखाएँ",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "डैमेज नंबर दिखाएँ",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "रक्षा ग्रेनेड दिखाएँ",
  T_46_META_WS_P_SHOWECCONOMY: "बाहरी अर्थव्यवस्था दिखाएँ",
  T_46_META_WS_P_SHOWECONOMY: "बाहरी अर्थव्यवस्था दिखाएँ",
  T_46_META_WS_P_SHOWFIRE: "फायर दिखाएँ",
  T_46_META_WS_P_SHOWFRAME: "फ्रेम दिखाएँ",
  T_46_META_WS_P_SHOWGIFT: "उपहार दिखाएँ",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "हिट पॉइंट प्रभाव दिखाएं",
  T_46_META_WS_P_SHOWJUMP: "कूदने दिखाएँ",
  T_46_META_WS_P_SHOWLIKE: "लाइक दिखाएँ",
  T_46_META_WS_P_SHOWLOBBY: "लॉबी दिखाएँ",
  T_46_META_WS_P_SHOWMAPEVALUATE: "मानचित्र मूल्यांकन दिखाएँ",
  T_46_META_WS_P_SHOWMATCHDETAIL: "मैच विवरण दिखाएँ",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "मूविंग जॉयस्टिक दिखाएँ",
  T_46_META_WS_P_SHOWNAME: "उपनाम दिखाएँ",
  T_46_META_WS_P_SHOWPIN: "पिन दिखाएँ",
  T_46_META_WS_P_SHOWPRONE: "लेटने दिखाएँ",
  T_46_META_WS_P_SHOWRANK: "रैंक दिखाएँ",
  T_46_META_WS_P_SHOWREPLAY: "पुनरावृत्ति दिखाएँ",
  T_46_META_WS_P_SHOWREPORT: "रिपोर्ट दिखाएँ",
  T_46_META_WS_P_SHOWSHARE: "साझा करें दिखाएँ",
  T_46_META_WS_P_SHOWSPRINT: "स्प्रिंट दिखाएँ",
  T_46_META_WS_P_SHOWTAG: "शो टैग",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "टीममेट्स जानकारी दिखाएँ",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "टीममेट स्थिति दिखाएँ",
  T_46_META_WS_P_SHOWTEAMSCORE: "टीम स्कोर दिखाएँ",
  T_46_META_WS_P_SHOWTIMETYPE: "समय प्रकार दिखाएँ",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "दो टीमों का स्कोर दिखाएँ",
  T_46_META_WS_P_SHRINKDURATION: "सिकुड़न अवधि (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "सिकुड़न एंड टाइम (ms)",
  T_46_META_WS_P_SHRINKSPEED: "अभिसरण दर",
  T_46_META_WS_P_SHRINKSTARTTIME: "सिकुड़न स्टार्ट टाइम (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS लक्ष्य सहायता की अनुमति दें",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "लक्ष्य सहायता दूरी क्षीणन गुणांक (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "लक्ष्य सहायता दूरी प्राथमिकता प्रभाव गुणांक (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "लक्ष्य सहायता दूरी प्राथमिकता अधिकतम दूरी",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "लक्ष्य सहायता दूरी प्राथमिकता न्यूनतम दूरी",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "लक्ष्य सहायता दूरी प्राथमिकता की अनुमति दें",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "लक्ष्य सहायता क्रॉसहेयर स्क्रीन सीमा आकर्षण अनुपात (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "दृष्टि आवर्धन अनुपात",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV आवर्धन",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS घूर्णन संवेदनशीलता",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS न्यूनतम नुकसान दूरी सुधार गुणांक",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS आवर्धन समय (सेकंड)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS आवर्धन",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS रिकवरी समय (सेकंड)",
  T_46_META_WS_P_SIZE: "आकार",
  T_46_META_WS_P_SIZEDELTA: "आकार अंतर",
  T_46_META_WS_P_SKELETON: "कंकाल",
  T_46_META_WS_P_SKIN: "त्वचा",
  T_46_META_WS_P_SKINID: "स्किन ID",
  T_46_META_WS_P_SKINWIDTH: "स्किन चौड़ाई",
  T_46_META_WS_P_SKYBOXENV: "आकाश बॉक्स",
  T_46_META_WS_P_SKYBOXRESOURCE: "आकाश बॉक्स संसाधन",
  T_46_META_WS_P_SLOPELIMIT: "ढलान सीमा",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "सुगम स्क्रॉल शुरू करें",
  T_46_META_WS_P_SOFTNESS: "मुलायमपन",
  T_46_META_WS_P_SORTTYPE: "सॉर्ट प्रकार",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "वेव प्रति स्पॉन गिनती",
  T_46_META_WS_P_SPAWNPOINT: "पुनरुत्थान बिंदु",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "स्पॉन बिंदु की संख्या",
  T_46_META_WS_P_SPAWNPOSITION: "स्पॉन स्थिति",
  T_46_META_WS_P_SPEED: "गति",
  T_46_META_WS_P_SPEEDWHILEAIMING: "एडीएस गति दर",
  T_46_META_WS_P_SPRAYCOLOR: "स्प्रे रंग",
  T_46_META_WS_P_SPRINTENERGYCOST: "स्प्रिंट ऊर्जा लागत",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "स्प्रिंट क्षैतिज गति",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "दौड़ने की गति माप",
  T_46_META_WS_P_SPRITENAME: "स्प्राइट आकार",
  T_46_META_WS_P_SPRITERESOURCE: "स्प्राइट संसाधन",
  T_46_META_WS_P_SRCVAL: "स्रोत मान",
  T_46_META_WS_P_STARTDROPTIME: "ड्रॉप टाइम (ms)",
  T_46_META_WS_P_STARTEVENT: "स्टार्ट इवेंट",
  T_46_META_WS_P_STARTPOSITION: "प्रारंभ स्थिति",
  T_46_META_WS_P_STARTRADIUS: "स्टार्ट रेडियस",
  T_46_META_WS_P_STARTSPAWNTIME: "स्पॉन प्रारंभ समय (सेकंड में)",
  T_46_META_WS_P_STARTTIME: "स्टार्ट टाइम (s)",
  T_46_META_WS_P_STARTVALUE: "प्रारंभिक मान",
  T_46_META_WS_P_STATICICONCOLORS: "स्टैटिक आइकॉन कलर्स",
  T_46_META_WS_P_STATICICONS: "स्टैटिक आइकॉन्स",
  T_46_META_WS_P_STATUS: "मिनी सेंट्री की स्थिति",
  T_46_META_WS_P_STEPOFFSET: "स्टेप ऑफ़सेट",
  T_46_META_WS_P_STOPDURATION: "रुकने की अवधि",
  T_46_META_WS_P_STOPEVENT: "स्टॉप इवेंट",
  T_46_META_WS_P_STORE: "स्टोर",
  T_46_META_WS_P_STROPID: "स्ट्रॉप ID",
  T_46_META_WS_P_STYLE: "शैली",
  T_46_META_WS_P_SUBTITLE: "सबटाइटल",
  T_46_META_WS_P_SUMMULTIPLIER: "कुल गुणक",
  T_46_META_WS_P_SWINGEXITACCELERATION: "झूल से बाहर निकलने की त्वरण",
  T_46_META_WS_P_SWINGINGSPEED: "झूलने की गति",
  T_46_META_WS_P_TAGS: "टैग",
  T_46_META_WS_P_TARGETCHECKPOINTID: "लक्षित चेकपॉइंट ID",
  T_46_META_WS_P_TARGETICONCOLORS: "टारगेट आइकॉन कलर्स",
  T_46_META_WS_P_TARGETICONS: "टारगेट आइकॉन्स",
  T_46_META_WS_P_TARGETID: "लक्ष्य आईडी",
  T_46_META_WS_P_TARGETITEMID: "लक्षित वस्तु ID",
  T_46_META_WS_P_TARGETROTATION: "लक्षित घुमाव",
  T_46_META_WS_P_TARGETSCALE: "लक्षित पैमाना",
  T_46_META_WS_P_TEAMCOLOR: "टीम का रंग",
  T_46_META_WS_P_TEAMCOLORS: "टीम रंग",
  T_46_META_WS_P_TEAMINDEXS: "टीम अनुक्रमणिका",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "टीममेट डैमेज फैक्टर",
  T_46_META_WS_P_TEAMMEMBERNUM: "टीम के सदस्य संख्या",
  T_46_META_WS_P_TEAMNUM: "टीम की संख्या",
  T_46_META_WS_P_TEAMRANK: "टीम रैंक",
  T_46_META_WS_P_TEAMRANKDISPLAY: "टीम रैंक प्रदर्शन",
  T_46_META_WS_P_TEAMRANKS: "टीम रैंक",
  T_46_META_WS_P_TEAMSCORES: "टीम स्कोर",
  T_46_META_WS_P_TEAMSEQ: "टीम अनुक्रम",
  T_46_META_WS_P_TEMPLATEENTITY: "टेम्पलेट एंटिटी",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "अस्थायी ढाल बिंदु",
  T_46_META_WS_P_TERRAINWETNESS: "भू-आर्द्रता",
  T_46_META_WS_P_TEXT: "टेक्स्ट",
  T_46_META_WS_P_TEXTCOLOR: "टेक्स्ट कलर",
  T_46_META_WS_P_TEXTKEY: "टेक्स्ट कुंजी",
  T_46_META_WS_P_TEXTKEYPARAMS: "टेक्स्ट कुंजी पैरामीटर",
  T_46_META_WS_P_TEXTURERESOURCE: "बनावट संसाधन",
  T_46_META_WS_P_THEMECOLOR: "थीम रंग",
  T_46_META_WS_P_THROWABLETYPE: "फेंकने योग्य प्रकार",
  T_46_META_WS_P_THROWINGSPEED: "फेंकने की गति",
  T_46_META_WS_P_THROWSPEED: "फेंकने की गति",
  T_46_META_WS_P_TICKINTERVAL: "टिक इंटरवल",
  T_46_META_WS_P_TIMEREQUIRED: "आवश्यक समय (मिलीसेकंड)",
  T_46_META_WS_P_TIPSTYPE: "टिप्स प्रकार",
  T_46_META_WS_P_TITLE: "शीर्षक",
  T_46_META_WS_P_TITLELIST: "शीर्षक",
  T_46_META_WS_P_TITLES: "स्कोर1",
  T_46_META_WS_P_TOP: "शीर्ष",
  T_46_META_WS_P_TOPALPHA: "ऊपर का अल्फा",
  T_46_META_WS_P_TOTALHP: "कुल HP",
  T_46_META_WS_P_TOTALLEVEL: "कुल स्तर",
  T_46_META_WS_P_TOTALROUNDCOUNT: "कुल राउंड की संख्या",
  T_46_META_WS_P_TOWSPEED: "खींचने की गति",
  T_46_META_WS_P_TRANSITIONSTAGE: "संक्रमण चरण",
  T_46_META_WS_P_TRANSITIONTYPE: "संक्रमण प्रकार",
  T_46_META_WS_P_TRIGGERPLAYERID: "पैसे",
  T_46_META_WS_P_TRIGGERRADIUS: "ट्रिगर रेंज",
  T_46_META_WS_P_TRIGGERRANGE: "ट्रिगर सीमा",
  T_46_META_WS_P_TRIGGERTIME: "ट्रिगर समय",
  T_46_META_WS_P_TURNSPEED: "मोड़ की गति",
  T_46_META_WS_P_TWEENERENABLED: "बाएं टीम",
  T_46_META_WS_P_TWEENSTYLE: "ट्वीन स्टाइल",
  T_46_META_WS_P_TYPE: "प्रकार",
  T_46_META_WS_P_UNSELECTEDCOLOR: "अचयनित रंग",
  T_46_META_WS_P_UNSELECTEDSPRITE: "अचयनित स्प्राइट",
  T_46_META_WS_P_UNSELECTEDTYPE: "अचयनित प्रकार",
  T_46_META_WS_P_UP: "ऊपर",
  T_46_META_WS_P_UPDATETYPE: "अपडेट प्रकार",
  T_46_META_WS_P_UPENERGYCOST: "ऊपर ऊर्जा लागत",
  T_46_META_WS_P_UPSPEED: "अप स्पीड",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "कस्टम पुश फोर्स का उपयोग",
  T_46_META_WS_P_USECUSTOMRESOURCE: "कस्टम रिसोर्स यूज़",
  T_46_META_WS_P_USEDCAPACITY: "उपयोग की गई क्षमता",
  T_46_META_WS_P_USEGRAVITY: "गुरुत्वाकर्षण का उपयोग",
  T_46_META_WS_P_USEPHYSICALCCT: "भौतिक CCT का उपयोग",
  T_46_META_WS_P_USERUID: "उपयोगकर्ता UID",
  T_46_META_WS_P_UVOFFSET: "UV ऑफ़सेट",
  T_46_META_WS_P_UVSIZE: "UV आकार",
  T_46_META_WS_P_VALUE: "मान",
  T_46_META_WS_P_VAULTDISTANCE: "वॉल्ट डिस्टेंस",
  T_46_META_WS_P_VAULTHEIGHT: "वॉल्ट हाइट",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "वाहन क्षति तत्व",
  T_46_META_WS_P_VEHICLESKINID: "वाहन त्वचा आईडी",
  T_46_META_WS_P_VEHICLESKINIDS: "वाहन की त्वचा आईडी",
  T_46_META_WS_P_VELOCITY: "वेग (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "XZ गति",
  T_46_META_WS_P_VELOCITYY: "Y गति",
  T_46_META_WS_P_VERTICALBAR: "लंबवत बार",
  T_46_META_WS_P_VERTICALOFFSET: "लंबवत ऑफ़सेट",
  T_46_META_WS_P_VEST: "बुलेटप्रूफ वेस्ट",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX टेक्सचर प्रकार",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "दृश्य कोण सीमा",
  T_46_META_WS_P_VISIBILITYLAYER: "दृश्यता परत",
  T_46_META_WS_P_VISIBLE: "दृश्यमान",
  T_46_META_WS_P_VISIBLEONBACK: "पीठ पर दिखाई देता है",
  T_46_META_WS_P_VISIBLEPLAYERS: "विज़िबल प्लेयर्स",
  T_46_META_WS_P_VOLUME: "ध्वनि स्तर",
  T_46_META_WS_P_WALLETID: "वॉलेट ID",
  T_46_META_WS_P_WANDERRANGE: "भटकाव की दूरी",
  T_46_META_WS_P_WAVECOUNT: "लहर की संख्या",
  T_46_META_WS_P_WAVEINTERVAL: "लहर का अंतराल",
  T_46_META_WS_P_WEAPONDAMAGERATE: "हथियार क्षति दर",
  T_46_META_WS_P_WEAPONSKINIDS: "हथियार की त्वचा आईडी",
  T_46_META_WS_P_WEAPONSUBTYPE: "हथियार उप-प्रकार",
  T_46_META_WS_P_WEAPONTYPE: "हथियार प्रकार",
  T_46_META_WS_P_WIDTH: "चौड़ाई",
  T_46_META_WS_P_WINMVPS: "जीत MVP",
  T_46_META_WS_P_WINTEXT: "जीत टेक्स्ट",
  T_46_META_WS_P_WORDWRAP: "शब्द संरेखण",
  T_46_META_WS_P_WORLDPOSITION: "विश्व स्थिति",
  T_46_META_WS_P_YAW: "यॉ",
  T_46_META_WS_PATROLALONG: "गश्त मार्ग",
  T_46_META_WS_PATROLTO: "गश्त पर जाएं",
  T_46_META_WS_PAUSE: "पॉज़",
  T_46_META_WS_PAUSEEMOTE: "इमोट को रोकें",
  T_46_META_WS_PAUSEFIXEDUPDATE: "स्थिर अपडेट को स्थगित करें",
  T_46_META_WS_PHASE: "चरण",
  T_46_META_WS_PLAY: "प्ले",
  T_46_META_WS_PLAYANIMATION: "एनिमेशन चलाएँ",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "चरित्र एनिमेशन क्लिप चलाएँ",
  T_46_META_WS_PLAYEMOTE: "इमोट चलाएं",
  T_46_META_WS_PLAYER: "खिलाड़ी",
  T_46_META_WS_PORTAL: "पोर्टल",
  T_46_META_WS_POSE: "मुद्रा",
  T_46_META_WS_POSITION: "स्थान",
  T_46_META_WS_PREPOSE: "पूर्व मुद्रा ",
  T_46_META_WS_PROFANITYFILTER: "अश्लीलता फ़िल्टर",
  T_46_META_WS_PURSUITTARGET: "शिकार लक्ष्य",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "क्वाटरनियन को अक्ष कोण में बदलें",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "क्वाटरनियन को ऑयलर कोण में बदलें",
  T_46_META_WS_QUITCHATCHANNEL: "चैट चैनल से बाहर निकलें",
  T_46_META_WS_QUITFACTION: "गुट से बाहर निकलें",
  T_46_META_WS_QUITGAME: "गेम छोड़ें",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "जेलब्रेक मिनी गेम से बाहर निकलें",
  T_46_META_WS_RANDOMFLOAT: "यादृच्छिक फ्लोट",
  T_46_META_WS_RANDOMINT: "यादृच्छिक पूर्णांक",
  T_46_META_WS_RANK: "रैंक",
  T_46_META_WS_READCSV: "CSV पढ़ें",
  T_46_META_WS_READCSVCELL: "CSV की सेल पढ़ें",
  T_46_META_WS_READCSVCELLBYNAME: "पंक्ति संख्या और कॉलम नाम द्वारा CSV की सेल पढ़ें",
  T_46_META_WS_READCSVCELLFROMSERVER: "सर्वर से CSV की सेल पढ़ें",
  T_46_META_WS_READCSVCOLUMN: "CSV का कॉलम पढ़ें",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "सर्वर से CSV का कॉलम पढ़ें",
  T_46_META_WS_READCSVFROMSERVER: "सर्वर से CSV पढ़ें",
  T_46_META_WS_READCSVROW: "CSV की पंक्ति पढ़ें",
  T_46_META_WS_READCSVROWBYKEY: "की द्वारा CSV की पंक्ति पढ़ें",
  T_46_META_WS_READCSVROWFROMSERVER: "सर्वर से CSV की पंक्ति पढ़ें",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "संचित डेटा स्टोर से पढ़ें",
  T_46_META_WS_READFROMDATASTORE: "डेटा स्टोर से पढ़ें",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "लीडरबोर्ड डेटा स्टोर से पढ़ें",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "रैंक के आधार पर लीडरबोर्ड डेटा स्टोर से पढ़ें",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI विशेष अनुसरण हटा दें",
  T_46_META_WS_REMOVEBACKPACKSKIN: "बैकपैक की त्वचा हटाएं",
  T_46_META_WS_REMOVEBUFF: "बफ हटाएं",
  T_46_META_WS_REMOVECOMPONENT: "घटक हटाएं",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "फॉर्मूला प्रॉपर्टी फैक्टर हटाएं",
  T_46_META_WS_REMOVEOUTFIT: "परिधान हटाएं",
  T_46_META_WS_REMOVESCRIPT: "स्क्रिप्ट हटाएं",
  T_46_META_WS_REMOVEVEHICLESKIN: "वाहन की त्वचा हटाएं",
  T_46_META_WS_REMOVEWEAPONSKIN: "हथियार की त्वचा हटाएं",
  T_46_META_WS_REPLACE: "बदलें",
  T_46_META_WS_REQUESTMATCHMAKING: "मैचमेकिंग का अनुरोध करें",
  T_46_META_WS_RESET: "रीसेट",
  T_46_META_WS_RESETBACKPACKSKIN: "बैकपैक की त्वचा को रीसेट करें",
  T_46_META_WS_RESETDYEING: "रंगाई रीसेट करें",
  T_46_META_WS_RESETJERSEY: "जर्सी रीसेट करें",
  T_46_META_WS_RESETOUTFIT: "परिधान रीसेट करें",
  T_46_META_WS_RESETVEHICLESKIN: "वाहन की त्वचा को रीसेट करें",
  T_46_META_WS_RESETWEAPONSKIN: "हथियार की त्वचा रीसेट करें",
  T_46_META_WS_RESUMEFIXEDUPDATE: "स्थिर अपडेट को फिर से शुरू करें",
  T_46_META_WS_REVERSE: "पलटें",
  T_46_META_WS_REVIVALSOURCE: "पुनर्जीवन स्रोत",
  T_46_META_WS_REVIVE: "पुनर्जीवित करें",
  T_46_META_WS_ROUND: "गोल करें",
  T_46_META_WS_ROUNDINDEX: "राउंड सूचकांक",
  T_46_META_WS_SAMPLEONCURVE: "कर्व पर सैंपल लें",
  T_46_META_WS_SCENENAME: "दृश्य का नाम",
  T_46_META_WS_SCORE: "स्कोर",
  T_46_META_WS_SCORER: "गोल करने वाला",
  T_46_META_WS_SCORETYPE: "स्कोर प्रकार",
  T_46_META_WS_SCREENMULTIRAYCAST: "स्क्रीन मल्टी-रेकास्ट",
  T_46_META_WS_SCREENSINGLERAYCAST: "स्क्रीन सिंगल रेcast",
  T_46_META_WS_SCREENTOUCHRAY: "स्क्रीन टच रेज",
  T_46_META_WS_SCREENTOWORLDPOINT: "स्क्रीन से वर्ल्ड",
  T_46_META_WS_SENDEVENT: "इवेंट भेजें",
  T_46_META_WS_SETACTIVE: "सक्रिय सेट करें",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "सभी खिलाड़ियों की मूवमेंट स्थिति सेट करें",
  T_46_META_WS_SETATTACKABLEENTITY: "आक्रमण योग्य एंटिटी सेट करें",
  T_46_META_WS_SETATTACKABLEFACTION: "आक्रमण योग्य गुट सेट करें",
  T_46_META_WS_SETATTACKABLETEAM: "आक्रमण योग्य टीम सेट करें",
  T_46_META_WS_SETBACKPACKSKIN: "बैकपैक की त्वचा सेट करें",
  T_46_META_WS_SETBEHAVIORSTATUS: "व्यवहार स्थिति सेट करें",
  T_46_META_WS_SETBLACKBOARDVALUE: "ब्लैकबोर्ड मूल्य सेट करें",
  T_46_META_WS_SETBUNDLE: "बंडल सेट करें",
  T_46_META_WS_SETCAMERAFOCUS: "कैमरा फ़ोकस सेट करें",
  T_46_META_WS_SETCAMERAFOLLOW: "कैमरा को फ़ॉलो सेट करें",
  T_46_META_WS_SETCHARACTER: "चरित्र सेट करें",
  T_46_META_WS_SETCULLINGMASK: "कूलिंग मास्क सेट करें",
  T_46_META_WS_SETCULLINGMASKLAYER: "कूलिंग मास्क लेयर सेट करें",
  T_46_META_WS_SETDEFAULTUISTATUS: "डिफ़ॉल्ट UI स्थिति सेट करें",
  T_46_META_WS_SETDROPSTATUS: "ड्रॉप स्थिति सेट करें",
  T_46_META_WS_SETFALLINGDAMAGE: "गिरने की क्षति सेट करें",
  T_46_META_WS_SETFOOTBALLPOSITION: "फुटबॉल की स्थिति सेट करें",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "फॉर्मूला प्रॉपर्टी पूर्ण सेट करें",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "फॉर्मूला प्रॉपर्टी सापेक्ष सेट करें",
  T_46_META_WS_SETFORWARD: "दिशा सेट करें",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "वैश्विक सोने की सीमा सेट करें",
  T_46_META_WS_SETINVINCIBILITY: "अजेय स्थिति सेट करें",
  T_46_META_WS_SETJERSEY: "जर्सी सेट करें",
  T_46_META_WS_SETOUTFIT: "परिधान सेट करें",
  T_46_META_WS_SETPARENT: "पैरेंट सेट करें",
  T_46_META_WS_SETPARENTCLIENT: "पैरेंट सेट करें",
  T_46_META_WS_SETPICKUPSTATUS: "पिकअप स्थिति सेट करें",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "खिलाड़ी के त्वरित संदेश स्थिति सेट करें",
  T_46_META_WS_SETPLAYERVOICESTATUS: "खिलाड़ी की आवाज़ स्थिति सेट करें",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "प्रॉपर्टी को स्मूथली सेट करें",
  T_46_META_WS_SETSKILLS: "कौशल सेट करें",
  T_46_META_WS_SETSKYBOX: "स्काईबॉक्स सेट करें",
  T_46_META_WS_SETSLEEPTHRESHOLD: "सोने की सीमा सेट करें",
  T_46_META_WS_SETSPECIALITEMSTATUS: "विशेष आइटम की स्थिति सेट करें",
  T_46_META_WS_SETVEHICLESKIN: "वाहन की त्वचा सेट करें",
  T_46_META_WS_SETWEAPONSKIN: "हथियार की त्वचा सेट करें",
  T_46_META_WS_SETWIDGETPARENT: "विजेट का पैरेंट सेट करें",
  T_46_META_WS_SHOPITEM: "दुकान का आइटम",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "रूप बदलने वाला समूह दिखाएँ",
  T_46_META_WS_SHUFFLE: "शफल",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "सिंगल रीकास्ट",
  T_46_META_WS_SKILL: "कौशल",
  T_46_META_WS_SLEEP: "सोएं",
  T_46_META_WS_SLERPQUATERNION: "क्वाटरनियन स्लर्प",
  T_46_META_WS_SPAWNABLES: "उत्पन्न वस्तुएं",
  T_46_META_WS_SPAWNEDITEM: "उत्पन्न आइटम",
  T_46_META_WS_SPAWNNEXTWAVE: "अगली लहर उत्पन्न करें",
  T_46_META_WS_SPHERECAST: "स्फीयर कास्ट",
  T_46_META_WS_SPHEREOVERLAP: "स्फीयर ओवरलैप",
  T_46_META_WS_SPLIT: "विभाजित करें",
  T_46_META_WS_SQRT: "वर्गमूल",
  T_46_META_WS_STARTPARACHUTE: "पैराशूट शुरू करें",
  T_46_META_WS_STARTPOSITION: "प्रारंभिक स्थान",
  T_46_META_WS_STATENAME: "स्थिति का नाम",
  T_46_META_WS_STATUS: "स्थिति",
  T_46_META_WS_STRINGTOFLOAT: "स्ट्रिंग को फ्लोट में बदलें",
  T_46_META_WS_STRINGTOINT: "स्ट्रिंग को पूर्णांक में बदलें",
  T_46_META_WS_STRIP: "स्ट्रिंग के किनारे से सफेद स्थान हटा दें",
  T_46_META_WS_SUB: "घटाएं",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI प्रॉक्सी पर्यवेक्षक स्विच करें",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "रूप बदलने वाला समूह स्विच करें",
  T_46_META_WS_SWITCHAREA: "क्षेत्र स्विच करें",
  T_46_META_WS_SWITCHCAMERA: "कैमरा स्विच करें",
  T_46_META_WS_SWITCHPHASE: "चरण स्विच करें",
  T_46_META_WS_SWITCHSCENE: "सीन स्विच करें",
  T_46_META_WS_SWITCHWEAPON: "हथियार बदलें",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "लक्ष्य",
  T_46_META_WS_TEAM: "टीम",
  T_46_META_WS_TELEPORT: "टेलीपोर्ट करें",
  T_46_META_WS_TELEPORTCCT: "CCT को टेलीपोर्ट करें",
  T_46_META_WS_TEXT: "पाठ",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "टाइमस्टैम्प को स्थानीयकृत स्ट्रिंग में बदलें",
  T_46_META_WS_TIRE: "टायर",
  T_46_META_WS_TOLOWER: "छोटे अक्षरों में बदलें",
  T_46_META_WS_TOSTRING: "स्ट्रिंग में बदलें",
  T_46_META_WS_TOUPPER: "बड़े अक्षरों में बदलें",
  T_46_META_WS_TRANSFERMONEY: "पैसा ट्रांसफर करें",
  T_46_META_WS_TRIGGER: "ट्रिगर",
  T_46_META_WS_TYPEIS: "प्रकार है",
  T_46_META_WS_UNLOADSCENE: "सीन अनलोड करें",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "जेलब्रेक मिशन अपडेट करें",
  T_46_META_WS_UPLOADGAMERESULT: "गेम परिणाम अपलोड करें",
  T_46_META_WS_VALUE: "क्षति",
  T_46_META_WS_VECTOR2ANGLE: "2D वेक्टर कोण",
  T_46_META_WS_VECTOR2DISTANCE: "2D वेक्टर की दूरी",
  T_46_META_WS_VECTOR2DOT: "2D वेक्टर डॉट",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D वेक्टर परिमाण",
  T_46_META_WS_VECTOR2NORMALIZE: "2D वेक्टर सामान्य",
  T_46_META_WS_VECTOR2REFLECT: "2D वेक्टर परावर्तन",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D से 3D वेक्टर",
  T_46_META_WS_VECTOR3REFLECT: "3D वेक्टर परावर्तन",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D से 2D वेक्टर",
  T_46_META_WS_VEHICLE: "वाहन",
  T_46_META_WS_VELOCITY: "गति",
  T_46_META_WS_WAITFORMILESECOND: "मिलिसेकंड का इंतजार करें",
  T_46_META_WS_WAITFORNEXTFRAME: "अगले फ्रेम का इंतजार करें",
  T_46_META_WS_WAKEUP: "उठें",
  T_46_META_WS_WAVES: "तरंगें",
  T_46_META_WS_WEAPON: "हथियार",
  T_46_META_WS_WORLDTOSCREENPOINT: "वर्ल्ड से स्क्रीन",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "संचित डेटा स्टोर में लिखें",
  T_46_META_WS_WRITETODATASTORE: "डेटा स्टोर में लिखें",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "लीडरबोर्ड डेटा स्टोर में लिखें",
  T_48_META_API_1_D: "वर्तमान गेम में सभी खिलाड़ियों को प्राप्त करें और खिलाड़ी सूची पर वापस लौटें।",
  T_48_META_API_1_R_D: "खिलाड़ी सूची",
  T_48_META_API_10_D: "दृश्य वस्तुएँ प्राप्त करें",
  T_48_META_API_10_P0_D: "किस प्रकार के दृश्य ऑब्जेक्ट को फ़िल्टर करना है",
  T_48_META_API_10_R_D: "दृश्य वस्तु सूची",
  T_48_META_API_100_D: "लोड हो रहे दृश्य पहले से लोड किए गए दृश्यों को स्वचालित रूप से अनलोड नहीं करेंगे।",
  T_48_META_API_100_P0_D: "लोड करने के लिए दृश्य आईडी",
  T_48_META_API_10000_D: "वर्तमान स्क्रिप्ट से जुड़ी इकाई लौटाता है",
  T_48_META_API_10000_R_D: "वर्तमान स्क्रिप्ट से बंधी इकाई",
  T_48_META_API_10001_D: "संबंधित इकाई को खोजने के लिए इकाई आईडी का उपयोग करें। यह एपीआई केवल संपादक द्वारा उपयोग किया जाता है। उपयोगकर्ता पक्ष पर इस एपीआई का उपयोग इसकी अनुकूलता, जैसे हटाने या समायोजन की गारंटी नहीं दे सकता है।",
  T_48_META_API_10001_P0_D: "लक्ष्य इकाई आईडी",
  T_48_META_API_10001_R_D: "इकाई",
  T_48_META_API_10002_D: "गेम की वैश्विक इकाई प्राप्त करें",
  T_48_META_API_10002_R_D: "वैश्विक इकाई",
  T_48_META_API_10003_D: "प्लेयर को विशिष्ट निर्देशांक पर टेलीपोर्ट करें (अप्रचलित, कृपया टेलीपोर्ट का उपयोग करें)",
  T_48_META_API_10003_P0_D: "टेलीपोर्टेड प्लेयर",
  T_48_META_API_10003_P1_D: "टेलीपोर्टेड बिंदु के निर्देशांक",
  T_48_META_API_10004_D: "टीम के साथियों के निकट स्थिति प्राप्त करें और उन खिलाड़ियों की स्थिति से बचें जो खड़े नहीं हो सकते (अप्रचलित, कृपया GetTeammateNearPosition का उपयोग करें)",
  T_48_META_API_10004_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10004_R_D: "टीम के साथियों के निकट समन्वय",
  T_48_META_API_10005_D: "उस खिलाड़ी को प्राप्त करें जो इकाई का स्वामी है",
  T_48_META_API_10005_P0_D: "लक्ष्य इकाई, इकाई केवल उस प्लेयर के साथ सिंक्रनाइज़ की जाएगी जिससे वह संबंधित है",
  T_48_META_API_10005_R_D: "वह खिलाड़ी जिससे लक्ष्य इकाई संबंधित है",
  T_48_META_API_10006_D: "खिलाड़ी को अजेय बनायें",
  T_48_META_API_10006_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10006_P1_D: "अजेयता प्रभाव की अवधि, सेकंड में",
  T_48_META_API_10007_D: "चयनित इकाई और उसकी सभी संपत्तियों को उसके मूल स्थान पर क्लोन करें",
  T_48_META_API_10007_P0_D: "इकाई बनाई गई",
  T_48_META_API_10007_P1_D: "क्लोन की जाने वाली इकाई",
  T_48_META_API_10008_D: "खिलाड़ी को क्षति पहुंचाता है। यदि कोई क्षति स्रोत नहीं चुना गया है, तो लक्ष्य को सिस्टम से क्षति प्राप्त होगी।",
  T_48_META_API_10008_P0_D: "क्षतिग्रस्त खेल इकाई",
  T_48_META_API_10008_P1_D: "गेम इकाई जो क्षति पहुंचाती है",
  T_48_META_API_10008_P2_D: "क्षति का प्रकार",
  T_48_META_API_10008_P3_D: "हानि",
  T_48_META_API_10009_D: "नामित खिलाड़ी का पुनरुत्थान",
  T_48_META_API_10009_P0_D: "पुनर्जीवित खिलाड़ी",
  T_48_META_API_1001_D: "यदि शर्तें पूरी होती हैं, तो IF के तहत नोड चलाया जाएगा। जब शर्तें पूरी नहीं होती हैं, यदि ELSE है, तो ELSE के नीचे नोड चलाएँ, अन्यथा IF कथन समाप्त करें।",
  T_48_META_API_1001_P0_D: "शर्त सूची को उप-प्रक्रिया सूचियों (तार्किक शाखा सूचियों) की संख्या के अनुरूप होना चाहिए",
  T_48_META_API_10010_D: "किसी निर्दिष्ट स्थान पर एक आइटम या आइटमों की सूची बनाता है।",
  T_48_META_API_10010_P0_D: "आइटम निर्माण स्थान",
  T_48_META_API_10010_P1_D: "बनाई गई वस्तु या वस्तुओं की सूची",
  T_48_META_API_10010_P2_D: "बनाई गई वस्तुओं की संख्या। आइटम सूची बनाते समय, आपको आइटम सूची के क्रम के अनुरूप आइटम मात्रा सूची भरनी होगी।",
  T_48_META_API_10011_D: "एआई इकाई लक्ष्य बिंदु तक गश्त करती है",
  T_48_META_API_10011_P0_D: "लक्ष्य एआई इकाई",
  T_48_META_API_10011_P1_D: "गतिशील लक्ष्य बिंदु",
  T_48_META_API_10011_P2_D: "क्या शुरुआती बिंदु पर वापस लौटना है",
  T_48_META_API_10011_P3_D: "गश्त के दौरान शत्रुतापूर्ण लक्ष्यों का पता लगाना और उन पर हमला करना है या नहीं",
  T_48_META_API_10012_D: "एआई इकाइयां समन्वय सूची के अनुसार क्रम में गश्त करती हैं",
  T_48_META_API_10012_P0_D: "लक्ष्य एआई इकाई",
  T_48_META_API_10012_P1_D: "चलती निर्देशांक बिंदु सूची",
  T_48_META_API_10012_P2_D: "गश्ती प्रकार, आप एकल, राउंड ट्रिप या साइकिल चुन सकते हैं",
  T_48_META_API_10012_P3_D: "गश्त के दौरान शत्रुतापूर्ण लक्ष्यों का पता लगाना और उन पर हमला करना है या नहीं",
  T_48_META_API_10013_D: "जनरेटर तुरंत इकाई संस्थाओं की अगली लहर को ताज़ा करता है",
  T_48_META_API_10013_P0_D: "जनरेटर इकाई",
  T_48_META_API_10014_D: "गणना योग्य विशेषताओं के लिए जोड़े गए गणना कारक। गणना योग्य विशेषताएं कारकों से बने सूत्र के माध्यम से अंतिम परिणाम की गणना करेंगी।",
  T_48_META_API_10014_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10014_P1_D: "गणना योग्य संपत्ति प्रकार",
  T_48_META_API_10014_P2_D: "कारक प्रकार की गणना करें",
  T_48_META_API_10014_P3_D: "कारक मानों की गणना करें",
  T_48_META_API_10015_D: "परिकलित संपत्तियों के लिए स्पष्ट गणना कारक",
  T_48_META_API_10015_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10015_P1_D: "गणना योग्य संपत्ति प्रकार",
  T_48_META_API_10016_D: "लक्ष्य इकाई के सभी परिकलित गुणों के लिए सभी परिकलित कारकों को साफ़ करता है",
  T_48_META_API_10016_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10017_D: "गुणों को संशोधित करें",
  T_48_META_API_10017_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10017_P1_D: "सम्पत्ती के प्रकार",
  T_48_META_API_10017_P2_D: "संशोधन विधि",
  T_48_META_API_10017_P3_D: "कीमत",
  T_48_META_API_10018_D: "गणना की गई संपत्ति का मूल्य निर्धारित करें",
  T_48_META_API_10018_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10018_P1_D: "सम्पत्ती के प्रकार",
  T_48_META_API_10018_P2_D: "कीमत",
  T_48_META_API_10019_D: "एकल परिकलित संपत्ति संशोधन साफ़ करें",
  T_48_META_API_10019_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10019_P1_D: "सम्पत्ती के प्रकार",
  T_48_META_API_1002_D: "पैरामीटर i न्यूनतम मान से शुरू होता है, और हर बार जब निचला नोड चलाया जाता है, तो मैं चरण मान को तब तक बढ़ाता है जब तक कि i अधिकतम मान से अधिक या उसके बराबर न हो जाए।",
  T_48_META_API_1002_P0_D: "लूप इंडेक्स का नाम, जिसका उपयोग स्थानीय चर पर लूप इंडेक्स मान प्राप्त करने के लिए किया जा सकता है",
  T_48_META_API_1002_P1_D: "लूप प्रारंभिक मान",
  T_48_META_API_1002_P2_D: "लूप अंत मान",
  T_48_META_API_1002_P3_D: "लूप चरण का आकार, जब प्रारंभिक मान अंतिम मान से कम हो, तो चरण का आकार 0 से अधिक होना चाहिए, जब प्रारंभिक मान अंतिम मान से अधिक हो, तो चरण का आकार 0 से कम होना चाहिए",
  T_48_META_API_10020_D: "गेम में सभी इकाइयां प्राप्त करें जो फ़िल्टर शर्तों को पूरा करती हैं",
  T_48_META_API_10020_P0_D: "फ़िल्टर परिणामों में इस पैरामीटर में दर्ज प्रकार शामिल होना चाहिए",
  T_48_META_API_10020_P1_D: "फ़िल्टर परिणामों में इस पैरामीटर में दर्ज प्रकार शामिल नहीं होना चाहिए",
  T_48_META_API_10020_P2_D: "फ़िल्टर परिणामों में इस पैरामीटर में दर्ज किए गए प्रकारों में से कम से कम एक प्रकार शामिल होता है",
  T_48_META_API_10020_R_D: "परिणाम इकाई सूची फ़िल्टर करें",
  T_48_META_API_10021_D: "फ़ुटबॉल में गति जोड़ें। एक ही दिशा में त्वरण के कारण गति बदल जाएगी।",
  T_48_META_API_10021_P0_D: "गोल फुटबॉल",
  T_48_META_API_10021_P1_D: "3डी अंतरिक्ष वेग जोड़ा गया",
  T_48_META_API_10022_D: "निर्दिष्ट इकाई को नष्ट करें",
  T_48_META_API_10022_P0_D: "नष्ट की जाने वाली लक्ष्य इकाई",
  T_48_META_API_10023_D: "इकाइयों में टैग जोड़ें",
  T_48_META_API_10023_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10023_P1_D: "कस्टम लेबल",
  T_48_META_API_10024_D: "इकाइयों से लेबल हटाएँ",
  T_48_META_API_10024_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10024_P1_D: "कस्टम लेबल",
  T_48_META_API_10025_D: "निर्धारित करें कि लक्ष्य इकाई में निर्दिष्ट टैग शामिल है या नहीं",
  T_48_META_API_10025_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10025_P1_D: "कस्टम लेबल",
  T_48_META_API_10025_R_D: "निर्दिष्ट टैग शामिल करना है या नहीं",
  T_48_META_API_10026_D: "फुटबॉल की स्थिति निर्धारित करें",
  T_48_META_API_10026_P0_D: "फुटबॉल इकाई",
  T_48_META_API_10026_P1_D: "जगह",
  T_48_META_API_10026_P2_D: "गति बनाए रखें",
  T_48_META_API_10027_D: "लक्ष्य प्लेयर द्वारा वर्तमान में उपयोग की जाने वाली कैमरा इकाई प्राप्त करें",
  T_48_META_API_10027_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10027_R_D: "वर्तमान में प्रयुक्त कैमरा इकाई",
  T_48_META_API_10028_D: "लक्ष्य प्लेयर के कैमरे को लक्ष्य कैमरे पर स्विच करें,",
  T_48_META_API_10028_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10028_P1_D: "लक्ष्य कैमरा",
  T_48_META_API_10028_P2_D: "स्विचिंग मोड, आप मूल तर्क या प्रगतिशील रखना चुन सकते हैं",
  T_48_META_API_10028_P3_D: "स्विचिंग समय कैमरों को प्रगतिशील मोड में स्विच करने का समय है",
  T_48_META_API_10029_D: "एक कैमरा बनाएं",
  T_48_META_API_10029_P0_D: "कैमरा प्रकार बनाया गया",
  T_48_META_API_10029_P1_D: "कैमरा इकाई बनाई गई",
  T_48_META_API_1003_D: "डेटा कंटेनर के ट्रैवर्सल को कार्यान्वित करें, प्रत्येक उप-तत्व प्राप्त करें, और उप-प्रक्रियाएं शामिल करें। लूप बॉडी उप-प्रक्रिया है।",
  T_48_META_API_1003_P0_D: "चाइल्ड तत्व के नाम पर जाएं, आप इसका उपयोग स्थानीय चर पर चाइल्ड तत्व मान प्राप्त करने के लिए कर सकते हैं",
  T_48_META_API_1003_P1_D: "लूप इंडेक्स का नाम, जिसका उपयोग स्थानीय चर पर लूप इंडेक्स मान प्राप्त करने के लिए किया जा सकता है",
  T_48_META_API_1003_P2_D: "ट्रैवर्स किया जाने वाला डेटा कंटेनर वर्तमान में निम्न प्रकारों का समर्थन करता है: सरणी प्रकार",
  T_48_META_API_10030_D: "लड़ने योग्य संस्थाओं को मार डालो",
  T_48_META_API_10030_P0_D: "लक्ष्य इकाई, एक लड़ने योग्य इकाई होनी चाहिए",
  T_48_META_API_10031_D: "लक्ष्य इकाई और उसके चाइल्ड नोड्स की गतिविधि स्थिति सेट करें, निष्क्रिय वस्तुओं की उपलब्धता, दृश्यता, टकराव आदि बंद कर दिए जाएंगे।",
  T_48_META_API_10031_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10031_P1_D: "क्या यह सक्रिय है?",
  T_48_META_API_10032_D: "हमेशा लक्ष्य इकाई का अनुसरण करने के लिए कैमरा इकाई की स्थिति निर्धारित करें",
  T_48_META_API_10032_P0_D: "लक्ष्य कैमरा इकाई",
  T_48_META_API_10032_P1_D: "अनुसरण करने योग्य लक्ष्य इकाई",
  T_48_META_API_10032_P2_D: "लक्ष्य इकाई निर्देशांक से ऑफसेट",
  T_48_META_API_10032_P3_D: "ऑफसेट समन्वय प्रणाली",
  T_48_META_API_10033_D: "कैमरा इकाई को हमेशा लक्ष्य इकाई के सामने सेट करें",
  T_48_META_API_10033_P0_D: "लक्ष्य कैमरा इकाई",
  T_48_META_API_10033_P1_D: "लक्ष्य इकाई",
  T_48_META_API_10033_P2_D: "लक्ष्य निर्देशांक से निर्धारण बिंदु का ऑफसेट",
  T_48_META_API_10033_P3_D: "ऑफसेट समन्वय प्रणाली",
  T_48_META_API_10034_D: "ट्वीन्स बनाएं",
  T_48_META_API_10034_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10034_P1_D: "संपत्ति आईडी",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "डेस्टवैल",
  T_48_META_API_10034_P4_D: "शैली",
  T_48_META_API_10034_P5_D: "वक्र",
  T_48_META_API_10034_P6_D: "अवधि",
  T_48_META_API_10034_P7_D: "बीच इकाई",
  T_48_META_API_10035_D: "पैरेंट नोड सेट करें, जिसके लिए पैरेंट और बच्चे दोनों के पास ट्रांसफ़ॉर्म घटक होना आवश्यक है",
  T_48_META_API_10035_P0_D: "मूल नोड",
  T_48_META_API_10035_P1_D: "चाइल्ड नोड",
  T_48_META_API_10035_P2_D: "क्या चाइल्ड नोड्स की वर्तमान विश्व स्थिति, रोटेशन और स्केलिंग को बनाए रखना है। यूआई सेट करते समय यह आइटम अमान्य है।",
  T_48_META_API_10036_D: "NewCurve (अप्रत्याशित, कृपया CreateTweenCurve का उपयोग करें)",
  T_48_META_API_10036_P0_D: "नियंत्रण केंद्र",
  T_48_META_API_10036_R_D: "ट्वेनकर्वएंटिटी",
  T_48_META_API_10037_D: "लक्ष्य इकाई को चलाने का प्रयास, जिसमें खेलने योग्य घटक होने चाहिए",
  T_48_META_API_10037_P0_D: "खेलने योग्य इकाई को लक्षित करें",
  T_48_META_API_10037_P1_D: `दोबारा चलाना है या नहीं
सही: दोबारा चलाना
गलत: खेलना जारी रखें`,
  T_48_META_API_10038_D: "बजाने योग्य इकाई को रोकें",
  T_48_META_API_10038_P0_D: "खेलने योग्य इकाई को लक्षित करें",
  T_48_META_API_10039_D: "बैलिस्टिक गति बनाएं, जो लक्ष्य इकाई को प्रारंभिक वेग और दिशा के साथ त्वरण प्रदान करेगी",
  T_48_META_API_10039_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10039_P1_D: "गति का प्रारंभिक वेग",
  T_48_META_API_10039_P2_D: "गति त्वरण",
  T_48_META_API_10039_P3_D: "अधिकतम विस्थापन दूरी",
  T_48_META_API_10039_P4_D: "बैलिस्टिक मोशन इकाई बनाई गई",
  T_48_META_API_10039_P5_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_1004_D: "वर्तमान लूप प्रक्रिया को बाधित करें और लूप से बाहर निकलें",
  T_48_META_API_10040_D: "गति के बाद स्थिति बनाएं, लक्ष्य इकाई निर्दिष्ट वस्तु की गति का अनुसरण करेगी",
  T_48_META_API_10040_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10040_P1_D: "वस्तु इकाइयाँ जो गति का अनुसरण करती हैं",
  T_48_META_API_10040_P2_D: "दूरी लक्ष्य निर्देशांक के ऑफसेट का अनुसरण करती है",
  T_48_META_API_10040_P3_D: "समन्वय प्रणाली का प्रयोग किया गया",
  T_48_META_API_10040_P4_D: "निम्नलिखित गति इकाई बनाई गई",
  T_48_META_API_10040_P5_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_10041_D: "एक टकटकी-निम्नलिखित गति बनाएं जहां लक्ष्य इकाई निर्दिष्ट वस्तु का सामना करेगी",
  T_48_META_API_10041_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10041_P1_D: "वस्तु इकाई पर नजर रखी जा रही है",
  T_48_META_API_10041_P2_D: "वस्तु इकाई से टकटकी बिंदु का ऑफसेट",
  T_48_META_API_10041_P3_D: "समन्वय प्रणाली का प्रयोग किया गया",
  T_48_META_API_10041_P4_D: "टकटकी-निम्नलिखित गति इकाई बनाई गई",
  T_48_META_API_10041_P5_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_10042_D: "पदावनत",
  T_48_META_API_10042_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_10042_P1_D: "मैच का परिणाम",
  T_48_META_API_10042_P2_D: "पदावनत",
  T_48_META_API_10042_P3_D: "पदावनत",
  T_48_META_API_10042_P4_D: "पदावनत",
  T_48_META_API_10043_D: "लक्ष्य इकाई के गुणों को सुचारू रूप से सेट करें गुण तुरंत बदल जाएंगे, लेकिन क्लाइंट एक सुचारू संक्रमण प्रदर्शन करेगा।",
  T_48_META_API_10043_P0_D: "लक्ष्य इकाई",
  T_48_META_API_10043_P1_D: "लक्ष्य इकाई का एक गुण",
  T_48_META_API_10043_P2_D: "जब विशेषता परिभाषित की जाती है तो लक्ष्य मान को आवश्यक प्रकार के अनुरूप होना चाहिए।",
  T_48_META_API_10044_D: "किरण का पता लगाएं और किरण दिशा में पहली इकाई हिट लौटाएं। यदि स्तर पैरामीटर रिक्त स्थान में भरा गया है, तो इलाके का पता लगाया जा सकता है।",
  T_48_META_API_10044_P0_D: "प्रारंभ स्थिति निर्देशांक",
  T_48_META_API_10044_P1_D: "किरण पता लगाने की दिशा",
  T_48_META_API_10044_P2_D: "किरण पहचान दूरी, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_10044_P3_D: "रे डिटेक्शन लेयर मास्क, केवल भरे हुए स्तर ही स्कैन में भाग लेंगे, खाली छोड़ने का मतलब है कि सभी स्तर स्कैन में भाग लेंगे",
  T_48_META_API_10044_P4_D: "क्या ट्रिगर्स को स्कैन करना संभव है?",
  T_48_META_API_10044_P5_D: "हिट इकाई",
  T_48_META_API_10044_P6_D: "हिट बिंदु निर्देशांक",
  T_48_META_API_10044_P7_D: "हिट बिंदु से प्रारंभ बिंदु तक की दूरी",
  T_48_META_API_10044_P8_D: "सतह पर सामान्य प्रहार करें",
  T_48_META_API_10045_D: "एक किरण का पता लगाएं और किरण की दिशा में हिट की गई सभी इकाइयों को निकट से दूर की ओर लौटाएं, यदि स्तर पैरामीटर रिक्त स्थान में भरा गया है, तो इलाके का पता लगाया जा सकता है।",
  T_48_META_API_10045_P0_D: "प्रारंभ स्थिति निर्देशांक",
  T_48_META_API_10045_P1_D: "किरण पता लगाने की दिशा",
  T_48_META_API_10045_P2_D: "किरण पहचान दूरी, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_10045_P3_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_10045_P4_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_10045_P5_D: "हिट संस्थाओं की सूची",
  T_48_META_API_10045_P6_D: "हिट सूची",
  T_48_META_API_10045_P7_D: "हिट बिंदु दूरी प्रारंभ बिंदु दूरी सूची",
  T_48_META_API_10045_P8_D: "सतह पर सामान्य प्रहार करें",
  T_48_META_API_10046_D: "प्रीफ़ैब्स का उपयोग करके टेम्पलेट्स के लिए इकाइयाँ बनाएँ",
  T_48_META_API_10046_P0_D: "इकाई बनाई गई",
  T_48_META_API_10046_P1_D: "प्रीफैब आईडी",
  T_48_META_API_10047_D: "डाइंग",
  T_48_META_API_10047_P0_D: "ऑब्जेक्ट को सामान्य सेट करें",
  T_48_META_API_10047_P1_D: "रंगाई बिंदु निर्धारित करें",
  T_48_META_API_10047_P2_D: "रंग",
  T_48_META_API_10048_D: "धुंधला होने की स्थिति",
  T_48_META_API_10048_P0_D: "रंगाई बिंदु निर्धारित करें",
  T_48_META_API_10048_P1_D: "दिशा निर्धारित करें",
  T_48_META_API_10048_P2_D: "दूरी तय करें",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "धुंधला आँकड़े",
  T_48_META_API_10049_P0_D: "रंग",
  T_48_META_API_10049_R_D: "रंगाई की मात्रा",
  T_48_META_API_1005_D: "शेष लूप सामग्री को छोड़ें और सीधे अगले लूप पर जाएँ",
  T_48_META_API_10050_D: "समतलीय श्रेणी का धुंधलापन",
  T_48_META_API_10050_P0_D: "ऑब्जेक्ट को सामान्य सेट करें",
  T_48_META_API_10050_P1_D: "रंगाई बिंदु निर्धारित करें",
  T_48_META_API_10050_P2_D: "रंगाई रेंज निर्धारित करें",
  T_48_META_API_10050_P3_D: "रंग",
  T_48_META_API_10050_P4_D: "रंगाई की मात्रा",
  T_48_META_API_10051_D: "क्षेत्र का धुंधलापन",
  T_48_META_API_10051_P0_D: "ऑब्जेक्ट को सामान्य सेट करें",
  T_48_META_API_10051_P1_D: "रंगाई बिंदु निर्धारित करें",
  T_48_META_API_10051_P2_D: "रंगाई रेंज निर्धारित करें",
  T_48_META_API_10051_P3_D: "रंग",
  T_48_META_API_10051_P4_D: "दाग वाला क्षेत्र ठीक किया गया",
  T_48_META_API_10051_P5_D: "यादृच्छिक गुणांक",
  T_48_META_API_10051_P6_D: "यादृच्छिक क्षीणन गुणांक",
  T_48_META_API_10051_P7_D: "रंगाई की मात्रा",
  T_48_META_API_10052_D: "लक्ष्य पैरेंट नोड इकाई के सभी चाइल्ड नोड प्राप्त करें",
  T_48_META_API_10052_P0_D: "मूल नोड इकाई",
  T_48_META_API_10052_R_D: "चाइल्ड नोड्स की सूची",
  T_48_META_API_10053_D: "सूचकांक के आधार पर लक्ष्य पैरेंट नोड इकाई का निर्दिष्ट चाइल्ड नोड प्राप्त करें",
  T_48_META_API_10053_P0_D: "मूल नोड इकाई",
  T_48_META_API_10053_P1_D: "चाइल्ड नोड इंडेक्स",
  T_48_META_API_10053_R_D: "चाइल्ड नोड इकाई",
  T_48_META_API_10054_D: "लक्ष्य चाइल्ड नोड इकाई का मूल नोड प्राप्त करें",
  T_48_META_API_10054_P0_D: "चाइल्ड नोड इकाई",
  T_48_META_API_10054_R_D: "मूल नोड इकाई",
  T_48_META_API_10055_D: "निर्दिष्ट पैरेंट नोड इकाई के अंतर्गत सभी चाइल्ड नोड्स हटाएं। नोड में एक ट्रांसफ़ॉर्म घटक होना चाहिए",
  T_48_META_API_10055_P0_D: "मूल नोड इकाई",
  T_48_META_API_10056_D: "निर्दिष्ट स्थान पर टेलीपोर्ट लक्ष्य",
  T_48_META_API_10056_P0_D: "यूनिट को टेलीपोर्ट किया जा रहा है",
  T_48_META_API_10056_P1_D: "टेलीपोर्ट बिंदु निर्देशांक",
  T_48_META_API_10056_P2_D: "टेलीपोर्टेशन के बाद यूनिट का उन्मुखीकरण",
  T_48_META_API_10057_D: "यादृच्छिक टीम के साथियों के पास का स्थान प्राप्त करें, जब कोई टीम के साथी न हों तो अपने पास के निर्देशांक लौटाएँ, और उन खिलाड़ियों के स्थान से बचें जो खड़े नहीं हो सकते।",
  T_48_META_API_10057_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10057_R_D: "लक्ष्य खिलाड़ी के साथियों के निकट समन्वय",
  T_48_META_API_10058_D: "स्पष्ट दाग की स्थिति",
  T_48_META_API_10059_D: "निर्दिष्ट ध्वनि प्रभाव चलाएं। यदि अधिक विशेषताएँ सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसकी इकाई विशेषताएँ सेट करें।",
  T_48_META_API_10059_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो ध्वनि प्रभाव इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो ध्वनि प्रभाव बनाता है।",
  T_48_META_API_10059_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_10059_P2_D: "ध्वनि प्रभाव प्रकार, ध्वनि प्रभाव का प्रकार जिसे खिलाड़ी चुन सकते हैं",
  T_48_META_API_1006_D: "वर्तमान निष्पादन प्रक्रिया को समाप्त करें और सीधे कॉलिंग स्थान पर लौटें। आप डेटा के साथ वापस लौट सकते हैं।",
  T_48_META_API_1006_P0_D: "अपेक्षित डेटा कॉलिंग स्थान पर वापस आ जाएगा",
  T_48_META_API_10060_D: "लक्ष्य खिलाड़ी को खेल से बाहर करें",
  T_48_META_API_10060_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10060_P1_D: "बिलिंग जानकारी प्रदर्शित करनी है या नहीं",
  T_48_META_API_10061_D: "लक्ष्य खिलाड़ी निर्दिष्ट मानचित्र से मिलान करने का अनुरोध करता है",
  T_48_META_API_10061_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_10061_P1_D: "युद्धक्षेत्र कोड",
  T_48_META_API_10061_P2_D: "क्या मैच रद्द करते समय पॉप-अप विंडो आपको मूल गेम पर लौटने के लिए संकेत देती है",
  T_48_META_API_10062_D: "चल रहे ध्वनि प्रभाव इकाई को बाधित करें",
  T_48_META_API_10062_P0_D: "ध्वनि प्रभाव इकाई जिसे रोकने की आवश्यकता है",
  T_48_META_API_10063_D: "ध्वनि प्रभाव बजाना जारी रखें, आप चुन सकते हैं कि शुरुआत से बजाना शुरू करना है या नहीं",
  T_48_META_API_10063_P0_D: "ध्वनि प्रभाव इकाइयाँ जिन्हें रुकने के बाद भी बजाना जारी रखना होगा",
  T_48_META_API_10063_P1_D: "क्या शून्य से शुरू करना है",
  T_48_META_API_10064_D: "एक एयरड्रॉप बनाएं। एयरड्रॉप के तीन चरण हैं: 1. तैयारी, 2. गिरना, 3. एयरड्रॉप विशेषताओं को केवल स्थिति 1 में संशोधित किया जा सकता है।",
  T_48_META_API_10064_P0_D: "एयरड्रॉप बॉक्स इकाई बनाई गई",
  T_48_META_API_1007_D: "एक लूप लागू करें जो स्थिति सत्य है या नहीं, इसके आधार पर निष्पादित होता रहता है, जब तक कि स्थिति गलत न हो और लूप समाप्त न हो जाए।",
  T_48_META_API_1007_P0_D: "जब स्थिति सत्य होती है, तो लूप जारी रहता है, और जब स्थिति गलत होती है, तो लूप समाप्त हो जाता है।",
  T_48_META_API_1008_D: `अगले तार्किक फ्रेम की शुरुआत तक प्रतीक्षा करें
सर्वर पर, यदि कम फ्रेम दर मोड सक्षम है, तो प्रतीक्षा लंबी होगी
क्लाइंट पर, प्रतीक्षा समय डिवाइस के प्रदर्शन और वर्तमान फ्रेम की तर्क जटिलता से प्रभावित होता है
उपयोग करें इस एपीआई फ़ंक्शन को एसिंक घोषित कर`,
  T_48_META_API_1009_D: "एक निश्चित अवधि तक प्रतीक्षा करने के बाद, इस एपीआई का उपयोग करने वाले फ़ंक्शन को एसिंक के रूप में घोषित करने की आवश्यकता होती है।",
  T_48_META_API_1009_P0_D: "प्रतीक्षा समय, मिलीसेकंड में",
  T_48_META_API_101_D: "निर्दिष्ट दृश्य को अनइंस्टॉल करें",
  T_48_META_API_101_P0_D: "दृश्य आईडी को अनइंस्टॉल किया जाएगा",
  T_48_META_API_1010: "इवेंट कॉलबैक",
  T_48_META_API_1010_D: "कोई घटना घटित होने पर कार्रवाई शुरू हो जाती है",
  T_48_META_API_1010_P0: "इवेंट पैरामीटर नाम",
  T_48_META_API_1010_P0_D: "इवेंट पैरामीटर का औपचारिक पैरामीटर नाम, जिसके माध्यम से स्थानीय चर पर वास्तविक पैरामीटर मान प्राप्त किया जा सकता है",
  T_48_META_API_1011: "कोड ब्लॉक",
  T_48_META_API_1011_D: "कोड का एक ब्लॉक जिसमें एपीआई का संयोजन होता है",
  T_48_META_API_1011_P0: "पैरामीटर नाम",
  T_48_META_API_1011_P0_D: "जब कोड ब्लॉक एक कस्टम फ़ंक्शन होता है तो औपचारिक पैरामीटर नाम",
  T_48_META_API_1012: "सीरियल के साथ कस्टम API खोजें और लागू करें",
  T_48_META_API_1012_D: "कस्टम फ़ंक्शन को क्रमबद्ध तरीके से कॉल करें यदि कस्टम फ़ंक्शन में प्रतीक्षा है, तो कॉलिंग स्थान भी प्रतीक्षा करेगा।",
  T_48_META_API_1012_P0_D: "वह इकाई जहां कस्टम फ़ंक्शन रहता है",
  T_48_META_API_1012_P1: "ग्राफ आईडी",
  T_48_META_API_1012_P1_D: "स्क्रिप्ट आईडी जहां कस्टम फ़ंक्शन स्थित है",
  T_48_META_API_1012_P2: "फ़ंक्शन आईडी",
  T_48_META_API_1012_P2_D: "लक्ष्य द्वारा बुलायी गयी फ़ंक्शन आईडी",
  T_48_META_API_1012_P3_D: "कस्टम फ़ंक्शन को दिए गए तर्कों की सूची",
  T_48_META_API_1013: "समानांतर के साथ कस्टम API खोजें और लागू करें",
  T_48_META_API_1013_D: "किसी कस्टम फ़ंक्शन को समानांतर में कॉल करें, भले ही कस्टम फ़ंक्शन में कोई प्रतीक्षा हो, यह तुरंत कॉलिंग स्थान पर वापस आ जाएगा और निष्पादन जारी रखेगा।",
  T_48_META_API_1013_P0_D: "वह इकाई जहां कस्टम फ़ंक्शन रहता है",
  T_48_META_API_1013_P1: "ग्राफ आईडी",
  T_48_META_API_1013_P1_D: "स्क्रिप्ट आईडी जहां कस्टम फ़ंक्शन स्थित है",
  T_48_META_API_1013_P2: "फ़ंक्शन आईडी",
  T_48_META_API_1013_P2_D: "लक्ष्य द्वारा बुलायी गयी फ़ंक्शन आईडी",
  T_48_META_API_1013_P3_D: "कस्टम फ़ंक्शन को दिए गए तर्कों की सूची",
  T_48_META_API_1014: "सीरियल के साथ स्वयं कस्टम एपीआई खोजें और लागू करें",
  T_48_META_API_1014_D: "वर्तमान स्क्रिप्ट में कस्टम फ़ंक्शन को सीरियल मोड में कॉल करें। यदि कस्टम फ़ंक्शन में प्रतीक्षा है, तो कॉलिंग स्थान भी प्रतीक्षा करेगा।",
  T_48_META_API_1014_P0: "फ़ंक्शन आईडी",
  T_48_META_API_1014_P0_D: "लक्ष्य द्वारा बुलायी गयी फ़ंक्शन आईडी",
  T_48_META_API_1014_P1_D: "कस्टम फ़ंक्शन को दिए गए तर्कों की सूची",
  T_48_META_API_1015: "समानांतर के साथ स्वयं कस्टम एपीआई खोजें और लागू करें",
  T_48_META_API_1015_D: "किसी कस्टम फ़ंक्शन को समानांतर में कॉल करें, भले ही कस्टम फ़ंक्शन में कोई प्रतीक्षा हो, यह तुरंत कॉलिंग स्थान पर वापस आ जाएगा और निष्पादन जारी रखेगा।",
  T_48_META_API_1015_P0: "इंडेक्स द्वारा स्थानीय चर सेट करें",
  T_48_META_API_1015_P0_D: "लक्ष्य द्वारा बुलायी गयी फ़ंक्शन आईडी",
  T_48_META_API_1015_P1_D: "कस्टम फ़ंक्शन को दिए गए तर्कों की सूची",
  T_48_META_API_1016_D: "इस एपीआई को कॉल करते समय लक्ष्य का प्रकार प्राप्त होता है",
  T_48_META_API_1016_P0_D: "लक्ष्य से पूछताछ की जा रही है",
  T_48_META_API_1016_R_D: "परिवर्तनशील प्रकार",
  T_48_META_API_1017_D: "निर्धारित करें कि लक्ष्य चर निर्दिष्ट प्रकार का है या नहीं",
  T_48_META_API_1017_P0_D: "लक्ष्य से पूछताछ की जा रही है",
  T_48_META_API_1017_P1_D: "प्रकार की तुलना की जा रही है",
  T_48_META_API_1017_R_D: "क्या यह सुसंगत है?",
  T_48_META_API_1018_D: "निर्धारित करें कि क्या लक्ष्य चर एक निश्चित प्रकार का उपवर्ग है, और रिटर्न मान एक बूलियन मान है",
  T_48_META_API_1018_P0_D: "लक्ष्य चर से पूछताछ की जा रही है",
  T_48_META_API_1018_P1_D: "प्रकार की तुलना की जा रही है",
  T_48_META_API_1018_R_D: "चाहे वह उपवर्ग हो",
  T_48_META_API_1019_D: "निर्दिष्ट कस्टम ईवेंट को ट्रिगर करने के लिए लक्ष्य इकाई का कारण बनें",
  T_48_META_API_1019_P0_D: "कस्टम ईवेंट आईडी भेजा गया",
  T_48_META_API_1019_P1_D: "लक्ष्य इकाई",
  T_48_META_API_1019_P2_D: "पैरामीटर सूची",
  T_48_META_API_102_D: "निर्दिष्ट दृश्य पर स्विच करने से अन्य लोड किए गए दृश्य अनलोड हो जाएंगे।",
  T_48_META_API_102_P0_D: "स्विच करने के लिए दृश्य आईडी",
  T_48_META_API_1020_D: "एक कंटेनर के ट्रैवर्सल को कार्यान्वित करें और उप-प्रक्रियाओं सहित प्रत्येक कुंजी-मूल्य जोड़ी प्राप्त करें। लूप बॉडी उप-प्रक्रिया है।",
  T_48_META_API_1020_P0_D: "कुंजी के नाम पर जाएँ, आप इसका उपयोग स्थानीय चर पर कुंजी मान प्राप्त करने के लिए कर सकते हैं",
  T_48_META_API_1020_P1_D: "मान के नाम पर ट्रैवर्स करें, जिसका उपयोग स्थानीय चर पर मान प्राप्त करने के लिए किया जा सकता है",
  T_48_META_API_1020_P2_D: "पार करने के लिए कंटेनर",
  T_48_META_API_1021_D: "निर्दिष्ट बॉट को नष्ट करें",
  T_48_META_API_1021_P0_D: "बॉट खिलाड़ी जिन्हें नष्ट किया जाना आवश्यक है",
  T_48_META_API_1022_D: "लक्ष्य खिलाड़ी को वाहन छोड़ने के लिए बाध्य करें",
  T_48_META_API_1022_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1023_D: "डैमेज जंप शब्द बनाएं",
  T_48_META_API_1023_P0_D: "शब्द सामग्री छोड़ें",
  T_48_META_API_1023_P1_D: "फ़ॉन्ट आकार",
  T_48_META_API_1023_P2_D: "फ़ॉन्ट रंग",
  T_48_META_API_1023_P3_D: "ठहरने की अवधि मिलीसेकंड में",
  T_48_META_API_1023_P4_D: "क्षतिग्रस्त इकाई",
  T_48_META_API_1023_P5_D: "लक्ष्य इकाई के विश्व निर्देशांक के सापेक्ष क्षति कूद शब्द की भरपाई",
  T_48_META_API_1023_P6_D: "क्षति कूद स्थिति पर फिर से यादृच्छिक स्थिति सुधार की सीमा का आकार",
  T_48_META_API_1023_P7_D: "क्या ट्विन एनिमेशन निष्पादित करना है",
  T_48_META_API_1024_D: "पदावनत",
  T_48_META_API_1024_P0_D: "पदावनत",
  T_48_META_API_1024_P1_D: "लक्ष्य इकाई",
  T_48_META_API_1024_P2_D: "चयन करने के बाद, यदि सर्वर पर कॉल किया जाता है, तो इसे क्लाइंट को भेजा जाएगा, यदि क्लाइंट पर कॉल किया जाता है, तो इसे सर्वर पर भेजा जाएगा।",
  T_48_META_API_1024_P3_D: "पैरामीटर सूची",
  T_48_META_API_1025_D: "कस्टम कार्य प्रगति क्वेरी करें",
  T_48_META_API_1025_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1025_P1_D: "कस्टम कार्य आईडी",
  T_48_META_API_1025_R_D: "कार्य प्रगति",
  T_48_META_API_1026_D: "लक्ष्य खिलाड़ी की बैकपैक त्वचा प्राप्त करें",
  T_48_META_API_1026_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1026_R_D: "बैकपैक त्वचा आईडी",
  T_48_META_API_1027_D: "लक्ष्य खिलाड़ी की बैकपैक स्किन सेट करें",
  T_48_META_API_1027_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1027_P1_D: "बैकपैक त्वचा आईडी",
  T_48_META_API_1028_D: "लक्ष्य खिलाड़ी की बैकपैक त्वचा को डिफ़ॉल्ट बाहरी कॉन्फ़िगरेशन पर पुनर्स्थापित करें",
  T_48_META_API_1028_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1029_D: "लक्ष्य खिलाड़ी की बैकपैक त्वचा साफ़ करें",
  T_48_META_API_1029_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_103_D: "गेम की स्काईबॉक्स पर्यावरण शैली बदलें, आप दिन, शाम, रात आदि चुन सकते हैं।",
  T_48_META_API_103_P0_D: "स्काईबॉक्स प्रकार",
  T_48_META_API_1030_D: "हड्डी लटकने वाले बिंदु का स्थान नाम से प्राप्त करें",
  T_48_META_API_1030_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1030_P1_D: "हड्डी लटकने वाले बिंदु का नाम",
  T_48_META_API_1030_R_D: "हड्डी की बिंदु",
  T_48_META_API_1031_D: "ऑब्जेक्ट इकाई के मूल नोड को सेट करें, ट्रांसफॉर्म, स्केलेटनपार्ट, प्लेयर और माउंटप्वाइंट घटकों के साथ माउंटेड इकाइयों का समर्थन करें।",
  T_48_META_API_1031_P0_D: "मूल नोड",
  T_48_META_API_1031_P1_D: "चाइल्ड नोड",
  T_48_META_API_1031_P2_D: "चाइल्ड नोड्स की वर्तमान विश्व स्थिति, रोटेशन और स्केलिंग को बनाए रखना है या नहीं, यदि यूआई द्वारा सेट किया गया है तो यह आइटम अमान्य है।",
  T_48_META_API_1032_D: "आइकन एनीमेशन प्रभाव चलाएं, आइकन प्लेबैक गति पर प्रारंभिक स्थिति से अंतिम स्थिति तक अनुवाद करता है",
  T_48_META_API_1032_P0_D: "चिह्न संसाधन आईडी",
  T_48_META_API_1032_P1_D: "रंग",
  T_48_META_API_1032_P2_D: "चिह्न ज़ूम",
  T_48_META_API_1032_P3_D: "प्रारंभिक स्थिति केंद्र",
  T_48_META_API_1032_P4_D: "आरंभिक क्षेत्र सीमा",
  T_48_META_API_1032_P5_D: "अंत स्थिति केंद्र",
  T_48_META_API_1032_P6_D: "अंतिम स्थिति सीमा",
  T_48_META_API_1032_P7_D: "प्लेबैक गति वह दूरी है जो प्रति सेकंड आइकन चलती है",
  T_48_META_API_1033_D: "कोण प्राप्त करने के लिए आर्कटेंजेंट ऑपरेशन करें",
  T_48_META_API_1033_P0_D: "Y अक्ष समन्वय",
  T_48_META_API_1033_P1_D: "एक्स-अक्ष समन्वय",
  T_48_META_API_1033_R_D: "कोण, सीमा (-180, 180]",
  T_48_META_API_1034_D: "इकाइयों में घटक जोड़ें। केवल उपयोगकर्ता द्वारा निर्मित कस्टम घटक समर्थित हैं।",
  T_48_META_API_1034_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1034_P1_D: "घटक प्रकार आईडी, केवल उपयोगकर्ता-निर्मित कस्टम घटकों का समर्थन करता है",
  T_48_META_API_1034_P2_D: "चाहे इसे सफलतापूर्वक जोड़ा गया हो, मौजूदा घटक या गैर-कस्टम घटक जोड़े जाने में विफल रहेंगे।",
  T_48_META_API_1035_D: "इकाइयों से घटकों को हटाएँ और केवल कस्टम घटकों का समर्थन करें",
  T_48_META_API_1035_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1035_P1_D: "घटक प्रकार आईडी, केवल उपयोगकर्ता-निर्मित कस्टम घटकों का समर्थन करता है",
  T_48_META_API_1035_P2_D: "चाहे निष्कासन सफल हो या नहीं, गैर-मौजूदा घटक या गैर-कस्टम घटक हटाए जाने में विफल रहेंगे।",
  T_48_META_API_1036_D: "प्लेयर निकास इंटरफ़ेस को बीच में ही अनुकूलित करें",
  T_48_META_API_1036_P0_D: "शीर्षक",
  T_48_META_API_1036_P1_D: "सामग्री",
  T_48_META_API_1036_P2_D: "विकल्प",
  T_48_META_API_1036_P3_D: "क्या पृष्ठभूमि प्रदर्शित करनी है",
  T_48_META_API_1037_D: "वर्तमान में लोड किए गए सभी दृश्य प्राप्त करें",
  T_48_META_API_1037_R_D: "दृश्य सूची",
  T_48_META_API_1038_D: "खिलाड़ी की स्थानीय लक्ष्य दिशा प्राप्त करें",
  T_48_META_API_1038_R_D: "लक्ष्य दिशा",
  T_48_META_API_1039_D: "स्थानीय टाइमस्टैम्प प्राप्त करें",
  T_48_META_API_1039_R_D: "समय-चिह्न",
  T_48_META_API_104_D: "प्लेयर को निर्दिष्ट दृश्य की निर्दिष्ट स्थिति पर स्विच करें, अनलोड किए गए दृश्य स्वचालित रूप से लोड हो जाएंगे, और लोड किए गए दृश्य स्वचालित रूप से अनलोड नहीं होंगे।",
  T_48_META_API_104_P0_D: "खिलाड़ी",
  T_48_META_API_104_P1_D: "लोड करने के लिए दृश्य आईडी",
  T_48_META_API_104_P2_D: "नये दृश्य में खिलाड़ी की स्थिति",
  T_48_META_API_104_P3_D: "नये दृश्य में खिलाड़ी का उन्मुखीकरण",
  T_48_META_API_1040_D: "वर्तमान प्लेटफ़ॉर्म के निश्चित फ़्रेम अपडेट को रोकें। विराम के बाद, प्लेटफ़ॉर्म का निश्चित फ़्रेम अपडेट इवेंट अब ट्रिगर नहीं होगा।",
  T_48_META_API_1041_D: "वर्तमान प्लेटफ़ॉर्म के निश्चित फ़्रेम अपडेट को फिर से शुरू करें पुनर्प्राप्ति के बाद, प्लेटफ़ॉर्म का निश्चित फ़्रेम अपडेट इवेंट फिर से ट्रिगर होना शुरू हो जाता है।",
  T_48_META_API_1042_D: "लक्ष्य खिलाड़ी और वर्तमान ग्राहक खिलाड़ी के बीच मित्र संबंध निर्धारित करें। वर्तमान ग्राहक स्वयं वर्तमान ग्राहक का मित्र नहीं है।",
  T_48_META_API_1042_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1042_R_D: "चाहे आप वर्तमान ग्राहक के मित्र हों",
  T_48_META_API_1043_D: "ट्रिगर कस्टम इवेंट",
  T_48_META_API_1043_P0_D: "कस्टम ईवेंट आईडी",
  T_48_META_API_1043_P1_D: "लक्ष्य इकाई",
  T_48_META_API_1043_P2_D: "रनिंग प्लेटफ़ॉर्म सर्वर या क्लाइंट है",
  T_48_META_API_1043_P3_D: "पैरामीटर सूची",
  T_48_META_API_1044_D: "स्काइडाइविंग शुरू करें",
  T_48_META_API_1044_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1044_P1_D: "इस ऊंचाई के नीचे, पैराशूट को खोलने के लिए मजबूर किया जाएगा",
  T_48_META_API_1044_P2_D: "फिसलते समय गति, एक्स घटक क्षैतिज गति का प्रतिनिधित्व करता है, और वाई घटक ऊर्ध्वाधर गति का प्रतिनिधित्व करता है जब वाई घटक नकारात्मक होता है, तो खिलाड़ी नीचे की ओर उतरता है",
  T_48_META_API_1044_P3_D: "गोता लगाते समय गति, एक्स घटक क्षैतिज गति का प्रतिनिधित्व करता है, और वाई घटक ऊर्ध्वाधर गति का प्रतिनिधित्व करता है जब वाई घटक नकारात्मक होता है, तो खिलाड़ी नीचे की ओर गिरता है",
  T_48_META_API_1044_P4_D: "छाता खोलते समय गति, एक्स घटक क्षैतिज गति का प्रतिनिधित्व करता है, और वाई घटक ऊर्ध्वाधर गति का प्रतिनिधित्व करता है जब वाई घटक नकारात्मक होता है, तो खिलाड़ी नीचे की ओर उतरता है",
  T_48_META_API_1045_D: "डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान पढ़ें",
  T_48_META_API_1045_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_1045_P1_D: "प्लेयर यूनिक आईडी",
  T_48_META_API_1045_P2_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1045_P3_D: "परिणाम पढ़ें",
  T_48_META_API_1045_P4_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1045_P5_D: "त्रुटि कोड",
  T_48_META_API_1046_D: "रैंकिंग डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान पढ़ें",
  T_48_META_API_1046_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_1046_P1_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1046_P2_D: "परिणाम पढ़ें",
  T_48_META_API_1046_P3_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1046_P4_D: "त्रुटि कोड",
  T_48_META_API_1047_D: "रैंकिंग डेटा तालिका में निर्दिष्ट रैंकिंग अंतराल का मान पढ़ें",
  T_48_META_API_1047_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_1047_P1_D: "प्रारंभिक रैंक अंतिम रैंक से कम या बराबर होनी चाहिए, और रैंक 1 से शुरू होनी चाहिए",
  T_48_META_API_1047_P2_D: "अंत रैंकिंग",
  T_48_META_API_1047_P3_D: "परिणाम पढ़ें",
  T_48_META_API_1047_P4_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1047_P5_D: "त्रुटि कोड",
  T_48_META_API_1048_D: "संचयी डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान पढ़ें",
  T_48_META_API_1048_P0_D: "डेटाबेस में संचित डेटा तालिका का नाम",
  T_48_META_API_1048_P1_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1048_P2_D: "परिणाम पढ़ें",
  T_48_META_API_1048_P3_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1048_P4_D: "त्रुटि कोड",
  T_48_META_API_1049_D: "डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान लिखें",
  T_48_META_API_1049_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_1049_P1_D: "प्लेयर यूनिक आईडी",
  T_48_META_API_1049_P2_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1049_P3_D: "मूल्य लिखा है",
  T_48_META_API_1049_P4_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1049_P5_D: "त्रुटि कोड",
  T_48_META_API_105_D: "दृश्य का स्काईबॉक्स प्राप्त करें",
  T_48_META_API_105_P0_D: "दृश्य आईडी",
  T_48_META_API_105_R_D: "स्काईबॉक्स",
  T_48_META_API_1050_D: "सूची में तत्वों की संख्या प्राप्त करें",
  T_48_META_API_1050_P0_D: "लक्ष्य सूची",
  T_48_META_API_1050_R_D: "तत्वों की संख्या",
  T_48_META_API_1051_D: "सूची में निर्दिष्ट सूचकांक पर तत्व मान प्राप्त करें",
  T_48_META_API_1051_P0_D: "लक्ष्य सूची",
  T_48_META_API_1051_P1_D: "सूचकांक मान, 0 से प्रारंभ",
  T_48_META_API_1051_R_D: "तत्व मान",
  T_48_META_API_1052_D: "सूची में निर्दिष्ट सूचकांक के अनुरूप तत्व मान सेट करता है",
  T_48_META_API_1052_P0_D: "लक्ष्य सूची",
  T_48_META_API_1052_P1_D: "सूचकांक मान, 0 से प्रारंभ",
  T_48_META_API_1052_P2_D: "तत्व मान",
  T_48_META_API_1053_D: "तत्वों को सूची के अंत में जोड़ें",
  T_48_META_API_1053_P0_D: "लक्ष्य सूची",
  T_48_META_API_1053_P1_D: "जोड़ने के लिए तत्व",
  T_48_META_API_1054_D: "सूची से निर्दिष्ट सूचकांक के अनुरूप तत्व को हटा देता है",
  T_48_META_API_1054_P0_D: "लक्ष्य सूची",
  T_48_META_API_1054_P1_D: "सूचकांक मान, 0 से प्रारंभ",
  T_48_META_API_1055_D: "सूची में सभी तत्व साफ़ करें",
  T_48_META_API_1055_P0_D: "लक्ष्य सूची",
  T_48_META_API_1056_D: "निर्दिष्ट सूची को उलट दें. सूची में तत्वों का क्रम उलट दिया जाएगा.",
  T_48_META_API_1056_P0_D: "लक्ष्य सूची",
  T_48_META_API_1057_D: "एक सूची कॉपी करें",
  T_48_META_API_1057_P0_D: "लक्ष्य सूची",
  T_48_META_API_1057_R_D: "नई सूची कॉपी की गई",
  T_48_META_API_1058_D: "सूची में निर्दिष्ट सूचकांक स्थिति में एक नया तत्व डालें। मूल सूचकांक स्थिति और उसके बाद के तत्वों को बारी-बारी से एक स्थान पीछे ले जाया जाएगा।",
  T_48_META_API_1058_P0_D: "लक्ष्य सूची",
  T_48_META_API_1058_P1_D: "सम्मिलित की जाने वाली सूचकांक स्थिति, सूचकांक की गणना 0 से की जाती है",
  T_48_META_API_1058_P2_D: "सम्मिलित करने के लिए नया तत्व मान",
  T_48_META_API_1059_D: "सूची में तत्वों को बेतरतीब ढंग से पुन: व्यवस्थित करें",
  T_48_META_API_1059_P0_D: "लक्ष्य सूची",
  T_48_META_API_1060_D: "दोनों पक्षों के मापदंडों की तुलना करें और सही या गलत लौटाएं",
  T_48_META_API_1060_P0_D: "तुलना के लिए उपयोग किया जाने वाला लवल्यू",
  T_48_META_API_1060_P1_D: "तुलना विधि निम्नलिखित विधियों का समर्थन करती है: >,>=,==,!=,<=,<,और (सीमित बूल प्रकार), या (सीमित बूल प्रकार)",
  T_48_META_API_1060_P2_D: "तुलना के लिए उपयोग किया जाने वाला लवल्यू",
  T_48_META_API_1060_R_D: "परिणामों की तुलना करें",
  T_48_META_API_1061_D: "चार बुनियादी अंकगणितीय संक्रियाओं में जोड़, घटाव, गुणा, भाग और शेष शामिल हैं। शेष संक्रिया केवल पूर्णांकों का समर्थन करती है, और शेष संक्रियाएं पूर्णांकों या दशमलवों का समर्थन करती हैं।",
  T_48_META_API_1061_P0_D: "संचालन का लाभ",
  T_48_META_API_1061_P1_D: "चार प्रकार की अंकगणितीय संक्रियाएँ, जिनमें जोड़, घटाव, गुणा, भाग और शेष शामिल हैं। शेष संक्रिया दशमलव का समर्थन नहीं करती है।",
  T_48_META_API_1061_P2_D: "ऑपरेशन का प्रतिद्वंद्विता",
  T_48_META_API_1061_R_D: "गणना परिणाम",
  T_48_META_API_1062_D: "सबसे छोटे पूर्णांक (समावेशी) और सबसे बड़े पूर्णांक (अनन्य) के बीच यादृच्छिक रूप से एक पूर्णांक उत्पन्न करता है",
  T_48_META_API_1062_P0_D: "यादृच्छिक सीमा के बाएँ अंतराल, यादृच्छिक रूप से भरे हुए मूल्य तक पहुँचना संभव है",
  T_48_META_API_1062_P1_D: "यादृच्छिक श्रेणी का सही अंतराल भरे हुए मान के लिए यादृच्छिक नहीं होगा।",
  T_48_META_API_1062_R_D: "यादृच्छिक परिणाम, पूर्णांक",
  T_48_META_API_1063_D: "सबसे छोटे दशमलव मान (समावेशी) और सबसे बड़े दशमलव मान (अनन्य) के बीच यादृच्छिक रूप से दशमलव उत्पन्न करता है",
  T_48_META_API_1063_P0_D: "यादृच्छिक श्रेणी के बाएँ अंतराल में, इस बात की बहुत कम संभावना है कि भरा हुआ मान यादृच्छिक होगा।",
  T_48_META_API_1063_P1_D: "यादृच्छिक श्रेणी का सही अंतराल भरे हुए मान के लिए यादृच्छिक नहीं होगा।",
  T_48_META_API_1063_R_D: "यादृच्छिक परिणाम, दशमलव, 7 दशमलव स्थानों तक सटीक",
  T_48_META_API_1064_D: "निर्धारित करें कि वस्तु खाली है या नहीं",
  T_48_META_API_1064_P0_D: "जिस वस्तु का निर्णय किया जाना है वह खाली है",
  T_48_META_API_1064_R_D: "क्या यह खाली है?",
  T_48_META_API_1065_D: "तार्किक निषेध, इनपुट मान: सत्य या ग़लत, वापसी मान: ग़लत या सत्य",
  T_48_META_API_1065_P0_D: "नॉन का मान ज्ञात करने की आवश्यकता है",
  T_48_META_API_1065_R_D: "नकारात्मक परिणाम",
  T_48_META_API_1066_D: "निरपेक्ष मान लें, पूर्णांक और दशमलव का समर्थन करता है",
  T_48_META_API_1066_P0_D: "मूल्य का निरपेक्ष मूल्य ज्ञात करने की आवश्यकता है",
  T_48_META_API_1066_R_D: "निरपेक्ष मान लेने का परिणाम",
  T_48_META_API_1067_D: "वर्गमूल की गणना करें",
  T_48_META_API_1067_P0_D: "मान का वर्गमूल ज्ञात करने की आवश्यकता है",
  T_48_META_API_1067_R_D: "वर्गमूल ज्ञात करने का परिणाम",
  T_48_META_API_1068_D: "नकारात्मक मानों की गणना करें",
  T_48_META_API_1068_P0_D: "एक ऋणात्मक मान ज्ञात करने की आवश्यकता है",
  T_48_META_API_1068_R_D: "नकारात्मक परिणाम",
  T_48_META_API_1069_D: "दो तारों को एक साथ जोड़ें",
  T_48_META_API_1069_P0_D: "स्ट्रिंग अंतराल",
  T_48_META_API_1069_P1_D: "स्ट्रिंग प्रतिद्वंद्विता",
  T_48_META_API_1069_R_D: "स्ट्रिंग संयोजन परिणाम",
  T_48_META_API_1070_D: "स्ट्रिंग की लंबाई प्राप्त करें",
  T_48_META_API_1070_P0_D: "डोरी",
  T_48_META_API_1070_R_D: "स्ट्रिंग लंबाई",
  T_48_META_API_1071_D: "निर्दिष्ट मान को निकटतम पूर्णांक तक पूर्णांकित करता है",
  T_48_META_API_1071_P0_D: "वह मान जिसे पूर्णांकित करने की आवश्यकता है",
  T_48_META_API_1071_R_D: "पूर्णांकन का परिणाम",
  T_48_META_API_1072_D: "निर्दिष्ट मान को निकटतम पूर्णांक तक पूर्णांकित करता है",
  T_48_META_API_1072_P0_D: "वह मान जिसे पूर्णांकित करने की आवश्यकता है",
  T_48_META_API_1072_R_D: "गोल करने का नतीजा",
  T_48_META_API_1073_D: "निर्दिष्ट मान को पूर्णांक में पूर्णांकित करता है",
  T_48_META_API_1073_P0_D: "वे मान जिन्हें पूर्णांकित करने की आवश्यकता है",
  T_48_META_API_1073_R_D: "गोल परिणाम",
  T_48_META_API_1074_D: "लक्ष्य स्ट्रिंग में सभी निर्दिष्ट स्ट्रिंग्स को बदलने के बाद, नई स्ट्रिंग को आउटपुट करें",
  T_48_META_API_1074_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1074_P1_D: "पुरानी स्ट्रिंग को बदला जाना है",
  T_48_META_API_1074_P2_D: "प्रतिस्थापित करने के लिए नई स्ट्रिंग",
  T_48_META_API_1074_R_D: "पूरी की गई स्ट्रिंग को बदलें",
  T_48_META_API_1075_D: "किसी निर्दिष्ट स्ट्रिंग की पहली घटना के लिए लक्ष्य स्ट्रिंग खोजें।",
  T_48_META_API_1075_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1075_P1_D: "खोजने के लिए निर्दिष्ट स्ट्रिंग",
  T_48_META_API_1075_P2_D: "प्रारंभिक स्थिति से स्ट्रिंग ढूंढें, स्ट्रिंग स्थिति की गणना 0 से की जाती है",
  T_48_META_API_1075_R_D: "लक्ष्य स्ट्रिंग में स्ट्रिंग की पहली घटना की स्थिति निर्दिष्ट करती है। स्ट्रिंग स्थिति की गणना 0 से की जाती है।",
  T_48_META_API_1076_D: "निर्दिष्ट स्थिति से शुरू करके निर्दिष्ट लंबाई की एक स्ट्रिंग को इंटरसेप्ट करने के बाद, एक नई स्ट्रिंग आउटपुट करें",
  T_48_META_API_1076_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1076_P1_D: "वह स्थिति जहां अवरोधन शुरू होता है। स्ट्रिंग स्थिति की गणना 0 से की जाती है।",
  T_48_META_API_1076_P2_D: "लंबाई काटें. डिफ़ॉल्ट रूप से, यह स्ट्रिंग के अंत तक कटता है.",
  T_48_META_API_1076_R_D: "अवरोधित स्ट्रिंग",
  T_48_META_API_1077_D: "तुलना करता है कि क्या दो सूचियों के तत्व बिल्कुल समान हैं। सूची क्षमता तुलना परिणाम को प्रभावित नहीं करती है।",
  T_48_META_API_1077_P0_D: "तुलना के लिए प्रयुक्त मानों की सूची बनाएं",
  T_48_META_API_1077_P1_D: "तुलना के लिए प्रयुक्त प्रतिमूल्यों की सूची बनाएं",
  T_48_META_API_1077_R_D: "परिणामों की तुलना करते हुए, यदि सामग्री सुसंगत है, तो सत्य लौटाया जाएगा; यदि सामग्री असंगत है, तो गलत लौटाया जाएगा।",
  T_48_META_API_1078_D: "निर्दिष्ट स्ट्रिंग को सीमांकक के रूप में उपयोग करते हुए, लक्ष्य स्ट्रिंग को कई स्लाइस में काटें और एक नई स्ट्रिंग आउटपुट करें। लगातार एन सीमांकक को एन-1 आधी-चौड़ाई वाले स्थानों में काटा जाएगा और स्ट्रिंग सूची तत्वों के रूप में आउटपुट किया जाएगा।",
  T_48_META_API_1078_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1078_P1_D: "सीमांकक स्ट्रिंग",
  T_48_META_API_1078_R_D: "आउटपुट स्ट्रिंग सूची हमेशा आधी-चौड़ाई वाले स्पेस तत्व के साथ समाप्त होती है।",
  T_48_META_API_1079_D: "स्ट्रिंग स्थिति सूची के अनुसार वर्ण निकालें और उन्हें एक नए स्ट्रिंग आउटपुट में संयोजित करें",
  T_48_META_API_1079_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1079_P1_D: "स्ट्रिंग स्थितियों की सूची, स्ट्रिंग स्थितियों की गणना 0 से शुरू करके की जाती है",
  T_48_META_API_1079_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_1080_D: "लक्ष्य स्ट्रिंग वर्णों को सभी अपरकेस में बदलें",
  T_48_META_API_1080_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1080_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_1081_D: "सभी लक्ष्य स्ट्रिंग वर्णों को लोअरकेस में बदलें",
  T_48_META_API_1081_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1081_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_1082_D: "लक्ष्य स्ट्रिंग के पहले गैर-स्पेस वर्ण से पहले और अंतिम गैर-स्पेस वर्ण के बाद सभी रिक्त स्थान हटा दें",
  T_48_META_API_1082_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1082_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_1083_D: "निर्दिष्ट पहचानकर्ता के साथ लिंक करने के बाद एक नई स्ट्रिंग आउटपुट करता है",
  T_48_META_API_1083_P0_D: "लक्ष्य स्ट्रिंग सूची",
  T_48_META_API_1083_P1_D: "स्ट्रिंग को संयोजित करने के लिए निर्दिष्ट पहचानकर्ता का उपयोग किया जाता है",
  T_48_META_API_1083_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_1084_D: "रैंकिंग डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान लिखें",
  T_48_META_API_1084_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_1084_P1_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1084_P2_D: "मूल्य लिखा है",
  T_48_META_API_1084_P3_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1084_P4_D: "त्रुटि कोड",
  T_48_META_API_1085_D: "संचयी डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप ऑफसेट मान लिखें",
  T_48_META_API_1085_P0_D: "डेटाबेस में संचित डेटा तालिका का नाम",
  T_48_META_API_1085_P1_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1085_P2_D: "चार प्रकार की अंकगणितीय संक्रियाएँ",
  T_48_META_API_1085_P3_D: "ऑफसेट मान लिखा गया",
  T_48_META_API_1085_P4_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1085_P5_D: "त्रुटि कोड",
  T_48_META_API_1086_D: "डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान हटाएँ",
  T_48_META_API_1086_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_1086_P1_D: "प्लेयर यूनिक आईडी",
  T_48_META_API_1086_P2_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1086_P3_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1086_P4_D: "त्रुटि कोड",
  T_48_META_API_1087_D: "रैंकिंग डेटा तालिका में निर्दिष्ट पहचानकर्ता के अनुरूप मान हटाएँ",
  T_48_META_API_1087_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_1087_P1_D: "पहचानकर्ता निर्दिष्ट करें",
  T_48_META_API_1087_P2_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1087_P3_D: "त्रुटि कोड",
  T_48_META_API_1088_D: "रैंकिंग डेटा तालिका में निर्दिष्ट रैंकिंग के अनुरूप मान हटाएँ",
  T_48_META_API_1088_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_1088_P1_D: "रैंकिंग निर्दिष्ट करें",
  T_48_META_API_1088_P2_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_1088_P3_D: "त्रुटि कोड",
  T_48_META_API_1089_D: "पर्सोना को उपयोगकर्ता संदेश भेजें",
  T_48_META_API_1089_P0_D: "लक्ष्य व्यक्तित्व आईडी",
  T_48_META_API_1089_P1_D: "संदेश की सामग्री",
  T_48_META_API_1090_D: "पर्सोना को सिस्टम संदेश भेजें",
  T_48_META_API_1090_P0_D: "लक्ष्य व्यक्तित्व आईडी",
  T_48_META_API_1090_P1_D: "संदेश की सामग्री",
  T_48_META_API_1091_D: "स्पष्ट व्यक्तित्व स्मृति",
  T_48_META_API_1091_P0_D: "त्रुटि कोड",
  T_48_META_API_1092_D: "सदस्य केंद्र जगाएँ",
  T_48_META_API_1092_P0_D: "त्रुटि कोड",
  T_48_META_API_1093_D: "सदस्यता समाप्ति टाइमस्टैम्प प्राप्त करें",
  T_48_META_API_1093_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1093_P1_D: "समय-चिह्न",
  T_48_META_API_1093_P2_D: "त्रुटि कोड",
  T_48_META_API_1094_D: "निर्धारित करें कि खिलाड़ी सदस्य है या नहीं",
  T_48_META_API_1094_P0_D: "त्रुटि कोड",
  T_48_META_API_1094_P1_D: "क्या आप एक सदस्य हैं?",
  T_48_META_API_1095_D: "सदस्यता समाप्ति टाइमस्टैम्प प्राप्त करें",
  T_48_META_API_1095_P0_D: "समय-चिह्न",
  T_48_META_API_1095_P1_D: "त्रुटि कोड",
  T_48_META_API_1096_D: "निर्धारित करें कि खिलाड़ी सदस्य है या नहीं",
  T_48_META_API_1096_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1096_P1_D: "त्रुटि कोड",
  T_48_META_API_1096_P2_D: "क्या आप एक सदस्य हैं?",
  T_48_META_API_1097_D: "सदस्य केंद्र जगाएँ",
  T_48_META_API_1097_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_1097_P1_D: "त्रुटि कोड",
  T_48_META_API_1099_D: "एक पर्सोना पर्यवेक्षक स्थापित करें, और पर्सोना के साथ बाद की बातचीत भी पर्यवेक्षक को भेजी जाएगी।",
  T_48_META_API_1099_P0_D: "लक्ष्य व्यक्तित्व आईडी",
  T_48_META_API_1099_P1_D: "पर्यवेक्षक सूची",
  T_48_META_API_11_D: "वर्तमान चरण को समाप्त करें और अगले चरण में प्रवेश करें",
  T_48_META_API_1100_D: "स्ट्रीमिंग का उपयोग करके पर्सोना को उपयोगकर्ता संदेश भेजें",
  T_48_META_API_1100_P0_D: "लक्ष्य व्यक्तित्व आईडी",
  T_48_META_API_1100_P1_D: "संदेश की सामग्री",
  T_48_META_API_1101_D: "स्ट्रीमिंग का उपयोग करके पर्सोना को सिस्टम संदेश भेजें",
  T_48_META_API_1101_P0_D: "लक्ष्य व्यक्तित्व आईडी",
  T_48_META_API_1101_P1_D: "संदेश की सामग्री",
  T_48_META_API_1101_P2_D: "जवाब देना है या नहीं",
  T_48_META_API_1103_D: "एक यादृच्छिक बीज बनाएँ",
  T_48_META_API_1103_P0_D: "बीज",
  T_48_META_API_1103_R_D: "रैंडम संख्या जनरेटर",
  T_48_META_API_1104_D: "निर्दिष्ट यादृच्छिक संख्या जनरेटर से अगला यादृच्छिक संख्या प्राप्त करें, अधिकतम मान 32767 है",
  T_48_META_API_1104_P0_D: "रैंडम संख्या जनरेटर",
  T_48_META_API_1104_P1_D: "सीमा न्यूनतम",
  T_48_META_API_1104_P2_D: "रेंज अधिकतम",
  T_48_META_API_1104_R_D: "यादृच्छिक संख्या",
  T_48_META_API_1108_D: "प्लेयर द्वारा प्रयुक्त क्लाइंट भाषा प्राप्त करें",
  T_48_META_API_12_D: "कंसोल पर लॉग प्रिंट करें",
  T_48_META_API_12_P0_D: "क्या छापने की जरूरत है",
  T_48_META_API_13_D: "पैरामीटर के साथ एक स्ट्रिंग आउटपुट करें",
  T_48_META_API_13_P0_D: "किसी पैरामीटर को दर्शाने के लिए %v प्लेसहोल्डर का उपयोग करें। %v की संख्या और पैरामीटर की संख्या सुसंगत होनी चाहिए।",
  T_48_META_API_13_P1_D: "आउटपुट में भाग लेने वाली पैरामीटर सूची को प्रारूप विवरण में %v की संख्या के अनुरूप होना आवश्यक है।",
  T_48_META_API_13_R_D: "आउटपुट स्ट्रिंग",
  T_48_META_API_14_D: "मैप ऑब्जेक्ट के अवशेषों को साफ करें, जिसमें डेथ बॉक्स, बनाई गई वस्तुएं, रखी गई वस्तुएं, प्रक्षेप्य अवशेष आदि शामिल हैं।",
  T_48_META_API_15_D: "उपयोगकर्ता अनुभव डेटा विश्लेषण के लिए प्रतिस्पर्धा बिंदु लॉग को अनुकूलित करें",
  T_48_META_API_15_P0_D: "रिपोर्ट किए जाने वाले फ़ील्ड नामों की सूची",
  T_48_META_API_15_P1_D: "रिपोर्ट किए जाने वाले फ़ील्ड मानों की सूची",
  T_48_META_API_1500_D: "त्रि-आयामी वेक्टर का एक्स घटक प्राप्त करें",
  T_48_META_API_1500_P0_D: "3डी वेक्टर",
  T_48_META_API_1500_R_D: "त्रि-आयामी वेक्टर एक्स घटक",
  T_48_META_API_1501_D: "त्रि-आयामी वेक्टर का Y घटक प्राप्त करें",
  T_48_META_API_1501_P0_D: "3डी वेक्टर",
  T_48_META_API_1501_R_D: "त्रि-आयामी वेक्टर Y घटक",
  T_48_META_API_1502_D: "त्रि-आयामी वेक्टर का Z घटक प्राप्त करें",
  T_48_META_API_1502_P0_D: "3डी वेक्टर",
  T_48_META_API_1502_R_D: "त्रि-आयामी वेक्टर Z घटक",
  T_48_META_API_1503_D: "त्रि-आयामी वेक्टर का X घटक सेट करता है",
  T_48_META_API_1503_P0_D: "3डी वेक्टर",
  T_48_META_API_1503_P1_D: "एक्स घटक",
  T_48_META_API_1504_D: "त्रि-आयामी वेक्टर का Y घटक सेट करता है",
  T_48_META_API_1504_P0_D: "3डी वेक्टर",
  T_48_META_API_1504_P1_D: "वाई घटक",
  T_48_META_API_1505_D: "त्रि-आयामी वेक्टर का Z घटक सेट करता है",
  T_48_META_API_1505_P0_D: "3डी वेक्टर",
  T_48_META_API_1505_P1_D: "Z घटक",
  T_48_META_API_1506_D: "दो त्रि-आयामी वेक्टर जोड़ें",
  T_48_META_API_1506_P0_D: "वाम",
  T_48_META_API_1506_P1_D: "दक्षिण",
  T_48_META_API_1506_R_D: "त्रि-आयामी वेक्टर जोड़ परिणाम",
  T_48_META_API_1507_D: "दो त्रि-आयामी वैक्टर घटाएँ",
  T_48_META_API_1507_P0_D: "वाम",
  T_48_META_API_1507_P1_D: "दक्षिण",
  T_48_META_API_1507_R_D: "त्रि-आयामी वेक्टर के अंतराल से प्रतिमूल्य घटाने का परिणाम",
  T_48_META_API_1508_D: "त्रि-आयामी वेक्टर को स्केल करना",
  T_48_META_API_1508_P0_D: "3डी वेक्टर को स्केल किया जाना है",
  T_48_META_API_1508_P1_D: "3डी वेक्टर स्केलिंग राशि",
  T_48_META_API_1508_R_D: "3डी वेक्टर स्केलिंग परिणाम",
  T_48_META_API_1509_D: "डॉट उत्पाद दो त्रि-आयामी वैक्टर, डॉट उत्पाद का परिणाम एक अदिश राशि है",
  T_48_META_API_1509_P0_D: "वाम",
  T_48_META_API_1509_P1_D: "दक्षिण",
  T_48_META_API_1509_R_D: "बिंदु गुणन परिणाम",
  T_48_META_API_1510_D: "दो त्रि-आयामी सदिशों को क्रॉस-गुणा करें। क्रॉस-गुणा का परिणाम एक वेक्टर है, जो उस तल के लंबवत है जहां दो वेक्टर स्थित हैं।",
  T_48_META_API_1510_P0_D: "वाम",
  T_48_META_API_1510_P1_D: "दक्षिण",
  T_48_META_API_1510_R_D: "क्रॉस उत्पाद का परिणाम, दिशा उस विमान के लंबवत है जहां ऑपरेशन में शामिल दो वैक्टर स्थित हैं।",
  T_48_META_API_1511_D: "त्रि-आयामी वैक्टर को सामान्यीकृत करें",
  T_48_META_API_1511_P0_D: "3डी वेक्टर",
  T_48_META_API_1511_R_D: "एक नया सामान्यीकृत वेक्टर लौटाता है। सांचे की लंबाई 1 है",
  T_48_META_API_1512_D: "मॉड्यूलो एक त्रि-आयामी वेक्टर",
  T_48_META_API_1512_P0_D: "3डी वेक्टर",
  T_48_META_API_1512_R_D: "मॉड्यूलो परिणाम वेक्टर मापांक की लंबाई है",
  T_48_META_API_1513_D: "दो त्रि-आयामी वैक्टरों की यूक्लिडियन दूरी की गणना करें",
  T_48_META_API_1513_P0_D: "वाम",
  T_48_META_API_1513_P1_D: "दक्षिण",
  T_48_META_API_1513_R_D: "दो वैक्टर घटाने के बाद, परिणामी वेक्टर की मॉड्यूल लंबाई",
  T_48_META_API_1514_D: "दो त्रि-आयामी सदिशों के बीच के कोण की गणना करें",
  T_48_META_API_1514_P0_D: "वाम",
  T_48_META_API_1514_P1_D: "दक्षिण",
  T_48_META_API_1514_R_D: "सदिश कोण, कोण सीमा 0-180",
  T_48_META_API_1515_D: "एक 3डी वेक्टर बनाएं",
  T_48_META_API_1515_P0_D: "त्रि-आयामी वेक्टर का एक्स घटक",
  T_48_META_API_1515_P1_D: "त्रि-आयामी वेक्टर का Y घटक",
  T_48_META_API_1515_P2_D: "त्रि-आयामी वेक्टर का Z घटक",
  T_48_META_API_1515_R_D: "त्रि-आयामी वेक्टर बनाया गया",
  T_48_META_API_1516_D: "एक नवनिर्मित दिशा बिंदु प्राप्त करें (बहिष्कृत, उपयोग न करें)",
  T_48_META_API_1516_P0_D: "जगह",
  T_48_META_API_1516_P1_D: "की ओर",
  T_48_META_API_1516_R_D: "डायरेक्टप्वाइंट",
  T_48_META_API_1517_D: "दिशा बिंदु स्थिति प्राप्त करें (अप्रचलित, कृपया उपयोग न करें)",
  T_48_META_API_1517_P0_D: "दिशा बिंदु",
  T_48_META_API_1517_R_D: "पद",
  T_48_META_API_1518_D: "दिशा बिंदु का उन्मुखीकरण प्राप्त करें (अप्रचलित, कृपया उपयोग न करें)",
  T_48_META_API_1518_P0_D: "दिशा बिंदु",
  T_48_META_API_1518_R_D: "आगे",
  T_48_META_API_1519_D: "एक सूची बनाएं",
  T_48_META_API_1519_P0_D: "सूची की प्रारंभिक लंबाई प्रारंभिक क्षमता से कम या उसके बराबर होनी चाहिए",
  T_48_META_API_1519_P1_D: "सूची की प्रारंभिक क्षमता प्रारंभिक लंबाई से अधिक या उसके बराबर होनी चाहिए। क्षमता को गतिशील रूप से विस्तारित किया जा सकता है, लेकिन यह एक निश्चित मात्रा में प्रदर्शन का उपभोग करेगा। निर्माण करते समय एक उचित मूल्य निर्धारित करने की सिफारिश की जाती है।",
  T_48_META_API_1519_R_D: "सूची बनाई गई",
  T_48_META_API_1520_D: "जाँचता है कि सूची में निर्दिष्ट तत्व शामिल है या नहीं",
  T_48_META_API_1520_P0_D: "लक्ष्य सूची",
  T_48_META_API_1520_P1_D: "जाँच करने के लिए निर्दिष्ट तत्व",
  T_48_META_API_1520_R_D: "निर्दिष्ट तत्व शामिल करना है या नहीं",
  T_48_META_API_1521_D: "लक्ष्य सूची के अंत में अनेक तत्व जोड़ें",
  T_48_META_API_1521_P0_D: "लक्ष्य सूची",
  T_48_META_API_1521_P1_D: "सूची संलग्न करें",
  T_48_META_API_1522_D: "निर्दिष्ट तत्व को सूची से हटा देता है",
  T_48_META_API_1522_P0_D: "लक्ष्य सूची",
  T_48_META_API_1522_P1_D: "हटाने के लिए तत्व मान",
  T_48_META_API_1523_D: "वह स्थिति सूचकांक प्राप्त करें जहां सूची में तत्व सबसे पहले दिखाई देता है। यदि सूची में कोई लक्ष्य तत्व नहीं है, तो -1 लौटाया जाता है।",
  T_48_META_API_1523_P0_D: "लक्ष्य सूची",
  T_48_META_API_1523_P1_D: "तत्व मान",
  T_48_META_API_1523_R_D: "स्थान सूचकांक",
  T_48_META_API_1524_D: "सूची में तत्व की अंतिम घटना का सूचकांक प्राप्त करता है यदि सूची में कोई लक्ष्य तत्व नहीं है, तो -1 लौटाया जाता है।",
  T_48_META_API_1524_P0_D: "लक्ष्य सूची",
  T_48_META_API_1524_P1_D: "तत्व मान",
  T_48_META_API_1524_R_D: "स्थान सूचकांक",
  T_48_META_API_1525_D: "किसी कोण की ज्या ज्ञात कीजिए",
  T_48_META_API_1525_P0_D: "कोण, 360, 360 डिग्री को दर्शाता है",
  T_48_META_API_1525_R_D: "साइन मान",
  T_48_META_API_1526_D: "किसी कोण की कोज्या ज्ञात कीजिए",
  T_48_META_API_1526_P0_D: "कोण, 360, 360 डिग्री को दर्शाता है",
  T_48_META_API_1526_R_D: "कोज्या",
  T_48_META_API_1527_D: "किसी कोण की स्पर्शरेखा ज्ञात कीजिए",
  T_48_META_API_1527_P0_D: "कोण, 360, 360 डिग्री को दर्शाता है",
  T_48_META_API_1527_R_D: "स्पर्शरेखा",
  T_48_META_API_1528_D: "दशमलव 255 पर निर्धारित पारदर्शिता के साथ एक रंग मान का निर्माण करें। पहले चैनल को एक बाइनरी संख्या में परिवर्तित करें। प्रत्येक 8 बिट इसे आर, जी, बी और पारदर्शिता के अनुसार विभाजित करें। फिर बाइनरी संख्या को एक इंट32 प्रकार में परिवर्तित करें वापस करो।",
  T_48_META_API_1528_P0_D: "रंग का लाल चैनल मान, मान सीमा [0,255] है। यदि यह सीमा से अधिक है, तो इसे कानूनी मान से जोड़ दिया जाएगा।",
  T_48_META_API_1528_P1_D: "रंग का हरा चैनल मान, मान सीमा [0,255] है। यदि यह सीमा से अधिक है, तो इसे कानूनी मान से जोड़ दिया जाएगा।",
  T_48_META_API_1528_P2_D: "रंग का नीला चैनल मान, मान सीमा [0,255] है। यदि यह सीमा से अधिक है, तो इसे कानूनी मान से जोड़ दिया जाएगा।",
  T_48_META_API_1528_R_D: "निर्मित रंग मूल्य",
  T_48_META_API_1529_D: "कोण प्राप्त करने के लिए आर्कसाइन ऑपरेशन करें",
  T_48_META_API_1529_P0_D: "आर्कसाइन ऑपरेशन के लिए मान, मान सीमा है [-1,1]",
  T_48_META_API_1529_R_D: "कोण",
  T_48_META_API_1530_D: "कोण प्राप्त करने के लिए आर्क कोसाइन ऑपरेशन करें",
  T_48_META_API_1530_P0_D: "आर्क कोसाइन ऑपरेशन के लिए मान, मान सीमा है [-1,1]",
  T_48_META_API_1530_R_D: "कोण",
  T_48_META_API_1531_D: "कोण प्राप्त करने के लिए आर्कटेंजेंट ऑपरेशन करें",
  T_48_META_API_1531_P0_D: "आर्कटेंजेंट ऑपरेशन करने का मान",
  T_48_META_API_1531_R_D: "कोण",
  T_48_META_API_1532_D: "निर्धारित करें कि क्या लक्ष्य इकाई निर्दिष्ट क्षेत्र सीमा के भीतर है। यदि इकाई में कोई स्थिति विशेषता नहीं है, तो गलत लौटा दिया जाएगा।",
  T_48_META_API_1532_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1532_P1_D: "गोले का केंद्र निर्दिष्ट करता है",
  T_48_META_API_1532_P2_D: "गोले की त्रिज्या निर्दिष्ट करता है",
  T_48_META_API_1532_R_D: "निर्णय परिणाम",
  T_48_META_API_1533_D: "निर्धारित करें कि क्या लक्ष्य इकाई निर्दिष्ट सिलेंडर सीमा के भीतर है। यदि इकाई के पास कोई स्थिति विशेषता नहीं है, तो गलत लौटा दिया जाएगा।",
  T_48_META_API_1533_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1533_P1_D: "सिलेंडर का केंद्र बिंदु निर्दिष्ट करता है",
  T_48_META_API_1533_P2_D: "सिलेंडर के क्रॉस-सेक्शनल त्रिज्या को निर्दिष्ट करता है",
  T_48_META_API_1533_P3_D: "सिलेंडर की ऊंचाई निर्दिष्ट करता है",
  T_48_META_API_1533_P4_D: "केंद्र बिंदु के चारों ओर सिलेंडर के घूर्णन के त्रि-आयामी यूलर कोण को निर्दिष्ट करता है",
  T_48_META_API_1533_R_D: "निर्णय परिणाम",
  T_48_META_API_1534_D: "निर्धारित करें कि लक्ष्य इकाई निर्दिष्ट घन सीमा के भीतर है या नहीं",
  T_48_META_API_1534_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1534_P1_D: "घन का केंद्र बिंदु निर्दिष्ट करता है",
  T_48_META_API_1534_P2_D: "घन की लंबाई निर्दिष्ट करता है",
  T_48_META_API_1534_P3_D: "घन की चौड़ाई निर्दिष्ट करता है",
  T_48_META_API_1534_P4_D: "घन की ऊंचाई निर्दिष्ट करता है",
  T_48_META_API_1534_P5_D: "केंद्र बिंदु के चारों ओर घन के त्रि-आयामी घूर्णन यूलर कोण को निर्दिष्ट करता है",
  T_48_META_API_1534_R_D: "निर्णय परिणाम",
  T_48_META_API_1535_D: "निर्धारित करें कि लक्ष्य इकाई निर्दिष्ट सेक्टर सिलेंडर सीमा के भीतर है या नहीं",
  T_48_META_API_1535_P0_D: "लक्ष्य इकाई",
  T_48_META_API_1535_P1_D: "सेक्टर-आकार वाले सिलेंडर के मध्य भाग के केंद्र को निर्दिष्ट करता है",
  T_48_META_API_1535_P2_D: "सेक्टर-आकार वाले सिलेंडर के मध्य-खंड त्रिज्या को निर्दिष्ट करता है",
  T_48_META_API_1535_P3_D: "सेक्टर-आकार वाले सिलेंडर के क्रॉस-सेक्शन त्रिज्या का परीक्षण नहीं किया जाता है, सर्कल के केंद्र के रूप में केंद्र बिंदु के साथ, छोटे सेक्टर-आकार वाले सिलेंडर क्षेत्र का परीक्षण नहीं किया जाएगा, केवल निर्दिष्ट सेक्टर-आकार वाले सिलेंडर और के बीच का अंतर छोट",
  T_48_META_API_1535_P4_D: "सेक्टर सिलेंडर की ऊंचाई निर्दिष्ट करता है",
  T_48_META_API_1535_P5_D: "पता लगाने के लिए सेक्टर-आकार वाले सिलेंडर के अनुभाग का केंद्रीय कोण। यदि यह 360 से अधिक है, तो इसे बेलनाकार आकार में पता लगाया जाएगा। यदि यह 0 से कम है, तो पता लगाने वाले क्षेत्र का आकार 0 होगा।",
  T_48_META_API_1535_P6_D: "केंद्र बिंदु के चारों ओर सेक्टर सिलेंडर के घूर्णन के त्रि-आयामी यूलर कोण को निर्दिष्ट करता है",
  T_48_META_API_1535_R_D: "निर्णय परिणाम",
  T_48_META_API_1536_D: "दो संख्याओं के मानों की तुलना करता है और बड़ी संख्या लौटाता है",
  T_48_META_API_1536_P0_D: "वाम",
  T_48_META_API_1536_P1_D: "दक्षिण",
  T_48_META_API_1536_R_D: "बड़ी संख्या",
  T_48_META_API_1537_D: "सूची में अधिकतम मान लौटाता है",
  T_48_META_API_1537_P0_D: "लक्ष्य सूची, केवल सूची तत्व प्रकार को संख्या के रूप में स्वीकार करती है",
  T_48_META_API_1537_P1_D: "तुलना परिणाम। यदि सूची में गैर-अंक हैं, तो तुलना विफल हो जाती है और गलत परिणाम मिलता है।",
  T_48_META_API_1537_P2_D: "यदि तुलना सफल होती है तो सूची में सबसे बड़ा मान लौटाता है, और तुलना विफल होने पर 0 लौटाता है।",
  T_48_META_API_1538_D: "दो संख्याओं के मानों की तुलना करता है और छोटी संख्या लौटाता है",
  T_48_META_API_1538_P0_D: "वाम",
  T_48_META_API_1538_P1_D: "दक्षिण",
  T_48_META_API_1538_R_D: "छोटी संख्या",
  T_48_META_API_1539_D: "सूची में न्यूनतम मान लौटाता है.",
  T_48_META_API_1539_P0_D: "लक्ष्य सूची, केवल सूची तत्व प्रकार को संख्या के रूप में स्वीकार करती है",
  T_48_META_API_1539_P1_D: "तुलना परिणाम। यदि सूची में गैर-अंक हैं, तो तुलना विफल हो जाती है और गलत परिणाम मिलता है।",
  T_48_META_API_1539_P2_D: "यदि तुलना सफल होती है तो सूची में सबसे छोटा मान लौटाता है, और तुलना विफल होने पर 0 लौटाता है।",
  T_48_META_API_1540_D: "रैखिक प्रक्षेप, प्रारंभ मान और लक्ष्य मान के बीच प्रक्षेप प्रगति के अनुरूप मान लौटाता है, प्रक्षेप गुणांक [0,1]",
  T_48_META_API_1540_P0_D: "रैखिक इंटरपोलेशन का प्रारंभिक मान इंटरपोलेशन प्रगति 0 होने पर यह मान लौटाया जाता है।",
  T_48_META_API_1540_P1_D: "रैखिक प्रक्षेप लक्ष्य मान, यह मान तब लौटाया जाता है जब प्रक्षेप प्रगति 1 होती है",
  T_48_META_API_1540_P2_D: "इंटरपोलेशन प्रगति, मान सीमा [0,1], जब मान 0 है, तो प्रारंभ मान वापस कर दिया जाता है, जब मान 1 है, तो लक्ष्य मान वापस कर दिया जाता है, जब मान 0.5 है, तो प्रारंभ मान और लक्ष्य का औसत मान लौटा दिया गया है",
  T_48_META_API_1540_R_D: "रैखिक प्रक्षेप वापसी मान",
  T_48_META_API_1541_D: "लक्ष्य मान की सीमा को सीमित करें और तीन इनपुट मापदंडों के बीच मध्य मान प्राप्त करें; यदि लक्ष्य मान न्यूनतम मान से छोटा है, तो न्यूनतम मान वापस कर दिया जाएगा लक्ष्य मान अधिकतम मान से बड़ा है, सीमा में होने पर अधिकतम मान स्वयं वापस आ जाएगा",
  T_48_META_API_1541_P0_D: "लक्ष्य मान",
  T_48_META_API_1541_P1_D: "सीमित सीमा का न्यूनतम मूल्य",
  T_48_META_API_1541_P2_D: "सीमित सीमा का अधिकतम मान",
  T_48_META_API_1541_R_D: "प्रतिबंध के बाद वापसी मूल्य",
  T_48_META_API_1542_D: "लक्ष्य रंग के चैनल मान प्राप्त करें",
  T_48_META_API_1542_P0_D: "लक्ष्य रंग",
  T_48_META_API_1542_P1_D: "रंग का आर मान, रेंज [0, 255]",
  T_48_META_API_1542_P2_D: "रंग का जी मान, रेंज [0, 255]",
  T_48_META_API_1542_P3_D: "रंग का बी मान, रेंज [0, 255]",
  T_48_META_API_1542_P4_D: "रंग, रेंज का मान [0, 255]",
  T_48_META_API_1543_D: "घातांक",
  T_48_META_API_1543_P0_D: "आधार",
  T_48_META_API_1543_P1_D: "अनुक्रमणिका",
  T_48_META_API_1543_R_D: "गणना परिणाम",
  T_48_META_API_1544_D: "लघुगणक संचालन",
  T_48_META_API_1544_P0_D: "आधार",
  T_48_META_API_1544_P1_D: "वास्तविक संख्या",
  T_48_META_API_1544_R_D: "गणना परिणाम",
  T_48_META_API_1545_D: "यूलर कोण के लिए दिशा वेक्टर",
  T_48_META_API_1545_P0_D: "दिशा सदिश",
  T_48_META_API_1545_R_D: "यूलर कोण",
  T_48_META_API_1546_D: "यूलर कोण घूर्णन दिशा वेक्टर",
  T_48_META_API_1546_P0_D: "यूलर कोण",
  T_48_META_API_1546_R_D: "दिशा सदिश",
  T_48_META_API_1547_D: "फ़्लोटिंग पॉइंट संख्या के लिए पूर्णांक",
  T_48_META_API_1547_P0_D: "पूर्णांक",
  T_48_META_API_1547_R_D: "चल बिन्दु संख्या",
  T_48_META_API_1548_D: "चतुर्भुज के अनुसार लक्ष्य वेक्टर घुमाएँ",
  T_48_META_API_1548_P0_D: "लक्ष्य वेक्टर",
  T_48_META_API_1548_P1_D: "चतुर्भुज घुमाएँ",
  T_48_META_API_1548_R_D: "घुमाया गया वेक्टर",
  T_48_META_API_1549_D: "लक्ष्य संख्या को स्ट्रिंग में बदलें",
  T_48_META_API_1549_P0_D: "लक्ष्य संख्या को एक स्ट्रिंग में परिवर्तित किया जाना है",
  T_48_META_API_1549_P1_D: "आउटपुट संख्यात्मक स्ट्रिंग प्रारूप",
  T_48_META_API_1549_R_D: "डोरी",
  T_48_META_API_1598_D: "सर्वर टाइमस्टैम्प प्राप्त करें",
  T_48_META_API_1598_R_D: "1 जनवरी 1970 को 0:00:00 के बाद से सेकंड की संख्या लौटाता है",
  T_48_META_API_1599_D: "सर्वर क्षेत्र प्राप्त करें",
  T_48_META_API_1599_R_D: "क्षेत्र का संक्षिप्त नाम लौटाता है (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "उपयोगकर्ता अनुभव डेटा विश्लेषण के लिए अनुकूलित उपयोगकर्ता ट्रैकिंग लॉग",
  T_48_META_API_16_P0_D: "खिलाड़ियों की रिपोर्ट की जानी है",
  T_48_META_API_16_P1_D: "रिपोर्ट किए जाने वाले फ़ील्ड नामों की सूची",
  T_48_META_API_16_P2_D: "रिपोर्ट किए जाने वाले फ़ील्ड मानों की सूची",
  T_48_META_API_1601_D: "एक शब्दकोश बनाएं",
  T_48_META_API_1601_R_D: "शब्दकोष बनाया",
  T_48_META_API_1602_D: "शब्दकोश में निर्दिष्ट कुंजी के अनुरूप मान प्राप्त करें",
  T_48_META_API_1602_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1602_P1_D: "कुंजी",
  T_48_META_API_1602_R_D: "मूल्य",
  T_48_META_API_1603_D: "शब्दकोश में निर्दिष्ट कुंजी के अनुरूप मान सेट करता है",
  T_48_META_API_1603_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1603_P1_D: "कुंजी",
  T_48_META_API_1603_P2_D: "मूल्य",
  T_48_META_API_1604_D: "निर्दिष्ट कुंजी-मूल्य युग्म को शब्दकोश से हटाएँ",
  T_48_META_API_1604_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1604_P1_D: "कुंजी",
  T_48_META_API_1605_D: "शब्दकोश में सभी कुंजी-मूल्य जोड़े साफ़ करें",
  T_48_META_API_1605_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1606_D: "शब्दकोश में कुंजी-मूल्य जोड़े की संख्या प्राप्त करें",
  T_48_META_API_1606_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1606_R_D: "शब्दकोश की लंबाई",
  T_48_META_API_1607_D: "निर्धारित करें कि शब्दकोश में कोई कुंजी मौजूद है या नहीं",
  T_48_META_API_1607_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1607_P1_D: "कुंजी",
  T_48_META_API_1607_R_D: "क्या मौजूद है",
  T_48_META_API_1608_D: "शब्दकोश की सभी कुंजियाँ प्राप्त करता है, एक सूची के रूप में लौटाया जाता है",
  T_48_META_API_1608_P0_D: "लक्ष्य शब्दकोश",
  T_48_META_API_1608_R_D: "सभी प्रमुख मानों की सूची",
  T_48_META_API_17_D: "पता लगाने के लिए रैखिक गति के एक बॉक्स-आकार वाले क्षेत्र का उपयोग करें, और बॉक्स-आकार वाले क्षेत्र के मार्ग पर आने वाली सभी संस्थाओं को निकट से दूर तक लौटाएं, यदि वे शुरू में बॉक्स-आकार की सीमा के भीतर हैं, तो उनका पता नहीं लगाया जाएगा; यदि रिक्त स्थान में पदानुक्रमित पैरामीटर भरे गए हैं, तो उनका पता लगाया जा सकता है",
  T_48_META_API_17_P0_D: "बॉक्स क्षेत्र के तीन किनारों की आधी लंबाई, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_17_P1_D: "बॉक्स क्षेत्र का केंद्र बिंदु",
  T_48_META_API_17_P2_D: "बॉक्स क्षेत्र का घुमाव",
  T_48_META_API_17_P3_D: "बॉक्स क्षेत्र यात्रा दिशा",
  T_48_META_API_17_P4_D: "बॉक्स क्षेत्र यात्रा दूरी, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_17_P5_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_17_P6_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_17_P7_D: "हिट संस्थाओं की सूची",
  T_48_META_API_1700_D: "निर्दिष्ट स्ट्रिंग को पूर्णांक में बदलें",
  T_48_META_API_1700_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1700_P1_D: "परिणाम पूर्णांक",
  T_48_META_API_1700_P2_D: "क्या रूपांतरण सफल है?",
  T_48_META_API_1701_D: "निर्दिष्ट स्ट्रिंग को फ़्लोटिंग पॉइंट नंबर में कनवर्ट करें",
  T_48_META_API_1701_P0_D: "लक्ष्य स्ट्रिंग",
  T_48_META_API_1701_P1_D: "परिणाम फ़्लोट करें",
  T_48_META_API_1701_P2_D: "क्या रूपांतरण सफल है?",
  T_48_META_API_18_D: "पता लगाने के लिए एक सीधी रेखा वाले गोलाकार क्षेत्र का उपयोग करें, और गोलाकार क्षेत्र मार्ग पर आने वाली सभी संस्थाओं को निकट से दूर तक लौटाएँ, यदि वे प्रारंभ में गोलाकार क्षेत्र में हैं, तो रिक्त स्थान में स्तर पैरामीटर भरने पर उनका पता नहीं लगाया जाएगा , इलाके का पता लगाया जा सकता है",
  T_48_META_API_18_P0_D: "गोलाकार क्षेत्र की त्रिज्या, केवल सकारात्मक मान ही स्वीकार किए जाते हैं",
  T_48_META_API_18_P1_D: "गोलाकार क्षेत्र का केंद्र बिंदु",
  T_48_META_API_18_P2_D: "गोलाकार क्षेत्र की यात्रा की दिशा",
  T_48_META_API_18_P3_D: "गोलाकार क्षेत्र द्वारा तय की गई दूरी के केवल सकारात्मक मान ही स्वीकार किए जाते हैं",
  T_48_META_API_18_P4_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_18_P5_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_18_P6_D: "हिट संस्थाओं की सूची",
  T_48_META_API_19_D: "पता लगाने के लिए एक रैखिक रूप से चलने वाले कैप्सूल क्षेत्र का उपयोग करें, और कैप्सूल क्षेत्र के मार्ग पर निकट से दूर तक आने वाली सभी संस्थाओं को लौटा दें, यदि वे शुरू में कैप्सूल क्षेत्र के भीतर हैं, तो स्तर पैरामीटर भरने पर उनका पता नहीं लगाया जाएगा; भूभाग का पता लगाया जा सकता है",
  T_48_META_API_19_P0_D: "कैप्सूल क्षेत्र के दोनों सिरों पर गोलार्धों की त्रिज्या, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_19_P1_D: "कैप्सूल क्षेत्र के दोनों सिरों पर गोलार्धों के केंद्रों के बीच की दूरी दोनों छोर पर गोलार्धों की त्रिज्या के दोगुने से अधिक होनी चाहिए।",
  T_48_META_API_19_P2_D: "कैप्सूल क्षेत्र का केंद्र बिंदु",
  T_48_META_API_19_P3_D: "कैप्सूल क्षेत्र का घूमना",
  T_48_META_API_19_P4_D: "कैप्सूल क्षेत्र की यात्रा की दिशा",
  T_48_META_API_19_P5_D: "कैप्सुल क्षेत्र में यात्रा की गई दूरी, केवल सकारात्मक मान स्वीकार किए जाते हैं।",
  T_48_META_API_19_P6_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_19_P7_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_19_P8_D: "हिट संस्थाओं की सूची",
  T_48_META_API_2_D: "वर्तमान गेम में सभी टीमों को प्राप्त करें और टीम सूची पर वापस लौटें।",
  T_48_META_API_2_R_D: "टीम सूची",
  T_48_META_API_20_D: "पता लगाने के लिए एक स्थिर बॉक्स-आकार वाले क्षेत्र का उपयोग करें और सभी इकाइयों को बॉक्स-आकार वाले क्षेत्र में लौटाएँ यदि स्तर पैरामीटर रिक्त स्थान में भरा गया है, तो इलाके का पता लगाया जा सकता है।",
  T_48_META_API_20_P0_D: "बॉक्स क्षेत्र के तीन किनारों की आधी लंबाई, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_20_P1_D: "बॉक्स क्षेत्र का केंद्र बिंदु",
  T_48_META_API_20_P2_D: "बॉक्स क्षेत्र का घुमाव",
  T_48_META_API_20_P3_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_20_P4_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_20_P5_D: "हिट संस्थाओं की सूची",
  T_48_META_API_2000_D: "लक्ष्य इकाई का विशेषता मान सेट करें, जिसके लिए आवश्यक है कि विशेषता परिभाषित की गई हो",
  T_48_META_API_2000_P0_D: "लक्ष्य इकाई",
  T_48_META_API_2000_P1_D: "लक्ष्य इकाई का एक गुण",
  T_48_META_API_2000_P2_D: "जब विशेषता परिभाषित की जाती है तो लक्ष्य मान को आवश्यक प्रकार के अनुरूप होना चाहिए।",
  T_48_META_API_2000_P3_D: "ऑपरेशन मोड, सभी प्रकार असाइनमेंट का समर्थन करते हैं, और संख्यात्मक प्रकार स्व-जोड़, स्व-घटाव, स्व-गुणा, स्व-विभाजन और स्व-शेष का भी समर्थन करते हैं।",
  T_48_META_API_2001_D: "किसी इकाई का विशेषता मान प्राप्त करें",
  T_48_META_API_2001_P0_D: "लक्ष्य इकाई",
  T_48_META_API_2001_P1_D: "इकाई की एक विशेषता आईडी",
  T_48_META_API_2001_R_D: "मान बताइए",
  T_48_META_API_2002: "ग्राफ प्रॉपर्टी सेट करें",
  T_48_META_API_2002_D: "स्क्रिप्ट वेरिएबल सेट करें",
  T_48_META_API_2002_P0_D: "लक्ष्य इकाई",
  T_48_META_API_2002_P1: "ग्राफ आईडी",
  T_48_META_API_2002_P1_D: "लक्ष्य स्क्रिप्ट आईडी",
  T_48_META_API_2002_P2: "संपत्ति आईडी",
  T_48_META_API_2002_P2_D: "स्क्रिप्ट में परिभाषित सदस्य विशेषता आईडी",
  T_48_META_API_2002_P3: "संपत्ति मूल्य",
  T_48_META_API_2002_P3_D: "जब विशेषता परिभाषित की जाती है तो लक्ष्य मान को आवश्यक प्रकार के अनुरूप होना चाहिए।",
  T_48_META_API_2002_P4_D: "ऑपरेशन मोड, सभी प्रकार असाइनमेंट का समर्थन करते हैं, और संख्यात्मक प्रकार स्व-जोड़, स्व-घटाव, स्व-गुणा, स्व-विभाजन और स्व-शेष का भी समर्थन करते हैं।",
  T_48_META_API_2003: "ग्राफ़ प्रॉपर्टी प्राप्त करें",
  T_48_META_API_2003_D: "स्क्रिप्ट वेरिएबल प्राप्त करें",
  T_48_META_API_2003_P0_D: "लक्ष्य इकाई",
  T_48_META_API_2003_P1: "ग्राफ आईडी",
  T_48_META_API_2003_P1_D: "लक्ष्य स्क्रिप्ट आईडी",
  T_48_META_API_2003_P2: "संपत्ति आईडी",
  T_48_META_API_2003_P2_D: "लक्ष्य विशेषता आईडी",
  T_48_META_API_2003_R_D: "मान बताइए",
  T_48_META_API_2004_D: "स्थानीय वेरिएबल को परिभाषित और आरंभ करें। स्थानीय वेरिएबल का दायरा घोषणा स्थिति से स्टेटमेंट ब्लॉक के अंत तक है।",
  T_48_META_API_2004_P0_D: "चर का नाम",
  T_48_META_API_2004_P1_D: "परिवर्तनीय प्रारंभिक मान",
  T_48_META_API_2004_P2_D: "परिवर्तनीय घोषणा प्रकार। कोई मान निर्दिष्ट करते समय, इसे घोषित प्रकार के अनुरूप होना आवश्यक है।",
  T_48_META_API_2005_D: "स्थानीय चर का मान निर्धारित करें। स्थानीय चर का दायरा घोषणा स्थिति से कथन ब्लॉक के अंत तक है।",
  T_48_META_API_2005_P0_D: "चर का नाम",
  T_48_META_API_2005_P1: "परिवर्तनीय मान",
  T_48_META_API_2005_P1_D: "परिवर्तनीय मान",
  T_48_META_API_2005_P2_D: "ऑपरेशन मोड, सभी प्रकार असाइनमेंट का समर्थन करते हैं, और संख्यात्मक प्रकार स्व-जोड़, स्व-घटाव, स्व-गुणा, स्व-विभाजन और स्व-शेष का भी समर्थन करते हैं।",
  T_48_META_API_2006: "स्थानीय चर प्राप्त करें",
  T_48_META_API_2006_D: "स्थानीय चर का मान प्राप्त करें। स्थानीय चर का दायरा घोषणा स्थिति से कथन ब्लॉक के अंत तक है।",
  T_48_META_API_2006_P0: "चर का नाम",
  T_48_META_API_2006_P0_D: "चर का नाम",
  T_48_META_API_2006_R_D: "परिवर्तनीय मान",
  T_48_META_API_2009: "सीरियल के साथ वैश्विक कस्टम API खोजें और लागू करें",
  T_48_META_API_2009_D: "वैश्विक कस्टम फ़ंक्शन को क्रमबद्ध तरीके से कॉल करें। यदि कस्टम फ़ंक्शन में प्रतीक्षा है, तो कॉलिंग स्थान भी प्रतीक्षा करेगा।",
  T_48_META_API_2009_P0: "ग्राफ आईडी",
  T_48_META_API_2009_P0_D: "स्क्रिप्ट आईडी जहां कस्टम फ़ंक्शन स्थित है",
  T_48_META_API_2009_P1: "फ़ंक्शन आईडी",
  T_48_META_API_2009_P1_D: "कस्टम फ़ंक्शन आईडी को कॉल किया गया",
  T_48_META_API_2009_P2_D: "कस्टम फ़ंक्शन को पास किए गए पैरामीटरों की सूची",
  T_48_META_API_2010: "समानांतर के साथ वैश्विक कस्टम API खोजें और लागू करें",
  T_48_META_API_2010_D: "वैश्विक कस्टम फ़ंक्शन को समानांतर में कॉल करें, चाहे कस्टम फ़ंक्शन में कोई प्रतीक्षा हो, यह तुरंत कॉलिंग स्थान पर वापस आ जाएगा और निष्पादन जारी रखेगा।",
  T_48_META_API_2010_P0: "ग्राफ आईडी",
  T_48_META_API_2010_P0_D: "स्क्रिप्ट आईडी जहां कस्टम फ़ंक्शन स्थित है",
  T_48_META_API_2010_P1: "फ़ंक्शन आईडी",
  T_48_META_API_2010_P1_D: "कस्टम फ़ंक्शन आईडी को कॉल किया गया",
  T_48_META_API_2010_P2_D: "कस्टम फ़ंक्शन को पास किए गए पैरामीटरों की सूची",
  T_48_META_API_2013: "स्व ग्राफ गुण सेट करें",
  T_48_META_API_2013_D: "वर्तमान स्क्रिप्ट के लिए वेरिएबल सेट करें",
  T_48_META_API_2013_P0: "संपत्ति आईडी",
  T_48_META_API_2013_P0_D: "लक्ष्य विशेषता आईडी",
  T_48_META_API_2013_P1: "संपत्ति मूल्य",
  T_48_META_API_2013_P1_D: "लक्ष्य मान",
  T_48_META_API_2013_P2_D: "ऑपरेशन मोड, सभी प्रकार असाइनमेंट का समर्थन करते हैं, और संख्यात्मक प्रकार स्व-जोड़, स्व-घटाव, स्व-गुणा, स्व-विभाजन और स्व-शेष का भी समर्थन करते हैं।",
  T_48_META_API_2014: "स्वयं ग्राफ संपत्ति प्राप्त करें",
  T_48_META_API_2014_D: "वर्तमान स्क्रिप्ट के चर प्राप्त करें",
  T_48_META_API_2014_P0: "संपत्ति आईडी",
  T_48_META_API_2014_P0_D: "लक्ष्य विशेषता आईडी",
  T_48_META_API_2014_R_D: "मान बताइए",
  T_48_META_API_21_D: "पता लगाने के लिए एक स्थिर गोलाकार क्षेत्र का उपयोग करें और गोलाकार क्षेत्र के भीतर सभी संस्थाओं को लौटाएँ यदि स्तर पैरामीटर रिक्त स्थान में भरा गया है, तो इलाके का पता लगाया जा सकता है।",
  T_48_META_API_21_P0_D: "गोलाकार क्षेत्र की त्रिज्या, केवल सकारात्मक मान ही स्वीकार किए जाते हैं",
  T_48_META_API_21_P1_D: "गोलाकार क्षेत्र का केंद्र बिंदु",
  T_48_META_API_21_P2_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_21_P3_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_21_P4_D: "हिट संस्थाओं की सूची",
  T_48_META_API_22_D: "पता लगाने के लिए एक स्थिर कैप्सूल क्षेत्र का उपयोग करें और कैप्सूल क्षेत्र के भीतर सभी संस्थाओं को वापस करें यदि स्तर पैरामीटर भरा गया है, तो इलाके का पता लगाया जा सकता है।",
  T_48_META_API_22_P0_D: "कैप्सूल क्षेत्र के दोनों सिरों पर गोलार्धों की त्रिज्या, केवल सकारात्मक मान स्वीकार किए जाते हैं",
  T_48_META_API_22_P1_D: "कैप्सूल क्षेत्र के दोनों सिरों पर गोलार्धों के केंद्रों के बीच की दूरी दोनों छोर पर गोलार्धों की त्रिज्या के दोगुने से अधिक होनी चाहिए।",
  T_48_META_API_22_P2_D: "कैप्सूल क्षेत्र का केंद्र बिंदु",
  T_48_META_API_22_P3_D: "कैप्सूल क्षेत्र का घूमना",
  T_48_META_API_22_P4_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_22_P5_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_22_P6_D: "हिट संस्थाओं की सूची",
  T_48_META_API_23_D: "प्लेयर के लिए विशेष आइटम स्थिति सेट करें। आपके पास केवल एक विशेष आइटम हो सकता है।",
  T_48_META_API_23_P0_D: "खिलाड़ी",
  T_48_META_API_23_P1_D: "आइटम आईडी",
  T_48_META_API_23_P2_D: "क्या इस आइटम को सक्षम करना है",
  T_48_META_API_23_P3_D: "विशेष वस्तु इकाई",
  T_48_META_API_24_D: "लक्ष्य पर बल लगाएं, जो एक भौतिक वस्तु होनी चाहिए",
  T_48_META_API_24_P0_D: "भौतिक वस्तु को लक्ष्य करें",
  T_48_META_API_24_P1_D: "बल सदिश",
  T_48_META_API_24_P2_D: "बल का प्रकार",
  T_48_META_API_25_D: "एक निश्चित बिंदु पर एक बार बल लगाएं, लक्ष्य एक कठोर पिंड होना चाहिए",
  T_48_META_API_25_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_25_P1_D: "बल सदिश",
  T_48_META_API_25_P2_D: "बल प्रयोग स्थिति",
  T_48_META_API_25_P3_D: "बल का प्रकार",
  T_48_META_API_26_D: "लक्ष्य पर एक टॉर्क लागू करें, जो एक कठोर शरीर होना चाहिए",
  T_48_META_API_26_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_26_P1_D: "टॉर्कः",
  T_48_META_API_26_P2_D: "बल प्रकार",
  T_48_META_API_27_D: "लक्ष्य कठोर शरीर को निर्दिष्ट स्थान पर ले जाएँ",
  T_48_META_API_27_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_27_P1_D: "स्थान निर्दिष्ट करें",
  T_48_META_API_28_D: "लक्ष्य कठोर शरीर को घुमाएँ",
  T_48_META_API_28_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_28_P1_D: "चतुर्भुज घुमाएँ",
  T_48_META_API_29_D: "अंतर्वेशित गति बनाएं, और लक्ष्य इकाई की निर्दिष्ट विशेषताएँ सेटिंग्स के अनुसार सुचारू रूप से चलेंगी",
  T_48_META_API_29_P0_D: "लक्ष्य इकाई",
  T_48_META_API_29_P1_D: "विशेषता आईडी जिसे बदलने की आवश्यकता है",
  T_48_META_API_29_P2_D: "विशेषता आरंभिक मान",
  T_48_META_API_29_P3_D: "विशेषता अंत मान",
  T_48_META_API_29_P4_D: `आप सिंगल, लूप और रेसिप्रोकेटिंग चुन सकते हैं। 
 लूप का मतलब है कि प्रत्येक मूवमेंट पूरा होने के बाद, इकाई फिर से शुरुआती मूल्य से आगे बढ़ेगी। रेसिप्रोकेटिंग का मतलब है कि शुरुआती मूल्य से लक्ष्य मूल्य तक की मूवमेंट पूरी होने के बाद, इकाई फिर से लक्ष्य मूल्य से शुरुआती मूल्य तक आगे बढ़ेगी, और फिर प्रक्रिया को दोहराएगी`,
  T_48_META_API_29_P5_D: "बेज़ियर वक्र नियंत्रण बिंदु",
  T_48_META_API_29_P6_D: "परिवर्तन की अवधि, मिलीसेकंड में",
  T_48_META_API_29_P7_D: "अंतर्वेशित गति इकाई बनाई गई",
  T_48_META_API_29_P8_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_3_D: "खेल को लक्ष्य चरण में बदलें, और राउंड भी एक विशेष चरण है। किसी मोड़ के भीतर एक चरण पर स्विच करते समय, मोड़ की गिनती 0 होती है।",
  T_48_META_API_3_P0_D: "लक्ष्य दौर या चरण का सूचकांक",
  T_48_META_API_30_D: "लक्ष्य खिलाड़ी को निर्दिष्ट वाहन में प्रवेश करने के लिए बाध्य करें",
  T_48_META_API_30_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_30_P1_D: "वाहन इकाई",
  T_48_META_API_30_P2_D: "सीट संख्या",
  T_48_META_API_30_P3_D: "क्या खिलाड़ी को वाहन में प्रवेश करने की सफलतापूर्वक अनुमति दी गई है",
  T_48_META_API_3001_D: "लक्ष्य खिलाड़ी को आइटम गिराने का कारण बनता है",
  T_48_META_API_3001_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3001_P1_D: "आइटम इकाई",
  T_48_META_API_3002_D: "वर्तमान में उपलब्ध यादृच्छिक स्पॉन बिंदु के भीतर उपलब्ध निर्देशांक प्राप्त करें जो पूरी तरह से व्याप्त नहीं है (अप्रचलित, कृपया GetRandomSpawnPosition का उपयोग करें)",
  T_48_META_API_3002_P0_D: "जिन खिलाड़ियों को स्पॉन क्षेत्र निर्दिष्ट करने की आवश्यकता है",
  T_48_META_API_3002_R_D: "बेतरतीब ढंग से निर्दिष्ट यादृच्छिक बिंदु निर्देशांक",
  T_48_META_API_3003_D: "खिलाड़ी के निर्दिष्ट बिंदु प्रकार का कुल अंक मान प्राप्त करें",
  T_48_META_API_3003_P0_D: "खिलाड़ी",
  T_48_META_API_3003_P1_D: "बिंदु प्रकार",
  T_48_META_API_3003_R_D: "अंक मूल्य",
  T_48_META_API_3004_D: "खिलाड़ी-निर्दिष्ट बिंदु प्रकार के लिए गोल बिंदु मान सेट करें",
  T_48_META_API_3004_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3004_P1_D: "बिंदु प्रकार",
  T_48_META_API_3004_P2_D: "अंक मूल्य",
  T_48_META_API_3005_D: "टीम के लिए निर्दिष्ट बिंदु प्रकार का कुल अंक मान प्राप्त करें",
  T_48_META_API_3005_P0_D: "टीम इकाई",
  T_48_META_API_3005_P1_D: "बिंदु प्रकार",
  T_48_META_API_3005_R_D: "अंक मूल्य",
  T_48_META_API_3006_D: "टीम के निर्दिष्ट बिंदु प्रकार के लिए गोल बिंदु मान सेट करें",
  T_48_META_API_3006_P0_D: "टीम इकाई",
  T_48_META_API_3006_P1_D: "बिंदु प्रकार",
  T_48_META_API_3006_P2_D: "अंक मूल्य",
  T_48_META_API_3007_D: "निर्दिष्ट राउंड और पॉइंट प्रकार के लिए खिलाड़ी के अंक प्राप्त करें",
  T_48_META_API_3007_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3007_P1_D: "गोल सूचकांक",
  T_48_META_API_3007_P2_D: "बिंदु प्रकार",
  T_48_META_API_3007_R_D: "अंक मूल्य",
  T_48_META_API_3008_D: "निर्दिष्ट राउंड और पॉइंट प्रकार के लिए टीम के अंक प्राप्त करें",
  T_48_META_API_3008_P0_D: "टीम इकाई",
  T_48_META_API_3008_P1_D: "गोल सूचकांक",
  T_48_META_API_3008_P2_D: "बिंदु प्रकार",
  T_48_META_API_3008_R_D: "अंक मूल्य",
  T_48_META_API_3009_D: "खिलाड़ी की कुल गेम रैंकिंग प्राप्त करें",
  T_48_META_API_3009_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3009_R_D: "श्रेणी",
  T_48_META_API_3011_D: "टीम के खेल की समग्र रैंकिंग प्राप्त करें",
  T_48_META_API_3011_P0_D: "पदावनत",
  T_48_META_API_3011_R_D: "श्रेणी",
  T_48_META_API_3013_D: "खिलाड़ी की निर्दिष्ट राउंड रैंकिंग प्राप्त करें",
  T_48_META_API_3013_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3013_P1_D: "गोल सूचकांक",
  T_48_META_API_3013_R_D: "श्रेणी",
  T_48_META_API_3014_D: "टीम की निर्दिष्ट राउंड रैंकिंग प्राप्त करें",
  T_48_META_API_3014_P0_D: "पदावनत",
  T_48_META_API_3014_P1_D: "गोल सूचकांक",
  T_48_META_API_3014_R_D: "श्रेणी",
  T_48_META_API_3015_D: "लक्ष्य इकाई का बटुआ प्राप्त करें",
  T_48_META_API_3015_P0_D: "लक्ष्य इकाई",
  T_48_META_API_3015_P1_D: "क्या कोई बटुआ मौजूद है?",
  T_48_META_API_3015_P2_D: "प्राप्त बटुआ इकाई",
  T_48_META_API_3016_D: "लक्ष्य खिलाड़ी के लिए एक वॉलेट बनाएं, यदि खिलाड़ी के पास पहले से ही एक वॉलेट है, तो यह अमान्य होगा।",
  T_48_META_API_3016_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3016_P1_D: "बटुए से बंधी इकाई, बटुए का मालिक",
  T_48_META_API_3016_P2_D: "बटुआ इकाई",
  T_48_META_API_3017_D: "निर्दिष्ट वॉलेट में मुद्रा जोड़ें",
  T_48_META_API_3017_P0_D: "लक्ष्य बटुआ",
  T_48_META_API_3017_P1_D: "मुद्रा प्रकार जोड़े गए",
  T_48_META_API_3017_P2_D: "मुद्रा राशि में वृद्धि",
  T_48_META_API_3018_D: "निर्दिष्ट वॉलेट के लिए मुद्रा कम करें",
  T_48_META_API_3018_P0_D: "लक्ष्य बटुआ",
  T_48_META_API_3018_P1_D: "कम मुद्रा प्रकार",
  T_48_META_API_3018_P2_D: "धन की मात्रा कम हो गई",
  T_48_META_API_3019_D: "मुद्रा को एक वॉलेट से दूसरे वॉलेट में स्थानांतरित करें",
  T_48_META_API_3019_P0_D: "मुद्रा स्थानांतरित करने के लिए वॉलेट",
  T_48_META_API_3019_P1_D: "हस्तांतरित मुद्रा का प्रकार",
  T_48_META_API_3019_P2_D: "हस्तांतरित मुद्रा की राशि",
  T_48_META_API_3019_P3_D: "मुद्रा स्थानांतरित करने के लिए वॉलेट",
  T_48_META_API_3020_D: "निर्दिष्ट वॉलेट में निर्दिष्ट प्रकार की मुद्रा की राशि प्राप्त करें",
  T_48_META_API_3020_P0_D: "लक्ष्य बटुआ",
  T_48_META_API_3020_P1_D: "क्वेरी मुद्रा प्रकार",
  T_48_META_API_3020_R_D: "मुद्रा मात्रा",
  T_48_META_API_3021_D: "निर्दिष्ट वॉलेट में निर्दिष्ट प्रकार की मुद्रा की इकाई प्राप्त करें",
  T_48_META_API_3021_P0_D: "लक्ष्य बटुआ",
  T_48_META_API_3021_P1_D: "क्वेरी मुद्रा प्रकार",
  T_48_META_API_3021_R_D: "मौद्रिक इकाई",
  T_48_META_API_3022_D: "खेल में सभी स्टोर प्राप्त करें, एक सूची के रूप में लौटाएँ",
  T_48_META_API_3022_R_D: "स्टोर इकाई सूची",
  T_48_META_API_3023_D: "लक्ष्य प्लेयर की उपस्थिति को निर्दिष्ट दृश्य ऑब्जेक्ट की उपस्थिति से बदलें",
  T_48_META_API_3023_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3023_P1_D: "प्रतिस्थापन लक्ष्य दृश्य वस्तु",
  T_48_META_API_3023_P2_D: "प्रतिस्थापन के बाद खिलाड़ी परिवर्तन भेस घटक बनाया गया",
  T_48_META_API_3024_D: "खिलाड़ी की भेस स्थिति को रद्द करें",
  T_48_META_API_3024_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3025_D: "लक्ष्य प्लेयर पर दृश्य इकाई का क्लोन बनाएं",
  T_48_META_API_3025_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3025_P1_D: "अवतारों के लिए प्रयुक्त दृश्य इकाइयाँ",
  T_48_META_API_3025_P2_D: "क्लोन इकाई बनाई गई",
  T_48_META_API_3026_D: "खिलाड़ी की भेस इकाई प्राप्त करें",
  T_48_META_API_3026_P0_D: "खिलाड़ी",
  T_48_META_API_3026_R_D: "खिलाड़ी प्रच्छन्न इकाई",
  T_48_META_API_3027_D: "सूचकांक के आधार पर चैट चैनल इकाई प्राप्त करें",
  T_48_META_API_3027_P0_D: "चैट चैनल इंडेक्स, रेंज [1,8]",
  T_48_META_API_3027_R_D: "चैट चैनल इकाई",
  T_48_META_API_3028_D: "चैट चैनल इकाई प्राप्त करें जहां निर्दिष्ट प्लेयर वर्तमान में स्थित है",
  T_48_META_API_3028_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3028_R_D: "चैट चैनल इकाई",
  T_48_META_API_3029_D: "खिलाड़ी को निर्दिष्ट चैट चैनल में शामिल होने दें। यदि खिलाड़ी पहले से ही किसी अन्य चैट चैनल में है, तो वह लक्ष्य चैनल पर स्विच हो जाएगा।",
  T_48_META_API_3029_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3029_P1_D: "चैट चैनल इकाई",
  T_48_META_API_3030_D: "इसके कारण प्लेयर वर्तमान चैनल से बाहर निकल जाता है और फिर किसी भी चैट चैनल में न होने की स्थिति में आ जाता है",
  T_48_META_API_3030_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3031_D: "पदावनत",
  T_48_META_API_3031_P0_D: "चैट चैनल इकाई, खाली जब चैनल में कोई खिलाड़ी न हो",
  T_48_META_API_3032_D: "खिलाड़ी की व्यवहार स्थिति सेट करें",
  T_48_META_API_3032_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3032_P1_D: "खिलाड़ी का व्यवहार प्रकार",
  T_48_META_API_3032_P2_D: `सक्षम: एक HUD बटन है और इसे सामान्य रूप से उपयोग किया जा सकता है
अक्षम: HUD बटन अक्षम है और सक्रिय या निष्क्रिय रूप से व्यवहार स्थिति में प्रवेश नहीं कर सकता है
शील्ड: HUD बटन छिपा हुआ है और सक्रिय रूप से व्यवहार स्थिति में प्रवेश नहीं कर सकता है, लेकिन`,
  T_48_META_API_3033_D: "प्लेयर एक निर्दिष्ट दृश्य ऑब्जेक्ट में बदल जाता है",
  T_48_META_API_3033_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3033_P1_D: "रूपांतरित होने वाली वस्तु",
  T_48_META_API_3033_P2_D: "परिवर्तन के बाद बनाई गई इकाई",
  T_48_META_API_3034_D: "खिलाड़ी अपना एक क्लोन बनाते हैं",
  T_48_META_API_3034_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3034_P1_D: "क्लोन इकाई बनाई गई",
  T_48_META_API_3035_D: "एक कस्टम स्टोर बनाएं जहां स्टोर का अगला स्तर अलमारियां हों",
  T_48_META_API_3035_P0_D: "स्टोर इकाई बनाई गई",
  T_48_META_API_3036_D: "एक कस्टम शेल्फ बनाएं. शेल्फ का ऊपरी स्तर स्टोर है और अगला स्तर उत्पाद है.",
  T_48_META_API_3036_P0_D: "शेल्फ इकाई बनाई गई",
  T_48_META_API_3037_D: "एक कस्टम उत्पाद बनाएं जो आइटम जोड़ सके",
  T_48_META_API_3037_P0_D: "उत्पाद इकाई बनाई गई",
  T_48_META_API_3038_D: "किसी उत्पाद में आइटम जोड़ें। इस प्रिमिटिव का कई बार उपयोग करके एक उत्पाद में कई आइटम जोड़े जा सकते हैं।",
  T_48_META_API_3038_P0_D: "कमोडिटी इकाई",
  T_48_META_API_3038_P1_D: "जोड़ने के लिए आइटम",
  T_48_META_API_3038_P2_D: "वस्तु की मात्रा",
  T_48_META_API_3039_D: "जेलब्रेक पुरस्कार दें",
  T_48_META_API_3039_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3039_P1_D: "मात्रा",
  T_48_META_API_3039_P2_D: "असली पैसा",
  T_48_META_API_3040_D: "अद्यतन जेलब्रेक कार्य",
  T_48_META_API_3040_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3040_P1_D: "कार्य आईडी",
  T_48_META_API_3040_P2_D: "कीमत",
  T_48_META_API_3041_D: "यादृच्छिक स्पॉन बिंदु निर्देशांक प्राप्त करना केवल उन उपलब्ध स्पॉन बिंदुओं से यादृच्छिक होगा जो पूरी तरह से व्याप्त नहीं हैं।",
  T_48_META_API_3041_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3041_R_D: "यादृच्छिक जन्म बिंदु निर्देशांक। यदि कोई जन्म बिंदु नहीं है जो शर्तों को पूरा करता है, तो (0, 0, 0) के करीब की स्थिति वापस कर दी जाएगी।",
  T_48_META_API_3042_D: "जेलब्रेक मिनी-गेम से बाहर निकलें",
  T_48_META_API_3042_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3042_P1_D: "कार्य आईडी",
  T_48_META_API_3043_D: "जेलब्रेक प्रॉप्स पर आधारित",
  T_48_META_API_3043_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3043_P1_D: "प्रोप प्रकार",
  T_48_META_API_3043_P2_D: "प्रोप आईडी",
  T_48_META_API_31_D: "सापेक्ष आत्म-गति बनाएँ, और लक्ष्य इकाई हर बार अपने वर्तमान विशेषता मान के सापेक्ष बदलती है",
  T_48_META_API_31_P0_D: "लक्ष्य इकाई",
  T_48_META_API_31_P1_D: "वे विशेषताएँ जिनमें गति परिवर्तन की आवश्यकता होती है",
  T_48_META_API_31_P2_D: "प्रति गतिविधि परिवर्तन की मात्रा",
  T_48_META_API_31_P3_D: "बेज़ियर वक्र नियंत्रण बिंदु",
  T_48_META_API_31_P4_D: `एकल: जब विशेषता डेल्टा मात्रा बदलती है तो रुकें
लूप: हर बार जब विशेषता डेल्टा मात्रा बदलती है, तो आंदोलन को दोहराएं`,
  T_48_META_API_31_P5_D: "परिवर्तन की अवधि, मिलीसेकंड में",
  T_48_META_API_31_P6_D: "निर्मित सापेक्ष स्व-चालित इकाई",
  T_48_META_API_31_P7_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_3100_D: "लक्ष्य निर्दिष्ट स्थिति में एनीमेशन चलाता है",
  T_48_META_API_3100_P0_D: "एक इकाई घटक जिसे एनिमेशन चलाने के लिए एनीमेशन नियंत्रक के साथ लगाया जा सकता है",
  T_48_META_API_3100_P1_D: "एनीमेशन नियंत्रक की निर्दिष्ट स्थिति",
  T_48_META_API_3100_P2_D: "एनिमेशन प्लेबैक स्पीड स्केलिंग",
  T_48_META_API_3100_P3_D: "लूप प्रकार, आप एनीमेशन का मूल तर्क रख सकते हैं, इसे केवल एक बार चला सकते हैं या इसे लूप में चला सकते हैं",
  T_48_META_API_3101_D: "चरित्र एनीमेशन चलाएं और कस्टम एनीमेशन संसाधनों का समर्थन करें",
  T_48_META_API_3101_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3101_P1_D: "कस्टम एनीमेशन संसाधन आईडी",
  T_48_META_API_3101_P2_D: "चाहे लूप करना हो",
  T_48_META_API_3102_D: "निर्दिष्ट खिलाड़ी के चरित्र संसाधन सेट करें",
  T_48_META_API_3102_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3102_P1_D: "कस्टम भूमिका संसाधन आईडी",
  T_48_META_API_3109_D: "सुरक्षित क्षेत्र को चालू करें जो अंतिम बिंदु तक आसानी से चलेगा",
  T_48_META_API_3109_P0_D: "सुरक्षित क्षेत्र की प्रारंभिक स्थिति",
  T_48_META_API_3109_P1_D: "सुरक्षा क्षेत्र की अंतिम स्थिति",
  T_48_META_API_3109_P2_D: "सुरक्षित क्षेत्र का प्रारंभिक दायरा",
  T_48_META_API_3109_P3_D: "सुरक्षित क्षेत्र की अंतिम त्रिज्या",
  T_48_META_API_3109_P4_D: "सुरक्षित क्षेत्र को अपनी अंतिम स्थिति तक पहुंचने में लगने वाला समय, सेकंड में",
  T_48_META_API_3109_P5_D: "सुरक्षित क्षेत्र के बाहर प्रति सेकंड हुई क्षति की मात्रा",
  T_48_META_API_3110_D: "चरित्र उपस्थिति समूह बदलें",
  T_48_META_API_3110_P0_D: "लक्ष्य",
  T_48_META_API_3110_P1_D: "उपस्थिति समूह",
  T_48_META_API_3111_D: "चरित्र उपस्थिति समूह दिखाएँ",
  T_48_META_API_3111_P0_D: "लक्ष्य",
  T_48_META_API_3111_P1_D: "उपस्थिति समूह",
  T_48_META_API_3112_D: "चरित्र उपस्थिति समूह छिपाएँ",
  T_48_META_API_3112_P0_D: "लक्ष्य",
  T_48_META_API_3112_P1_D: "उपस्थिति समूह",
  T_48_META_API_3121_D: "क्राफ्टलैंड स्टूडियो पीसी सांख्यिकी उपयोग के लिए अभिकथन परिणाम भेजें",
  T_48_META_API_3121_P0_D: "दावा अभिव्यक्ति",
  T_48_META_API_3121_P1_D: "संकेत देना",
  T_48_META_API_32_D: "खिलाड़ी का आज का टोकन डेटा प्राप्त करें",
  T_48_META_API_32_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_32_P1_D: "टोकनआईडी",
  T_48_META_API_32_P2_D: "टोकन की संख्या",
  T_48_META_API_32_P3_D: "क्या आदिम को सफलतापूर्वक बुलाया गया है",
  T_48_META_API_3200_D: "प्लेयर में आइटम जोड़ें और जारी किए गए आइटम की सूची लौटाएँ",
  T_48_META_API_3200_P0_D: "खिलाड़ी",
  T_48_META_API_3200_P1_D: "आइटम आईडी",
  T_48_META_API_3200_P2_D: "वस्तु की मात्रा",
  T_48_META_API_3200_P3_D: "प्लेयर के लिए जोड़े गए आइटमों की सूची, एक सूची के रूप में लौटाई जाती है, भले ही केवल एक आइटम जोड़ा गया हो",
  T_48_META_API_3201_D: "रक्त की मात्रा की ऊपरी सीमा को पार किए बिना निर्दिष्ट खिलाड़ी के रक्त की मात्रा को पुनर्स्थापित करें।",
  T_48_META_API_3201_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3201_P1_D: "खिलाड़ी को रक्त जोड़ने का मूल्य केवल सकारात्मक संख्याएँ स्वीकार की जाती हैं।",
  T_48_META_API_3202_D: "लक्ष्य खिलाड़ी की कौशल सूची निर्धारित करें",
  T_48_META_API_3202_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3202_P1_D: "कौशल सूची",
  T_48_META_API_3203_D: "लक्ष्य खिलाड़ी की कौशल सूची प्राप्त करें",
  T_48_META_API_3203_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3203_R_D: "कौशल सूची",
  T_48_META_API_3205_D: "प्लेयर से एक निश्चित संख्या में आइटम हटाएँ",
  T_48_META_API_3205_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3205_P1_D: "हटाने के लिए आइटम प्रकार",
  T_48_META_API_3205_P2_D: "हटाई जाने वाली मात्रा, यदि यह खिलाड़ी द्वारा रखी गई मात्रा से अधिक है, तो केवल रखी गई वस्तुएँ हटा दी जाएंगी।",
  T_48_META_API_3206_D: "खिलाड़ी के पास मौजूद निर्दिष्ट वस्तुओं की संख्या प्राप्त करें",
  T_48_META_API_3206_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3206_P1_D: "वस्तु का प्रकार",
  T_48_META_API_3206_R_D: "खिलाड़ी के पास मौजूद राशि",
  T_48_META_API_3207_D: "जांचें कि क्या खिलाड़ी वर्तमान चेकपॉइंट को ट्रिगर कर सकता है",
  T_48_META_API_3207_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3207_P1_D: "ट्रिगर",
  T_48_META_API_3207_R_D: "सत्य: ट्रिगर किया जा सकता है, गलत: ट्रिगर नहीं किया जा सकता",
  T_48_META_API_3208_D: "संक्रमण मोड ज़ोंबी विकास",
  T_48_META_API_3208_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3209_D: "एआई इकाइयां डिफ़ॉल्ट व्यवहार वृक्ष को रोकती/निष्पादित करती हैं",
  T_48_META_API_3209_P0_D: "व्यवहार वृक्ष लक्ष्यों को सक्षम करने के लिए",
  T_48_META_API_3209_P1_D: "क्या डिफ़ॉल्ट व्यवहार वृक्ष को निष्पादित करना है",
  T_48_META_API_3210_D: "एआई संस्थाएं निर्धारित लक्ष्यों का पीछा करती हैं",
  T_48_META_API_3210_P0_D: "एआई इकाई जो खोज कार्यान्वित करती है",
  T_48_META_API_3210_P1_D: "लक्ष्य का पीछा किया जा रहा है",
  T_48_META_API_3211_D: "प्लेयर आइटम नष्ट करें (अप्रत्याशित, DeleteEquipment का उपयोग करें)",
  T_48_META_API_3211_P0_D: "वह खिलाड़ी जिसका आइटम नष्ट हो गया था",
  T_48_META_API_3211_P1_D: "नष्ट की गई वस्तु का प्रकार",
  T_48_META_API_3211_P2_D: "हथियार स्लॉट, केवल हथियारों के लिए प्रभावी",
  T_48_META_API_3212_D: "जर्सी बदलें",
  T_48_META_API_3212_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3212_P1_D: "कपड़े की शैली",
  T_48_META_API_3212_P2_D: "मुख्य रंग एक",
  T_48_META_API_3212_P3_D: "मुख्य रंग दो",
  T_48_META_API_3212_P4_D: "विन्यास",
  T_48_META_API_3213_D: "खिलाड़ी की जर्सी को उसकी मूल स्थिति में पुनर्स्थापित करें",
  T_48_META_API_3213_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3214_D: "प्लेयर वॉयस चैट को चालू और बंद करें",
  T_48_META_API_3214_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3214_P1_D: "वॉइस चैट को बंद करना है या नहीं, सही: बंद करें गलत: चालू करें",
  T_48_META_API_3215_D: "प्लेयर त्वरित चैट स्विच करें",
  T_48_META_API_3215_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3215_P1_D: "क्या त्वरित चैट बंद करनी है, सत्य: बंद करें, गलत: खुला",
  T_48_META_API_3216_D: "सेट करें कि लक्षित खिलाड़ी आइटम उठा सकता है या नहीं",
  T_48_META_API_3216_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3216_P1_D: "क्या सामान उठाने से मना किया जाए, सत्य: सामान उठाने से रोका जाए, गलत: उठाया जा सकता है",
  T_48_META_API_3217_D: "निर्धारित करें कि लक्ष्य खिलाड़ी आइटम गिरा सकता है या नहीं",
  T_48_META_API_3217_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3217_P1_D: "क्या वस्तुओं को गिराने से रोका जाए, सत्य: उठाने से रोका जाए, असत्य: उठाया जा सकता है",
  T_48_META_API_3218_D: "खिलाड़ी के निर्दिष्ट स्लॉट में हथियार को नष्ट करें",
  T_48_META_API_3218_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3218_P1_D: "नष्ट करने के लिए हथियार स्लॉट",
  T_48_META_API_3218_P2_D: "नष्ट करने की मात्रा",
  T_48_META_API_3218_P3_D: "चाहे इसे सफलतापूर्वक नष्ट किया गया हो या नहीं, यदि हथियार स्लॉट में कोई हथियार सुसज्जित नहीं है, तो विनाश विफल हो जाएगा।",
  T_48_META_API_3219_D: "लक्ष्य खिलाड़ी के बैकपैक से सुसज्जित वस्तुओं सहित सभी वस्तुओं को साफ़ करें",
  T_48_META_API_3219_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3220_D: "प्लेयर ओरिएंटेशन सेट करें",
  T_48_META_API_3220_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3220_P1_D: "खिलाड़ी की दिशा",
  T_48_META_API_3221_D: "(अप्रत्याशित, कृपया इसका उपयोग न करें। संबंधित जानकारी के लिए, विशेषता <प्लेयर>:कंकाल देखें)",
  T_48_META_API_3221_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_3221_P1_D: "ज़ूम भाग",
  T_48_META_API_3221_P2_D: "ज़ूम मान",
  T_48_META_API_3222_D: "एक खिलाड़ी को टकराव प्रभाव दें, लक्षित खिलाड़ी एक निश्चित गति से गिरेगा, और हवा में टकराने के बाद टकराव को मजबूत रूप से रोका जाएगा।",
  T_48_META_API_3222_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3222_P1_D: "उड़ने की दिशा",
  T_48_META_API_3222_P2_D: "नॉक-अप अवधि",
  T_48_META_API_3222_P3_D: "उड़ान भरते समय Y-अक्ष का प्रारंभिक वेग",
  T_48_META_API_3222_P4_D: "उड़ान भरते समय XZ विमान का प्रारंभिक वेग",
  T_48_META_API_3222_P5_D: "क्या खिलाड़ी का ओरिएंटेशन बदलना है",
  T_48_META_API_3223_D: "लक्ष्य खिलाड़ी या एनपीसी की वस्त्र आईडी प्राप्त करें",
  T_48_META_API_3223_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3223_P1_D: "कपड़ों का प्रकार",
  T_48_META_API_3223_R_D: "वस्त्र पहचान",
  T_48_META_API_3224_D: "लक्ष्य खिलाड़ी या एनपीसी की कपड़ों की आईडी सेट करें",
  T_48_META_API_3224_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3224_P1_D: "वस्त्र पहचान",
  T_48_META_API_3225_D: "लक्ष्य खिलाड़ी के डिफ़ॉल्ट कपड़ों को पुनर्स्थापित करता है, जिसे एनपीसी पर लागू नहीं किया जा सकता है।",
  T_48_META_API_3225_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3226_D: "एआई इकाई निर्दिष्ट लक्ष्य पर हमला करती है",
  T_48_META_API_3226_P0_D: "एआई इकाई जो हमला करती है",
  T_48_META_API_3226_P1_D: "हमले का लक्ष्य",
  T_48_META_API_3227_D: "खिलाड़ी के हथियार को निर्दिष्ट स्लॉट में हथियार पर स्विच करें",
  T_48_META_API_3227_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3227_P1_D: "स्विच करने के लिए हथियार स्लॉट",
  T_48_META_API_3227_P2_D: "स्विच सफल है या नहीं। यदि हथियार स्लॉट में कोई हथियार सुसज्जित नहीं है, तो स्विच विफल हो जाएगा।",
  T_48_META_API_3228_D: "लक्ष्य खिलाड़ी या एनपीसी की हथियार त्वचा प्राप्त करें",
  T_48_META_API_3228_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3228_P1_D: "हथियार त्वचा आईडी",
  T_48_META_API_3228_R_D: "हथियार त्वचा आईडी",
  T_48_META_API_3229_D: "लक्ष्य खिलाड़ी या एनपीसी की हथियार त्वचा सेट करें",
  T_48_META_API_3229_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3229_P1_D: "हथियार त्वचा आईडी",
  T_48_META_API_3230_D: "लक्ष्य खिलाड़ी की डिफ़ॉल्ट हथियार त्वचा को पुनर्स्थापित करता है, जिसे एनपीसी पर लागू नहीं किया जा सकता है।",
  T_48_META_API_3230_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3230_P1_D: "हथियार आईडी",
  T_48_META_API_3231_D: "खिलाड़ी पोशाकें सेट करें",
  T_48_META_API_3231_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3231_P1_D: "पोशाक सूची",
  T_48_META_API_3232_D: "लक्ष्य प्लेयर या एनपीसी से निर्दिष्ट प्रकार के सभी कपड़ों को हटा देता है",
  T_48_META_API_3232_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3232_P1_D: "कपड़ों का प्रकार",
  T_48_META_API_3233_D: "खिलाड़ी या एनपीसी द्वारा निर्दिष्ट हथियार की त्वचा को हटा दें",
  T_48_META_API_3233_P0_D: "लक्ष्य खिलाड़ी या एनपीसी",
  T_48_META_API_3233_P1_D: "हथियार आईडी",
  T_48_META_API_3234_D: "लक्ष्य में बफ़ जोड़ें",
  T_48_META_API_3234_P0_D: "लक्ष्य इकाई एक ऐसी इकाई होनी चाहिए जो बफ़्स जोड़ सके",
  T_48_META_API_3234_P1_D: "बफ़ आईडी",
  T_48_META_API_3235_D: "लक्ष्य से बफ़ हटाएँ",
  T_48_META_API_3235_P0_D: "लक्ष्य इकाई एक ऐसी इकाई होनी चाहिए जो बफ़्स जोड़ सके",
  T_48_META_API_3235_P1_D: "बफ़ आईडी",
  T_48_META_API_3236_D: "लक्ष्य का वर्तमान बफ़ प्राप्त करें",
  T_48_META_API_3236_P0_D: "लक्ष्य इकाई एक ऐसी इकाई होनी चाहिए जो बफ़्स जोड़ सके",
  T_48_META_API_3236_R_D: "शौकीन सूची",
  T_48_META_API_3237_D: "लक्ष्य खिलाड़ी के बैकपैक की सूची में आइटम प्राप्त करें",
  T_48_META_API_3237_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3237_P1_D: "सहारा सूची",
  T_48_META_API_3238_D: "निर्दिष्ट स्लॉट में हथियार में सहायक उपकरण जोड़ें। जो सहायक उपकरण स्लॉट से मेल नहीं खाते हैं उन्हें जोड़ा नहीं जा सकेगा; लेकिन डुप्लिकेट सहायक उपकरण मूल सहायक उपकरण को बदल देंगे जब खिलाड़ी का बैकपैक भर जाएगा , मूल सहायक उपकरण खिलाड़ी के वर्तमान स्थान पर ज",
  T_48_META_API_3238_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3238_P1_D: "उपकरण स्लॉट",
  T_48_META_API_3238_P2_D: "सामान",
  T_48_META_API_3238_P3_D: `क्या सहायक उपकरण सफलतापूर्वक जोड़ा गया था
सत्य: सहायक उपकरण को संबंधित स्लॉट में हथियार से सुसज्जित किया गया है
गलत: सहायक उपकरण जोड़ा नहीं जा सका और खिलाड़ी के बैकपैक में दिखाई नहीं देगा`,
  T_48_META_API_3238_P4_D: "सहायक उपकरण जोड़े गए, असफल होने पर खाली",
  T_48_META_API_3239_D: "बैकपैक उपकरण कॉलम में उपकरण प्राप्त करें",
  T_48_META_API_3239_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3239_P1_D: "उपकरण स्लॉट",
  T_48_META_API_3239_P2_D: "निर्दिष्ट स्लॉट में यदि कोई उपकरण नहीं है, तो यह खाली होगा।",
  T_48_META_API_3239_P3_D: "इस उपकरण के लिए सभी सहायक उपकरण",
  T_48_META_API_3240_D: "द्वि-आयामी वेक्टर का एक्स घटक लें",
  T_48_META_API_3240_P0_D: "2डी वेक्टर",
  T_48_META_API_3240_R_D: "द्वि-आयामी वेक्टर एक्स घटक",
  T_48_META_API_3241_D: "द्वि-आयामी वेक्टर का Y घटक लें",
  T_48_META_API_3241_P0_D: "2डी वेक्टर",
  T_48_META_API_3241_R_D: "द्वि-आयामी वेक्टर Y घटक",
  T_48_META_API_3242_D: "2डी वेक्टर एक्स घटक सेट करता है",
  T_48_META_API_3242_P0_D: "2डी वेक्टर",
  T_48_META_API_3242_P1_D: "द्वि-आयामी वेक्टर एक्स घटक",
  T_48_META_API_3243_D: "2D वेक्टर Y घटक सेट करता है",
  T_48_META_API_3243_P0_D: "2डी वेक्टर",
  T_48_META_API_3243_P1_D: "द्वि-आयामी वेक्टर Y घटक",
  T_48_META_API_3244_D: "दो 2D वेक्टर जोड़ें",
  T_48_META_API_3244_P0_D: "वाम",
  T_48_META_API_3244_P1_D: "दक्षिण",
  T_48_META_API_3244_R_D: "द्वि-आयामी वेक्टर जोड़ परिणाम",
  T_48_META_API_3245_D: "दो 2डी वेक्टर घटाएं",
  T_48_META_API_3245_P0_D: "वाम",
  T_48_META_API_3245_P1_D: "दक्षिण",
  T_48_META_API_3245_R_D: "द्वि-आयामी वेक्टर घटाव परिणाम",
  T_48_META_API_3246_D: "द्वि-आयामी सदिशों को गुणा करें",
  T_48_META_API_3246_P0_D: "2डी वेक्टर",
  T_48_META_API_3246_P1_D: "2डी वेक्टर स्केलिंग मान",
  T_48_META_API_3246_R_D: "द्वि-आयामी वेक्टर गुणन परिणाम",
  T_48_META_API_3247_D: "डॉट उत्पाद दो द्वि-आयामी वैक्टर। डॉट उत्पाद का परिणाम एक अदिश राशि है, जो दो वैक्टर के बीच के कोण का प्रतिनिधित्व करता है।",
  T_48_META_API_3247_P0_D: "वाम",
  T_48_META_API_3247_P1_D: "दक्षिण",
  T_48_META_API_3247_R_D: "बिंदु गुणन परिणाम",
  T_48_META_API_3248_D: "दो 2डी वैक्टरों की यूक्लिडियन दूरी की गणना करें",
  T_48_META_API_3248_P0_D: "वाम",
  T_48_META_API_3248_P1_D: "दक्षिण",
  T_48_META_API_3248_R_D: "दो वैक्टर घटाने के बाद, परिणामी वेक्टर की मॉड्यूल लंबाई",
  T_48_META_API_3249_D: "दो द्वि-आयामी सदिशों के बीच के कोण की गणना करें",
  T_48_META_API_3249_P0_D: "वाम",
  T_48_META_API_3249_P1_D: "दक्षिण",
  T_48_META_API_3249_R_D: "सदिश कोण, कोण सीमा 0-180",
  T_48_META_API_3250_D: "2डी वेक्टर को सामान्यीकृत करें",
  T_48_META_API_3250_P0_D: "2डी वेक्टर",
  T_48_META_API_3250_R_D: "सामान्यीकृत परिणाम एक ही दिशा में 1 मीटर की लंबाई वाला एक वेक्टर है।",
  T_48_META_API_3251_D: "मोडुलो एक द्वि-आयामी वेक्टर",
  T_48_META_API_3251_P0_D: "2डी वेक्टर",
  T_48_META_API_3251_R_D: "मॉड्यूलो परिणाम वेक्टर की लंबाई है",
  T_48_META_API_3252_D: "एक सामान्य ऊर्ध्वाधर सीधी रेखा द्वारा प्रतिबिंबित द्वि-आयामी वेक्टर के वेक्टर की गणना करें",
  T_48_META_API_3252_P0_D: "घटना 2D वेक्टर",
  T_48_META_API_3252_P1_D: "सामान्य 2D वेक्टर",
  T_48_META_API_3252_R_D: "प्रतिबिंब 2D वेक्टर",
  T_48_META_API_3253_D: "सामान्य के लंबवत समतल द्वारा परावर्तित त्रि-आयामी वेक्टर के वेक्टर की गणना करें",
  T_48_META_API_3253_P0_D: "घटना त्रि-आयामी वेक्टर",
  T_48_META_API_3253_P1_D: "सामान्य 3D वेक्टर",
  T_48_META_API_3253_R_D: "प्रतिबिंब 3डी वेक्टर",
  T_48_META_API_3254_D: "त्रि-आयामी वेक्टर को द्वि-आयामी वेक्टर में बदलें और त्रि-आयामी वेक्टर के Z घटक को हटा दें",
  T_48_META_API_3254_P0_D: "लक्ष्य 3D वेक्टर",
  T_48_META_API_3254_R_D: "परिवर्तित द्वि-आयामी वेक्टर",
  T_48_META_API_3255_D: "द्वि-आयामी वेक्टर को त्रि-आयामी वेक्टर में बदलें, और त्रि-आयामी वेक्टर के Z घटक को 0 पर सेट करें",
  T_48_META_API_3255_P0_D: "लक्ष्य 2डी वेक्टर",
  T_48_META_API_3255_R_D: "परिवर्तित त्रि-आयामी वेक्टर",
  T_48_META_API_3256_D: "एक 2डी वेक्टर बनाएं",
  T_48_META_API_3256_P0_D: "द्वि-आयामी वेक्टर का एक्स घटक",
  T_48_META_API_3256_P1_D: "द्वि-आयामी वेक्टर का Y घटक",
  T_48_META_API_3256_R_D: "द्वि-आयामी वेक्टर बनाया गया",
  T_48_META_API_3257_D: "उपयोगकर्ता अनुभव डेटा विश्लेषण के लिए प्रतिस्पर्धा बिंदु लॉग को अनुकूलित करें",
  T_48_META_API_3257_P0_D: "लकड़ी का लट्ठा",
  T_48_META_API_3258_D: "उपयोगकर्ता अनुभव डेटा विश्लेषण के लिए प्रतिस्पर्धा बिंदु लॉग को अनुकूलित करें",
  T_48_META_API_3258_P0_D: "खिलाड़ियों की रिपोर्ट की जानी है",
  T_48_META_API_3258_P1_D: "लकड़ी का लट्ठा",
  T_48_META_API_33_D: "गंदा शब्द फ़िल्टर",
  T_48_META_API_33_P0_D: "मूल पाठ जिसे गंदे शब्दों के लिए फ़िल्टर करने की आवश्यकता है",
  T_48_META_API_33_R_D: "फ़िल्टर किया गया पाठ",
  T_48_META_API_3301_D: "एक शिविर इकाई बनाएँ",
  T_48_META_API_3301_P0_D: "गुट इकाई",
  T_48_META_API_3302_D: "लक्ष्य इकाई निर्दिष्ट शिविर में शामिल हो जाती है",
  T_48_META_API_3302_P0_D: "लक्ष्य इकाई",
  T_48_META_API_3302_P1_D: "गुट इकाई",
  T_48_META_API_3303_D: "शिविर का आक्रमण योग्य शिविर प्राप्त करें",
  T_48_META_API_3303_P0_D: "शिविर पर हमला",
  T_48_META_API_3303_R_D: "गुट इकाई सूची",
  T_48_META_API_3304_D: "शिविर के आक्रमण योग्य शिविर को स्थापित करें",
  T_48_META_API_3304_P0_D: "शिविर पर हमला",
  T_48_META_API_3304_P1_D: "लक्ष्य शिविर",
  T_48_META_API_3304_P2_D: "क्या यह हमला करने योग्य है?",
  T_48_META_API_3305_D: "खिलाड़ियों पर आक्रमण करने के लिए सेट अप करें",
  T_48_META_API_3305_P0_D: "खिलाड़ी",
  T_48_META_API_3305_P1_D: "खिलाड़ियों पर हमला कर सकते हैं",
  T_48_META_API_3305_P2_D: "क्या यह हमला करने योग्य है?",
  T_48_META_API_3306_D: "टीम की आक्रमण योग्य टीमें सेट करें",
  T_48_META_API_3306_P0_D: "हमलावर टीम",
  T_48_META_API_3306_P1_D: "लक्ष्य टीम",
  T_48_META_API_3306_P2_D: "क्या यह हमला करने योग्य है?",
  T_48_META_API_3307_D: "पदावनत",
  T_48_META_API_3307_P0_D: "पदावनत",
  T_48_META_API_3307_R_D: "प्लेयर इकाई सूची",
  T_48_META_API_3308_D: "निर्दिष्ट इकाई वर्तमान शिविर से बाहर निकलती है",
  T_48_META_API_3308_P0_D: "लक्ष्य इकाई",
  T_48_META_API_3309_D: "लक्ष्य का गुट प्राप्त करें",
  T_48_META_API_3309_P0_D: "लक्ष्य इकाई",
  T_48_META_API_3309_R_D: "गुट इकाई",
  T_48_META_API_3310_D: "निर्धारित करें कि क्या लक्ष्य पर हमला किया जा सकता है",
  T_48_META_API_3310_P0_D: "हमलावर",
  T_48_META_API_3310_P1_D: "लक्ष्य इकाई",
  T_48_META_API_3310_R_D: "क्या यह हमला करने योग्य है?",
  T_48_META_API_3311_D: "संस्थाओं के लिए आक्रमण योग्य लक्ष्य निर्धारित करें",
  T_48_META_API_3311_P0_D: "हमलावर",
  T_48_META_API_3311_P1_D: "लक्ष्य इकाई",
  T_48_META_API_3311_P2_D: "क्या यह हमला करने योग्य है?",
  T_48_META_API_3312_D: "किसी इकाई के आक्रमण योग्य लक्ष्य प्राप्त करता है",
  T_48_META_API_3312_P0_D: "हमलावर",
  T_48_META_API_3312_R_D: "आक्रमण योग्य संस्थाओं की सूची",
  T_48_META_API_34_D: "निर्धारित करें कि लक्ष्य इकाई में घटक हैं या नहीं",
  T_48_META_API_34_P0_D: "लक्ष्य इकाई",
  T_48_META_API_34_P1_D: "घटक प्रकार",
  T_48_META_API_34_R_D: "क्या मौजूद है",
  T_48_META_API_35_D: "बॉट जोड़ें",
  T_48_META_API_35_P0_D: "बॉट कठिनाई स्तर",
  T_48_META_API_35_P1_D: "बॉट जिस टीम से संबंधित है",
  T_48_META_API_35_P2_D: "निर्मित बॉट प्लेयर इकाई",
  T_48_META_API_3500_D: "प्लेयर टोकन डेटा प्राप्त करें",
  T_48_META_API_3500_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3500_P1_D: "टोकनआईडी",
  T_48_META_API_3500_P2_D: "टोकन की संख्या",
  T_48_META_API_3500_P3_D: "क्या यह सफल है?",
  T_48_META_API_3501_D: "खिलाड़ियों के लिए टोकन डेटा जोड़ें",
  T_48_META_API_3501_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3501_P1_D: "टोकनआईडी",
  T_48_META_API_3501_P2_D: "टोकन की संख्या",
  T_48_META_API_3501_P3_D: "ब्लॉक सफलतापूर्वक बुलाया गया है या नहीं",
  T_48_META_API_3502_D: "लक्ष्य खिलाड़ी टोकन का उपभोग करें",
  T_48_META_API_3502_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3502_P1_D: "टोकनआईडी",
  T_48_META_API_3502_P2_D: "टोकन की संख्या",
  T_48_META_API_3502_P3_D: "क्या आदिम को सफलतापूर्वक बुलाया गया है",
  T_48_META_API_3503_D: "निर्दिष्ट स्थान पर टोकन जोड़ें",
  T_48_META_API_3503_P0_D: "जगह",
  T_48_META_API_3503_P1_D: "टोकनआईडी",
  T_48_META_API_3503_P2_D: "टोकन की संख्या",
  T_48_META_API_3503_P3_D: "क्या आदिम को सफलतापूर्वक बुलाया गया है",
  T_48_META_API_3504_D: "लक्ष्य AI निर्दिष्ट कौशल जारी करता है",
  T_48_META_API_3504_P0_D: "लक्ष्य एआई",
  T_48_META_API_3504_P1_D: "कौशल",
  T_48_META_API_3504_P2_D: "कौशल लक्ष्य",
  T_48_META_API_3504_P3_D: "क्या कौशल सफलतापूर्वक जारी किया गया है",
  T_48_META_API_3505_D: "शुरुआती बिंदु से अंतिम बिंदु तक एक पाथफाइंडिंग पथ बनाएं, जो बाधाओं को पार कर जाएगा और एआई पाथफाइंडिंग के लिए इस्तेमाल किया जा सकता है।",
  T_48_META_API_3505_P0_D: "प्रारंभिक बिंदु निर्देशांक",
  T_48_META_API_3505_P1_D: "अंतिम बिंदु निर्देशांक",
  T_48_META_API_3505_P2_D: "क्या पथ खोज पथ सफलतापूर्वक स्थापित किया गया था",
  T_48_META_API_3505_P3_D: "मार्ग-निर्धारण बिंदु संग्रह",
  T_48_META_API_3506_D: "व्यवहार वृक्ष ब्लैकबोर्ड चर सेट करें",
  T_48_META_API_3506_P0_D: "लक्ष्य व्यवहार वृक्ष",
  T_48_META_API_3506_P1_D: "चर का नाम",
  T_48_META_API_3506_P2_D: "परिवर्तनीय मान",
  T_48_META_API_3507_D: "व्यवहार वृक्ष ब्लैकबोर्ड चर प्राप्त करें",
  T_48_META_API_3507_P0_D: "लक्ष्य व्यवहार वृक्ष",
  T_48_META_API_3507_P1_D: "चर का नाम",
  T_48_META_API_3507_P2_D: "परिवर्तनीय मान",
  T_48_META_API_3508_D: "व्यवहार वृक्ष नोड पैरामीटर प्राप्त करें",
  T_48_META_API_3508_P0_D: "लक्ष्य व्यवहार वृक्ष नोड",
  T_48_META_API_3508_P1_D: "मापदण्ड नाम",
  T_48_META_API_3508_P2_D: "पैरामीटर मान",
  T_48_META_API_3509_D: "लक्ष्य खिलाड़ी की वाहन त्वचा प्राप्त करें",
  T_48_META_API_3509_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3509_P1_D: "वाहन आईडी",
  T_48_META_API_3509_R_D: "वाहन त्वचा",
  T_48_META_API_3510_D: "लक्ष्य खिलाड़ी की वाहन त्वचा सेट करें",
  T_48_META_API_3510_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3510_P1_D: "वाहन त्वचा आईडी",
  T_48_META_API_3511_D: "लक्षित खिलाड़ी के निर्दिष्ट वाहन की त्वचा को साफ करें",
  T_48_META_API_3511_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3511_P1_D: "वाहन आईडी",
  T_48_META_API_3512_D: "लक्ष्य खिलाड़ी की डिफ़ॉल्ट वाहन त्वचा को पुनर्स्थापित करें",
  T_48_META_API_3512_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_3512_P1_D: "वाहन आईडी",
  T_48_META_API_36_D: "स्लीप टारगेट, केवल गतिशील प्रकार के कठोर निकायों के लिए उपयोग किया जा सकता है",
  T_48_META_API_36_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_37_D: "लक्ष्य को जगाएं, इसका उपयोग केवल गतिशील प्रकार के कठोर निकायों के लिए किया जा सकता है",
  T_48_META_API_37_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_38_D: "जांचें कि लक्ष्य कठोर शरीर सो रहा है या नहीं",
  T_48_META_API_38_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_38_R_D: "क्या यह सो रहा है?",
  T_48_META_API_39_D: "नींद की सीमा निर्धारित करें",
  T_48_META_API_39_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_39_P1_D: "नींद की सीमा। कुछ समय के लिए इसकी गति और घूर्णन इस मान से कम होने के बाद कठोर शरीर नींद की स्थिति में प्रवेश करता है।",
  T_48_META_API_4_D: "सेट करें कि क्या सभी खिलाड़ी चल सकते हैं",
  T_48_META_API_4_P0_D: `सत्य: स्थानांतरित किया जा सकता है
गलत: स्थानांतरित नहीं किया जा सकता`,
  T_48_META_API_40_D: "नींद की सीमा प्राप्त करें",
  T_48_META_API_40_P0_D: "लक्ष्य कठोर शरीर",
  T_48_META_API_40_R_D: "नींद की सीमा। कुछ समय के लिए इसकी गति और घूर्णन इस मान से कम होने के बाद कठोर शरीर नींद की स्थिति में प्रवेश करता है।",
  T_48_META_API_4000_D: "संपूर्ण तालिका की सामग्री पढ़ें और पंक्ति क्रम में एक द्वि-आयामी सरणी लौटाएँ।",
  T_48_META_API_4000_P0_D: "तालिका नाम",
  T_48_META_API_4000_R_D: "तालिका सामग्री",
  T_48_META_API_4001_D: "तालिका की एक पंक्ति की सामग्री पढ़ें और एक सरणी लौटाएँ",
  T_48_META_API_4001_P0_D: "तालिका नाम",
  T_48_META_API_4001_P1_D: "पढ़ने के लिए पंक्तियों की संख्या, 1 से शुरू करके",
  T_48_META_API_4001_R_D: "तालिका एक पंक्ति की सामग्री निर्दिष्ट करती है",
  T_48_META_API_4002_D: "तालिका के किसी कॉलम की सामग्री पढ़ें और एक सरणी लौटाएँ",
  T_48_META_API_4002_P0_D: "तालिका नाम",
  T_48_META_API_4002_P1_D: "पढ़ने के लिए कॉलमों की संख्या, 1 से शुरू करके",
  T_48_META_API_4002_R_D: "तालिका किसी कॉलम की सामग्री निर्दिष्ट करती है",
  T_48_META_API_4003_D: "तालिका सेल की सामग्री पढ़ें",
  T_48_META_API_4003_P0_D: "तालिका नाम",
  T_48_META_API_4003_P1_D: "पढ़ने के लिए पंक्तियों की संख्या, 1 से शुरू करके",
  T_48_META_API_4003_P2_D: "पढ़ने के लिए कॉलमों की संख्या, 1 से शुरू करके",
  T_48_META_API_4003_R_D: "तालिका में निर्दिष्ट सेल की सामग्री",
  T_48_META_API_4004_D: "तालिका में किसी निश्चित सेल की सामग्री को पंक्ति संख्या और कॉलम नाम से पढ़ें",
  T_48_META_API_4004_P0_D: "तालिका नाम",
  T_48_META_API_4004_P1_D: "पढ़ने के लिए पंक्तियों की संख्या, 1 से शुरू करके",
  T_48_META_API_4004_P2_D: "पढ़ने के लिए कॉलम का नाम",
  T_48_META_API_4004_R_D: "तालिका में निर्दिष्ट सेल की सामग्री",
  T_48_META_API_4005_D: "संपूर्ण तालिका की सामग्री पढ़ें और एक द्वि-आयामी सरणी लौटाएँ",
  T_48_META_API_4005_P0_D: "तालिका नाम",
  T_48_META_API_4005_R_D: "तालिका की सामग्री, द्वि-आयामी सरणी",
  T_48_META_API_4006_D: "संपूर्ण तालिका की एक निश्चित पंक्ति की सामग्री पढ़ें और एक सरणी लौटाएँ",
  T_48_META_API_4006_P0_D: "तालिका नाम",
  T_48_META_API_4006_P1_D: "पढ़ने के लिए पंक्तियों की संख्या, 1 से शुरू करके",
  T_48_META_API_4006_R_D: "तालिका एक पंक्ति, एक सरणी की सामग्री निर्दिष्ट करती है",
  T_48_META_API_4007_D: "संपूर्ण तालिका के एक कॉलम की सामग्री पढ़ें और एक सरणी लौटाएँ",
  T_48_META_API_4007_P0_D: "तालिका नाम",
  T_48_META_API_4007_P1_D: "पढ़ने के लिए कॉलमों की संख्या, 1 से शुरू करके",
  T_48_META_API_4007_R_D: "तालिका एक कॉलम, एक सरणी की सामग्री निर्दिष्ट करती है",
  T_48_META_API_4008_D: "तालिका सेल की सामग्री पढ़ें",
  T_48_META_API_4008_P0_D: "तालिका नाम",
  T_48_META_API_4008_P1_D: "पढ़ने के लिए पंक्तियों की संख्या, 1 से शुरू करके",
  T_48_META_API_4008_P2_D: "पढ़ने के लिए कॉलमों की संख्या, 1 से शुरू करके",
  T_48_META_API_4008_R_D: "तालिका में निर्दिष्ट सेल की सामग्री",
  T_48_META_API_4009_D: "कॉलम संख्या और सेल मान द्वारा निर्दिष्ट पंक्ति खोजें",
  T_48_META_API_4009_P0_D: "तालिका नाम",
  T_48_META_API_4009_P1_D: "पढ़ने योग्य स्तंभों की संख्या",
  T_48_META_API_4009_P2_D: "खोजने के लिए सेल मान",
  T_48_META_API_4009_R_D: "मिली पंक्ति की सामग्री, सरणी",
  T_48_META_API_4010_D: "कॉलम नाम से कॉलम नंबर प्राप्त करें",
  T_48_META_API_4010_P0_D: "तालिका नाम",
  T_48_META_API_4010_P1_D: "क्रम संख्या जांचने के लिए कॉलम का नाम",
  T_48_META_API_4010_R_D: "स्तंभों की संख्या, 1 से गिनती",
  T_48_META_API_41_D: "वैश्विक नींद सीमा निर्धारित करें, जो केवल नव निर्मित गतिशील प्रकार के कठोर निकायों के लिए मान्य है।",
  T_48_META_API_41_P0_D: "नींद की सीमा। कुछ समय के लिए इसकी गति और घूर्णन इस मान से कम होने के बाद कठोर शरीर नींद की स्थिति में प्रवेश करता है।",
  T_48_META_API_42_D: "वैश्विक नींद सीमा प्राप्त करें",
  T_48_META_API_42_R_D: "नींद की सीमा, डिफ़ॉल्ट 0.005 है। कुछ समय के लिए गति और घूर्णन इस मान से कम होने के बाद कठोर शरीर नींद की स्थिति में प्रवेश करेगा।",
  T_48_META_API_43_D: "दिए गए चतुर्भुज को यूलर कोणों में परिवर्तित करें। यूलर कोणों का घूर्णन क्रम YXZ है।",
  T_48_META_API_43_P0_D: "इनपुट चतुर्भुज",
  T_48_META_API_43_R_D: "यूलर कोण लौटाए गए",
  T_48_META_API_44_D: "दिए गए यूलर कोणों को चतुर्भुज में बदलें",
  T_48_META_API_44_P0_D: "इनपुट यूलर कोण",
  T_48_META_API_44_R_D: "क्वाटरनियन लौट आया",
  T_48_META_API_45_D: "अक्ष कोण द्वारा दर्शाए गए घूर्णन को चतुर्भुज में परिवर्तित करें",
  T_48_META_API_45_P0_D: "अक्ष",
  T_48_META_API_45_P1_D: "घूर्णन की धुरी के चारों ओर दक्षिणावर्त घूर्णन का कोण",
  T_48_META_API_45_R_D: "क्वाटरनियन लौट आया",
  T_48_META_API_46_D: "चतुर्भुज को अक्ष कोण निरूपण में बदलें",
  T_48_META_API_46_P0_D: "इनपुट चतुर्भुज",
  T_48_META_API_46_P1_D: "अक्ष",
  T_48_META_API_46_P2_D: "घूर्णन की धुरी के चारों ओर दक्षिणावर्त घूर्णन का कोण",
  T_48_META_API_47_D: "कस्टम कार्य पूर्णता प्रगति सेट करें",
  T_48_META_API_47_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_47_P1_D: "कार्य आईडी",
  T_48_META_API_47_P2_D: "पूर्णता प्रगति, ऋणात्मक संख्याओं की अनुमति नहीं है",
  T_48_META_API_48_D: "एक बेज़ियर वक्र बनाएं जिसका उपयोग गति को प्रक्षेपित करने के लिए किया जा सकता है",
  T_48_META_API_48_P0_D: "वक्र नियंत्रण बिंदु",
  T_48_META_API_48_R_D: "बेज़ियर वक्र",
  T_48_META_API_49_D: "दृश्य मानचित्र आईडी प्राप्त करें",
  T_48_META_API_49_P0_D: "दृश्य आईडी",
  T_48_META_API_49_R_D: "मानचित्र आईडी",
  T_48_META_API_5_D: "दृश्य में रखे गए ऑब्जेक्ट हटाएं (अप्रचलित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_5_P0_D: "ऑब्जेक्ट इकाई को हटाया जाना है",
  T_48_META_API_50_D: "प्रत्येक फ्रेम के सापेक्ष एक गति बनाएं। लक्ष्य इकाई प्रत्येक फ्रेम में एक बार अपनी विशेषताओं को बदलती है, और हर बार यह अपने वर्तमान विशेषता मान के सापेक्ष बदलती है।",
  T_48_META_API_50_P0_D: "लक्ष्य इकाई",
  T_48_META_API_50_P1_D: "वे विशेषताएँ जिनमें गति परिवर्तन की आवश्यकता होती है",
  T_48_META_API_50_P2_D: "प्रति गतिविधि परिवर्तन की मात्रा",
  T_48_META_API_50_P3_D: `अन्य गति मोड के साथ संयोजन में उपयोग किए जाने पर कॉन्फ़िगरेशन
सही: सापेक्ष गति के साथ संयोजन में उपयोग किया जा सकता है
गलत: निरपेक्ष गति के साथ संयोजन में उपयोग किया जा सकता है`,
  T_48_META_API_50_P4_D: "प्रति फ्रेम स्वयं के सापेक्ष निर्मित गति इकाई",
  T_48_META_API_50_P5_D: "निर्माण के बाद स्वचालित रूप से खेलना प्रारंभ करना है या नहीं",
  T_48_META_API_5000_D: "डेटाबेस में किसी तालिका में कुंजी से संबंधित मान पढ़ें",
  T_48_META_API_5000_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5000_P1_D: "खिलाड़ियों को चिह्नित करें और समवर्ती स्थितियों को संभालें",
  T_48_META_API_5000_P2_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5000_P3_D: "पढ़ा गया परिणाम लौटाएँ",
  T_48_META_API_5000_P4_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5001_D: "डेटाबेस में किसी तालिका में कुंजी के अनुरूप मान लिखें",
  T_48_META_API_5001_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5001_P1_D: "खिलाड़ियों को चिह्नित करें और समवर्ती स्थितियों को संभालें",
  T_48_META_API_5001_P2_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5001_P3_D: "मूल्य लिखा है",
  T_48_META_API_5001_P4_D: "डेटाबेस से संबंधित युद्धक्षेत्र कोड, जिसे रिक्त स्थान में भरा जा सकता है, वर्तमान मानचित्र के युद्धक्षेत्र कोड का प्रतिनिधित्व करता है",
  T_48_META_API_5002_D: "डेटाबेस में एक निश्चित तालिका में एक निश्चित कुंजी से संबंधित मान हटाएं",
  T_48_META_API_5002_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5002_P1_D: "खिलाड़ियों को चिह्नित करें और समवर्ती स्थितियों को संभालें",
  T_48_META_API_5002_P2_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5002_P3_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5003_D: "डेटाबेस में रैंकिंग तालिका में किसी कुंजी के अनुरूप मान पढ़ें",
  T_48_META_API_5003_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_5003_P1_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5003_P2_D: "पढ़ा गया परिणाम लौटाएँ",
  T_48_META_API_5003_P3_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5004_D: "डेटाबेस में रैंकिंग तालिका में कुंजी के अनुरूप मान लिखें",
  T_48_META_API_5004_P0_D: "डेटाबेस में रैंकिंग तालिका का नाम",
  T_48_META_API_5004_P1_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5004_P2_D: "मूल्य लिखा है",
  T_48_META_API_5004_P3_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5005_D: "डेटाबेस में रैंकिंग तालिका में कुंजी से संबंधित मान हटाएं",
  T_48_META_API_5005_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5005_P1_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5005_P2_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5006_D: "डेटाबेस में रैंकिंग तालिका में एक निश्चित रैंकिंग से संबंधित मान हटाएँ",
  T_48_META_API_5006_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5006_P1_D: "लीडरबोर्ड में स्थान",
  T_48_META_API_5006_P2_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5007_D: "डेटाबेस में रैंकिंग तालिका में एक निश्चित रैंकिंग से एक निश्चित रैंकिंग तक मान पढ़ें",
  T_48_META_API_5007_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5007_P1_D: "प्रारंभिक रैंक",
  T_48_META_API_5007_P2_D: "अंत रैंकिंग",
  T_48_META_API_5007_P3_D: "पढ़ा गया परिणाम लौटाएँ",
  T_48_META_API_5007_P4_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5008_D: "संचयी डेटाबेस में किसी तालिका में कुंजी से संबंधित मान पढ़ें",
  T_48_META_API_5008_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5008_P1_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5008_P2_D: "पढ़ा गया परिणाम लौटाएँ",
  T_48_META_API_5008_P3_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_5009_D: "संचयी डेटाबेस में किसी तालिका में कुंजी के अनुरूप ऑफसेट मान लिखें",
  T_48_META_API_5009_P0_D: "डेटाबेस में तालिका का नाम",
  T_48_META_API_5009_P1_D: "डेटा की पहचान करने के लिए उपयोग किया जाने वाला एक कस्टम नाम",
  T_48_META_API_5009_P2_D: "चार प्रकार के अंकगणितीय ऑपरेशन वर्तमान में निम्नलिखित प्रकारों का समर्थन करते हैं: इंट प्रकार जोड़, घटाव, गुणा, विभाजन और शेष का समर्थन करता है;",
  T_48_META_API_5009_P3_D: "ऑफसेट मान लिखा गया",
  T_48_META_API_5009_P4_D: "डेटाबेस के अनुरूप युद्धभूमि कोड",
  T_48_META_API_51_D: "खेलने योग्य इकाई को रीसेट करें और प्लेबैक स्थिति को बदले बिना बजाने योग्य इकाई को उसके प्रारंभिक स्वरूप में पुनर्स्थापित करें।",
  T_48_META_API_51_P0_D: "खेलने योग्य इकाई को लक्षित करें",
  T_48_META_API_52_D: "दो चतुर्भुजों को गुणा करें। A*B का अर्थ है पहले A को घुमाना और फिर B को घुमाना। विभिन्न घूर्णन क्रमों से अलग-अलग परिणाम प्राप्त होंगे।",
  T_48_META_API_52_P0_D: "लैवल्यू क्वाटरनियन",
  T_48_META_API_52_P1_D: "आरवैल्यू क्वाटर्नियन",
  T_48_META_API_52_R_D: "गणना परिणाम क्वाटर्नियन",
  T_48_META_API_53_D: "निर्दिष्ट दिशा की ओर मुख करके एक घूमने वाला चतुर्भुज बनाता है",
  T_48_META_API_53_P0_D: "दिशा निर्दिष्ट करें",
  T_48_META_API_53_P1_D: "ऊपर की दिशा",
  T_48_META_API_53_R_D: "निर्दिष्ट दिशा में संरेखित करने के लिए आवश्यक घूर्णन की मात्रा",
  T_48_META_API_54_D: "ए से बी तक चतुर्धातुक गोलाकार प्रक्षेप",
  T_48_META_API_54_P0_D: "एक मूल्य",
  T_48_META_API_54_P1_D: "बी मान",
  T_48_META_API_54_P2_D: "इंटरपोलेशन प्रगति, मान सीमा [0,1], जब मान 0 होता है, तो प्रारंभिक मान लौटाया जाता है, जब मान 1 होता है, तो लक्ष्य मान लौटाया जाता है",
  T_48_META_API_54_R_D: "परिणाम चतुर्भुज",
  T_48_META_API_57_D: "लक्ष्य डेटा को चेतावनी के रूप में कंसोल पर प्रिंट करें",
  T_48_META_API_57_P0_D: "क्या छापने की जरूरत है",
  T_48_META_API_58_D: "लक्ष्य डेटा को त्रुटि रूप में कंसोल पर प्रिंट करें",
  T_48_META_API_58_P0_D: "क्या छापने की जरूरत है",
  T_48_META_API_59_D: "वक्र पर मान प्राप्त करें",
  T_48_META_API_59_P0_D: "वक्र",
  T_48_META_API_59_P1_D: "नमूनाकरण बिंदु, मान सीमा [0,1]",
  T_48_META_API_59_R_D: "परिणाम",
  T_48_META_API_6_D: "निर्दिष्ट निर्देशांक के अनुसार दृश्य ऑब्जेक्ट बनाएं",
  T_48_META_API_6_P0_D: "दृश्य वस्तु इकाई बनाई गई",
  T_48_META_API_6_P1_D: "वह स्थान जहाँ वस्तु उत्पन्न होती है",
  T_48_META_API_6_P2_D: "कोड स्क्रिप्ट में निर्मित ऑब्जेक्ट प्रकार आईडी का उपयोग करते समय, आपको संपत्ति पंजीकरण में स्तर ऑब्जेक्ट गणना को पहले से पंजीकृत करना होगा।",
  T_48_META_API_60_D: "वक्रों से प्रक्षेप करें",
  T_48_META_API_60_P0_D: "मान प्रकार",
  T_48_META_API_60_P1_D: "आरंभिक मूल्य",
  T_48_META_API_60_P2_D: "लक्ष्य मान",
  T_48_META_API_60_P3_D: "वक्र",
  T_48_META_API_60_P4_D: "नमूनाकरण बिंदु, मान सीमा [0,1]",
  T_48_META_API_60_R_D: "परिणाम",
  T_48_META_API_6000_D: "लक्ष्य इकाई के लिए स्क्रिप्ट जोड़ें",
  T_48_META_API_6000_P0_D: "लक्ष्य इकाई",
  T_48_META_API_6000_P1_D: "स्क्रिप्ट आईडी",
  T_48_META_API_6001_D: "लक्ष्य इकाई के लिए स्क्रिप्ट अनइंस्टॉल करें",
  T_48_META_API_6001_P0_D: "लक्ष्य इकाई",
  T_48_META_API_6001_P1_D: "स्क्रिप्ट आईडी",
  T_48_META_API_6002_D: "जांचें कि निर्दिष्ट स्क्रिप्ट लक्ष्य इकाई में मौजूद है या नहीं",
  T_48_META_API_6002_P0_D: "लक्ष्य इकाई",
  T_48_META_API_6002_P1_D: "स्क्रिप्ट आईडी",
  T_48_META_API_6002_R_D: "क्या निर्दिष्ट स्क्रिप्ट मौजूद है",
  T_48_META_API_61_D: "यूआई नियंत्रण का मूल नोड सेट करें",
  T_48_META_API_61_P0_D: "पैरेंट नोड, आप यूआई नियंत्रण या कस्टम यूआई निर्दिष्ट कर सकते हैं",
  T_48_META_API_61_P1_D: "चाइल्ड नोड",
  T_48_META_API_62_D: "पदावनत",
  T_48_META_API_62_P0_D: "पदावनत",
  T_48_META_API_62_P1_D: "पदावनत",
  T_48_META_API_62_P2_D: "पदावनत",
  T_48_META_API_62_P3_D: "पदावनत",
  T_48_META_API_62_P4_D: "पदावनत",
  T_48_META_API_63_D: "वर्तमान कैमरे से स्क्रीन स्पर्श बिंदु तक एक किरण बनाता है",
  T_48_META_API_63_P0_D: "स्क्रीन स्पर्श बिंदु",
  T_48_META_API_63_P1_D: "प्रस्थान बिंदू",
  T_48_META_API_63_P2_D: "किरण दिशा",
  T_48_META_API_64_D: "कस्टम बिलिंग जानकारी अपलोड करें",
  T_48_META_API_64_P0_D: "खिलाड़ी इकाई",
  T_48_META_API_64_P1_D: "मैच का परिणाम",
  T_48_META_API_64_P2_D: "अंक शीर्षक",
  T_48_META_API_64_P3_D: "अंक मूल्य",
  T_48_META_API_65_D: "निर्दिष्ट ध्वनि प्रभाव चलाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो आप इसके इकाई गुण सेट कर सकते हैं।",
  T_48_META_API_65_P0_D: "ध्वनि प्रभाव इकाई बनाई गई",
  T_48_META_API_65_P1_D: "लक्ष्य वादक, केवल लक्ष्य वादक ही ध्वनि प्रभाव सुन सकता है",
  T_48_META_API_65_P2_D: "ध्वनि प्रभाव प्रकार",
  T_48_META_API_65_P3_D: "लूप प्रकार",
  T_48_META_API_65_P4_D: "तुरंत खेलना है या नहीं",
  T_48_META_API_66_D: "एक निर्दिष्ट दृश्य प्रभाव बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो आप इसके इकाई गुण सेट कर सकते हैं।",
  T_48_META_API_66_P0_D: "विशेष प्रभाव इकाई बनाई गई",
  T_48_META_API_66_P1_D: "लक्ष्य खिलाड़ी, केवल लक्ष्य खिलाड़ी ही दिखाई देता है",
  T_48_META_API_66_P2_D: "विशेष प्रभाव प्रकार",
  T_48_META_API_66_P3_D: "लूप प्रकार",
  T_48_META_API_66_P4_D: "तुरंत खेलना है या नहीं",
  T_48_META_API_67_D: "निर्दिष्ट ध्वनि प्रभाव बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो आप इसके इकाई गुण सेट कर सकते हैं।",
  T_48_META_API_67_P0_D: "ध्वनि प्रभाव इकाई बनाई गई",
  T_48_META_API_67_P1_D: "ध्वनि प्रभाव प्रकार",
  T_48_META_API_67_P2_D: "लूप प्रकार",
  T_48_META_API_67_P3_D: "तुरंत खेलना है या नहीं",
  T_48_META_API_68_D: "विश्व निर्देशांक को स्क्रीन निर्देशांक में बदलें",
  T_48_META_API_68_P0_D: "विश्व निर्देशांक",
  T_48_META_API_68_P1_D: "स्क्रीन पर मैप करना है या नहीं",
  T_48_META_API_68_P2_D: "मानचित्र स्थान",
  T_48_META_API_69_D: "स्क्रीन निर्देशांक को विश्व निर्देशांक में बदलें",
  T_48_META_API_69_P0_D: "स्क्रीन निर्देशांक",
  T_48_META_API_69_P1_D: "स्क्रीन से दूरी",
  T_48_META_API_69_P2_D: "विश्व निर्देशांक",
  T_48_META_API_7_D: "लक्ष्य मान को स्ट्रिंग में बदलें",
  T_48_META_API_7_P0_D: "लक्ष्य मान को एक स्ट्रिंग में परिवर्तित किया जाना है",
  T_48_META_API_7_R_D: "डोरी",
  T_48_META_API_70_D: "स्क्रीन टच के माध्यम से किरण का पता लगाएं और पहली हिट इकाई लौटाएं",
  T_48_META_API_70_P0_D: "होम स्क्रीन टच",
  T_48_META_API_70_P1_D: "पता लगाने की दूरी",
  T_48_META_API_70_P2_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_70_P3_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_70_P4_D: "हिट इकाई",
  T_48_META_API_70_P5_D: "हिट बिंदु निर्देशांक",
  T_48_META_API_70_P6_D: "हिट बिंदु से प्रारंभ बिंदु तक की दूरी",
  T_48_META_API_70_P7_D: "सतह पर सामान्य प्रहार करें",
  T_48_META_API_71_D: "स्क्रीन टच के माध्यम से रे का पता लगाना, सभी हिट इकाइयों को लौटाना",
  T_48_META_API_71_P0_D: "होम स्क्रीन टच",
  T_48_META_API_71_P1_D: "पता लगाने की दूरी",
  T_48_META_API_71_P2_D: "लेयर मास्क, केवल भरी हुई परतें ही स्कैन में भाग लेंगी, खाली छोड़ने का मतलब है कि सभी परतें स्कैन में भाग लेंगी",
  T_48_META_API_71_P3_D: "क्या ट्रिगर्स का पता लगाना संभव है",
  T_48_META_API_71_P4_D: "हिट संस्थाओं की सूची",
  T_48_META_API_71_P5_D: "हिट बिंदु समन्वय सूची",
  T_48_META_API_71_P6_D: "हिट बिंदु और प्रारंभ बिंदु के बीच की दूरी की सूची",
  T_48_META_API_71_P7_D: "हिट सतह सामान्य सूची",
  T_48_META_API_72_D: "एक निर्दिष्ट दृश्य प्रभाव बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो आप इसके इकाई गुण सेट कर सकते हैं।",
  T_48_META_API_72_P0_D: "विशेष प्रभाव इकाई बनाई गई",
  T_48_META_API_72_P1_D: "विशेष प्रभाव प्रकार",
  T_48_META_API_72_P2_D: "लूप प्रकार",
  T_48_META_API_72_P3_D: "तुरंत खेलना है या नहीं",
  T_48_META_API_73_D: "एक अंतर्निहित यूआई बनाएं जो अन्य क्लाइंट के साथ सिंक्रनाइज़ न हो",
  T_48_META_API_73_P0_D: "अंतर्निहित यूआई इकाइयां बनाई गईं",
  T_48_META_API_73_P1_D: "अंतर्निहित यूआई प्रकार",
  T_48_META_API_74_D: "एक कस्टम यूआई बनाएं जो अन्य क्लाइंट के साथ सिंक नहीं किया जाएगा",
  T_48_META_API_74_P0_D: "कस्टम यूआई इकाइयां बनाई गईं",
  T_48_META_API_74_P1_D: "कस्टम यूआई इंडेक्स",
  T_48_META_API_75_D: "वर्तमान क्लाइंट के अनुरूप प्लेयर प्राप्त करें",
  T_48_META_API_75_R_D: "खिलाड़ी इकाई",
  T_48_META_API_76_D: "एआई राक्षस बनाएं",
  T_48_META_API_76_P0_D: "लक्ष्य एआई",
  T_48_META_API_76_P1_D: "स्थान बनाएँ",
  T_48_META_API_76_P2_D: "एआई प्रकार",
  T_48_META_API_76_P3_D: "टीम",
  T_48_META_API_76_P4_D: "क्या स्वचालित रूप से शत्रुओं की खोज करनी है",
  T_48_META_API_76_P5_D: "आक्रमण मोड",
  T_48_META_API_76_P6_D: "यात्रा पथ",
  T_48_META_API_77_D: "वेक्टर का पहला घटक सेट करें",
  T_48_META_API_77_P0_D: "वेक्टर",
  T_48_META_API_77_P1_D: "प्रथम घटक मान",
  T_48_META_API_77_R_D: "पहले घटक को संशोधित करने के बाद वेक्टर",
  T_48_META_API_78_D: "वेक्टर का दूसरा घटक सेट करता है",
  T_48_META_API_78_P0_D: "वेक्टर",
  T_48_META_API_78_P1_D: "दूसरा घटक मान",
  T_48_META_API_78_R_D: "दूसरे घटक को संशोधित करने के बाद वेक्टर",
  T_48_META_API_79_D: "वेक्टर का तीसरा घटक सेट करता है",
  T_48_META_API_79_P0_D: "वेक्टर",
  T_48_META_API_79_P1_D: "तीसरा घटक मान",
  T_48_META_API_79_R_D: "तीसरे घटक को संशोधित करने के बाद वेक्टर",
  T_48_META_API_8_D: "सुरक्षित क्षेत्र को चालू करें जो केंद्र समन्वय बिंदु तक सिकुड़ जाएगा",
  T_48_META_API_8_P0_D: "सुरक्षित क्षेत्र का केंद्र बिंदु",
  T_48_META_API_8_P1_D: "सुरक्षित क्षेत्र की त्रिज्या",
  T_48_META_API_8_P2_D: "प्रतीक्षा समय, सेकंडों में, जिसके बाद सुरक्षित क्षेत्र केंद्र बिंदु की ओर सिकुड़ना शुरू हो जाएगा",
  T_48_META_API_8_P3_D: "सुरक्षित क्षेत्र को केंद्र बिंदु तक सिकुड़ने में लगने वाला समय, सेकंड में",
  T_48_META_API_8_P4_D: "सुरक्षित क्षेत्र के बाहर प्रति सेकंड हुई क्षति की मात्रा",
  T_48_META_API_80_D: "द्वि-आयामी वेक्टर का पहला घटक सेट करता है",
  T_48_META_API_80_P0_D: "2डी वेक्टर",
  T_48_META_API_80_P1_D: "प्रथम घटक मान",
  T_48_META_API_80_R_D: "पहले घटक को संशोधित करने के बाद द्वि-आयामी वेक्टर",
  T_48_META_API_81_D: "2डी वेक्टर का दूसरा घटक सेट करता है",
  T_48_META_API_81_P0_D: "2डी वेक्टर",
  T_48_META_API_81_P1_D: "दूसरा घटक मान",
  T_48_META_API_81_R_D: "दूसरे घटक को संशोधित करने के बाद द्वि-आयामी वेक्टर",
  T_48_META_API_82_D: "चरित्र नियंत्रक को निर्दिष्ट स्थान पर ले जाएँ यदि यह खिलाड़ी को प्रभावित करता है, तो खिलाड़ी को खिलाड़ी नियंत्रक को चालू करना होगा जो प्रभावी होने के लिए भौतिक प्रभावों का उपयोग करता है।",
  T_48_META_API_82_P0_D: "लक्ष्य चरित्र नियंत्रक",
  T_48_META_API_82_P1_D: "स्थान निर्दिष्ट करें",
  T_48_META_API_83_D: "लक्ष्य पैरेंट नोड इकाई के नाम के आधार पर निर्दिष्ट चाइल्ड नोड प्राप्त करें",
  T_48_META_API_83_P0_D: "मूल नोड इकाई",
  T_48_META_API_83_P1_D: "चाइल्ड नोड नाम",
  T_48_META_API_83_R_D: "चाइल्ड नोड इकाई",
  T_48_META_API_84_D: "एओआई पर विशेष ध्यान दें, दूरी की परवाह किए बिना हमेशा सिंक्रनाइज़",
  T_48_META_API_84_P0_D: "विशेष चिंता के लक्ष्य",
  T_48_META_API_84_P1_D: "पर्यवेक्षक",
  T_48_META_API_85_D: "AOI का विशेष ध्यान हटाएँ और दृष्टि से बाहर AOI सिंक्रनाइज़ेशन रद्द करें",
  T_48_META_API_85_P0_D: "विशेष चिंता के लक्ष्य",
  T_48_META_API_85_P1_D: "पर्यवेक्षक",
  T_48_META_API_86_D: "निर्दिष्ट लक्ष्य के सभी एओआई साफ़ करें",
  T_48_META_API_86_P0_D: "विशेष चिंता के लक्ष्य",
  T_48_META_API_87_D: "निर्धारित करें कि क्या एओआई विशेष चिंता का विषय है",
  T_48_META_API_87_P0_D: "विशेष चिंता के लक्ष्य",
  T_48_META_API_87_P1_D: "पदावनत",
  T_48_META_API_87_R_D: "क्या मौजूद है",
  T_48_META_API_88_D: "प्लेयर के प्रॉक्सी ऑब्जर्वर को टॉगल करें",
  T_48_META_API_88_P0_D: "खिलाड़ी",
  T_48_META_API_88_P1_D: "प्रॉक्सी पर्यवेक्षक",
  T_48_META_API_89_D: "चरित्र नियंत्रक को एक बार विस्थापित करें। यदि यह खिलाड़ी को प्रभावित करता है, तो खिलाड़ी को खिलाड़ी नियंत्रक को चालू करना होगा जो प्रभावी होने के लिए भौतिक प्रभावों का उपयोग करता है।",
  T_48_META_API_89_P0_D: "लक्ष्य वस्तु, यदि यह एक खिलाड़ी है, तो प्रभाव को प्रभावी करने के लिए खिलाड़ी को भौतिकी का उपयोग करके खिलाड़ी नियंत्रक को चालू करना होगा",
  T_48_META_API_89_P1_D: "विस्थापन वेक्टर",
  T_48_META_API_9_D: "सुरक्षित क्षेत्र तंत्र को बंद कर दें। जब सुरक्षित क्षेत्र न्यूनतम हो जाए, तो सुरक्षित क्षेत्र के बाहर के खिलाड़ियों को नुकसान होता रहेगा। सुरक्षित क्षेत्र तंत्र को बंद करने के बाद, खिलाड़ी फिर से सुरक्षित हो जाएंगे।",
  T_48_META_API_90_D: "सेट करें कि क्या खिलाड़ी स्वतंत्र रूप से बाहर निकल सकते हैं",
  T_48_META_API_90_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_90_P1_D: "क्या स्वतंत्र रूप से बाहर निकलना संभव है?",
  T_48_META_API_9000_D: "एक अंतर्निर्मित यूआई बनाएं जिसे केवल निर्दिष्ट खिलाड़ी ही देख सकें",
  T_48_META_API_9000_P0_D: "अंतर्निहित यूआई इकाइयां बनाई गईं",
  T_48_META_API_9000_P1_D: "यूआई जिस प्लेयर इकाई से संबंधित है, वह केवल इस प्लेयर को दिखाई देती है",
  T_48_META_API_9000_P2_D: "अंतर्निहित यूआई प्रकार",
  T_48_META_API_9001_D: "अंतर्निहित गेम यूआई हटाएं",
  T_48_META_API_9001_P0_D: "हटाने के लिए अंतर्निहित यूआई इकाई",
  T_48_META_API_9002_D: "निर्दिष्ट आइकन प्रकार का उपयोग करके एक आइकन बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसके इकाई गुण सेट करें (अप्रचलित, कृपया CreateLevelObject का उपयोग करें)",
  T_48_META_API_9002_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो आइकन इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो आइकन बनाता है।",
  T_48_META_API_9002_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_9002_P2_D: "संसाधन पथ, खिलाड़ी द्वारा चयनित आइकन के अनुरूप संसाधन पथ",
  T_48_META_API_9003_D: "निर्दिष्ट आइकन हटाएं (अप्रत्याशित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_9003_P0_D: "हटाने के लिए चिह्न इकाई",
  T_48_META_API_9004_D: "निर्दिष्ट टेक्स्ट सामग्री का उपयोग करके एक टेक्स्ट बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसके इकाई गुण सेट करें (अप्रचलित, कृपया CreateLevelObject का उपयोग करें)",
  T_48_META_API_9004_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो टेक्स्ट इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो टेक्स्ट बनाता है।",
  T_48_META_API_9004_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_9004_P2_D: "प्रस्तुत की जाने वाली पाठ्य सामग्री",
  T_48_META_API_9005_D: "निर्दिष्ट पाठ हटाएं (अप्रत्याशित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_9005_P0_D: "हटाने के लिए पाठ इकाई",
  T_48_META_API_9006_D: "निर्दिष्ट प्रभाव प्रकार का उपयोग करके एक आइकन बनाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसके इकाई गुण सेट करें (अप्रचलित, कृपया CreateEffect का उपयोग करें)",
  T_48_META_API_9006_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो विशेष प्रभाव इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो विशेष प्रभाव बनाता है।",
  T_48_META_API_9006_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_9006_P2_D: "विशेष प्रभाव प्रकार, विशेष प्रभाव का प्रकार जिसे खिलाड़ी चुन सकते हैं",
  T_48_META_API_9007_D: "निर्दिष्ट प्रभाव हटाएं (अप्रत्याशित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_9007_P0_D: "हटाने के लिए प्रभाव इकाई",
  T_48_META_API_9008_D: "एक कस्टम यूआई बनाएं जिसे केवल निर्दिष्ट खिलाड़ी ही देख सकें",
  T_48_META_API_9008_P0_D: "कस्टम यूआई इकाइयां बनाई गईं",
  T_48_META_API_9008_P1_D: "यूआई जिस प्लेयर इकाई से संबंधित है, वह केवल इस प्लेयर को दिखाई देती है",
  T_48_META_API_9008_P2_D: "कस्टम यूआई इंडेक्स",
  T_48_META_API_9009_D: "कस्टम गेम यूआई हटाएं",
  T_48_META_API_9009_P0_D: "हटाने के लिए कस्टम यूआई इकाई",
  T_48_META_API_9010_D: "कस्टम यूआई से यूआई नियंत्रण प्राप्त करें",
  T_48_META_API_9010_P0_D: "वह प्लेयर इकाई जिससे यूआई संबंधित है",
  T_48_META_API_9010_P1_D: "कस्टम यूआई इकाइयाँ",
  T_48_META_API_9010_P2_D: "अद्वितीय सूचकांक को नियंत्रित करें",
  T_48_META_API_9010_R_D: "यूआई नियंत्रण इकाई",
  T_48_META_API_9011_D: "निर्दिष्ट ध्वनि प्रभाव चलाएं। यदि अधिक गुण सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसके इकाई गुण सेट करें (अप्रचलित, कृपया CreateSound का उपयोग करें)",
  T_48_META_API_9011_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो ध्वनि प्रभाव इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो ध्वनि प्रभाव बनाता है।",
  T_48_META_API_9011_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_9011_P2_D: "ध्वनि प्रभाव प्रकार, ध्वनि प्रभाव का प्रकार जिसे खिलाड़ी चुन सकते हैं",
  T_48_META_API_9012_D: "निर्दिष्ट ध्वनि प्रभाव हटाएं (अप्रत्याशित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_9012_P0_D: "हटाने योग्य ध्वनि इकाई",
  T_48_META_API_9013_D: "कस्टम यूआई से पथ का उपयोग करके यूआई नियंत्रण प्राप्त करें",
  T_48_META_API_9013_P0_D: "वह प्लेयर इकाई जिससे यूआई संबंधित है",
  T_48_META_API_9013_P1_D: "कस्टम यूआई",
  T_48_META_API_9013_P2_D: "नियंत्रण पथ",
  T_48_META_API_9013_R_D: "यूआई नियंत्रण इकाई",
  T_48_META_API_9014_D: "बजने वाली ध्वनि इकाई को बाधित करें (बहिष्कृत, कृपया पॉज़साउंड का उपयोग करें)",
  T_48_META_API_9014_P0_D: "ध्वनि प्रभाव इकाई जिसे रोकने की आवश्यकता है",
  T_48_META_API_9015_D: "ध्वनि प्रभाव चलाना जारी रखें, आप चुन सकते हैं कि शुरुआत से बजाना शुरू करना है या नहीं (अप्रचलित, कृपया ResumeSound का उपयोग करें)",
  T_48_META_API_9015_P0_D: "ध्वनि प्रभाव इकाइयाँ जिन्हें रुकने के बाद भी बजाना जारी रखना होगा",
  T_48_META_API_9015_P1_D: "क्या शून्य से शुरू करना है",
  T_48_META_API_9016_D: "कस्टम यूआई नियंत्रण बनाएं",
  T_48_META_API_9016_P0_D: "कस्टम नियंत्रण इकाई बनाई गई",
  T_48_META_API_9016_P1_D: "बनाए गए नियंत्रण का प्रकार",
  T_48_META_API_9016_P2_D: "संबंधित यूआई इकाई",
  T_48_META_API_9016_P3_D: "यह जिस मूल नियंत्रण से संबंधित है, यदि इसे खाली छोड़ दिया जाए, तो यह जिस यूआई इकाई से संबंधित है, वह मूल नोड होगी।",
  T_48_META_API_9017_D: "लक्ष्य कैमरा लेयर मास्क सेट करें",
  T_48_META_API_9017_P0_D: "लक्ष्य कैमरा इकाई",
  T_48_META_API_9017_P1_D: "लेयर मास्क, लक्ष्य कैमरे में केवल भरी हुई परतें प्रदर्शित होंगी, खाली छोड़ने का मतलब है कि सभी परतें प्रदर्शित होंगी।",
  T_48_META_API_9018_D: "लक्ष्य कैमरा लेयर मास्क प्राप्त करें",
  T_48_META_API_9018_P0_D: "लक्ष्य कैमरा इकाई",
  T_48_META_API_9018_R_D: "लेयर मास्क, केवल लेयर मास्क के भीतर की परतें ही लक्ष्य कैमरे में प्रदर्शित होंगी",
  T_48_META_API_9019_D: "सेट करें कि निर्दिष्ट स्तर लक्ष्य कैमरे को दिखाई दे रहा है या नहीं",
  T_48_META_API_9019_P0_D: "लक्ष्य कैमरा इकाई",
  T_48_META_API_9019_P1_D: "दृश्यता स्तर",
  T_48_META_API_9019_P2_D: "दिखाई दे रहा है या नहीं",
  T_48_META_API_9020_D: "लक्ष्य प्लेयर की डिफ़ॉल्ट इंटरफ़ेस दृश्यता स्थिति सेट करें",
  T_48_META_API_9020_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9020_P1_D: "प्लेयर इंटरफ़ेस प्रकार। प्लेयर इंटरफ़ेस प्रकार एक यूआई तत्व है जिसका उपयोग खिलाड़ियों और खिलाड़ी-संबंधित सामग्री को नियंत्रित करने के लिए किया जाता है।",
  T_48_META_API_9020_P2_D: "स्विच मान प्लेयर इंटरफ़ेस की दृश्यता निर्धारित करता है।",
  T_48_META_API_9021_D: "एक टाइमस्टैम्प स्थानीयकृत स्ट्रिंग बनाएं",
  T_48_META_API_9021_P0_D: "समय-चिह्न",
  T_48_META_API_9021_P1_D: "स्वरूपण शैली",
  T_48_META_API_9021_R_D: "टाइमस्टैम्प स्थानीयकरण स्ट्रिंग",
  T_48_META_API_9022_D: "मिनिमैप आइकन बनाएं",
  T_48_META_API_9022_P0_D: "मिनिमैप आइकन इकाई बनाई गई",
  T_48_META_API_9022_P1_D: "प्लेयर का है. बनाया गया मिनिमैप आइकन केवल उस प्लेयर को दिखाई देता है.",
  T_48_META_API_9022_P2_D: "मिनिमैप आइकन संसाधन पथ",
  T_48_META_API_9023_D: "निर्दिष्ट विशेष प्रभाव प्रकार का उपयोग करके एक आइकन बनाएं यदि अधिक गुण सेट करने की आवश्यकता है, तो इकाई के माध्यम से इसके इकाई गुण सेट करें।",
  T_48_META_API_9023_P0_D: "कोड का उपयोग औपचारिक पैरामीटर के नाम का प्रतिनिधित्व करने के लिए किया जाता है जो विशेष प्रभाव इकाई बनाता है, और इसके संबंधित स्थानीय चर मान वह इकाई है जो विशेष प्रभाव बनाता है।",
  T_48_META_API_9023_P1_D: "यह जिस खिलाड़ी इकाई से संबंधित है, वह केवल इस खिलाड़ी को दिखाई देती है",
  T_48_META_API_9023_P2_D: "विशेष प्रभाव प्रकार, विशेष प्रभाव का प्रकार जिसे खिलाड़ी चुन सकते हैं",
  T_48_META_API_9024_D: "निर्दिष्ट प्रभाव हटाएं (अप्रत्याशित, कृपया DeleteEntity का उपयोग करें)",
  T_48_META_API_9024_P0_D: "हटाने के लिए प्रभाव इकाई",
  T_48_META_API_9025_D: "लक्ष्य वस्तु के लिए मानचित्र पर स्थिर पिक्सेल उत्पन्न करें। स्थिर पिक्सेल लक्ष्य वस्तु के साथ नहीं चलेंगे।",
  T_48_META_API_9025_P0_D: "स्थिर पिक्सेल इकाई बनाई गई",
  T_48_META_API_9025_P1_D: "यह प्लेयर का है, बनाया गया स्थिर पिक्सेल केवल प्लेयर को दिखाई देता है",
  T_48_META_API_9025_P2_D: "लक्ष्य वस्तु इकाई",
  T_48_META_API_9026_D: "लक्ष्य खिलाड़ी की मिनिमैप इकाई प्राप्त करें",
  T_48_META_API_9026_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9026_R_D: "वर्तमान प्लेयर मिनिमैप",
  T_48_META_API_9027_D: "खिलाड़ी के गिरने से होने वाली क्षति को ऊंचाई के अनुसार निर्धारित किया जा सकता है।",
  T_48_META_API_9027_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9027_P1_D: "अत्यधिक खंडित सूची",
  T_48_META_API_9027_P2_D: "क्षति खंड सूची",
  T_48_META_API_91_D: "निर्दिष्ट टीम में लक्ष्य जोड़ने से लक्ष्य मूल टीम को छोड़ देगा।",
  T_48_META_API_91_P0_D: "लक्ष्य जिन्हें टीम में जोड़ने की आवश्यकता है",
  T_48_META_API_91_P1_D: "शामिल होने वाली टीमें",
  T_48_META_API_91_P2_D: "क्या यह सफल है?",
  T_48_META_API_92_D: "लक्ष्य को नई टीम में जोड़ने से लक्ष्य मूल टीम को छोड़ देगा।",
  T_48_META_API_92_P0_D: "लक्ष्य जिन्हें टीम में जोड़ने की आवश्यकता है",
  T_48_META_API_92_P1_D: "नई टीम का नाम",
  T_48_META_API_92_P2_D: "क्या यह सफल है?",
  T_48_META_API_94_D: "स्थानीय चर का मान सूचकांक द्वारा निर्धारित करें; निर्धारित करने से पहले, चर को वर्तमान कॉल प्रक्रिया में परिभाषित किया जाना चाहिए",
  T_48_META_API_94_P0: "अनुक्रमणिका",
  T_48_META_API_94_P0_D: "इंडेक्स द्वारा चर प्राप्त करें",
  T_48_META_API_94_P1: "परिवर्तनीय मान",
  T_48_META_API_94_P1_D: "लक्ष्य चर मान",
  T_48_META_API_94_P2: "अंकगणित प्रकार",
  T_48_META_API_94_P2_D: "संचालन विधि; सभी प्रकार असाइनमेंट का समर्थन करते हैं, और संख्यात्मक प्रकार भी वृद्धि, कमी, गुणा, भाग और मापांक संचालन का समर्थन करते हैं",
  T_48_META_API_94_P3: "चर का नाम",
  T_48_META_API_94_P3_D: "लक्ष्य चर नाम। केवल त्रुटि आउटपुट के लिए उपयोग किया जाता है",
  T_48_META_API_95: "इंडेक्स द्वारा स्थानीय चर प्राप्त करें",
  T_48_META_API_95_D: "स्थानीय चर का मान प्राप्त करें; प्राप्त करने से पहले, चर को वर्तमान कॉल प्रक्रिया में परिभाषित किया जाना चाहिए",
  T_48_META_API_95_P0: "अनुक्रमणिका",
  T_48_META_API_95_P0_D: "परिवर्तनीय सूचकांक",
  T_48_META_API_95_P1: "चर का नाम",
  T_48_META_API_95_P1_D: "लक्ष्य चर नाम। केवल त्रुटि आउटपुट के लिए उपयोग किया जाता है",
  T_48_META_API_9500_D: "विशेष प्रभाव चलाने के लिए लक्षित खिलाड़ी के ग्राहक को सूचित करें",
  T_48_META_API_9500_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9500_P1_D: "विशेष प्रभाव संसाधन पथ",
  T_48_META_API_9500_P2_D: "रंग",
  T_48_META_API_9500_P3_D: "ज़ूम आकार, डिफ़ॉल्ट 1 है",
  T_48_META_API_9500_P4_D: "बाइंडिंग ऑब्जेक्ट, विशेष प्रभाव इसके चाइल्ड नोड्स के रूप में जुड़े होंगे",
  T_48_META_API_9500_P5_D: "बाध्य वस्तु के सापेक्ष विश्व समन्वय ऑफसेट",
  T_48_META_API_9501_D: "लक्ष्य प्लेयर के क्लाइंट को ध्वनि प्रभाव चलाने के लिए सूचित करता है",
  T_48_META_API_9501_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9501_P1_D: "ध्वनि प्रभाव प्रकार",
  T_48_META_API_9502_D: "फ़्लोटिंग शब्द प्रदर्शित करने के लिए लक्ष्य खिलाड़ी के क्लाइंट को सूचित करें",
  T_48_META_API_9502_P0_D: "लक्षित खिलाड़ी",
  T_48_META_API_9502_P1_D: "पियाओजी सामग्री",
  T_48_META_API_9502_P2_D: "तैरते शब्द का रंग, प्रकार है रंग",
  T_48_META_API_9502_P3_D: "फ़्लोटिंग वर्णों की अवधि मिलीसेकेंड में",
  T_48_META_API_9503_D: "लक्ष्य इकाई को एक बार इमोट क्रिया अभिव्यक्ति चलाने के लिए प्रेरित करता है",
  T_48_META_API_9503_P0_D: "इमोटे खेलने का लक्ष्य",
  T_48_META_API_9503_P1_D: "भावना प्रकार",
  T_48_META_API_9504_D: "किसी इकाई की इमोट एक्शन अभिव्यक्ति को रोकें/फिर से शुरू करें",
  T_48_META_API_9504_P0_D: "इमोट लक्ष्यों को रोकें/फिर से शुरू करें",
  T_48_META_API_9504_P1_D: "सत्य: प्लेबैक रोकें, गलत: प्लेबैक फिर से शुरू करें",
  T_48_META_EVT_1_D: "गेम शुरू होने पर ट्रिगर होने पर, सर्वर क्लाइंट से कुछ समय पहले तैयार हो जाएगा",
  T_48_META_EVT_10_D: "मौजूदा इकाई को नुकसान होने से पहले ट्रिगर करता है",
  T_48_META_EVT_10_P0_D: "हमलावर इकाई, खाली हो सकती है",
  T_48_META_EVT_10_P1_D: "क्षति का प्रकार",
  T_48_META_EVT_10_P2_D: "क्षति की मात्रा",
  T_48_META_EVT_10_P3_D: "घायल भाग",
  T_48_META_EVT_1000_D: "जब खिलाड़ी के अंक बदलते हैं तो ट्रिगर हो जाता है",
  T_48_META_EVT_1000_P0_D: "जिन खिलाड़ियों के अंक बदल गए हैं",
  T_48_META_EVT_1000_P1_D: "परिवर्तन बिंदुओं का प्रकार",
  T_48_META_EVT_1000_P2_D: "अभिन्न परिवर्तन के बाद अभिन्न मूल्य",
  T_48_META_EVT_1001_D: "जब टीम के अंक बदलते हैं तो ट्रिगर होता है",
  T_48_META_EVT_1001_P0_D: "अंक वाली टीमें बदल जाती हैं",
  T_48_META_EVT_1001_P1_D: "परिवर्तन बिंदुओं का प्रकार",
  T_48_META_EVT_1001_P2_D: "अभिन्न परिवर्तन के बाद अभिन्न मूल्य",
  T_48_META_EVT_1002_D: "खिलाड़ी की रैंकिंग बदलने पर ट्रिगर होता है",
  T_48_META_EVT_1002_P0_D: "जिन खिलाड़ियों की रैंकिंग बदलती है",
  T_48_META_EVT_1002_P1_D: "रैंकिंग में बदलाव के बाद रैंकिंग",
  T_48_META_EVT_1003_D: "पदावनत",
  T_48_META_EVT_1003_P0_D: "पदावनत",
  T_48_META_EVT_1003_P1_D: "रैंकिंग में बदलाव के बाद रैंकिंग",
  T_48_META_EVT_11_D: "जब कोई खिलाड़ी बीच में ही छोड़ देता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_11_P0_D: "वह खिलाड़ी जिसने बीच में ही छोड़ दिया",
  T_48_META_EVT_12_D: "जब प्लेयर नियंत्रक किसी इकाई को छूता है तो ट्रिगर होता है। यह केवल तभी ट्रिगर होगा जब नियंत्रक सक्रिय रूप से चलता है।",
  T_48_META_EVT_12_P0_D: "संस्थाओं का सामना हुआ",
  T_48_META_EVT_13_D: "मौजूदा इकाई को नुकसान पहुंचाने से पहले ट्रिगर",
  T_48_META_EVT_13_P0_D: "इकाई को नुकसान हो रहा है",
  T_48_META_EVT_13_P1_D: "क्षति का प्रकार",
  T_48_META_EVT_13_P2_D: "क्षति की मात्रा",
  T_48_META_EVT_13_P3_D: "घायल भाग",
  T_48_META_EVT_14_D: "हर बार बजाने योग्य इकाई के लूप होने पर ट्रिगर होता है जब बजाने योग्य इकाई ध्वनि प्रभाव, विशेष प्रभाव आदि होती है, तो यह घटना केवल क्लाइंट पर प्रभाव डालती है।",
  T_48_META_EVT_2_D: "लॉजिकल फ्रेम अपडेट होने पर ट्रिगर होता है। इस इवेंट की ट्रिगरिंग की आवृत्ति प्लेटफ़ॉर्म और सेटिंग्स के आधार पर अलग-अलग होगी।",
  T_48_META_EVT_2002_D: "जब खिलाड़ी मर जाता है तो ट्रिगर होता है",
  T_48_META_EVT_2002_P0_D: "मृत खिलाड़ी",
  T_48_META_EVT_2003_D: "जब कोई खिलाड़ी सहायता करता है तो ट्रिगर होता है",
  T_48_META_EVT_2003_P0_D: "जिन खिलाड़ियों को सहायता प्राप्त हुई",
  T_48_META_EVT_2003_P1_D: "मारा गया खिलाड़ी",
  T_48_META_EVT_2004_D: "जब खिलाड़ी क्षति पहुंचाता है तो ट्रिगर होता है",
  T_48_META_EVT_2004_P0_D: "वह खिलाड़ी जिसने क्षति पहुंचाई",
  T_48_META_EVT_2004_P1_D: "जिन खिलाड़ियों को नुकसान हुआ",
  T_48_META_EVT_2004_P2_D: "क्षति का प्रकार",
  T_48_META_EVT_2004_P3_D: "हानि",
  T_48_META_EVT_2004_P4_D: "घायल भाग",
  T_48_META_EVT_2005_D: "यह तब ट्रिगर होता है जब कोई खिलाड़ी हत्या का कारण बनता है",
  T_48_META_EVT_2005_P0_D: "वह खिलाड़ी जिसने हत्या का कारण बना",
  T_48_META_EVT_2005_P1_D: "मारा गया खिलाड़ी",
  T_48_META_EVT_2005_P2_D: "क्षति का प्रकार",
  T_48_META_EVT_2006_D: "जब कोई खिलाड़ी खेल में शामिल होता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_2006_P0_D: "जो खिलाड़ी खेल में शामिल होते हैं",
  T_48_META_EVT_2007_D: "खिलाड़ी के पुनर्जीवित होने पर ट्रिगर होता है",
  T_48_META_EVT_2007_P0_D: "पुनर्जीवित खिलाड़ी",
  T_48_META_EVT_2007_P1_D: "पुनरुत्थान स्रोत",
  T_48_META_EVT_2008_D: "जब खिलाड़ी को नीचे गिराया जाता है तो ट्रिगर होता है",
  T_48_META_EVT_2008_P0_D: "गिरा हुआ खिलाड़ी",
  T_48_META_EVT_2008_P1_D: "हमलावर खिलाड़ी",
  T_48_META_EVT_2009_D: "जब प्लेयर डिस्कनेक्ट हो जाता है तो सक्रिय हो जाता है",
  T_48_META_EVT_2009_P0_D: "डिस्कनेक्ट किया गया खिलाड़ी",
  T_48_META_EVT_2010_D: "जब प्लेयर पुनः कनेक्ट होता है तो सक्रिय हो जाता है",
  T_48_META_EVT_2010_P0_D: "खिलाड़ी पुनः जुड़ रहे हैं",
  T_48_META_EVT_2100_D: "जब टीम हटा दी जाती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_2100_P0_D: "हटाई गई टीम",
  T_48_META_EVT_2101_D: "टीम जोड़ते समय ट्रिगर हुआ",
  T_48_META_EVT_2101_P0_D: "टीमें जोड़ी गईं",
  T_48_META_EVT_2102_D: "जब टीम नष्ट हो जाती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_2102_P0_D: "जिस टीम का सफाया हो गया",
  T_48_META_EVT_3_D: "गेम समाप्त होने पर सक्रिय हो जाता है। यह ईवेंट सर्वर पर गेम समाप्त होने से पहले सक्रिय हो जाता है।",
  T_48_META_EVT_30_D: "जब दृश्य सफलतापूर्वक लोड हो जाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_30_P0_D: "दृश्य का नाम",
  T_48_META_EVT_3000_D: "वर्तमान इकाई बनने के बाद सक्रिय हो जाती है",
  T_48_META_EVT_3001_D: "वर्तमान इकाई के नष्ट होने से पहले ट्रिगर किया गया",
  T_48_META_EVT_3002_D: "जब खिलाड़ी ट्रिगर में प्रवेश करता है तो फायर हो जाता है",
  T_48_META_EVT_3002_P0_D: "खिलाड़ी ट्रिगर में प्रवेश कर रहा है",
  T_48_META_EVT_3003_D: "जब खिलाड़ी ट्रिगर छोड़ता है तो फायर हो जाता है",
  T_48_META_EVT_3003_P0_D: "खिलाड़ी ट्रिगर छोड़ रहा है",
  T_48_META_EVT_3004_D: "यूआई बटन नियंत्रण पर क्लिक करने के बाद सक्रिय हो गया",
  T_48_META_EVT_3004_P0_D: "खिलाड़ी जिसने क्लिक किया",
  T_48_META_EVT_3005_D: "अंतर्निहित यूआई में एक बटन क्लिक करने पर सक्रिय हो जाता है",
  T_48_META_EVT_3005_P0_D: "क्लिक किए गए बटन नियंत्रण का नाम",
  T_48_META_EVT_3006_D: "जब खिलाड़ी वेकबोर्ड का उपयोग कर रहा हो तो ट्रिगर हो जाता है",
  T_48_META_EVT_3007_D: "वर्तमान इकाई उपलब्ध होने के बाद सक्रिय हो जाती है",
  T_48_META_EVT_3008_D: "वर्तमान इकाई अनुपलब्ध होने के बाद आग लग जाती है",
  T_48_META_EVT_3009_D: "जब कोई इकाई ट्रिगर में प्रवेश करती है तो ट्रिगर होता है। जब कोई ट्रिगर इवेंट ट्रिगर होता है, तो दोनों पक्षों को इवेंट प्राप्त होता है। एक पक्ष को एक कठोर निकाय होना चाहिए और दूसरा पक्ष एक ट्रिगर होना चाहिए। विशेष रूप से, जब ट्रिगर एक कस्टम ट्रिगर ऑब्जेक्ट होता है, तो केवल ट्रिगर ही इवेंट प्राप्त करेगा।",
  T_48_META_EVT_3009_P0_D: "ट्रिगर घटना घटित होने पर प्रतिपक्ष इकाई",
  T_48_META_EVT_3010_D: "जब इकाई ट्रिगर छोड़ती है तो ट्रिगर होता है। जब इवेंट ट्रिगर होता है, तो दोनों पक्षों को इवेंट प्राप्त होता है। एक पक्ष को एक कठोर निकाय होना चाहिए और दूसरे पक्ष को एक ट्रिगर होना चाहिए। विशेष रूप से, जब ट्रिगर एक कस्टम ट्रिगर ऑब्जेक्ट होता है, तो केवल ट्रिगर ही इवेंट प्राप्त करेगा।",
  T_48_META_EVT_3010_P0_D: "ट्रिगर घटना घटित होने पर प्रतिपक्ष इकाई",
  T_48_META_EVT_3011_D: "वर्तमान इकाई के नष्ट हो जाने के बाद ट्रिगर होता है",
  T_48_META_EVT_3011_P0_D: "हमलावर इकाई, खाली हो सकती है",
  T_48_META_EVT_3011_P1_D: "क्षति का प्रकार",
  T_48_META_EVT_3011_P2_D: "घायल भाग",
  T_48_META_EVT_3012_D: "वर्तमान इकाई पर हमला होने के बाद ट्रिगर हुआ",
  T_48_META_EVT_3012_P0_D: "हमलावर इकाई, खाली हो सकती है",
  T_48_META_EVT_3012_P1_D: "क्षति का प्रकार",
  T_48_META_EVT_3012_P2_D: "क्षति की मात्रा",
  T_48_META_EVT_3012_P3_D: "घायल भाग",
  T_48_META_EVT_3013_D: "वर्तमान इकाई द्वारा क्षति पहुँचाने के बाद ट्रिगर",
  T_48_META_EVT_3013_P0_D: "इकाई को नुकसान हो रहा है",
  T_48_META_EVT_3013_P1_D: "क्षति का प्रकार",
  T_48_META_EVT_3013_P2_D: "क्षति की मात्रा",
  T_48_META_EVT_3013_P3_D: "घायल भाग",
  T_48_META_EVT_3014_D: "वर्तमान इकाई द्वारा अन्य संस्थाओं को नष्ट करने के बाद ट्रिगर किया गया",
  T_48_META_EVT_3014_P0_D: "नष्ट इकाई",
  T_48_META_EVT_3014_P1_D: "घायल भाग",
  T_48_META_EVT_3015_D: "खिलाड़ी के पुनर्जीवित होने पर ट्रिगर होता है",
  T_48_META_EVT_3015_P0_D: "खिलाड़ी पुनरुत्थान स्रोत प्रकार",
  T_48_META_EVT_3016_D: "जब जनरेटर एक इकाई उत्पन्न करता है तो सक्रिय हो जाता है",
  T_48_META_EVT_3016_P0_D: "उत्पन्न इकाई सूची",
  T_48_META_EVT_3016_P1_D: "तरंग संख्या",
  T_48_META_EVT_3017_D: "तब कॉल किया जाता है जब खिलाड़ी नॉकडाउन घुटना टेककर स्थिति में प्रवेश करता है",
  T_48_META_EVT_3018_D: "यह तब शुरू होता है जब टीम के सभी सदस्य मर जाते हैं",
  T_48_META_EVT_3019_D: "हेलमेट, बॉडी कवच या बैकपैक से सुसज्जित होने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3019_P0_D: "उपकरण आईडी",
  T_48_META_EVT_3020_D: "प्राथमिक, द्वितीयक या हाथापाई हथियार पकड़ने पर ट्रिगर होता है, जिसमें मुट्ठी पर स्विच करना भी शामिल है",
  T_48_META_EVT_3020_P0_D: "ट्रिगर होने पर हथियार इकाई सुसज्जित हो जाती है",
  T_48_META_EVT_3021_D: "प्रोप का उपयोग करने के बाद ट्रिगर किया गया प्रॉप्स जिसके लिए समय की आवश्यकता होती है, उपयोग पूरा होने के बाद इस घटना को ट्रिगर करेगा।",
  T_48_META_EVT_3021_P0_D: "प्रोप आईडी",
  T_48_META_EVT_3021_P1_D: "प्रोप इकाई, खाली हो सकती है",
  T_48_META_EVT_3021_P2_D: "प्रॉप्स का उपयोग करके बनाई गई नई प्रॉप इकाई खाली हो सकती है",
  T_48_META_EVT_3022_D: "कोई वस्तु प्राप्त होने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3022_P0_D: "वस्तु का प्रकार",
  T_48_META_EVT_3022_P1_D: "आइटम इकाई, खाली हो सकती है",
  T_48_META_EVT_3023_D: "जब इकाई स्कोर बदलता है तो ट्रिगर होता है",
  T_48_META_EVT_3023_P0_D: "परिवर्तन बिंदुओं का प्रकार",
  T_48_META_EVT_3023_P1_D: "अभिन्न परिवर्तन के बाद अभिन्न मूल्य",
  T_48_META_EVT_3024_D: "किसी इकाई की रैंक बदलने पर ट्रिगर होता है",
  T_48_META_EVT_3024_P0_D: "रैंकिंग में बदलाव के बाद रैंकिंग",
  T_48_META_EVT_3025_D: "सहायता पर ट्रिगर किया गया",
  T_48_META_EVT_3025_P0_D: "वह वस्तु जो मारी गई थी",
  T_48_META_EVT_3026_D: "यह तब ट्रिगर होता है जब कोई इकाई ड्राइवर और यात्री सहित वाहन में प्रवेश करती है",
  T_48_META_EVT_3026_P0_D: "वाहन में प्रवेश करने वाली इकाई",
  T_48_META_EVT_3026_P1_D: "वाहन में प्रवेश",
  T_48_META_EVT_3027_D: "जब इकाई वाहन छोड़ती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3027_P0_D: "इकाई वाहन छोड़ रही है",
  T_48_META_EVT_3027_P1_D: "प्रस्थान करने वाला वाहन",
  T_48_META_EVT_3028_D: "ट्रिगर तब होता है जब इकाई वाहन चला रही हो और वाहन में ड्राइवर हो।",
  T_48_META_EVT_3028_P0_D: "वह इकाई जो वाहन चलाती है",
  T_48_META_EVT_3028_P1_D: "वाहन चलाना",
  T_48_META_EVT_3029_D: "जब वाहन किसी इकाई द्वारा प्रवेश किया जाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3029_P0_D: "ट्रिगर इकाई",
  T_48_META_EVT_3030_D: "वाहन इकाई के चले जाने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3030_P0_D: "ट्रिगर इकाई",
  T_48_META_EVT_3031_D: "यह तब ट्रिगर होता है जब वाहन किसी इकाई द्वारा चलाया जाता है",
  T_48_META_EVT_3031_P0_D: "ट्रिगर इकाई",
  T_48_META_EVT_3032_D: "इकाई द्वारा टेलीपोर्ट के लिए पोर्टल का उपयोग करने के बाद ट्रिगर हुआ (अप्रचलित, कृपया OnBouncesOffTire का उपयोग करें)",
  T_48_META_EVT_3032_P0_D: "पोर्टल का उपयोग करने वाली संस्थाएँ",
  T_48_META_EVT_3032_P1_D: "पोर्टल का उपयोग किया गया",
  T_48_META_EVT_3033_D: "इकाई के बाउंस होने पर ट्रिगर होता है",
  T_48_META_EVT_3033_P0_D: "ट्रिगर इकाई",
  T_48_META_EVT_3033_P1_D: "उछलती हुई वस्तु का प्रयोग किया गया",
  T_48_META_EVT_3034_D: "पोर्टल द्वारा इकाई को टेलीपोर्ट करने के बाद ट्रिगर किया गया",
  T_48_META_EVT_3034_P0_D: "संचारण इकाई",
  T_48_META_EVT_3035_D: "टायर के उछलने के बाद इकाई चालू हो गई",
  T_48_META_EVT_3035_P0_D: "बाउंस इकाई",
  T_48_META_EVT_3036_D: "तब ट्रिगर होता है जब तंत्र इकाई को हवा में गिरा देता है",
  T_48_META_EVT_3036_P0_D: "वे संस्थाएँ जिन्हें नष्ट कर दिया गया",
  T_48_META_EVT_3036_P1_D: "यांत्रिक वस्तुएं",
  T_48_META_EVT_3037_D: "जब कोई इकाई ट्रिगर में प्रवेश करती है तो सक्रिय हो जाती है",
  T_48_META_EVT_3037_P0_D: "प्रवेश ट्रिगर",
  T_48_META_EVT_3038_D: "जब कोई इकाई ट्रिगर छोड़ती है तो सक्रिय हो जाती है",
  T_48_META_EVT_3038_P0_D: "प्रस्थान ट्रिगर",
  T_48_META_EVT_3039_D: "हथियार इकाई प्राप्त होने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3039_P0_D: "हथियार इकाई",
  T_48_META_EVT_3040_D: "यह तब ट्रिगर होता है जब किसी तंत्र द्वारा इकाई को हटा दिया जाता है",
  T_48_META_EVT_3040_P0_D: "वे संस्थाएँ जिन्हें नष्ट कर दिया गया",
  T_48_META_EVT_3040_P1_D: "यांत्रिक वस्तुएं",
  T_48_META_EVT_3041_D: "किसी लक्षित इकाई को लक्षित करते समय ट्रिगर किया गया",
  T_48_META_EVT_3041_P0_D: "लक्षित इकाई",
  T_48_META_EVT_3042_D: "किसी खिलाड़ी द्वारा लक्षित किये जाने पर ट्रिगर होता है",
  T_48_META_EVT_3042_P0_D: "निशाना लगाता हुआ खिलाड़ी",
  T_48_META_EVT_3043_D: "जब गोली लक्ष्य पर लगती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3043_P0_D: "लक्ष्य पर प्रहार",
  T_48_META_EVT_3043_P1_D: "दुनिया निर्देशांक बनाती है कि गोली कहाँ लगी",
  T_48_META_EVT_3044_D: "किसी हथियार से प्रहार करने पर ट्रिगर होता है",
  T_48_META_EVT_3044_P0_D: "हथियारों",
  T_48_META_EVT_3044_P1_D: "हिट क्षेत्र का विश्व निर्देशांक",
  T_48_META_EVT_3045_D: "यह तब ट्रिगर होता है जब खिलाड़ी इस स्तर पर किसी ऑब्जेक्ट में बदलना चुनता है",
  T_48_META_EVT_3045_P0_D: "प्लेयर एक इकाई में बदल जाता है, न कि दृश्य वस्तु में",
  T_48_META_EVT_3046_D: "यह तब ट्रिगर होता है जब खिलाड़ी इस श्वसन बिंदु पर पुनर्जीवित हो जाता है",
  T_48_META_EVT_3046_P0_D: "इस रिस्पॉन पॉइंट पर खिलाड़ी पुनर्जीवित हो गए",
  T_48_META_EVT_3047_D: "जब खिलाड़ी हथियार गिराता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3047_P0_D: "छोड़ी गई हथियार इकाई",
  T_48_META_EVT_3048_D: "यह तब ट्रिगर होता है जब खिलाड़ी हथियार के अलावा कोई अन्य वस्तु गिरा देता है",
  T_48_META_EVT_3048_P0_D: "वस्तु का प्रकार",
  T_48_META_EVT_3048_P1_D: "आइटम इकाई, खाली हो सकती है",
  T_48_META_EVT_3049_D: "फुटबॉल गन से टकराने पर ट्रिगर हुआ",
  T_48_META_EVT_3049_P0_D: "खिलाड़ी",
  T_48_META_EVT_3049_P1_D: "मार खाने के बाद की गति",
  T_48_META_EVT_3050_D: "जब फुटबॉल किसी इकाई से टकराता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3050_P0_D: "टकराव की वस्तु",
  T_48_META_EVT_3050_P1_D: "टक्कर के बाद की गति",
  T_48_META_EVT_3051_D: "जब प्लेयर सफलतापूर्वक वॉयस चैनल से जुड़ जाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3051_P0_D: "वॉयस चैनल इकाई",
  T_48_META_EVT_3052_D: "यह तब ट्रिगर होता है जब कोई प्लेयर वॉयस चैनल से जुड़ने में विफल रहता है",
  T_48_META_EVT_3052_P0_D: "वॉयस चैनल इकाई",
  T_48_META_EVT_3053_D: "जब प्लेयर वॉयस चैनल से बाहर निकलता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3053_P0_D: "वॉयस चैनल इकाई",
  T_48_META_EVT_3054_D: "जब फुटबॉल गोल में प्रवेश करती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3054_P0_D: "लक्ष्य",
  T_48_META_EVT_3054_P1_D: "स्कोरर, स्कोर करने से पहले गेंद को छूने वाला अंतिम खिलाड़ी",
  T_48_META_EVT_3054_P2_D: "असिस्टर, अंतिम खिलाड़ी जो गोल में प्रवेश करने से पहले गेंद को छूता है",
  T_48_META_EVT_3055_D: "जब खिलाड़ी फायर बटन दबाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3056_D: "जब खिलाड़ी कूदता है तो ट्रिगर होता है",
  T_48_META_EVT_3057_D: "जब खिलाड़ी झुक रहा हो तो ट्रिगर हो जाता है",
  T_48_META_EVT_3058_D: "जब खिलाड़ी प्रवण होता है तो ट्रिगर होता है",
  T_48_META_EVT_3059_D: "जब खिलाड़ी दौड़ता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3060_D: "यह तब ट्रिगर होता है जब कोई वस्तु स्टोर में सफलतापूर्वक खरीदी जाती है",
  T_48_META_EVT_3060_P0_D: "खिलाड़ी जो सामान खरीदते हैं",
  T_48_META_EVT_3060_P1_D: "माल",
  T_48_META_EVT_3061_D: "जब खिलाड़ी द्वारा हथियार सुसज्जित किया जाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3061_P0_D: "खिलाड़ी हथियारों से लैस",
  T_48_META_EVT_3062_D: "यह तब ट्रिगर होता है जब इस हथियार से एक इकाई को मार दिया जाता है",
  T_48_META_EVT_3062_P0_D: "हत्या की गई इकाई",
  T_48_META_EVT_3063_D: "यह तब ट्रिगर होता है जब इस हथियार का उपयोग किसी इकाई को नुकसान पहुंचाने के लिए किया जाता है",
  T_48_META_EVT_3063_P0_D: "क्षतिग्रस्त इकाई",
  T_48_META_EVT_3063_P1_D: "हानि",
  T_48_META_EVT_3064_D: "जब हथियार गोलियां बदलता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3065_D: "जब कोई इकाई वाहन में प्रवेश करती है तो ट्रिगर हो जाती है। यह घटना ड्राइवर या यात्री के रूप में ट्रिगर हो सकती है।",
  T_48_META_EVT_3065_P0_D: "वाहन में प्रवेश",
  T_48_META_EVT_3066_D: "जब इकाई वाहन छोड़ती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3066_P0_D: "प्रस्थान करने वाला वाहन",
  T_48_META_EVT_3067_D: "जब कोई इकाई वाहन चलाती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3067_P0_D: "वाहन चलाना",
  T_48_META_EVT_3068_D: "किसी इकाई द्वारा पोर्टल का उपयोग करके टेलीपोर्ट करने के बाद ट्रिगर किया गया",
  T_48_META_EVT_3068_P0_D: "पोर्टल का उपयोग किया गया",
  T_48_META_EVT_3069_D: "टायर द्वारा इकाई को बाउंस करने के बाद ट्रिगर किया गया",
  T_48_META_EVT_3069_P0_D: "टायरों का प्रयोग किया गया",
  T_48_META_EVT_3070_D: "यह तब ट्रिगर होता है जब किसी तंत्र द्वारा इकाई को हटा दिया जाता है",
  T_48_META_EVT_3070_P0_D: "यांत्रिक वस्तुएं",
  T_48_META_EVT_3071_D: "प्लेयर द्वारा यूआई बटन नियंत्रण दबाने के बाद ट्रिगर हो जाता है",
  T_48_META_EVT_3071_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3072_D: "यूआई बटन नियंत्रण बढ़ाए जाने के बाद सक्रिय हो जाता है",
  T_48_META_EVT_3072_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3073_D: "यूआई बटन नियंत्रण को प्लेयर द्वारा डबल-क्लिक करने के बाद ट्रिगर किया जाता है",
  T_48_META_EVT_3073_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3074_D: "जेलब्रेक क्षेत्र शुरू होता है",
  T_48_META_EVT_3075_D: "जेलब्रेक क्षेत्र का अंत",
  T_48_META_EVT_3076_D: "जब खिलाड़ी वेकबोर्ड का उपयोग बंद कर देता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3077_D: "यह तब ट्रिगर होता है जब प्लेयर द्वारा यूआई इनपुट बॉक्स नियंत्रण की टेक्स्ट सामग्री बदल दी जाती है",
  T_48_META_EVT_3077_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3077_P1_D: "पाठ्य सामग्री परिवर्तित",
  T_48_META_EVT_3078_D: "जब कोई बजाने योग्य इकाई खेलना शुरू करती है तो सक्रिय हो जाती है",
  T_48_META_EVT_3078_P0_D: "बजाने योग्य इकाई",
  T_48_META_EVT_3079_D: "जब बजाने योग्य इकाई का बजना समाप्त हो जाता है तब ट्रिगर होता है। जब बजाने योग्य इकाई ध्वनि प्रभाव, विशेष प्रभाव इत्यादि होती है, तो यह घटना केवल क्लाइंट पर प्रभाव डालती है।",
  T_48_META_EVT_3079_P0_D: "बजाने योग्य इकाई",
  T_48_META_EVT_3080_D: "जब खेलने योग्य इकाई खेलना जारी रखती है तो सक्रिय हो जाती है",
  T_48_META_EVT_3080_P0_D: "बजाने योग्य इकाई",
  T_48_META_EVT_3081_D: "जब खेलने योग्य इकाई प्लेबैक रोक देती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3081_P0_D: "बजाने योग्य इकाई",
  T_48_META_EVT_3082_D: "जेलब्रेक किए गए खिलाड़ी शामिल होते हैं",
  T_48_META_EVT_3082_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3083_D: "जेलब्रेक किए गए खिलाड़ी बाहर निकलते हैं",
  T_48_META_EVT_3083_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3084_D: "उलटी गिनती के अंत में आग",
  T_48_META_EVT_3084_P0_D: "स्वामित्व वाली इकाई",
  T_48_META_EVT_3085_D: "जब कोई वस्तु उठाई जाती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3085_P0_D: "वह खिलाड़ी जिसने आइटम उठाया",
  T_48_META_EVT_3086_D: "किसी वस्तु के गिरने पर ट्रिगर होता है",
  T_48_META_EVT_3086_P0_D: "वह खिलाड़ी जिसने आइटम गिराया",
  T_48_META_EVT_3087_D: "जब यह आइटम सुसज्जित होता है तो ट्रिगर होता है",
  T_48_META_EVT_3088_D: "माइन बनने के बाद जब वस्तु चालू होती है तो आग लग जाती है",
  T_48_META_EVT_3089_D: "माइन बनने के बाद जब ऑब्जेक्ट ट्रिगर होता है तो आग लग जाती है",
  T_48_META_EVT_3089_P0_D: "माइन बनने के बाद ऑब्जेक्ट के लक्ष्य को ट्रिगर करें",
  T_48_META_EVT_3090_D: "स्टोर में सामान खरीदने से पहले ट्रिगर किया गया",
  T_48_META_EVT_3090_P0_D: "खिलाड़ी जो सामान खरीदते हैं",
  T_48_META_EVT_3090_P1_D: "माल",
  T_48_META_EVT_3091_D: "जब यह उपकरण उपयोग में होता है तो यह चालू हो जाता है",
  T_48_META_EVT_3092_D: "जब ग्रैपल गन से गोली चलाई जाती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3093_D: "ट्रिगर तब होता है जब प्रक्षेप्य फेंके जाने के बाद फट जाता है",
  T_48_META_EVT_3093_P0_D: "विस्फोट बिंदु",
  T_48_META_EVT_3094_D: "स्प्रे गन से टकराने पर ट्रिगर हो गया",
  T_48_META_EVT_3094_P0_D: "स्प्रे बंदूक इकाई",
  T_48_META_EVT_3094_P1_D: "हिट बिंदु",
  T_48_META_EVT_3094_P2_D: "सामान्य मारो",
  T_48_META_EVT_3095_D: "पेंट गन से प्रहार करने पर ट्रिगर हुआ",
  T_48_META_EVT_3095_P0_D: "वस्तु से टकराना",
  T_48_META_EVT_3095_P1_D: "हिट बिंदु",
  T_48_META_EVT_3095_P2_D: "सामान्य मारो",
  T_48_META_EVT_3096_D: "यह तब ट्रिगर होता है जब कोई वाहन या डाई बैरल फट जाता है",
  T_48_META_EVT_3096_P0_D: "वह खिलाड़ी जिसने विस्फोट किया",
  T_48_META_EVT_3096_P1_D: "विस्फोट से प्रभावित खिलाड़ियों की सूची",
  T_48_META_EVT_3097_D: "जब हथियार फायरिंग बंद कर देता है तो फायर हो जाता है",
  T_48_META_EVT_3097_P0_D: "फायरिंग रोकने पर मौजूदा मैगजीन में बची गोला-बारूद की मात्रा",
  T_48_META_EVT_3098_D: "जब पीछा करने वाला लक्ष्य पीछा करने की सीमा में प्रवेश करता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3099_D: "तब ट्रिगर होता है जब पीछा करने वाला लक्ष्य पीछा करने की सीमा छोड़ देता है",
  T_48_META_EVT_31_D: "दृश्य स्विच सफल होने पर ट्रिगर किया गया",
  T_48_META_EVT_31_P0_D: "दृश्य का नाम",
  T_48_META_EVT_3100_D: "जब हमला लक्ष्य हमले की सीमा में प्रवेश करता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3101_D: "तब ट्रिगर होता है जब हमला लक्ष्य हमले की सीमा छोड़ देता है",
  T_48_META_EVT_3102_D: "यह इवेंट तब ट्रिगर होता है जब क्लाइंट क्लिक इवेंट के माध्यम से कैमरा रे डिटेक्शन ट्रिगर होता है",
  T_48_META_EVT_3102_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3102_P1_D: "क्या कैमरे की किरण वस्तु से टकराती है",
  T_48_META_EVT_3102_P2_D: "कैमरे की किरण लोकेशन पर पड़ती है",
  T_48_META_EVT_3102_P3_D: "क्लाइंट कैमरा ओरिएंटेशन",
  T_48_META_EVT_3102_P4_D: "क्लाइंट कैमरा स्थिति",
  T_48_META_EVT_3102_P5_D: "हिट इकाई",
  T_48_META_EVT_3103_D: "स्टोर इंटरफ़ेस खुलने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3103_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3104_D: "स्टोर इंटरफ़ेस बंद होने पर ट्रिगर होता है",
  T_48_META_EVT_3104_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3105_D: "जब व्यवहार वृक्ष तर्क इस नोड में प्रवेश करता है तो ट्रिगर होता है",
  T_48_META_EVT_3105_P0_D: "नोड नाम",
  T_48_META_EVT_3105_P1_D: "स्वामित्व वाली इकाई",
  T_48_META_EVT_3106_D: "जब व्यवहार वृक्ष तर्क नोड से बाहर निकलता है तो ट्रिगर होता है",
  T_48_META_EVT_3106_P0_D: "नोड नाम",
  T_48_META_EVT_3106_P1_D: "स्वामित्व वाली इकाई",
  T_48_META_EVT_3107_D: "कठोर शरीर के जागृत होने पर ट्रिगर होता है",
  T_48_META_EVT_3108_D: "यह तब शुरू होता है जब कठोर शरीर सो जाता है",
  T_48_META_EVT_3109_D: "जब खिलाड़ी हिलता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3109_P0_D: "नज़रिया",
  T_48_META_EVT_3110_D: "प्लेयर निष्क्रिय होने पर ट्रिगर होता है",
  T_48_META_EVT_3110_P0_D: "नज़रिया",
  T_48_META_EVT_3111_D: "जब खिलाड़ी किसी कौशल का उपयोग करता है तो ट्रिगर होता है",
  T_48_META_EVT_3111_P0_D: "कौशल का प्रयोग किया गया",
  T_48_META_EVT_3112_D: "जब खिलाड़ी दौड़ना समाप्त कर लेता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3113_D: "SwitchEquipSlot गणना के तहत स्लॉट के अनुरूप आइटम प्राप्त करते समय ट्रिगर किया गया",
  T_48_META_EVT_3113_P0_D: "प्राप्त वस्तु इकाई",
  T_48_META_EVT_3114_D: "हैंडहेल्ड वस्तुओं को स्विच करते समय ट्रिगर किया गया, जिसमें मुट्ठी पर स्विच करना भी शामिल है",
  T_48_META_EVT_3114_P0_D: "स्विच करने के बाद रखे गए आइटम की इकाई",
  T_48_META_EVT_3115_D: "यह तब ट्रिगर होता है जब स्टोर में कोई खिलाड़ी दूसरों से सामान खरीदने का अनुरोध करता है",
  T_48_META_EVT_3115_P0_D: "वह खिलाड़ी जिसने उत्पाद का अनुरोध किया था",
  T_48_META_EVT_3115_P1_D: "माल",
  T_48_META_EVT_3116_D: "यह तब ट्रिगर होता है जब स्टोर में कोई खिलाड़ी दूसरों से सामान खरीदने का अनुरोध करता है और अनुरोध स्वीकार कर लिया जाता है।",
  T_48_META_EVT_3116_P0_D: "खिलाड़ी जो खरीदने में मदद करते हैं",
  T_48_META_EVT_3116_P1_D: "खिलाड़ी खरीदारी में मदद का अनुरोध कर रहे हैं",
  T_48_META_EVT_3116_P2_D: "माल",
  T_48_META_EVT_3117_D: "जब एक निश्चित फ्रेम अपडेट किया जाता है तो ट्रिगर होता है, आवृत्ति प्रति सेकंड 30 बार तय होती है",
  T_48_META_EVT_3118_D: "पॉज़ गेम एपीआई को कॉल करने के बाद ट्रिगर किया गया",
  T_48_META_EVT_3119_D: "रिज्यूम गेम एपीआई को कॉल करने के बाद ट्रिगर हुआ",
  T_48_META_EVT_3120_D: "जब कोई खिलाड़ी मित्रों को जोड़ता या हटाता है तो ट्रिगर होता है",
  T_48_META_EVT_3121_D: "पर्सोना जानकारी प्राप्त करते समय ट्रिगर किया गया",
  T_48_META_EVT_3121_P0_D: "जानकारी सामग्री",
  T_48_META_EVT_3121_P1_D: "प्रेषक व्यक्तित्व",
  T_48_META_EVT_3122_D: "खिलाड़ी की छलांग के अंत में फायर होता है",
  T_48_META_EVT_3123_D: "खिलाड़ी के गिरने पर ट्रिगर होता है",
  T_48_META_EVT_3124_D: "जब खिलाड़ी का गिरना समाप्त हो जाता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3125_D: "पर्सोना व्यवहार प्राप्त करते समय ट्रिगर किया गया",
  T_48_META_EVT_3125_P0_D: "व्यवहार",
  T_48_META_EVT_3125_P1_D: "प्रेषक व्यक्तित्व",
  T_48_META_EVT_3126_D: "जब सदस्य की जानकारी बदलती है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3126_P0_D: "परिवर्तन के बाद सदस्य की स्थिति",
  T_48_META_EVT_3127_D: "सदस्य केंद्र में प्रवेश करते समय ट्रिगर हो गया",
  T_48_META_EVT_3128_D: "सदस्य केंद्र छोड़ते समय ट्रिगर हुआ",
  T_48_META_EVT_3129_D: "जब खिलाड़ी गिरी हुई अवस्था में प्रवेश करता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_3129_P0_D: "हमलावर इकाई, खाली हो सकती है",
  T_48_META_EVT_3130_D: "पर्सोना स्टेटस प्राप्त होने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3130_P0_D: "प्रेषक व्यक्तित्व",
  T_48_META_EVT_3130_P1_D: "त्रुटि कोड",
  T_48_META_EVT_3131_D: "यूआई के माध्यम से पर्सोना को जानकारी भेजते समय ट्रिगर किया गया",
  T_48_META_EVT_3131_P0_D: "जानकारी सामग्री",
  T_48_META_EVT_3131_P1_D: "प्रेषक व्यक्तित्व",
  T_48_META_EVT_3132_D: "पर्सोना का अंत प्राप्त होने पर ट्रिगर हुआ",
  T_48_META_EVT_3132_P0_D: "प्रेषक व्यक्तित्व",
  T_48_META_EVT_3132_P1_D: "त्रुटि कोड",
  T_48_META_EVT_32_D: "जब प्लेयर दृश्य बदलता है तो ट्रिगर हो जाता है",
  T_48_META_EVT_32_P0_D: "दृश्य का नाम",
  T_48_META_EVT_3200_D: "जब एनीमेशन क्लिप चलना समाप्त हो जाए तो सक्रिय हो जाता है",
  T_48_META_EVT_3200_P0_D: "एनिमेशन क्लिप नाम",
  T_48_META_EVT_3201_D: "एनीमेशन स्थिति प्लेबैक पूरा होने पर ट्रिगर किया गया",
  T_48_META_EVT_3201_P0_D: "एनिमेशन स्थिति का नाम",
  T_48_META_EVT_3204_D: "टॉगल नियंत्रण की स्थिति बदलने पर ट्रिगर हो जाता है",
  T_48_META_EVT_3204_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3204_P1_D: "राज्य",
  T_48_META_EVT_3260_D: "जब प्लेयर द्वारा टचपैड दबाया जाता है तो सक्रिय हो जाता है",
  T_48_META_EVT_3260_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3260_P1_D: "प्रेस की स्थिति",
  T_48_META_EVT_3261_D: "टचपैड को ऊपर उठाने पर सक्रिय हो जाता है",
  T_48_META_EVT_3261_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3261_P1_D: "ऊंचा स्थान",
  T_48_META_EVT_3262_D: "जब टचपैड फिसलने लगता है तो सक्रिय हो जाता है",
  T_48_META_EVT_3262_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3262_P1_D: "स्लाइडिंग स्थिति प्रारंभ करें",
  T_48_META_EVT_3263_D: "टचपैड स्लाइडिंग के दौरान ट्रिगर किया गया, स्लाइडिंग के दौरान, यह इवेंट प्रत्येक फ्रेम में एक बार ट्रिगर किया जाएगा।",
  T_48_META_EVT_3263_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3263_P1_D: "स्लाइडिंग स्थिति प्रारंभ करें",
  T_48_META_EVT_3263_P2_D: "विस्थापन",
  T_48_META_EVT_3264_D: "टचपैड स्लाइड के अंत में सक्रिय होता है",
  T_48_META_EVT_3264_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3264_P1_D: "अंत स्लाइडिंग स्थिति",
  T_48_META_EVT_3265_D: "जॉयस्टिक दबाने पर सक्रिय हो जाता है",
  T_48_META_EVT_3265_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3266_D: "जॉयस्टिक को उठाने पर आग लग जाती है",
  T_48_META_EVT_3266_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3267_D: "जॉयस्टिक का उपयोग करते समय ट्रिगर हुआ",
  T_48_META_EVT_3267_P0_D: "ट्रिगर प्लेयर",
  T_48_META_EVT_3267_P1_D: "आउटपुट विस्थापन",
  T_48_META_EVT_3268_D: "यह तब ट्रिगर होता है जब खिलाड़ी दूसरे रुख से खड़ा होता है",
  T_48_META_EVT_3268_P0_D: "खड़े होने से पहले खिलाड़ी की मुद्रा",
  T_48_META_EVT_3269_D: "जब हथियार चलाया जाता है तो ट्रिगर होता है",
  T_48_META_EVT_4_D: "प्रत्येक दौर की शुरुआत में ट्रिगर किया गया",
  T_48_META_EVT_4_P0_D: "गोल सूचकांक, 0 से प्रारंभ",
  T_48_META_EVT_5_D: "प्रत्येक राउंड के अंत में ट्रिगर",
  T_48_META_EVT_5_P0_D: "गोल सूचकांक, 0 से प्रारंभ",
  T_48_META_EVT_6_D: "जब कोई इकाई टकराती है तो ट्रिगर होती है। केवल कठोर बॉडी घटकों वाली इकाइयां ही इस घटना का समर्थन करती हैं।",
  T_48_META_EVT_6_P0_D: "संस्थाओं का सामना हुआ",
  T_48_META_EVT_7_D: "प्रत्येक चरण की शुरुआत में ट्रिगर किया गया",
  T_48_META_EVT_7_P0_D: "मंच इकाई",
  T_48_META_EVT_8_D: "प्रत्येक चरण के अंत में ट्रिगर किया गया",
  T_48_META_EVT_8_P0_D: "मंच इकाई",
  T_48_META_EVT_9_D: "इकाई टकराव के अंत में ट्रिगर किया गया। केवल माउंटेड कठोर बॉडी घटकों वाली इकाइयां ही इस घटना का समर्थन करती हैं।",
  T_48_META_EVT_9_P0_D: "संस्थाओं का सामना हुआ",
  T_49_META_TYP_10_I1_D: "टैग लिस्ट",
  T_49_META_TYP_10_I2_D: "क्या यह उपलब्ध है?",
  T_49_META_TYP_10_I3_D: "क्या सभी पैरेंट नोड उपलब्ध हैं?",
  T_49_META_TYP_10_I4_D: "क्या यह दृश्य में उपलब्ध है?",
  T_49_META_TYP_10_I5_D: "लॉजिक अपडेट को सक्षम करना है या नहीं। अक्षम होने पर, इकाई पर स्क्रिप्ट हर फ़्रेम को अपडेट करना बंद कर देगी।",
  T_49_META_TYP_10_I6_D: "इकाई का नाम",
  T_49_META_TYP_10_I7_D: "क्षेत्र फ़िल्टर विकल्प, 0 का अर्थ है कि क्या स्वचालित गणना नियंत्रित है, 1 का अर्थ है कि यह नियंत्रित नहीं है और हमेशा सिंक्रनाइज़ है, 2 का अर्थ है कि यह नियंत्रित है",
  T_49_META_TYP_100_I0_D: "ट्रिगर रेंज सेट करें",
  T_49_META_TYP_100_I1_D: "मॉडल दृश्यता",
  T_49_META_TYP_101_I0_D: "खिलाड़ी",
  T_49_META_TYP_101_I1_D: "लक्षित वस्तु ID",
  T_49_META_TYP_101_I2_D: "लक्षित घुमाव",
  T_49_META_TYP_101_I3_D: "लक्षित पैमाना",
  T_49_META_TYP_1010_I1_D: "समय की अवधि, सेकंड में",
  T_49_META_TYP_1010_I2_D: "उलटी गिनती का आरंभ समय, खेल सेकंड में",
  T_49_META_TYP_1010_I3_D: "समय का अद्यतन प्रकार, `EUITimeUpdateType` देखें, वैकल्पिक: स्थिर, समय, उलटी गिनती",
  T_49_META_TYP_1010_I4_D: "प्रदर्शन स्थिति, जब अनुसरण करने के लिए कोई लक्ष्य होता है, तो यह लक्ष्य मूल के सापेक्ष ऑफसेट होता है, जब अनुसरण करने के लिए कोई लक्ष्य नहीं होता है, तो यह स्क्रीन निर्देशांक होता है",
  T_49_META_TYP_1011_I10_D: "प्रगति आइकन नाम",
  T_49_META_TYP_1011_I2_D: "थीम रंग",
  T_49_META_TYP_1011_I3_D: "स्थानीयकृत प्रदर्शन सक्षम करना है या नहीं",
  T_49_META_TYP_1011_I4_D: "शीर्षक",
  T_49_META_TYP_1011_I5_D: "विवरण",
  T_49_META_TYP_1011_I6_D: "आइकन संसाधन नाम",
  T_49_META_TYP_1011_I7_D: "अधिकतम प्रगति",
  T_49_META_TYP_1011_I8_D: "वर्तमान प्रगति",
  T_49_META_TYP_1011_I9_D: "प्रगति आइकन",
  T_49_META_TYP_1012_I1_D: "स्थानीयकरण सक्षम करना है या नहीं",
  T_49_META_TYP_1012_I2_D: "गोल संख्या पाठ",
  T_49_META_TYP_1012_I3_D: "राउंड संख्या लोकलाइज़ेशन कुंजी पैरामीटर",
  T_49_META_TYP_1012_I5_D: "बाईं ओर का रंग",
  T_49_META_TYP_1012_I6_D: "दाईं ओर का रंग",
  T_49_META_TYP_1013_I2_D: "गोल संख्या पाठ",
  T_49_META_TYP_1013_I3_D: "राउंड संख्या लोकलाइज़ेशन कुंजी पैरामीटर",
  T_49_META_TYP_1014_I2_D: "प्रथम स्कोर शीर्षक पाठ",
  T_49_META_TYP_1014_I3_D: "पहला स्कोर मान",
  T_49_META_TYP_1014_I4_D: "पहला स्कोर पैरामीटर",
  T_49_META_TYP_1014_I5_D: "दूसरा स्कोर शीर्षक पाठ",
  T_49_META_TYP_1014_I6_D: "दूसरा स्कोर मान",
  T_49_META_TYP_1014_I7_D: "दूसरा स्कोर पैरामीटर",
  T_49_META_TYP_1016_I1_D: "मूल्य के अनुसार संबंधित स्थिति प्रदर्शित करें, जीत (1), हार (2), ड्रा (3), जीत (4)",
  T_49_META_TYP_1016_I2_D: "2 टीमों के स्कोर दिखाएँ। अगर सही है, तो यह प्रदर्शित होगा, अन्यथा यह छिपा रहेगा।",
  T_49_META_TYP_1016_I3_D: "बाईं टीम का स्कोर",
  T_49_META_TYP_1016_I4_D: "दाईं टीम का स्कोर",
  T_49_META_TYP_1016_I5_D: "चरण समाप्ति टाइमस्टैम्प",
  T_49_META_TYP_1017_I1_D: "बाईं टीम का नाम",
  T_49_META_TYP_1017_I2_D: "बाईं ओर विवरण",
  T_49_META_TYP_1017_I3_D: "दाईं टीम का नाम",
  T_49_META_TYP_1017_I4_D: "दाईं ओर विवरण",
  T_49_META_TYP_1018_I1_D: "राउंड संख्या",
  T_49_META_TYP_1018_I4_D: "बायीं टीम का स्कोर",
  T_49_META_TYP_1018_I6_D: "सही टीम स्कोर",
  T_49_META_TYP_1019_I1_D: "जीत, हार और ड्रा क्रमशः 1 2 3 के अनुरूप हैं",
  T_49_META_TYP_102_I0_D: "पुनरुत्थान स्रोत प्रकार, खिलाड़ी मृत्यु से पुनर्जीवित",
  T_49_META_TYP_102_I1_D: "पुनरुत्थान स्रोत प्रकार, खिलाड़ी एक गिराए गए राज्य से पुनर्जीवित होता है",
  T_49_META_TYP_1020_I2_D: "प्रदर्शित की जाने वाली पाठ कुंजी",
  T_49_META_TYP_1020_I3_D: "पाठ कुंजी के अनुरूप पैरामीटर सरणी",
  T_49_META_TYP_1021_I1_D: "आधार समय (सेकंड में)",
  T_49_META_TYP_1021_I2_D: "अवधि सेकंड में",
  T_49_META_TYP_1021_I3_D: "डिस्प्ले पोजीशन। जब कोई लक्ष्य होता है जिसका अनुसरण करना होता है, तो यह लक्ष्य मूल के सापेक्ष ऑफसेट होता है। जब कोई लक्ष्य नहीं होता जिसका अनुसरण करना होता है, तो यह स्क्रीन निर्देशांक होता है। डिफ़ॉल्ट मान Vector3(0) है",
  T_49_META_TYP_1022_I2_D: "प्रदर्शित की जाने वाली पाठ कुंजी",
  T_49_META_TYP_1022_I3_D: "पाठ कुंजी के अनुरूप पैरामीटर सरणी",
  T_49_META_TYP_1023_I1_D: "टीम स्कोर दिखाएं सही होने पर प्रदर्शित होता है, अन्यथा बंद होता है",
  T_49_META_TYP_1023_I4_D: "जब प्लेयर की स्थिति सत्य हो तो प्रदर्शित करें, अन्यथा बंद करें",
  T_49_META_TYP_1023_I5_D: "बाएं खिलाड़ी की स्थिति सारणी, 0: जीवित खिलाड़ियों की संख्या, 1: मृत खिलाड़ियों की संख्या, 2: हारे हुए खिलाड़ियों की संख्या",
  T_49_META_TYP_1023_I6_D: "दाएँ खिलाड़ी की स्थिति सारणी, 0: जीवित खिलाड़ियों की संख्या, 1: मृत खिलाड़ियों की संख्या, 2: हारे हुए खिलाड़ियों की संख्या",
  T_49_META_TYP_1023_I7_D: "बाईं टीममेट झंडे की संख्या",
  T_49_META_TYP_1023_I8_D: "दाएं साथी का झंडा संख्या",
  T_49_META_TYP_1024_I2_D: "ओफ़्सेट",
  T_49_META_TYP_1024_I3_D: "रैंक",
  T_49_META_TYP_1024_I4_D: "टीम का रंग",
  T_49_META_TYP_1024_I5_D: "आइकॉन नाम",
  T_49_META_TYP_1024_I6_D: "यदि बॉर्डर सत्य है तो उसे प्रदर्शित किया जाएगा, अन्यथा उसे बंद कर दिया जाएगा।",
  T_49_META_TYP_1024_I7_D: "स्कोर टेक्स्ट कुंजी",
  T_49_META_TYP_1024_I8_D: "स्कोर टेक्स्ट कुंजी पैरामीटर",
  T_49_META_TYP_1028_I1_D: "बाईं टीम के जीवित सदस्य की संख्या",
  T_49_META_TYP_1028_I2_D: "दाईं टीम के जीवित सदस्य की संख्या",
  T_49_META_TYP_1028_I3_D: "बाईं पृष्ठभूमि का रंग",
  T_49_META_TYP_1028_I4_D: "दाईं पृष्ठभूमि का रंग",
  T_49_META_TYP_1028_I5_D: "बाईं आइकॉन नाम",
  T_49_META_TYP_1028_I6_D: "दाईं आइकॉन नाम",
  T_49_META_TYP_1029_I1_D: "आइकॉन नाम",
  T_49_META_TYP_1029_I2_D: "पृष्ठभूमि आइकॉन नाम",
  T_49_META_TYP_103_I0_D: "प्राथमिक हथियार A",
  T_49_META_TYP_103_I1_D: "प्राथमिक हथियार B",
  T_49_META_TYP_103_I10_D: "बर्फ़ीली बम",
  T_49_META_TYP_103_I11_D: "बर्फ की दीवार",
  T_49_META_TYP_103_I12_D: "ज़मीन में खदान",
  T_49_META_TYP_103_I13_D: "स्वचालित बुर्ज",
  T_49_META_TYP_103_I14_D: "नकली ग्रेनेड",
  T_49_META_TYP_103_I16_D: "स्केटबोर्ड, छलावरण...",
  T_49_META_TYP_103_I2_D: "द्वितीयक हथियार",
  T_49_META_TYP_103_I3_D: "विस्फोटक हथियार",
  T_49_META_TYP_103_I5_D: "भारी हथियार",
  T_49_META_TYP_1030_I3_D: "बाईं टीम के जीवित सदस्य की संख्या",
  T_49_META_TYP_1030_I4_D: "दाईं टीम के जीवित सदस्य की संख्या",
  T_49_META_TYP_1030_I5_D: "टीम आइकन का नाम बाईं ओर",
  T_49_META_TYP_1030_I6_D: "टीम आइकन का नाम दाईं ओर",
  T_49_META_TYP_1031_I2_D: "शीघ्र सूचना विवरण",
  T_49_META_TYP_1031_I3_D: "सेकंड में उल्टी गिनती शुरू होने का टाइमस्टैम्प",
  T_49_META_TYP_1031_I4_D: "टिप्स विवरण पैरामीटर",
  T_49_META_TYP_1032_I1_D: "टिप्स प्रकार",
  T_49_META_TYP_1032_I3_D: "पैरामीटर",
  T_49_META_TYP_1033_I1_D: "स्विचिंग चरण, 0 का अर्थ है कि वर्तमान राउंड निपटाया गया है, 1 का अर्थ है कि अगला राउंड शुरू होता है",
  T_49_META_TYP_1033_I10_D: "विफलता संकेत पाठ, इसे डिफ़ॉल्ट के लिए रिक्त छोड़ दें",
  T_49_META_TYP_1033_I11_D: "राउंड आय शीर्षक",
  T_49_META_TYP_1033_I12_D: "राउंड आय",
  T_49_META_TYP_1033_I13_D: "राउंड आय विवरण शीर्षक",
  T_49_META_TYP_1033_I14_D: "गोल आय मूल्यों की विस्तृत सूची ऊपर दी गई विस्तृत शीर्षक सूची से मेल खाती है।",
  T_49_META_TYP_1033_I15_D: "एमवीपी खिलाड़ी उपनाम",
  T_49_META_TYP_1033_I16_D: "अगला राउंड अनुक्रमणिका",
  T_49_META_TYP_1033_I17_D: "मैच पॉइंट है",
  T_49_META_TYP_1033_I18_D: "अंतिम राउंड है",
  T_49_META_TYP_1033_I6_D: "टीम आइकन का नाम बाईं ओर",
  T_49_META_TYP_1033_I7_D: "टीम आइकन का नाम दाईं ओर",
  T_49_META_TYP_1033_I8_D: "मान के अनुसार संबंधित स्थिति प्रदर्शित करें, विजय (1), विफलता (2)",
  T_49_META_TYP_1033_I9_D: "विजय संकेत पाठ, इसे डिफ़ॉल्ट के लिए रिक्त छोड़ दें",
  T_49_META_TYP_1036_I1_D: "यह बताता है कि कितने स्तर हैं",
  T_49_META_TYP_1036_I2_D: "वर्तमान ज़ॉम्बी स्तर को इंगित करता है",
  T_49_META_TYP_1037_I1_D: "यह बताता है कि कितने बिंदु प्रदर्शित किए गए हैं",
  T_49_META_TYP_1039_I3_D: "सेकंड में उल्टी गिनती शुरू होने का टाइमस्टैम्प",
  T_49_META_TYP_104_I0_D: "शैली A",
  T_49_META_TYP_104_I1_D: "शैली B",
  T_49_META_TYP_104_I2_D: "शैली C",
  T_49_META_TYP_1040_I10_D: "आइटम विवरण",
  T_49_META_TYP_1040_I11_D: "चयनित आइटम का सूचकांक, 0 से शुरू होता है। यदि यह 0 से कम है, तो इसका अर्थ है चयन रद्द करना।",
  T_49_META_TYP_1040_I12_D: "बटन नाम",
  T_49_META_TYP_1040_I13_D: "बटन रंग",
  T_49_META_TYP_1040_I2_D: "काउंटडाउन कुंजी",
  T_49_META_TYP_1040_I3_D: "काउंटडाउन समय",
  T_49_META_TYP_1040_I4_D: "विवरण कुंजी",
  T_49_META_TYP_1040_I5_D: "विवरण जानकारी पैरामीटर सरणी",
  T_49_META_TYP_1040_I6_D: "आइटम बैकग्राउंड स्प्राइट",
  T_49_META_TYP_1040_I7_D: "आइटम बैकग्राउंड रंग",
  T_49_META_TYP_1040_I8_D: "आइटम आइकॉन",
  T_49_META_TYP_1040_I9_D: "आइटम नाम",
  T_49_META_TYP_1041_I2_D: "पोजीशन",
  T_49_META_TYP_1041_I3_D: "आइकन छवि",
  T_49_META_TYP_1041_I4_D: "लेबल",
  T_49_META_TYP_1041_I5_D: "पृष्ठभूमि रंग",
  T_49_META_TYP_1042_I1_D: "स्थानीय स्थिति",
  T_49_META_TYP_1043_I4_D: "रंग",
  T_49_META_TYP_1043_I5_D: "लेबल कुंजी",
  T_49_META_TYP_1043_I6_D: "लेबल पैरामीटर",
  T_49_META_TYP_1045_I2_D: "बटन चिह्न",
  T_49_META_TYP_1045_I3_D: "आइकॉन रंग",
  T_49_META_TYP_1045_I4_D: "आकार, चौड़ाई और ऊंचाई समान हैं",
  T_49_META_TYP_1045_I5_D: "नीचे दाएँ एंकर बिंदु के सापेक्ष स्थिति",
  T_49_META_TYP_1045_I6_D: "चार्ज मात्रा, 0 से कम होने पर छिपाई गई",
  T_49_META_TYP_1045_I7_D: "सीडी प्रारंभ समय, मिलीसेकंड में",
  T_49_META_TYP_1045_I8_D: "सीडी अवधि मिलीसेकंड में",
  T_49_META_TYP_1045_I9_D: "यदि सही है, तो बटन धूसर हो जाएगा, और यदि गलत है, तो उसे पुनः स्थापित कर दिया जाएगा।",
  T_49_META_TYP_106_I1_D: "सक्षम करें",
  T_49_META_TYP_106_I2_D: "अक्षम करें",
  T_49_META_TYP_109_I0_D: "चैट चैनल ID",
  T_49_META_TYP_109_I1_D: "खिलाड़ी सूची",
  T_49_META_TYP_11_I0_D: "क्या वर्तमान गेम अवैध स्थिति में है? यदि यह अवैध स्थिति में है, तो इसका मतलब है कि गेम ने टकराव के लिए अपना मूल्य खो दिया है। गेम को सीधे समाप्त करने की सिफारिश की जाती है।",
  T_49_META_TYP_11_I1_D: "वर्तमान खेल की अवधि, मिलीसेकंड में",
  T_49_META_TYP_11_I10_D: "क्या हर दौर में उपकरण को रीसेट करना है",
  T_49_META_TYP_11_I11_D: "विष चक्र तंत्र को सक्षम करना है या नहीं",
  T_49_META_TYP_11_I12_D: "सेफ ज़ोन साइज",
  T_49_META_TYP_11_I13_D: "सिकुड़ने के शुरू समय",
  T_49_META_TYP_11_I14_D: "सिकुड़ने की अवधि",
  T_49_META_TYP_11_I15_D: "आउट-ऑफ़-ज़ोन डैमेज",
  T_49_META_TYP_11_I18_D: "रिवाइवल टाइप",
  T_49_META_TYP_11_I2_D: "वर्तमान राउंड सूचकांक, जिसके माध्यम से वर्तमान राउंड इकाई प्राप्त की जा सकती है",
  T_49_META_TYP_11_I27_D: "कुल राउंड की संख्या",
  T_49_META_TYP_11_I3_D: "वर्तमान चरण सूचकांक, जिसके माध्यम से वर्तमान चरण इकाई प्राप्त की जा सकती है",
  T_49_META_TYP_11_I32_D: "राउंड की शुरुआत में प्राप्त सोने के सिक्कों की मात्रा",
  T_49_META_TYP_11_I33_D: "हत्या करने पर प्राप्त सोने के सिक्कों की मात्रा",
  T_49_META_TYP_11_I34_D: "जीतने पर प्राप्त सोने के सिक्कों की मात्रा",
  T_49_META_TYP_11_I35_D: "वॉलेट UI प्रदर्शित करना है या नहीं",
  T_49_META_TYP_11_I36_D: "स्काईबॉक्स इकाई",
  T_49_META_TYP_11_I37_D: "खेल शुरू होने के बाद से संचयी चलित फ़्रेम",
  T_49_META_TYP_11_I38_D: "चल सकता है",
  T_49_META_TYP_11_I39_D: "निपटान को अनुकूलित करना है या नहीं",
  T_49_META_TYP_11_I4_D: "प्रीसेट UGC मोड की टेम्पलेट आईडी",
  T_49_META_TYP_11_I40_D: "क्या बीच में शामिल होने की अनुमति है?",
  T_49_META_TYP_11_I41_D: "कम फ्रेम दर मोड चालू करें, गेम 15FPS पर चलेगा, अन्यथा 30FPS",
  T_49_META_TYP_11_I42_D: "गेम सर्वर के दो तार्किक फ़्रेम अपडेट के बीच का अंतराल",
  T_49_META_TYP_11_I43_D: "मिलीसेकंड में फ़्रेम अपडेट अंतराल निश्चित किया गया",
  T_49_META_TYP_11_I5_D: "यदि बंद है, तो खिलाड़ी पुनर्जीवन अक्षम हो जाता है।",
  T_49_META_TYP_11_I6_D: "यदि बंद है, तो बॉट पुनरुत्थान अक्षम है",
  T_49_META_TYP_11_I7_D: "पुनरुत्थान समय, सेकंड में",
  T_49_META_TYP_11_I8_D: "खेल में कुल टीमों की संख्या",
  T_49_META_TYP_11_I9_D: "प्रति टीम सदस्यों की संख्या",
  T_49_META_TYP_110_I0_D: "चैनल A",
  T_49_META_TYP_110_I1_D: "चैनल B",
  T_49_META_TYP_110_I2_D: "चैनल C",
  T_49_META_TYP_110_I3_D: "चैनल D",
  T_49_META_TYP_110_I4_D: "चैनल E",
  T_49_META_TYP_110_I5_D: "चैनल F",
  T_49_META_TYP_111_I1_D: "पूरे वेग से दौड़ना",
  T_49_META_TYP_111_I2_D: "हमला",
  T_49_META_TYP_111_I3_D: "कूदना",
  T_49_META_TYP_111_I4_D: "ऊपर चढ़ना",
  T_49_META_TYP_111_I5_D: "ड्राइव",
  T_49_META_TYP_111_I6_D: "वाहन में प्रवेश करें",
  T_49_META_TYP_111_I7_D: "वाहन से बाहर निकलें",
  T_49_META_TYP_111_I8_D: "वाहन चलाएं",
  T_49_META_TYP_112_I0_D: "सक्षम करें",
  T_49_META_TYP_112_I1_D: "अक्षम करें",
  T_49_META_TYP_112_I2_D: "अदृश्य",
  T_49_META_TYP_117_I0_D: "ताली",
  T_49_META_TYP_117_I1_D: "हाई-हैट",
  T_49_META_TYP_117_I2_D: "बास ड्रम",
  T_49_META_TYP_117_I3_D: "ओपन हाई-हैट",
  T_49_META_TYP_117_I4_D: "राइड",
  T_49_META_TYP_117_I5_D: "स्नेयर ड्रम",
  T_49_META_TYP_118_I0_D: "क्या शिविर के सभी सदस्य मर चुके हैं?",
  T_49_META_TYP_118_I1_D: "सभी खिलाड़ियों की सूची",
  T_49_META_TYP_118_I2_D: "मित्रपक्ष",
  T_49_META_TYP_118_I3_D: "हमला करने योग्य गुट",
  T_49_META_TYP_118_I4_D: "UI नाम प्रदर्शित करना है या नहीं",
  T_49_META_TYP_118_I5_D: "मानचित्र जानकारी प्रदर्शित करनी है या नहीं",
  T_49_META_TYP_118_I6_D: "प्रदर्शित करना है या नहीं",
  T_49_META_TYP_118_I7_D: "प्रदर्शित करना है या नहीं",
  T_49_META_TYP_118_I8_D: "सभी सदस्य",
  T_49_META_TYP_118_I9_D: "त्वरित संदेश दिखाएँ",
  T_49_META_TYP_119_I0_D: "हाँ",
  T_49_META_TYP_119_I1_D: "नहीं",
  T_49_META_TYP_120_I1_D: "अनुसरण करने के लिए लक्ष्य इकाई, डिफ़ॉल्ट रिक्त है",
  T_49_META_TYP_120_I2_D: "यूआई रंग",
  T_49_META_TYP_120_I3_D: "यूआई लंबाई",
  T_49_META_TYP_120_I4_D: "वर्तमान प्रगति मान, 0 से 1.0",
  T_49_META_TYP_120_I5_D: "डिस्प्ले पोजीशन। जब कोई लक्ष्य होता है जिसका अनुसरण करना होता है, तो यह लक्ष्य मूल के सापेक्ष ऑफसेट होता है। जब कोई लक्ष्य नहीं होता जिसका अनुसरण करना होता है, तो यह स्क्रीन निर्देशांक होता है। डिफ़ॉल्ट मान Vector3(0) है",
  T_49_META_TYP_121_I0_D: "3 सेकंड",
  T_49_META_TYP_121_I1_D: "5 सेकंड",
  T_49_META_TYP_121_I2_D: "10 सेकंड",
  T_49_META_TYP_121_I3_D: "15 सेकंड",
  T_49_META_TYP_121_I4_D: "30 सेकंड",
  T_49_META_TYP_121_I5_D: "9999 सेकंड",
  T_49_META_TYP_122_I0_D: "आकाश बॉक्स संसाधन",
  T_49_META_TYP_122_I1_D: "लाइट कलर",
  T_49_META_TYP_122_I10_D: "उपदृश्य GUID",
  T_49_META_TYP_122_I11_D: "धुंध प्रभाव स्विच",
  T_49_META_TYP_122_I12_D: "कोहरा प्रभाव मोड",
  T_49_META_TYP_122_I13_D: "घातीय कोहरा घनत्व",
  T_49_META_TYP_122_I14_D: "रेखीय कोहरे की प्रारंभिक दूरी",
  T_49_META_TYP_122_I15_D: "रेखीय कोहरे की अंतिम दूरी",
  T_49_META_TYP_122_I16_D: "कोहरा प्रभाव सुविधा सक्षम करें",
  T_49_META_TYP_122_I17_D: "मुख्य प्रकाश स्रोत घूर्णन कोण",
  T_49_META_TYP_122_I18_D: "मुख्य प्रकाश स्रोत रोटेशन कोण सुविधा सक्षम करें",
  T_49_META_TYP_122_I2_D: "लाइट इंटेंसिटी",
  T_49_META_TYP_122_I3_D: "डार्कनेस",
  T_49_META_TYP_122_I4_D: "शैडो स्ट्रेंथ",
  T_49_META_TYP_122_I5_D: "टेरन वेटनेस",
  T_49_META_TYP_122_I6_D: "लेंस फ्लेर",
  T_49_META_TYP_122_I7_D: "फॉग कलर",
  T_49_META_TYP_122_I8_D: "एम्बिएंट कलर",
  T_49_META_TYP_123_I0_D: "दिन",
  T_49_META_TYP_123_I1_D: "नाईट",
  T_49_META_TYP_123_I2_D: "डस्क",
  T_49_META_TYP_123_I3_D: "सिटी व्यू",
  T_49_META_TYP_123_I4_D: "कलरफुल स्काई",
  T_49_META_TYP_123_I5_D: "फ्रॉस्ट मून",
  T_49_META_TYP_124_I0_D: "करीब रेंज",
  T_49_META_TYP_124_I1_D: "मध्यम दूरी",
  T_49_META_TYP_124_I2_D: "लम्बी दूरी",
  T_49_META_TYP_125_I0_D: "डिफ्यूज़ कलर",
  T_49_META_TYP_125_I2_D: "डिफ्यूज़ टेक्सचर",
  T_49_META_TYP_125_I4_D: "डिफ्यूज़ अल्फा",
  T_49_META_TYP_126_I1_D: "नाम",
  T_49_META_TYP_126_I2_D: "वर्तमान प्रगति मूल्य",
  T_49_META_TYP_126_I3_D: "अधिकतम प्रगति मान",
  T_49_META_TYP_126_I4_D: "स्क्रीन निर्देशांक, डिफ़ॉल्ट वेक्टर3(0) है",
  T_49_META_TYP_126_I5_D: "प्रगति पट्टी की लंबाई। वर्तमान डिफ़ॉल्ट मान प्रीफ़ैब पर UI की लंबाई है।",
  T_49_META_TYP_127_I0_D: "एक निश्चित अक्ष के साथ अनुवाद, तीन अक्षों को जोड़ा जा सकता है",
  T_49_META_TYP_127_I1_D: "एक निश्चित अक्ष के साथ घूमें, तीन अक्षों को जोड़ा जा सकता है",
  T_49_META_TYP_127_I2_D: "एक निश्चित अक्ष के साथ ज़ूम करें, आप तीन अक्षों को जोड़ सकते हैं",
  T_49_META_TYP_128_I0_D: "झाड़ियों",
  T_49_META_TYP_128_I1_D: "कद्दू",
  T_49_META_TYP_128_I2_D: "डरावनी आकृति",
  T_49_META_TYP_128_I3_D: "कैबिनेट",
  T_49_META_TYP_129_I0_D: "यादृच्छिक लूट",
  T_49_META_TYP_129_I1_D: "AR गोला बारूद",
  T_49_META_TYP_129_I2_D: "SMG गोला बारूद",
  T_49_META_TYP_129_I3_D: "SN गोला बारूद",
  T_49_META_TYP_129_I4_D: "HG गोला बारूद",
  T_49_META_TYP_129_I5_D: "एसजी बुलेट",
  T_49_META_TYP_129_I6_D: "धनुष के गोला बारूद",
  T_49_META_TYP_13_I1_D: "मूल नोड के सापेक्ष एंकर निर्देशांक",
  T_49_META_TYP_13_I10_D: "विजेट और एंकर बॉक्स के आकार में अंतर",
  T_49_META_TYP_13_I11_D: "पिवट",
  T_49_META_TYP_13_I12_D: "गहराई",
  T_49_META_TYP_13_I14_D: "एक ही पैरेंट नोड के अंतर्गत सभी चाइल्ड नोड्स का क्रम",
  T_49_META_TYP_13_I15_D: "पेरेंट आईडी",
  T_49_META_TYP_13_I16_D: "अनोखा ID",
  T_49_META_TYP_13_I17_D: "प्राथमिकता",
  T_49_META_TYP_13_I18_D: "वास्तविक स्थिति",
  T_49_META_TYP_13_I2_D: "चौड़ाई",
  T_49_META_TYP_13_I4_D: "Z-अक्ष घूर्णन कोण",
  T_49_META_TYP_13_I6_D: "प्रीफ़ैब में नियंत्रण की आंतरिक आईडी",
  T_49_META_TYP_13_I7_D: "यूआई इकाई",
  T_49_META_TYP_13_I8_D: "एंकर न्यूनतम",
  T_49_META_TYP_13_I9_D: "एंकर अधिकतम",
  T_49_META_TYP_130_I0_D: "बेतरतीब उपभोग्य सामग्रियों की लूट",
  T_49_META_TYP_130_I1_D: "चिकित्सा किट",
  T_49_META_TYP_130_I2_D: "मरम्मत किट",
  T_49_META_TYP_130_I3_D: "क्षैतिज रेखा",
  T_49_META_TYP_130_I4_D: "इनहेलेटर",
  T_49_META_TYP_131_I0_D: "यादृच्छिक कवच लूट",
  T_49_META_TYP_131_I1_D: "स्तर 1 कवच",
  T_49_META_TYP_131_I2_D: "दूसरे स्तर का कवच",
  T_49_META_TYP_131_I3_D: "स्तर 3 कवच",
  T_49_META_TYP_132_I0_D: "रैंडम थ्रो लूट",
  T_49_META_TYP_132_I1_D: "ग्रेनेड",
  T_49_META_TYP_132_I4_D: "फ्लैश फ्रीज",
  T_49_META_TYP_133_I0_D: "रैंडम स्कोप लूट",
  T_49_META_TYP_133_I1_D: "2x दृष्टि",
  T_49_META_TYP_133_I2_D: "4x दृष्टि",
  T_49_META_TYP_133_I3_D: "थर्मल स्कोप",
  T_49_META_TYP_134_I0_D: "यादृच्छिक हथियार लूट",
  T_49_META_TYP_134_I5_D: "शॉटगन",
  T_49_META_TYP_134_I8_D: "फुटबॉल गन",
  T_49_META_TYP_135_I0_D: "लूट बुलेट पॉइंट",
  T_49_META_TYP_136_I0_D: "उपभोग्य वस्तु अंक लूटें",
  T_49_META_TYP_137_I0_D: "उपभोग्य वस्तु अंक लूटें",
  T_49_META_TYP_138_I0_D: "लूट ज़ूम बिंदु",
  T_49_META_TYP_139_I0_D: "कवच अंक लूटें",
  T_49_META_TYP_14_I0_D: "खिलाड़ी का वर्तमान स्वास्थ्य",
  T_49_META_TYP_14_I1_D: "खिलाड़ी का वर्तमान अधिकतम स्वास्थ्य",
  T_49_META_TYP_14_I11_D: "खिलाड़ी का गुट",
  T_49_META_TYP_14_I12_D: "खिलाड़ी का क्षति गुणक, जैसे 2x 2.0 है",
  T_49_META_TYP_14_I13_D: "पुरुष या महिला पात्र के समान ही कंकाल का उपयोग करें। 0 का अर्थ है मॉडल को प्रतिस्थापित न करें",
  T_49_META_TYP_14_I14_D: "मौजूदा गति स्केलिंग के साथ टकराव नहीं होगा",
  T_49_META_TYP_14_I15_D: "मौजूदा कूद ऊंचाई स्केलिंग के साथ संघर्ष नहीं होगा",
  T_49_META_TYP_14_I16_D: "पहचान, 0 सामान्य खिलाड़ी, 1 शिकारी, 2 माँ ज़ोंबी, 3 सामान्य ज़ोंबी, 4 विकसित ज़ोंबी प्रकार 1, 5 विकसित ज़ोंबी प्रकार 2, 6 विकसित ज़ोंबी प्रकार 3",
  T_49_META_TYP_14_I17_D: "ज़ोंबी स्तर, 1~3",
  T_49_META_TYP_14_I19_D: "खिलाड़ी का उपनाम",
  T_49_META_TYP_14_I2_D: "निर्धारित करें कि वर्तमान खिलाड़ी एक AI खिलाड़ी है या नहीं। AI आमतौर पर एक NPC या PVE राक्षस होता है।",
  T_49_META_TYP_14_I20_D: "क्षति होने पर, क्षति प्रतिशत को कम या बढ़ाया जा सकता है।",
  T_49_META_TYP_14_I21_D: "खिलाड़ी का वर्तमान ई.पी.",
  T_49_META_TYP_14_I22_D: "अधिकतम खिलाड़ी EP",
  T_49_META_TYP_14_I23_D: "वर्तमान में हाथ में मुख्य हथियार",
  T_49_META_TYP_14_I24_D: "मृत्यु पर सभी उपकरण खो जाते हैं",
  T_49_META_TYP_14_I26_D: "लक्ष्य सहायक प्रकार",
  T_49_META_TYP_14_I27_D: "सहायक द्वारा लॉक की अनुमति दें",
  T_49_META_TYP_14_I28_D: "वॉयस चैट टॉगल करें: सही वॉयस बंद करता है, गलत वॉयस चालू करता है",
  T_49_META_TYP_14_I29_D: "त्वरित चैट टॉगल करें: सही आवाज़ बंद करता है, गलत आवाज़ चालू करता है",
  T_49_META_TYP_14_I3_D: "खिलाड़ी की स्थिति",
  T_49_META_TYP_14_I30_D: "चैनल",
  T_49_META_TYP_14_I35_D: "आइटम पिकअप टॉगल करें: पिकअप अक्षम करने के लिए सत्य, पिकअप सक्षम करने के लिए असत्य",
  T_49_META_TYP_14_I36_D: "आइटम त्यागने को टॉगल करें: आइटम त्यागने से रोकने के लिए सत्य, आइटम त्यागने की अनुमति देने के लिए असत्य",
  T_49_META_TYP_14_I37_D: "आक्रमण के लिए लक्षित वस्तुएं",
  T_49_META_TYP_14_I38_D: "दोस्त खिलाड़ी",
  T_49_META_TYP_14_I39_D: "गुट",
  T_49_META_TYP_14_I4_D: "खिलाड़ी का जीवित रहने का समय। यदि खिलाड़ी मर जाता है, तो समय की पुनः गणना की जाती है।",
  T_49_META_TYP_14_I40_D: "फрак्शन में संख्या",
  T_49_META_TYP_14_I41_D: "खिलाड़ी जिस कैमरे का उपयोग कर रहा है",
  T_49_META_TYP_14_I42_D: "कस्टम गुरुत्वाकर्षण",
  T_49_META_TYP_14_I43_D: "हेलमेट",
  T_49_META_TYP_14_I44_D: "बुलेटप्रूफ वेस्ट",
  T_49_META_TYP_14_I5_D: "खिलाड़ी की अजेयता",
  T_49_META_TYP_14_I52_D: "उपयोगकर्ता यूआईडी",
  T_49_META_TYP_14_I53_D: "हेडशॉट डैमेज में कमी",
  T_49_META_TYP_14_I54_D: "खिलाड़ी-बद्ध अवतार",
  T_49_META_TYP_14_I55_D: "लिंग",
  T_49_META_TYP_14_I56_D: "हथियार की त्वचा आईडी",
  T_49_META_TYP_14_I57_D: "खिलाड़ी का स्पॉन पॉइंट",
  T_49_META_TYP_14_I58_D: "खिलाड़ी का पुनरुत्थान बिंदु। यदि कोई चेकपॉइंट रिकॉर्ड नहीं है, तो जन्म बिंदु का उपयोग किया जाता है, अन्यथा चेकपॉइंट का उपयोग किया जाता है।",
  T_49_META_TYP_14_I59_D: "खिलाड़ी की वर्तमान स्थिति",
  T_49_META_TYP_14_I6_D: "वह इकाई जिससे खिलाड़ी संबंधित है",
  T_49_META_TYP_14_I60_D: "खिलाड़ी की वर्तमान दिशा",
  T_49_META_TYP_14_I61_D: "त्वचा की हड्डियों तक पहुंचने के लिए प्रयुक्त नोड",
  T_49_META_TYP_14_I62_D: "बैकपैक",
  T_49_META_TYP_14_I63_D: "अस्थायी ढाल बिंदु",
  T_49_META_TYP_14_I64_D: "वाहन त्वचा आईडी",
  T_49_META_TYP_14_I65_D: "गिरने की एनीमेशन छोड़ें",
  T_49_META_TYP_14_I66_D: "गिरने की क्षति बंद करें",
  T_49_META_TYP_14_I67_D: "वर्तमान हाथ में वस्तु",
  T_49_META_TYP_14_I68_D: "आइटम उठाने की रोकथाम सूची",
  T_49_META_TYP_14_I69_D: "खिलाड़ी संसाधन आईडी",
  T_49_META_TYP_14_I7_D: "वर्तमान चेकपॉइंट आईडी",
  T_49_META_TYP_14_I70_D: "खरीदने का अनुरोध संदेश भेजने का लक्ष्य",
  T_49_META_TYP_14_I71_D: "वर्तमान में चलाए जा रहे इमोट संसाधन की आईडी",
  T_49_META_TYP_14_I72_D: "क्या वर्तमान में चल रहा इमोट लूपिंग है",
  T_49_META_TYP_14_I73_D: "नॉकडाउन स्थिति से निपटना",
  T_49_META_TYP_14_I74_D: "चाहे डैमेज जंप को सक्षम करना हो, डिफ़ॉल्ट रूप से यह सत्य है, जिसका अर्थ है कि यह सक्षम है",
  T_49_META_TYP_14_I76_D: "क्या मैं बीच में ही नौकरी छोड़ सकता हूँ?",
  T_49_META_TYP_14_I77_D: "पोशाक संबंधी वह जानकारी जिसे खिलाड़ी को किसी अन्य पात्र में रूपांतरित होते समय ध्यान में रखना आवश्यक होता है",
  T_49_META_TYP_14_I8_D: "वह चेकपॉइंट आईडी जिसकी ओर लक्ष्य जा रहा है",
  T_49_META_TYP_140_I0_D: "वेव 1",
  T_49_META_TYP_140_I1_D: "लहर 2",
  T_49_META_TYP_140_I2_D: "वेव 3",
  T_49_META_TYP_140_I3_D: "निरंतर",
  T_49_META_TYP_141_I0_D: "यादृच्छिक फ़ुटबॉल लूट",
  T_49_META_TYP_141_I1_D: "फ़ुटबॉल शील्ड",
  T_49_META_TYP_141_I2_D: "ठंडक ग्रेनेड",
  T_49_META_TYP_142_I0_D: "लूट सॉकर",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "एफएफ क्लासिक (शूटिंग)",
  T_49_META_TYP_147_I1_D: "तिसरा आदमी",
  T_49_META_TYP_147_I2_D: "प्रथम व्यक्ति शूटर)",
  T_49_META_TYP_147_I3_D: "शीर्ष दृश्य",
  T_49_META_TYP_147_I4_D: "क्षैतिज स्क्रॉल",
  T_49_META_TYP_147_I5_D: "कस्टम कैमरा",
  T_49_META_TYP_147_I6_D: "पीछा करना",
  T_49_META_TYP_147_I7_D: "खिलाड़ी द्वारा नियंत्रित, स्वतंत्र रूप से घूमने वाला कैमरा",
  T_49_META_TYP_147_I8_D: "नया प्रथम-व्यक्ति कैमरा",
  T_49_META_TYP_148_I0_D: "विभिन्न प्रकार के प्रीसेट कैमरा प्रकार, साथ ही कस्टम कैमरा प्रकार भी प्रदान करता है",
  T_49_META_TYP_148_I1_D: "दृश्य क्षेत्र कैमरे का देखने का कोण है",
  T_49_META_TYP_148_I10_D: "कैमरा स्विचिंग एनीमेशन का प्रकार",
  T_49_META_TYP_148_I11_D: "यह तभी प्रभावी होता है जब स्विच का प्रकार सुचारू हो। इस कैमरे पर स्विच करने का संक्रमण समय मिलीसेकंड में है।",
  T_49_META_TYP_148_I12_D: "जब कैमरे और अनुसरण की जा रही वस्तु के बीच कोई बाधा होती है, तो कैमरे का मूवमेंट मोड",
  T_49_META_TYP_148_I13_D: "कैमरा छवि कैसे प्रस्तुत करता है",
  T_49_META_TYP_148_I14_D: "ऑब्जेक्ट ऑफ़सेट संदर्भ निर्देशांक प्रणाली का पालन करें",
  T_49_META_TYP_148_I15_D: "ऑब्जेक्ट ऑफ़सेट संदर्भ निर्देशांक प्रणाली का निरीक्षण करें",
  T_49_META_TYP_148_I16_D: "कैमरे का रेंडर लेयर मास्क कैमरे के रेंडर किए गए ऑब्जेक्ट को दृश्यता स्तर के आधार पर फ़िल्टर कर सकता है",
  T_49_META_TYP_148_I17_D: "दृश्य कोण सीमा",
  T_49_META_TYP_148_I2_D: "आम तौर पर इसका मतलब खिलाड़ी की मूल स्थिति के सापेक्ष कैमरे की स्थिति के ऑफसेट से है। अलग-अलग कैमरा प्रकारों के लिए इसका विशिष्ट अर्थ अलग-अलग होता है।",
  T_49_META_TYP_148_I3_D: "आम तौर पर इसका मतलब खिलाड़ी की मूल स्थिति के सापेक्ष कैमरे के फ़ोकस बिंदु के ऑफ़सेट से है। अलग-अलग कैमरा प्रकारों के लिए इसका विशिष्ट अर्थ अलग-अलग होता है।",
  T_49_META_TYP_148_I4_D: "कैमरे का ऊर्ध्वाधर घूर्णन कोण",
  T_49_META_TYP_148_I5_D: "कैमरे का क्षैतिज घूर्णन कोण",
  T_49_META_TYP_148_I7_D: "वह लक्ष्य जिसका कैमरा अनुसरण करता है",
  T_49_META_TYP_148_I8_D: "कैमरा क्या देख रहा है",
  T_49_META_TYP_148_I9_D: "वर्तमान में कैमरा का उपयोग करने वाला खिलाड़ी",
  T_49_META_TYP_15_I0_D: "क्या टीम के सभी सदस्य वर्तमान में मर चुके हैं",
  T_49_META_TYP_15_I1_D: "सभी टीम सदस्यों की सूची",
  T_49_META_TYP_15_I3_D: "दुश्मन टीमों की सूची",
  T_49_META_TYP_15_I4_D: "मैत्रीपूर्ण टीम सूची",
  T_49_META_TYP_15_I5_D: "टीम नं.",
  T_49_META_TYP_150_I0_D: "स्थिरता",
  T_49_META_TYP_150_I1_D: "कैप्सूल के दोनों सिरों पर गोलार्धों की त्रिज्या",
  T_49_META_TYP_150_I2_D: "क्षति गुणक",
  T_49_META_TYP_152_I1_D: "कस्टम गुरुत्वाकर्षण",
  T_49_META_TYP_152_I2_D: "ट्रिगर प्रदर्शित करना है या नहीं, सत्य का अर्थ है प्रदर्शित करना",
  T_49_META_TYP_154_I0_D: "दोहरा हथियार नहीं चलाया जा सकता",
  T_49_META_TYP_154_I1_D: "केवल एक ही प्रकार की बंदूक से ही दोहरे हथियार का इस्तेमाल किया जा सकता है",
  T_49_META_TYP_154_I2_D: "इसे किसी अन्य हथियार से या स्वयं से भी इस्तेमाल किया जा सकता है",
  T_49_META_TYP_155_I0_D: "श्रेणी",
  T_49_META_TYP_155_I1_D: "अधिकतम टिकाऊपन",
  T_49_META_TYP_155_I2_D: "वर्तमान टिकाऊपन",
  T_49_META_TYP_155_I3_D: "क्षति में कमी कारक",
  T_49_META_TYP_155_I4_D: "विस्फोट क्षति कमी कारक",
  T_49_META_TYP_155_I5_D: "ड्यूरेबिलिटी की लागत हो सकती है",
  T_49_META_TYP_155_I6_D: "नष्ट किया जा सकता है",
  T_49_META_TYP_156_I1_D: "अधिकतम टिकाऊपन",
  T_49_META_TYP_156_I2_D: "वर्तमान टिकाऊपन",
  T_49_META_TYP_156_I3_D: "क्षति में कमी कारक",
  T_49_META_TYP_156_I4_D: "विस्फोट क्षति कमी कारक",
  T_49_META_TYP_156_I5_D: "ड्यूरेबिलिटी की लागत हो सकती है",
  T_49_META_TYP_156_I6_D: "नष्ट किया जा सकता है",
  T_49_META_TYP_157_I0_D: "कोई एनीमेशन नहीं",
  T_49_META_TYP_157_I1_D: "स्मूथ",
  T_49_META_TYP_158_I2_D: "UI एंकर प्रकार गणना, डिफ़ॉल्ट मान 9 (केंद्र) है",
  T_49_META_TYP_158_I6_D: "लेबल कुंजी",
  T_49_META_TYP_158_I7_D: "लेबल पैरामीटर",
  T_49_META_TYP_158_I8_D: "बाएं टीम",
  T_49_META_TYP_16_I1_D: "इकाई से संबंधित आइटम आईडी",
  T_49_META_TYP_16_I2_D: "केवल तब उपयोग किया जाता है जब ऑब्जेक्ट को स्थिर रूप से लोड किया जाता है ताकि यह निर्धारित किया जा सके कि NavMesh स्थिर रूप से उत्पन्न हुआ है या नहीं",
  T_49_META_TYP_16_I3_D: "क्या यह NavMesh का गतिशील अवरोधन है",
  T_49_META_TYP_16_I4_D: "अतुल्यकालिक लोडिंग",
  T_49_META_TYP_160_I0_D: "ईंट A",
  T_49_META_TYP_160_I1_D: "टाइल A",
  T_49_META_TYP_160_I10_D: "बालू A",
  T_49_META_TYP_160_I11_D: "बर्फ A",
  T_49_META_TYP_160_I12_D: "लकड़ी A",
  T_49_META_TYP_160_I13_D: "पत्थर A",
  T_49_META_TYP_160_I14_D: "लॉन B",
  T_49_META_TYP_160_I15_D: "ईंट B",
  T_49_META_TYP_160_I16_D: "ईंट C",
  T_49_META_TYP_160_I17_D: "साफ",
  T_49_META_TYP_160_I2_D: "टाइल B",
  T_49_META_TYP_160_I3_D: "टाइल C",
  T_49_META_TYP_160_I4_D: "बांस A",
  T_49_META_TYP_160_I5_D: "सीमेंट A",
  T_49_META_TYP_160_I6_D: "कंटेनर A",
  T_49_META_TYP_160_I7_D: "लॉन A",
  T_49_META_TYP_160_I8_D: "बर्फ A",
  T_49_META_TYP_160_I9_D: "मैग्मा A",
  T_49_META_TYP_165_I0_D: "टकराव को सक्षम करना है या नहीं",
  T_49_META_TYP_165_I1_D: "ट्रिगर के रूप में कार्य करना है या नहीं",
  T_49_META_TYP_165_I2_D: "भौतिक स्तर, भौतिक मॉड्यूल में स्तर को कॉन्फ़िगर करें, 16 तक",
  T_49_META_TYP_166_I0_D: "इमोट1",
  T_49_META_TYP_166_I1_D: "इमोट2",
  T_49_META_TYP_166_I2_D: "इमोट3",
  T_49_META_TYP_166_I3_D: "इमोट4",
  T_49_META_TYP_166_I4_D: "इमोट5",
  T_49_META_TYP_167_I0_D: "VFX टेक्सचर प्रकार",
  T_49_META_TYP_170_I0_D: "क्या यह दिखाई देता है? यदि यह दिखाई नहीं देता है, तो क्लाइंट लक्ष्य को रेंडर करना बंद कर देता है।",
  T_49_META_TYP_170_I1_D: "दृश्य स्तर, मान सीमा [0,15], कैमरे में दृश्यता को प्रभावित करता है",
  T_49_META_TYP_171_I0_D: "ऊर्जा",
  T_49_META_TYP_172_I0_D: "गोलियों की संख्या",
  T_49_META_TYP_173_I0_D: "अतिरिक्त बैकपैक क्षमता",
  T_49_META_TYP_173_I1_D: "खेल के बाहर खिलाड़ियों की त्वचा विन्यास को प्राथमिकता दी जाती है",
  T_49_META_TYP_173_I2_D: "बैकपैक स्किन आईडी, बैकपैक स्किन कॉन्फ़िगरेशन",
  T_49_META_TYP_174_I2_D: "अधिकतम नुकसान",
  T_49_META_TYP_174_I4_D: "फेंकने की गति",
  T_49_META_TYP_174_I5_D: "विस्फोट में देरी, सेकंड में",
  T_49_META_TYP_174_I6_D: "स्वयं नुकसान अनुपात",
  T_49_META_TYP_174_I7_D: "टीम के साथी नुकसान अनुपात",
  T_49_META_TYP_174_I8_D: "वाहन नुकसान अनुपात",
  T_49_META_TYP_174_I9_D: "त्वचा",
  T_49_META_TYP_175_I0_D: "जमी हुई क्षेत्र त्रिज्या",
  T_49_META_TYP_175_I1_D: "जमे हुए क्षेत्र की अवधि, सेकंड में",
  T_49_META_TYP_176_I0_D: "हथियार का मुख्य प्रकार",
  T_49_META_TYP_176_I1_D: "हथियार उप-प्रकार",
  T_49_META_TYP_177_I0_D: "जब कैमरे और अनुसरण की जा रही वस्तु के बीच कोई बाधा आती है, तो कैमरा कोई परिवर्तन नहीं करता है।",
  T_49_META_TYP_177_I1_D: "जब कैमरे और पीछा की जा रही वस्तु के बीच कोई बाधा आती है, तो कैमरा पीछा की जा रही वस्तु के करीब चला जाएगा।",
  T_49_META_TYP_177_I2_D: "जब कैमरे और अनुवर्ती वस्तु के बीच कोई अवरोधक होता है, तो अवरोधक अर्ध-पारदर्शी हो जाता है",
  T_49_META_TYP_178_I0_D: "जब कैमरा किसी वस्तु का निरीक्षण करता है, तो नजदीक की वस्तुएं बड़ी दिखाई देती हैं तथा दूर की वस्तुएं छोटी दिखाई देती हैं।",
  T_49_META_TYP_178_I1_D: "जब कैमरा किसी वस्तु का निरीक्षण करता है, तो निकट और दूर की वस्तुएं एक ही आकार की होती हैं",
  T_49_META_TYP_184_I0_D: "प्रस्तुत किये जाने वाले संसाधन का UUID निर्दिष्ट करें.",
  T_49_META_TYP_185_I0_D: "उपयोग करने के लिए मॉडल मेश को रेंडर करें",
  T_49_META_TYP_185_I1_D: "रेंडरिंग के लिए उपयोग की जाने वाली सामग्रियों की सूची",
  T_49_META_TYP_187_I0_D: "आइटम ID",
  T_49_META_TYP_190_I0_D: "खुला राज्य",
  T_49_META_TYP_190_I1_D: "खेल परिणाम",
  T_49_META_TYP_190_I10_D: "स्कोर 1",
  T_49_META_TYP_190_I11_D: "स्कोर 2",
  T_49_META_TYP_190_I12_D: "स्कोर 3",
  T_49_META_TYP_190_I13_D: "जीत MVP",
  T_49_META_TYP_190_I14_D: "हार MVP",
  T_49_META_TYP_190_I15_D: "मैच विवरण दिखाएँ",
  T_49_META_TYP_190_I16_D: "मानचित्र मूल्यांकन दिखाएँ",
  T_49_META_TYP_190_I17_D: "उपहार दिखाएँ",
  T_49_META_TYP_190_I18_D: "रिपोर्ट दिखाएँ",
  T_49_META_TYP_190_I19_D: "पुनरावृत्ति दिखाएँ",
  T_49_META_TYP_190_I20_D: "साझा करें दिखाएँ",
  T_49_META_TYP_190_I21_D: "लॉबी दिखाएँ",
  T_49_META_TYP_190_I22_D: "लाइक दिखाएँ",
  T_49_META_TYP_190_I23_D: "दोस्त जोड़ें दिखाएँ",
  T_49_META_TYP_190_I24_D: "बाहरी अर्थव्यवस्था दिखाएँ",
  T_49_META_TYP_190_I4_D: "दायां टीम",
  T_49_META_TYP_190_I5_D: "शीर्षक",
  T_49_META_TYP_190_I6_D: "खिलाड़ी रैंक",
  T_49_META_TYP_190_I9_D: "शीर्षक",
  T_49_META_TYP_191_I0_D: "केंद्रीय दायरा",
  T_49_META_TYP_191_I4_D: "केंद्र फ़्लैश समय, मिलीसेकंड में",
  T_49_META_TYP_191_I5_D: "एज फ्लैश समय, मिलीसेकंड में",
  T_49_META_TYP_191_I6_D: "प्रभाव की अवधि",
  T_49_META_TYP_192_I3_D: "विशेष प्रभाव की अवधि, सेकंड में",
  T_49_META_TYP_193_I1_D: "मैच शीर्षक बायां",
  T_49_META_TYP_193_I10_D: "स्कोर 1",
  T_49_META_TYP_193_I11_D: "स्कोर 2",
  T_49_META_TYP_193_I12_D: "स्कोर 3",
  T_49_META_TYP_193_I13_D: "स्कोर 4",
  T_49_META_TYP_193_I14_D: "स्कोर 5",
  T_49_META_TYP_193_I15_D: "जीत MVP",
  T_49_META_TYP_193_I16_D: "हार MVP",
  T_49_META_TYP_193_I17_D: "मैच विवरण दिखाएँ",
  T_49_META_TYP_193_I18_D: "मानचित्र मूल्यांकन दिखाएँ",
  T_49_META_TYP_193_I19_D: "उपहार दिखाएँ",
  T_49_META_TYP_193_I2_D: "मैच शीर्षक दायाँ",
  T_49_META_TYP_193_I20_D: "रिपोर्ट दिखाएँ",
  T_49_META_TYP_193_I21_D: "पुनरावृत्ति दिखाएँ",
  T_49_META_TYP_193_I22_D: "साझा करें दिखाएँ",
  T_49_META_TYP_193_I23_D: "लॉबी दिखाएँ",
  T_49_META_TYP_193_I24_D: "लाइक दिखाएँ",
  T_49_META_TYP_193_I25_D: "दोस्त जोड़ें दिखाएँ",
  T_49_META_TYP_193_I26_D: "बाहरी अर्थव्यवस्था दिखाएँ",
  T_49_META_TYP_193_I3_D: "खेल परिणाम",
  T_49_META_TYP_193_I4_D: "टीम रैंक",
  T_49_META_TYP_193_I5_D: "खिलाड़ी रैंक",
  T_49_META_TYP_193_I6_D: "टीम रैंकिंग",
  T_49_META_TYP_193_I7_D: "मुख्य स्कोर शीर्षक",
  T_49_META_TYP_193_I8_D: "मुख्य स्कोर",
  T_49_META_TYP_193_I9_D: "शीर्षक",
  T_49_META_TYP_194_I0_D: "खदान के प्रभावी होने का समय (सेकंड में)",
  T_49_META_TYP_194_I1_D: "ट्रिगर त्रिज्या",
  T_49_META_TYP_194_I2_D: "खदान की सीमा के भीतर खदान को सक्रिय करने में लगने वाला समय, सेकंड में",
  T_49_META_TYP_194_I3_D: "स्वयं ट्रिगर कर सकता है",
  T_49_META_TYP_194_I4_D: "टीम द्वारा ट्रिगर किया जा सकता है",
  T_49_META_TYP_194_I5_D: "वाहन द्वारा ट्रिगर किया जा सकता है",
  T_49_META_TYP_194_I6_D: "खदान का अस्तित्व समय, जो खत्म होने के बाद अपने आप फट जाएगा। समय उस समय से शुरू होता है जब खदान रखी जाती है, सेकंड में",
  T_49_META_TYP_194_I7_D: "आक्रमणशील",
  T_49_META_TYP_194_I8_D: "स्वास्थ्य",
  T_49_META_TYP_195_I0_D: "एक बार",
  T_49_META_TYP_195_I2_D: "रेसिप्रोकेटिंग",
  T_49_META_TYP_197_I0_D: "क्या यह खेल रहा है?",
  T_49_META_TYP_197_I1_D: "मार्क बिट",
  T_49_META_TYP_197_I2_D: "बनाते समय स्वचालित रूप से चलाने के लिए जाँच करें",
  T_49_META_TYP_198_I0_D: "अनुलग्नक से संबंधित प्रॉप आईडी",
  T_49_META_TYP_199_I0_D: "अधिकतम ऊर्जा",
  T_49_META_TYP_199_I1_D: "ऊर्जा लागत",
  T_49_META_TYP_199_I10_D: "गिरने की क्षति अनुपात",
  T_49_META_TYP_199_I11_D: "वर्तमान ऊर्जा",
  T_49_META_TYP_199_I2_D: "ऊपर ऊर्जा लागत",
  T_49_META_TYP_199_I3_D: "स्प्रिंट ऊर्जा लागत",
  T_49_META_TYP_199_I4_D: "रश ऊर्जा लागत",
  T_49_META_TYP_199_I5_D: "आधार क्षैतिज गति",
  T_49_META_TYP_199_I6_D: "स्प्रिंट क्षैतिज गति",
  T_49_META_TYP_199_I7_D: "आधार ऊर्ध्वाधर गति",
  T_49_META_TYP_199_I8_D: "स्प्रिंट ऊर्ध्वाधर गति",
  T_49_META_TYP_199_I9_D: "रश की दूरी",
  T_49_META_TYP_200_I0_D: "क्षेत्र आईडी",
  T_49_META_TYP_200_I1_D: "गेम आईडी",
  T_49_META_TYP_201_I0_D: "धीमापन प्रतिशत: खुले पानी में जलीय वस्तुओं की गति का प्रतिशत धीमा हो जाता है",
  T_49_META_TYP_203_I0_D: "लक्ष्य इकाई",
  T_49_META_TYP_203_I1_D: "गुण ID",
  T_49_META_TYP_203_I10_D: "वह समय जब गेम सर्वर टिक-टिक करना शुरू करता है",
  T_49_META_TYP_203_I11_D: "प्रारंभिक मान",
  T_49_META_TYP_203_I12_D: "अंतिम मान",
  T_49_META_TYP_203_I13_D: "उत्तीर्ण प्रतिशत",
  T_49_META_TYP_203_I4_D: "ट्वीन स्टाइल",
  T_49_META_TYP_203_I6_D: "अवधि",
  T_49_META_TYP_203_I7_D: "उलटा",
  T_49_META_TYP_203_I8_D: "नियंत्रण केंद्र",
  T_49_META_TYP_203_I9_D: "गेम सर्वर स्थिति को बलपूर्वक सिंक करें",
  T_49_META_TYP_204_I0_D: "अधिकतम कूद की ऊँचाई",
  T_49_META_TYP_204_I1_D: "गिरने से होने वाली क्षति का प्रतिशत",
  T_49_META_TYP_204_I2_D: "ऊर्जा पुनर्प्राप्ति",
  T_49_META_TYP_204_I3_D: "ऊर्जा का उपभोग करें",
  T_49_META_TYP_204_I4_D: "अधिकतम ऊर्जा",
  T_49_META_TYP_205_I0_D: "न्यूनतम उड़ान ऊँचाई",
  T_49_META_TYP_205_I1_D: "न्यूनतम समाप्ति ऊँचाई",
  T_49_META_TYP_205_I2_D: "क्षैतिज उड़ान गति",
  T_49_META_TYP_205_I3_D: "ऊर्ध्वाधर उड़ान गति",
  T_49_META_TYP_205_I4_D: "गिरने की गति",
  T_49_META_TYP_205_I5_D: "मोड़ की गति",
  T_49_META_TYP_205_I6_D: "अधिकतम उडान ऊँचाई",
  T_49_META_TYP_205_I7_D: "ऊंचाई को पार करने के बाद गिरने की गति",
  T_49_META_TYP_205_I8_D: "परिवर्तनीय गति त्वरण",
  T_49_META_TYP_206_I0_D: "वेग",
  T_49_META_TYP_206_I1_D: "त्वरण",
  T_49_META_TYP_206_I10_D: "उच्च गति पर, अधिकतम स्टीयरिंग कोण",
  T_49_META_TYP_206_I11_D: "हाई-स्पीड स्टीयरिंग कोण इंटरपोलेशन बेस दर",
  T_49_META_TYP_206_I2_D: "बूस्ट की गति",
  T_49_META_TYP_206_I3_D: "स्प्रिंट अवधि (सेकंड में)",
  T_49_META_TYP_206_I4_D: "स्प्रिंट कूलडाउन समय, सेकंड में",
  T_49_META_TYP_206_I6_D: "कुछ सेकंड में जम्प सीडी",
  T_49_META_TYP_206_I7_D: "स्केटबोर्ड पर चढ़ने के बाद स्प्रिंट सीडी, इकाई: सेकंड",
  T_49_META_TYP_206_I8_D: "बूस्ट पर चढ़ने का कूलडाउन स्विच",
  T_49_META_TYP_206_I9_D: "स्केटबोर्ड पर फिसलने की सी.डी., कुछ सेकंड में",
  T_49_META_TYP_207_I1_D: "प्रारंभ सूचकांक",
  T_49_META_TYP_207_I2_D: "अंत स्थिति",
  T_49_META_TYP_207_I3_D: "ज़िपलाइन आईडी",
  T_49_META_TYP_207_I4_D: "समूह आईडी",
  T_49_META_TYP_207_I5_D: "क्या यह ख़त्म हो गया?",
  T_49_META_TYP_21_I0_D: "यूआई का बुनियादी स्तर",
  T_49_META_TYP_210_I1_D: "प्रारंभिक वेग",
  T_49_META_TYP_210_I2_D: "त्वरण",
  T_49_META_TYP_210_I3_D: "अधिकतम विस्थापन",
  T_49_META_TYP_210_I4_D: "प्रारंभिक विश्व स्थिति",
  T_49_META_TYP_210_I5_D: "गेम सर्वर ने स्थान की जानकारी का जबरन सिंक्रनाइज़ेशन किया",
  T_49_META_TYP_211_I0_D: "स्थानीय स्थिति",
  T_49_META_TYP_211_I1_D: "विश्व स्थिति",
  T_49_META_TYP_212_I0_D: "स्वयं",
  T_49_META_TYP_212_I2_D: "ऑफसेट निर्देशांक",
  T_49_META_TYP_213_I0_D: "स्वयं",
  T_49_META_TYP_213_I2_D: "ऑफसेट निर्देशांक",
  T_49_META_TYP_215_I0_D: "विजय",
  T_49_META_TYP_215_I1_D: "हार",
  T_49_META_TYP_215_I2_D: "बूयाह",
  T_49_META_TYP_215_I3_D: "ड्रॉ",
  T_49_META_TYP_218_I0_D: "तीव्रता",
  T_49_META_TYP_218_I1_D: "सीमा",
  T_49_META_TYP_218_I2_D: "हल्के रंग",
  T_49_META_TYP_22_I0_D: "यदि खुली स्थिति सत्य है, तो इसे प्रदर्शित किया जाएगा, अन्यथा इसे बंद कर दिया जाएगा।",
  T_49_META_TYP_22_I1_D: "प्रीफ़ेब आईडी",
  T_49_META_TYP_22_I2_D: "वर्तमान अधिकतम नियंत्रण आईडी",
  T_49_META_TYP_22_I3_D: "यूआई का बुनियादी स्तर",
  T_49_META_TYP_22_I4_D: "प्लेयर व्यू सक्षम करें",
  T_49_META_TYP_22_I5_D: "विश्व स्थिति",
  T_49_META_TYP_22_I6_D: "क्या यह दृश्य में है?",
  T_49_META_TYP_22_I7_D: "विश्व निर्देशांक में घूर्णन",
  T_49_META_TYP_22_I8_D: "विश्व निर्देशांक में स्केलिंग",
  T_49_META_TYP_221_I0_D: "गियर शिफ्ट विलंब, मान जितना बड़ा होगा, गियर परिवर्तन की गति उतनी ही धीमी होगी",
  T_49_META_TYP_222_I0_D: "गियर शिफ्ट विलंब, मान जितना बड़ा होगा, गियर परिवर्तन की गति उतनी ही धीमी होगी",
  T_49_META_TYP_225_I0_D: "बुर्ज क्षति",
  T_49_META_TYP_225_I1_D: "क्षति अंतराल (सेकंड)",
  T_49_META_TYP_225_I10_D: "कोण के भीतर आग",
  T_49_META_TYP_225_I11_D: "क्षति न्यूनीकरण दर",
  T_49_META_TYP_225_I12_D: "कवच प्रवेश",
  T_49_META_TYP_225_I2_D: "सटीकता",
  T_49_META_TYP_225_I3_D: "सीमा",
  T_49_META_TYP_225_I4_D: "कोणीय गति",
  T_49_META_TYP_225_I5_D: "ऊपर कोण",
  T_49_META_TYP_225_I6_D: "नीचे कोण",
  T_49_META_TYP_225_I7_D: "अधिकतम HP",
  T_49_META_TYP_225_I8_D: "जीवन काल (सेकंड)",
  T_49_META_TYP_225_I9_D: "अधिकतम टॉरट संख्या",
  T_49_META_TYP_226_I0_D: "बुर्ज का वर्तमान स्वास्थ्य",
  T_49_META_TYP_226_I1_D: "हमले को सक्षम करें",
  T_49_META_TYP_227_I0_D: "सिंपल विजेट",
  T_49_META_TYP_227_I1_D: "छवि विजेट",
  T_49_META_TYP_227_I10_D: "टेक्सचर विजेट",
  T_49_META_TYP_227_I11_D: "प्रोफ़ाइल विजेट",
  T_49_META_TYP_227_I12_D: "टॉगल विजेट",
  T_49_META_TYP_227_I13_D: "टच पैड विजेट",
  T_49_META_TYP_227_I14_D: "जोयस्टिक विजेट",
  T_49_META_TYP_227_I15_D: "सोशल बटन",
  T_49_META_TYP_227_I2_D: "लेबल विजेट",
  T_49_META_TYP_227_I3_D: "बटन विजेट",
  T_49_META_TYP_227_I4_D: "इनपुट लेबल विजेट",
  T_49_META_TYP_227_I5_D: "पैनल",
  T_49_META_TYP_227_I6_D: "स्क्रॉल पैनल",
  T_49_META_TYP_227_I7_D: "ग्रिड",
  T_49_META_TYP_227_I8_D: "लेआउट विजेट",
  T_49_META_TYP_227_I9_D: "कंटेनर विजेट",
  T_49_META_TYP_231_I0_D: "स्थायीत्व रिकवरी",
  T_49_META_TYP_231_I1_D: "प्रभावी होने में लगने वाला समय अंतराल, सेकंड में",
  T_49_META_TYP_233_I2_D: "टाइमिंग का अंतिम समय, सेकंड में",
  T_49_META_TYP_233_I4_D: "आइकन संसाधन नाम",
  T_49_META_TYP_234_I0_D: "ट्रिगर समय, सेकंड में",
  T_49_META_TYP_234_I1_D: "स्वयं ट्रिगर कर सकता है",
  T_49_META_TYP_234_I10_D: "वर्तमान स्वास्थ्य",
  T_49_META_TYP_234_I2_D: "टीम द्वारा ट्रिगर किया जा सकता है",
  T_49_META_TYP_234_I3_D: "वाहन द्वारा ट्रिगर किया जा सकता है",
  T_49_META_TYP_234_I4_D: "अवधि, सेकंड में",
  T_49_META_TYP_234_I5_D: "आक्रमणशील",
  T_49_META_TYP_234_I6_D: "स्वास्थ्य",
  T_49_META_TYP_235_I0_D: "अधिकतम स्वास्थ्य",
  T_49_META_TYP_235_I2_D: "अधिकतम संख्या",
  T_49_META_TYP_237_I0_D: "फेंकने की गति",
  T_49_META_TYP_237_I1_D: "खिलाड़ी खींचने की गति",
  T_49_META_TYP_238_I0_D: "स्प्रे रंग",
  T_49_META_TYP_239_I0_D: "प्रारंभिक गति",
  T_49_META_TYP_239_I1_D: "त्वरण (जैसे गुरुत्वाकर्षण)",
  T_49_META_TYP_24_I0_D: "हाथापाई",
  T_49_META_TYP_24_I1_D: "बंदूक",
  T_49_META_TYP_24_I10_D: "एयरड्रॉप क्षति, राक्षस आत्महत्या क्षति",
  T_49_META_TYP_24_I11_D: "वाहन विस्फोट पर जलने वाला नुकसान",
  T_49_META_TYP_24_I12_D: "तेल ड्रम विस्फोट",
  T_49_META_TYP_24_I13_D: "मिसाइल-प्रकार का हथियार",
  T_49_META_TYP_24_I14_D: "राक्षस",
  T_49_META_TYP_24_I15_D: "नुकसान का क्षेत्र",
  T_49_META_TYP_24_I17_D: "चरित्र कौशल",
  T_49_META_TYP_24_I2_D: "ग्रेनेड फेंको",
  T_49_META_TYP_24_I3_D: "सुरक्षित क्षेत्र",
  T_49_META_TYP_24_I4_D: "वाहन",
  T_49_META_TYP_24_I5_D: "गिरना",
  T_49_META_TYP_24_I6_D: "मौत का क्षेत्र",
  T_49_META_TYP_24_I7_D: "बाहर निकलना",
  T_49_META_TYP_24_I8_D: "डिस्कनेक्ट",
  T_49_META_TYP_24_I9_D: "वाहन विस्फोट",
  T_49_META_TYP_241_I0_D: "कर्षण गति",
  T_49_META_TYP_241_I1_D: "स्विंग गति",
  T_49_META_TYP_241_I2_D: "ट्रैक्शन बटन चालू करें",
  T_49_META_TYP_241_I3_D: "स्विंग बटन चालू करें",
  T_49_META_TYP_241_I4_D: "मोशन एंकर",
  T_49_META_TYP_241_I5_D: "झूल से बाहर निकलने की त्वरण",
  T_49_META_TYP_242_I2_D: "बाएं प्रभाव सक्रिय",
  T_49_META_TYP_242_I3_D: "दाएं प्रभाव सक्रिय",
  T_49_META_TYP_242_I4_D: "केंद्रीय रेखा सक्रिय",
  T_49_META_TYP_242_I5_D: "मान",
  T_49_META_TYP_242_I7_D: "UI स्थिति, केवल XY घटक ही मान्य हैं",
  T_49_META_TYP_242_I8_D: "मध्य रेखा स्थिति [0,1]",
  T_49_META_TYP_243_I0_D: "ऊपरी कपड़े",
  T_49_META_TYP_243_I1_D: "निचले कपड़े",
  T_49_META_TYP_243_I2_D: "जूते",
  T_49_META_TYP_243_I3_D: "चेहरे की पेंटिंग",
  T_49_META_TYP_243_I4_D: "हेडवियर",
  T_49_META_TYP_243_I5_D: "बॉडीसूट",
  T_49_META_TYP_243_I6_D: "चेहरे की सजावट",
  T_49_META_TYP_244_I0_D: "प्रदर्शित किया जाने वाला पाठ",
  T_49_META_TYP_244_I10_D: "उन खिलाड़ियों की सूची जो इस इकाई को देख सकते हैं",
  T_49_META_TYP_244_I11_D: "प्रदर्शन पदानुक्रम",
  T_49_META_TYP_244_I2_D: "लक्ष्य का पालन करें",
  T_49_META_TYP_244_I3_D: "जब गहराई को नजरअंदाज किया जाता है, तो इसे दीवार के माध्यम से प्रदर्शित किया जा सकता है, अन्यथा इसे प्रदर्शित नहीं किया जा सकता",
  T_49_META_TYP_244_I4_D: "हमेशा वीडियो में",
  T_49_META_TYP_244_I5_D: "जब इसे सत्य पर सेट किया जाता है, तो स्थिति स्क्रीन पर तब प्रदर्शित होगी जब वह स्क्रीन के बाहर होगी",
  T_49_META_TYP_244_I6_D: "फ़ॉन्ट शैली",
  T_49_META_TYP_244_I7_D: "फ़ॉन्ट प्रकार",
  T_49_META_TYP_244_I8_D: "फ़ॉन्ट आकार",
  T_49_META_TYP_245_I0_D: "प्रभाव संसाधन पथ",
  T_49_META_TYP_245_I11_D: "प्रदर्शन पदानुक्रम",
  T_49_META_TYP_245_I3_D: "जब गहराई को नजरअंदाज किया जाता है, तो इसे दीवार के माध्यम से प्रदर्शित किया जा सकता है, अन्यथा इसे प्रदर्शित नहीं किया जा सकता",
  T_49_META_TYP_245_I4_D: "जब इसे सत्य पर सेट किया जाता है, तो स्थिति स्क्रीन पर तब प्रदर्शित होगी जब वह स्क्रीन के बाहर होगी",
  T_49_META_TYP_245_I5_D: "हमेशा वीडियो में",
  T_49_META_TYP_245_I6_D: "रेंडर प्रकार",
  T_49_META_TYP_245_I7_D: "चौड़ाई",
  T_49_META_TYP_246_I0_D: "संतरा",
  T_49_META_TYP_246_I1_D: "बैंगनी",
  T_49_META_TYP_246_I2_D: "लाल",
  T_49_META_TYP_246_I3_D: "हरा",
  T_49_META_TYP_246_I4_D: "नीला",
  T_49_META_TYP_247_I1_D: "पूरे वेग से दौड़ना",
  T_49_META_TYP_247_I14_D: "भाव-भंगिमा",
  T_49_META_TYP_247_I15_D: "त्वरित चैट",
  T_49_META_TYP_247_I16_D: "वस्त्र उठाना",
  T_49_META_TYP_247_I17_D: "त्वरित चैट दिखाएं",
  T_49_META_TYP_247_I18_D: "एचपी (स्वास्थ्य)",
  T_49_META_TYP_247_I19_D: "ईपी (ऊर्जा)",
  T_49_META_TYP_247_I2_D: "हमला",
  T_49_META_TYP_247_I20_D: "कवच",
  T_49_META_TYP_247_I21_D: "पुनः लोड करें",
  T_49_META_TYP_247_I22_D: "त्वरित बंदूक परिवर्तन बटन",
  T_49_META_TYP_247_I23_D: "वाहन हॉर्न बटन को चालू/बंद किया जा सकता है",
  T_49_META_TYP_247_I24_D: "चालू/बंद करने के लिए वॉयस (माइक्रोफ़ोन) बटन",
  T_49_META_TYP_247_I25_D: "मार्क बटन को चालू/बंद करें",
  T_49_META_TYP_247_I27_D: "नेटवर्क सिग्नल बटन को चालू/बंद किया जा सकता है",
  T_49_META_TYP_247_I28_D: "सक्रिय कौशल",
  T_49_META_TYP_247_I29_D: "क्रॉसहेयर",
  T_49_META_TYP_247_I3_D: "कूदना",
  T_49_META_TYP_247_I30_D: "निष्क्रिय कौशल",
  T_49_META_TYP_247_I4_D: "हत्या के सुझाव",
  T_49_META_TYP_247_I5_D: "हथियार स्लॉट",
  T_49_META_TYP_247_I6_D: "मिनी मैप",
  T_49_META_TYP_247_I7_D: "बैकपैक यूआई",
  T_49_META_TYP_247_I8_D: "चिकित्सा सामग्री",
  T_49_META_TYP_247_I9_D: "यदि सत्य है तो इसे प्रदर्शित किया जाएगा, अन्यथा इसे बंद कर दिया जाएगा।",
  T_49_META_TYP_249_I3_D: "विस्फोटक हथियार",
  T_49_META_TYP_249_I5_D: "भारी हथियार",
  T_49_META_TYP_249_I8_D: "बर्फ़ीली बम",
  T_49_META_TYP_249_I9_D: "नकली ग्रेनेड",
  T_49_META_TYP_25_I0_D: "वर्तमान चरण का सूचकांक, प्रक्रिया संपादक में सूचकांक के अनुरूप",
  T_49_META_TYP_25_I1_D: "वर्तमान चरण का प्रारंभ समय, मि.से. में",
  T_49_META_TYP_25_I2_D: "वर्तमान चरण का अंतिम समय, मि.से. में",
  T_49_META_TYP_25_I3_D: "वर्तमान चरण की अवधि, एमएस में",
  T_49_META_TYP_250_I1_D: "विशेष प्रभाव रंग, RGBA चार चैनल, एकल चैनल मान सीमा 0~255, Int32 में संग्रहीत",
  T_49_META_TYP_250_I3_D: "VFX टेक्सचर प्रकार",
  T_49_META_TYP_250_I4_D: "डिफ्यूज़ अल्फा",
  T_49_META_TYP_2500_I1_D: "डिफ़ॉल्ट स्पॉन बिंदु है या नहीं",
  T_49_META_TYP_2500_I3_D: "क्या इस स्पॉन क्षेत्र में पहले से ही कोई खिलाड़ी पैदा हुआ है?",
  T_49_META_TYP_2500_I4_D: "वर्तमान में निर्दिष्ट जन्म बिंदु के निर्देशांक",
  T_49_META_TYP_2502_I0_D: "चाहे वह मृत्यु ट्रिगर हो, यदि वह मृत्यु ट्रिगर नहीं है, तो वह अजेयता ट्रिगर है। (यह OB32 से विरासत में मिली समस्या है, कृपया भविष्य में कार्यक्षमता को विभाजित करें!)",
  T_49_META_TYP_2502_I1_D: "ट्रिगर बॉर्डर प्रदर्शित करना है या नहीं, सत्य का अर्थ है प्रदर्शित करना",
  T_49_META_TYP_2503_I0_D: "चेकपॉइंट आईडी",
  T_49_META_TYP_2503_I2_D: "चेकपॉइंट स्थान",
  T_49_META_TYP_2507_I0_D: "डिफेंस टावर किस कैंप से संबंधित है? अगर यह खिलाड़ी के कैंप से संबंधित है, तो यह खिलाड़ी पर हमला नहीं करेगा।",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "ऑब्जेक्ट आईडी",
  T_49_META_TYP_2507_I2_D: "अधिकतम HP",
  T_49_META_TYP_2507_I3_D: "आक्रमण क्षति, एक एकल आक्रमण से खिलाड़ी को होने वाली क्षति",
  T_49_META_TYP_2507_I4_D: "दो हमलों के बीच का अंतराल, सेकंड में",
  T_49_META_TYP_2507_I5_D: "केंद्र को केंद्र मानकर किसी भी आकार की त्रिज्या वाले क्षेत्र पर हमला किया जा सकता है",
  T_49_META_TYP_2507_I6_D: "क्षति न्यूनीकरण दर, 1 से कम दशमलव। अंतिम क्षति (1-क्षति न्यूनीकरण दर) से गुणा की गई क्षति है",
  T_49_META_TYP_2507_I7_D: "हमला लक्ष्य",
  T_49_META_TYP_2507_I8_D: "कोण",
  T_49_META_TYP_2507_I9_D: "मिनी सेंट्री की स्थिति",
  T_49_META_TYP_2508_I0_D: "प्रत्येक लहर में पैदा होने वाले ज़ॉम्बी की संख्या",
  T_49_META_TYP_2508_I1_D: "ज़ोंबी की कितनी लहरें उत्पन्न होंगी?",
  T_49_META_TYP_2508_I2_D: "चाहे लगातार जनरेट करना हो, लेकिन एक ही स्क्रीन पर एक सीमा होगी",
  T_49_META_TYP_2508_I3_D: "वर्तमान में कौन सी तरंग उत्पन्न हो रही है?",
  T_49_META_TYP_2508_I5_D: "वर्तमान लहर में किस प्रकार के ज़ॉम्बी उत्पन्न हुए हैं",
  T_49_META_TYP_2508_I6_D: "क्या एआई मरने पर उपकरण या आइटम गिराएगा?",
  T_49_META_TYP_2508_I7_D: "स्पॉन प्रारंभ समय (सेकंड में)",
  T_49_META_TYP_2508_I8_D: "अगली लहर और पिछली लहर के बीच का समय अंतराल",
  T_49_META_TYP_2509_I0_D: "प्रत्येक लहर में पैदा होने वाली इकाइयों की संख्या",
  T_49_META_TYP_2509_I1_D: "कुल कितनी यूनिट जनरेटर की तरंगें उत्पन्न होंगी",
  T_49_META_TYP_2509_I2_D: "वर्तमान में कौन सी तरंग उत्पन्न हो रही है?",
  T_49_META_TYP_2509_I4_D: "प्रत्येक तरंग के सृजन के लिए टेम्पलेट के रूप में किस इकाई का उपयोग किया जाएगा?",
  T_49_META_TYP_2509_I5_D: "यूनिट स्पॉन समय",
  T_49_META_TYP_2509_I6_D: "चाहे लगातार जनरेट करना हो, लेकिन एक ही स्क्रीन पर एक सीमा होगी",
  T_49_META_TYP_2509_I7_D: "अगली लहर और पिछली लहर के बीच का समय अंतराल",
  T_49_META_TYP_2509_I8_D: "टेम्पलेट का प्रीफ़ैबआईडी",
  T_49_META_TYP_2510_I0_D: "स्पॉन बिंदु की संख्या",
  T_49_META_TYP_252_I1_D: "लेफ्ट आइकॉन",
  T_49_META_TYP_252_I2_D: "लेफ्ट टेक्स्ट",
  T_49_META_TYP_252_I3_D: "लेफ्ट स्कोर",
  T_49_META_TYP_252_I5_D: "राइट आइकॉन",
  T_49_META_TYP_252_I6_D: "राइट टेक्स्ट",
  T_49_META_TYP_252_I7_D: "राइट स्कोर",
  T_49_META_TYP_252_I8_D: "प्रोग्रेस [0,1]",
  T_49_META_TYP_253_I0_D: "आइकन चुनें",
  T_49_META_TYP_253_I1_D: "टेक्स्ट",
  T_49_META_TYP_253_I2_D: "इफेक्ट एक्टिव",
  T_49_META_TYP_253_I3_D: "यूआई स्थान",
  T_49_META_TYP_254_I1_D: "उदाहरण के लिए, 1.25 का मतलब है सामान्य गति का 1.25 गुना",
  T_49_META_TYP_254_I2_D: "कलर",
  T_49_META_TYP_256_I0_D: "पूर्णतया स्थिर. सबसे किफायती प्रदर्शन",
  T_49_META_TYP_256_I1_D: "सामान्य रूप से बल लगाएं। सबसे अधिक प्रदर्शन उपभोग",
  T_49_META_TYP_256_I2_D: "गति को स्क्रिप्ट द्वारा नियंत्रित किया जा सकता है, और द्रव्यमान को अनंत माना जा सकता है",
  T_49_META_TYP_257_I0_D: "विभिन्न प्रकार के कठोर पिंडों के अलग-अलग कार्य होते हैं",
  T_49_META_TYP_257_I1_D: "ग्रेविटी जा इस्तेमाल करें",
  T_49_META_TYP_257_I2_D: "द्रव्यमान (किलोग्राम), न्यूनतम प्रभावी द्रव्यमान 0.001 किग्रा है। यदि यह 0 है, तो इसका अर्थ है अनंत द्रव्यमान और बल के तहत गति नहीं करेगा",
  T_49_META_TYP_257_I3_D: "गुरुत्वाकर्षण केंद्र की स्थिति, स्थानीय निर्देशांक प्रणाली",
  T_49_META_TYP_257_I4_D: "दृढ़ पिंड गति का रेखीय वेग",
  T_49_META_TYP_257_I5_D: "एक दृढ़ पिंड का कोणीय वेग",
  T_49_META_TYP_257_I6_D: "रेखीय गति का प्राकृतिक क्षीणन गुणांक। गुणांक जितना बड़ा होगा, गति उतनी ही तेजी से घटती है।",
  T_49_META_TYP_257_I7_D: "कोणीय वेग का प्राकृतिक क्षीणन गुणांक। गुणांक जितना बड़ा होगा, गति उतनी ही तेजी से घटती है।",
  T_49_META_TYP_257_I8_D: "कठोर शरीर पर लगाए गए प्रतिबंध RigidbodyConstrainType का एक संग्रह हैं",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "बैकग्राउंड",
  T_49_META_TYP_259_I1_D: "टेक्स्ट",
  T_49_META_TYP_259_I2_D: "यूआई स्थान",
  T_49_META_TYP_259_I4_D: "टेक्स्ट कलर",
  T_49_META_TYP_260_I0_D: "आइकन चुनें",
  T_49_META_TYP_260_I1_D: "प्रगति पट्टी का रंग",
  T_49_META_TYP_260_I2_D: "मान",
  T_49_META_TYP_260_I3_D: "गति, मी/से",
  T_49_META_TYP_260_I4_D: "विशेष प्रभाव प्रदर्शित करना है या नहीं",
  T_49_META_TYP_260_I5_D: "यूआई स्थिति [0,1]",
  T_49_META_TYP_260_I6_D: "कौशल की प्रारंभिक प्रगति, मान [0, 1] है। UI बनने के बाद, प्रगति तुरंत वर्तमान प्रगति के साथ सिंक्रनाइज़ हो जाएगी",
  T_49_META_TYP_260_I7_D: "इफेक्ट कलर",
  T_49_META_TYP_260_I8_D: "ऑब्जेक्ट का स्केल मान सेट करें",
  T_49_META_TYP_265_I1_D: "क्या बैकग्राउंड फिलिंग करनी है",
  T_49_META_TYP_265_I2_D: "पृष्ठभूमि नाम",
  T_49_META_TYP_265_I3_D: "पृष्ठभूमि रंग",
  T_49_META_TYP_265_I5_D: "बीजीअल्फा",
  T_49_META_TYP_265_I6_D: "काटने का प्रकार",
  T_49_META_TYP_265_I7_D: "मास्क प्रकार, मास्किंग करते समय चयनित छवि का नाम है",
  T_49_META_TYP_265_I8_D: "एज सॉफ्टनिंग यूनिट",
  T_49_META_TYP_267_I0_D: "स्क्रॉलिंग आरंभिक बिंदु, डिफ़ॉल्ट ऊपरी बायां कोना है",
  T_49_META_TYP_267_I1_D: "एकाधिक स्क्रॉल दिशाओं का समर्थन करें",
  T_49_META_TYP_267_I10_D: "क्षैतिज बार",
  T_49_META_TYP_267_I11_D: "स्थान प्रदर्शित करें",
  T_49_META_TYP_267_I2_D: "घटक को XY दिशा में खींचें",
  T_49_META_TYP_267_I3_D: "एकाधिक ड्रैग प्रभावों का समर्थन करें",
  T_49_META_TYP_267_I4_D: "स्क्रॉल फैक्टर, मान जितना बड़ा होगा, स्क्रॉलिंग उतनी ही तेज़ होगी",
  T_49_META_TYP_267_I5_D: "जड़त्व कारक, मान जितना बड़ा होगा, लुढ़कते समय जड़त्व उतना ही अधिक होगा।",
  T_49_META_TYP_267_I6_D: "क्या ड्रैगिंग व्यूपोर्ट तक सीमित है, डिफ़ॉल्ट रूप से चयनित है",
  T_49_META_TYP_267_I7_D: "जब चेक किया जाता है, तो ड्रैगिंग धीमी गति से शुरू होगी, यदि अनचेक किया जाता है, तो ड्रैगिंग माउस की गति से शुरू होगी",
  T_49_META_TYP_267_I8_D: "जब यह व्यूपोर्ट में फिट हो जाए, तो खींचकर बाहर निकलें",
  T_49_META_TYP_267_I9_D: "लंबवत बार",
  T_49_META_TYP_268_I0_D: "डिफ़ॉल्ट",
  T_49_META_TYP_268_I1_D: "बंद करें",
  T_49_META_TYP_268_I2_D: "दिखाएं",
  T_49_META_TYP_269_I0_D: "मालिक",
  T_49_META_TYP_269_I1_D: "आईडी सेट करें",
  T_49_META_TYP_269_I2_D: "हेडड्रेस आईडी",
  T_49_META_TYP_269_I3_D: "फेस आईडी",
  T_49_META_TYP_269_I4_D: "मेकअप आईडी",
  T_49_META_TYP_269_I5_D: "ऊपरी शरीर आईडी",
  T_49_META_TYP_269_I6_D: "निचले शरीर की पहचान",
  T_49_META_TYP_269_I7_D: "जूता आईडी",
  T_49_META_TYP_272_I0_D: "महिला",
  T_49_META_TYP_272_I1_D: "पुरुष",
  T_49_META_TYP_273_I0_D: "छोटे मानचित्र के केंद्र के अनुरूप विश्व निर्देशांक",
  T_49_META_TYP_273_I1_D: "छोटे मानचित्र का आकार, चौड़ाई और ऊंचाई समान है",
  T_49_META_TYP_273_I2_D: "मिनिमैप डेप्थ मैप प्रदर्शन मोड को सक्षम करना है या नहीं",
  T_49_META_TYP_274_I1_D: "स्केलिंग",
  T_49_META_TYP_274_I4_D: "आइकन प्रदर्शन स्तर",
  T_49_META_TYP_275_I0_D: "हड्डी का आकार",
  T_49_META_TYP_275_I1_D: "अस्थि नोड के विश्व निर्देशांक",
  T_49_META_TYP_276_I0_D: "सिर",
  T_49_META_TYP_276_I1_D: "बायां हाथ",
  T_49_META_TYP_276_I2_D: "बायां हाथ (हथेली)",
  T_49_META_TYP_276_I3_D: "दायां हाथ",
  T_49_META_TYP_276_I4_D: "दायां हाथ (हथेली)",
  T_49_META_TYP_276_I5_D: "धड़",
  T_49_META_TYP_276_I6_D: "बायां पैर",
  T_49_META_TYP_276_I7_D: "बायां पैर (पैर की अंगुली)",
  T_49_META_TYP_276_I8_D: "दायां पैर",
  T_49_META_TYP_276_I9_D: "दायां पैर (पैर की अंगुली)",
  T_49_META_TYP_277_I1_D: "कैमरा किरण संसूचन की दूरी",
  T_49_META_TYP_277_I2_D: "कैमरा किरण पहचान के लिए टकराव परत मास्क",
  T_49_META_TYP_277_I3_D: "बटन स्थिति ऑफसेट",
  T_49_META_TYP_277_I4_D: "चिह्न संसाधन आईडी",
  T_49_META_TYP_277_I5_D: "क्लिक क्षेत्र का आकार",
  T_49_META_TYP_277_I6_D: "ऑब्जेक्ट को लक्ष्य बिंदु पर प्रदर्शित करना है या नहीं",
  T_49_META_TYP_277_I7_D: "लक्ष्य बिंदु प्रदर्शन ऑब्जेक्ट",
  T_49_META_TYP_278_I0_D: "मानचित्र पिक्सेल उत्पन्न करने के लिए लक्ष्य इकाई",
  T_49_META_TYP_28_I0_D: "क्या इसे हर दौर में रीसेट किया जा सकता है?",
  T_49_META_TYP_280_I0_D: "गोले की त्रिज्या",
  T_49_META_TYP_281_I0_D: "कैप्सूल के दोनों सिरों पर गोलार्धों की त्रिज्या",
  T_49_META_TYP_29_I0_D: "गोला",
  T_49_META_TYP_29_I1_D: "प्रकाश किरण",
  T_49_META_TYP_29_I10_D: "पैर के तलवे पर स्थित प्रकाश स्तंभ का उपयोग अब फिनिश लाइन में प्रवेश करते समय फीडबैक के लिए किया जाता है",
  T_49_META_TYP_29_I11_D: "ठंडक",
  T_49_META_TYP_29_I12_D: "प्रकाश",
  T_49_META_TYP_29_I13_D: "ऊपर की ओर बहाव",
  T_49_META_TYP_29_I14_D: "गैस विस्फोट",
  T_49_META_TYP_29_I15_D: "छिपाने वाला मारा गया",
  T_49_META_TYP_29_I16_D: "बर्बरता",
  T_49_META_TYP_29_I17_D: "क्लोन की मौत",
  T_49_META_TYP_29_I18_D: "शूटिंग फीडबैक",
  T_49_META_TYP_29_I19_D: "क्लोन की मौत",
  T_49_META_TYP_29_I2_D: "बूम",
  T_49_META_TYP_29_I20_D: "क्लोन",
  T_49_META_TYP_29_I21_D: "पोर्टल",
  T_49_META_TYP_29_I22_D: "फ्लैशबैंक धुआं",
  T_49_META_TYP_29_I23_D: "आग का गोला",
  T_49_META_TYP_29_I24_D: "लूप में जलना",
  T_49_META_TYP_29_I25_D: "जहर गैस",
  T_49_META_TYP_29_I26_D: "दिल",
  T_49_META_TYP_29_I29_D: "दरवाजा",
  T_49_META_TYP_29_I30_D: "आतिशबाजी",
  T_49_META_TYP_29_I31_D: "रनिंग शूज़ VFX",
  T_49_META_TYP_29_I32_D: "विस्फोट VFX",
  T_49_META_TYP_29_I33_D: "स्पॉन प्वाइंट VFX",
  T_49_META_TYP_29_I34_D: "लेजर VFX",
  T_49_META_TYP_29_I35_D: "कौशल कैस्ट VFX",
  T_49_META_TYP_29_I36_D: "बुलेट VFX",
  T_49_META_TYP_29_I37_D: "बुलेट हिट VFX",
  T_49_META_TYP_29_I38_D: "शूटिंग VFX",
  T_49_META_TYP_29_I39_D: "कौशल VFX",
  T_49_META_TYP_29_I40_D: "हैलो",
  T_49_META_TYP_29_I41_D: "बुलबुला",
  T_49_META_TYP_29_I42_D: "धुआं और धूल",
  T_49_META_TYP_29_I43_D: "उड़ती हुई मलबा",
  T_49_META_TYP_29_I44_D: "रेखा",
  T_49_META_TYP_29_I45_D: "झपकना",
  T_49_META_TYP_29_I47_D: "उठते कण",
  T_49_META_TYP_29_I48_D: "धुआं",
  T_49_META_TYP_29_I49_D: "तावीज़",
  T_49_META_TYP_29_I50_D: "ठंढा क्षेत्र",
  T_49_META_TYP_29_I51_D: "कोहरा",
  T_49_META_TYP_29_I52_D: "बर्फ के टुकड़े",
  T_49_META_TYP_29_I53_D: "आग",
  T_49_META_TYP_29_I54_D: "प्रकाश किरण",
  T_49_META_TYP_29_I55_D: "जहर गैस का प्रसार",
  T_49_META_TYP_29_I56_D: "जहर गैस",
  T_49_META_TYP_29_I57_D: "विस्फोट की आग",
  T_49_META_TYP_29_I58_D: "प्रकाश प्रभाव",
  T_49_META_TYP_29_I59_D: "तारा",
  T_49_META_TYP_29_I6_D: "आपके पैरों के नीचे प्रभामंडल",
  T_49_META_TYP_29_I60_D: "जलता हुआ अलाव",
  T_49_META_TYP_29_I61_D: "पानी की छींटें",
  T_49_META_TYP_29_I62_D: "बिजली का झटका",
  T_49_META_TYP_29_I63_D: "स्याही VFX",
  T_49_META_TYP_29_I64_D: "ब्लैकहोल VFX",
  T_49_META_TYP_29_I65_D: "ब्लैकहोल विस्फोट VFX",
  T_49_META_TYP_29_I66_D: "क्रिस्टल बॉल VFX",
  T_49_META_TYP_29_I67_D: "लेजर बुलेट विशेष प्रभाव",
  T_49_META_TYP_29_I68_D: "अनुगामी प्रभाव",
  T_49_META_TYP_29_I69_D: "बादल प्रभाव",
  T_49_META_TYP_29_I7_D: "ज़मीन का मार्कर",
  T_49_META_TYP_29_I8_D: "धुआं",
  T_49_META_TYP_29_I9_D: "तावीज़ विस्फोट",
  T_49_META_TYP_290_I0_D: "रिफ्रेश अंतराल, संख्या जितनी बड़ी होगी, रिफ्रेश उतना ही धीमा होगा, मिलीसेकंड में",
  T_49_META_TYP_290_I1_D: "डिबगिंग सक्षम करना है या नहीं",
  T_49_META_TYP_291_I0_D: "स्थिति नोड",
  T_49_META_TYP_291_I1_D: "क्रिया नोड",
  T_49_META_TYP_293_I0_D: "बिहेवियर ट्री ID",
  T_49_META_TYP_293_I1_D: "अटैच टारगेट",
  T_49_META_TYP_294_I1_D: "लेआउट प्रकार",
  T_49_META_TYP_294_I10_D: "सॉर्ट प्रकार",
  T_49_META_TYP_294_I2_D: "सामग्री मूल",
  T_49_META_TYP_294_I3_D: "व्यवस्था की दिशा",
  T_49_META_TYP_294_I4_D: "उप-आइटम ग्रिड की चौड़ाई और ऊंचाई",
  T_49_META_TYP_294_I5_D: "सेल अंतराल",
  T_49_META_TYP_294_I6_D: "प्रतिबंध",
  T_49_META_TYP_294_I7_D: "प्रतिबंध की संख्या",
  T_49_META_TYP_294_I8_D: "ऊर्ध्वाधर ऑफसेट",
  T_49_META_TYP_294_I9_D: "क्षैतिज ऑफसेट",
  T_49_META_TYP_295_I2_D: "प्ले गति",
  T_49_META_TYP_296_I1_D: "क्लिप लंबाई",
  T_49_META_TYP_297_I0_D: "बाउंड ऑब्जेक्ट",
  T_49_META_TYP_297_I4_D: "रिसोर्स ID",
  T_49_META_TYP_298_I0_D: "डिफ़ॉल्ट",
  T_49_META_TYP_298_I2_D: "एक बार",
  T_49_META_TYP_30_I0_D: "वर्ग",
  T_49_META_TYP_30_I1_D: "चौकोर",
  T_49_META_TYP_30_I10_D: "तीर",
  T_49_META_TYP_30_I11_D: "कॉलआउट",
  T_49_META_TYP_30_I12_D: "चट्टान",
  T_49_META_TYP_30_I13_D: "कैंची",
  T_49_META_TYP_30_I14_D: "कागज",
  T_49_META_TYP_30_I15_D: "पसंद",
  T_49_META_TYP_30_I16_D: "सही",
  T_49_META_TYP_30_I17_D: "गलत",
  T_49_META_TYP_30_I18_D: "जोड़",
  T_49_META_TYP_30_I19_D: "बिजली चमकना",
  T_49_META_TYP_30_I2_D: "दायां कोण वाला ट्रैपेज़ियम",
  T_49_META_TYP_30_I20_D: "दिल",
  T_49_META_TYP_30_I21_D: "तारा",
  T_49_META_TYP_30_I22_D: "चाँद",
  T_49_META_TYP_30_I23_D: "सूरज",
  T_49_META_TYP_30_I24_D: "चश्मा",
  T_49_META_TYP_30_I25_D: "चाबी",
  T_49_META_TYP_30_I26_D: "ट्रॉफी",
  T_49_META_TYP_30_I27_D: "झंडा",
  T_49_META_TYP_30_I28_D: "घड़ी",
  T_49_META_TYP_30_I29_D: "फ़ोल्डर",
  T_49_META_TYP_30_I3_D: "ट्रैपेज़ियम",
  T_49_META_TYP_30_I30_D: "खुला फ़ोल्डर",
  T_49_META_TYP_30_I31_D: "घर",
  T_49_META_TYP_30_I32_D: "विश्राम",
  T_49_META_TYP_30_I33_D: "रिफ्रेश",
  T_49_META_TYP_30_I34_D: "लूप",
  T_49_META_TYP_30_I35_D: "आवर्धक",
  T_49_META_TYP_30_I36_D: "कचरा पात्र",
  T_49_META_TYP_30_I37_D: "वापसी",
  T_49_META_TYP_30_I38_D: "हीरा",
  T_49_META_TYP_30_I39_D: "तैराकी रिंग",
  T_49_META_TYP_30_I4_D: "षट्भुज",
  T_49_META_TYP_30_I40_D: "पैसा",
  T_49_META_TYP_30_I41_D: "ताला",
  T_49_META_TYP_30_I42_D: "सेटिंग्स",
  T_49_META_TYP_30_I43_D: "बाहर निकलना",
  T_49_META_TYP_30_I44_D: "संवाद",
  T_49_META_TYP_30_I45_D: "क्रॉसहेयर",
  T_49_META_TYP_30_I46_D: "बंदूक",
  T_49_META_TYP_30_I47_D: "तलवार",
  T_49_META_TYP_30_I48_D: "विस्फोट",
  T_49_META_TYP_30_I49_D: "लक्ष्य",
  T_49_META_TYP_30_I5_D: "गोल",
  T_49_META_TYP_30_I50_D: "क्रॉस",
  T_49_META_TYP_30_I51_D: "रक्षा",
  T_49_META_TYP_30_I52_D: "राक्षस",
  T_49_META_TYP_30_I53_D: "पुनर्नवीनीकरण",
  T_49_META_TYP_30_I54_D: "उपहार",
  T_49_META_TYP_30_I55_D: "कपड़े",
  T_49_META_TYP_30_I56_D: "खेल",
  T_49_META_TYP_30_I57_D: "खिलाड़ी",
  T_49_META_TYP_30_I58_D: "स्टोर",
  T_49_META_TYP_30_I59_D: "बाहर निकलना",
  T_49_META_TYP_30_I6_D: "त्रिकोण",
  T_49_META_TYP_30_I60_D: "चेतावनी",
  T_49_META_TYP_30_I61_D: "पाठ",
  T_49_META_TYP_30_I62_D: "टाइमर ऑब्जेक्ट",
  T_49_META_TYP_30_I63_D: "घंटी",
  T_49_META_TYP_30_I64_D: "पालतू जानवर",
  T_49_META_TYP_30_I65_D: "बम",
  T_49_META_TYP_30_I66_D: "मरम्मत",
  T_49_META_TYP_30_I67_D: "मुस्कान वाला चेहरा",
  T_49_META_TYP_30_I68_D: "स्पीकर",
  T_49_META_TYP_30_I7_D: "विस्मयादिबोधक चिन्ह",
  T_49_META_TYP_30_I70_D: "मुकुट",
  T_49_META_TYP_30_I71_D: "लड़ाई",
  T_49_META_TYP_30_I72_D: "गिल्ड",
  T_49_META_TYP_30_I73_D: "दिल की धड़कन",
  T_49_META_TYP_30_I74_D: "संगीत",
  T_49_META_TYP_30_I75_D: "वाहन",
  T_49_META_TYP_30_I76_D: "नजदीकी हथियार",
  T_49_META_TYP_30_I77_D: "पिस्तौल",
  T_49_META_TYP_30_I78_D: "राइफल",
  T_49_META_TYP_30_I79_D: "स्नाइपर राइफल",
  T_49_META_TYP_30_I8_D: "प्रश्न चिन्ह",
  T_49_META_TYP_30_I80_D: "शॉटगन",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "हीलिंग गन",
  T_49_META_TYP_30_I83_D: "आर्मर शेटर",
  T_49_META_TYP_30_I84_D: "हेडशॉट",
  T_49_META_TYP_30_I85_D: "कौशल 1",
  T_49_META_TYP_30_I86_D: "कौशल 2",
  T_49_META_TYP_30_I87_D: "कौशल 3",
  T_49_META_TYP_30_I88_D: "कौशल 4",
  T_49_META_TYP_30_I89_D: "कौशल 5",
  T_49_META_TYP_30_I9_D: "चिह्न",
  T_49_META_TYP_30_I90_D: "कौशल 6",
  T_49_META_TYP_30_I91_D: "कौशल 7",
  T_49_META_TYP_30_I92_D: "कौशल 8",
  T_49_META_TYP_30_I93_D: "कौशल 9",
  T_49_META_TYP_30_I94_D: "कौशल 10",
  T_49_META_TYP_300_I0_D: "रिसोर्स ID",
  T_49_META_TYP_300_I2_D: "घुमाव",
  T_49_META_TYP_300_I3_D: "निर्मित इकाई",
  T_49_META_TYP_301_I1_D: "आत्म-स्फोट",
  T_49_META_TYP_301_I2_D: "डैश अटैक",
  T_49_META_TYP_301_I3_D: "शॉक वेव",
  T_49_META_TYP_301_I4_D: "हवा हमला",
  T_49_META_TYP_301_I5_D: "कूद हमला",
  T_49_META_TYP_301_I6_D: "शील्ड अप",
  T_49_META_TYP_301_I7_D: "शील्ड टूटा",
  T_49_META_TYP_302_I5_D: "बैग",
  T_49_META_TYP_302_I7_D: "स्केटबोर्ड, छलावरण...",
  T_49_META_TYP_303_I0_D: "प्लेयर मैक्स HP जोड़ें",
  T_49_META_TYP_303_I1_D: "प्लेयर HP लगातार रिस्टोर होती है",
  T_49_META_TYP_305_I0_D: "समाप्त",
  T_49_META_TYP_305_I1_D: "चल रहा है",
  T_49_META_TYP_307_I0_D: "प्रति नुकसान अनुभव",
  T_49_META_TYP_307_I1_D: "प्रति दूरी अनुभव",
  T_49_META_TYP_307_I2_D: "प्रति सेकंड अनुभव",
  T_49_META_TYP_307_I3_D: "चिप अनुभव",
  T_49_META_TYP_307_I4_D: "अधिकतम चार्ज",
  T_49_META_TYP_308_I0_D: "जेल निर्माता",
  T_49_META_TYP_31_I0_D: "ग्रेनेड विस्फोट",
  T_49_META_TYP_31_I1_D: "गोली",
  T_49_META_TYP_31_I10_D: "हिट से नुकसान होने का ध्वनि प्रभाव",
  T_49_META_TYP_31_I11_D: "उन्नत ध्वनि प्रभाव",
  T_49_META_TYP_31_I12_D: "कमज़ोर क्लिक ध्वनि प्रभाव",
  T_49_META_TYP_31_I13_D: "खिलाड़ी तंत्र ध्वनि प्रभाव पर कदम",
  T_49_META_TYP_31_I14_D: "उपकरण मरम्मत ध्वनि प्रभाव",
  T_49_META_TYP_31_I15_D: "उपकरण मरम्मत ध्वनि प्रभाव",
  T_49_META_TYP_31_I16_D: "दोषपूर्ण या अनुपस्थित ध्वनि प्रभाव",
  T_49_META_TYP_31_I17_D: "अनुस्मारक ध्वनि प्रभाव",
  T_49_META_TYP_31_I18_D: "फुटबॉल लैंडिंग ध्वनि प्रभाव",
  T_49_META_TYP_31_I19_D: "जयकार ध्वनि प्रभाव",
  T_49_META_TYP_31_I2_D: "काउंटडाउन बीप",
  T_49_META_TYP_31_I20_D: "बम चेतावनी ध्वनि प्रभाव",
  T_49_META_TYP_31_I21_D: "बम विस्फोट ध्वनि प्रभाव",
  T_49_META_TYP_31_I22_D: "हंटर ध्वनि प्रभाव प्रकट होता है",
  T_49_META_TYP_31_I23_D: "अंतिम बीजीएम ध्वनि प्रभाव",
  T_49_META_TYP_31_I24_D: "आपूर्ति बॉक्स ताज़ा ध्वनि प्रभाव",
  T_49_META_TYP_31_I25_D: "त्वरक ध्वनि प्रभाव",
  T_49_META_TYP_31_I26_D: "गायब होने की याद दिलाने वाला ध्वनि प्रभाव",
  T_49_META_TYP_31_I27_D: "दृश्य प्रभाव ध्वनि प्रभाव",
  T_49_META_TYP_31_I28_D: "रात्रि कीट ध्वनि प्रभाव",
  T_49_META_TYP_31_I29_D: "सुस्त मार ध्वनि प्रभाव",
  T_49_META_TYP_31_I3_D: "UI टैप",
  T_49_META_TYP_31_I30_D: "प्रत्युत्तरात्मक ध्वनि प्रभाव",
  T_49_META_TYP_31_I31_D: "आश्चर्यजनक ध्वनि प्रभावों की खोज करें",
  T_49_META_TYP_31_I32_D: "छोटे भूत का ध्वनि प्रभाव",
  T_49_META_TYP_31_I33_D: "चरण प्रारंभ ध्वनि प्रभाव",
  T_49_META_TYP_31_I34_D: "ज़ोंबी ध्वनि प्रभाव",
  T_49_META_TYP_31_I35_D: "डरावने ध्वनि प्रभाव",
  T_49_META_TYP_31_I36_D: "परिवर्तन ध्वनि प्रभाव",
  T_49_META_TYP_31_I37_D: "तेज़ दिल की धड़कन ध्वनि प्रभाव",
  T_49_META_TYP_31_I38_D: "मध्यम गति दिल की धड़कन ध्वनि प्रभाव",
  T_49_META_TYP_31_I39_D: "धीमी दिल की धड़कन ध्वनि प्रभाव",
  T_49_META_TYP_31_I4_D: "हिट पर महिला की चीख",
  T_49_META_TYP_31_I40_D: "क्रोध ध्वनि प्रभाव",
  T_49_META_TYP_31_I41_D: "क्लिक ध्वनि प्रभाव",
  T_49_META_TYP_31_I42_D: "कौशल पुनर्प्राप्ति ध्वनि प्रभाव",
  T_49_META_TYP_31_I43_D: "खेल ध्वनि प्रभाव जोड़ा गया",
  T_49_META_TYP_31_I44_D: "यांत्रिक प्रतिध्वनि ध्वनि प्रभाव",
  T_49_META_TYP_31_I45_D: "मच्छर ध्वनि प्रभाव",
  T_49_META_TYP_31_I46_D: "गहन डिंग डिंग डिंग 1 ध्वनि प्रभाव",
  T_49_META_TYP_31_I47_D: "गहन डिंग डिंग डिंग 2 ध्वनि प्रभाव",
  T_49_META_TYP_31_I48_D: "तंत्र खोलने का ध्वनि प्रभाव",
  T_49_META_TYP_31_I49_D: "चार्जिंग ध्वनि प्रभाव 1",
  T_49_META_TYP_31_I5_D: "हिट पर पुरुष की चीख",
  T_49_META_TYP_31_I50_D: "पदचाप की ध्वनि प्रभाव",
  T_49_META_TYP_31_I51_D: "मिशन सफलता संकेत 1 ध्वनि प्रभाव",
  T_49_META_TYP_31_I52_D: "खतरे की चेतावनी ध्वनि 1 ध्वनि प्रभाव",
  T_49_META_TYP_31_I53_D: "खतरे की चेतावनी ध्वनि 2 ध्वनि प्रभाव",
  T_49_META_TYP_31_I54_D: "उलटी गिनती 3 ध्वनि प्रभाव",
  T_49_META_TYP_31_I55_D: "टिप्स ध्वनि प्रभाव दिखाएं",
  T_49_META_TYP_31_I56_D: "कौओं की आवाज का परिवेशीय ध्वनि प्रभाव",
  T_49_META_TYP_31_I57_D: "टेलीपोर्टर का उपयोग करके गलत क्षेत्र में टेलीपोर्ट करने का ध्वनि प्रभाव",
  T_49_META_TYP_31_I58_D: "टेलीपोर्ट बिंदु का उपयोग करके सही क्षेत्र में टेलीपोर्ट करने का ध्वनि प्रभाव",
  T_49_META_TYP_31_I59_D: "ध्वनि संचारित करें",
  T_49_META_TYP_31_I6_D: "सोने का सिक्का पिकअप ध्वनि प्रभाव",
  T_49_META_TYP_31_I60_D: "बिजली के झटके का ध्वनि प्रभाव",
  T_49_META_TYP_31_I61_D: "प्रॉप ध्वनि प्रभाव प्राप्त करें",
  T_49_META_TYP_31_I62_D: "इलेक्ट्रॉनिक स्वप्निल प्यारा पृष्ठभूमि संगीत ध्वनि प्रभाव",
  T_49_META_TYP_31_I63_D: "आकस्मिक खेल पृष्ठभूमि संगीत ध्वनि प्रभाव",
  T_49_META_TYP_31_I64_D: "बॉक्स खोलें",
  T_49_META_TYP_31_I65_D: "रैंक अप",
  T_49_META_TYP_31_I66_D: "अधिकतम स्तर",
  T_49_META_TYP_31_I67_D: "बटन टैप करें",
  T_49_META_TYP_31_I68_D: "काउंटडाउन",
  T_49_META_TYP_31_I69_D: "दुश्मन को हराएँ",
  T_49_META_TYP_31_I7_D: "दौड़ में फिनिश लाइन पार करने के लिए ट्रिगर ध्वनि प्रभाव",
  T_49_META_TYP_31_I70_D: "समाप्त",
  T_49_META_TYP_31_I71_D: "आगे बढ़ें",
  T_49_META_TYP_31_I72_D: "विजय",
  T_49_META_TYP_31_I73_D: "प्रशिक्षण आधार चेकपॉइंट",
  T_49_META_TYP_31_I74_D: "काउंटडाउन",
  T_49_META_TYP_31_I75_D: "खेल शुरू",
  T_49_META_TYP_31_I76_D: "बड़ा सोना प्राप्त करें",
  T_49_META_TYP_31_I77_D: "मध्यम सोना प्राप्त करें",
  T_49_META_TYP_31_I78_D: "छोटा सोना प्राप्त करें",
  T_49_META_TYP_31_I79_D: "झगड़े में शामिल हों",
  T_49_META_TYP_31_I8_D: "ट्रिगर ध्वनि प्रभाव",
  T_49_META_TYP_31_I80_D: "गिल्ड आपूर्ति",
  T_49_META_TYP_31_I81_D: "स्पीकर",
  T_49_META_TYP_31_I82_D: "गिल्ड लीडर को महाभियोग",
  T_49_META_TYP_31_I83_D: "गोदाम सहेजें",
  T_49_META_TYP_31_I84_D: "विशेष बंदूक की आवाज़",
  T_49_META_TYP_31_I85_D: "गोली लगना",
  T_49_META_TYP_31_I86_D: "ले जाओ",
  T_49_META_TYP_31_I87_D: "टैप अक्षम बटन",
  T_49_META_TYP_31_I88_D: "कौशल चार्ज पूरा",
  T_49_META_TYP_31_I89_D: "लेजर कौशल",
  T_49_META_TYP_31_I9_D: "खराब ध्वनि प्रभाव",
  T_49_META_TYP_31_I90_D: "उपभोग्य वस्तु प्राप्त करें 2",
  T_49_META_TYP_31_I91_D: "काउंटडाउन 3",
  T_49_META_TYP_31_I92_D: "खेल समाप्त 2",
  T_49_META_TYP_31_I93_D: "किल प्रॉम्प्ट",
  T_49_META_TYP_31_I94_D: "विस्फोट",
  T_49_META_TYP_31_I95_D: "ऊर्जा बॉल कौशल",
  T_49_META_TYP_31_I96_D: "रक्त पूल कौशल",
  T_49_META_TYP_311_I1_D: "अधिकतम नुकसान",
  T_49_META_TYP_311_I3_D: "हाथ से छूटने के बाद फेंकी गई वस्तु की उड़ने की गति, मी/से में",
  T_49_META_TYP_311_I4_D: "फेंकी गई वस्तु के छोड़े जाने से लेकर उसके प्रभावी होने तक का समय अंतराल, सेकंड में",
  T_49_META_TYP_313_I0_D: "क्षेत्र का त्रिज्या",
  T_49_META_TYP_313_I1_D: "काउंटर ज़ोन की अवधि, सेकंड में",
  T_49_META_TYP_314_I0_D: "एनिमेशन नियंत्रक संसाधन आईडी",
  T_49_META_TYP_314_I1_D: "एनीमेशन कंट्रोलर",
  T_49_META_TYP_315_I0_D: "बैकपैक मालिक",
  T_49_META_TYP_315_I1_D: "बैकपैक स्थान",
  T_49_META_TYP_315_I2_D: "इस्तेमाल की क्षमता",
  T_49_META_TYP_315_I3_D: "सभी सप्लाई",
  T_49_META_TYP_316_I0_D: "बनावट संसाधन",
  T_49_META_TYP_316_I1_D: "शेडर नाम",
  T_49_META_TYP_316_I11_D: "फ्लिप विधि",
  T_49_META_TYP_316_I2_D: "UV ऑफ़सेट",
  T_49_META_TYP_316_I3_D: "UV आकार",
  T_49_META_TYP_316_I4_D: "भरने का प्रकार",
  T_49_META_TYP_316_I5_D: "बाएं और दाएं सीमा",
  T_49_META_TYP_316_I6_D: "ऊपर और नीचे की सीमा",
  T_49_META_TYP_317_I0_D: "कोई नहीं",
  T_49_META_TYP_317_I1_D: "फ्रीज़ पोजीशन X",
  T_49_META_TYP_317_I2_D: "फ्रीज़ पोजीशन Y",
  T_49_META_TYP_317_I3_D: "फ्रीज़ पोजीशन Z",
  T_49_META_TYP_317_I4_D: "एक्स अक्ष के चारों ओर घूर्णन को सीमित करें",
  T_49_META_TYP_317_I5_D: "Y अक्ष के चारों ओर घूर्णन को सीमित करें",
  T_49_META_TYP_317_I6_D: "Z अक्ष के चारों ओर घूर्णन को सीमित करें",
  T_49_META_TYP_317_I7_D: "फ्रीज़ पोजीशन",
  T_49_META_TYP_317_I8_D: "फ्रीज़ रोटेशन",
  T_49_META_TYP_317_I9_D: "सभी फ्रीज़ करें",
  T_49_META_TYP_318_I0_D: "श्रेणी",
  T_49_META_TYP_318_I1_D: "पूर्ण क्षति की दूरी",
  T_49_META_TYP_318_I10_D: "खिलाड़ी लक्ष्य गति गुणांक",
  T_49_META_TYP_318_I11_D: "दृष्टि आवर्धन अनुपात",
  T_49_META_TYP_318_I12_D: "FOV आवर्धन",
  T_49_META_TYP_318_I13_D: "ADS आवर्धन",
  T_49_META_TYP_318_I14_D: "ADS आवर्धन समय (सेकंड)",
  T_49_META_TYP_318_I15_D: "ADS रिकवरी समय (सेकंड)",
  T_49_META_TYP_318_I16_D: "स्कोप के लिए न्यूनतम क्षति दूरी सुधार कारक",
  T_49_META_TYP_318_I17_D: "ADS लक्ष्य सहायता की अनुमति दें",
  T_49_META_TYP_318_I18_D: "लक्ष्य सहायता क्रॉसहेयर स्क्रीन सीमा आकर्षण अनुपात (0-1)",
  T_49_META_TYP_318_I19_D: "लक्ष्य सहायता दूरी क्षीणन गुणांक (0-1)",
  T_49_META_TYP_318_I2_D: "न्यूनतम नुकसान की दूरी",
  T_49_META_TYP_318_I20_D: "लक्ष्य सहायता दूरी प्राथमिकता की अनुमति दें",
  T_49_META_TYP_318_I21_D: "लक्ष्य सहायता दूरी प्राथमिकता न्यूनतम दूरी",
  T_49_META_TYP_318_I22_D: "लक्ष्य सहायता दूरी प्राथमिकता अधिकतम दूरी",
  T_49_META_TYP_318_I23_D: "लक्ष्य सहायता दूरी प्राथमिकता प्रभाव गुणांक (>=1)",
  T_49_META_TYP_318_I24_D: "ADS घूर्णन संवेदनशीलता",
  T_49_META_TYP_318_I25_D: "अभिसरण दर",
  T_49_META_TYP_318_I3_D: "गोला-बारूद क्लिप आकार",
  T_49_META_TYP_318_I4_D: "हमले का अंतराल",
  T_49_META_TYP_318_I5_D: "पुनः लोड गति",
  T_49_META_TYP_318_I6_D: "स्वचालित पुनः लोड गति",
  T_49_META_TYP_318_I7_D: "स्कैटर स्पीड",
  T_49_META_TYP_318_I8_D: "झुकने या लेटने पर बिखराव दर। हर 0.1 का मतलब है कि प्रत्येक गोली के लिए क्रॉसहेयर रेंज 10% बढ़ जाती है।",
  T_49_META_TYP_318_I9_D: "अधिकतम फैलाव",
  T_49_META_TYP_319_I0_D: "सरल",
  T_49_META_TYP_319_I1_D: "स्लाइस",
  T_49_META_TYP_319_I2_D: "टाइल्ड",
  T_49_META_TYP_319_I3_D: "भरा हुआ",
  T_49_META_TYP_319_I4_D: "फिट",
  T_49_META_TYP_32_I0_D: "प्लेयर सामान्य सक्रिय अवस्था में है",
  T_49_META_TYP_32_I1_D: "खिलाड़ी बेहोश अवस्था में है",
  T_49_META_TYP_32_I2_D: "खिलाड़ी मृत अवस्था में है",
  T_49_META_TYP_320_I0_D: "क्षैतिज",
  T_49_META_TYP_320_I1_D: "ऊर्ध्वाधर",
  T_49_META_TYP_320_I2_D: "रेडियल 90°",
  T_49_META_TYP_320_I3_D: "रेडियल 180°",
  T_49_META_TYP_320_I4_D: "रेडियल 360°",
  T_49_META_TYP_321_I0_D: "लक्ष्य सहायता को सक्रिय करने की अधिकतम दूरी",
  T_49_META_TYP_321_I1_D: "जब सहायता प्राप्त लक्ष्यीकरण को ट्रिगर किया जाता है तो क्रॉसहेयर ऑफ़सेट होता है। यदि ऑफ़सेट बिंदु इकाई में नहीं है, तो सहायता प्राप्त लक्ष्यीकरण विफल हो जाएगा।",
  T_49_META_TYP_322_I0_D: "कोई नहीं",
  T_49_META_TYP_322_I1_D: "सिर",
  T_49_META_TYP_322_I2_D: "शरीर",
  T_49_META_TYP_322_I3_D: "अंग",
  T_49_META_TYP_323_I0_D: "पैमाना",
  T_49_META_TYP_323_I1_D: "अकाउंट आईडी",
  T_49_META_TYP_323_I2_D: "खिलाड़ी प्रोफ़ाइल जानकारी",
  T_49_META_TYP_323_I3_D: "शैली",
  T_49_META_TYP_323_I4_D: "रैंक दिखाएँ",
  T_49_META_TYP_323_I5_D: "पिन दिखाएँ",
  T_49_META_TYP_323_I6_D: "उपनाम दिखाएँ",
  T_49_META_TYP_324_I0_D: "निर्दिष्ट परिमाण का बल उत्पन्न करता है",
  T_49_META_TYP_324_I1_D: "निर्दिष्ट परिमाण का त्वरण उत्पन्न करता है",
  T_49_META_TYP_324_I2_D: "निर्दिष्ट आकार का आवेग उत्पन्न करता है",
  T_49_META_TYP_324_I3_D: "निर्दिष्ट आकार की गति उत्पन्न करता है",
  T_49_META_TYP_326_I0_D: "खाता आईडी",
  T_49_META_TYP_326_I1_D: "अवतार आईडी",
  T_49_META_TYP_326_I2_D: "बैनर आईडी",
  T_49_META_TYP_326_I3_D: "पिन आईडी",
  T_49_META_TYP_326_I4_D: "खिलाड़ी का उपनाम",
  T_49_META_TYP_326_I5_D: "BR रैंक",
  T_49_META_TYP_326_I6_D: "उच्चतम BR रैंक",
  T_49_META_TYP_326_I7_D: "CS रैंक",
  T_49_META_TYP_326_I8_D: "उच्चतम CS रैंक",
  T_49_META_TYP_327_I0_D: "संसाधन आईडी",
  T_49_META_TYP_327_I1_D: "पार्क मास्क 1",
  T_49_META_TYP_327_I2_D: "पार्ट मास्क 2",
  T_49_META_TYP_327_I3_D: "पार्ट मास्क 3",
  T_49_META_TYP_327_I4_D: "पार्ट मास्क 4",
  T_49_META_TYP_329_I0_D: "चालक",
  T_49_META_TYP_329_I1_D: "यात्री A",
  T_49_META_TYP_329_I2_D: "यात्री B",
  T_49_META_TYP_329_I3_D: "यात्री C",
  T_49_META_TYP_33_I0_D: "आरोही क्रम में, शून्य मानों को नजरअंदाज कर दिया जाता है और अंतिम रूप से क्रमबद्ध किया जाता है।",
  T_49_META_TYP_33_I1_D: "अवरोही, बड़े से छोटे",
  T_49_META_TYP_33_I2_D: "आरोही, छोटे से बड़े",
  T_49_META_TYP_330_I4_D: "अजेयता प्रभाव की अवधि (इकाई: s)",
  T_49_META_TYP_330_I5_D: "नियंत्रण केंद्र",
  T_49_META_TYP_330_I8_D: "डेल्टा मान",
  T_49_META_TYP_332_I0_D: "लूप है",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "सुपरमार्केट",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "संसाधन पथ, डिफ़ॉल्ट रूप से रिक्त",
  T_49_META_TYP_335_I1_D: "प्ले की संख्या, डिफ़ॉल्ट 1 है",
  T_49_META_TYP_335_I2_D: "वॉल्यूम, डिफ़ॉल्ट 50 है",
  T_49_META_TYP_335_I3_D: "अधिकतम दूरी",
  T_49_META_TYP_335_I4_D: "न्यूनतम दूरी",
  T_49_META_TYP_335_I5_D: "क्या यह 3D संगीत है?",
  T_49_META_TYP_335_I6_D: "प्राथमिकता",
  T_49_META_TYP_335_I7_D: "शुरू करने से पहले प्रतीक्षा समय, सेकंड में",
  T_49_META_TYP_335_I8_D: "खेल रहा है",
  T_49_META_TYP_338_I0_D: "मोबाइल स्थिति",
  T_49_META_TYP_338_I1_D: "स्प्रिंट स्थिति",
  T_49_META_TYP_338_I2_D: "हमले की स्थिति",
  T_49_META_TYP_338_I3_D: "जम्प स्टेट",
  T_49_META_TYP_338_I4_D: "चढ़ाई की अवस्था",
  T_49_META_TYP_338_I5_D: "वाहन में प्रवेश करें (चालक)",
  T_49_META_TYP_338_I6_D: "वाहन में प्रवेश (यात्री)",
  T_49_META_TYP_338_I7_D: "वाहन से बाहर निकलें",
  T_49_META_TYP_338_I8_D: "ड्राइव",
  T_49_META_TYP_339_I0_D: "अंग क्षति अनुपात",
  T_49_META_TYP_339_I1_D: "सिर क्षति अनुपात",
  T_49_META_TYP_339_I2_D: "अधिकतम स्थायित्व अनुपात",
  T_49_META_TYP_339_I3_D: "अतिरिक्त HP अनुपात",
  T_49_META_TYP_339_I4_D: "अतिरिक्त विस्फोट क्षति न्यूनीकरण कारक (%)",
  T_49_META_TYP_339_I5_D: "अतिरिक्त बैकपैक क्षमता",
  T_49_META_TYP_339_I6_D: "प्रतिस्थापन प्राथमिकता",
  T_49_META_TYP_34_I0_D: "डिफ़ॉल्ट मुट्ठी",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "फेमस-I",
  T_49_META_TYP_34_I101_D: "ग्रोज़ा-एक्स",
  T_49_META_TYP_34_I102_D: "एसवीडी-वाई",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "एम4ए1-आई",
  T_49_META_TYP_34_I106_D: "एम4ए1-II",
  T_49_META_TYP_34_I107_D: "एम4ए1-III",
  T_49_META_TYP_34_I108_D: "एम4ए1-III",
  T_49_META_TYP_34_I109_D: "चार्ज्ड शॉटगन",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "हाथ का गोला",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "शील्ड गन",
  T_49_META_TYP_34_I114_D: "एमपी5-II",
  T_49_META_TYP_34_I115_D: "एमपी5-III",
  T_49_META_TYP_34_I116_D: "एमपी5-III",
  T_49_META_TYP_34_I117_D: "एम60-II",
  T_49_META_TYP_34_I118_D: "एम60-III",
  T_49_META_TYP_34_I119_D: "एम60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "वीएसएस-II",
  T_49_META_TYP_34_I121_D: "वीएसएस-III",
  T_49_META_TYP_34_I122_D: "एम14-II",
  T_49_META_TYP_34_I123_D: "एम14-III",
  T_49_META_TYP_34_I124_D: "एम14-III",
  T_49_META_TYP_34_I125_D: "कर98के-II",
  T_49_META_TYP_34_I126_D: "कर98के-III",
  T_49_META_TYP_34_I127_D: "कर98के-III",
  T_49_META_TYP_34_I128_D: "फेमस-II",
  T_49_META_TYP_34_I129_D: "फेमस-III",
  T_49_META_TYP_34_I13_D: "ज्वाला ग्रेनेड",
  T_49_META_TYP_34_I133_D: "फ्लैशबैंग",
  T_49_META_TYP_34_I134_D: "धुआँ ग्रेनेड",
  T_49_META_TYP_34_I135_D: "ठंडक ग्रेनेड",
  T_49_META_TYP_34_I136_D: "बुलेटप्रूफ वेस्ट Lv1",
  T_49_META_TYP_34_I137_D: "बुलेटप्रूफ वेस्ट Lv2",
  T_49_META_TYP_34_I138_D: "बुलेटप्रूफ वेस्ट Lv3",
  T_49_META_TYP_34_I139_D: "हेलमेट Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "हेलमेट Lv2",
  T_49_META_TYP_34_I141_D: "हेलमेट Lv3",
  T_49_META_TYP_34_I142_D: "विस्फोट-रोधी कवच",
  T_49_META_TYP_34_I143_D: "बैकपैक Lv1",
  T_49_META_TYP_34_I144_D: "बैकपैक Lv2",
  T_49_META_TYP_34_I145_D: "बैकपैक Lv3",
  T_49_META_TYP_34_I146_D: "थूथन Lv1",
  T_49_META_TYP_34_I147_D: "थूथन Lv2",
  T_49_META_TYP_34_I148_D: "थूथन Lv3",
  T_49_META_TYP_34_I149_D: "गुलबंद",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "आक्रमण थूथन",
  T_49_META_TYP_34_I151_D: "चौड़ा थूथन",
  T_49_META_TYP_34_I152_D: "पत्रिका Lv1",
  T_49_META_TYP_34_I153_D: "पत्रिका Lv2",
  T_49_META_TYP_34_I154_D: "पत्रिका Lv3",
  T_49_META_TYP_34_I155_D: "डबल बंडल पत्रिका",
  T_49_META_TYP_34_I156_D: "चेन पत्रिका",
  T_49_META_TYP_34_I157_D: "ग्रिप Lv1",
  T_49_META_TYP_34_I158_D: "ग्रिप Lv2",
  T_49_META_TYP_34_I159_D: "ग्रिप Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "फोल्डिंग स्टैंड",
  T_49_META_TYP_34_I161_D: "मार्क्समैन राइफल ग्रिप",
  T_49_META_TYP_34_I162_D: "शॉटगन स्टॉक",
  T_49_META_TYP_34_I163_D: "स्नाइपर राइफल बटस्टॉक",
  T_49_META_TYP_34_I164_D: "थर्मल इमेजिंग स्कोप",
  T_49_META_TYP_34_I165_D: "स्टॉक Lv1",
  T_49_META_TYP_34_I166_D: "स्टॉक Lv2",
  T_49_META_TYP_34_I167_D: "स्टॉक Lv3",
  T_49_META_TYP_34_I168_D: "शील्ड एक्सटेंडर",
  T_49_META_TYP_34_I169_D: "पूर्ण शरीर कवच",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "अत्यधिक इंटरलेयर",
  T_49_META_TYP_34_I171_D: "विस्फोट-रोधी इंटरलेयर",
  T_49_META_TYP_34_I172_D: "बैकपैक विस्तार",
  T_49_META_TYP_34_I173_D: "उपचार श्वसन यंत्र",
  T_49_META_TYP_34_I174_D: "क्षैतिज रेखा",
  T_49_META_TYP_34_I175_D: "चिकित्सा किट",
  T_49_META_TYP_34_I176_D: "कवच मरम्मत किट",
  T_49_META_TYP_34_I177_D: "उच्च तकनीक सामग्री से बना कृत्रिम बुद्धिमत्ता संतरी टॉवर एक निश्चित सीमा के भीतर दुश्मनों को सक्रिय रूप से खोजेगा और हमला करेगा।",
  T_49_META_TYP_34_I178_D: "लेवल 1 मशरूम",
  T_49_META_TYP_34_I179_D: "लेवल 2 मशरूम",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "लेवल 3 मशरूम",
  T_49_META_TYP_34_I181_D: "स्तर 4 मशरूम",
  T_49_META_TYP_34_I182_D: "व्यक्तिगत UAV",
  T_49_META_TYP_34_I184_D: "निकटता खान",
  T_49_META_TYP_34_I185_D: "जेट उड़ान जूते",
  T_49_META_TYP_34_I186_D: "बाउंस पावर बूट्स",
  T_49_META_TYP_34_I187_D: "हैंग ग्लाइडिंग",
  T_49_META_TYP_34_I188_D: "नकली ग्रेनेड",
  T_49_META_TYP_34_I189_D: "चुंबकीय होवरबोर्ड",
  T_49_META_TYP_34_I19_D: "रेगिस्तानी बाज",
  T_49_META_TYP_34_I190_D: "बम निरोधक चिमटा",
  T_49_META_TYP_34_I191_D: "गन अपग्रेडर",
  T_49_META_TYP_34_I192_D: "राइफल गोला-बारूद",
  T_49_META_TYP_34_I193_D: "पिस्तौल गोला-बारूद",
  T_49_META_TYP_34_I194_D: "स्नाइपर राइफल की गोली",
  T_49_META_TYP_34_I195_D: "शॉटगन की गोली",
  T_49_META_TYP_34_I196_D: "एसएमजी की गोली",
  T_49_META_TYP_34_I197_D: "तीर",
  T_49_META_TYP_34_I198_D: "M79 ग्रेनेड",
  T_49_META_TYP_34_I199_D: "आग फेंकने वाली गोली",
  T_49_META_TYP_34_I2_D: "क्रॉसबो",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "थ्रोइंगनाइफ2",
  T_49_META_TYP_34_I201_D: "हुक",
  T_49_META_TYP_34_I202_D: "फुटबॉल गन",
  T_49_META_TYP_34_I203_D: "मुक्केबाज़ी",
  T_49_META_TYP_34_I204_D: "फ्लेमथ्रोवर",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "मेडमैनएकार्ड",
  T_49_META_TYP_34_I207_D: "Djmaleकार्ड",
  T_49_META_TYP_34_I208_D: "ग्रैफ़िटिस्टकार्ड",
  T_49_META_TYP_34_I209_D: "डिटेक्टिवकार्ड",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "प्रोफेसरकार्ड",
  T_49_META_TYP_34_I211_D: "बाउंटीहंटरकार्ड",
  T_49_META_TYP_34_I212_D: "सुपरस्टारकार्ड",
  T_49_META_TYP_34_I213_D: "एक्सट्रीमकार्ड",
  T_49_META_TYP_34_I214_D: "म्यूज़िकब्रोकार्ड",
  T_49_META_TYP_34_I215_D: "केंटाकार्ड",
  T_49_META_TYP_34_I216_D: "ट्रैकर कार्ड",
  T_49_META_TYP_34_I217_D: "क्रेजीगर्लकार्ड",
  T_49_META_TYP_34_I218_D: "रनस्पीडअपकार्ड",
  T_49_META_TYP_34_I219_D: "सैंटिनोकार्ड",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "विलेनकार्ड",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "स्कार-I",
  T_49_META_TYP_34_I25_D: "स्कार-II",
  T_49_META_TYP_34_I26_D: "स्कार-III",
  T_49_META_TYP_34_I27_D: "एम1014-आई",
  T_49_META_TYP_34_I28_D: "एम1014-II",
  T_49_META_TYP_34_I29_D: "एम1014-III",
  T_49_META_TYP_34_I3_D: "फ़ुटबॉल शील्ड",
  T_49_META_TYP_34_I30_D: "सुपरहीट एनर्जी गन",
  T_49_META_TYP_34_I31_D: "ओवरहीट गन-I",
  T_49_META_TYP_34_I32_D: "सुपरहीट गन-II",
  T_49_META_TYP_34_I33_D: "सुपरहीट गन-III",
  T_49_META_TYP_34_I34_D: "प्लाज्मा-एक्स",
  T_49_META_TYP_34_I35_D: "हीलिंग पिस्टल-वाई",
  T_49_META_TYP_34_I36_D: "हील स्नाइपर",
  T_49_META_TYP_34_I37_D: "हीलिंग पिस्तौल",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "तलने की कड़ाही",
  T_49_META_TYP_34_I44_D: "एक प्रकार का कुलहाड़ा",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "एम249-एक्स",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "बेस्बाल का बल्ला",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "कटाना",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "गैटलिंग",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "शक्तिशाली हुक गन",
  T_49_META_TYP_34_I71_D: "एफएफ चाकू",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 गोलियां 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "एम82बी",
  T_49_META_TYP_34_I78_D: "एम82बी",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "कठफोड़वा",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "मैग-7",
  T_49_META_TYP_34_I85_D: "मैग-7",
  T_49_META_TYP_34_I86_D: "घास काटने का आला",
  T_49_META_TYP_34_I87_D: "हथौड़ा",
  T_49_META_TYP_34_I88_D: "फेंकने वाला चाकू (पिकअप)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "खासियत -2",
  T_49_META_TYP_34_I92_D: "किंगफिशर",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "एमपी5-I",
  T_49_META_TYP_34_I95_D: "एम60-आई",
  T_49_META_TYP_34_I96_D: "वीएसएस-I",
  T_49_META_TYP_34_I97_D: "एम14-आई",
  T_49_META_TYP_34_I98_D: "कर98के-आई",
  T_49_META_TYP_34_I99_D: "AWM_वाई",
  T_49_META_TYP_340_I0_D: "आसान",
  T_49_META_TYP_340_I1_D: "सरल",
  T_49_META_TYP_340_I2_D: "सामान्य",
  T_49_META_TYP_340_I3_D: "मध्यम",
  T_49_META_TYP_340_I4_D: "कठिन",
  T_49_META_TYP_340_I5_D: "नरक",
  T_49_META_TYP_342_I0_D: "स्टार्ट इवेंट",
  T_49_META_TYP_342_I1_D: "स्टॉप इवेंट",
  T_49_META_TYP_342_I2_D: "पॉज़ इवेंट",
  T_49_META_TYP_342_I3_D: "समय निर्धारण शुरू करने के लिए बनाए जाने के बाद कितनी देर तक प्रतीक्षा करनी है, मिलीसेकंड में",
  T_49_META_TYP_342_I4_D: "लूप काउंट",
  T_49_META_TYP_342_I5_D: "इवेंट्स",
  T_49_META_TYP_342_I6_D: "उल्टी गिनती या उल्टी गिनती",
  T_49_META_TYP_342_I7_D: "खिलाड़ी की स्थिति",
  T_49_META_TYP_342_I8_D: "टाइमिंग का अंतिम समय, सेकंड में",
  T_49_META_TYP_345_I10_D: "हाथ का गोला",
  T_49_META_TYP_345_I12_D: "बर्फ़ दीवार गन",
  T_49_META_TYP_345_I13_D: "फ्लेमथ्रोवर",
  T_49_META_TYP_345_I4_D: "मशीनगन",
  T_49_META_TYP_345_I6_D: "विशेष गन",
  T_49_META_TYP_345_I8_D: "चार्ज गन",
  T_49_META_TYP_346_I0_D: "राइफल गोला-बारूद",
  T_49_META_TYP_346_I1_D: "पिस्तौल गोला-बारूद",
  T_49_META_TYP_346_I2_D: "स्नाइपर राइफल की गोली",
  T_49_META_TYP_346_I3_D: "शॉटगन की गोली",
  T_49_META_TYP_346_I4_D: "एसएमजी की गोली",
  T_49_META_TYP_346_I5_D: "तीर",
  T_49_META_TYP_346_I6_D: "M79 ग्रेनेड",
  T_49_META_TYP_346_I7_D: "हुक",
  T_49_META_TYP_346_I8_D: "M79 विशेष ग्रेनेड",
  T_49_META_TYP_347_I3_D: "जब सत्य हो, तो इसे सापेक्ष गति के साथ जोड़ा जा सकता है। जब असत्य हो, तो इसे निरपेक्ष गति के साथ जोड़ा जाना चाहिए, अन्यथा गुण सही ढंग से प्रभावी नहीं होगा।",
  T_49_META_TYP_347_I6_D: "डेल्टा मान",
  T_49_META_TYP_350_I0_D: "स्पोर्ट्स कार",
  T_49_META_TYP_350_I1_D: "मोटरसाइकिल",
  T_49_META_TYP_350_I2_D: "जीप",
  T_49_META_TYP_350_I3_D: "एसयूवी",
  T_49_META_TYP_350_I4_D: "राक्षस ट्रक",
  T_49_META_TYP_350_I5_D: "टुक टुक",
  T_49_META_TYP_352_I1_D: "अचयनित स्प्राइट",
  T_49_META_TYP_352_I2_D: "कोई छवि प्रकार चयनित नहीं",
  T_49_META_TYP_352_I3_D: "अचयनित रंग",
  T_49_META_TYP_352_I4_D: "चयनित स्प्राइट",
  T_49_META_TYP_352_I5_D: "छवि प्रकार चुनें",
  T_49_META_TYP_352_I6_D: "चयनित रंग",
  T_49_META_TYP_353_I0_D: "HP पुनर्प्राप्ति मात्रा",
  T_49_META_TYP_353_I1_D: "HP रिकवरी स्पीड (ms)",
  T_49_META_TYP_353_I2_D: "आवश्यक समय (मिलीसेकंड)",
  T_49_META_TYP_354_I0_D: "EP पुनर्प्राप्ति मात्रा",
  T_49_META_TYP_355_I0_D: "HP पुनर्प्राप्ति मात्रा",
  T_49_META_TYP_355_I1_D: "EP पुनर्प्राप्ति मात्रा",
  T_49_META_TYP_355_I2_D: "आवश्यक समय (मिलीसेकंड)",
  T_49_META_TYP_356_I0_D: "ड्रॉप आइटम्स",
  T_49_META_TYP_356_I1_D: "एयरड्रॉप बॉक्स ड्रॉप समय मि.से.",
  T_49_META_TYP_356_I2_D: "एयर ड्रॉप स्टेट",
  T_49_META_TYP_357_I0_D: "सरफेस",
  T_49_META_TYP_357_I1_D: "सीमा",
  T_49_META_TYP_359_I0_D: "भौतिकी के साथ प्लेयर कंट्रोलर का उपयोग करना है या नहीं",
  T_49_META_TYP_359_I1_D: "यदि इसे इस कोण से अधिक ढलान पर रखा जाए तो यह नीचे की ओर खिसकेगा",
  T_49_META_TYP_359_I10_D: "यह गुरुत्वाकर्षण त्वरण केवल खिलाड़ी नियंत्रक पर लागू होता है।",
  T_49_META_TYP_359_I11_D: "द्रव्यमान, किलोग्राम",
  T_49_META_TYP_359_I12_D: "यदि ढलान अधिकतम चढ़ाई कोण से अधिक हो जाए तो यह नीचे की ओर खिसक जाएगी।",
  T_49_META_TYP_359_I16_D: "खुलने के बाद, सर्वर-साइड प्रिमिटिव या स्क्रिप्ट मूवमेंट को नियंत्रित करते हैं",
  T_49_META_TYP_359_I17_D: "सक्षम होने पर, कठोर शरीर को धकेलते समय पात्र द्वारा लगाया गया बल अनुकूलित किया जा सकता है",
  T_49_META_TYP_359_I18_D: "जब पात्र दृढ़ पिंड को धक्का देता है तो लागू बल की मात्रा",
  T_49_META_TYP_359_I19_D: "सत्य तब होता है जब निचला भाग कोलाइडर को छूता है, आमतौर पर इसका उपयोग यह निर्धारित करने के लिए किया जाता है कि खिलाड़ी जमीन पर है या नहीं",
  T_49_META_TYP_359_I2_D: "केवल इस ऊंचाई से अधिक की बाधाओं पर ही अवरोध प्रभाव पड़ेगा। मान सीमा [0, ऊंचाई] है",
  T_49_META_TYP_359_I20_D: "कस्टम भौतिक स्तर, मान [0,15]",
  T_49_META_TYP_359_I21_D: "गुरुत्वाकर्षण के साथ घुमाव सक्षम करें",
  T_49_META_TYP_359_I3_D: "कैप्सूल की वह गहराई जो एम्बेड की जा सकती है। यह चरित्र को अटकने या हिलने से रोक सकता है। जब तक कोई विशेष आवश्यकता न हो, इसे संशोधित करने की अनुशंसा नहीं की जाती है। मान सीमा (0, त्रिज्या]",
  T_49_META_TYP_359_I4_D: "न्यूनतम गति दूरी। इस मान से कम गति नहीं की जाएगी। यदि कोई विशेष आवश्यकता न हो तो इसे 0 पर ही रखने की अनुशंसा की जाती है",
  T_49_META_TYP_359_I5_D: "स्थानीय निर्देशांक मूल से टक्कर बॉक्स केंद्र का ऑफसेट",
  T_49_META_TYP_359_I6_D: "कैप्सूल की त्रिज्या, न्यूनतम मान 0.01 है",
  T_49_META_TYP_359_I7_D: "कैप्सूल की कुल ऊंचाई, ऊपरी और निचले गोलार्धों सहित, न्यूनतम मान 2*त्रिज्या के साथ",
  T_49_META_TYP_359_I8_D: "वर्तमान रेखीय गति, मीटर/सेकेंड में",
  T_49_META_TYP_360_I0_D: "बाईं ओर फायरिंग आर्क कोण",
  T_49_META_TYP_360_I1_D: "दाईं ओर फायरिंग आर्क कोण",
  T_49_META_TYP_360_I2_D: "न्यूनतम ऊँचाई कोण",
  T_49_META_TYP_360_I3_D: "अधिकतम अवनति कोण",
  T_49_META_TYP_360_I4_D: "नाल वेग",
  T_49_META_TYP_362_I0_D: "प्लेयर को हिट करने के बाद फ़्रीज़ होने का समय, सेकंड में",
  T_49_META_TYP_363_I0_D: "HUD अनुरोध खरीद अक्षम करें",
  T_49_META_TYP_363_I1_D: "खरीदारी में मदद के लिए टीम से पूछें",
  T_49_META_TYP_363_I2_D: "खरीदारी में मदद के लिए गुट से पूछें",
  T_49_META_TYP_364_I0_D: "सेंटर पोजीशन है",
  T_49_META_TYP_364_I1_D: "चाहे लूप करना हो",
  T_49_META_TYP_364_I2_D: "एनिमेशन का नाम",
  T_49_META_TYP_364_I3_D: "स्वचालित रूप से चलाना है या नहीं",
  T_49_META_TYP_364_I4_D: "कस्टम रिसोर्स यूज़",
  T_49_META_TYP_366_I0_D: "प्रस्तुत किये जाने वाले बैच संसाधन का UUID निर्दिष्ट करें",
  T_49_META_TYP_367_I1_D: "शो टैग",
  T_49_META_TYP_367_I2_D: "लक्ष्य चिन्हित करने के लिए आइकन शैली",
  T_49_META_TYP_367_I3_D: "लक्ष्य को चिह्नित करते समय प्रदर्शित आइकन का ओवरले रंग",
  T_49_META_TYP_367_I4_D: "पैमाने पर प्रदर्शित आइकन शैली",
  T_49_META_TYP_367_I5_D: "आइकन ओवरले रंग एक पैमाने पर प्रदर्शित होता है",
  T_49_META_TYP_367_I6_D: "हमेशा मार्क दिखाएं",
  T_49_META_TYP_370_I0_D: "मुख्य शीर्षक",
  T_49_META_TYP_370_I1_D: "सबटाइटल",
  T_49_META_TYP_370_I2_D: "शीर्ष पृष्ठभूमि रंग",
  T_49_META_TYP_370_I3_D: "नीचे पृष्ठभूमि का रंग",
  T_49_META_TYP_371_I2_D: "लेफ्ट स्कोर",
  T_49_META_TYP_371_I3_D: "राइट स्कोर",
  T_49_META_TYP_371_I4_D: "बायीं ओर अंतिम स्कोर, जिसका उपयोग स्कोर स्विचिंग एनीमेशन चलाने के लिए किया जाता है",
  T_49_META_TYP_371_I5_D: "दाईं ओर का अंतिम स्कोर स्कोर स्विचिंग एनीमेशन चलाने के लिए उपयोग किया जाता है",
  T_49_META_TYP_372_I0_D: "खड़ा",
  T_49_META_TYP_372_I1_D: "झुकने दिखाएँ",
  T_49_META_TYP_372_I10_D: "उच्च ऊंचाई पर गिरावट",
  T_49_META_TYP_372_I11_D: "कम ऊंचाई से गिरना, जैसे कूदना",
  T_49_META_TYP_372_I12_D: "उड़ने वाले जूते",
  T_49_META_TYP_372_I13_D: "डबल जंप",
  T_49_META_TYP_372_I14_D: "कुर्सी पर बैठो",
  T_49_META_TYP_372_I15_D: "गुलेल द्वारा बाहर निकाला जाना",
  T_49_META_TYP_372_I16_D: "गुलेल तैयारी चरण",
  T_49_META_TYP_372_I17_D: "ग्लाइडिंग प्रॉप्स ग्लाइडिंग",
  T_49_META_TYP_372_I18_D: "ग्लाइडिंग प्रोप ड्रॉप",
  T_49_META_TYP_372_I19_D: "टायरों से उछलकर",
  T_49_META_TYP_372_I2_D: "दौड़ना",
  T_49_META_TYP_372_I20_D: "मानव टायर से उछला",
  T_49_META_TYP_372_I21_D: "पार्टी क्षेत्र में एक कार्रवाई",
  T_49_META_TYP_372_I22_D: "एक विमान ले लो",
  T_49_META_TYP_372_I23_D: "तोप में प्रवेश करें",
  T_49_META_TYP_372_I24_D: "तोप, वाहन आदि से बाहर निकलते समय, यदि जिस वस्तु पर आप सवार हैं वह उड़ रही है, तो यह स्थिति होती है",
  T_49_META_TYP_372_I25_D: "स्प्रिंगबोर्ड से कूदने के बाद",
  T_49_META_TYP_372_I26_D: "ज़िपलाइन से उतरें",
  T_49_META_TYP_372_I27_D: "उपयोग नहीं किया",
  T_49_META_TYP_372_I3_D: "घुटनों के बल चलना",
  T_49_META_TYP_372_I4_D: "तेज़ तैराकी",
  T_49_META_TYP_372_I5_D: "ऊर्ध्वाधर गिरावट",
  T_49_META_TYP_372_I6_D: "वॉल के ऊपर से",
  T_49_META_TYP_372_I7_D: "उपयोग नहीं किया",
  T_49_META_TYP_372_I8_D: "गिरा दिया गया लेकिन मरा नहीं",
  T_49_META_TYP_372_I9_D: "जल बोर्ड का उपयोग करें",
  T_49_META_TYP_374_I0_D: "स्वास्थ्य, स्तर और स्ट्रोक रंग",
  T_49_META_TYP_374_I1_D: "जैसे-जैसे स्वास्थ्य कम होता जाता है, गायब हिस्सा कुछ समय के लिए यह रंग प्रदर्शित करता है",
  T_49_META_TYP_374_I10_D: "अनुसरण करने के लिए लक्ष्य के सापेक्ष ऑफसेट",
  T_49_META_TYP_374_I11_D: "प्रत्येक दो विभाजन रेखाओं के बीच स्वास्थ्य मान प्रदर्शित नहीं किया जाएगा यदि यह 0 से कम या बराबर है",
  T_49_META_TYP_374_I12_D: "कुल HP",
  T_49_META_TYP_374_I13_D: "वर्तमान HP",
  T_49_META_TYP_374_I14_D: "सक्षम होने पर, स्वास्थ्य परिवर्तन अलग-अलग रंगों में प्रदर्शित किए जाएंगे",
  T_49_META_TYP_374_I15_D: "सक्षम होने पर, ऑफसेट गुण स्थानीय निर्देशांक प्रणाली का उपयोग करके विश्व निर्देशांक में परिवर्तित हो जाते हैं।",
  T_49_META_TYP_374_I2_D: "जब स्वास्थ्य बढ़ता है, तो बढ़ा हुआ भाग कुछ समय के लिए यह रंग प्रदर्शित करता है",
  T_49_META_TYP_374_I3_D: "स्वास्थ्य सीमा और धुंधले तल का रंग",
  T_49_META_TYP_374_I4_D: "रेंज 0~1, समग्र UI की पारदर्शिता",
  T_49_META_TYP_374_I5_D: "समग्र UI स्केलिंग निर्धारित करता है, और फ़ॉन्ट को एक साथ स्केल किया जाता है",
  T_49_META_TYP_374_I6_D: "वर्तमान स्वास्थ्य पट्टी के स्वामी का नाम इंगित करता है",
  T_49_META_TYP_374_I8_D: "स्क्रीन पर प्रदर्शित स्वास्थ्य पट्टी की लंबाई",
  T_49_META_TYP_374_I9_D: "ट्रांसफ़ॉर्म घटक के साथ किसी इकाई का अनुसरण करना चाहिए",
  T_49_META_TYP_375_I1_D: "लड़ाकू इकाई",
  T_49_META_TYP_376_I1_D: "लड़ाकू इकाई",
  T_49_META_TYP_38_I0_D: "अल्फा",
  T_49_META_TYP_382_I0_D: "गलती करना",
  T_49_META_TYP_382_I1_D: "नॉकडाउन स्थिति को छोड़ें और सीधे मरें",
  T_49_META_TYP_382_I2_D: "गिराने को छोड़ें नहीं",
  T_49_META_TYP_387_I1_D: "बाहर दबाने की अनुमति",
  T_49_META_TYP_389_I0_D: "आधार का डिफ़ॉल्ट ऑफ़सेट",
  T_49_META_TYP_389_I1_D: "पृष्ठभूमि स्प्राइट",
  T_49_META_TYP_389_I10_D: "अक्रिय अल्फा",
  T_49_META_TYP_389_I2_D: "पृष्ठभूमि त्रिज्या",
  T_49_META_TYP_389_I3_D: "जॉयस्टिक कैप छवि",
  T_49_META_TYP_389_I4_D: "जॉयस्टिक कैप त्रिज्या",
  T_49_META_TYP_389_I5_D: "जॉयस्टिक कैप ड्रैग त्रिज्या",
  T_49_META_TYP_389_I6_D: "तीर स्प्राइट",
  T_49_META_TYP_389_I7_D: "तीर आकार",
  T_49_META_TYP_389_I8_D: "तीर ऑफ़सेट",
  T_49_META_TYP_389_I9_D: "सक्रिय अल्फा",
  T_49_META_TYP_39_I1_D: "स्प्राइट आकार",
  T_49_META_TYP_39_I10_D: "ग्रेडियंट ऊपर",
  T_49_META_TYP_39_I11_D: "ग्रेडियंट नीचे",
  T_49_META_TYP_39_I12_D: "ऊपर का अल्फा",
  T_49_META_TYP_39_I13_D: "नीचे का अल्फा",
  T_49_META_TYP_39_I3_D: "फ्लिप",
  T_49_META_TYP_39_I4_D: "भरा हुआ",
  T_49_META_TYP_39_I5_D: "केंद्र अदृश्य",
  T_49_META_TYP_39_I6_D: "भरने की दिशा",
  T_49_META_TYP_39_I7_D: "भरने की मात्रा",
  T_49_META_TYP_39_I8_D: "भरना पलटना",
  T_49_META_TYP_39_I9_D: "ग्रेडियंट",
  T_49_META_TYP_392_I0_D: "खेल में प्रत्येक राउंड में सुरक्षित क्षेत्र प्रकट होने का समय, डिफ़ॉल्ट मान 0 है, इकाई ms है",
  T_49_META_TYP_392_I1_D: "वृत्त को छोटा करने में लगा समय, ms में",
  T_49_META_TYP_392_I10_D: "सिकुड़ते वृत्त का अंतिम समय, ms में",
  T_49_META_TYP_392_I12_D: "ज़हर चक्र अंत त्रिज्या",
  T_49_META_TYP_392_I13_D: "सिकुड़ने के शुरू समय",
  T_49_META_TYP_392_I14_D: "डैमेज इंटरवल (ms)",
  T_49_META_TYP_392_I3_D: "विष चक्र में खिलाड़ियों को पहुंचाई गई क्षति की मात्रा।",
  T_49_META_TYP_392_I4_D: "सुरक्षित क्षेत्र में खिलाड़ियों की सूची",
  T_49_META_TYP_392_I5_D: "सुरक्षित क्षेत्र का गायब होने का समय। यदि सुरक्षित क्षेत्र का गायब होने का समय प्रभावी समय से कम है, तो कोई सुरक्षित क्षेत्र उत्पन्न नहीं होगा।",
  T_49_META_TYP_392_I6_D: "समूह ID",
  T_49_META_TYP_392_I7_D: "ज़हर चक्र की प्रारंभिक त्रिज्या",
  T_49_META_TYP_392_I8_D: "अंतिम स्थिति",
  T_49_META_TYP_392_I9_D: "स्थिति",
  T_49_META_TYP_394_I0_D: "इसका मान लगभग 3.1416 है",
  T_49_META_TYP_394_I1_D: "इसका मान लगभग 2.7183 है",
  T_49_META_TYP_396_I0_D: "शीर्षक",
  T_49_META_TYP_396_I1_D: "सामग्री",
  T_49_META_TYP_396_I2_D: "विकल्प",
  T_49_META_TYP_396_I3_D: "पृष्ठभूमि दिखाएं",
  T_49_META_TYP_399_I0_D: "कूद की ऊँचाई",
  T_49_META_TYP_399_I1_D: "लैंडिंग से पहले आप लगातार कितनी छलांग लगा सकते हैं",
  T_49_META_TYP_399_I2_D: "आप उतरने से पहले कई बार छलांग लगा सकते हैं।",
  T_49_META_TYP_399_I3_D: "हवा में मूवमेंट को सक्षम करें",
  T_49_META_TYP_40_I1_D: "लेबल",
  T_49_META_TYP_40_I10_D: "पंक्ति अंतर",
  T_49_META_TYP_40_I11_D: "अतिप्रवाह विधि",
  T_49_META_TYP_40_I12_D: "फ़ॉन्ट शैली",
  T_49_META_TYP_40_I13_D: "शैडो लागू करें",
  T_49_META_TYP_40_I14_D: "शैडो रंग",
  T_49_META_TYP_40_I15_D: "शैडो ऑफ़सेट",
  T_49_META_TYP_40_I3_D: "स्थानीयकरण कुंजी, एकाधिक भाषाओं में उपयोग की जा सकती है",
  T_49_META_TYP_40_I5_D: "संरेखण",
  T_49_META_TYP_40_I6_D: "लंबवत संरेखण",
  T_49_META_TYP_40_I7_D: "बोल्ड",
  T_49_META_TYP_40_I8_D: "इटैलिक",
  T_49_META_TYP_40_I9_D: "अंडरलाइन",
  T_49_META_TYP_400_I0_D: "सक्रिय",
  T_49_META_TYP_400_I1_D: "निष्क्रिय",
  T_49_META_TYP_400_I2_D: "कोई हमला नहीं",
  T_49_META_TYP_401_I0_D: "फायर नहीं कर सकते",
  T_49_META_TYP_401_I1_D: "लगातार फायर कर सकते हैं",
  T_49_META_TYP_401_I2_D: "प्रति आक्रमण आदेश पर एक बार फायर करता है",
  T_49_META_TYP_401_I3_D: "प्रत्येक आक्रमण कमांड तीन बार फायर करता है",
  T_49_META_TYP_401_I4_D: "प्रत्येक आक्रमण कमांड दो बार फायर करता है",
  T_49_META_TYP_401_I5_D: "प्रक्षेप्य",
  T_49_META_TYP_402_I0_D: "मित्र के रूप में जोड़ने का लक्ष्य",
  T_49_META_TYP_402_I1_D: "फ़ंक्शन प्रकार",
  T_49_META_TYP_402_I2_D: "शैली",
  T_49_META_TYP_403_I0_D: "मित्र जोड़ें",
  T_49_META_TYP_403_I1_D: "रिपोर्ट करें",
  T_49_META_TYP_404_I0_D: "हल्का",
  T_49_META_TYP_404_I1_D: "अंधेरा",
  T_49_META_TYP_405_I0_D: "श्रेणी द्वारा",
  T_49_META_TYP_405_I1_D: "उच्च से निम्न प्राथमिकता",
  T_49_META_TYP_405_I2_D: "कम से उच्च प्राथमिकता",
  T_49_META_TYP_406_I0_D: "खिलाड़ी की वॉल्टिंग क्रिया की दूरी को नियंत्रित करता है",
  T_49_META_TYP_406_I1_D: "ऊपर और नीचे चढ़ते समय खिलाड़ी के शरीर की ऊंचाई को नियंत्रित करता है",
  T_49_META_TYP_407_I0_D: "स्थानीय",
  T_49_META_TYP_407_I1_D: "क्लाइंट",
  T_49_META_TYP_407_I2_D: "सर्वर",
  T_49_META_TYP_407_I3_D: "दोनों",
  T_49_META_TYP_409_I0_D: "कोई त्रुटि नहीं",
  T_49_META_TYP_409_I1_D: "डेटा संग्रहण समय समाप्ति, मुख्यतः पठन कार्यों के लिए",
  T_49_META_TYP_409_I10_D: "टीम परिवर्तन विफल - अमान्य लक्ष्य टीम",
  T_49_META_TYP_409_I11_D: "टीम परिवर्तन विफल - मृत खिलाड़ियों को टीम बदलने की अनुमति नहीं है",
  T_49_META_TYP_409_I12_D: "टीम परिवर्तन विफल - वाहनों में टीम परिवर्तन की अनुमति नहीं है",
  T_49_META_TYP_409_I2_D: "डेटा संग्रहण पढ़ने और लिखने की आवृत्ति सीमा से अधिक हो जाती है",
  T_49_META_TYP_409_I3_D: "पैरामीटर असामान्यता",
  T_49_META_TYP_409_I4_D: "कमरा बनाने में विफल: कोई वैध व्यक्तित्व आईडी नहीं",
  T_49_META_TYP_409_I5_D: "अपरिभाषित त्रुटि स्थिति",
  T_49_META_TYP_409_I6_D: "वाणिज्यिक सेवाएँ बंद हैं और उपयोगकर्ता अब डेवलपर की सेवाओं का उपयोग नहीं कर सकते हैं",
  T_49_META_TYP_409_I7_D: "टीम परिवर्तन विफल - मोड समर्थित नहीं है",
  T_49_META_TYP_409_I8_D: "टीम परिवर्तन विफल - वर्तमान में लक्ष्य टीम में पहले से ही मौजूद है",
  T_49_META_TYP_409_I9_D: "टीम परिवर्तन विफल - अमान्य ऑब्जेक्ट",
  T_49_META_TYP_41_I0_D: "स्प्राइट आकार",
  T_49_META_TYP_41_I19_D: "टक्कर बॉक्स अक्षम करें",
  T_49_META_TYP_41_I3_D: "अक्षम रंग",
  T_49_META_TYP_41_I4_D: "दबाया गया रंग",
  T_49_META_TYP_41_I5_D: "भरने का प्रकार",
  T_49_META_TYP_41_I6_D: "FE बटन है",
  T_49_META_TYP_41_I7_D: "दबाया गया स्प्राइट",
  T_49_META_TYP_41_I8_D: "दबाया गया स्प्राइट प्रकार",
  T_49_META_TYP_41_I9_D: "फ्लिप प्रकार",
  T_49_META_TYP_411_I0_D: "फॉरवर्ड स्पीड",
  T_49_META_TYP_411_I1_D: "बैकवर्ड स्पीड",
  T_49_META_TYP_411_I2_D: "अप स्पीड",
  T_49_META_TYP_411_I3_D: "डाउन स्पीड",
  T_49_META_TYP_411_I4_D: "ग्रेनेड मिन डैमेज",
  T_49_META_TYP_411_I5_D: "ग्रेनेड मैक्स डैमेज",
  T_49_META_TYP_411_I6_D: "ग्रेनेड रेंज",
  T_49_META_TYP_412_I0_D: "थ्रॉटल बटन का उपयोग करने पर वाहन को मिलने वाली अश्वशक्ति की मात्रा",
  T_49_META_TYP_412_I1_D: "रिवर्स/ब्रेक बटन का उपयोग करने पर वाहन को मिलने वाली अश्वशक्ति की मात्रा",
  T_49_META_TYP_412_I2_D: "उच्च गति पर, अधिकतम स्टीयरिंग कोण",
  T_49_META_TYP_412_I3_D: "उच्च गति अधिकतम स्टीयरिंग कोण आवेदन के लिए गति सीमा",
  T_49_META_TYP_412_I4_D: "अधिकतम गति तक पहुंचने के बाद, वाहन कोई और अश्वशक्ति प्रदान नहीं करेगा, लेकिन वाहन इस अधिकतम गति को पार कर सकता है (उदाहरण के लिए ढलान पर जाकर)",
  T_49_META_TYP_412_I5_D: "जब वाहन नियंत्रित नहीं हो रहा हो, तो IdleBrakeInput को BrakeTorque से गुणा करके वाहन की गति कम की जाती है",
  T_49_META_TYP_412_I6_D: "क्षति सूत्र के मापदंडों का उपयोग करके, लोगों को मारने से होने वाली क्षति की गणना करने के लिए उपयोग किया जाता है",
  T_49_META_TYP_412_I7_D: "लोगों को टक्कर मारने से होने वाले नुकसान की गणना करने के लिए उपयोग किया जाता है। इस गति से अधिक होने के बाद, नुकसान में वृद्धि नहीं होगी।",
  T_49_META_TYP_412_I8_D: "टक्कर की क्षति की गणना, न्यूनतम क्षति के लिए उपयोग किया जाता है",
  T_49_META_TYP_412_I9_D: "टक्कर की क्षति गणना, अधिकतम क्षति के लिए उपयोग किया जाता है",
  T_49_META_TYP_413_I0_D: "खिलाड़ी (एनपीसी) द्वारा रूपांतरित वस्त्र",
  T_49_META_TYP_414_I1_D: "विस्तृत रेंज",
  T_49_META_TYP_415_I0_D: "पर्सोना ID",
  T_49_META_TYP_415_I1_D: "उपनाम",
  T_49_META_TYP_415_I2_D: "अवतार",
  T_49_META_TYP_416_I1_D: "बाउंड पर्सना",
  T_49_META_TYP_416_I2_D: "ओफ़्सेट",
  T_49_META_TYP_416_I3_D: "ऊंचाई",
  T_49_META_TYP_416_I4_D: "सिस्टम संदेशों का उत्तर देना है या नहीं",
  T_49_META_TYP_416_I5_D: "व्यक्तित्व उपनाम",
  T_49_META_TYP_416_I6_D: "व्यक्तित्वअवतार",
  T_49_META_TYP_416_I7_D: "उपयोगकर्ता उपनाम",
  T_49_META_TYP_416_I8_D: "उपयोगकर्ता अवतार",
  T_49_META_TYP_417_I0_D: "संसाधन आईडी",
  T_49_META_TYP_418_I0_D: "सदस्यता समाप्ति",
  T_49_META_TYP_418_I1_D: "सदस्य बनें",
  T_49_META_TYP_418_I2_D: "सदस्यता नवीनीकरण",
  T_49_META_TYP_42_I0_D: "डिफ़ॉल्ट टेक्स्ट",
  T_49_META_TYP_42_I1_D: "सक्रिय टेक्स्ट",
  T_49_META_TYP_42_I10_D: "अधिकतम लंबाई",
  T_49_META_TYP_42_I14_D: "दबाया गया रंग",
  T_49_META_TYP_42_I16_D: "स्थानीयकरण कुंजी, एकाधिक भाषाओं में उपयोग की जा सकती है",
  T_49_META_TYP_42_I3_D: "संरेखण",
  T_49_META_TYP_42_I4_D: "लंबवत संरेखण",
  T_49_META_TYP_42_I5_D: "बोल्ड",
  T_49_META_TYP_42_I6_D: "इटैलिक",
  T_49_META_TYP_42_I7_D: "अंडरलाइन",
  T_49_META_TYP_42_I8_D: "पंक्ति अंतर",
  T_49_META_TYP_42_I9_D: "शब्द संरेखण",
  T_49_META_TYP_424_I0_D: "रेखीय कोहरा प्रभाव",
  T_49_META_TYP_424_I1_D: "सूचकांक कोहरा प्रभाव",
  T_49_META_TYP_424_I2_D: "घातीय वर्ग कोहरा प्रभाव",
  T_49_META_TYP_426_I0_D: "तीव्रता",
  T_49_META_TYP_426_I1_D: "सीमा",
  T_49_META_TYP_426_I2_D: "स्पॉटलाइट शंकु का कोण डिग्री में",
  T_49_META_TYP_426_I3_D: "हल्के रंग",
  T_49_META_TYP_428_I0_D: "हथियार की त्वचा आईडी",
  T_49_META_TYP_428_I2_D: "आईडी सेट करें",
  T_49_META_TYP_428_I3_D: "हेडड्रेस आईडी",
  T_49_META_TYP_428_I4_D: "फेस आईडी",
  T_49_META_TYP_428_I5_D: "मेकअप आईडी",
  T_49_META_TYP_428_I6_D: "ऊपरी शरीर आईडी",
  T_49_META_TYP_428_I7_D: "निचले शरीर की पहचान",
  T_49_META_TYP_428_I8_D: "जूता आईडी",
  T_49_META_TYP_431_I1_D: "लक्ष्य इकाई का प्रक्षेप पथ",
  T_49_META_TYP_431_I3_D: "गति की गति, इकाई: m/s",
  T_49_META_TYP_431_I4_D: `जब गति कर रहे हों, तो क्या वस्तु पथ के स्पर्शरेखा की ओर मुड़नी चाहिए?
डिफ़ॉल्ट मान: False, वस्तु की दिशा अपरिवर्तित रहती है।
यदि True पर सेट किया जाए, तो वस्तु पथ की अग्रसर दिशा में मुड़ेगी।`,
  T_49_META_TYP_431_I5_D: "खेले गए प्रतिशत",
  T_49_META_TYP_432_I0_D: "रोल कोण, जो इस बिंदु के दोनों ओर पथ के रेडियल घुमाव को प्रभावित करता है",
  T_49_META_TYP_432_I1_D: "स्पर्शरेखा नियंत्रण बिंदु और मार्गबिंदु की सापेक्ष स्थिति पथ स्पर्शरेखा निर्धारित करती है",
  T_49_META_TYP_433_I0_D: "पथ बिंदुओं के बीच सीधी रेखाएँ प्रक्षेपित करें",
  T_49_META_TYP_433_I1_D: "सुचारू गति के लिए पथ बिंदुओं के बीच वक्रीय प्रक्षेप",
  T_49_META_TYP_433_I2_D: "वक्र बिंदु के स्पर्शरेखा के मैनुअल समायोजन का समर्थन करें",
  T_49_META_TYP_434_I0_D: "पथ प्रकार",
  T_49_META_TYP_434_I1_D: "पथ की कुल लंबाई",
  T_49_META_TYP_434_I2_D: "क्या शुरुआत और अंत जुड़े हुए हैं",
  T_49_META_TYP_434_I3_D: "वेपॉइंट संग्रह",
  T_49_META_TYP_437_I3_D: "बाएं खिलाड़ी",
  T_49_META_TYP_437_I4_D: "दाएं खिलाड़ी",
  T_49_META_TYP_437_I5_D: "अभिन्न प्रकार के नामों की सरणी",
  T_49_META_TYP_437_I6_D: "बाईं ओर अंक सरणी (सूची एक आयाम: खिलाड़ी; सूची दो आयाम: कस्टम अंक प्रकार के अनुसार भरा गया अंक डेटा)",
  T_49_META_TYP_437_I7_D: "दाईं ओर अंक सरणी (सूची एक आयाम: खिलाड़ी; सूची दो आयाम: कस्टम अंक प्रकार के अनुसार भरे गए अंक डेटा)",
  T_49_META_TYP_438_I1_D: "खिलाड़ियों की समूहीकरण सरणी",
  T_49_META_TYP_438_I2_D: "समूह रैंकिंग सरणी",
  T_49_META_TYP_438_I3_D: "समूह स्कोर सरणी",
  T_49_META_TYP_438_I4_D: "अभिन्न प्रकार के नामों की सरणी",
  T_49_META_TYP_438_I5_D: "समूहीकृत रंग सरणी",
  T_49_META_TYP_438_I6_D: "खिलाड़ी अंक सरणी (समूहीकृत न होने पर क्रम के अनुरूप)",
  T_49_META_TYP_442_I1_D: "लेफ्ट स्कोर",
  T_49_META_TYP_442_I10_D: "दाईं ओर मृत्यु चिह्न",
  T_49_META_TYP_442_I2_D: "राइट स्कोर",
  T_49_META_TYP_442_I3_D: "बायीं ओर जीवित बचे लोगों की संख्या",
  T_49_META_TYP_442_I4_D: "दाईं ओर जीवित बचे लोगों की संख्या",
  T_49_META_TYP_442_I5_D: "बाईं ओर मरने वालों की संख्या",
  T_49_META_TYP_442_I6_D: "दाईं ओर मृत्यु दर",
  T_49_META_TYP_442_I7_D: "बायीं ओर जीवन रक्षा आइकन",
  T_49_META_TYP_442_I8_D: "दाईं ओर जीवन रक्षा आइकन",
  T_49_META_TYP_442_I9_D: "बायीं ओर मृत्यु चिह्न",
  T_49_META_TYP_444_I0_D: "अंग्रेज़ी",
  T_49_META_TYP_444_I1_D: "सरलीकृत चीनी",
  T_49_META_TYP_444_I10_D: "फ्रेंच",
  T_49_META_TYP_444_I11_D: "जर्मन",
  T_49_META_TYP_444_I12_D: "तुर्की",
  T_49_META_TYP_444_I13_D: "हिन्दी",
  T_49_META_TYP_444_I14_D: "जापानी",
  T_49_META_TYP_444_I15_D: "रोमानियाई",
  T_49_META_TYP_444_I16_D: "अरबी",
  T_49_META_TYP_444_I17_D: "बर्मी",
  T_49_META_TYP_444_I18_D: "उर्दू",
  T_49_META_TYP_444_I19_D: "बंगाली",
  T_49_META_TYP_444_I2_D: "परंपरागत चीनी",
  T_49_META_TYP_444_I3_D: "थाई",
  T_49_META_TYP_444_I4_D: "वियतनामी",
  T_49_META_TYP_444_I5_D: "इन्डोनेशियाई",
  T_49_META_TYP_444_I6_D: "पुर्तगाली",
  T_49_META_TYP_444_I7_D: "स्पैनिश",
  T_49_META_TYP_444_I8_D: "रूसी",
  T_49_META_TYP_444_I9_D: "कोरियाई",
  T_49_META_TYP_51_I0_D: "सामान्य ज़ोंबी",
  T_49_META_TYP_51_I1_D: "लकड़ी काटने वाला ज़ॉम्बी",
  T_49_META_TYP_51_I10_D: "उड़ती हुई बम मधुमक्खी",
  T_49_META_TYP_51_I11_D: "ज़ोंबी ड्रैगन",
  T_49_META_TYP_51_I2_D: "थ्रो ज़ॉम्बी",
  T_49_META_TYP_51_I3_D: "विस्फोटक ज़ॉम्बी",
  T_49_META_TYP_51_I4_D: "अत्याचारी ज़ॉम्बी",
  T_49_META_TYP_51_I5_D: "लाल थ्रो ज़ॉम्बी",
  T_49_META_TYP_51_I6_D: "मिस्टर वी",
  T_49_META_TYP_51_I7_D: "टैंक ज़ॉम्बी",
  T_49_META_TYP_51_I8_D: "ड्रिल ज़ॉम्बी",
  T_49_META_TYP_51_I9_D: "समुराई",
  T_49_META_TYP_56_I10_D: "विस्फोट विलंब",
  T_49_META_TYP_56_I11_D: "विस्फोट की सीमा",
  T_49_META_TYP_56_I12_D: "विस्फोट क्षति",
  T_49_META_TYP_56_I13_D: "जलने का समय",
  T_49_META_TYP_56_I14_D: "जलने की क्षति",
  T_49_META_TYP_56_I15_D: "जलने की क्षति अंतराल",
  T_49_META_TYP_56_I17_D: "वाहन चालक",
  T_49_META_TYP_56_I18_D: "विमान में सवार सभी यात्री",
  T_49_META_TYP_56_I19_D: "वाहन त्वचा आईडी",
  T_49_META_TYP_56_I20_D: "खिलाड़ी कॉन्फ़िगरेशन प्राथमिकता",
  T_49_META_TYP_56_I21_D: "अधिकतम HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "क्या मैन्युअल रूप से या स्वचालित रूप से स्थानांतरित करना है (डिफ़ॉल्ट रूप से मैन्युअल)",
  T_49_META_TYP_58_I0_D: "उत्पन्न BUFF प्रकार",
  T_49_META_TYP_58_I1_D: "एक BUFF के चुने जाने से लेकर अगले BUFF के उत्पन्न होने तक का समय, सेकंड में",
  T_49_META_TYP_59_I0_D: "मोशन प्रकार",
  T_49_META_TYP_59_I1_D: "X दिशा में मोशन मान",
  T_49_META_TYP_59_I2_D: "Y दिशा में मोशन मान",
  T_49_META_TYP_59_I3_D: "Z दिशा में मोशन मान",
  T_49_META_TYP_59_I4_D: "आंदोलन की अवधि",
  T_49_META_TYP_59_I5_D: "रुकने की अवधि",
  T_49_META_TYP_59_I6_D: "पलटा मोशन अक्षम",
  T_49_META_TYP_60_I0_D: "हथियार अंक लूटें",
  T_49_META_TYP_61_I0_D: "बाउंड मनी",
  T_49_META_TYP_61_I1_D: "ट्रिगर रेंज सेट करें",
  T_49_META_TYP_61_I2_D: "मॉडल दृश्यता",
  T_49_META_TYP_62_I0_D: "XZ गति",
  T_49_META_TYP_62_I1_D: "Y गति",
  T_49_META_TYP_64_I0_D: "संगीत घटक प्रकार",
  T_49_META_TYP_66_I0_D: "इंस्टेंसआईडी",
  T_49_META_TYP_66_I1_D: "पथ बिंदु",
  T_49_META_TYP_68_I0_D: "एआई की वर्तमान स्थिति",
  T_49_META_TYP_68_I1_D: "एआई का वर्तमान अधिकतम स्वास्थ्य",
  T_49_META_TYP_68_I10_D: "क्या एआई मरने पर उपकरण या आइटम गिराएगा?",
  T_49_META_TYP_68_I11_D: "क्या AI वर्तमान में अजेय अवस्था में है",
  T_49_META_TYP_68_I12_D: "क्षति होने पर, क्षति प्रतिशत को कम या बढ़ाया जा सकता है।",
  T_49_META_TYP_68_I13_D: "एआई के प्रकार",
  T_49_META_TYP_68_I14_D: "क्या स्वचालित रूप से शत्रुओं की खोज करनी है",
  T_49_META_TYP_68_I15_D: "0 का अर्थ है स्वचालित हमला, 1 का अर्थ है रक्षात्मक हमला, 2 का अर्थ है कोई हमला नहीं",
  T_49_META_TYP_68_I16_D: "पथ आईडी",
  T_49_META_TYP_68_I17_D: "शिकार लक्ष्य",
  T_49_META_TYP_68_I18_D: "आक्रमण लक्ष्य",
  T_49_META_TYP_68_I19_D: "AI के स्पॉन पॉइंट निर्देशांक",
  T_49_META_TYP_68_I2_D: "उस टीम की इकाई प्राप्त करें जिससे AI संबंधित है",
  T_49_META_TYP_68_I20_D: "टीम गुट संख्या",
  T_49_META_TYP_68_I4_D: "केवल सामान्य हमलों की आक्रमण शक्ति को ही संशोधित किया जा सकता है, तथा कौशल की आक्रमण शक्ति को नहीं गिना जाता।",
  T_49_META_TYP_68_I7_D: "AI की मुक्त गति की सीमा। आप केवल मूल मूल्य को संशोधित कर सकते हैं। यदि कोई अतिरिक्त बोनस है, तो उसे मूल्य के आधार पर जोड़ा जाएगा।",
  T_49_META_TYP_68_I8_D: "AI दुश्मन की सीमा का पता लगाता है और केवल मूल मूल्य को संशोधित कर सकता है। यदि कोई अतिरिक्त बोनस है, तो उसे मूल्य के आधार पर जोड़ा जाएगा।",
  T_49_META_TYP_68_I9_D: "वास्तविक गति। यदि कोई कौशल त्वरण है, तो इसे उससे गुणा किया जाएगा।",
  T_49_META_TYP_70_I0_D: "सूत्र की लक्ष्य इकाई आईडी, आंतरिक रूप से उपयोग की जाती है और प्लेयर को दिखाई नहीं देती है।",
  T_49_META_TYP_70_I1_D: "सूत्र की लक्ष्य इकाई विशेषता आईडी, आंतरिक रूप से उपयोग की जाती है और प्लेयर को दिखाई नहीं देती है।",
  T_49_META_TYP_70_I2_D: "न्यूनतम स्वीकृत मान",
  T_49_META_TYP_70_I3_D: "अधिकतम स्वीकृत मान",
  T_49_META_TYP_70_I4_D: "आधार गुणांक",
  T_49_META_TYP_70_I5_D: "पूर्व संचयक",
  T_49_META_TYP_70_I6_D: "गुणक",
  T_49_META_TYP_70_I7_D: "गुणा और संचित",
  T_49_META_TYP_70_I8_D: "पोस्ट संचयक",
  T_49_META_TYP_71_I0_D: "उत्पाद संख्या",
  T_49_META_TYP_71_I1_D: "मूल्य",
  T_49_META_TYP_71_I10_D: "स्टोर आइटम",
  T_49_META_TYP_71_I2_D: "मुद्रा प्रकार",
  T_49_META_TYP_71_I3_D: "कुल खरीद सीमा",
  T_49_META_TYP_71_I4_D: "वर्तमान समग्र खरीद प्रतिबंध",
  T_49_META_TYP_71_I5_D: "प्रोडक्ट का नाम",
  T_49_META_TYP_71_I6_D: "उत्पाद वर्णन",
  T_49_META_TYP_71_I7_D: "उत्पाद आइटम सूची",
  T_49_META_TYP_71_I8_D: "खरीदने योग्य है या नहीं",
  T_49_META_TYP_71_I9_D: "संसाधन पथ, डिफ़ॉल्ट रूप से रिक्त",
  T_49_META_TYP_72_I1_D: "शेल्व्स",
  T_49_META_TYP_73_I1_D: "मैनुअल बंद करना अक्षम है या नहीं",
  T_49_META_TYP_74_I0_D: "हथियार",
  T_49_META_TYP_74_I1_D: "हेलमेट",
  T_49_META_TYP_74_I2_D: "वेस्ट",
  T_49_META_TYP_74_I3_D: "ग्रेनेड",
  T_49_META_TYP_75_I0_D: "एक तरफा",
  T_49_META_TYP_75_I1_D: "आगे और पीछे",
  T_49_META_TYP_76_I0_D: "केवल गश्त करें, रास्ते में पड़ने वाले लक्ष्यों पर हमला न करें",
  T_49_META_TYP_76_I1_D: "गश्त करते हुए हमला",
  T_49_META_TYP_79_I0_D: "हथियार की आक्रमण शक्ति",
  T_49_META_TYP_79_I1_D: "हमला की सीमा",
  T_49_META_TYP_79_I10_D: "बुलेट स्प्रेड शुरू संख्या",
  T_49_META_TYP_79_I11_D: "आइटम आईडी",
  T_49_META_TYP_79_I12_D: "दो शॉट के बीच न्यूनतम प्रतीक्षा समय, सेकंड में। फायरिंग के प्रकार के आधार पर प्रत्येक शॉट से कई गोलियां फायर हो सकती हैं।",
  T_49_META_TYP_79_I13_D: "जिन खिलाड़ियों के पास यह हथियार है",
  T_49_META_TYP_79_I14_D: "गोला-बारूद की खपत",
  T_49_META_TYP_79_I15_D: "दोहरे हथियार चलाने का प्रकार (0: कोई दोहरा हथियार नहीं, 1: स्वयं का, 2: कोई भी हथियार)",
  T_49_META_TYP_79_I16_D: "कवच क्षति गुणांक",
  T_49_META_TYP_79_I17_D: "खिलाड़ी की गति",
  T_49_META_TYP_79_I18_D: "धड़ पर चोट से होने वाली क्षति का अनुपात",
  T_49_META_TYP_79_I19_D: "हेडशॉट से होने वाली क्षति का अनुपात",
  T_49_META_TYP_79_I2_D: "दो गोलियों के बीच न्यूनतम प्रतीक्षा समय, सेकंड में",
  T_49_META_TYP_79_I20_D: "अंगों के लिए क्षति अनुपात",
  T_49_META_TYP_79_I21_D: "अतिरिक्त क्षति अनुपात (कार, तेल बैरल बर्फ की दीवार)",
  T_49_META_TYP_79_I22_D: "पीठ पर दिखाई देता है",
  T_49_META_TYP_79_I23_D: "अतिरिक्त क्षति के लिए ज़मीन पर मारो",
  T_49_META_TYP_79_I24_D: "प्रति शॉट गोला बारूद",
  T_49_META_TYP_79_I25_D: "पुनः लोड गति (आधार गति * गुणांक)",
  T_49_META_TYP_79_I26_D: "वर्तमान गोला-बारूद की गिनती",
  T_49_META_TYP_79_I27_D: "बंदूक की त्वचा आईडी",
  T_49_META_TYP_79_I28_D: "जब खिलाड़ी के कॉन्फ़िगरेशन को प्राथमिकता दी जाती है, तो खिलाड़ी की बंदूक त्वचा कॉन्फ़िगरेशन हथियार की अपनी बंदूक त्वचा विशेषताओं को ओवरराइड कर देगी",
  T_49_META_TYP_79_I29_D: "किसी हथियार पर बंदूक की खाल के गुण लिखते समय, हथियार का मूल मूल्य बंदूक की खाल से प्रभावित होगा",
  T_49_META_TYP_79_I3_D: "गोलियों की मैग साइज",
  T_49_META_TYP_79_I30_D: "प्रसार वृद्धि दर (0.1 = शॉट्स के प्रत्येक अतिरिक्त विस्फोट से क्रॉसहेयर 10% बढ़ जाता है)",
  T_49_META_TYP_79_I31_D: "बिखराव पुनर्प्राप्ति गति",
  T_49_META_TYP_79_I32_D: "शूटिंग करते समय खिलाड़ी की गति प्रभावित होती है",
  T_49_META_TYP_79_I33_D: "चलते समय फैलाव आकार (1.5 = 1.5 * आधार क्रॉसहेयर आकार)",
  T_49_META_TYP_79_I34_D: "हथियार प्रकार",
  T_49_META_TYP_79_I36_D: "आग प्रकार",
  T_49_META_TYP_79_I37_D: "एकल शॉट है",
  T_49_META_TYP_79_I38_D: "शस्त्र साइलेंस है",
  T_49_META_TYP_79_I39_D: "एडीएस गति दर",
  T_49_META_TYP_79_I4_D: "प्रारंभिक मैग गिनती",
  T_49_META_TYP_79_I5_D: "कवच प्रवेश",
  T_49_META_TYP_79_I6_D: "पूर्ण क्षति की दूरी",
  T_49_META_TYP_79_I7_D: "न्यूनतम नुकसान की दूरी",
  T_49_META_TYP_79_I8_D: "न्यूनतम नुकसान",
  T_49_META_TYP_79_I9_D: "बिखराव शुरू होने से पहले दागी जा सकने वाली गोलियों की संख्या",
  T_49_META_TYP_80_I1_D: "जब सही हो, तो मैन्युअल रूप से बंद करना प्रतिबंधित है",
  T_49_META_TYP_80_I2_D: "बाउंड स्टोर इकाई",
  T_49_META_TYP_80_I4_D: "बाउंड वॉलेट आईडी",
  T_49_META_TYP_80_I5_D: "अनुरोध प्रकार",
  T_49_META_TYP_80_I6_D: "वर्तमान UI प्लेयर के अनुरोधित लक्ष्य का प्रकार",
  T_49_META_TYP_80_I7_D: "ट्रिगर खिलाड़ी आईडी",
  T_49_META_TYP_81_I0_D: "रैंडम बफ",
  T_49_META_TYP_81_I1_D: "HP बफ",
  T_49_META_TYP_81_I2_D: "बुलेट बफ",
  T_49_META_TYP_81_I3_D: "आर्मर बफ",
  T_49_META_TYP_82_I1_D: "बटन चिह्न",
  T_49_META_TYP_82_I3_D: "लंगर बिंदु के सापेक्ष स्थिति",
  T_49_META_TYP_83_I1_D: "पैसे",
  T_49_META_TYP_83_I2_D: "पैरामीटर पास करना",
  T_49_META_TYP_86_I0_D: "न्यूनतम",
  T_49_META_TYP_86_I1_D: "अधिकतम",
  T_49_META_TYP_86_I2_D: "आधार गुणांक, सभी गणनाओं से पहले मूल मान से गुणा किया जाता है",
  T_49_META_TYP_86_I3_D: "पूर्व-संचयक, गुणन से पहले संचय करता है और गुणन गणना में भाग लेता है",
  T_49_META_TYP_86_I4_D: "सतत गुणक, सतत गुणन, उदाहरण के लिए (90% तक घटाएं, 110% तक मजबूत करें) प्रभाव है मूल्य*90%*110%",
  T_49_META_TYP_86_I5_D: "गुणन संचायक, उदाहरण के लिए (10% जोड़ें, 5% जोड़ें) का प्रभाव मान*(1+10%+5%) होता है",
  T_49_META_TYP_86_I6_D: "पोस्ट-संचयकर्ता, गुणन गणना में भाग नहीं लेता है, और अंत में जोड़ा जाता है",
  T_49_META_TYP_88_I0_D: "मूल प्रकार, सबसे बुनियादी खेल मुद्रा, वर्तमान संस्करण में सामान्य वस्तुओं का मूल्य निर्धारण प्रकार",
  T_49_META_TYP_89_I0_D: "वर्तमान में, संस्करण में केवल आधार मुद्रा ही है",
  T_49_META_TYP_89_I1_D: "मुद्रा मात्रा",
  T_49_META_TYP_89_I2_D: "मुद्रा चिह्न",
  T_49_META_TYP_89_I3_D: "मुद्रा चिह्न का रंग",
  T_49_META_TYP_90_I0_D: "बटुए की सामग्री मुद्राओं का एक समूह है",
  T_49_META_TYP_92_I0_D: "स्क्वायर लकड़ी का बक्सा",
  T_49_META_TYP_92_I1_D: "लंबा लकड़ी का बक्सा",
  T_49_META_TYP_92_I10_D: "निगरानी टावर",
  T_49_META_TYP_92_I100_D: "सीढ़ी",
  T_49_META_TYP_92_I101_D: "सीढ़ी लैंडिंग B",
  T_49_META_TYP_92_I102_D: "सीढ़ी लैंडिंग A",
  T_49_META_TYP_92_I103_D: "टेलीफोन बूथ",
  T_49_META_TYP_92_I104_D: "BIS थीम दीवार",
  T_49_META_TYP_92_I105_D: "BIS थीम फूलों का बिस्तर",
  T_49_META_TYP_92_I106_D: "वेंडिंग मशीन",
  T_49_META_TYP_92_I107_D: "राक्षस इकाई",
  T_49_META_TYP_92_I108_D: "यूनिट जनरेटर",
  T_49_META_TYP_92_I109_D: "स्पोर्ट्स कार",
  T_49_META_TYP_92_I11_D: "गार्डहाउस",
  T_49_META_TYP_92_I110_D: "टुक टुक",
  T_49_META_TYP_92_I111_D: "नाशक लकड़ी का बक्सा",
  T_49_META_TYP_92_I112_D: "एसयूवी",
  T_49_META_TYP_92_I113_D: "मोटरसाइकिल",
  T_49_META_TYP_92_I114_D: "राक्षस ट्रक",
  T_49_META_TYP_92_I115_D: "सोना जनरेटर",
  T_49_META_TYP_92_I116_D: "सीढ़ी लैंडिंग C",
  T_49_META_TYP_92_I117_D: "चिह्न",
  T_49_META_TYP_92_I118_D: "बाड़ा",
  T_49_META_TYP_92_I119_D: "जर्सी मशीन",
  T_49_META_TYP_92_I12_D: "दो मंजिला घर",
  T_49_META_TYP_92_I121_D: "कंक्रीट का खंभा",
  T_49_META_TYP_92_I122_D: "लूट फुटबॉल आइटम बॉक्स",
  T_49_META_TYP_92_I123_D: "तेल ड्रम",
  T_49_META_TYP_92_I124_D: "निम्न-गुरुत्वाकर्षण क्षेत्र",
  T_49_META_TYP_92_I125_D: "हथियार",
  T_49_META_TYP_92_I126_D: "बाड़ा B",
  T_49_META_TYP_92_I127_D: "छोटा घर A",
  T_49_META_TYP_92_I128_D: "क्षतिग्रस्त ट्रक",
  T_49_META_TYP_92_I129_D: "बुनियादी गोलाकार",
  T_49_META_TYP_92_I13_D: "रेत की मूर्ति",
  T_49_META_TYP_92_I130_D: "बेसिक शंकु",
  T_49_META_TYP_92_I131_D: "बेसिक सिलिंडर",
  T_49_META_TYP_92_I132_D: "उपभोक्ता जनरेटर",
  T_49_META_TYP_92_I133_D: "कस्टम जल शरीर",
  T_49_META_TYP_92_I134_D: "तीर",
  T_49_META_TYP_92_I135_D: "रंगीन ब्लॉक",
  T_49_META_TYP_92_I136_D: "रंगीन तेल ड्रम",
  T_49_META_TYP_92_I137_D: "पाठ",
  T_49_META_TYP_92_I138_D: "आइकन",
  T_49_META_TYP_92_I139_D: "बर्फ की गुड़िया",
  T_49_META_TYP_92_I14_D: "फव्वारा",
  T_49_META_TYP_92_I140_D: "कैप्सूल ट्रिगर",
  T_49_META_TYP_92_I141_D: "गोलाकार टकराव ट्रिगर",
  T_49_META_TYP_92_I142_D: "परावर्तक ठोस रंग ब्लॉक 1",
  T_49_META_TYP_92_I143_D: "बम्पर कार निर्माता",
  T_49_META_TYP_92_I144_D: "चेकर्ड एम्यूज़मेंट पार्क ब्लॉक",
  T_49_META_TYP_92_I145_D: "बड़ा स्क्रीन",
  T_49_META_TYP_92_I146_D: "मंच",
  T_49_META_TYP_92_I147_D: "विशाल लोलिपॉप",
  T_49_META_TYP_92_I148_D: "खाद्य ट्रक B",
  T_49_META_TYP_92_I15_D: "चेरी ब्लॉसम ट्री",
  T_49_META_TYP_92_I16_D: "एक मंजिला घर",
  T_49_META_TYP_92_I17_D: "तीन मंजिला घर",
  T_49_META_TYP_92_I18_D: "केला का पेड़",
  T_49_META_TYP_92_I19_D: "शौचालय",
  T_49_META_TYP_92_I2_D: "झाड़ी ढकी लंबी लकड़ी का बक्सा",
  T_49_META_TYP_92_I20_D: "बाड़",
  T_49_META_TYP_92_I21_D: "नष्ट होने वाला कंटेनर",
  T_49_META_TYP_92_I22_D: "नष्ट होने वाला बाड़",
  T_49_META_TYP_92_I23_D: "टायर",
  T_49_META_TYP_92_I24_D: "बम्पर कार",
  T_49_META_TYP_92_I25_D: "उभयचर वाहन",
  T_49_META_TYP_92_I26_D: "जीप",
  T_49_META_TYP_92_I27_D: "कचरा पात्र",
  T_49_META_TYP_92_I28_D: "मेडिकल टेंट",
  T_49_META_TYP_92_I29_D: "गैरेज",
  T_49_META_TYP_92_I3_D: "घास का ढेर",
  T_49_META_TYP_92_I30_D: "रंगीन दीवार",
  T_49_META_TYP_92_I31_D: "तोरी",
  T_49_META_TYP_92_I32_D: "लोहे का मंच",
  T_49_META_TYP_92_I33_D: "कंटेनर हाउस",
  T_49_META_TYP_92_I34_D: "ट्रेलर",
  T_49_META_TYP_92_I35_D: "दीवार A",
  T_49_META_TYP_92_I36_D: "संगीत नोट्स - पियानो",
  T_49_META_TYP_92_I37_D: "संगीत नोट्स - पियानो",
  T_49_META_TYP_92_I38_D: "संगीत नोट्स - ड्रम",
  T_49_META_TYP_92_I39_D: "संगीत नोट्स - ड्रम",
  T_49_META_TYP_92_I4_D: "बर्बाद गाड़ी",
  T_49_META_TYP_92_I40_D: "संगीत नोट्स - सिंथेसाइज़र A",
  T_49_META_TYP_92_I41_D: "संगीत नोट्स - सिंथेसाइज़र A",
  T_49_META_TYP_92_I42_D: "संगीत नोट्स - सिंथेसाइज़र B",
  T_49_META_TYP_92_I43_D: "संगीत नोट्स - सिंथेसाइज़र B",
  T_49_META_TYP_92_I44_D: "संगीत नोट्स - सिंथेसाइज़र C",
  T_49_META_TYP_92_I45_D: "संगीत नोट्स - सिंथेसाइज़र C",
  T_49_META_TYP_92_I46_D: "बफ जनरेटर",
  T_49_META_TYP_92_I47_D: "प्रोपेलर तंत्र",
  T_49_META_TYP_92_I48_D: "फ्राइंग पैन तंत्र",
  T_49_META_TYP_92_I49_D: "ब्लॉक ट्रैप",
  T_49_META_TYP_92_I5_D: "बर्बाद बस",
  T_49_META_TYP_92_I50_D: "रिंग तंत्र",
  T_49_META_TYP_92_I51_D: "विशाल हथौड़ा जाल",
  T_49_META_TYP_92_I52_D: "मोबाइल बोर्ड",
  T_49_META_TYP_92_I53_D: "गतिमान लक्ष्य",
  T_49_META_TYP_92_I54_D: "दूरबीन दीवार",
  T_49_META_TYP_92_I55_D: "लूट बिंदु हथियार घटक",
  T_49_META_TYP_92_I56_D: "लूट बिंदु बुलेट घटक",
  T_49_META_TYP_92_I57_D: "लूट बिंदु उपभोज्य आइटम घटक",
  T_49_META_TYP_92_I58_D: "लूट बिंदु फेंकने वाला आइटम घटक",
  T_49_META_TYP_92_I59_D: "लूट बिंदु ज़ूम घटक",
  T_49_META_TYP_92_I6_D: "कंटेनर A",
  T_49_META_TYP_92_I60_D: "लूट बिंदु कवच घटक",
  T_49_META_TYP_92_I61_D: "पाइप I",
  T_49_META_TYP_92_I62_D: "पाइप T",
  T_49_META_TYP_92_I63_D: "क्रॉस पाइप",
  T_49_META_TYP_92_I64_D: "एल्बो पाइप",
  T_49_META_TYP_92_I65_D: "विशाल मशरूम क्लस्टर",
  T_49_META_TYP_92_I66_D: "सुखाने की रैक",
  T_49_META_TYP_92_I67_D: "लकड़ी का पुल",
  T_49_META_TYP_92_I68_D: "स्क्रीन",
  T_49_META_TYP_92_I69_D: "ठोस स्तम्भ",
  T_49_META_TYP_92_I7_D: "शिपिंग कंटेनर बी",
  T_49_META_TYP_92_I70_D: "कैक्टस",
  T_49_META_TYP_92_I71_D: "मृत लकड़ी",
  T_49_META_TYP_92_I72_D: "राजमहल दीपक",
  T_49_META_TYP_92_I73_D: "सड़क लाइट",
  T_49_META_TYP_92_I74_D: "सौर पैनल",
  T_49_META_TYP_92_I75_D: "एयर कंडीशनर",
  T_49_META_TYP_92_I76_D: "वर्ग",
  T_49_META_TYP_92_I77_D: "ढलान",
  T_49_META_TYP_92_I78_D: "खाद्य ट्रक",
  T_49_META_TYP_92_I79_D: "मृत्यु या अमरता ट्रिगर",
  T_49_META_TYP_92_I8_D: "शिपिंग कंटेनर सी",
  T_49_META_TYP_92_I80_D: "चेकपॉइंट",
  T_49_META_TYP_92_I81_D: "अंत स्थिति",
  T_49_META_TYP_92_I82_D: "पासा",
  T_49_META_TYP_92_I83_D: "बेंच",
  T_49_META_TYP_92_I84_D: "बस स्टेशन",
  T_49_META_TYP_92_I85_D: "कुत्ते का घर",
  T_49_META_TYP_92_I86_D: "विज्ञापन बोर्ड",
  T_49_META_TYP_92_I87_D: "पानी का जग",
  T_49_META_TYP_92_I88_D: "ग्रैफिटी दीवार",
  T_49_META_TYP_92_I89_D: "घास की छत की झोपड़ी",
  T_49_META_TYP_92_I9_D: "कक्ष",
  T_49_META_TYP_92_I90_D: "पत्थर का आर्च पुल",
  T_49_META_TYP_92_I91_D: "छाता के साथ आँगन सेट",
  T_49_META_TYP_92_I92_D: "फिनिश बैनर",
  T_49_META_TYP_92_I93_D: "किला",
  T_49_META_TYP_92_I94_D: "मॉन्स्टर स्पॉन पॉइंट",
  T_49_META_TYP_92_I95_D: "चिह्न",
  T_49_META_TYP_92_I97_D: "कस्टम ट्रिगर",
  T_49_META_TYP_92_I98_D: "डबल दरवाजा",
  T_49_META_TYP_92_I99_D: "बैरिकेड",
  T_49_META_TYP_94_I0_D: "जोड़ें",
  T_49_META_TYP_94_I1_D: "गुणा करें",
  T_49_META_TYP_95_I0_D: "मुद्रा प्रकार",
  T_49_META_TYP_95_I1_D: "मुद्रा मात्रा",
  T_49_META_TYP_96_I0_D: "वॉलेट प्राप्त करें",
  T_49_META_TYP_96_I1_D: "प्रदर्शन स्थिति (लंगर बिंदु ऊपरी दायाँ कोना है)",
  T_49_META_TYP_97_I0_D: "विश्व निर्देशांक में स्थिति",
  T_49_META_TYP_97_I1_D: "विश्व निर्देशांक प्रणाली में घूर्णन कोण, XYZ घटक पिच कोण, यॉ कोण और रोल कोण हैं, तथा घूर्णन क्रम YXZ है।",
  T_49_META_TYP_97_I10_D: "स्थानीय निर्देशांक अक्ष की दिशा x",
  T_49_META_TYP_97_I11_D: "स्थानीय निर्देशांक अक्ष की दिशा z",
  T_49_META_TYP_97_I2_D: "विश्व निर्देशांक में स्केलिंग",
  T_49_META_TYP_97_I3_D: "इस नोड का मूल नोड",
  T_49_META_TYP_97_I4_D: "विश्व निर्देशांक में घूर्णन, चतुर्धातुक के रूप में व्यक्त",
  T_49_META_TYP_97_I5_D: "स्थानीय निर्देशांक प्रणाली में स्थिति",
  T_49_META_TYP_97_I6_D: "स्थानीय निर्देशांक प्रणाली में घूर्णन, चतुर्धातुक के रूप में व्यक्त किया गया",
  T_49_META_TYP_97_I7_D: "स्थानीय निर्देशांक प्रणाली में घूर्णन कोण, XYZ घटक पिच कोण, यॉ कोण और रोल कोण हैं, तथा घूर्णन क्रम YXZ है।",
  T_49_META_TYP_97_I8_D: "स्थानीय निर्देशांक प्रणाली में आकार मापना",
  T_49_META_TYP_97_I9_D: "स्थानीय निर्देशांक अक्ष की दिशा y",
  T_49_META_TYP_99_I0_D: "फुटबॉल रेडियस",
  T_49_META_TYP_99_I1_D: "सामान्य परिस्थितियों में घर्षण गुणांक",
  T_49_META_TYP_99_I2_D: "प्रभाव के तहत घर्षण गुणांक",
  T_49_META_TYP_99_I3_D: "न्यूनतम शूटिंग कोण",
  T_49_META_TYP_99_I4_D: "न्यूनतम उन्नयन कोण",
  T_49_META_TYP_99_I5_D: "रिसेट समय",
  T_49_META_TYP_99_I6_D: "अधिकतम शूटिंग कोण",
  T_49_META_TYP_99_I7_D: "रिसेट स्थिति",
  T_49_META_TYPE_0_D: "ऑब्जेक्ट, प्रकार पदानुक्रम का मूल",
  T_49_META_TYPE_1_D: "सूची डेटा के एक सेट के लिए एक कंटेनर है",
  T_49_META_TYPE_10_D: "इकाई आधार घटक, सभी घटक इस घटक को संयोजित करेंगे",
  T_49_META_TYPE_100_D: "जर्सी मशीन",
  T_49_META_TYPE_101_D: "मोर्फ ऑब्जेक्ट",
  T_49_META_TYPE_1010_D: "टाइमर सूचना",
  T_49_META_TYPE_1011_D: "ओपनिंग बैनर",
  T_49_META_TYPE_1012_D: "दो टीमों के दौर की शुरुआत में बैनर इकाई। इकाई गुणों को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_1013_D: "आम तौर पर, राउंड की शुरुआत में बैनर इकाई, इकाई गुणों को संशोधित करने से संबंधित यूआई पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_1014_D: "टीम राउंड स्कोर बैनर इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_1015_D: "चेकपॉइंट प्रबंधक निकाय। निकाय विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_1016_D: "इकाई को राउंड के अंत में प्रदर्शित किया जाता है। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शित सामग्री प्रभावित होगी",
  T_49_META_TYPE_1017_D: "यदि शुरुआत में दो टीमें हों, तो एक दूसरे के खिलाफ लड़ रही दो टीमों का बैनर प्रदर्शित करें",
  T_49_META_TYPE_1018_D: "दोनों टीमों का स्कोर",
  T_49_META_TYPE_1019_D: "अंतिम परिणाम: जीत, हार, ड्रा",
  T_49_META_TYPE_102_D: "पुनरुत्थान स्रोत प्रकार: मृत्यु, पतन",
  T_49_META_TYPE_1020_D: "संख्या इकाई चालू करें, इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_1021_D: "चरण उलटी गिनती इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_1022_D: "गेम सूचना उपशीर्षक इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_1023_D: "दो टीमों की खेल जानकारी इकाइयाँ। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शित सामग्री प्रभावित होगी",
  T_49_META_TYPE_1024_D: "टीम मिलान जानकारी UI इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_1027_D: "किसी प्रकार के प्रकार का वर्णन करता है, जो Typeof का उपयोग किए जाने पर लौटाया जाता है",
  T_49_META_TYPE_1028_D: "गुट सूचना इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शित सामग्री प्रभावित होगी",
  T_49_META_TYPE_1029_D: "आइकन सूचना इकाई को संकेत देता है, इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_103_D: "आइटम स्लॉट प्रकार गणना",
  T_49_META_TYPE_1030_D: "दो टीमों की खेल जानकारी की एक सरलीकृत इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शित सामग्री प्रभावित होगी",
  T_49_META_TYPE_1031_D: "टाइमिंग प्रॉम्प्ट इंटरफ़ेस इकाई, इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_1032_D: "फ़्लोटिंग टेक्स्ट इकाई को संकेत देता है। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शित सामग्री प्रभावित होगी",
  T_49_META_TYPE_1033_D: "टर्न स्विचिंग इकाई में वर्तमान टर्न सेटलमेंट और अगले टर्न की शुरुआत की जानकारी शामिल होती है। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर डिस्प्ले सामग्री प्रभावित होगी",
  T_49_META_TYPE_1035_D: "स्कोरबोर्ड बटन UI इकाई खोलें। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_1036_D: "संक्रमण मोड, UI वर्तमान ज़ॉम्बी स्तर दिखा रहा है",
  T_49_META_TYPE_1037_D: "पॉइंट्स डायनेमिक इफ़ेक्ट UI एंटिटी जोड़ें। एंटिटी विशेषताओं को संशोधित करने से संबंधित UI पर डिस्प्ले कंटेंट प्रभावित होगा",
  T_49_META_TYPE_1038_D: "संक्रमण मोड ज़ोंबी यूआई प्रभाव",
  T_49_META_TYPE_1039_D: "उलटी गिनती फ्लोटिंग टेक्स्ट प्रॉम्प्ट इकाई, इकाई विशेषताओं को संशोधित करने से संबंधित यूआई पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_104_D: "जर्सी शैली",
  T_49_META_TYPE_1040_D: "UI कार्ड सलेक्शन पैनल",
  T_49_META_TYPE_1041_D: "UI पहचान सूचना",
  T_49_META_TYPE_1042_D: "UI 5-सेकंड काउंटडाउन",
  T_49_META_TYPE_1043_D: "UI टाइटल बैनर",
  T_49_META_TYPE_1044_D: "UI बिल्ट-इन स्विच",
  T_49_META_TYPE_1045_D: "UI कौशल बटन",
  T_49_META_TYPE_105_D: "फुटबॉल गोल",
  T_49_META_TYPE_106_D: "लक्ष्य सहायता प्रकार",
  T_49_META_TYPE_107_D: "निशाना साधकर मारा जा सकता है, लेकिन जरूरी नहीं कि इससे नुकसान हो",
  T_49_META_TYPE_108_D: "पूर्णांक प्रकार, 64-बिट हस्ताक्षरित पूर्णांक",
  T_49_META_TYPE_109_D: "चैट चैनल इकाई एक कंटेनर है जिसमें उसका अपना चैनल आईडी और प्लेयर्स होते हैं।",
  T_49_META_TYPE_11_D: "वैश्विक इकाई, पूरे खेल में अद्वितीय",
  T_49_META_TYPE_110_D: "निष्क्रिय वॉयस चैनल",
  T_49_META_TYPE_111_D: "व्यवहार प्रकार",
  T_49_META_TYPE_112_D: "खिलाड़ी व्यवहार स्थिति प्रकार",
  T_49_META_TYPE_113_D: "ड्रम संगीत",
  T_49_META_TYPE_114_D: "लीड1 संगीत",
  T_49_META_TYPE_115_D: "लीड2 संगीत",
  T_49_META_TYPE_116_D: "लीड3 संगीत",
  T_49_META_TYPE_117_D: "ड्रम संगीत घटक प्रकार",
  T_49_META_TYPE_118_D: "गुट",
  T_49_META_TYPE_119_D: "आक्रमण विकल्प",
  T_49_META_TYPE_12_D: "एक लड़ाकू इकाई जो हमला कर सकती है, हमला हो सकता है, मार सकती है, आदि।",
  T_49_META_TYPE_120_D: "UI प्रगति पट्टी",
  T_49_META_TYPE_121_D: "प्रत्येक तरंग अंतराल समय",
  T_49_META_TYPE_122_D: "स्काईबॉस",
  T_49_META_TYPE_123_D: "स्काईबॉक्स आधार प्रकार गणना",
  T_49_META_TYPE_124_D: "खोज सीमा",
  T_49_META_TYPE_125_D: "आप वस्तुओं के मूल स्वरूप को संशोधित कर सकते हैं, जैसे बनावट और पारदर्शिता",
  T_49_META_TYPE_126_D: "हेल्थ बार",
  T_49_META_TYPE_127_D: "वस्तुओं को कैसे स्थानांतरित करें",
  T_49_META_TYPE_128_D: "मोर्फेबल ऑब्जेक्ट",
  T_49_META_TYPE_129_D: "लूट गोला-बारूद प्रकार",
  T_49_META_TYPE_13_D: "यूआई नियंत्रण इकाई",
  T_49_META_TYPE_130_D: "लूट उपभोग्य वस्तु प्रकार",
  T_49_META_TYPE_131_D: "लूट आर्मर प्रकार",
  T_49_META_TYPE_132_D: "लूट फेंकने योग्य वस्तु प्रकार",
  T_49_META_TYPE_133_D: "लूट स्कोप प्रकार",
  T_49_META_TYPE_134_D: "लूट हथियार प्रकार",
  T_49_META_TYPE_135_D: "चयनित प्रकार के गोलाबारूद को गिरा देगा",
  T_49_META_TYPE_136_D: "चयनित प्रकार के प्रॉप्स ड्रॉप का उत्पादन करेगा",
  T_49_META_TYPE_137_D: "चयनित प्रकार के प्रक्षेप्य को गिराएगा",
  T_49_META_TYPE_138_D: "चयनित प्रकार का दायरा समाप्त हो जाएगा",
  T_49_META_TYPE_139_D: "चयनित प्रकार का कवच गिर जाएगा",
  T_49_META_TYPE_14_D: "खेल में खिलाड़ी इकाइयाँ, प्रति उपयोगकर्ता एक",
  T_49_META_TYPE_140_D: "लहर",
  T_49_META_TYPE_141_D: "लूट फुटबॉल प्रकार",
  T_49_META_TYPE_142_D: "लूट फुटबॉल आइटम बॉक्स",
  T_49_META_TYPE_143_D: "लीड1 संगीत घटक प्रकार",
  T_49_META_TYPE_144_D: "लीड2 संगीत घटक प्रकार",
  T_49_META_TYPE_145_D: "लीड3 संगीत घटक प्रकार",
  T_49_META_TYPE_146_D: "कीबोर्ड संगीत घटक प्रकार",
  T_49_META_TYPE_147_D: "विभिन्न प्रकार के प्रीसेट कैमरा प्रकार, साथ ही कस्टम कैमरा प्रकार भी प्रदान करता है",
  T_49_META_TYPE_148_D: "कैमरा घटक",
  T_49_META_TYPE_149_D: "लोकलाइजेशन की",
  T_49_META_TYPE_15_D: "खेल में टीम इकाईयाँ, प्रत्येक टीम के लिए एक",
  T_49_META_TYPE_150_D: "तेल ड्रम",
  T_49_META_TYPE_151_D: "क्वाटर्नियन एक विशेष चार-आयामी सदिश है जिसका उपयोग केवल घूर्णन को दर्शाने के लिए किया जाता है।",
  T_49_META_TYPE_152_D: "निम्न-गुरुत्वाकर्षण क्षेत्र",
  T_49_META_TYPE_153_D: "इकाई कंटेनर, जो स्थान पर संबंधित प्रकार की इकाइयाँ उत्पन्न करेगा",
  T_49_META_TYPE_154_D: "डुअल-व्हील्ड हथियार प्रकार",
  T_49_META_TYPE_155_D: "हेलमेट इकाई",
  T_49_META_TYPE_156_D: "शरीर कवच इकाई",
  T_49_META_TYPE_157_D: "कैमरा ट्रांजिशन प्रकार",
  T_49_META_TYPE_158_D: "पाठ प्रॉम्प्ट इंटरफ़ेस",
  T_49_META_TYPE_159_D: "वेक्टर2",
  T_49_META_TYPE_16_D: "स्तरीय ऑब्जेक्ट इकाई",
  T_49_META_TYPE_160_D: "मानचित्र प्रकार",
  T_49_META_TYPE_161_D: "रिप्लेस करने योग्य टेक्सचर VFX",
  T_49_META_TYPE_162_D: "टाइप लिस्ट",
  T_49_META_TYPE_163_D: "टाइप या टाइप लिस्ट",
  T_49_META_TYPE_164_D: "घटक सभी इकाई घटकों या विशिष्ट घटक वर्गों का आधार वर्ग है",
  T_49_META_TYPE_165_D: "टक्कर बॉक्स घटक",
  T_49_META_TYPE_166_D: "भाव का प्रकट",
  T_49_META_TYPE_167_D: "विशेष प्रभाव इकाई एक प्रदर्शित विशेष प्रभाव (हटाए गए, पुनर्चक्रणीय और पुन: प्रयोज्य) का प्रतिनिधित्व करती है",
  T_49_META_TYPE_17_D: "स्तर वस्तु सूची",
  T_49_META_TYPE_170_D: "यह बताता है कि दृश्यता सेट की जा सकती है या नहीं",
  T_49_META_TYPE_171_D: "मशरूम",
  T_49_META_TYPE_172_D: "गोला-बारूद",
  T_49_META_TYPE_173_D: "बैग",
  T_49_META_TYPE_174_D: "ग्रेनेड घटक",
  T_49_META_TYPE_175_D: "ठंडा ग्रेनेड",
  T_49_META_TYPE_176_D: "हथियार जनरेटर",
  T_49_META_TYPE_177_D: "जब कैमरे और अनुसरण की जा रही वस्तु के बीच कोई बाधा होती है, तो कैमरे का मूवमेंट मोड",
  T_49_META_TYPE_178_D: "कैमरा छवि कैसे प्रस्तुत करता है",
  T_49_META_TYPE_179_D: "बुनियादी गोलाकार",
  T_49_META_TYPE_18_D: "(अप्रचलित, उपयोग न करें)",
  T_49_META_TYPE_180_D: "किसी घटक की संपत्ति को संदर्भित करता है",
  T_49_META_TYPE_181_D: "मेश एसेट के प्रकार का वर्णन करने के लिए उपयोग किया जाता है",
  T_49_META_TYPE_182_D: "भौतिक परिसंपत्ति के प्रकार का वर्णन करने के लिए उपयोग किया जाता है",
  T_49_META_TYPE_183_D: "बनावट परिसंपत्ति के प्रकार का वर्णन करने के लिए उपयोग किया जाता है",
  T_49_META_TYPE_184_D: "अंतर्निहित मॉडल संसाधनों का उपयोग करके रेंडरिंग के लिए एक ब्रिज रेंडरिंग घटक",
  T_49_META_TYPE_185_D: "कस्टम मॉडल संसाधनों के साथ रेंडरिंग के लिए कस्टम रेंडरिंग घटक",
  T_49_META_TYPE_186_D: "एक रिक्त ऑब्जेक्ट घटक जिसका उपयोग रेंडरर घटकों, कोलाइडर घटकों आदि के साथ किया जा सकता है।",
  T_49_META_TYPE_187_D: "कंटेनर",
  T_49_META_TYPE_188_D: "बुनियादी सिलेंडर या शंकु",
  T_49_META_TYPE_189_D: "स्थानीयकृत स्ट्रिंग्स की सूची",
  T_49_META_TYPE_19_D: "सूची टेम्पलेट में, आप T के माध्यम से सामग्री का प्रकार निर्दिष्ट कर सकते हैं",
  T_49_META_TYPE_190_D: "दो टीम स्कोर पैनल",
  T_49_META_TYPE_191_D: "एक सामरिक हथियार जो एक निश्चित सीमा के भीतर दुश्मनों को अस्थायी रूप से अंधा कर सकता है।",
  T_49_META_TYPE_192_D: "उपयोग के बाद, यह धुआँ उत्पन्न कर सकता है जो घटना को छुपा देता है, जो दुश्मन के हमले को बाधित करने के लिए एक शक्तिशाली हथियार है।",
  T_49_META_TYPE_193_D: "मल्टी-टीम रिजल्ट पैनल",
  T_49_META_TYPE_194_D: "प्रेरण बारूदी सुरंगों को ज़मीन पर रखा जा सकता है। दुश्मन के पास आने पर वे फट जाएँगी। सावधान रहें कि उन पर पैर न पड़ें।",
  T_49_META_TYPE_195_D: "इंटरपोलेशन गति कैसे निभाई जाती है",
  T_49_META_TYPE_197_D: "बजाने योग्य घटक",
  T_49_META_TYPE_198_D: "आइटम बेस",
  T_49_META_TYPE_199_D: "हवाई युद्ध के लिए सहायक उपकरण, लेकिन आपको हर समय ऊर्जा खपत पर ध्यान देने की आवश्यकता है",
  T_49_META_TYPE_2_D: "बूलियन प्रकार, सत्य, असत्य, या हाँ या नहीं को दर्शाने के लिए उपयोग किया जाता है",
  T_49_META_TYPE_20_D: "अंतर्निहित इंटरफ़ेस प्रकार गणना, जो प्रकार प्रणाली के आधार पर स्वचालित रूप से उत्पन्न होती है",
  T_49_META_TYPE_200_D: "जेलब्रेक क्षेत्र",
  T_49_META_TYPE_201_D: "वे क्षेत्र जहाँ आप प्रवेश करने के बाद तैर सकते हैं",
  T_49_META_TYPE_202_D: "कोलाइडर ID",
  T_49_META_TYPE_203_D: "प्रक्षेप गति",
  T_49_META_TYPE_204_D: "जूते एक तकनीकी शक्ति उपकरण से सुसज्जित हैं जो आपको हवा में दोहरी छलांग लगाने की अनुमति देता है",
  T_49_META_TYPE_205_D: "एक हैंग ग्लाइडर जो आसमान में उड़ सकता है। इसका उपयोग उच्च ऊंचाई से उतरने और दूर स्थान पर जाने के लिए किया जा सकता है।",
  T_49_META_TYPE_206_D: "स्केटबोर्ड",
  T_49_META_TYPE_207_D: "ज़िपलाइन",
  T_49_META_TYPE_208_D: "खेलने योग्य वस्तुओं की सूची",
  T_49_META_TYPE_209_D: "खेलने योग्य या खेलने योग्य की सूची",
  T_49_META_TYPE_21_D: "अंतर्निहित इंटरफ़ेस इकाई, विशिष्ट कार्यों के इंटरफ़ेस को समाहित करती है",
  T_49_META_TYPE_210_D: "बैलिस्टिक एनीमेशन बैलिस्टिक गति का अनुकरण है।",
  T_49_META_TYPE_211_D: "निर्देशांक प्रणाली",
  T_49_META_TYPE_212_D: "एक वस्तु दूसरी वस्तु का अनुसरण करती है",
  T_49_META_TYPE_213_D: "किसी वस्तु का अग्र भाग सदैव दूसरी वस्तु की ओर होता है",
  T_49_META_TYPE_214_D: "एटलस स्प्राइट एसेट का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_49_META_TYPE_215_D: "मैच का परिणाम",
  T_49_META_TYPE_216_D: "शब्दकोश डेटा कंटेनर, डेटा तत्व कुंजी, मान की एक जोड़ी है",
  T_49_META_TYPE_217_D: "शब्दकोश डेटा टेम्पलेट, सामग्री का प्रकार T1 और T2 द्वारा निर्दिष्ट किया जा सकता है",
  T_49_META_TYPE_218_D: "एक प्रकार का प्रकाश स्रोत जो अपने स्थान से सभी दिशाओं में समान तीव्रता का प्रकाश उत्सर्जित करता है",
  T_49_META_TYPE_219_D: "मोटरसाइकिल वाहन",
  T_49_META_TYPE_22_D: "कस्टम इंटरफ़ेस, इंटरफ़ेस संपादक के माध्यम से प्लेयर द्वारा बनाया गया इंटरफ़ेस",
  T_49_META_TYPE_220_D: "टुक-टुक (तीन पहिया) वाहन",
  T_49_META_TYPE_221_D: "उभयचर/मशीन गन मोटरसाइकिल वाहन",
  T_49_META_TYPE_222_D: "चार पहिया वाहन",
  T_49_META_TYPE_224_D: "सस्किल टाइप लिस्ट",
  T_49_META_TYPE_225_D: "उच्च तकनीक सामग्री से बना कृत्रिम बुद्धिमत्ता बुर्ज एक निश्चित सीमा के भीतर दुश्मनों को सक्रिय रूप से खोजेगा और उन पर हमला करेगा।",
  T_49_META_TYPE_226_D: "बुर्ज प्रोप का उपयोग करने के बाद उत्पन्न बुर्ज",
  T_49_META_TYPE_227_D: "कस्टम UI नियंत्रण प्रकार गणना",
  T_49_META_TYPE_23_D: "स्तर ऑब्जेक्ट प्रकार गणना, जो प्रकार प्रणाली के आधार पर स्वचालित रूप से उत्पन्न होगी",
  T_49_META_TYPE_231_D: "मरम्मत किट",
  T_49_META_TYPE_233_D: "प्रोग्रेस सर्कल",
  T_49_META_TYPE_234_D: "निर्मित भूमि खदान",
  T_49_META_TYPE_235_D: "गloo दीवार",
  T_49_META_TYPE_236_D: "निर्मित बर्फ की दीवार",
  T_49_META_TYPE_237_D: "हुक गन",
  T_49_META_TYPE_238_D: "इंद्रधनुष स्प्रे बंदूक",
  T_49_META_TYPE_239_D: "स्प्रे राइफल",
  T_49_META_TYPE_24_D: "वर्तमान में सिस्टम द्वारा परिभाषित क्षति के प्रकार",
  T_49_META_TYPE_240_D: "इकाई सभी घटकों का वाहक है। उदाहरण उत्पन्न करने के लिए घटकों को इकाई से जोड़ा जाना चाहिए।",
  T_49_META_TYPE_241_D: "शक्तिशाली हुक गन",
  T_49_META_TYPE_242_D: "स्कोर बार",
  T_49_META_TYPE_243_D: "कपड़ों के स्लॉट",
  T_49_META_TYPE_244_D: "एक पाठ इकाई प्रदर्शित पाठ का प्रतिनिधित्व करती है.",
  T_49_META_TYPE_245_D: "आइकन इकाई एक प्रदर्शित आइकन का प्रतिनिधित्व करती है",
  T_49_META_TYPE_246_D: "स्प्रे रंग",
  T_49_META_TYPE_247_D: "खिलाड़ी UI प्रकार",
  T_49_META_TYPE_248_D: "सामान्य UI स्विच इकाई",
  T_49_META_TYPE_249_D: "उपकरण स्लॉट बदलें",
  T_49_META_TYPE_25_D: "खेल प्रक्रिया के चरण, जैसे खेल प्रारंभ, खेल की तैयारी, खेल समाप्ति, आदि।",
  T_49_META_TYPE_250_D: "प्रभाव इकाई एक प्रदर्शित प्रभाव का प्रतिनिधित्व करती है",
  T_49_META_TYPE_2500_D: "खिलाड़ी का स्पॉन पॉइंट",
  T_49_META_TYPE_2501_D: "ट्रिगर्स का उपयोग खिलाड़ियों (या अन्य वस्तुओं) के प्रवेश और निकास की घटनाओं को ट्रिगर करने के लिए किया जाता है",
  T_49_META_TYPE_2502_D: "मृत्यु या अजेयता ट्रिगर, जब खिलाड़ी प्रवेश करता है, तो यह नियंत्रित करता है कि यह विशेषता के अनुसार मृत्यु या अजेयता प्रभाव है या नहीं",
  T_49_META_TYPE_2503_D: "रेस मोड चेकपॉइंट",
  T_49_META_TYPE_2504_D: "आमतौर पर रेसिंग मोड में निर्दिष्ट फिनिश लाइन में प्रवेश करने वाले खिलाड़ी की पहचान करने के लिए इसका उपयोग किया जाता है। यह एक विशिष्ट ट्रिगर है। कस्टम ट्रिगर बाद में खोले जाएँगे। यह एंडपॉइंट कस्टम ट्रिगर का सिर्फ़ एक आवरण है।",
  T_49_META_TYPE_2505_D: "स्पॉन पॉइंट के चारों ओर बाड़, इसे बंद करने के बाद, आप स्पॉन पॉइंट छोड़ सकते हैं",
  T_49_META_TYPE_2507_D: "टॉर्रेट",
  T_49_META_TYPE_2508_D: "मॉन्स्टर स्पॉन",
  T_49_META_TYPE_2509_D: "मांग के अनुसार संगत प्रकार के उदाहरण उत्पन्न किए जा सकते हैं",
  T_49_META_TYPE_251_D: "इफेक्ट कंटेनर",
  T_49_META_TYPE_2510_D: "खिलाड़ी स्पॉन क्षेत्र (आयताकार)",
  T_49_META_TYPE_252_D: "स्प्रे परिणाम UI",
  T_49_META_TYPE_253_D: "हिन्ट बटन",
  T_49_META_TYPE_254_D: "हार्टबीट प्रभाव",
  T_49_META_TYPE_255_D: "टाइमस्टैम्प स्थानीयकरण स्ट्रिंग",
  T_49_META_TYPE_256_D: "रिजिडबॉडी टाइप",
  T_49_META_TYPE_257_D: "रिगिडबॉडी घटक",
  T_49_META_TYPE_258_D: "टाइमस्टैम्प फॉर्मेट स्टाइल टाइप",
  T_49_META_TYPE_259_D: "सुझाव",
  T_49_META_TYPE_26_D: "खेल में एक राउंड आमतौर पर एक छोटा राउंड होता है, जिसमें कई चरण होते हैं।",
  T_49_META_TYPE_260_D: "प्रोग्रेस स्किल बटन",
  T_49_META_TYPE_261_D: "अनोखा ID",
  T_49_META_TYPE_262_D: "वेपन स्किन ID",
  T_49_META_TYPE_263_D: "वस्त्र पहचान",
  T_49_META_TYPE_264_D: "आइटम आईडी, जब संस्करण में केवल हथियार आईडी हो",
  T_49_META_TYPE_265_D: "यूआई पैनल इकाई",
  T_49_META_TYPE_267_D: "UI स्क्रॉल दृश्य इकाई, वह UI जिसे प्लेयर UI संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_268_D: "तीन अवस्थाओं वाला एक स्विच, चालू और बंद के अलावा, आप मूल तर्क को बनाए रखने का विकल्प चुन सकते हैं",
  T_49_META_TYPE_269_D: "खिलाड़ियों का उपकरण",
  T_49_META_TYPE_270_D: "एंटिटी या प्रीफैब ID",
  T_49_META_TYPE_271_D: "UI पैनल इकाई, वह UI जिसे प्लेयर UI संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_272_D: "लिंग गणना",
  T_49_META_TYPE_273_D: "मिनीमैप",
  T_49_META_TYPE_274_D: "मिनी-मैप पर प्रदर्शित आइकन लक्ष्य का अनुसरण कर सकता है",
  T_49_META_TYPE_275_D: "कंकाल में अलग-अलग भाग नोड्स",
  T_49_META_TYPE_276_D: "त्वचा की हड्डियों तक पहुंचने के लिए प्रयुक्त नोड",
  T_49_META_TYPE_277_D: "क्लाइंट-साइड कैमरा रे डिटेक्शन",
  T_49_META_TYPE_278_D: "छोटे मानचित्र पर प्रदर्शित पिक्सेल ब्लॉक उस स्थान पर वस्तु के टकराव के आकार को दर्शाता है",
  T_49_META_TYPE_279_D: "रंगीन ड्रम",
  T_49_META_TYPE_28_D: "प्रत्येक राउंड की शुरुआत में, स्थिति रीसेट हो जाएगी",
  T_49_META_TYPE_280_D: "गोलाकार ट्रिगर",
  T_49_META_TYPE_281_D: "कैप्सूल ट्रिगर",
  T_49_META_TYPE_282_D: "एसेट कॉन्फ़िगरेशन आईडी के प्रकार का वर्णन करता है, जिसका उपयोग पैरेंट पैकेज के साथ आने वाली एसेट कॉन्फ़िगरेशन आईडी को इंगित करने के लिए किया जाता है, जिसे लोड करने से पहले कॉन्फ़िगरेशन तालिका के माध्यम से पार्स करने की आवश्यकता होती है",
  T_49_META_TYPE_283_D: "परिसंपत्ति के प्रकार का वर्णन करता है, परिसंपत्ति पहचानकर्ता को दर्शाने के लिए उपयोग किया जाता है, और इसे सीधे लोड किया जा सकता है",
  T_49_META_TYPE_284_D: "एक मानव मॉडल संसाधन का प्रतिनिधित्व करता है जिसे खिलाड़ी चरित्र के साथ प्रतिस्थापित किया जा सकता है",
  T_49_META_TYPE_285_D: "सूची या शब्दकोश, पर लूप किया जा सकता है",
  T_49_META_TYPE_286_D: "स्क्रिप्ट परिसंपत्ति का वर्णन करने वाली एक आईडी.",
  T_49_META_TYPE_287_D: "एक स्थिर स्क्रिप्ट परिसंपत्ति का वर्णन करने वाली आईडी.",
  T_49_META_TYPE_288_D: "एक आईडी जो कस्टम UI परिसंपत्ति का वर्णन करती है.",
  T_49_META_TYPE_289_D: "प्रीसेट एसेट का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_49_META_TYPE_29_D: "विशेष प्रभाव",
  T_49_META_TYPE_290_D: "व्यवहार पेड़",
  T_49_META_TYPE_291_D: "बिहेवियर ट्री नोड प्रकार",
  T_49_META_TYPE_292_D: "बिहेवियर ट्री कस्टम नोड",
  T_49_META_TYPE_293_D: "बिहेवियर ट्री अटैचेबल",
  T_49_META_TYPE_294_D: "यूआई लेआउट इकाई, वह यूआई जिसे खिलाड़ी यूआई संपादक के माध्यम से संपादित करते हैं",
  T_49_META_TYPE_295_D: "स्थिति",
  T_49_META_TYPE_296_D: "एनिमेशन क्लिप",
  T_49_META_TYPE_297_D: "एनीमेशन कंट्रोलर",
  T_49_META_TYPE_298_D: "लूप प्रकार",
  T_49_META_TYPE_3_D: "पूर्णांक प्रकार, 32-बिट हस्ताक्षरित पूर्णांक",
  T_49_META_TYPE_30_D: "आइकन",
  T_49_META_TYPE_300_D: "UI3DContainer इकाई, वह UI जिसे खिलाड़ी UI संपादक के माध्यम से संपादित करते हैं",
  T_49_META_TYPE_301_D: "एआई स्किल टाइप",
  T_49_META_TYPE_302_D: "उपकरण स्लॉट गणना",
  T_49_META_TYPE_303_D: "BuffData.csv में Id कॉलम के अनुरूप, कृपया नए आइटम जोड़ने से पहले GPP से पुष्टि करें कि क्या यह लागू है",
  T_49_META_TYPE_304_D: "बफ़ टाइप लिस्ट",
  T_49_META_TYPE_305_D: "बिहेवियर ट्री नोड स्थिति",
  T_49_META_TYPE_306_D: "आप बफ़ जोड़ सकते हैं, बफ़ हटा सकते हैं, और जोड़े गए बफ़ की सूची प्राप्त कर सकते हैं",
  T_49_META_TYPE_307_D: "आइस वॉल निर्माता",
  T_49_META_TYPE_308_D: "विशेष आइटम आईडी प्रकार",
  T_49_META_TYPE_309_D: "प्रॉप्स फेंकना",
  T_49_META_TYPE_31_D: "आवाज़",
  T_49_META_TYPE_310_D: "क्रॉसबो",
  T_49_META_TYPE_311_D: "ग्रेनेड बेस",
  T_49_META_TYPE_312_D: "प्रॉप्स फेंकना",
  T_49_META_TYPE_313_D: "डी-आइस वॉल ग्रेनेड",
  T_49_META_TYPE_314_D: "एनीमेशन नियंत्रकों और संसाधनों का प्रबंधन",
  T_49_META_TYPE_315_D: "प्लेयर बैकपैक",
  T_49_META_TYPE_316_D: "UITexture इकाई, UI संपादक के माध्यम से प्लेयर द्वारा संपादित UI",
  T_49_META_TYPE_317_D: "कठोर शरीर गति बाधाएं, प्रत्येक बाधा का संयोजन में उपयोग किया जा सकता है",
  T_49_META_TYPE_318_D: "अटैचमेंट",
  T_49_META_TYPE_319_D: "भरण प्रकार गणना",
  T_49_META_TYPE_32_D: "खिलाड़ी स्थिति प्रकार",
  T_49_META_TYPE_320_D: "भरण दिशा गणना",
  T_49_META_TYPE_321_D: "वे संस्थाएं जिन्हें लक्षित किया जा सकता है",
  T_49_META_TYPE_322_D: "क्षतिग्रस्त शरीर के हिस्से की प्रकार",
  T_49_META_TYPE_323_D: "UIProfileInfo इकाई, वह UI जिसे खिलाड़ी UI संपादक के माध्यम से संपादित करते हैं",
  T_49_META_TYPE_324_D: "कठोर पिंडों पर बलों के कई अलग-अलग प्रभाव। ध्यान दें कि यह केवल गतिशील दृढ़ निकायों के लिए मान्य है।",
  T_49_META_TYPE_325_D: "कस्टम इंटरफ़ेस एसेट में नियंत्रण का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_49_META_TYPE_326_D: "खिलाड़ी प्रोफ़ाइल जानकारी",
  T_49_META_TYPE_327_D: "प्रत्येक घटक के विन्यास के अनुसार प्रतिस्थापन",
  T_49_META_TYPE_328_D: "बिहेवियर ट्री ID",
  T_49_META_TYPE_329_D: "सीट प्रकार",
  T_49_META_TYPE_33_D: "क्रमबद्ध करें: आरोही शून्य मानों को अनदेखा करें, अवरोही, आरोही",
  T_49_META_TYPE_330_D: "स्वयं के सापेक्ष गति",
  T_49_META_TYPE_331_D: "बीज़ियर कर्व",
  T_49_META_TYPE_332_D: "पुनर्चक्रणीय घटक",
  T_49_META_TYPE_333_D: "फ़ॉन्ट प्रकार",
  T_49_META_TYPE_334_D: "व्हीकल स्किन ID",
  T_49_META_TYPE_335_D: "ध्वनि प्रभाव इकाई बजाए जा रहे ध्वनि प्रभाव का प्रतिनिधित्व करती है।",
  T_49_META_TYPE_336_D: "ध्वनि प्रभाव सूची",
  T_49_META_TYPE_337_D: "ध्वनि प्रभाव या ध्वनि प्रभाव सूची",
  T_49_META_TYPE_338_D: "खिलाड़ी व्यवहार विशेषता सिंक्रनाइज़ेशन इकाई",
  T_49_META_TYPE_339_D: "उपकरण सहायक",
  T_49_META_TYPE_34_D: "आइटम आईडी",
  T_49_META_TYPE_340_D: "बॉट की कठिनाई प्रकार",
  T_49_META_TYPE_341_D: "पूर्णांक शब्दकोश",
  T_49_META_TYPE_342_D: "टाइमर ऑब्जेक्ट",
  T_49_META_TYPE_343_D: "फेंकने वाला चाकू (पिकअप)",
  T_49_META_TYPE_344_D: "थ्रोइंग नाइफ",
  T_49_META_TYPE_345_D: "हथियार प्रकार",
  T_49_META_TYPE_346_D: "गोला-बारूद प्रकार",
  T_49_META_TYPE_347_D: "फ्रेम स्व-सापेक्ष",
  T_49_META_TYPE_348_D: "फ़ंक्शन पॉइंटर एक वर्चुअल फ़ंक्शन या डेलिगेशन मैकेनिज़्म को कार्यान्वित करने के लिए फ़ंक्शन इंस्टेंस की ओर इशारा करता है।",
  T_49_META_TYPE_349_D: "कोरोउटीन के हैंडल को संदर्भित करता है, और कुछ हैंडल ऑपरेशन कर सकता है",
  T_49_META_TYPE_350_D: "वाहन गणना",
  T_49_META_TYPE_351_D: "ऑब्जेक्ट के प्रकार का वर्णन करता है",
  T_49_META_TYPE_352_D: "UIToggle इकाई, वह UI जिसे प्लेयर UI संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_353_D: "चिकित्सा किट",
  T_49_META_TYPE_354_D: "इनहेलेटर",
  T_49_META_TYPE_355_D: "क्षैतिज रेखा",
  T_49_META_TYPE_356_D: "एयरड्रॉप, तैयारी का समय समाप्त होने के बाद, यह एक ऊंचे स्थान से गिरना शुरू हो जाएगा",
  T_49_META_TYPE_357_D: "वस्तुओं का वर्णनात्मक रंग, जैसे कि बॉर्डर, सतहें, आदि (हटाएं, पुनर्चक्रणीय)",
  T_49_META_TYPE_358_D: "किसी घटना को संदर्भित करता है",
  T_49_META_TYPE_359_D: "भौतिक प्रभावों के साथ प्लेयर नियंत्रक, बल लागू कर सकता है और बल प्राप्त कर सकता है",
  T_49_META_TYPE_360_D: "लॉन्च पैड",
  T_49_META_TYPE_361_D: "मुड़ी हुई तोप को खोलकर लोगों को उड़ाने के लिए इस्तेमाल किया जा सकता है। सावधान रहें कि आप खुद को सुरक्षित क्षेत्र से बाहर न फेंकें!",
  T_49_META_TYPE_362_D: "बर्फ के गेंद से लड़ाई! शुल्क!",
  T_49_META_TYPE_363_D: "स्टोर अनुरोध खरीद",
  T_49_META_TYPE_364_D: "एनीमेशन ट्रिगर",
  T_49_META_TYPE_365_D: "एनीमेशन ट्रिगर इंटरफ़ेस घटक",
  T_49_META_TYPE_366_D: "बैच कंबाइन रेंडर",
  T_49_META_TYPE_367_D: "शीर्ष कम्पास",
  T_49_META_TYPE_368_D: "कस्टम भूमिका संसाधन आईडी",
  T_49_META_TYPE_369_D: "कस्टम एनीमेशन संसाधन आईडी",
  T_49_META_TYPE_370_D: "राउंड की शुरुआत में प्रदर्शित जानकारी",
  T_49_META_TYPE_371_D: "प्रत्येक राउंड के अंत में परिणाम प्रदर्शित करें",
  T_49_META_TYPE_372_D: "खिलाड़ी का रुख प्रकार",
  T_49_META_TYPE_373_D: "संग्रह आईडी, संसाधन जानकारी संग्रह के लिए उपयोग किया जाता है",
  T_49_META_TYPE_374_D: "फॉलो स्वास्थ्य बार",
  T_49_META_TYPE_375_D: "राक्षस हमले के लक्ष्य प्रकार की गणना",
  T_49_META_TYPE_376_D: "रक्षा टॉवर हमले लक्ष्य प्रकार गणना",
  T_49_META_TYPE_377_D: "खिलाड़ी इकाइयों और वाहन इकाई प्रकारों के लिए उपनाम",
  T_49_META_TYPE_378_D: "ऑडियो परिसंपत्ति का वर्णन करने वाली एक आईडी.",
  T_49_META_TYPE_379_D: "कॉन्फ़िगरेशन तालिका परिसंपत्ति का वर्णन करने के लिए उपयोग की जाने वाली आईडी",
  T_49_META_TYPE_38_D: "UI खाली विजेट इकाई, UI संपादक के माध्यम से प्लेयर द्वारा संपादित UI",
  T_49_META_TYPE_380_D: "विशेष प्रभाव परिसंपत्ति का वर्णन करने वाली आईडी.",
  T_49_META_TYPE_381_D: "एनीमेशन नियंत्रक परिसंपत्ति का वर्णन करने वाली एक आईडी.",
  T_49_META_TYPE_382_D: "नॉकडाउन स्थिति प्रबंधन विधि",
  T_49_META_TYPE_383_D: "मानचित्र की सतह या सजावट",
  T_49_META_TYPE_384_D: "वस्तुएँ",
  T_49_META_TYPE_385_D: "चरित्र कौशल आईडी",
  T_49_META_TYPE_386_D: "स्किल ID लिस्ट",
  T_49_META_TYPE_387_D: "UITouchPad इकाई, वह UI जिसे प्लेयर UI संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_388_D: "बैकपैक स्किन ID",
  T_49_META_TYPE_389_D: "जॉयस्टिक इकाई, यूआई संपादक के माध्यम से खिलाड़ी द्वारा संपादित यूआई",
  T_49_META_TYPE_39_D: "यूआई चित्र इकाई, यूआई संपादक के माध्यम से खिलाड़ी द्वारा संपादित यूआई",
  T_49_META_TYPE_390_D: "श्रेणीकृत",
  T_49_META_TYPE_391_D: "कस्टम UI या विजेट",
  T_49_META_TYPE_392_D: "ज़हर चक्र में रखी जा सकने वाली वस्तुएँ",
  T_49_META_TYPE_393_D: "भौतिक सीसीटी या रिगिडबॉडी घटकों वाली संस्थाएं",
  T_49_META_TYPE_394_D: "गणितीय स्थिरांक",
  T_49_META_TYPE_395_D: "भौतिक सीसीटी या प्लेयर सीसीटी घटकों वाली संस्थाएं उनके साथ आगे बढ़ सकती हैं",
  T_49_META_TYPE_396_D: "मध्य-खेल निकासी कॉन्फ़िगरेशन",
  T_49_META_TYPE_397_D: "टक्कर के आकार का वर्णन करने के लिए प्रयुक्त घटक",
  T_49_META_TYPE_398_D: "स्ट्रिंग या स्थानीयकरण स्ट्रिंग",
  T_49_META_TYPE_399_D: "भौतिक प्रभावों के साथ चरित्र नियंत्रक, केवल FF पात्रों के लिए",
  T_49_META_TYPE_4_D: "फ़्लोटिंग पॉइंट प्रकार, 32-बिट एकल-परिशुद्धता फ़्लोटिंग पॉइंट संख्या",
  T_49_META_TYPE_40_D: "यूआई पाठ इकाई, यूआई संपादक के माध्यम से खिलाड़ी द्वारा संपादित यूआई",
  T_49_META_TYPE_400_D: "आक्रामक व्यवहार कैसे अपनाएं",
  T_49_META_TYPE_401_D: "आग प्रकार",
  T_49_META_TYPE_402_D: "सामाजिक बटन विडगेट",
  T_49_META_TYPE_403_D: "सामाजिक बटन के प्रकार",
  T_49_META_TYPE_404_D: "सोशल बटन शैलियाँ",
  T_49_META_TYPE_405_D: "लेआउट सॉर्ट प्रकार",
  T_49_META_TYPE_406_D: "बाधाओं पर ट्रिगर कर सकते हैं",
  T_49_META_TYPE_407_D: "प्लेटफ़ॉर्म प्रकार",
  T_49_META_TYPE_408_D: "बेस डेटा उपनाम",
  T_49_META_TYPE_409_D: "त्रुटि कोड गणना",
  T_49_META_TYPE_41_D: "यूआई बटन इकाई, वह यूआई जिसे प्लेयर यूआई संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_410_D: "खिलाड़ी इकाई या ट्रांसफ़ॉर्म इकाई प्रकार के लिए उपनाम।",
  T_49_META_TYPE_411_D: "हेलीकॉप्टर वाहन",
  T_49_META_TYPE_412_D: "कार घटक वाहन घटक का कार्यात्मक विस्तार है",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "कैमरे के घूर्णन कोण को सीमित करें",
  T_49_META_TYPE_415_D: "व्यक्तित्व",
  T_49_META_TYPE_416_D: "पर्सोना चैट विंडो इंटरफ़ेस",
  T_49_META_TYPE_417_D: "कण इकाई घटक",
  T_49_META_TYPE_418_D: "सदस्य स्थिति गणना",
  T_49_META_TYPE_419_D: "बंदूक की त्वचा का प्रकार",
  T_49_META_TYPE_42_D: "UI इनपुट इकाई, वह UI जिसे प्लेयर UI संपादक के माध्यम से संपादित करता है",
  T_49_META_TYPE_420_D: "वाहन त्वचा प्रकार",
  T_49_META_TYPE_421_D: "त्वचा का प्रकार",
  T_49_META_TYPE_422_D: "बैकपैक त्वचा का प्रकार",
  T_49_META_TYPE_423_D: "पर्सोना ID",
  T_49_META_TYPE_424_D: "कोहरा प्रभाव मूल प्रकार",
  T_49_META_TYPE_425_D: "कण परिसंपत्ति आईडी",
  T_49_META_TYPE_426_D: "प्रकाश स्रोत का एक प्रकार जो प्रकाश स्रोत से प्रकाश स्रोत के ऋणात्मक Y अक्ष तक शंक्वाकार प्रकाश उत्सर्जित करता है, जो डिफ़ॉल्ट रूप से ज़मीन को प्रकाशित करता है",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "पोशाक संबंधी वह जानकारी जिसे खिलाड़ी को किसी अन्य पात्र में रूपांतरित होते समय ध्यान में रखना आवश्यक होता है",
  T_49_META_TYPE_429_D: "खिलाड़ी या एनपीसी इकाई",
  T_49_META_TYPE_43_D: "तत्व प्रकार खिलाड़ी इकाइयों की एक सूची होनी चाहिए",
  T_49_META_TYPE_430_D: "रैंडम संख्या जनरेटर",
  T_49_META_TYPE_431_D: "गतिशील वस्तु एक कस्टम पथ पर चलती है",
  T_49_META_TYPE_432_D: "वक्र पथ वेपॉइंट अनुकूलित करें",
  T_49_META_TYPE_433_D: "वक्र पथ वेपॉइंट प्रकार अनुकूलित करें",
  T_49_META_TYPE_434_D: "कस्टम वक्र पथ",
  T_49_META_TYPE_435_D: "खिलाड़ी विशिष्ट पहचानकर्ता सूची",
  T_49_META_TYPE_436_D: "त्रुटि कोड सूची",
  T_49_META_TYPE_437_D: "दोनों टीमों के लिए मैच विवरण UI इकाई। इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी।",
  T_49_META_TYPE_438_D: "एकाधिक टीम मिलान विवरण UI इकाई, इकाई विशेषताओं को संशोधित करने से संबंधित UI पर प्रदर्शन सामग्री प्रभावित होगी",
  T_49_META_TYPE_439_D: "संयोजन करें",
  T_49_META_TYPE_44_D: "तत्व प्रकार टीम इकाइयों की सूची होना चाहिए",
  T_49_META_TYPE_440_D: "समय",
  T_49_META_TYPE_441_D: "टाइमलाइन संसाधन आईडी",
  T_49_META_TYPE_442_D: "दो-टीम मैच की जानकारी के लिए नया सरलीकृत इकाई घटक, पूरी तरह से अनुकूलित संख्या प्रदर्शन का समर्थन करता है",
  T_49_META_TYPE_443_D: "संवाद प्रवाह परिसंपत्ति आईडी",
  T_49_META_TYPE_444_D: "भाषा का प्रकार",
  T_49_META_TYPE_45_D: "बूल लिस्ट",
  T_49_META_TYPE_46_D: "Int लिस्ट",
  T_49_META_TYPE_47_D: "फ्लोटिंग लिस्ट",
  T_49_META_TYPE_48_D: "स्ट्रिंग लिस्ट",
  T_49_META_TYPE_49_D: "वेक्टर3 लिस्ट",
  T_49_META_TYPE_5_D: "स्ट्रिंग प्रकार, मान पाठ सामग्री है",
  T_49_META_TYPE_50_D: "तत्व प्रकार संस्थाओं की सूची होना चाहिए",
  T_49_META_TYPE_51_D: "ज़ोंबी प्रकार",
  T_49_META_TYPE_53_D: "सामान्य स्तर वस्तु",
  T_49_META_TYPE_54_D: "नष्ट करने योग्य वस्तु",
  T_49_META_TYPE_55_D: "सामान्य स्पॉन पॉइंट",
  T_49_META_TYPE_56_D: "वाहन",
  T_49_META_TYPE_57_D: "खिलाड़ियों को प्रवेश करते समय निर्दिष्ट स्थान पर टेलीपोर्ट किया जा सकता है",
  T_49_META_TYPE_58_D: "बफ़्स मांग पर उत्पन्न किए जा सकते हैं",
  T_49_META_TYPE_59_D: "मूव प्लेटफार्म",
  T_49_META_TYPE_6_D: "त्रि-आयामी वेक्टर, जो स्थानिक निर्देशांक या स्थानिक दिशाओं का प्रतिनिधित्व कर सकता है",
  T_49_META_TYPE_60_D: "चयनित प्रकार का हथियार गिराया जाएगा",
  T_49_META_TYPE_61_D: "ट्रिगर रेंज में प्रवेश करने से बाउंड स्टोर खुल जाएगा",
  T_49_META_TYPE_62_D: "उत्कृष्ट उछाल वाला पासा",
  T_49_META_TYPE_63_D: "खिलाड़ी जब उस पर कदम रखेंगे तो उन्हें निर्दिष्ट स्थान पर उछाल दिया जाएगा",
  T_49_META_TYPE_64_D: "जब खिलाड़ी इस पर कदम रखेगा तो यह आवाज करेगा",
  T_49_META_TYPE_65_D: "बुनियादी स्केलेबल",
  T_49_META_TYPE_66_D: "कस्टम पथ",
  T_49_META_TYPE_67_D: "पथ बिंदु",
  T_49_META_TYPE_68_D: "AI राक्षस निकाय, जैसे कि ज़ॉम्बी",
  T_49_META_TYPE_69_D: "बड़ी संख्याएँ उच्च परिशुद्धता वाली फ़्लोटिंग पॉइंट संख्याएँ होती हैं",
  T_49_META_TYPE_7_D: "संख्या पूर्णांक, 64-बिट पूर्णांक, या फ़्लोटिंग पॉइंट प्रकार के लिए एक प्रकार का उपनाम है",
  T_49_META_TYPE_70_D: "विशेषता सूत्रों का उपयोग इकाई विशेषता मानों की गणना करने के लिए किया जाता है। वर्तमान में केवल कुछ खिलाड़ी विशेषताएँ और हथियार विशेषताएँ ही समर्थित हैं।",
  T_49_META_TYPE_71_D: "केवल दुकानों में बेची जाने वाली वस्तुओं के लिए उपयोग किया जाता है। माल खरीदकर प्राप्त की जाने वाली वस्तुओं की अवधारणा से माल अलग है।",
  T_49_META_TYPE_72_D: "इसमें कई उत्पाद शामिल हैं",
  T_49_META_TYPE_73_D: "इसमें कई अलमारियां हैं",
  T_49_META_TYPE_74_D: "आइटम आईडी",
  T_49_META_TYPE_75_D: "वापस आना",
  T_49_META_TYPE_76_D: "गश्ती शैली",
  T_49_META_TYPE_77_D: "एक जनरेटर इकाई जो ऑब्जेक्ट्स को उत्पन्न और ताज़ा कर सकती है",
  T_49_META_TYPE_78_D: "एक इकाई इकाई जिसे इकाई जनरेटर द्वारा अवशोषित किया जा सकता है और बैचों में उत्पन्न किया जा सकता है",
  T_49_META_TYPE_79_D: "हथियार",
  T_49_META_TYPE_8_D: "शर्तें विशेष Bool प्रकार की हैं",
  T_49_META_TYPE_80_D: "दुकान इंटरफ़ेस",
  T_49_META_TYPE_81_D: "बफ़ प्रकार",
  T_49_META_TYPE_82_D: "UI दिल की धड़कन",
  T_49_META_TYPE_83_D: "इंटरएक्शन बटन",
  T_49_META_TYPE_84_D: "रैंक योग्य संस्थाएं, जिन्हें रैंक किया जा सकता है",
  T_49_META_TYPE_85_D: "समाकलनीय इकाइयों के अपने स्वयं के समाकलन होते हैं",
  T_49_META_TYPE_86_D: "विशेषता सूत्र कारक प्रकार",
  T_49_META_TYPE_87_D: "RGBA रंग के प्रकार का वर्णन करता है, प्रत्येक चैनल मान सीमा 0~255 है",
  T_49_META_TYPE_88_D: "मुद्रा प्रकार, वर्तमान में केवल आधार मुद्रा प्रकार",
  T_49_META_TYPE_89_D: "मुद्रा इकाई, जिसका उपयोग मुद्रा के प्रकार और मात्रा का वर्णन करने के लिए किया जाता है",
  T_49_META_TYPE_9_D: "शर्तों का एक सेट",
  T_49_META_TYPE_90_D: "वॉलेट इकाई मुद्रा इकाइयों के एक समूह के लिए एक कंटेनर है",
  T_49_META_TYPE_91_D: "पूर्णांक या पूर्णांक सरणी प्रकार को संदर्भित करता है",
  T_49_META_TYPE_92_D: "डायनामिक क्रिएट लेवल ऑब्जेक्ट प्रकार",
  T_49_META_TYPE_93_D: "सूत्रीकरण योग्य गुणों वाली संस्थाएं",
  T_49_META_TYPE_94_D: "विशेषता संशोधन विधि",
  T_49_META_TYPE_95_D: "सोना जनरेटर",
  T_49_META_TYPE_96_D: "वॉलेट",
  T_49_META_TYPE_97_D: "स्थिति, रोटेशन और स्केलिंग, पैरेंट-चाइल्ड संरचना का समर्थन करते हैं",
  T_49_META_TYPE_98_D: "सभी उपलब्ध प्रकारों की सूची बनाएं",
  T_49_META_TYPE_99_D: "फुटबॉल"
};
export {
  _ as default
};
